// src/styles/sprinkles.css.ts
import { createSprinkles as _ad221 } from "@vanilla-extract/sprinkles/createRuntimeSprinkles";
var sprinkles = _ad221({ conditions: void 0, styles: { m: { mappings: ["margin"] }, mt: { mappings: ["marginTop"] }, mr: { mappings: ["marginRight"] }, mb: { mappings: ["marginBottom"] }, ml: { mappings: ["marginLeft"] }, mx: { mappings: ["marginLeft", "marginRight"] }, my: { mappings: ["marginTop", "marginBottom"] }, p: { mappings: ["padding"] }, pt: { mappings: ["paddingTop"] }, pr: { mappings: ["paddingRight"] }, pb: { mappings: ["paddingBottom"] }, pl: { mappings: ["paddingLeft"] }, px: { mappings: ["paddingLeft", "paddingRight"] }, py: { mappings: ["paddingTop", "paddingBottom"] }, margin: { values: { buttonPaddingHorizontal: { defaultClass: "sprinkles_margin_buttonPaddingHorizontal__151f9bf0" }, buttonMargin: { defaultClass: "sprinkles_margin_buttonMargin__151f9bf1" }, focusMargin: { defaultClass: "sprinkles_margin_focusMargin__151f9bf2" }, checkboxLabelMargin: { defaultClass: "sprinkles_margin_checkboxLabelMargin__151f9bf3" }, iconMargin: { defaultClass: "sprinkles_margin_iconMargin__151f9bf4" }, cardMargin: { defaultClass: "sprinkles_margin_cardMargin__151f9bf5" }, gamerTileMargin: { defaultClass: "sprinkles_margin_gamerTileMargin__151f9bf6" }, productTileMargin: { defaultClass: "sprinkles_margin_productTileMargin__151f9bf7" }, productTilePadding: { defaultClass: "sprinkles_margin_productTilePadding__151f9bf8" }, actionSheetInternalMargin: { defaultClass: "sprinkles_margin_actionSheetInternalMargin__151f9bf9" }, actionSheetMenuPadding: { defaultClass: "sprinkles_margin_actionSheetMenuPadding__151f9bfa" }, actionSheetItemIconMargin: { defaultClass: "sprinkles_margin_actionSheetItemIconMargin__151f9bfb" }, inlineTabsPaddingHorizontal: { defaultClass: "sprinkles_margin_inlineTabsPaddingHorizontal__151f9bfc" }, inlineTabsMarginHorizontal: { defaultClass: "sprinkles_margin_inlineTabsMarginHorizontal__151f9bfd" }, scrollBarOffset: { defaultClass: "sprinkles_margin_scrollBarOffset__151f9bfe" }, actionModalContentPadding: { defaultClass: "sprinkles_margin_actionModalContentPadding__151f9bff" }, friendsWhoPlayContainerOffset: { defaultClass: "sprinkles_margin_friendsWhoPlayContainerOffset__151f9bfg" }, activityItemProfileBadgeMargin: { defaultClass: "sprinkles_margin_activityItemProfileBadgeMargin__151f9bfh" }, tagPaddingHorizontal: { defaultClass: "sprinkles_margin_tagPaddingHorizontal__151f9bfi" }, xdsTagPaddingHorizontal: { defaultClass: "sprinkles_margin_xdsTagPaddingHorizontal__151f9bfj" }, xdsTagIconMargin: { defaultClass: "sprinkles_margin_xdsTagIconMargin__151f9bfk" }, xs: { defaultClass: "sprinkles_margin_xs__151f9bfl" }, sm: { defaultClass: "sprinkles_margin_sm__151f9bfm" }, md: { defaultClass: "sprinkles_margin_md__151f9bfn" }, lg: { defaultClass: "sprinkles_margin_lg__151f9bfo" }, xl: { defaultClass: "sprinkles_margin_xl__151f9bfp" }, xxl: { defaultClass: "sprinkles_margin_xxl__151f9bfq" } } }, marginTop: { values: { buttonPaddingHorizontal: { defaultClass: "sprinkles_marginTop_buttonPaddingHorizontal__151f9bfr" }, buttonMargin: { defaultClass: "sprinkles_marginTop_buttonMargin__151f9bfs" }, focusMargin: { defaultClass: "sprinkles_marginTop_focusMargin__151f9bft" }, checkboxLabelMargin: { defaultClass: "sprinkles_marginTop_checkboxLabelMargin__151f9bfu" }, iconMargin: { defaultClass: "sprinkles_marginTop_iconMargin__151f9bfv" }, cardMargin: { defaultClass: "sprinkles_marginTop_cardMargin__151f9bfw" }, gamerTileMargin: { defaultClass: "sprinkles_marginTop_gamerTileMargin__151f9bfx" }, productTileMargin: { defaultClass: "sprinkles_marginTop_productTileMargin__151f9bfy" }, productTilePadding: { defaultClass: "sprinkles_marginTop_productTilePadding__151f9bfz" }, actionSheetInternalMargin: { defaultClass: "sprinkles_marginTop_actionSheetInternalMargin__151f9bf10" }, actionSheetMenuPadding: { defaultClass: "sprinkles_marginTop_actionSheetMenuPadding__151f9bf11" }, actionSheetItemIconMargin: { defaultClass: "sprinkles_marginTop_actionSheetItemIconMargin__151f9bf12" }, inlineTabsPaddingHorizontal: { defaultClass: "sprinkles_marginTop_inlineTabsPaddingHorizontal__151f9bf13" }, inlineTabsMarginHorizontal: { defaultClass: "sprinkles_marginTop_inlineTabsMarginHorizontal__151f9bf14" }, scrollBarOffset: { defaultClass: "sprinkles_marginTop_scrollBarOffset__151f9bf15" }, actionModalContentPadding: { defaultClass: "sprinkles_marginTop_actionModalContentPadding__151f9bf16" }, friendsWhoPlayContainerOffset: { defaultClass: "sprinkles_marginTop_friendsWhoPlayContainerOffset__151f9bf17" }, activityItemProfileBadgeMargin: { defaultClass: "sprinkles_marginTop_activityItemProfileBadgeMargin__151f9bf18" }, tagPaddingHorizontal: { defaultClass: "sprinkles_marginTop_tagPaddingHorizontal__151f9bf19" }, xdsTagPaddingHorizontal: { defaultClass: "sprinkles_marginTop_xdsTagPaddingHorizontal__151f9bf1a" }, xdsTagIconMargin: { defaultClass: "sprinkles_marginTop_xdsTagIconMargin__151f9bf1b" }, xs: { defaultClass: "sprinkles_marginTop_xs__151f9bf1c" }, sm: { defaultClass: "sprinkles_marginTop_sm__151f9bf1d" }, md: { defaultClass: "sprinkles_marginTop_md__151f9bf1e" }, lg: { defaultClass: "sprinkles_marginTop_lg__151f9bf1f" }, xl: { defaultClass: "sprinkles_marginTop_xl__151f9bf1g" }, xxl: { defaultClass: "sprinkles_marginTop_xxl__151f9bf1h" } } }, marginRight: { values: { buttonPaddingHorizontal: { defaultClass: "sprinkles_marginRight_buttonPaddingHorizontal__151f9bf1i" }, buttonMargin: { defaultClass: "sprinkles_marginRight_buttonMargin__151f9bf1j" }, focusMargin: { defaultClass: "sprinkles_marginRight_focusMargin__151f9bf1k" }, checkboxLabelMargin: { defaultClass: "sprinkles_marginRight_checkboxLabelMargin__151f9bf1l" }, iconMargin: { defaultClass: "sprinkles_marginRight_iconMargin__151f9bf1m" }, cardMargin: { defaultClass: "sprinkles_marginRight_cardMargin__151f9bf1n" }, gamerTileMargin: { defaultClass: "sprinkles_marginRight_gamerTileMargin__151f9bf1o" }, productTileMargin: { defaultClass: "sprinkles_marginRight_productTileMargin__151f9bf1p" }, productTilePadding: { defaultClass: "sprinkles_marginRight_productTilePadding__151f9bf1q" }, actionSheetInternalMargin: { defaultClass: "sprinkles_marginRight_actionSheetInternalMargin__151f9bf1r" }, actionSheetMenuPadding: { defaultClass: "sprinkles_marginRight_actionSheetMenuPadding__151f9bf1s" }, actionSheetItemIconMargin: { defaultClass: "sprinkles_marginRight_actionSheetItemIconMargin__151f9bf1t" }, inlineTabsPaddingHorizontal: { defaultClass: "sprinkles_marginRight_inlineTabsPaddingHorizontal__151f9bf1u" }, inlineTabsMarginHorizontal: { defaultClass: "sprinkles_marginRight_inlineTabsMarginHorizontal__151f9bf1v" }, scrollBarOffset: { defaultClass: "sprinkles_marginRight_scrollBarOffset__151f9bf1w" }, actionModalContentPadding: { defaultClass: "sprinkles_marginRight_actionModalContentPadding__151f9bf1x" }, friendsWhoPlayContainerOffset: { defaultClass: "sprinkles_marginRight_friendsWhoPlayContainerOffset__151f9bf1y" }, activityItemProfileBadgeMargin: { defaultClass: "sprinkles_marginRight_activityItemProfileBadgeMargin__151f9bf1z" }, tagPaddingHorizontal: { defaultClass: "sprinkles_marginRight_tagPaddingHorizontal__151f9bf20" }, xdsTagPaddingHorizontal: { defaultClass: "sprinkles_marginRight_xdsTagPaddingHorizontal__151f9bf21" }, xdsTagIconMargin: { defaultClass: "sprinkles_marginRight_xdsTagIconMargin__151f9bf22" }, xs: { defaultClass: "sprinkles_marginRight_xs__151f9bf23" }, sm: { defaultClass: "sprinkles_marginRight_sm__151f9bf24" }, md: { defaultClass: "sprinkles_marginRight_md__151f9bf25" }, lg: { defaultClass: "sprinkles_marginRight_lg__151f9bf26" }, xl: { defaultClass: "sprinkles_marginRight_xl__151f9bf27" }, xxl: { defaultClass: "sprinkles_marginRight_xxl__151f9bf28" } } }, marginBottom: { values: { buttonPaddingHorizontal: { defaultClass: "sprinkles_marginBottom_buttonPaddingHorizontal__151f9bf29" }, buttonMargin: { defaultClass: "sprinkles_marginBottom_buttonMargin__151f9bf2a" }, focusMargin: { defaultClass: "sprinkles_marginBottom_focusMargin__151f9bf2b" }, checkboxLabelMargin: { defaultClass: "sprinkles_marginBottom_checkboxLabelMargin__151f9bf2c" }, iconMargin: { defaultClass: "sprinkles_marginBottom_iconMargin__151f9bf2d" }, cardMargin: { defaultClass: "sprinkles_marginBottom_cardMargin__151f9bf2e" }, gamerTileMargin: { defaultClass: "sprinkles_marginBottom_gamerTileMargin__151f9bf2f" }, productTileMargin: { defaultClass: "sprinkles_marginBottom_productTileMargin__151f9bf2g" }, productTilePadding: { defaultClass: "sprinkles_marginBottom_productTilePadding__151f9bf2h" }, actionSheetInternalMargin: { defaultClass: "sprinkles_marginBottom_actionSheetInternalMargin__151f9bf2i" }, actionSheetMenuPadding: { defaultClass: "sprinkles_marginBottom_actionSheetMenuPadding__151f9bf2j" }, actionSheetItemIconMargin: { defaultClass: "sprinkles_marginBottom_actionSheetItemIconMargin__151f9bf2k" }, inlineTabsPaddingHorizontal: { defaultClass: "sprinkles_marginBottom_inlineTabsPaddingHorizontal__151f9bf2l" }, inlineTabsMarginHorizontal: { defaultClass: "sprinkles_marginBottom_inlineTabsMarginHorizontal__151f9bf2m" }, scrollBarOffset: { defaultClass: "sprinkles_marginBottom_scrollBarOffset__151f9bf2n" }, actionModalContentPadding: { defaultClass: "sprinkles_marginBottom_actionModalContentPadding__151f9bf2o" }, friendsWhoPlayContainerOffset: { defaultClass: "sprinkles_marginBottom_friendsWhoPlayContainerOffset__151f9bf2p" }, activityItemProfileBadgeMargin: { defaultClass: "sprinkles_marginBottom_activityItemProfileBadgeMargin__151f9bf2q" }, tagPaddingHorizontal: { defaultClass: "sprinkles_marginBottom_tagPaddingHorizontal__151f9bf2r" }, xdsTagPaddingHorizontal: { defaultClass: "sprinkles_marginBottom_xdsTagPaddingHorizontal__151f9bf2s" }, xdsTagIconMargin: { defaultClass: "sprinkles_marginBottom_xdsTagIconMargin__151f9bf2t" }, xs: { defaultClass: "sprinkles_marginBottom_xs__151f9bf2u" }, sm: { defaultClass: "sprinkles_marginBottom_sm__151f9bf2v" }, md: { defaultClass: "sprinkles_marginBottom_md__151f9bf2w" }, lg: { defaultClass: "sprinkles_marginBottom_lg__151f9bf2x" }, xl: { defaultClass: "sprinkles_marginBottom_xl__151f9bf2y" }, xxl: { defaultClass: "sprinkles_marginBottom_xxl__151f9bf2z" } } }, marginLeft: { values: { buttonPaddingHorizontal: { defaultClass: "sprinkles_marginLeft_buttonPaddingHorizontal__151f9bf30" }, buttonMargin: { defaultClass: "sprinkles_marginLeft_buttonMargin__151f9bf31" }, focusMargin: { defaultClass: "sprinkles_marginLeft_focusMargin__151f9bf32" }, checkboxLabelMargin: { defaultClass: "sprinkles_marginLeft_checkboxLabelMargin__151f9bf33" }, iconMargin: { defaultClass: "sprinkles_marginLeft_iconMargin__151f9bf34" }, cardMargin: { defaultClass: "sprinkles_marginLeft_cardMargin__151f9bf35" }, gamerTileMargin: { defaultClass: "sprinkles_marginLeft_gamerTileMargin__151f9bf36" }, productTileMargin: { defaultClass: "sprinkles_marginLeft_productTileMargin__151f9bf37" }, productTilePadding: { defaultClass: "sprinkles_marginLeft_productTilePadding__151f9bf38" }, actionSheetInternalMargin: { defaultClass: "sprinkles_marginLeft_actionSheetInternalMargin__151f9bf39" }, actionSheetMenuPadding: { defaultClass: "sprinkles_marginLeft_actionSheetMenuPadding__151f9bf3a" }, actionSheetItemIconMargin: { defaultClass: "sprinkles_marginLeft_actionSheetItemIconMargin__151f9bf3b" }, inlineTabsPaddingHorizontal: { defaultClass: "sprinkles_marginLeft_inlineTabsPaddingHorizontal__151f9bf3c" }, inlineTabsMarginHorizontal: { defaultClass: "sprinkles_marginLeft_inlineTabsMarginHorizontal__151f9bf3d" }, scrollBarOffset: { defaultClass: "sprinkles_marginLeft_scrollBarOffset__151f9bf3e" }, actionModalContentPadding: { defaultClass: "sprinkles_marginLeft_actionModalContentPadding__151f9bf3f" }, friendsWhoPlayContainerOffset: { defaultClass: "sprinkles_marginLeft_friendsWhoPlayContainerOffset__151f9bf3g" }, activityItemProfileBadgeMargin: { defaultClass: "sprinkles_marginLeft_activityItemProfileBadgeMargin__151f9bf3h" }, tagPaddingHorizontal: { defaultClass: "sprinkles_marginLeft_tagPaddingHorizontal__151f9bf3i" }, xdsTagPaddingHorizontal: { defaultClass: "sprinkles_marginLeft_xdsTagPaddingHorizontal__151f9bf3j" }, xdsTagIconMargin: { defaultClass: "sprinkles_marginLeft_xdsTagIconMargin__151f9bf3k" }, xs: { defaultClass: "sprinkles_marginLeft_xs__151f9bf3l" }, sm: { defaultClass: "sprinkles_marginLeft_sm__151f9bf3m" }, md: { defaultClass: "sprinkles_marginLeft_md__151f9bf3n" }, lg: { defaultClass: "sprinkles_marginLeft_lg__151f9bf3o" }, xl: { defaultClass: "sprinkles_marginLeft_xl__151f9bf3p" }, xxl: { defaultClass: "sprinkles_marginLeft_xxl__151f9bf3q" } } }, padding: { values: { buttonPaddingHorizontal: { defaultClass: "sprinkles_padding_buttonPaddingHorizontal__151f9bf3r" }, buttonMargin: { defaultClass: "sprinkles_padding_buttonMargin__151f9bf3s" }, focusMargin: { defaultClass: "sprinkles_padding_focusMargin__151f9bf3t" }, checkboxLabelMargin: { defaultClass: "sprinkles_padding_checkboxLabelMargin__151f9bf3u" }, iconMargin: { defaultClass: "sprinkles_padding_iconMargin__151f9bf3v" }, cardMargin: { defaultClass: "sprinkles_padding_cardMargin__151f9bf3w" }, gamerTileMargin: { defaultClass: "sprinkles_padding_gamerTileMargin__151f9bf3x" }, productTileMargin: { defaultClass: "sprinkles_padding_productTileMargin__151f9bf3y" }, productTilePadding: { defaultClass: "sprinkles_padding_productTilePadding__151f9bf3z" }, actionSheetInternalMargin: { defaultClass: "sprinkles_padding_actionSheetInternalMargin__151f9bf40" }, actionSheetMenuPadding: { defaultClass: "sprinkles_padding_actionSheetMenuPadding__151f9bf41" }, actionSheetItemIconMargin: { defaultClass: "sprinkles_padding_actionSheetItemIconMargin__151f9bf42" }, inlineTabsPaddingHorizontal: { defaultClass: "sprinkles_padding_inlineTabsPaddingHorizontal__151f9bf43" }, inlineTabsMarginHorizontal: { defaultClass: "sprinkles_padding_inlineTabsMarginHorizontal__151f9bf44" }, scrollBarOffset: { defaultClass: "sprinkles_padding_scrollBarOffset__151f9bf45" }, actionModalContentPadding: { defaultClass: "sprinkles_padding_actionModalContentPadding__151f9bf46" }, friendsWhoPlayContainerOffset: { defaultClass: "sprinkles_padding_friendsWhoPlayContainerOffset__151f9bf47" }, activityItemProfileBadgeMargin: { defaultClass: "sprinkles_padding_activityItemProfileBadgeMargin__151f9bf48" }, tagPaddingHorizontal: { defaultClass: "sprinkles_padding_tagPaddingHorizontal__151f9bf49" }, xdsTagPaddingHorizontal: { defaultClass: "sprinkles_padding_xdsTagPaddingHorizontal__151f9bf4a" }, xdsTagIconMargin: { defaultClass: "sprinkles_padding_xdsTagIconMargin__151f9bf4b" }, xs: { defaultClass: "sprinkles_padding_xs__151f9bf4c" }, sm: { defaultClass: "sprinkles_padding_sm__151f9bf4d" }, md: { defaultClass: "sprinkles_padding_md__151f9bf4e" }, lg: { defaultClass: "sprinkles_padding_lg__151f9bf4f" }, xl: { defaultClass: "sprinkles_padding_xl__151f9bf4g" }, xxl: { defaultClass: "sprinkles_padding_xxl__151f9bf4h" } } }, paddingTop: { values: { buttonPaddingHorizontal: { defaultClass: "sprinkles_paddingTop_buttonPaddingHorizontal__151f9bf4i" }, buttonMargin: { defaultClass: "sprinkles_paddingTop_buttonMargin__151f9bf4j" }, focusMargin: { defaultClass: "sprinkles_paddingTop_focusMargin__151f9bf4k" }, checkboxLabelMargin: { defaultClass: "sprinkles_paddingTop_checkboxLabelMargin__151f9bf4l" }, iconMargin: { defaultClass: "sprinkles_paddingTop_iconMargin__151f9bf4m" }, cardMargin: { defaultClass: "sprinkles_paddingTop_cardMargin__151f9bf4n" }, gamerTileMargin: { defaultClass: "sprinkles_paddingTop_gamerTileMargin__151f9bf4o" }, productTileMargin: { defaultClass: "sprinkles_paddingTop_productTileMargin__151f9bf4p" }, productTilePadding: { defaultClass: "sprinkles_paddingTop_productTilePadding__151f9bf4q" }, actionSheetInternalMargin: { defaultClass: "sprinkles_paddingTop_actionSheetInternalMargin__151f9bf4r" }, actionSheetMenuPadding: { defaultClass: "sprinkles_paddingTop_actionSheetMenuPadding__151f9bf4s" }, actionSheetItemIconMargin: { defaultClass: "sprinkles_paddingTop_actionSheetItemIconMargin__151f9bf4t" }, inlineTabsPaddingHorizontal: { defaultClass: "sprinkles_paddingTop_inlineTabsPaddingHorizontal__151f9bf4u" }, inlineTabsMarginHorizontal: { defaultClass: "sprinkles_paddingTop_inlineTabsMarginHorizontal__151f9bf4v" }, scrollBarOffset: { defaultClass: "sprinkles_paddingTop_scrollBarOffset__151f9bf4w" }, actionModalContentPadding: { defaultClass: "sprinkles_paddingTop_actionModalContentPadding__151f9bf4x" }, friendsWhoPlayContainerOffset: { defaultClass: "sprinkles_paddingTop_friendsWhoPlayContainerOffset__151f9bf4y" }, activityItemProfileBadgeMargin: { defaultClass: "sprinkles_paddingTop_activityItemProfileBadgeMargin__151f9bf4z" }, tagPaddingHorizontal: { defaultClass: "sprinkles_paddingTop_tagPaddingHorizontal__151f9bf50" }, xdsTagPaddingHorizontal: { defaultClass: "sprinkles_paddingTop_xdsTagPaddingHorizontal__151f9bf51" }, xdsTagIconMargin: { defaultClass: "sprinkles_paddingTop_xdsTagIconMargin__151f9bf52" }, xs: { defaultClass: "sprinkles_paddingTop_xs__151f9bf53" }, sm: { defaultClass: "sprinkles_paddingTop_sm__151f9bf54" }, md: { defaultClass: "sprinkles_paddingTop_md__151f9bf55" }, lg: { defaultClass: "sprinkles_paddingTop_lg__151f9bf56" }, xl: { defaultClass: "sprinkles_paddingTop_xl__151f9bf57" }, xxl: { defaultClass: "sprinkles_paddingTop_xxl__151f9bf58" } } }, paddingRight: { values: { buttonPaddingHorizontal: { defaultClass: "sprinkles_paddingRight_buttonPaddingHorizontal__151f9bf59" }, buttonMargin: { defaultClass: "sprinkles_paddingRight_buttonMargin__151f9bf5a" }, focusMargin: { defaultClass: "sprinkles_paddingRight_focusMargin__151f9bf5b" }, checkboxLabelMargin: { defaultClass: "sprinkles_paddingRight_checkboxLabelMargin__151f9bf5c" }, iconMargin: { defaultClass: "sprinkles_paddingRight_iconMargin__151f9bf5d" }, cardMargin: { defaultClass: "sprinkles_paddingRight_cardMargin__151f9bf5e" }, gamerTileMargin: { defaultClass: "sprinkles_paddingRight_gamerTileMargin__151f9bf5f" }, productTileMargin: { defaultClass: "sprinkles_paddingRight_productTileMargin__151f9bf5g" }, productTilePadding: { defaultClass: "sprinkles_paddingRight_productTilePadding__151f9bf5h" }, actionSheetInternalMargin: { defaultClass: "sprinkles_paddingRight_actionSheetInternalMargin__151f9bf5i" }, actionSheetMenuPadding: { defaultClass: "sprinkles_paddingRight_actionSheetMenuPadding__151f9bf5j" }, actionSheetItemIconMargin: { defaultClass: "sprinkles_paddingRight_actionSheetItemIconMargin__151f9bf5k" }, inlineTabsPaddingHorizontal: { defaultClass: "sprinkles_paddingRight_inlineTabsPaddingHorizontal__151f9bf5l" }, inlineTabsMarginHorizontal: { defaultClass: "sprinkles_paddingRight_inlineTabsMarginHorizontal__151f9bf5m" }, scrollBarOffset: { defaultClass: "sprinkles_paddingRight_scrollBarOffset__151f9bf5n" }, actionModalContentPadding: { defaultClass: "sprinkles_paddingRight_actionModalContentPadding__151f9bf5o" }, friendsWhoPlayContainerOffset: { defaultClass: "sprinkles_paddingRight_friendsWhoPlayContainerOffset__151f9bf5p" }, activityItemProfileBadgeMargin: { defaultClass: "sprinkles_paddingRight_activityItemProfileBadgeMargin__151f9bf5q" }, tagPaddingHorizontal: { defaultClass: "sprinkles_paddingRight_tagPaddingHorizontal__151f9bf5r" }, xdsTagPaddingHorizontal: { defaultClass: "sprinkles_paddingRight_xdsTagPaddingHorizontal__151f9bf5s" }, xdsTagIconMargin: { defaultClass: "sprinkles_paddingRight_xdsTagIconMargin__151f9bf5t" }, xs: { defaultClass: "sprinkles_paddingRight_xs__151f9bf5u" }, sm: { defaultClass: "sprinkles_paddingRight_sm__151f9bf5v" }, md: { defaultClass: "sprinkles_paddingRight_md__151f9bf5w" }, lg: { defaultClass: "sprinkles_paddingRight_lg__151f9bf5x" }, xl: { defaultClass: "sprinkles_paddingRight_xl__151f9bf5y" }, xxl: { defaultClass: "sprinkles_paddingRight_xxl__151f9bf5z" } } }, paddingBottom: { values: { buttonPaddingHorizontal: { defaultClass: "sprinkles_paddingBottom_buttonPaddingHorizontal__151f9bf60" }, buttonMargin: { defaultClass: "sprinkles_paddingBottom_buttonMargin__151f9bf61" }, focusMargin: { defaultClass: "sprinkles_paddingBottom_focusMargin__151f9bf62" }, checkboxLabelMargin: { defaultClass: "sprinkles_paddingBottom_checkboxLabelMargin__151f9bf63" }, iconMargin: { defaultClass: "sprinkles_paddingBottom_iconMargin__151f9bf64" }, cardMargin: { defaultClass: "sprinkles_paddingBottom_cardMargin__151f9bf65" }, gamerTileMargin: { defaultClass: "sprinkles_paddingBottom_gamerTileMargin__151f9bf66" }, productTileMargin: { defaultClass: "sprinkles_paddingBottom_productTileMargin__151f9bf67" }, productTilePadding: { defaultClass: "sprinkles_paddingBottom_productTilePadding__151f9bf68" }, actionSheetInternalMargin: { defaultClass: "sprinkles_paddingBottom_actionSheetInternalMargin__151f9bf69" }, actionSheetMenuPadding: { defaultClass: "sprinkles_paddingBottom_actionSheetMenuPadding__151f9bf6a" }, actionSheetItemIconMargin: { defaultClass: "sprinkles_paddingBottom_actionSheetItemIconMargin__151f9bf6b" }, inlineTabsPaddingHorizontal: { defaultClass: "sprinkles_paddingBottom_inlineTabsPaddingHorizontal__151f9bf6c" }, inlineTabsMarginHorizontal: { defaultClass: "sprinkles_paddingBottom_inlineTabsMarginHorizontal__151f9bf6d" }, scrollBarOffset: { defaultClass: "sprinkles_paddingBottom_scrollBarOffset__151f9bf6e" }, actionModalContentPadding: { defaultClass: "sprinkles_paddingBottom_actionModalContentPadding__151f9bf6f" }, friendsWhoPlayContainerOffset: { defaultClass: "sprinkles_paddingBottom_friendsWhoPlayContainerOffset__151f9bf6g" }, activityItemProfileBadgeMargin: { defaultClass: "sprinkles_paddingBottom_activityItemProfileBadgeMargin__151f9bf6h" }, tagPaddingHorizontal: { defaultClass: "sprinkles_paddingBottom_tagPaddingHorizontal__151f9bf6i" }, xdsTagPaddingHorizontal: { defaultClass: "sprinkles_paddingBottom_xdsTagPaddingHorizontal__151f9bf6j" }, xdsTagIconMargin: { defaultClass: "sprinkles_paddingBottom_xdsTagIconMargin__151f9bf6k" }, xs: { defaultClass: "sprinkles_paddingBottom_xs__151f9bf6l" }, sm: { defaultClass: "sprinkles_paddingBottom_sm__151f9bf6m" }, md: { defaultClass: "sprinkles_paddingBottom_md__151f9bf6n" }, lg: { defaultClass: "sprinkles_paddingBottom_lg__151f9bf6o" }, xl: { defaultClass: "sprinkles_paddingBottom_xl__151f9bf6p" }, xxl: { defaultClass: "sprinkles_paddingBottom_xxl__151f9bf6q" } } }, paddingLeft: { values: { buttonPaddingHorizontal: { defaultClass: "sprinkles_paddingLeft_buttonPaddingHorizontal__151f9bf6r" }, buttonMargin: { defaultClass: "sprinkles_paddingLeft_buttonMargin__151f9bf6s" }, focusMargin: { defaultClass: "sprinkles_paddingLeft_focusMargin__151f9bf6t" }, checkboxLabelMargin: { defaultClass: "sprinkles_paddingLeft_checkboxLabelMargin__151f9bf6u" }, iconMargin: { defaultClass: "sprinkles_paddingLeft_iconMargin__151f9bf6v" }, cardMargin: { defaultClass: "sprinkles_paddingLeft_cardMargin__151f9bf6w" }, gamerTileMargin: { defaultClass: "sprinkles_paddingLeft_gamerTileMargin__151f9bf6x" }, productTileMargin: { defaultClass: "sprinkles_paddingLeft_productTileMargin__151f9bf6y" }, productTilePadding: { defaultClass: "sprinkles_paddingLeft_productTilePadding__151f9bf6z" }, actionSheetInternalMargin: { defaultClass: "sprinkles_paddingLeft_actionSheetInternalMargin__151f9bf70" }, actionSheetMenuPadding: { defaultClass: "sprinkles_paddingLeft_actionSheetMenuPadding__151f9bf71" }, actionSheetItemIconMargin: { defaultClass: "sprinkles_paddingLeft_actionSheetItemIconMargin__151f9bf72" }, inlineTabsPaddingHorizontal: { defaultClass: "sprinkles_paddingLeft_inlineTabsPaddingHorizontal__151f9bf73" }, inlineTabsMarginHorizontal: { defaultClass: "sprinkles_paddingLeft_inlineTabsMarginHorizontal__151f9bf74" }, scrollBarOffset: { defaultClass: "sprinkles_paddingLeft_scrollBarOffset__151f9bf75" }, actionModalContentPadding: { defaultClass: "sprinkles_paddingLeft_actionModalContentPadding__151f9bf76" }, friendsWhoPlayContainerOffset: { defaultClass: "sprinkles_paddingLeft_friendsWhoPlayContainerOffset__151f9bf77" }, activityItemProfileBadgeMargin: { defaultClass: "sprinkles_paddingLeft_activityItemProfileBadgeMargin__151f9bf78" }, tagPaddingHorizontal: { defaultClass: "sprinkles_paddingLeft_tagPaddingHorizontal__151f9bf79" }, xdsTagPaddingHorizontal: { defaultClass: "sprinkles_paddingLeft_xdsTagPaddingHorizontal__151f9bf7a" }, xdsTagIconMargin: { defaultClass: "sprinkles_paddingLeft_xdsTagIconMargin__151f9bf7b" }, xs: { defaultClass: "sprinkles_paddingLeft_xs__151f9bf7c" }, sm: { defaultClass: "sprinkles_paddingLeft_sm__151f9bf7d" }, md: { defaultClass: "sprinkles_paddingLeft_md__151f9bf7e" }, lg: { defaultClass: "sprinkles_paddingLeft_lg__151f9bf7f" }, xl: { defaultClass: "sprinkles_paddingLeft_xl__151f9bf7g" }, xxl: { defaultClass: "sprinkles_paddingLeft_xxl__151f9bf7h" } } }, gap: { values: { buttonPaddingHorizontal: { defaultClass: "sprinkles_gap_buttonPaddingHorizontal__151f9bf7i" }, buttonMargin: { defaultClass: "sprinkles_gap_buttonMargin__151f9bf7j" }, focusMargin: { defaultClass: "sprinkles_gap_focusMargin__151f9bf7k" }, checkboxLabelMargin: { defaultClass: "sprinkles_gap_checkboxLabelMargin__151f9bf7l" }, iconMargin: { defaultClass: "sprinkles_gap_iconMargin__151f9bf7m" }, cardMargin: { defaultClass: "sprinkles_gap_cardMargin__151f9bf7n" }, gamerTileMargin: { defaultClass: "sprinkles_gap_gamerTileMargin__151f9bf7o" }, productTileMargin: { defaultClass: "sprinkles_gap_productTileMargin__151f9bf7p" }, productTilePadding: { defaultClass: "sprinkles_gap_productTilePadding__151f9bf7q" }, actionSheetInternalMargin: { defaultClass: "sprinkles_gap_actionSheetInternalMargin__151f9bf7r" }, actionSheetMenuPadding: { defaultClass: "sprinkles_gap_actionSheetMenuPadding__151f9bf7s" }, actionSheetItemIconMargin: { defaultClass: "sprinkles_gap_actionSheetItemIconMargin__151f9bf7t" }, inlineTabsPaddingHorizontal: { defaultClass: "sprinkles_gap_inlineTabsPaddingHorizontal__151f9bf7u" }, inlineTabsMarginHorizontal: { defaultClass: "sprinkles_gap_inlineTabsMarginHorizontal__151f9bf7v" }, scrollBarOffset: { defaultClass: "sprinkles_gap_scrollBarOffset__151f9bf7w" }, actionModalContentPadding: { defaultClass: "sprinkles_gap_actionModalContentPadding__151f9bf7x" }, friendsWhoPlayContainerOffset: { defaultClass: "sprinkles_gap_friendsWhoPlayContainerOffset__151f9bf7y" }, activityItemProfileBadgeMargin: { defaultClass: "sprinkles_gap_activityItemProfileBadgeMargin__151f9bf7z" }, tagPaddingHorizontal: { defaultClass: "sprinkles_gap_tagPaddingHorizontal__151f9bf80" }, xdsTagPaddingHorizontal: { defaultClass: "sprinkles_gap_xdsTagPaddingHorizontal__151f9bf81" }, xdsTagIconMargin: { defaultClass: "sprinkles_gap_xdsTagIconMargin__151f9bf82" }, xs: { defaultClass: "sprinkles_gap_xs__151f9bf83" }, sm: { defaultClass: "sprinkles_gap_sm__151f9bf84" }, md: { defaultClass: "sprinkles_gap_md__151f9bf85" }, lg: { defaultClass: "sprinkles_gap_lg__151f9bf86" }, xl: { defaultClass: "sprinkles_gap_xl__151f9bf87" }, xxl: { defaultClass: "sprinkles_gap_xxl__151f9bf88" } } } } }, { conditions: void 0, styles: { color: { values: { contentPrimary: { defaultClass: "sprinkles_color_contentPrimary__151f9bf89" }, contentSecondary: { defaultClass: "sprinkles_color_contentSecondary__151f9bf8a" }, contentDisabled: { defaultClass: "sprinkles_color_contentDisabled__151f9bf8b" }, contentError: { defaultClass: "sprinkles_color_contentError__151f9bf8c" }, contentAccent: { defaultClass: "sprinkles_color_contentAccent__151f9bf8d" }, contentOnBackplatePrimary: { defaultClass: "sprinkles_color_contentOnBackplatePrimary__151f9bf8e" }, contentOnBackplateSecondary: { defaultClass: "sprinkles_color_contentOnBackplateSecondary__151f9bf8f" }, contentOnBackplateTertiary: { defaultClass: "sprinkles_color_contentOnBackplateTertiary__151f9bf8g" }, contentOnBackplateAccent: { defaultClass: "sprinkles_color_contentOnBackplateAccent__151f9bf8h" }, contentOnBackplateDisabled: { defaultClass: "sprinkles_color_contentOnBackplateDisabled__151f9bf8i" }, contentOnBackplateTransparentPrimary: { defaultClass: "sprinkles_color_contentOnBackplateTransparentPrimary__151f9bf8j" }, contentOnBackplateTransparentSecondary: { defaultClass: "sprinkles_color_contentOnBackplateTransparentSecondary__151f9bf8k" }, contentOnBackplateTransparentTertiary: { defaultClass: "sprinkles_color_contentOnBackplateTransparentTertiary__151f9bf8l" }, contentOnBackplateTransparentAccent: { defaultClass: "sprinkles_color_contentOnBackplateTransparentAccent__151f9bf8m" }, contentOnBackplateTransparentDisabled: { defaultClass: "sprinkles_color_contentOnBackplateTransparentDisabled__151f9bf8n" }, contentOnBackplateAcrylicPrimaryRest: { defaultClass: "sprinkles_color_contentOnBackplateAcrylicPrimaryRest__151f9bf8o" }, contentOnHover: { defaultClass: "sprinkles_color_contentOnHover__151f9bf8p" }, contentOnHoverTransparent: { defaultClass: "sprinkles_color_contentOnHoverTransparent__151f9bf8q" }, contentOnPress: { defaultClass: "sprinkles_color_contentOnPress__151f9bf8r" }, contentOnPressTransparent: { defaultClass: "sprinkles_color_contentOnPressTransparent__151f9bf8s" }, contentPrimaryDisabled: { defaultClass: "sprinkles_color_contentPrimaryDisabled__151f9bf8t" }, contentPrimaryOnHover: { defaultClass: "sprinkles_color_contentPrimaryOnHover__151f9bf8u" }, contentPrimaryOnPress: { defaultClass: "sprinkles_color_contentPrimaryOnPress__151f9bf8v" }, contentHyperlinkRest: { defaultClass: "sprinkles_color_contentHyperlinkRest__151f9bf8w" }, contentHyperlinkHover: { defaultClass: "sprinkles_color_contentHyperlinkHover__151f9bf8x" }, contentHyperlinkPress: { defaultClass: "sprinkles_color_contentHyperlinkPress__151f9bf8y" }, contentHyperlinkVisited: { defaultClass: "sprinkles_color_contentHyperlinkVisited__151f9bf8z" }, containerSolidAppBackground: { defaultClass: "sprinkles_color_containerSolidAppBackground__151f9bf90" }, containerSolidContainer: { defaultClass: "sprinkles_color_containerSolidContainer__151f9bf91" }, containerSolidContainerDark: { defaultClass: "sprinkles_color_containerSolidContainerDark__151f9bf92" }, containerSolidContainerLight: { defaultClass: "sprinkles_color_containerSolidContainerLight__151f9bf93" }, containerAcrylicDark: { defaultClass: "sprinkles_color_containerAcrylicDark__151f9bf94" }, containerAcrylicExtraDark: { defaultClass: "sprinkles_color_containerAcrylicExtraDark__151f9bf95" }, containerAcrylicExtraLight: { defaultClass: "sprinkles_color_containerAcrylicExtraLight__151f9bf96" }, containerAcrylicLight: { defaultClass: "sprinkles_color_containerAcrylicLight__151f9bf97" }, containerAcrylicWhiteHeavy: { defaultClass: "sprinkles_color_containerAcrylicWhiteHeavy__151f9bf98" }, containerAcrylicWhiteLight: { defaultClass: "sprinkles_color_containerAcrylicWhiteLight__151f9bf99" }, containerSemitransparentFogHeavy: { defaultClass: "sprinkles_color_containerSemitransparentFogHeavy__151f9bf9a" }, containerSemitransparentFogLight: { defaultClass: "sprinkles_color_containerSemitransparentFogLight__151f9bf9b" }, containerSemitransparentSmokeDark: { defaultClass: "sprinkles_color_containerSemitransparentSmokeDark__151f9bf9c" }, containerSemitransparentSmokeExtraDark: { defaultClass: "sprinkles_color_containerSemitransparentSmokeExtraDark__151f9bf9d" }, containerSemitransparentSmokeExtraLight: { defaultClass: "sprinkles_color_containerSemitransparentSmokeExtraLight__151f9bf9e" }, containerSemitransparentSmokeLight: { defaultClass: "sprinkles_color_containerSemitransparentSmokeLight__151f9bf9f" }, stateHover: { defaultClass: "sprinkles_color_stateHover__151f9bf9g" }, statePress: { defaultClass: "sprinkles_color_statePress__151f9bf9h" }, stateFocus: { defaultClass: "sprinkles_color_stateFocus__151f9bf9i" }, stateRest: { defaultClass: "sprinkles_color_stateRest__151f9bf9j" }, stateDisabled: { defaultClass: "sprinkles_color_stateDisabled__151f9bf9k" }, backplateAcrylicAccentDisabled: { defaultClass: "sprinkles_color_backplateAcrylicAccentDisabled__151f9bf9l" }, backplateAcrylicAccentFocus: { defaultClass: "sprinkles_color_backplateAcrylicAccentFocus__151f9bf9m" }, backplateAcrylicAccentHover: { defaultClass: "sprinkles_color_backplateAcrylicAccentHover__151f9bf9n" }, backplateAcrylicAccentPress: { defaultClass: "sprinkles_color_backplateAcrylicAccentPress__151f9bf9o" }, backplateAcrylicAccentRest: { defaultClass: "sprinkles_color_backplateAcrylicAccentRest__151f9bf9p" }, backplateAcrylicPrimaryDisabled: { defaultClass: "sprinkles_color_backplateAcrylicPrimaryDisabled__151f9bf9q" }, backplateAcrylicPrimaryFocus: { defaultClass: "sprinkles_color_backplateAcrylicPrimaryFocus__151f9bf9r" }, backplateAcrylicPrimaryHover: { defaultClass: "sprinkles_color_backplateAcrylicPrimaryHover__151f9bf9s" }, backplateAcrylicPrimaryPress: { defaultClass: "sprinkles_color_backplateAcrylicPrimaryPress__151f9bf9t" }, backplateAcrylicPrimaryRest: { defaultClass: "sprinkles_color_backplateAcrylicPrimaryRest__151f9bf9u" }, backplateAcrylicSecondaryDisabled: { defaultClass: "sprinkles_color_backplateAcrylicSecondaryDisabled__151f9bf9v" }, backplateAcrylicSecondaryFocus: { defaultClass: "sprinkles_color_backplateAcrylicSecondaryFocus__151f9bf9w" }, backplateAcrylicSecondaryHover: { defaultClass: "sprinkles_color_backplateAcrylicSecondaryHover__151f9bf9x" }, backplateAcrylicSecondaryPress: { defaultClass: "sprinkles_color_backplateAcrylicSecondaryPress__151f9bf9y" }, backplateAcrylicSecondaryRest: { defaultClass: "sprinkles_color_backplateAcrylicSecondaryRest__151f9bf9z" }, backplateAcrylicTertiaryDisabled: { defaultClass: "sprinkles_color_backplateAcrylicTertiaryDisabled__151f9bfa0" }, backplateAcrylicTertiaryFocus: { defaultClass: "sprinkles_color_backplateAcrylicTertiaryFocus__151f9bfa1" }, backplateAcrylicTertiaryHover: { defaultClass: "sprinkles_color_backplateAcrylicTertiaryHover__151f9bfa2" }, backplateAcrylicTertiaryPress: { defaultClass: "sprinkles_color_backplateAcrylicTertiaryPress__151f9bfa3" }, backplateAcrylicTertiaryRest: { defaultClass: "sprinkles_color_backplateAcrylicTertiaryRest__151f9bfa4" }, backplateSemitransparentAccentDisabled: { defaultClass: "sprinkles_color_backplateSemitransparentAccentDisabled__151f9bfa5" }, backplateSemitransparentAccentFocus: { defaultClass: "sprinkles_color_backplateSemitransparentAccentFocus__151f9bfa6" }, backplateSemitransparentAccentHover: { defaultClass: "sprinkles_color_backplateSemitransparentAccentHover__151f9bfa7" }, backplateSemitransparentAccentPress: { defaultClass: "sprinkles_color_backplateSemitransparentAccentPress__151f9bfa8" }, backplateSemitransparentAccentRest: { defaultClass: "sprinkles_color_backplateSemitransparentAccentRest__151f9bfa9" }, backplateSemitransparentPrimaryDisabled: { defaultClass: "sprinkles_color_backplateSemitransparentPrimaryDisabled__151f9bfaa" }, backplateSemitransparentPrimaryFocus: { defaultClass: "sprinkles_color_backplateSemitransparentPrimaryFocus__151f9bfab" }, backplateSemitransparentPrimaryHover: { defaultClass: "sprinkles_color_backplateSemitransparentPrimaryHover__151f9bfac" }, backplateSemitransparentPrimaryPress: { defaultClass: "sprinkles_color_backplateSemitransparentPrimaryPress__151f9bfad" }, backplateSemitransparentPrimaryRest: { defaultClass: "sprinkles_color_backplateSemitransparentPrimaryRest__151f9bfae" }, backplateSemitransparentSecondaryDisabled: { defaultClass: "sprinkles_color_backplateSemitransparentSecondaryDisabled__151f9bfaf" }, backplateSemitransparentSecondaryFocus: { defaultClass: "sprinkles_color_backplateSemitransparentSecondaryFocus__151f9bfag" }, backplateSemitransparentSecondaryHover: { defaultClass: "sprinkles_color_backplateSemitransparentSecondaryHover__151f9bfah" }, backplateSemitransparentSecondaryPress: { defaultClass: "sprinkles_color_backplateSemitransparentSecondaryPress__151f9bfai" }, backplateSemitransparentSecondaryRest: { defaultClass: "sprinkles_color_backplateSemitransparentSecondaryRest__151f9bfaj" }, backplateSemitransparentTertiaryDisabled: { defaultClass: "sprinkles_color_backplateSemitransparentTertiaryDisabled__151f9bfak" }, backplateSemitransparentTertiaryFocus: { defaultClass: "sprinkles_color_backplateSemitransparentTertiaryFocus__151f9bfal" }, backplateSemitransparentTertiaryHover: { defaultClass: "sprinkles_color_backplateSemitransparentTertiaryHover__151f9bfam" }, backplateSemitransparentTertiaryPress: { defaultClass: "sprinkles_color_backplateSemitransparentTertiaryPress__151f9bfan" }, backplateSemitransparentTertiaryRest: { defaultClass: "sprinkles_color_backplateSemitransparentTertiaryRest__151f9bfao" }, backplateSolidAccentDisabled: { defaultClass: "sprinkles_color_backplateSolidAccentDisabled__151f9bfap" }, backplateSolidAccentFocus: { defaultClass: "sprinkles_color_backplateSolidAccentFocus__151f9bfaq" }, backplateSolidAccentHover: { defaultClass: "sprinkles_color_backplateSolidAccentHover__151f9bfar" }, backplateSolidAccentPress: { defaultClass: "sprinkles_color_backplateSolidAccentPress__151f9bfas" }, backplateSolidAccentRest: { defaultClass: "sprinkles_color_backplateSolidAccentRest__151f9bfat" }, backplateSolidBrandRest: { defaultClass: "sprinkles_color_backplateSolidBrandRest__151f9bfau" }, backplateSolidPrimaryDisabled: { defaultClass: "sprinkles_color_backplateSolidPrimaryDisabled__151f9bfav" }, backplateSolidPrimaryFocus: { defaultClass: "sprinkles_color_backplateSolidPrimaryFocus__151f9bfaw" }, backplateSolidPrimaryHover: { defaultClass: "sprinkles_color_backplateSolidPrimaryHover__151f9bfax" }, backplateSolidPrimaryPress: { defaultClass: "sprinkles_color_backplateSolidPrimaryPress__151f9bfay" }, backplateSolidPrimaryRest: { defaultClass: "sprinkles_color_backplateSolidPrimaryRest__151f9bfaz" }, backplateSolidSecondaryDisabled: { defaultClass: "sprinkles_color_backplateSolidSecondaryDisabled__151f9bfb0" }, backplateSolidSecondaryFocus: { defaultClass: "sprinkles_color_backplateSolidSecondaryFocus__151f9bfb1" }, backplateSolidSecondaryHover: { defaultClass: "sprinkles_color_backplateSolidSecondaryHover__151f9bfb2" }, backplateSolidSecondaryPress: { defaultClass: "sprinkles_color_backplateSolidSecondaryPress__151f9bfb3" }, backplateSolidSecondaryRest: { defaultClass: "sprinkles_color_backplateSolidSecondaryRest__151f9bfb4" }, backplateSolidTertiaryDisabled: { defaultClass: "sprinkles_color_backplateSolidTertiaryDisabled__151f9bfb5" }, backplateSolidTertiaryFocus: { defaultClass: "sprinkles_color_backplateSolidTertiaryFocus__151f9bfb6" }, backplateSolidTertiaryHover: { defaultClass: "sprinkles_color_backplateSolidTertiaryHover__151f9bfb7" }, backplateSolidTertiaryPress: { defaultClass: "sprinkles_color_backplateSolidTertiaryPress__151f9bfb8" }, backplateSolidTertiaryRest: { defaultClass: "sprinkles_color_backplateSolidTertiaryRest__151f9bfb9" }, dividerLight: { defaultClass: "sprinkles_color_dividerLight__151f9bfba" }, dividerMedium: { defaultClass: "sprinkles_color_dividerMedium__151f9bfbb" }, dividerStrong: { defaultClass: "sprinkles_color_dividerStrong__151f9bfbc" }, activityOnline: { defaultClass: "sprinkles_color_activityOnline__151f9bfbd" }, activityOffline: { defaultClass: "sprinkles_color_activityOffline__151f9bfbe" }, activityError: { defaultClass: "sprinkles_color_activityError__151f9bfbf" }, activityWarning: { defaultClass: "sprinkles_color_activityWarning__151f9bfbg" }, activityFavorite: { defaultClass: "sprinkles_color_activityFavorite__151f9bfbh" }, productXboxGreen: { defaultClass: "sprinkles_color_productXboxGreen__151f9bfbi" }, productDataVizXbox: { defaultClass: "sprinkles_color_productDataVizXbox__151f9bfbj" }, productDataVizWindows: { defaultClass: "sprinkles_color_productDataVizWindows__151f9bfbk" }, productDataVizChevron: { defaultClass: "sprinkles_color_productDataVizChevron__151f9bfbl" }, hCBlack: { defaultClass: "sprinkles_color_hCBlack__151f9bfbm" }, hCDisabled: { defaultClass: "sprinkles_color_hCDisabled__151f9bfbn" }, hCHyperlink: { defaultClass: "sprinkles_color_hCHyperlink__151f9bfbo" }, hCPrimary: { defaultClass: "sprinkles_color_hCPrimary__151f9bfbp" }, hCSecondary: { defaultClass: "sprinkles_color_hCSecondary__151f9bfbq" }, hCWhite: { defaultClass: "sprinkles_color_hCWhite__151f9bfbr" }, smokeLight: { defaultClass: "sprinkles_color_smokeLight__151f9bfbs" }, smokeStrong: { defaultClass: "sprinkles_color_smokeStrong__151f9bfbt" }, focusActive: { defaultClass: "sprinkles_color_focusActive__151f9bfbu" } } }, background: { values: { contentPrimary: { defaultClass: "sprinkles_background_contentPrimary__151f9bfbv" }, contentSecondary: { defaultClass: "sprinkles_background_contentSecondary__151f9bfbw" }, contentDisabled: { defaultClass: "sprinkles_background_contentDisabled__151f9bfbx" }, contentError: { defaultClass: "sprinkles_background_contentError__151f9bfby" }, contentAccent: { defaultClass: "sprinkles_background_contentAccent__151f9bfbz" }, contentOnBackplatePrimary: { defaultClass: "sprinkles_background_contentOnBackplatePrimary__151f9bfc0" }, contentOnBackplateSecondary: { defaultClass: "sprinkles_background_contentOnBackplateSecondary__151f9bfc1" }, contentOnBackplateTertiary: { defaultClass: "sprinkles_background_contentOnBackplateTertiary__151f9bfc2" }, contentOnBackplateAccent: { defaultClass: "sprinkles_background_contentOnBackplateAccent__151f9bfc3" }, contentOnBackplateDisabled: { defaultClass: "sprinkles_background_contentOnBackplateDisabled__151f9bfc4" }, contentOnBackplateTransparentPrimary: { defaultClass: "sprinkles_background_contentOnBackplateTransparentPrimary__151f9bfc5" }, contentOnBackplateTransparentSecondary: { defaultClass: "sprinkles_background_contentOnBackplateTransparentSecondary__151f9bfc6" }, contentOnBackplateTransparentTertiary: { defaultClass: "sprinkles_background_contentOnBackplateTransparentTertiary__151f9bfc7" }, contentOnBackplateTransparentAccent: { defaultClass: "sprinkles_background_contentOnBackplateTransparentAccent__151f9bfc8" }, contentOnBackplateTransparentDisabled: { defaultClass: "sprinkles_background_contentOnBackplateTransparentDisabled__151f9bfc9" }, contentOnBackplateAcrylicPrimaryRest: { defaultClass: "sprinkles_background_contentOnBackplateAcrylicPrimaryRest__151f9bfca" }, contentOnHover: { defaultClass: "sprinkles_background_contentOnHover__151f9bfcb" }, contentOnHoverTransparent: { defaultClass: "sprinkles_background_contentOnHoverTransparent__151f9bfcc" }, contentOnPress: { defaultClass: "sprinkles_background_contentOnPress__151f9bfcd" }, contentOnPressTransparent: { defaultClass: "sprinkles_background_contentOnPressTransparent__151f9bfce" }, contentPrimaryDisabled: { defaultClass: "sprinkles_background_contentPrimaryDisabled__151f9bfcf" }, contentPrimaryOnHover: { defaultClass: "sprinkles_background_contentPrimaryOnHover__151f9bfcg" }, contentPrimaryOnPress: { defaultClass: "sprinkles_background_contentPrimaryOnPress__151f9bfch" }, contentHyperlinkRest: { defaultClass: "sprinkles_background_contentHyperlinkRest__151f9bfci" }, contentHyperlinkHover: { defaultClass: "sprinkles_background_contentHyperlinkHover__151f9bfcj" }, contentHyperlinkPress: { defaultClass: "sprinkles_background_contentHyperlinkPress__151f9bfck" }, contentHyperlinkVisited: { defaultClass: "sprinkles_background_contentHyperlinkVisited__151f9bfcl" }, containerSolidAppBackground: { defaultClass: "sprinkles_background_containerSolidAppBackground__151f9bfcm" }, containerSolidContainer: { defaultClass: "sprinkles_background_containerSolidContainer__151f9bfcn" }, containerSolidContainerDark: { defaultClass: "sprinkles_background_containerSolidContainerDark__151f9bfco" }, containerSolidContainerLight: { defaultClass: "sprinkles_background_containerSolidContainerLight__151f9bfcp" }, containerAcrylicDark: { defaultClass: "sprinkles_background_containerAcrylicDark__151f9bfcq" }, containerAcrylicExtraDark: { defaultClass: "sprinkles_background_containerAcrylicExtraDark__151f9bfcr" }, containerAcrylicExtraLight: { defaultClass: "sprinkles_background_containerAcrylicExtraLight__151f9bfcs" }, containerAcrylicLight: { defaultClass: "sprinkles_background_containerAcrylicLight__151f9bfct" }, containerAcrylicWhiteHeavy: { defaultClass: "sprinkles_background_containerAcrylicWhiteHeavy__151f9bfcu" }, containerAcrylicWhiteLight: { defaultClass: "sprinkles_background_containerAcrylicWhiteLight__151f9bfcv" }, containerSemitransparentFogHeavy: { defaultClass: "sprinkles_background_containerSemitransparentFogHeavy__151f9bfcw" }, containerSemitransparentFogLight: { defaultClass: "sprinkles_background_containerSemitransparentFogLight__151f9bfcx" }, containerSemitransparentSmokeDark: { defaultClass: "sprinkles_background_containerSemitransparentSmokeDark__151f9bfcy" }, containerSemitransparentSmokeExtraDark: { defaultClass: "sprinkles_background_containerSemitransparentSmokeExtraDark__151f9bfcz" }, containerSemitransparentSmokeExtraLight: { defaultClass: "sprinkles_background_containerSemitransparentSmokeExtraLight__151f9bfd0" }, containerSemitransparentSmokeLight: { defaultClass: "sprinkles_background_containerSemitransparentSmokeLight__151f9bfd1" }, stateHover: { defaultClass: "sprinkles_background_stateHover__151f9bfd2" }, statePress: { defaultClass: "sprinkles_background_statePress__151f9bfd3" }, stateFocus: { defaultClass: "sprinkles_background_stateFocus__151f9bfd4" }, stateRest: { defaultClass: "sprinkles_background_stateRest__151f9bfd5" }, stateDisabled: { defaultClass: "sprinkles_background_stateDisabled__151f9bfd6" }, backplateAcrylicAccentDisabled: { defaultClass: "sprinkles_background_backplateAcrylicAccentDisabled__151f9bfd7" }, backplateAcrylicAccentFocus: { defaultClass: "sprinkles_background_backplateAcrylicAccentFocus__151f9bfd8" }, backplateAcrylicAccentHover: { defaultClass: "sprinkles_background_backplateAcrylicAccentHover__151f9bfd9" }, backplateAcrylicAccentPress: { defaultClass: "sprinkles_background_backplateAcrylicAccentPress__151f9bfda" }, backplateAcrylicAccentRest: { defaultClass: "sprinkles_background_backplateAcrylicAccentRest__151f9bfdb" }, backplateAcrylicPrimaryDisabled: { defaultClass: "sprinkles_background_backplateAcrylicPrimaryDisabled__151f9bfdc" }, backplateAcrylicPrimaryFocus: { defaultClass: "sprinkles_background_backplateAcrylicPrimaryFocus__151f9bfdd" }, backplateAcrylicPrimaryHover: { defaultClass: "sprinkles_background_backplateAcrylicPrimaryHover__151f9bfde" }, backplateAcrylicPrimaryPress: { defaultClass: "sprinkles_background_backplateAcrylicPrimaryPress__151f9bfdf" }, backplateAcrylicPrimaryRest: { defaultClass: "sprinkles_background_backplateAcrylicPrimaryRest__151f9bfdg" }, backplateAcrylicSecondaryDisabled: { defaultClass: "sprinkles_background_backplateAcrylicSecondaryDisabled__151f9bfdh" }, backplateAcrylicSecondaryFocus: { defaultClass: "sprinkles_background_backplateAcrylicSecondaryFocus__151f9bfdi" }, backplateAcrylicSecondaryHover: { defaultClass: "sprinkles_background_backplateAcrylicSecondaryHover__151f9bfdj" }, backplateAcrylicSecondaryPress: { defaultClass: "sprinkles_background_backplateAcrylicSecondaryPress__151f9bfdk" }, backplateAcrylicSecondaryRest: { defaultClass: "sprinkles_background_backplateAcrylicSecondaryRest__151f9bfdl" }, backplateAcrylicTertiaryDisabled: { defaultClass: "sprinkles_background_backplateAcrylicTertiaryDisabled__151f9bfdm" }, backplateAcrylicTertiaryFocus: { defaultClass: "sprinkles_background_backplateAcrylicTertiaryFocus__151f9bfdn" }, backplateAcrylicTertiaryHover: { defaultClass: "sprinkles_background_backplateAcrylicTertiaryHover__151f9bfdo" }, backplateAcrylicTertiaryPress: { defaultClass: "sprinkles_background_backplateAcrylicTertiaryPress__151f9bfdp" }, backplateAcrylicTertiaryRest: { defaultClass: "sprinkles_background_backplateAcrylicTertiaryRest__151f9bfdq" }, backplateSemitransparentAccentDisabled: { defaultClass: "sprinkles_background_backplateSemitransparentAccentDisabled__151f9bfdr" }, backplateSemitransparentAccentFocus: { defaultClass: "sprinkles_background_backplateSemitransparentAccentFocus__151f9bfds" }, backplateSemitransparentAccentHover: { defaultClass: "sprinkles_background_backplateSemitransparentAccentHover__151f9bfdt" }, backplateSemitransparentAccentPress: { defaultClass: "sprinkles_background_backplateSemitransparentAccentPress__151f9bfdu" }, backplateSemitransparentAccentRest: { defaultClass: "sprinkles_background_backplateSemitransparentAccentRest__151f9bfdv" }, backplateSemitransparentPrimaryDisabled: { defaultClass: "sprinkles_background_backplateSemitransparentPrimaryDisabled__151f9bfdw" }, backplateSemitransparentPrimaryFocus: { defaultClass: "sprinkles_background_backplateSemitransparentPrimaryFocus__151f9bfdx" }, backplateSemitransparentPrimaryHover: { defaultClass: "sprinkles_background_backplateSemitransparentPrimaryHover__151f9bfdy" }, backplateSemitransparentPrimaryPress: { defaultClass: "sprinkles_background_backplateSemitransparentPrimaryPress__151f9bfdz" }, backplateSemitransparentPrimaryRest: { defaultClass: "sprinkles_background_backplateSemitransparentPrimaryRest__151f9bfe0" }, backplateSemitransparentSecondaryDisabled: { defaultClass: "sprinkles_background_backplateSemitransparentSecondaryDisabled__151f9bfe1" }, backplateSemitransparentSecondaryFocus: { defaultClass: "sprinkles_background_backplateSemitransparentSecondaryFocus__151f9bfe2" }, backplateSemitransparentSecondaryHover: { defaultClass: "sprinkles_background_backplateSemitransparentSecondaryHover__151f9bfe3" }, backplateSemitransparentSecondaryPress: { defaultClass: "sprinkles_background_backplateSemitransparentSecondaryPress__151f9bfe4" }, backplateSemitransparentSecondaryRest: { defaultClass: "sprinkles_background_backplateSemitransparentSecondaryRest__151f9bfe5" }, backplateSemitransparentTertiaryDisabled: { defaultClass: "sprinkles_background_backplateSemitransparentTertiaryDisabled__151f9bfe6" }, backplateSemitransparentTertiaryFocus: { defaultClass: "sprinkles_background_backplateSemitransparentTertiaryFocus__151f9bfe7" }, backplateSemitransparentTertiaryHover: { defaultClass: "sprinkles_background_backplateSemitransparentTertiaryHover__151f9bfe8" }, backplateSemitransparentTertiaryPress: { defaultClass: "sprinkles_background_backplateSemitransparentTertiaryPress__151f9bfe9" }, backplateSemitransparentTertiaryRest: { defaultClass: "sprinkles_background_backplateSemitransparentTertiaryRest__151f9bfea" }, backplateSolidAccentDisabled: { defaultClass: "sprinkles_background_backplateSolidAccentDisabled__151f9bfeb" }, backplateSolidAccentFocus: { defaultClass: "sprinkles_background_backplateSolidAccentFocus__151f9bfec" }, backplateSolidAccentHover: { defaultClass: "sprinkles_background_backplateSolidAccentHover__151f9bfed" }, backplateSolidAccentPress: { defaultClass: "sprinkles_background_backplateSolidAccentPress__151f9bfee" }, backplateSolidAccentRest: { defaultClass: "sprinkles_background_backplateSolidAccentRest__151f9bfef" }, backplateSolidBrandRest: { defaultClass: "sprinkles_background_backplateSolidBrandRest__151f9bfeg" }, backplateSolidPrimaryDisabled: { defaultClass: "sprinkles_background_backplateSolidPrimaryDisabled__151f9bfeh" }, backplateSolidPrimaryFocus: { defaultClass: "sprinkles_background_backplateSolidPrimaryFocus__151f9bfei" }, backplateSolidPrimaryHover: { defaultClass: "sprinkles_background_backplateSolidPrimaryHover__151f9bfej" }, backplateSolidPrimaryPress: { defaultClass: "sprinkles_background_backplateSolidPrimaryPress__151f9bfek" }, backplateSolidPrimaryRest: { defaultClass: "sprinkles_background_backplateSolidPrimaryRest__151f9bfel" }, backplateSolidSecondaryDisabled: { defaultClass: "sprinkles_background_backplateSolidSecondaryDisabled__151f9bfem" }, backplateSolidSecondaryFocus: { defaultClass: "sprinkles_background_backplateSolidSecondaryFocus__151f9bfen" }, backplateSolidSecondaryHover: { defaultClass: "sprinkles_background_backplateSolidSecondaryHover__151f9bfeo" }, backplateSolidSecondaryPress: { defaultClass: "sprinkles_background_backplateSolidSecondaryPress__151f9bfep" }, backplateSolidSecondaryRest: { defaultClass: "sprinkles_background_backplateSolidSecondaryRest__151f9bfeq" }, backplateSolidTertiaryDisabled: { defaultClass: "sprinkles_background_backplateSolidTertiaryDisabled__151f9bfer" }, backplateSolidTertiaryFocus: { defaultClass: "sprinkles_background_backplateSolidTertiaryFocus__151f9bfes" }, backplateSolidTertiaryHover: { defaultClass: "sprinkles_background_backplateSolidTertiaryHover__151f9bfet" }, backplateSolidTertiaryPress: { defaultClass: "sprinkles_background_backplateSolidTertiaryPress__151f9bfeu" }, backplateSolidTertiaryRest: { defaultClass: "sprinkles_background_backplateSolidTertiaryRest__151f9bfev" }, dividerLight: { defaultClass: "sprinkles_background_dividerLight__151f9bfew" }, dividerMedium: { defaultClass: "sprinkles_background_dividerMedium__151f9bfex" }, dividerStrong: { defaultClass: "sprinkles_background_dividerStrong__151f9bfey" }, activityOnline: { defaultClass: "sprinkles_background_activityOnline__151f9bfez" }, activityOffline: { defaultClass: "sprinkles_background_activityOffline__151f9bff0" }, activityError: { defaultClass: "sprinkles_background_activityError__151f9bff1" }, activityWarning: { defaultClass: "sprinkles_background_activityWarning__151f9bff2" }, activityFavorite: { defaultClass: "sprinkles_background_activityFavorite__151f9bff3" }, productXboxGreen: { defaultClass: "sprinkles_background_productXboxGreen__151f9bff4" }, productDataVizXbox: { defaultClass: "sprinkles_background_productDataVizXbox__151f9bff5" }, productDataVizWindows: { defaultClass: "sprinkles_background_productDataVizWindows__151f9bff6" }, productDataVizChevron: { defaultClass: "sprinkles_background_productDataVizChevron__151f9bff7" }, hCBlack: { defaultClass: "sprinkles_background_hCBlack__151f9bff8" }, hCDisabled: { defaultClass: "sprinkles_background_hCDisabled__151f9bff9" }, hCHyperlink: { defaultClass: "sprinkles_background_hCHyperlink__151f9bffa" }, hCPrimary: { defaultClass: "sprinkles_background_hCPrimary__151f9bffb" }, hCSecondary: { defaultClass: "sprinkles_background_hCSecondary__151f9bffc" }, hCWhite: { defaultClass: "sprinkles_background_hCWhite__151f9bffd" }, smokeLight: { defaultClass: "sprinkles_background_smokeLight__151f9bffe" }, smokeStrong: { defaultClass: "sprinkles_background_smokeStrong__151f9bfff" }, focusActive: { defaultClass: "sprinkles_background_focusActive__151f9bffg" } } }, backgroundColor: { values: { contentPrimary: { defaultClass: "sprinkles_backgroundColor_contentPrimary__151f9bffh" }, contentSecondary: { defaultClass: "sprinkles_backgroundColor_contentSecondary__151f9bffi" }, contentDisabled: { defaultClass: "sprinkles_backgroundColor_contentDisabled__151f9bffj" }, contentError: { defaultClass: "sprinkles_backgroundColor_contentError__151f9bffk" }, contentAccent: { defaultClass: "sprinkles_backgroundColor_contentAccent__151f9bffl" }, contentOnBackplatePrimary: { defaultClass: "sprinkles_backgroundColor_contentOnBackplatePrimary__151f9bffm" }, contentOnBackplateSecondary: { defaultClass: "sprinkles_backgroundColor_contentOnBackplateSecondary__151f9bffn" }, contentOnBackplateTertiary: { defaultClass: "sprinkles_backgroundColor_contentOnBackplateTertiary__151f9bffo" }, contentOnBackplateAccent: { defaultClass: "sprinkles_backgroundColor_contentOnBackplateAccent__151f9bffp" }, contentOnBackplateDisabled: { defaultClass: "sprinkles_backgroundColor_contentOnBackplateDisabled__151f9bffq" }, contentOnBackplateTransparentPrimary: { defaultClass: "sprinkles_backgroundColor_contentOnBackplateTransparentPrimary__151f9bffr" }, contentOnBackplateTransparentSecondary: { defaultClass: "sprinkles_backgroundColor_contentOnBackplateTransparentSecondary__151f9bffs" }, contentOnBackplateTransparentTertiary: { defaultClass: "sprinkles_backgroundColor_contentOnBackplateTransparentTertiary__151f9bfft" }, contentOnBackplateTransparentAccent: { defaultClass: "sprinkles_backgroundColor_contentOnBackplateTransparentAccent__151f9bffu" }, contentOnBackplateTransparentDisabled: { defaultClass: "sprinkles_backgroundColor_contentOnBackplateTransparentDisabled__151f9bffv" }, contentOnBackplateAcrylicPrimaryRest: { defaultClass: "sprinkles_backgroundColor_contentOnBackplateAcrylicPrimaryRest__151f9bffw" }, contentOnHover: { defaultClass: "sprinkles_backgroundColor_contentOnHover__151f9bffx" }, contentOnHoverTransparent: { defaultClass: "sprinkles_backgroundColor_contentOnHoverTransparent__151f9bffy" }, contentOnPress: { defaultClass: "sprinkles_backgroundColor_contentOnPress__151f9bffz" }, contentOnPressTransparent: { defaultClass: "sprinkles_backgroundColor_contentOnPressTransparent__151f9bfg0" }, contentPrimaryDisabled: { defaultClass: "sprinkles_backgroundColor_contentPrimaryDisabled__151f9bfg1" }, contentPrimaryOnHover: { defaultClass: "sprinkles_backgroundColor_contentPrimaryOnHover__151f9bfg2" }, contentPrimaryOnPress: { defaultClass: "sprinkles_backgroundColor_contentPrimaryOnPress__151f9bfg3" }, contentHyperlinkRest: { defaultClass: "sprinkles_backgroundColor_contentHyperlinkRest__151f9bfg4" }, contentHyperlinkHover: { defaultClass: "sprinkles_backgroundColor_contentHyperlinkHover__151f9bfg5" }, contentHyperlinkPress: { defaultClass: "sprinkles_backgroundColor_contentHyperlinkPress__151f9bfg6" }, contentHyperlinkVisited: { defaultClass: "sprinkles_backgroundColor_contentHyperlinkVisited__151f9bfg7" }, containerSolidAppBackground: { defaultClass: "sprinkles_backgroundColor_containerSolidAppBackground__151f9bfg8" }, containerSolidContainer: { defaultClass: "sprinkles_backgroundColor_containerSolidContainer__151f9bfg9" }, containerSolidContainerDark: { defaultClass: "sprinkles_backgroundColor_containerSolidContainerDark__151f9bfga" }, containerSolidContainerLight: { defaultClass: "sprinkles_backgroundColor_containerSolidContainerLight__151f9bfgb" }, containerAcrylicDark: { defaultClass: "sprinkles_backgroundColor_containerAcrylicDark__151f9bfgc" }, containerAcrylicExtraDark: { defaultClass: "sprinkles_backgroundColor_containerAcrylicExtraDark__151f9bfgd" }, containerAcrylicExtraLight: { defaultClass: "sprinkles_backgroundColor_containerAcrylicExtraLight__151f9bfge" }, containerAcrylicLight: { defaultClass: "sprinkles_backgroundColor_containerAcrylicLight__151f9bfgf" }, containerAcrylicWhiteHeavy: { defaultClass: "sprinkles_backgroundColor_containerAcrylicWhiteHeavy__151f9bfgg" }, containerAcrylicWhiteLight: { defaultClass: "sprinkles_backgroundColor_containerAcrylicWhiteLight__151f9bfgh" }, containerSemitransparentFogHeavy: { defaultClass: "sprinkles_backgroundColor_containerSemitransparentFogHeavy__151f9bfgi" }, containerSemitransparentFogLight: { defaultClass: "sprinkles_backgroundColor_containerSemitransparentFogLight__151f9bfgj" }, containerSemitransparentSmokeDark: { defaultClass: "sprinkles_backgroundColor_containerSemitransparentSmokeDark__151f9bfgk" }, containerSemitransparentSmokeExtraDark: { defaultClass: "sprinkles_backgroundColor_containerSemitransparentSmokeExtraDark__151f9bfgl" }, containerSemitransparentSmokeExtraLight: { defaultClass: "sprinkles_backgroundColor_containerSemitransparentSmokeExtraLight__151f9bfgm" }, containerSemitransparentSmokeLight: { defaultClass: "sprinkles_backgroundColor_containerSemitransparentSmokeLight__151f9bfgn" }, stateHover: { defaultClass: "sprinkles_backgroundColor_stateHover__151f9bfgo" }, statePress: { defaultClass: "sprinkles_backgroundColor_statePress__151f9bfgp" }, stateFocus: { defaultClass: "sprinkles_backgroundColor_stateFocus__151f9bfgq" }, stateRest: { defaultClass: "sprinkles_backgroundColor_stateRest__151f9bfgr" }, stateDisabled: { defaultClass: "sprinkles_backgroundColor_stateDisabled__151f9bfgs" }, backplateAcrylicAccentDisabled: { defaultClass: "sprinkles_backgroundColor_backplateAcrylicAccentDisabled__151f9bfgt" }, backplateAcrylicAccentFocus: { defaultClass: "sprinkles_backgroundColor_backplateAcrylicAccentFocus__151f9bfgu" }, backplateAcrylicAccentHover: { defaultClass: "sprinkles_backgroundColor_backplateAcrylicAccentHover__151f9bfgv" }, backplateAcrylicAccentPress: { defaultClass: "sprinkles_backgroundColor_backplateAcrylicAccentPress__151f9bfgw" }, backplateAcrylicAccentRest: { defaultClass: "sprinkles_backgroundColor_backplateAcrylicAccentRest__151f9bfgx" }, backplateAcrylicPrimaryDisabled: { defaultClass: "sprinkles_backgroundColor_backplateAcrylicPrimaryDisabled__151f9bfgy" }, backplateAcrylicPrimaryFocus: { defaultClass: "sprinkles_backgroundColor_backplateAcrylicPrimaryFocus__151f9bfgz" }, backplateAcrylicPrimaryHover: { defaultClass: "sprinkles_backgroundColor_backplateAcrylicPrimaryHover__151f9bfh0" }, backplateAcrylicPrimaryPress: { defaultClass: "sprinkles_backgroundColor_backplateAcrylicPrimaryPress__151f9bfh1" }, backplateAcrylicPrimaryRest: { defaultClass: "sprinkles_backgroundColor_backplateAcrylicPrimaryRest__151f9bfh2" }, backplateAcrylicSecondaryDisabled: { defaultClass: "sprinkles_backgroundColor_backplateAcrylicSecondaryDisabled__151f9bfh3" }, backplateAcrylicSecondaryFocus: { defaultClass: "sprinkles_backgroundColor_backplateAcrylicSecondaryFocus__151f9bfh4" }, backplateAcrylicSecondaryHover: { defaultClass: "sprinkles_backgroundColor_backplateAcrylicSecondaryHover__151f9bfh5" }, backplateAcrylicSecondaryPress: { defaultClass: "sprinkles_backgroundColor_backplateAcrylicSecondaryPress__151f9bfh6" }, backplateAcrylicSecondaryRest: { defaultClass: "sprinkles_backgroundColor_backplateAcrylicSecondaryRest__151f9bfh7" }, backplateAcrylicTertiaryDisabled: { defaultClass: "sprinkles_backgroundColor_backplateAcrylicTertiaryDisabled__151f9bfh8" }, backplateAcrylicTertiaryFocus: { defaultClass: "sprinkles_backgroundColor_backplateAcrylicTertiaryFocus__151f9bfh9" }, backplateAcrylicTertiaryHover: { defaultClass: "sprinkles_backgroundColor_backplateAcrylicTertiaryHover__151f9bfha" }, backplateAcrylicTertiaryPress: { defaultClass: "sprinkles_backgroundColor_backplateAcrylicTertiaryPress__151f9bfhb" }, backplateAcrylicTertiaryRest: { defaultClass: "sprinkles_backgroundColor_backplateAcrylicTertiaryRest__151f9bfhc" }, backplateSemitransparentAccentDisabled: { defaultClass: "sprinkles_backgroundColor_backplateSemitransparentAccentDisabled__151f9bfhd" }, backplateSemitransparentAccentFocus: { defaultClass: "sprinkles_backgroundColor_backplateSemitransparentAccentFocus__151f9bfhe" }, backplateSemitransparentAccentHover: { defaultClass: "sprinkles_backgroundColor_backplateSemitransparentAccentHover__151f9bfhf" }, backplateSemitransparentAccentPress: { defaultClass: "sprinkles_backgroundColor_backplateSemitransparentAccentPress__151f9bfhg" }, backplateSemitransparentAccentRest: { defaultClass: "sprinkles_backgroundColor_backplateSemitransparentAccentRest__151f9bfhh" }, backplateSemitransparentPrimaryDisabled: { defaultClass: "sprinkles_backgroundColor_backplateSemitransparentPrimaryDisabled__151f9bfhi" }, backplateSemitransparentPrimaryFocus: { defaultClass: "sprinkles_backgroundColor_backplateSemitransparentPrimaryFocus__151f9bfhj" }, backplateSemitransparentPrimaryHover: { defaultClass: "sprinkles_backgroundColor_backplateSemitransparentPrimaryHover__151f9bfhk" }, backplateSemitransparentPrimaryPress: { defaultClass: "sprinkles_backgroundColor_backplateSemitransparentPrimaryPress__151f9bfhl" }, backplateSemitransparentPrimaryRest: { defaultClass: "sprinkles_backgroundColor_backplateSemitransparentPrimaryRest__151f9bfhm" }, backplateSemitransparentSecondaryDisabled: { defaultClass: "sprinkles_backgroundColor_backplateSemitransparentSecondaryDisabled__151f9bfhn" }, backplateSemitransparentSecondaryFocus: { defaultClass: "sprinkles_backgroundColor_backplateSemitransparentSecondaryFocus__151f9bfho" }, backplateSemitransparentSecondaryHover: { defaultClass: "sprinkles_backgroundColor_backplateSemitransparentSecondaryHover__151f9bfhp" }, backplateSemitransparentSecondaryPress: { defaultClass: "sprinkles_backgroundColor_backplateSemitransparentSecondaryPress__151f9bfhq" }, backplateSemitransparentSecondaryRest: { defaultClass: "sprinkles_backgroundColor_backplateSemitransparentSecondaryRest__151f9bfhr" }, backplateSemitransparentTertiaryDisabled: { defaultClass: "sprinkles_backgroundColor_backplateSemitransparentTertiaryDisabled__151f9bfhs" }, backplateSemitransparentTertiaryFocus: { defaultClass: "sprinkles_backgroundColor_backplateSemitransparentTertiaryFocus__151f9bfht" }, backplateSemitransparentTertiaryHover: { defaultClass: "sprinkles_backgroundColor_backplateSemitransparentTertiaryHover__151f9bfhu" }, backplateSemitransparentTertiaryPress: { defaultClass: "sprinkles_backgroundColor_backplateSemitransparentTertiaryPress__151f9bfhv" }, backplateSemitransparentTertiaryRest: { defaultClass: "sprinkles_backgroundColor_backplateSemitransparentTertiaryRest__151f9bfhw" }, backplateSolidAccentDisabled: { defaultClass: "sprinkles_backgroundColor_backplateSolidAccentDisabled__151f9bfhx" }, backplateSolidAccentFocus: { defaultClass: "sprinkles_backgroundColor_backplateSolidAccentFocus__151f9bfhy" }, backplateSolidAccentHover: { defaultClass: "sprinkles_backgroundColor_backplateSolidAccentHover__151f9bfhz" }, backplateSolidAccentPress: { defaultClass: "sprinkles_backgroundColor_backplateSolidAccentPress__151f9bfi0" }, backplateSolidAccentRest: { defaultClass: "sprinkles_backgroundColor_backplateSolidAccentRest__151f9bfi1" }, backplateSolidBrandRest: { defaultClass: "sprinkles_backgroundColor_backplateSolidBrandRest__151f9bfi2" }, backplateSolidPrimaryDisabled: { defaultClass: "sprinkles_backgroundColor_backplateSolidPrimaryDisabled__151f9bfi3" }, backplateSolidPrimaryFocus: { defaultClass: "sprinkles_backgroundColor_backplateSolidPrimaryFocus__151f9bfi4" }, backplateSolidPrimaryHover: { defaultClass: "sprinkles_backgroundColor_backplateSolidPrimaryHover__151f9bfi5" }, backplateSolidPrimaryPress: { defaultClass: "sprinkles_backgroundColor_backplateSolidPrimaryPress__151f9bfi6" }, backplateSolidPrimaryRest: { defaultClass: "sprinkles_backgroundColor_backplateSolidPrimaryRest__151f9bfi7" }, backplateSolidSecondaryDisabled: { defaultClass: "sprinkles_backgroundColor_backplateSolidSecondaryDisabled__151f9bfi8" }, backplateSolidSecondaryFocus: { defaultClass: "sprinkles_backgroundColor_backplateSolidSecondaryFocus__151f9bfi9" }, backplateSolidSecondaryHover: { defaultClass: "sprinkles_backgroundColor_backplateSolidSecondaryHover__151f9bfia" }, backplateSolidSecondaryPress: { defaultClass: "sprinkles_backgroundColor_backplateSolidSecondaryPress__151f9bfib" }, backplateSolidSecondaryRest: { defaultClass: "sprinkles_backgroundColor_backplateSolidSecondaryRest__151f9bfic" }, backplateSolidTertiaryDisabled: { defaultClass: "sprinkles_backgroundColor_backplateSolidTertiaryDisabled__151f9bfid" }, backplateSolidTertiaryFocus: { defaultClass: "sprinkles_backgroundColor_backplateSolidTertiaryFocus__151f9bfie" }, backplateSolidTertiaryHover: { defaultClass: "sprinkles_backgroundColor_backplateSolidTertiaryHover__151f9bfif" }, backplateSolidTertiaryPress: { defaultClass: "sprinkles_backgroundColor_backplateSolidTertiaryPress__151f9bfig" }, backplateSolidTertiaryRest: { defaultClass: "sprinkles_backgroundColor_backplateSolidTertiaryRest__151f9bfih" }, dividerLight: { defaultClass: "sprinkles_backgroundColor_dividerLight__151f9bfii" }, dividerMedium: { defaultClass: "sprinkles_backgroundColor_dividerMedium__151f9bfij" }, dividerStrong: { defaultClass: "sprinkles_backgroundColor_dividerStrong__151f9bfik" }, activityOnline: { defaultClass: "sprinkles_backgroundColor_activityOnline__151f9bfil" }, activityOffline: { defaultClass: "sprinkles_backgroundColor_activityOffline__151f9bfim" }, activityError: { defaultClass: "sprinkles_backgroundColor_activityError__151f9bfin" }, activityWarning: { defaultClass: "sprinkles_backgroundColor_activityWarning__151f9bfio" }, activityFavorite: { defaultClass: "sprinkles_backgroundColor_activityFavorite__151f9bfip" }, productXboxGreen: { defaultClass: "sprinkles_backgroundColor_productXboxGreen__151f9bfiq" }, productDataVizXbox: { defaultClass: "sprinkles_backgroundColor_productDataVizXbox__151f9bfir" }, productDataVizWindows: { defaultClass: "sprinkles_backgroundColor_productDataVizWindows__151f9bfis" }, productDataVizChevron: { defaultClass: "sprinkles_backgroundColor_productDataVizChevron__151f9bfit" }, hCBlack: { defaultClass: "sprinkles_backgroundColor_hCBlack__151f9bfiu" }, hCDisabled: { defaultClass: "sprinkles_backgroundColor_hCDisabled__151f9bfiv" }, hCHyperlink: { defaultClass: "sprinkles_backgroundColor_hCHyperlink__151f9bfiw" }, hCPrimary: { defaultClass: "sprinkles_backgroundColor_hCPrimary__151f9bfix" }, hCSecondary: { defaultClass: "sprinkles_backgroundColor_hCSecondary__151f9bfiy" }, hCWhite: { defaultClass: "sprinkles_backgroundColor_hCWhite__151f9bfiz" }, smokeLight: { defaultClass: "sprinkles_backgroundColor_smokeLight__151f9bfj0" }, smokeStrong: { defaultClass: "sprinkles_backgroundColor_smokeStrong__151f9bfj1" }, focusActive: { defaultClass: "sprinkles_backgroundColor_focusActive__151f9bfj2" } } }, borderColor: { values: { contentPrimary: { defaultClass: "sprinkles_borderColor_contentPrimary__151f9bfj3" }, contentSecondary: { defaultClass: "sprinkles_borderColor_contentSecondary__151f9bfj4" }, contentDisabled: { defaultClass: "sprinkles_borderColor_contentDisabled__151f9bfj5" }, contentError: { defaultClass: "sprinkles_borderColor_contentError__151f9bfj6" }, contentAccent: { defaultClass: "sprinkles_borderColor_contentAccent__151f9bfj7" }, contentOnBackplatePrimary: { defaultClass: "sprinkles_borderColor_contentOnBackplatePrimary__151f9bfj8" }, contentOnBackplateSecondary: { defaultClass: "sprinkles_borderColor_contentOnBackplateSecondary__151f9bfj9" }, contentOnBackplateTertiary: { defaultClass: "sprinkles_borderColor_contentOnBackplateTertiary__151f9bfja" }, contentOnBackplateAccent: { defaultClass: "sprinkles_borderColor_contentOnBackplateAccent__151f9bfjb" }, contentOnBackplateDisabled: { defaultClass: "sprinkles_borderColor_contentOnBackplateDisabled__151f9bfjc" }, contentOnBackplateTransparentPrimary: { defaultClass: "sprinkles_borderColor_contentOnBackplateTransparentPrimary__151f9bfjd" }, contentOnBackplateTransparentSecondary: { defaultClass: "sprinkles_borderColor_contentOnBackplateTransparentSecondary__151f9bfje" }, contentOnBackplateTransparentTertiary: { defaultClass: "sprinkles_borderColor_contentOnBackplateTransparentTertiary__151f9bfjf" }, contentOnBackplateTransparentAccent: { defaultClass: "sprinkles_borderColor_contentOnBackplateTransparentAccent__151f9bfjg" }, contentOnBackplateTransparentDisabled: { defaultClass: "sprinkles_borderColor_contentOnBackplateTransparentDisabled__151f9bfjh" }, contentOnBackplateAcrylicPrimaryRest: { defaultClass: "sprinkles_borderColor_contentOnBackplateAcrylicPrimaryRest__151f9bfji" }, contentOnHover: { defaultClass: "sprinkles_borderColor_contentOnHover__151f9bfjj" }, contentOnHoverTransparent: { defaultClass: "sprinkles_borderColor_contentOnHoverTransparent__151f9bfjk" }, contentOnPress: { defaultClass: "sprinkles_borderColor_contentOnPress__151f9bfjl" }, contentOnPressTransparent: { defaultClass: "sprinkles_borderColor_contentOnPressTransparent__151f9bfjm" }, contentPrimaryDisabled: { defaultClass: "sprinkles_borderColor_contentPrimaryDisabled__151f9bfjn" }, contentPrimaryOnHover: { defaultClass: "sprinkles_borderColor_contentPrimaryOnHover__151f9bfjo" }, contentPrimaryOnPress: { defaultClass: "sprinkles_borderColor_contentPrimaryOnPress__151f9bfjp" }, contentHyperlinkRest: { defaultClass: "sprinkles_borderColor_contentHyperlinkRest__151f9bfjq" }, contentHyperlinkHover: { defaultClass: "sprinkles_borderColor_contentHyperlinkHover__151f9bfjr" }, contentHyperlinkPress: { defaultClass: "sprinkles_borderColor_contentHyperlinkPress__151f9bfjs" }, contentHyperlinkVisited: { defaultClass: "sprinkles_borderColor_contentHyperlinkVisited__151f9bfjt" }, containerSolidAppBackground: { defaultClass: "sprinkles_borderColor_containerSolidAppBackground__151f9bfju" }, containerSolidContainer: { defaultClass: "sprinkles_borderColor_containerSolidContainer__151f9bfjv" }, containerSolidContainerDark: { defaultClass: "sprinkles_borderColor_containerSolidContainerDark__151f9bfjw" }, containerSolidContainerLight: { defaultClass: "sprinkles_borderColor_containerSolidContainerLight__151f9bfjx" }, containerAcrylicDark: { defaultClass: "sprinkles_borderColor_containerAcrylicDark__151f9bfjy" }, containerAcrylicExtraDark: { defaultClass: "sprinkles_borderColor_containerAcrylicExtraDark__151f9bfjz" }, containerAcrylicExtraLight: { defaultClass: "sprinkles_borderColor_containerAcrylicExtraLight__151f9bfk0" }, containerAcrylicLight: { defaultClass: "sprinkles_borderColor_containerAcrylicLight__151f9bfk1" }, containerAcrylicWhiteHeavy: { defaultClass: "sprinkles_borderColor_containerAcrylicWhiteHeavy__151f9bfk2" }, containerAcrylicWhiteLight: { defaultClass: "sprinkles_borderColor_containerAcrylicWhiteLight__151f9bfk3" }, containerSemitransparentFogHeavy: { defaultClass: "sprinkles_borderColor_containerSemitransparentFogHeavy__151f9bfk4" }, containerSemitransparentFogLight: { defaultClass: "sprinkles_borderColor_containerSemitransparentFogLight__151f9bfk5" }, containerSemitransparentSmokeDark: { defaultClass: "sprinkles_borderColor_containerSemitransparentSmokeDark__151f9bfk6" }, containerSemitransparentSmokeExtraDark: { defaultClass: "sprinkles_borderColor_containerSemitransparentSmokeExtraDark__151f9bfk7" }, containerSemitransparentSmokeExtraLight: { defaultClass: "sprinkles_borderColor_containerSemitransparentSmokeExtraLight__151f9bfk8" }, containerSemitransparentSmokeLight: { defaultClass: "sprinkles_borderColor_containerSemitransparentSmokeLight__151f9bfk9" }, stateHover: { defaultClass: "sprinkles_borderColor_stateHover__151f9bfka" }, statePress: { defaultClass: "sprinkles_borderColor_statePress__151f9bfkb" }, stateFocus: { defaultClass: "sprinkles_borderColor_stateFocus__151f9bfkc" }, stateRest: { defaultClass: "sprinkles_borderColor_stateRest__151f9bfkd" }, stateDisabled: { defaultClass: "sprinkles_borderColor_stateDisabled__151f9bfke" }, backplateAcrylicAccentDisabled: { defaultClass: "sprinkles_borderColor_backplateAcrylicAccentDisabled__151f9bfkf" }, backplateAcrylicAccentFocus: { defaultClass: "sprinkles_borderColor_backplateAcrylicAccentFocus__151f9bfkg" }, backplateAcrylicAccentHover: { defaultClass: "sprinkles_borderColor_backplateAcrylicAccentHover__151f9bfkh" }, backplateAcrylicAccentPress: { defaultClass: "sprinkles_borderColor_backplateAcrylicAccentPress__151f9bfki" }, backplateAcrylicAccentRest: { defaultClass: "sprinkles_borderColor_backplateAcrylicAccentRest__151f9bfkj" }, backplateAcrylicPrimaryDisabled: { defaultClass: "sprinkles_borderColor_backplateAcrylicPrimaryDisabled__151f9bfkk" }, backplateAcrylicPrimaryFocus: { defaultClass: "sprinkles_borderColor_backplateAcrylicPrimaryFocus__151f9bfkl" }, backplateAcrylicPrimaryHover: { defaultClass: "sprinkles_borderColor_backplateAcrylicPrimaryHover__151f9bfkm" }, backplateAcrylicPrimaryPress: { defaultClass: "sprinkles_borderColor_backplateAcrylicPrimaryPress__151f9bfkn" }, backplateAcrylicPrimaryRest: { defaultClass: "sprinkles_borderColor_backplateAcrylicPrimaryRest__151f9bfko" }, backplateAcrylicSecondaryDisabled: { defaultClass: "sprinkles_borderColor_backplateAcrylicSecondaryDisabled__151f9bfkp" }, backplateAcrylicSecondaryFocus: { defaultClass: "sprinkles_borderColor_backplateAcrylicSecondaryFocus__151f9bfkq" }, backplateAcrylicSecondaryHover: { defaultClass: "sprinkles_borderColor_backplateAcrylicSecondaryHover__151f9bfkr" }, backplateAcrylicSecondaryPress: { defaultClass: "sprinkles_borderColor_backplateAcrylicSecondaryPress__151f9bfks" }, backplateAcrylicSecondaryRest: { defaultClass: "sprinkles_borderColor_backplateAcrylicSecondaryRest__151f9bfkt" }, backplateAcrylicTertiaryDisabled: { defaultClass: "sprinkles_borderColor_backplateAcrylicTertiaryDisabled__151f9bfku" }, backplateAcrylicTertiaryFocus: { defaultClass: "sprinkles_borderColor_backplateAcrylicTertiaryFocus__151f9bfkv" }, backplateAcrylicTertiaryHover: { defaultClass: "sprinkles_borderColor_backplateAcrylicTertiaryHover__151f9bfkw" }, backplateAcrylicTertiaryPress: { defaultClass: "sprinkles_borderColor_backplateAcrylicTertiaryPress__151f9bfkx" }, backplateAcrylicTertiaryRest: { defaultClass: "sprinkles_borderColor_backplateAcrylicTertiaryRest__151f9bfky" }, backplateSemitransparentAccentDisabled: { defaultClass: "sprinkles_borderColor_backplateSemitransparentAccentDisabled__151f9bfkz" }, backplateSemitransparentAccentFocus: { defaultClass: "sprinkles_borderColor_backplateSemitransparentAccentFocus__151f9bfl0" }, backplateSemitransparentAccentHover: { defaultClass: "sprinkles_borderColor_backplateSemitransparentAccentHover__151f9bfl1" }, backplateSemitransparentAccentPress: { defaultClass: "sprinkles_borderColor_backplateSemitransparentAccentPress__151f9bfl2" }, backplateSemitransparentAccentRest: { defaultClass: "sprinkles_borderColor_backplateSemitransparentAccentRest__151f9bfl3" }, backplateSemitransparentPrimaryDisabled: { defaultClass: "sprinkles_borderColor_backplateSemitransparentPrimaryDisabled__151f9bfl4" }, backplateSemitransparentPrimaryFocus: { defaultClass: "sprinkles_borderColor_backplateSemitransparentPrimaryFocus__151f9bfl5" }, backplateSemitransparentPrimaryHover: { defaultClass: "sprinkles_borderColor_backplateSemitransparentPrimaryHover__151f9bfl6" }, backplateSemitransparentPrimaryPress: { defaultClass: "sprinkles_borderColor_backplateSemitransparentPrimaryPress__151f9bfl7" }, backplateSemitransparentPrimaryRest: { defaultClass: "sprinkles_borderColor_backplateSemitransparentPrimaryRest__151f9bfl8" }, backplateSemitransparentSecondaryDisabled: { defaultClass: "sprinkles_borderColor_backplateSemitransparentSecondaryDisabled__151f9bfl9" }, backplateSemitransparentSecondaryFocus: { defaultClass: "sprinkles_borderColor_backplateSemitransparentSecondaryFocus__151f9bfla" }, backplateSemitransparentSecondaryHover: { defaultClass: "sprinkles_borderColor_backplateSemitransparentSecondaryHover__151f9bflb" }, backplateSemitransparentSecondaryPress: { defaultClass: "sprinkles_borderColor_backplateSemitransparentSecondaryPress__151f9bflc" }, backplateSemitransparentSecondaryRest: { defaultClass: "sprinkles_borderColor_backplateSemitransparentSecondaryRest__151f9bfld" }, backplateSemitransparentTertiaryDisabled: { defaultClass: "sprinkles_borderColor_backplateSemitransparentTertiaryDisabled__151f9bfle" }, backplateSemitransparentTertiaryFocus: { defaultClass: "sprinkles_borderColor_backplateSemitransparentTertiaryFocus__151f9bflf" }, backplateSemitransparentTertiaryHover: { defaultClass: "sprinkles_borderColor_backplateSemitransparentTertiaryHover__151f9bflg" }, backplateSemitransparentTertiaryPress: { defaultClass: "sprinkles_borderColor_backplateSemitransparentTertiaryPress__151f9bflh" }, backplateSemitransparentTertiaryRest: { defaultClass: "sprinkles_borderColor_backplateSemitransparentTertiaryRest__151f9bfli" }, backplateSolidAccentDisabled: { defaultClass: "sprinkles_borderColor_backplateSolidAccentDisabled__151f9bflj" }, backplateSolidAccentFocus: { defaultClass: "sprinkles_borderColor_backplateSolidAccentFocus__151f9bflk" }, backplateSolidAccentHover: { defaultClass: "sprinkles_borderColor_backplateSolidAccentHover__151f9bfll" }, backplateSolidAccentPress: { defaultClass: "sprinkles_borderColor_backplateSolidAccentPress__151f9bflm" }, backplateSolidAccentRest: { defaultClass: "sprinkles_borderColor_backplateSolidAccentRest__151f9bfln" }, backplateSolidBrandRest: { defaultClass: "sprinkles_borderColor_backplateSolidBrandRest__151f9bflo" }, backplateSolidPrimaryDisabled: { defaultClass: "sprinkles_borderColor_backplateSolidPrimaryDisabled__151f9bflp" }, backplateSolidPrimaryFocus: { defaultClass: "sprinkles_borderColor_backplateSolidPrimaryFocus__151f9bflq" }, backplateSolidPrimaryHover: { defaultClass: "sprinkles_borderColor_backplateSolidPrimaryHover__151f9bflr" }, backplateSolidPrimaryPress: { defaultClass: "sprinkles_borderColor_backplateSolidPrimaryPress__151f9bfls" }, backplateSolidPrimaryRest: { defaultClass: "sprinkles_borderColor_backplateSolidPrimaryRest__151f9bflt" }, backplateSolidSecondaryDisabled: { defaultClass: "sprinkles_borderColor_backplateSolidSecondaryDisabled__151f9bflu" }, backplateSolidSecondaryFocus: { defaultClass: "sprinkles_borderColor_backplateSolidSecondaryFocus__151f9bflv" }, backplateSolidSecondaryHover: { defaultClass: "sprinkles_borderColor_backplateSolidSecondaryHover__151f9bflw" }, backplateSolidSecondaryPress: { defaultClass: "sprinkles_borderColor_backplateSolidSecondaryPress__151f9bflx" }, backplateSolidSecondaryRest: { defaultClass: "sprinkles_borderColor_backplateSolidSecondaryRest__151f9bfly" }, backplateSolidTertiaryDisabled: { defaultClass: "sprinkles_borderColor_backplateSolidTertiaryDisabled__151f9bflz" }, backplateSolidTertiaryFocus: { defaultClass: "sprinkles_borderColor_backplateSolidTertiaryFocus__151f9bfm0" }, backplateSolidTertiaryHover: { defaultClass: "sprinkles_borderColor_backplateSolidTertiaryHover__151f9bfm1" }, backplateSolidTertiaryPress: { defaultClass: "sprinkles_borderColor_backplateSolidTertiaryPress__151f9bfm2" }, backplateSolidTertiaryRest: { defaultClass: "sprinkles_borderColor_backplateSolidTertiaryRest__151f9bfm3" }, dividerLight: { defaultClass: "sprinkles_borderColor_dividerLight__151f9bfm4" }, dividerMedium: { defaultClass: "sprinkles_borderColor_dividerMedium__151f9bfm5" }, dividerStrong: { defaultClass: "sprinkles_borderColor_dividerStrong__151f9bfm6" }, activityOnline: { defaultClass: "sprinkles_borderColor_activityOnline__151f9bfm7" }, activityOffline: { defaultClass: "sprinkles_borderColor_activityOffline__151f9bfm8" }, activityError: { defaultClass: "sprinkles_borderColor_activityError__151f9bfm9" }, activityWarning: { defaultClass: "sprinkles_borderColor_activityWarning__151f9bfma" }, activityFavorite: { defaultClass: "sprinkles_borderColor_activityFavorite__151f9bfmb" }, productXboxGreen: { defaultClass: "sprinkles_borderColor_productXboxGreen__151f9bfmc" }, productDataVizXbox: { defaultClass: "sprinkles_borderColor_productDataVizXbox__151f9bfmd" }, productDataVizWindows: { defaultClass: "sprinkles_borderColor_productDataVizWindows__151f9bfme" }, productDataVizChevron: { defaultClass: "sprinkles_borderColor_productDataVizChevron__151f9bfmf" }, hCBlack: { defaultClass: "sprinkles_borderColor_hCBlack__151f9bfmg" }, hCDisabled: { defaultClass: "sprinkles_borderColor_hCDisabled__151f9bfmh" }, hCHyperlink: { defaultClass: "sprinkles_borderColor_hCHyperlink__151f9bfmi" }, hCPrimary: { defaultClass: "sprinkles_borderColor_hCPrimary__151f9bfmj" }, hCSecondary: { defaultClass: "sprinkles_borderColor_hCSecondary__151f9bfmk" }, hCWhite: { defaultClass: "sprinkles_borderColor_hCWhite__151f9bfml" }, smokeLight: { defaultClass: "sprinkles_borderColor_smokeLight__151f9bfmm" }, smokeStrong: { defaultClass: "sprinkles_borderColor_smokeStrong__151f9bfmn" }, focusActive: { defaultClass: "sprinkles_borderColor_focusActive__151f9bfmo" } } } } }, { conditions: void 0, styles: { textAlign: { values: { left: { defaultClass: "sprinkles_textAlign_left__151f9bfmp" }, center: { defaultClass: "sprinkles_textAlign_center__151f9bfmq" }, right: { defaultClass: "sprinkles_textAlign_right__151f9bfmr" } } }, textDecoration: { values: { none: { defaultClass: "sprinkles_textDecoration_none__151f9bfms" }, underline: { defaultClass: "sprinkles_textDecoration_underline__151f9bfmt" }, "line-through": { defaultClass: "sprinkles_textDecoration_line-through__151f9bfmu" } } }, textTransform: { values: { none: { defaultClass: "sprinkles_textTransform_none__151f9bfmv" }, uppercase: { defaultClass: "sprinkles_textTransform_uppercase__151f9bfmw" }, lowercase: { defaultClass: "sprinkles_textTransform_lowercase__151f9bfmx" }, capitalize: { defaultClass: "sprinkles_textTransform_capitalize__151f9bfmy" } } } } }, { conditions: void 0, styles: { display: { values: { none: { defaultClass: "sprinkles_display_none__151f9bfmz" }, block: { defaultClass: "sprinkles_display_block__151f9bfn0" }, inline: { defaultClass: "sprinkles_display_inline__151f9bfn1" }, "inline-block": { defaultClass: "sprinkles_display_inline-block__151f9bfn2" }, flex: { defaultClass: "sprinkles_display_flex__151f9bfn3" }, "inline-flex": { defaultClass: "sprinkles_display_inline-flex__151f9bfn4" }, grid: { defaultClass: "sprinkles_display_grid__151f9bfn5" }, "inline-grid": { defaultClass: "sprinkles_display_inline-grid__151f9bfn6" } } }, alignItems: { values: { "flex-start": { defaultClass: "sprinkles_alignItems_flex-start__151f9bfn7" }, center: { defaultClass: "sprinkles_alignItems_center__151f9bfn8" }, "flex-end": { defaultClass: "sprinkles_alignItems_flex-end__151f9bfn9" }, stretch: { defaultClass: "sprinkles_alignItems_stretch__151f9bfna" }, baseline: { defaultClass: "sprinkles_alignItems_baseline__151f9bfnb" } } }, justifyContent: { values: { "flex-start": { defaultClass: "sprinkles_justifyContent_flex-start__151f9bfnc" }, center: { defaultClass: "sprinkles_justifyContent_center__151f9bfnd" }, "flex-end": { defaultClass: "sprinkles_justifyContent_flex-end__151f9bfne" }, "space-between": { defaultClass: "sprinkles_justifyContent_space-between__151f9bfnf" }, "space-around": { defaultClass: "sprinkles_justifyContent_space-around__151f9bfng" }, "space-evenly": { defaultClass: "sprinkles_justifyContent_space-evenly__151f9bfnh" } } }, flexDirection: { values: { row: { defaultClass: "sprinkles_flexDirection_row__151f9bfni" }, column: { defaultClass: "sprinkles_flexDirection_column__151f9bfnj" }, "row-reverse": { defaultClass: "sprinkles_flexDirection_row-reverse__151f9bfnk" }, "column-reverse": { defaultClass: "sprinkles_flexDirection_column-reverse__151f9bfnl" } } }, flexWrap: { values: { nowrap: { defaultClass: "sprinkles_flexWrap_nowrap__151f9bfnm" }, wrap: { defaultClass: "sprinkles_flexWrap_wrap__151f9bfnn" }, "wrap-reverse": { defaultClass: "sprinkles_flexWrap_wrap-reverse__151f9bfno" } } }, flexGrow: { values: { "0": { defaultClass: "sprinkles_flexGrow_0__151f9bfnp" }, "1": { defaultClass: "sprinkles_flexGrow_1__151f9bfnq" } } }, flexShrink: { values: { "0": { defaultClass: "sprinkles_flexShrink_0__151f9bfnr" }, "1": { defaultClass: "sprinkles_flexShrink_1__151f9bfns" } } }, borderRadius: { values: { buttonBorderRadius: { defaultClass: "sprinkles_borderRadius_buttonBorderRadius__151f9bfnt" }, buttonBasicBorderRadius: { defaultClass: "sprinkles_borderRadius_buttonBasicBorderRadius__151f9bfnu" }, buttonBasicFocusBorderRadius: { defaultClass: "sprinkles_borderRadius_buttonBasicFocusBorderRadius__151f9bfnv" }, buttonHeroBorderRadius: { defaultClass: "sprinkles_borderRadius_buttonHeroBorderRadius__151f9bfnw" }, buttonHeroFocusBorderRadius: { defaultClass: "sprinkles_borderRadius_buttonHeroFocusBorderRadius__151f9bfnx" }, buttonStandardBorderRadius: { defaultClass: "sprinkles_borderRadius_buttonStandardBorderRadius__151f9bfny" }, buttonAcceleratorIconBorderRadius: { defaultClass: "sprinkles_borderRadius_buttonAcceleratorIconBorderRadius__151f9bfnz" }, buttonAcceleratorIconFocusBorderRadius: { defaultClass: "sprinkles_borderRadius_buttonAcceleratorIconFocusBorderRadius__151f9bfo0" }, buttonCircleBorderRadius: { defaultClass: "sprinkles_borderRadius_buttonCircleBorderRadius__151f9bfo1" }, cardBorderRadius: { defaultClass: "sprinkles_borderRadius_cardBorderRadius__151f9bfo2" }, cardShadowBorderRadius: { defaultClass: "sprinkles_borderRadius_cardShadowBorderRadius__151f9bfo3" }, focusBorderRadius: { defaultClass: "sprinkles_borderRadius_focusBorderRadius__151f9bfo4" }, tagBorderRadius: { defaultClass: "sprinkles_borderRadius_tagBorderRadius__151f9bfo5" }, xdsTagBorderRadius: { defaultClass: "sprinkles_borderRadius_xdsTagBorderRadius__151f9bfo6" }, actionSheetMenuBorderRadius: { defaultClass: "sprinkles_borderRadius_actionSheetMenuBorderRadius__151f9bfo7" }, scrollIndicatorBorderRadius: { defaultClass: "sprinkles_borderRadius_scrollIndicatorBorderRadius__151f9bfo8" }, inlineTabsSelectionIndicatorBorderRadius: { defaultClass: "sprinkles_borderRadius_inlineTabsSelectionIndicatorBorderRadius__151f9bfo9" }, hoverBorderRadius: { defaultClass: "sprinkles_borderRadius_hoverBorderRadius__151f9bfoa" }, buttonBorderWidth: { defaultClass: "sprinkles_borderRadius_buttonBorderWidth__151f9bfob" }, buttonCircleBorderWidth: { defaultClass: "sprinkles_borderRadius_buttonCircleBorderWidth__151f9bfoc" }, buttonLinkBorderWidth: { defaultClass: "sprinkles_borderRadius_buttonLinkBorderWidth__151f9bfod" }, cardBorderWidth: { defaultClass: "sprinkles_borderRadius_cardBorderWidth__151f9bfoe" }, focusBorderWidth: { defaultClass: "sprinkles_borderRadius_focusBorderWidth__151f9bfof" }, gamerTileBorderWidth: { defaultClass: "sprinkles_borderRadius_gamerTileBorderWidth__151f9bfog" }, hoverBorderWidth: { defaultClass: "sprinkles_borderRadius_hoverBorderWidth__151f9bfoh" }, listItemViewBorderWidth: { defaultClass: "sprinkles_borderRadius_listItemViewBorderWidth__151f9bfoi" }, productTileBorderWidth: { defaultClass: "sprinkles_borderRadius_productTileBorderWidth__151f9bfoj" }, searchBarBorderWidth: { defaultClass: "sprinkles_borderRadius_searchBarBorderWidth__151f9bfok" }, searchBarFocusedBorderWidth: { defaultClass: "sprinkles_borderRadius_searchBarFocusedBorderWidth__151f9bfol" }, tagBorderWidth: { defaultClass: "sprinkles_borderRadius_tagBorderWidth__151f9bfom" }, xdsTagBorderWidth: { defaultClass: "sprinkles_borderRadius_xdsTagBorderWidth__151f9bfon" }, themedViewBorderWidth: { defaultClass: "sprinkles_borderRadius_themedViewBorderWidth__151f9bfoo" }, themedBackgroundViewBorderWidth: { defaultClass: "sprinkles_borderRadius_themedBackgroundViewBorderWidth__151f9bfop" }, none: { defaultClass: "sprinkles_borderRadius_none__151f9bfoq" }, xs: { defaultClass: "sprinkles_borderRadius_xs__151f9bfor" }, sm: { defaultClass: "sprinkles_borderRadius_sm__151f9bfos" }, md: { defaultClass: "sprinkles_borderRadius_md__151f9bfot" }, lg: { defaultClass: "sprinkles_borderRadius_lg__151f9bfou" }, xl: { defaultClass: "sprinkles_borderRadius_xl__151f9bfov" }, xxl: { defaultClass: "sprinkles_borderRadius_xxl__151f9bfow" }, full: { defaultClass: "sprinkles_borderRadius_full__151f9bfox" } } }, position: { values: { "static": { defaultClass: "sprinkles_position_static__151f9bfoy" }, relative: { defaultClass: "sprinkles_position_relative__151f9bfoz" }, absolute: { defaultClass: "sprinkles_position_absolute__151f9bfp0" }, fixed: { defaultClass: "sprinkles_position_fixed__151f9bfp1" }, sticky: { defaultClass: "sprinkles_position_sticky__151f9bfp2" } } }, overflow: { values: { visible: { defaultClass: "sprinkles_overflow_visible__151f9bfp3" }, hidden: { defaultClass: "sprinkles_overflow_hidden__151f9bfp4" }, scroll: { defaultClass: "sprinkles_overflow_scroll__151f9bfp5" }, auto: { defaultClass: "sprinkles_overflow_auto__151f9bfp6" } } }, width: { values: { full: { defaultClass: "sprinkles_width_full__151f9bfp7" }, auto: { defaultClass: "sprinkles_width_auto__151f9bfp8" }, screen: { defaultClass: "sprinkles_width_screen__151f9bfp9" }, "1/2": { defaultClass: "sprinkles_width_1/2__151f9bfpa" }, "1/3": { defaultClass: "sprinkles_width_1/3__151f9bfpb" }, "2/3": { defaultClass: "sprinkles_width_2/3__151f9bfpc" }, "1/4": { defaultClass: "sprinkles_width_1/4__151f9bfpd" }, "3/4": { defaultClass: "sprinkles_width_3/4__151f9bfpe" } } }, height: { values: { full: { defaultClass: "sprinkles_height_full__151f9bfpf" }, auto: { defaultClass: "sprinkles_height_auto__151f9bfpg" }, screen: { defaultClass: "sprinkles_height_screen__151f9bfph" }, "1/2": { defaultClass: "sprinkles_height_1/2__151f9bfpi" }, "1/3": { defaultClass: "sprinkles_height_1/3__151f9bfpj" }, "2/3": { defaultClass: "sprinkles_height_2/3__151f9bfpk" }, "1/4": { defaultClass: "sprinkles_height_1/4__151f9bfpl" }, "3/4": { defaultClass: "sprinkles_height_3/4__151f9bfpm" } } }, minHeight: { values: { full: { defaultClass: "sprinkles_minHeight_full__151f9bfpn" }, screen: { defaultClass: "sprinkles_minHeight_screen__151f9bfpo" }, auto: { defaultClass: "sprinkles_minHeight_auto__151f9bfpp" } } }, maxWidth: { values: { none: { defaultClass: "sprinkles_maxWidth_none__151f9bfpq" }, full: { defaultClass: "sprinkles_maxWidth_full__151f9bfpr" }, sm: { defaultClass: "sprinkles_maxWidth_sm__151f9bfps" }, md: { defaultClass: "sprinkles_maxWidth_md__151f9bfpt" }, lg: { defaultClass: "sprinkles_maxWidth_lg__151f9bfpu" }, xl: { defaultClass: "sprinkles_maxWidth_xl__151f9bfpv" } } } } }, { conditions: void 0, styles: { borderWidth: { values: { "0": { defaultClass: "sprinkles_borderWidth_0__151f9bfpw" }, "1": { defaultClass: "sprinkles_borderWidth_1__151f9bfpx" }, "2": { defaultClass: "sprinkles_borderWidth_2__151f9bfpy" }, "4": { defaultClass: "sprinkles_borderWidth_4__151f9bfpz" } } }, borderStyle: { values: { none: { defaultClass: "sprinkles_borderStyle_none__151f9bfq0" }, solid: { defaultClass: "sprinkles_borderStyle_solid__151f9bfq1" }, dashed: { defaultClass: "sprinkles_borderStyle_dashed__151f9bfq2" }, dotted: { defaultClass: "sprinkles_borderStyle_dotted__151f9bfq3" } } } } }, { conditions: void 0, styles: { boxShadow: { values: { none: { defaultClass: "sprinkles_boxShadow_none__151f9bfq4" }, sm: { defaultClass: "sprinkles_boxShadow_sm__151f9bfq5" }, md: { defaultClass: "sprinkles_boxShadow_md__151f9bfq6" }, lg: { defaultClass: "sprinkles_boxShadow_lg__151f9bfq7" }, xl: { defaultClass: "sprinkles_boxShadow_xl__151f9bfq8" }, focus: { defaultClass: "sprinkles_boxShadow_focus__151f9bfq9" }, button: { defaultClass: "sprinkles_boxShadow_button__151f9bfqa" }, modal: { defaultClass: "sprinkles_boxShadow_modal__151f9bfqb" }, popover: { defaultClass: "sprinkles_boxShadow_popover__151f9bfqc" } } }, opacity: { values: { "0": { defaultClass: "sprinkles_opacity_0__151f9bfqd" }, "25": { defaultClass: "sprinkles_opacity_25__151f9bfqe" }, "50": { defaultClass: "sprinkles_opacity_50__151f9bfqf" }, "75": { defaultClass: "sprinkles_opacity_75__151f9bfqg" }, "100": { defaultClass: "sprinkles_opacity_100__151f9bfqh" } } } } });

// src/styles/breakpoints.css.ts
var breakpoints = { xs: "320px", sm: "576px", md: "768px", lg: "992px", xl: "1200px", xxl: "1400px" };
var mediaQueries = { xs: "@media (min-width: 320px)", sm: "@media (min-width: 576px)", md: "@media (min-width: 768px)", lg: "@media (min-width: 992px)", xl: "@media (min-width: 1200px)", xxl: "@media (min-width: 1400px)", maxXs: "@media (max-width: 319px)", maxSm: "@media (max-width: 575px)", maxMd: "@media (max-width: 767px)", maxLg: "@media (max-width: 991px)", maxXl: "@media (max-width: 1199px)", portrait: "@media (orientation: portrait)", landscape: "@media (orientation: landscape)" };

// src/styles/themes.css.ts
var themeMap = { dark: "dark", light: "light", "hc-dark": "hc-dark", "hc-light": "hc-light" };
var vars = { colors: { secondaryLabelOpacity: "var(--colors-secondaryLabelOpacity__uhesuc0)", contentPrimary: "var(--colors-contentPrimary__uhesuc1)", contentSecondary: "var(--colors-contentSecondary__uhesuc2)", contentDisabled: "var(--colors-contentDisabled__uhesuc3)", contentError: "var(--colors-contentError__uhesuc4)", contentAccent: "var(--colors-contentAccent__uhesuc5)", contentOnBackplatePrimary: "var(--colors-contentOnBackplatePrimary__uhesuc6)", contentOnBackplateSecondary: "var(--colors-contentOnBackplateSecondary__uhesuc7)", contentOnBackplateTertiary: "var(--colors-contentOnBackplateTertiary__uhesuc8)", contentOnBackplateAccent: "var(--colors-contentOnBackplateAccent__uhesuc9)", contentOnBackplateDisabled: "var(--colors-contentOnBackplateDisabled__uhesuca)", contentOnBackplateTransparentPrimary: "var(--colors-contentOnBackplateTransparentPrimary__uhesucb)", contentOnBackplateTransparentSecondary: "var(--colors-contentOnBackplateTransparentSecondary__uhesucc)", contentOnBackplateTransparentTertiary: "var(--colors-contentOnBackplateTransparentTertiary__uhesucd)", contentOnBackplateTransparentAccent: "var(--colors-contentOnBackplateTransparentAccent__uhesuce)", contentOnBackplateTransparentDisabled: "var(--colors-contentOnBackplateTransparentDisabled__uhesucf)", contentOnBackplateAcrylicPrimaryRest: "var(--colors-contentOnBackplateAcrylicPrimaryRest__uhesucg)", contentOnHover: "var(--colors-contentOnHover__uhesuch)", contentOnHoverTransparent: "var(--colors-contentOnHoverTransparent__uhesuci)", contentOnPress: "var(--colors-contentOnPress__uhesucj)", contentOnPressTransparent: "var(--colors-contentOnPressTransparent__uhesuck)", contentPrimaryDisabled: "var(--colors-contentPrimaryDisabled__uhesucl)", contentPrimaryOnHover: "var(--colors-contentPrimaryOnHover__uhesucm)", contentPrimaryOnPress: "var(--colors-contentPrimaryOnPress__uhesucn)", contentHyperlinkRest: "var(--colors-contentHyperlinkRest__uhesuco)", contentHyperlinkHover: "var(--colors-contentHyperlinkHover__uhesucp)", contentHyperlinkPress: "var(--colors-contentHyperlinkPress__uhesucq)", contentHyperlinkVisited: "var(--colors-contentHyperlinkVisited__uhesucr)", containerSolidAppBackground: "var(--colors-containerSolidAppBackground__uhesucs)", containerSolidContainer: "var(--colors-containerSolidContainer__uhesuct)", containerSolidContainerDark: "var(--colors-containerSolidContainerDark__uhesucu)", containerSolidContainerLight: "var(--colors-containerSolidContainerLight__uhesucv)", containerAcrylicDark: "var(--colors-containerAcrylicDark__uhesucw)", containerAcrylicExtraDark: "var(--colors-containerAcrylicExtraDark__uhesucx)", containerAcrylicExtraLight: "var(--colors-containerAcrylicExtraLight__uhesucy)", containerAcrylicLight: "var(--colors-containerAcrylicLight__uhesucz)", containerAcrylicWhiteHeavy: "var(--colors-containerAcrylicWhiteHeavy__uhesuc10)", containerAcrylicWhiteLight: "var(--colors-containerAcrylicWhiteLight__uhesuc11)", containerSemitransparentFogHeavy: "var(--colors-containerSemitransparentFogHeavy__uhesuc12)", containerSemitransparentFogLight: "var(--colors-containerSemitransparentFogLight__uhesuc13)", containerSemitransparentSmokeDark: "var(--colors-containerSemitransparentSmokeDark__uhesuc14)", containerSemitransparentSmokeExtraDark: "var(--colors-containerSemitransparentSmokeExtraDark__uhesuc15)", containerSemitransparentSmokeExtraLight: "var(--colors-containerSemitransparentSmokeExtraLight__uhesuc16)", containerSemitransparentSmokeLight: "var(--colors-containerSemitransparentSmokeLight__uhesuc17)", stateHover: "var(--colors-stateHover__uhesuc18)", statePress: "var(--colors-statePress__uhesuc19)", stateFocus: "var(--colors-stateFocus__uhesuc1a)", stateRest: "var(--colors-stateRest__uhesuc1b)", stateDisabled: "var(--colors-stateDisabled__uhesuc1c)", backplateAcrylicAccentDisabled: "var(--colors-backplateAcrylicAccentDisabled__uhesuc1d)", backplateAcrylicAccentFocus: "var(--colors-backplateAcrylicAccentFocus__uhesuc1e)", backplateAcrylicAccentHover: "var(--colors-backplateAcrylicAccentHover__uhesuc1f)", backplateAcrylicAccentPress: "var(--colors-backplateAcrylicAccentPress__uhesuc1g)", backplateAcrylicAccentRest: "var(--colors-backplateAcrylicAccentRest__uhesuc1h)", backplateAcrylicPrimaryDisabled: "var(--colors-backplateAcrylicPrimaryDisabled__uhesuc1i)", backplateAcrylicPrimaryFocus: "var(--colors-backplateAcrylicPrimaryFocus__uhesuc1j)", backplateAcrylicPrimaryHover: "var(--colors-backplateAcrylicPrimaryHover__uhesuc1k)", backplateAcrylicPrimaryPress: "var(--colors-backplateAcrylicPrimaryPress__uhesuc1l)", backplateAcrylicPrimaryRest: "var(--colors-backplateAcrylicPrimaryRest__uhesuc1m)", backplateAcrylicSecondaryDisabled: "var(--colors-backplateAcrylicSecondaryDisabled__uhesuc1n)", backplateAcrylicSecondaryFocus: "var(--colors-backplateAcrylicSecondaryFocus__uhesuc1o)", backplateAcrylicSecondaryHover: "var(--colors-backplateAcrylicSecondaryHover__uhesuc1p)", backplateAcrylicSecondaryPress: "var(--colors-backplateAcrylicSecondaryPress__uhesuc1q)", backplateAcrylicSecondaryRest: "var(--colors-backplateAcrylicSecondaryRest__uhesuc1r)", backplateAcrylicTertiaryDisabled: "var(--colors-backplateAcrylicTertiaryDisabled__uhesuc1s)", backplateAcrylicTertiaryFocus: "var(--colors-backplateAcrylicTertiaryFocus__uhesuc1t)", backplateAcrylicTertiaryHover: "var(--colors-backplateAcrylicTertiaryHover__uhesuc1u)", backplateAcrylicTertiaryPress: "var(--colors-backplateAcrylicTertiaryPress__uhesuc1v)", backplateAcrylicTertiaryRest: "var(--colors-backplateAcrylicTertiaryRest__uhesuc1w)", backplateSemitransparentAccentDisabled: "var(--colors-backplateSemitransparentAccentDisabled__uhesuc1x)", backplateSemitransparentAccentFocus: "var(--colors-backplateSemitransparentAccentFocus__uhesuc1y)", backplateSemitransparentAccentHover: "var(--colors-backplateSemitransparentAccentHover__uhesuc1z)", backplateSemitransparentAccentPress: "var(--colors-backplateSemitransparentAccentPress__uhesuc20)", backplateSemitransparentAccentRest: "var(--colors-backplateSemitransparentAccentRest__uhesuc21)", backplateSemitransparentPrimaryDisabled: "var(--colors-backplateSemitransparentPrimaryDisabled__uhesuc22)", backplateSemitransparentPrimaryFocus: "var(--colors-backplateSemitransparentPrimaryFocus__uhesuc23)", backplateSemitransparentPrimaryHover: "var(--colors-backplateSemitransparentPrimaryHover__uhesuc24)", backplateSemitransparentPrimaryPress: "var(--colors-backplateSemitransparentPrimaryPress__uhesuc25)", backplateSemitransparentPrimaryRest: "var(--colors-backplateSemitransparentPrimaryRest__uhesuc26)", backplateSemitransparentSecondaryDisabled: "var(--colors-backplateSemitransparentSecondaryDisabled__uhesuc27)", backplateSemitransparentSecondaryFocus: "var(--colors-backplateSemitransparentSecondaryFocus__uhesuc28)", backplateSemitransparentSecondaryHover: "var(--colors-backplateSemitransparentSecondaryHover__uhesuc29)", backplateSemitransparentSecondaryPress: "var(--colors-backplateSemitransparentSecondaryPress__uhesuc2a)", backplateSemitransparentSecondaryRest: "var(--colors-backplateSemitransparentSecondaryRest__uhesuc2b)", backplateSemitransparentTertiaryDisabled: "var(--colors-backplateSemitransparentTertiaryDisabled__uhesuc2c)", backplateSemitransparentTertiaryFocus: "var(--colors-backplateSemitransparentTertiaryFocus__uhesuc2d)", backplateSemitransparentTertiaryHover: "var(--colors-backplateSemitransparentTertiaryHover__uhesuc2e)", backplateSemitransparentTertiaryPress: "var(--colors-backplateSemitransparentTertiaryPress__uhesuc2f)", backplateSemitransparentTertiaryRest: "var(--colors-backplateSemitransparentTertiaryRest__uhesuc2g)", backplateSolidAccentDisabled: "var(--colors-backplateSolidAccentDisabled__uhesuc2h)", backplateSolidAccentFocus: "var(--colors-backplateSolidAccentFocus__uhesuc2i)", backplateSolidAccentHover: "var(--colors-backplateSolidAccentHover__uhesuc2j)", backplateSolidAccentPress: "var(--colors-backplateSolidAccentPress__uhesuc2k)", backplateSolidAccentRest: "var(--colors-backplateSolidAccentRest__uhesuc2l)", backplateSolidBrandRest: "var(--colors-backplateSolidBrandRest__uhesuc2m)", backplateSolidPrimaryDisabled: "var(--colors-backplateSolidPrimaryDisabled__uhesuc2n)", backplateSolidPrimaryFocus: "var(--colors-backplateSolidPrimaryFocus__uhesuc2o)", backplateSolidPrimaryHover: "var(--colors-backplateSolidPrimaryHover__uhesuc2p)", backplateSolidPrimaryPress: "var(--colors-backplateSolidPrimaryPress__uhesuc2q)", backplateSolidPrimaryRest: "var(--colors-backplateSolidPrimaryRest__uhesuc2r)", backplateSolidSecondaryDisabled: "var(--colors-backplateSolidSecondaryDisabled__uhesuc2s)", backplateSolidSecondaryFocus: "var(--colors-backplateSolidSecondaryFocus__uhesuc2t)", backplateSolidSecondaryHover: "var(--colors-backplateSolidSecondaryHover__uhesuc2u)", backplateSolidSecondaryPress: "var(--colors-backplateSolidSecondaryPress__uhesuc2v)", backplateSolidSecondaryRest: "var(--colors-backplateSolidSecondaryRest__uhesuc2w)", backplateSolidTertiaryDisabled: "var(--colors-backplateSolidTertiaryDisabled__uhesuc2x)", backplateSolidTertiaryFocus: "var(--colors-backplateSolidTertiaryFocus__uhesuc2y)", backplateSolidTertiaryHover: "var(--colors-backplateSolidTertiaryHover__uhesuc2z)", backplateSolidTertiaryPress: "var(--colors-backplateSolidTertiaryPress__uhesuc30)", backplateSolidTertiaryRest: "var(--colors-backplateSolidTertiaryRest__uhesuc31)", dividerLight: "var(--colors-dividerLight__uhesuc32)", dividerMedium: "var(--colors-dividerMedium__uhesuc33)", dividerStrong: "var(--colors-dividerStrong__uhesuc34)", activityOnline: "var(--colors-activityOnline__uhesuc35)", activityOffline: "var(--colors-activityOffline__uhesuc36)", activityError: "var(--colors-activityError__uhesuc37)", activityWarning: "var(--colors-activityWarning__uhesuc38)", activityFavorite: "var(--colors-activityFavorite__uhesuc39)", productXboxGreen: "var(--colors-productXboxGreen__uhesuc3a)", productDataVizXbox: "var(--colors-productDataVizXbox__uhesuc3b)", productDataVizWindows: "var(--colors-productDataVizWindows__uhesuc3c)", productDataVizChevron: "var(--colors-productDataVizChevron__uhesuc3d)", hCBlack: "var(--colors-hCBlack__uhesuc3e)", hCDisabled: "var(--colors-hCDisabled__uhesuc3f)", hCHyperlink: "var(--colors-hCHyperlink__uhesuc3g)", hCPrimary: "var(--colors-hCPrimary__uhesuc3h)", hCSecondary: "var(--colors-hCSecondary__uhesuc3i)", hCWhite: "var(--colors-hCWhite__uhesuc3j)", smokeLight: "var(--colors-smokeLight__uhesuc3k)", smokeStrong: "var(--colors-smokeStrong__uhesuc3l)", focusActive: "var(--colors-focusActive__uhesuc3m)" }, shadows: { shadowLayer1: "var(--shadows-shadowLayer1__uhesuc3n)", shadowLayer2: "var(--shadows-shadowLayer2__uhesuc3o)", shadowLayer3: "var(--shadows-shadowLayer3__uhesuc3p)", elevation1: "var(--shadows-elevation1__uhesuc3q)", elevation2: "var(--shadows-elevation2__uhesuc3r)", elevation3: "var(--shadows-elevation3__uhesuc3s)", elevation4: "var(--shadows-elevation4__uhesuc3t)", glowBrand: "var(--shadows-glowBrand__uhesuc3u)", glowUserColor: "var(--shadows-glowUserColor__uhesuc3v)", focusRing: "var(--shadows-focusRing__uhesuc3w)" }, space: { "0": "var(--space-0__uhesuc3x)", "1": "var(--space-1__uhesuc3y)", "2": "var(--space-2__uhesuc3z)", "3": "var(--space-3__uhesuc40)", "4": "var(--space-4__uhesuc41)", "5": "var(--space-5__uhesuc42)", "6": "var(--space-6__uhesuc43)", "8": "var(--space-8__uhesuc44)", "10": "var(--space-10__uhesuc45)", "12": "var(--space-12__uhesuc46)" }, fontSizes: { h1: "var(--fontSizes-h1__uhesuc47)", h2: "var(--fontSizes-h2__uhesuc48)", h3: "var(--fontSizes-h3__uhesuc49)", h4: "var(--fontSizes-h4__uhesuc4a)", h5: "var(--fontSizes-h5__uhesuc4b)", h6: "var(--fontSizes-h6__uhesuc4c)", subTitle1: "var(--fontSizes-subTitle1__uhesuc4d)", subTitle2: "var(--fontSizes-subTitle2__uhesuc4e)", body1: "var(--fontSizes-body1__uhesuc4f)", body2: "var(--fontSizes-body2__uhesuc4g)", caption: "var(--fontSizes-caption__uhesuc4h)", caption2: "var(--fontSizes-caption2__uhesuc4i)", buttonText: "var(--fontSizes-buttonText__uhesuc4j)", tag: "var(--fontSizes-tag__uhesuc4k)" }, fonts: { system: "var(--fonts-system__uhesuc4l)", primary: "var(--fonts-primary__uhesuc4m)", bahnschrift: "var(--fonts-bahnschrift__uhesuc4n)" }, fontWeights: { light: "var(--fontWeights-light__uhesuc4o)", normal: "var(--fontWeights-normal__uhesuc4p)", medium: "var(--fontWeights-medium__uhesuc4q)", semibold: "var(--fontWeights-semibold__uhesuc4r)", bold: "var(--fontWeights-bold__uhesuc4s)" }, lineHeights: { h1: "var(--lineHeights-h1__uhesuc4t)", h2: "var(--lineHeights-h2__uhesuc4u)", h3: "var(--lineHeights-h3__uhesuc4v)", h4: "var(--lineHeights-h4__uhesuc4w)", h5: "var(--lineHeights-h5__uhesuc4x)", h6: "var(--lineHeights-h6__uhesuc4y)", subTitle1: "var(--lineHeights-subTitle1__uhesuc4z)", subTitle2: "var(--lineHeights-subTitle2__uhesuc50)", body1: "var(--lineHeights-body1__uhesuc51)", body2: "var(--lineHeights-body2__uhesuc52)", caption: "var(--lineHeights-caption__uhesuc53)", caption2: "var(--lineHeights-caption2__uhesuc54)", buttonText: "var(--lineHeights-buttonText__uhesuc55)", tag: "var(--lineHeights-tag__uhesuc56)", none: "var(--lineHeights-none__uhesuc57)", tight: "var(--lineHeights-tight__uhesuc58)", normal: "var(--lineHeights-normal__uhesuc59)", relaxed: "var(--lineHeights-relaxed__uhesuc5a)" }, radii: { none: "var(--radii-none__uhesuc5b)", sm: "var(--radii-sm__uhesuc5c)", md: "var(--radii-md__uhesuc5d)", lg: "var(--radii-lg__uhesuc5e)", full: "var(--radii-full__uhesuc5f)", buttonBasic: "var(--radii-buttonBasic__uhesuc5g)", buttonBasicFocus: "var(--radii-buttonBasicFocus__uhesuc5h)", buttonHero: "var(--radii-buttonHero__uhesuc5i)", buttonHeroFocus: "var(--radii-buttonHeroFocus__uhesuc5j)", card: "var(--radii-card__uhesuc5k)", focus: "var(--radii-focus__uhesuc5l)", "switch": "var(--radii-switch__uhesuc5m)", switchThumb: "var(--radii-switchThumb__uhesuc5n)", picker: "var(--radii-picker__uhesuc5o)", pickerItem: "var(--radii-pickerItem__uhesuc5p)", pickerItemFocus: "var(--radii-pickerItemFocus__uhesuc5q)" }, transitions: { fast: "var(--transitions-fast__uhesuc5r)", normal: "var(--transitions-normal__uhesuc5s)", slow: "var(--transitions-slow__uhesuc5t)" } };

// src/components/StyleProvider/StyleProvider.tsx
import { createContext, useContext, useState, useEffect } from "react";
import { jsx } from "react/jsx-runtime";
function getSystemThemePreference() {
  if (typeof window === "undefined" || !window.matchMedia) {
    return "dark";
  }
  const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  return prefersDark ? "dark" : "light";
}
var LIGHT_THEME = "light";
var DARK_THEME = "dark";
var HC_LIGHT_THEME = "hc-light";
var HC_DARK_THEME = "hc-dark";
var StyleProviderContext = createContext({
  theme: "dark",
  setTheme: () => {
  }
});
var useStyleProvider = () => useContext(StyleProviderContext);
function StyleProvider({
  children,
  defaultTheme = "dark"
}) {
  const [theme, setTheme] = useState(defaultTheme);
  useEffect(() => {
    if (typeof document !== "undefined") {
      const root = document.documentElement;
      root.classList.remove(DARK_THEME);
      root.classList.remove(LIGHT_THEME);
      root.classList.remove(HC_DARK_THEME);
      root.classList.remove(HC_LIGHT_THEME);
      root.classList.add(theme);
      root.setAttribute("data-theme", theme);
    }
  }, [theme]);
  return /* @__PURE__ */ jsx(StyleProviderContext.Provider, { value: { theme, setTheme }, children });
}

// src/components/Container/Container.tsx
import { forwardRef } from "react";

// src/components/Container/Container.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var container = _7a468({ defaultClassName: "Container__15129q31 Container_baseContainer__15129q30", variantClassNames: { size: { sm: "Container_container_size_sm__15129q32", md: "Container_container_size_md__15129q33", lg: "Container_container_size_lg__15129q34", xl: "Container_container_size_xl__15129q35", xxl: "Container_container_size_xxl__15129q36", full: "Container_container_size_full__15129q37" }, padding: { none: "Container_container_padding_none__15129q38", small: "Container_container_padding_small__15129q39", medium: "Container_container_padding_medium__15129q3a", large: "Container_container_padding_large__15129q3b", xlarge: "Container_container_padding_xlarge__15129q3c", xxlarge: "Container_container_padding_xxlarge__15129q3d" }, background: { none: "Container_container_background_none__15129q3e", primary: "Container_container_background_primary__15129q3f", secondary: "Container_container_background_secondary__15129q3g", accent: "Container_container_background_accent__15129q3h", card: "Container_container_background_card__15129q3i" }, centered: { true: "Container_container_centered_true__15129q3j" } }, defaultVariants: { size: "lg", padding: "medium", background: "none", centered: false }, compoundVariants: [] });

// src/components/Container/Container.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var Container = forwardRef(
  ({
    children,
    size = "lg",
    padding = "medium",
    background = "none",
    centered = false,
    as = "div",
    className: _className,
    ...props
  }, ref) => {
    const containerClass = container({ size, padding, background, centered });
    const combinedClassName = _className ? `${containerClass} ${_className}` : containerClass;
    const Element = as;
    return /* @__PURE__ */ jsx2(Element, { ref, className: combinedClassName, ...props, children });
  }
);
Container.displayName = "Container";

// src/components/Section/Section.tsx
import { forwardRef as forwardRef2 } from "react";

// src/components/Section/Section.css.ts
import { createRuntimeFn as _7a4682 } from "@vanilla-extract/recipes/createRuntimeFn";
var section = _7a4682({ defaultClassName: "Section__1nl3x2u1 Section_baseSection__1nl3x2u0", variantClassNames: { spacing: { none: "Section_section_spacing_none__1nl3x2u2", small: "Section_section_spacing_small__1nl3x2u3", medium: "Section_section_spacing_medium__1nl3x2u4", large: "Section_section_spacing_large__1nl3x2u5", xlarge: "Section_section_spacing_xlarge__1nl3x2u6" }, background: { none: "Section_section_background_none__1nl3x2u7", primary: "Section_section_background_primary__1nl3x2u8", secondary: "Section_section_background_secondary__1nl3x2u9", accent: "Section_section_background_accent__1nl3x2ua", ai: "Section_section_background_ai__1nl3x2ub" }, centered: { true: "Section_section_centered_true__1nl3x2uc" } }, defaultVariants: { spacing: "medium", background: "none", centered: false }, compoundVariants: [] });

// src/components/Section/Section.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var Section = forwardRef2(
  ({
    children,
    spacing = "medium",
    background = "none",
    centered = false,
    as = "section",
    className: _className,
    ...props
  }, _ref) => {
    const sectionClass = section({ spacing, background, centered });
    const combinedClassName = _className ? `${sectionClass} ${_className}` : sectionClass;
    const Element = as;
    return /* @__PURE__ */ jsx3(Element, { className: combinedClassName, ...props, children });
  }
);
Section.displayName = "Section";

// src/components/Footer/Footer.tsx
import { Fragment } from "react";

// src/components/Footer/Footer.css.ts
import { createRuntimeFn as _7a4683 } from "@vanilla-extract/recipes/createRuntimeFn";
var footer = _7a4683({ defaultClassName: "Footer_footer__nwwflh1", variantClassNames: { position: { absolute: "Footer_footer_position_absolute__nwwflh2", relative: "Footer_footer_position_relative__nwwflh3", "fixed-bottom": "Footer_footer_position_fixed-bottom__nwwflh4" }, transparent: { true: "Footer_footer_transparent_true__nwwflh5" } }, defaultVariants: { position: "relative", transparent: false }, compoundVariants: [] });
var footerBase = "Footer_footerBase__nwwflh0";
var footerInfo = "Footer_footerInfo__nwwflh9";
var footerInfoLink = "Footer_footerInfoLink__nwwflha";
var footerLink = "Footer_footerLink__nwwflh8";
var footerLinks = "Footer_footerLinks__nwwflh7";
var footerLogo = "Footer_footerLogo__nwwflh6";

// src/components/Footer/Footer.tsx
import { jsx as jsx4, jsxs } from "react/jsx-runtime";
function renderDefaultLink(link) {
  return /* @__PURE__ */ jsx4(
    "a",
    {
      className: footerLink,
      href: link.href,
      children: link.label
    },
    `link-${link.href}-${link.label}`
  );
}
function renderDefaultInfoLink(infoLink) {
  return /* @__PURE__ */ jsx4("a", { className: footerInfoLink, href: infoLink.href, children: infoLink.label });
}
function FooterLogo({ logo }) {
  if (!logo) {
    return null;
  }
  return /* @__PURE__ */ jsx4("div", { className: footerLogo, children: logo });
}
function FooterLinks({
  links,
  renderLink
}) {
  if (!links.length) {
    return null;
  }
  return /* @__PURE__ */ jsx4("div", { className: footerLinks, children: links.map((link, _index) => renderLink ? /* @__PURE__ */ jsx4(Fragment, { children: renderLink(link, footerLink) }, `link-${link.href}-${link.label}`) : renderDefaultLink(link)) });
}
function FooterInfo({
  infoText,
  infoLink,
  renderLink
}) {
  if (!infoText) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", { className: footerInfo, children: [
    infoText,
    " ",
    infoLink && (renderLink ? renderLink(infoLink, footerInfoLink) : renderDefaultInfoLink(infoLink))
  ] });
}
function Footer({
  logo,
  links = [],
  infoText,
  infoLink,
  position,
  absolute = false,
  transparent = false,
  className,
  renderLink
}) {
  const positionVariant = position || (absolute ? "absolute" : "relative");
  const footerClass = footer({ position: positionVariant, transparent });
  const combinedClassName = className ? `${footerBase} ${footerClass} ${className}` : `${footerBase} ${footerClass}`;
  return /* @__PURE__ */ jsxs("footer", { className: combinedClassName, children: [
    /* @__PURE__ */ jsx4(FooterLogo, { logo }),
    /* @__PURE__ */ jsx4(FooterLinks, { links, renderLink }),
    infoText && /* @__PURE__ */ jsx4(FooterInfo, { infoLink, infoText, renderLink })
  ] });
}
Footer.displayName = "Footer";

// src/components/Typography/Text.tsx
import { forwardRef as forwardRef3 } from "react";

// src/components/Typography/Text.css.ts
import { createRuntimeFn as _7a4684 } from "@vanilla-extract/recipes/createRuntimeFn";
var text = _7a4684({ defaultClassName: "Text__1507cg01 Text_baseText__1507cg00", variantClassNames: { size: { xs: "Text_text_size_xs__1507cg02", sm: "Text_text_size_sm__1507cg03", base: "Text_text_size_base__1507cg04", lg: "Text_text_size_lg__1507cg05", xl: "Text_text_size_xl__1507cg06", "2xl": "Text_text_size_2xl__1507cg07", "3xl": "Text_text_size_3xl__1507cg08", "4xl": "Text_text_size_4xl__1507cg09" }, weight: { normal: "Text_text_weight_normal__1507cg0a", medium: "Text_text_weight_medium__1507cg0b", semibold: "Text_text_weight_semibold__1507cg0c", bold: "Text_text_weight_bold__1507cg0d" }, color: { primary: "Text_text_color_primary__1507cg0e", secondary: "Text_text_color_secondary__1507cg0f", accent: "Text_text_color_accent__1507cg0g", success: "Text_text_color_success__1507cg0h", error: "Text_text_color_error__1507cg0i" }, align: { left: "Text_text_align_left__1507cg0j", center: "Text_text_align_center__1507cg0k", right: "Text_text_align_right__1507cg0l" }, lineHeight: { none: "Text_text_lineHeight_none__1507cg0m", tight: "Text_text_lineHeight_tight__1507cg0n", normal: "Text_text_lineHeight_normal__1507cg0o", relaxed: "Text_text_lineHeight_relaxed__1507cg0p" } }, defaultVariants: { size: "base", weight: "normal", color: "primary", align: "left", lineHeight: "normal" }, compoundVariants: [] });

// src/components/Typography/Text.tsx
import { jsx as jsx5 } from "react/jsx-runtime";
var Text = forwardRef3(
  ({
    children,
    size = "base",
    weight = "normal",
    color = "primary",
    align = "left",
    lineHeight = "normal",
    as = "p",
    className: _className,
    ...props
  }, ref) => {
    const textClass = text({ size, weight, color, align, lineHeight });
    const combinedClassName = _className ? `${textClass} ${_className}` : textClass;
    const Element = as;
    return (
      // @ts-expect-error - Polymorphic component ref type issues
      /* @__PURE__ */ jsx5(Element, { ref, className: combinedClassName, ...props, children })
    );
  }
);
Text.displayName = "Text";

// src/components/Typography/Heading.tsx
import { createElement, forwardRef as forwardRef4 } from "react";
var Heading = forwardRef4(
  ({
    children,
    level = "h2",
    size,
    weight = "bold",
    lineHeight,
    color = "primary",
    align = "left",
    className: _className,
    ...props
  }, ref) => {
    const defaultSizes = {
      h1: "4xl",
      h2: "3xl",
      h3: "2xl",
      h4: "xl",
      h5: "lg",
      h6: "base"
    };
    const defaultLineHeights = {
      "4xl": "relaxed",
      // Use relaxed (32px) line height for largest headings
      "3xl": "relaxed",
      // Use relaxed (32px) line height for h2
      "2xl": "relaxed",
      // Use relaxed (32px) line height for h3
      xl: "normal",
      // Use normal (24px) line height for h4
      lg: "normal",
      // Use normal (24px) line height for h5
      base: "normal"
      // Use normal (24px) line height for h6
    };
    const headingSize = size || defaultSizes[level];
    const headingLineHeight = lineHeight || (headingSize ? defaultLineHeights[headingSize] : "normal");
    const textClass = text({
      size: headingSize,
      weight,
      color,
      align,
      lineHeight: headingLineHeight
    });
    const combinedClassName = _className ? `${textClass} ${_className}` : textClass;
    return createElement(
      level,
      {
        ref,
        className: combinedClassName,
        ...props
      },
      children
    );
  }
);
Heading.displayName = "Heading";

// src/components/Typography/Description.tsx
import { forwardRef as forwardRef5 } from "react";
import { jsx as jsx6 } from "react/jsx-runtime";
var Description = forwardRef5(
  ({
    children,
    variant = "default",
    size = "base",
    ...props
  }, ref) => {
    const colorMap = {
      default: "primary",
      muted: "secondary",
      accent: "accent"
    };
    return /* @__PURE__ */ jsx6(
      Text,
      {
        ref,
        color: colorMap[variant],
        lineHeight: "relaxed",
        size,
        ...props,
        children
      }
    );
  }
);
Description.displayName = "Description";

// src/components/Menu/Menu.tsx
import { forwardRef as forwardRef6, useCallback, useEffect as useEffect2, useImperativeHandle, useMemo, useRef, useState as useState2 } from "react";
import { createPortal } from "react-dom";

// src/components/Menu/Menu.css.ts
var closeButton = "Menu_closeButton__1ojpoqid sprinkles_position_absolute__151f9bfp0 sprinkles_display_flex__151f9bfn3 sprinkles_alignItems_center__151f9bfn8 sprinkles_justifyContent_center__151f9bfnd";
var menuContainer = "Menu_menuContainer__1ojpoqi1 sprinkles_position_absolute__151f9bfp0 sprinkles_display_flex__151f9bfn3 sprinkles_flexDirection_column__151f9bfnj";
var menuContent = "Menu_menuContent__1ojpoqi3 sprinkles_display_flex__151f9bfn3 sprinkles_flexDirection_column__151f9bfnj";
var menuDivider = "Menu_menuDivider__1ojpoqi9";
var menuItem = "Menu_menuItem__1ojpoqi5 sprinkles_display_flex__151f9bfn3 sprinkles_alignItems_center__151f9bfn8 sprinkles_width_full__151f9bfp7";
var menuItemIcon = "Menu_menuItemIcon__1ojpoqi7 sprinkles_display_flex__151f9bfn3 sprinkles_alignItems_center__151f9bfn8 sprinkles_justifyContent_center__151f9bfnd";
var menuItemText = "Menu_menuItemText__1ojpoqi8";

// src/components/Menu/Menu.tsx
import { Fragment as Fragment2, jsx as jsx7, jsxs as jsxs2 } from "react/jsx-runtime";
function renderMenuContent(children, showCloseButton, setOpen) {
  return /* @__PURE__ */ jsxs2(Fragment2, { children: [
    /* @__PURE__ */ jsx7("div", { className: menuContent, role: "presentation", children }),
    showCloseButton && /* @__PURE__ */ jsx7(
      "button",
      {
        "aria-label": "Close menu",
        className: closeButton,
        type: "button",
        onClick: () => setOpen(false),
        children: /* @__PURE__ */ jsx7("svg", { fill: "none", height: "16", viewBox: "0 0 24 24", width: "16", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx7(
          "path",
          {
            d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
            fill: "currentColor"
          }
        ) })
      }
    )
  ] });
}
var Menu = forwardRef6(({
  ariaLabel = "Menu",
  children,
  className = "",
  isOpen: controlledIsOpen,
  defaultOpen = false,
  onOpenChange,
  onClose,
  // Legacy support
  showCloseButton = true,
  triggerId,
  role = "menu",
  placement = "bottom start",
  offset = 4,
  dismissBehavior = {
    onEscape: true,
    onClickOutside: true,
    onResize: true
  },
  containerProps
}, ref) => {
  const menuRef = useRef(null);
  const triggerElementRef = useRef(null);
  const [mounted, setMounted] = useState2(false);
  const [triggerElementFound, setTriggerElementFound] = useState2(false);
  const [uncontrolledOpen, setUncontrolledOpen] = useState2(defaultOpen);
  const isControlled = controlledIsOpen !== void 0;
  const isOpen = isControlled ? controlledIsOpen : uncontrolledOpen;
  const setOpen = useCallback((next) => {
    if (!isControlled) {
      setUncontrolledOpen(next);
    }
    onOpenChange?.(next);
    if (!next) {
      onClose?.();
    }
  }, [isControlled, onOpenChange, onClose]);
  useImperativeHandle(ref, () => ({
    open: () => setOpen(true),
    close: () => setOpen(false),
    toggle: () => setOpen(!isOpen),
    get isOpen() {
      return isOpen;
    },
    get domElement() {
      return menuRef.current;
    }
  }), [setOpen, isOpen]);
  useEffect2(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);
  useEffect2(() => {
    if (triggerId) {
      const findTriggerElement = () => {
        const element = document.getElementById(triggerId);
        if (element) {
          triggerElementRef.current = element;
          setTriggerElementFound(true);
          return true;
        }
        return false;
      };
      if (!findTriggerElement()) {
        const timeoutId = setTimeout(() => {
          if (findTriggerElement()) {
            setTriggerElementFound(true);
          }
        }, 10);
        return () => clearTimeout(timeoutId);
      }
    }
  }, [triggerId, isOpen]);
  useEffect2(() => {
    if (!isOpen) {
      return;
    }
    const handleClickOutside = (event) => {
      if (!dismissBehavior.onClickOutside) {
        return;
      }
      const target = event.target;
      if (triggerElementRef.current?.contains(target)) {
        return;
      }
      if (menuRef.current?.contains(target)) {
        return;
      }
      setOpen(false);
    };
    const handleEscapeKey = (event) => {
      if (dismissBehavior.onEscape && event.key === "Escape") {
        setOpen(false);
      }
    };
    const handleScroll = (event) => {
      if (menuRef.current?.contains(event.target)) {
        return;
      }
      setOpen(false);
    };
    const handleResize = () => {
      if (dismissBehavior.onResize) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscapeKey);
    window.addEventListener("scroll", handleScroll, true);
    if (dismissBehavior.onResize) {
      window.addEventListener("resize", handleResize);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscapeKey);
      window.removeEventListener("scroll", handleScroll, true);
      window.removeEventListener("resize", handleResize);
    };
  }, [isOpen, setOpen, dismissBehavior]);
  useEffect2(() => {
    if (!isOpen || !menuRef.current) {
      return;
    }
    const menuElement = menuRef.current;
    const focusableElements = menuElement.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (focusableElements.length === 0) {
      return;
    }
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];
    firstElement.focus();
    const handleTabKey = (event) => {
      if (event.key !== "Tab") {
        return;
      }
      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    };
    menuElement.addEventListener("keydown", handleTabKey);
    return () => {
      menuElement.removeEventListener("keydown", handleTabKey);
    };
  }, [isOpen]);
  const menuStyle = useMemo(() => {
    const _ = isOpen;
    const baseStyle = {
      position: "fixed",
      // Use fixed instead of absolute for portal rendering
      zIndex: 9999,
      maxHeight: "80vh",
      overflowY: "auto"
    };
    if (!triggerId || !triggerElementRef.current || !triggerElementFound) {
      return baseStyle;
    }
    const rect = triggerElementRef.current.getBoundingClientRect();
    switch (placement) {
      case "bottom start": {
        return {
          ...baseStyle,
          top: rect.bottom + offset,
          left: rect.left,
          minWidth: `${rect.width}px`,
          maxWidth: "300px"
        };
      }
      case "bottom end":
        return {
          ...baseStyle,
          top: rect.bottom + offset,
          right: window.innerWidth - rect.right,
          minWidth: `${rect.width}px`,
          maxWidth: "300px"
        };
      case "top start":
        return {
          ...baseStyle,
          bottom: window.innerHeight - rect.top + offset,
          left: rect.left,
          minWidth: `${rect.width}px`,
          maxWidth: "300px"
        };
      case "top end":
        return {
          ...baseStyle,
          bottom: window.innerHeight - rect.top + offset,
          right: window.innerWidth - rect.right,
          minWidth: `${rect.width}px`,
          maxWidth: "300px"
        };
      default:
        return {
          ...baseStyle,
          top: rect.bottom + offset,
          left: rect.left,
          minWidth: `${rect.width}px`,
          maxWidth: "300px"
        };
    }
  }, [triggerId, placement, offset, triggerElementFound, isOpen]);
  if (!isOpen || !mounted) {
    return null;
  }
  return createPortal(
    /* @__PURE__ */ jsx7(
      "div",
      {
        ref: menuRef,
        "aria-label": ariaLabel,
        "aria-labelledby": triggerId,
        className: `${menuContainer} ${className}`,
        role,
        style: menuStyle,
        tabIndex: -1,
        ...containerProps,
        children: renderMenuContent(children, showCloseButton, setOpen)
      }
    ),
    // Always append to document.body to avoid overflow clipping issues
    document.body
  );
});
Menu.displayName = "Menu";

// src/components/Menu/MenuItem.tsx
import { Fragment as Fragment3, jsx as jsx8, jsxs as jsxs3 } from "react/jsx-runtime";
function MenuItem({
  label: label5,
  icon: icon2,
  onClick,
  showDivider,
  className = "",
  ariaLabel
}) {
  return /* @__PURE__ */ jsxs3(Fragment3, { children: [
    showDivider && /* @__PURE__ */ jsx8("div", { className: menuDivider, role: "separator" }),
    /* @__PURE__ */ jsxs3(
      "button",
      {
        "aria-label": ariaLabel || label5,
        className: `${menuItem} ${className}`,
        role: "menuitem",
        onClick,
        children: [
          icon2 && /* @__PURE__ */ jsx8("span", { className: menuItemIcon, children: icon2 }),
          /* @__PURE__ */ jsx8("span", { className: menuItemText, children: label5 })
        ]
      }
    )
  ] });
}

// src/components/Spinner/Spinner.css.ts
import { createRuntimeFn as _7a4685 } from "@vanilla-extract/recipes/createRuntimeFn";
var spinner = "Spinner_spinner__xcgtio0";
var spinnerContainer = _7a4685({ defaultClassName: "sprinkles_display_flex__151f9bfn3 sprinkles_alignItems_center__151f9bfn8 sprinkles_justifyContent_center__151f9bfnd sprinkles_gap_sm__151f9bf84", variantClassNames: { inline: { true: "sprinkles_display_inline-flex__151f9bfn4", false: "Spinner_spinnerContainer_inline_false__xcgtiom" } }, defaultVariants: { inline: false }, compoundVariants: [] });
var spinnerLabel = "sprinkles_marginLeft_sm__151f9bf3m sprinkles_color_contentPrimary__151f9bf89";
var spinnerVariants = _7a4685({ defaultClassName: "sprinkles_display_inline-flex__151f9bfn4 sprinkles_alignItems_center__151f9bfn8 sprinkles_justifyContent_center__151f9bfnd", variantClassNames: { size: { small: "Spinner_spinnerVariants_size_small__xcgtioc", medium: "Spinner_spinnerVariants_size_medium__xcgtiod", large: "Spinner_spinnerVariants_size_large__xcgtioe" }, color: { primary: "Spinner_spinnerVariants_color_primary__xcgtiof", secondary: "Spinner_spinnerVariants_color_secondary__xcgtiog", neutral: "Spinner_spinnerVariants_color_neutral__xcgtioh" } }, defaultVariants: { size: "medium", color: "primary" }, compoundVariants: [] });
var xboxButtonA = "Spinner_xboxButtonA__xcgtio5";
var xboxButtonB = "Spinner_xboxButtonB__xcgtio6";
var xboxButtonX = "Spinner_xboxButtonX__xcgtio7";
var xboxButtonY = "Spinner_xboxButtonY__xcgtio8";
var xboxControllerSpinner = _7a4685({ defaultClassName: "Spinner_xboxControllerSpinner__xcgtio1", variantClassNames: { color: { primary: "Spinner_xboxControllerSpinner_color_primary__xcgtio2", secondary: "Spinner_xboxControllerSpinner_color_secondary__xcgtio3", neutral: "Spinner_xboxControllerSpinner_color_neutral__xcgtio4" } }, defaultVariants: { color: "primary" }, compoundVariants: [] });

// src/components/Spinner/XboxControllerSpinner.tsx
import { jsx as jsx9, jsxs as jsxs4 } from "react/jsx-runtime";
function XboxControllerSpinner({ color = "primary" }) {
  return /* @__PURE__ */ jsx9(
    "svg",
    {
      "aria-hidden": "true",
      className: xboxControllerSpinner({ color }),
      viewBox: "0 0 100 100",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsxs4("g", { transform: "translate(50, 50)", children: [
        /* @__PURE__ */ jsx9(
          "circle",
          {
            className: xboxButtonA,
            cx: "0",
            cy: "20",
            fill: "#3CB04C",
            r: "10",
            stroke: "#fff",
            strokeWidth: "1.5"
          }
        ),
        /* @__PURE__ */ jsx9(
          "circle",
          {
            className: xboxButtonB,
            cx: "20",
            cy: "0",
            fill: "#F25022",
            r: "10",
            stroke: "#fff",
            strokeWidth: "1.5"
          }
        ),
        /* @__PURE__ */ jsx9(
          "circle",
          {
            className: xboxButtonX,
            cx: "-20",
            cy: "0",
            fill: "#00A4EF",
            r: "10",
            stroke: "#fff",
            strokeWidth: "1.5"
          }
        ),
        /* @__PURE__ */ jsx9(
          "circle",
          {
            className: xboxButtonY,
            cx: "0",
            cy: "-20",
            fill: "#FFB900",
            r: "10",
            stroke: "#fff",
            strokeWidth: "1.5"
          }
        )
      ] })
    }
  );
}

// src/components/Spinner/Spinner.tsx
import { jsx as jsx10, jsxs as jsxs5 } from "react/jsx-runtime";
function Spinner({
  size = "medium",
  color = "primary",
  label: label5,
  inline = false,
  classic = false,
  className,
  containerProps,
  ...rest
}) {
  return /* @__PURE__ */ jsxs5(
    "div",
    {
      "aria-live": "polite",
      className: spinnerContainer({ inline }),
      role: "status",
      ...containerProps,
      children: [
        /* @__PURE__ */ jsx10("div", { className: `${spinnerVariants({ size, color })} ${className || ""}`, ...rest, children: classic ? /* @__PURE__ */ jsx10("div", { "aria-hidden": "true", className: spinner }) : /* @__PURE__ */ jsx10(XboxControllerSpinner, { color }) }),
        label5 && /* @__PURE__ */ jsx10("span", { className: spinnerLabel, children: label5 }),
        /* @__PURE__ */ jsx10("span", { className: "sr-only", children: label5 })
      ]
    }
  );
}

// src/components/Spinner/LoadingSpinner.css.ts
var pattern = "LoadingSpinner_pattern__avljkx3";
var rotating = "LoadingSpinner_rotating__avljkx2";
var spinner2 = "LoadingSpinner_spinner__avljkx1";

// src/components/Spinner/LoadingSpinner.tsx
import { jsx as jsx11, jsxs as jsxs6 } from "react/jsx-runtime";
var cn = (...args) => args.flat().map((arg) => {
  if (typeof arg === "string") {
    return arg;
  }
  if (typeof arg === "object" && arg !== null) {
    return Object.entries(arg).filter(([, value]) => value).map(([key]) => key).join(" ");
  }
  return "";
}).filter(Boolean).join(" ");
function LoadingSpinner({ animating = true, className }) {
  return /* @__PURE__ */ jsxs6(
    "svg",
    {
      className: cn(spinner2, className),
      height: "600",
      version: "1.1",
      viewBox: "0 0 600 600",
      width: "600",
      x: "0",
      xmlns: "http://www.w3.org/2000/svg",
      y: "0",
      children: [
        /* @__PURE__ */ jsxs6("defs", { children: [
          /* @__PURE__ */ jsxs6("linearGradient", { gradientTransform: "rotate(90)", id: "Gradient1", children: [
            /* @__PURE__ */ jsx11("stop", { offset: "0%", stopColor: "rgba(255, 255, 255, 1)" }),
            /* @__PURE__ */ jsx11("stop", { offset: "100%", stopColor: "rgba(255, 255, 255, 0.5)" })
          ] }),
          /* @__PURE__ */ jsxs6("linearGradient", { gradientTransform: "rotate(90)", id: "Gradient2", children: [
            /* @__PURE__ */ jsx11(
              "stop",
              {
                offset: "0%",
                stopColor: "rgba(255, 255, 255, 0)",
                stopOpacity: "0"
              }
            ),
            /* @__PURE__ */ jsx11("stop", { offset: "90%", stopColor: "rgba(255, 255, 255, 0.5)" }),
            /* @__PURE__ */ jsx11("stop", { offset: "100%", stopColor: "rgba(255, 255, 255, 0.65)" })
          ] }),
          /* @__PURE__ */ jsx11(
            "pattern",
            {
              height: "600",
              id: "Pattern",
              patternUnits: "userSpaceOnUse",
              width: "600",
              x: "0",
              y: "0",
              children: /* @__PURE__ */ jsxs6("g", { transform: "rotate(0, 300, 300)", children: [
                /* @__PURE__ */ jsx11(
                  "rect",
                  {
                    fill: "url(#Gradient1)",
                    height: "600",
                    shapeRendering: "crispEdges",
                    width: "300",
                    x: "0",
                    y: "0"
                  }
                ),
                /* @__PURE__ */ jsx11(
                  "rect",
                  {
                    fill: "url(#Gradient2)",
                    height: "600",
                    shapeRendering: "crispEdges",
                    width: "300",
                    x: "300",
                    y: "0"
                  }
                )
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ jsx11(
          "path",
          {
            className: cn({ [rotating]: animating }, pattern),
            d: "M 364 58 A 250 250 0 1 1 235 58",
            fill: "transparent",
            stroke: "url(#Pattern)",
            strokeWidth: "80",
            transform: "rotate(105, 300, 300)"
          }
        )
      ]
    }
  );
}

// src/components/LoadingOverlay/LoadingOverlay.css.ts
import { createRuntimeFn as _7a4686 } from "@vanilla-extract/recipes/createRuntimeFn";
var content = "LoadingOverlay_content__18xvh8c9";
var message = "LoadingOverlay_message__18xvh8ca";
var overlayVariants = _7a4686({ defaultClassName: "LoadingOverlay_overlay__18xvh8c0", variantClassNames: { blur: { true: "LoadingOverlay_overlayVariants_blur_true__18xvh8c2", false: "LoadingOverlay_overlayVariants_blur_false__18xvh8c3" }, background: { light: "LoadingOverlay_overlayVariants_background_light__18xvh8c4", dark: "LoadingOverlay_overlayVariants_background_dark__18xvh8c5", transparent: "LoadingOverlay_overlayVariants_background_transparent__18xvh8c6" }, fullScreen: { true: "LoadingOverlay_overlayVariants_fullScreen_true__18xvh8c7", false: "LoadingOverlay_overlayVariants_fullScreen_false__18xvh8c8" } }, defaultVariants: { blur: false, background: "dark", fullScreen: false }, compoundVariants: [] });

// src/components/LoadingOverlay/LoadingOverlay.tsx
import { jsx as jsx12, jsxs as jsxs7 } from "react/jsx-runtime";
function LoadingOverlay({
  blur = false,
  background = "dark",
  fullScreen = false,
  message: messageText,
  spinnerSize = "large",
  spinnerColor = "primary",
  className,
  containerProps,
  children
}) {
  return /* @__PURE__ */ jsx12(
    "div",
    {
      "aria-live": "polite",
      className: `${overlayVariants({ blur, background, fullScreen })} ${className || ""}`,
      role: "status",
      ...containerProps,
      children: /* @__PURE__ */ jsxs7("div", { className: content, children: [
        children || /* @__PURE__ */ jsx12(Spinner, { color: spinnerColor, size: spinnerSize }),
        messageText && /* @__PURE__ */ jsx12("div", { className: message, children: messageText })
      ] })
    }
  );
}

// src/components/Dropdown/Dropdown.tsx
import { forwardRef as forwardRef9, useImperativeHandle as useImperativeHandle2, useMemo as useMemo2, useRef as useRef2, useState as useState3, useId } from "react";

// src/components/Icon/Icon.tsx
import { forwardRef as forwardRef7, memo } from "react";

// src/components/Icon/Icon.css.ts
import { createRuntimeFn as _7a4687 } from "@vanilla-extract/recipes/createRuntimeFn";
var icon = _7a4687({ defaultClassName: "Icon__1apf2rc9 Icon_baseIcon__1apf2rc0", variantClassNames: { size: { xxSmall: "Icon_sizeVariants_xxSmall__1apf2rc1", xSmall: "Icon_sizeVariants_xSmall__1apf2rc2", small: "Icon_sizeVariants_small__1apf2rc3", medium: "Icon_sizeVariants_medium__1apf2rc4", large: "Icon_sizeVariants_large__1apf2rc5", xLarge: "Icon_sizeVariants_xLarge__1apf2rc6", xxLarge: "Icon_sizeVariants_xxLarge__1apf2rc7", xxxLarge: "Icon_sizeVariants_xxxLarge__1apf2rc8" } }, defaultVariants: { size: "medium" }, compoundVariants: [] });

// src/components/Icon/Icon.tsx
import { jsx as jsx13 } from "react/jsx-runtime";
var IconSize = /* @__PURE__ */ ((IconSize2) => {
  IconSize2["Custom"] = "Custom";
  IconSize2["XXSmall"] = "xxSmall";
  IconSize2["XSmall"] = "xSmall";
  IconSize2["Small"] = "small";
  IconSize2["Medium"] = "medium";
  IconSize2["Large"] = "large";
  IconSize2["XLarge"] = "xLarge";
  IconSize2["XXLarge"] = "xxLarge";
  IconSize2["XXXLarge"] = "xxxLarge";
  return IconSize2;
})(IconSize || {});
var IconUnmanaged = forwardRef7(
  ({ className, icon: SvgComponent, iconSize = "medium" /* Medium */, ...restProps }, ref) => {
    const getSizeValue = (size) => {
      if (size === "Custom") {
        return void 0;
      }
      const sizeMap = {
        xxsmall: "xxSmall",
        xsmall: "xSmall",
        small: "small",
        medium: "medium",
        large: "large",
        xlarge: "xLarge",
        xxlarge: "xxLarge",
        xxxlarge: "xxxLarge"
      };
      return sizeMap[size.toLowerCase()];
    };
    const sizeKey = typeof iconSize === "string" ? iconSize : IconSize[iconSize];
    const iconClass = icon({
      size: getSizeValue(sizeKey)
    });
    return /* @__PURE__ */ jsx13(
      SvgComponent,
      {
        ref,
        className: className ? `${iconClass} ${className}` : iconClass,
        ...restProps
      }
    );
  }
);
IconUnmanaged.displayName = "IconUnmanaged";
var Icon = memo(IconUnmanaged);
Icon.displayName = "Icon";

// src/components/Icon/icons/ChevronDown.tsx
import { jsx as jsx14, jsxs as jsxs8 } from "react/jsx-runtime";
function SvgChevronDown({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs8(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx14("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx14("path", { d: "M1939 467l90 90-1005 1005L19 557l90-90 915 915 915-915z" })
      ]
    }
  );
}
var ChevronDown_default = SvgChevronDown;

// src/components/Icon/icons/StatusCircleCheckmark.tsx
import { jsx as jsx15, jsxs as jsxs9 } from "react/jsx-runtime";
function SvgStatusCircleCheckmark({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs9(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx15("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx15("path", { d: "M1363 851l90 90-621 621-365-365 90-90 275 275 531-531z" })
      ]
    }
  );
}
var StatusCircleCheckmark_default = SvgStatusCircleCheckmark;

// src/components/IconAndTextButton/IconAndTextButton.tsx
import { forwardRef as forwardRef8 } from "react";

// src/components/IconAndTextButton/IconAndTextButton.css.ts
import { createRuntimeFn as _7a4688 } from "@vanilla-extract/recipes/createRuntimeFn";
var iconAndTextButton = _7a4688({ defaultClassName: "IconAndTextButton__1epzxy71 IconAndTextButton_baseButtonStyles__1epzxy70", variantClassNames: { size: { standard: "IconAndTextButton_iconAndTextButton_size_standard__1epzxy72", large: "IconAndTextButton_iconAndTextButton_size_large__1epzxy73" }, textStyle: { cta: "IconAndTextButton_iconAndTextButton_textStyle_cta__1epzxy74", action: "IconAndTextButton_iconAndTextButton_textStyle_action__1epzxy75" }, alignment: { center: "IconAndTextButton_iconAndTextButton_alignment_center__1epzxy76", left: "IconAndTextButton_iconAndTextButton_alignment_left__1epzxy77" }, kind: { standard: "IconAndTextButton_iconAndTextButton_kind_standard__1epzxy78", brand: "IconAndTextButton_iconAndTextButton_kind_brand__1epzxy79", destructive: "IconAndTextButton_iconAndTextButton_kind_destructive__1epzxy7a", tertiary: "IconAndTextButton_iconAndTextButton_kind_tertiary__1epzxy7b" }, isToggled: { true: "IconAndTextButton_iconAndTextButton_isToggled_true__1epzxy7c", false: "IconAndTextButton_iconAndTextButton_isToggled_false__1epzxy7d" } }, defaultVariants: { size: "standard", textStyle: "cta", alignment: "center", kind: "standard", isToggled: false }, compoundVariants: [[{ kind: "standard", isToggled: true }, "IconAndTextButton_iconAndTextButton_compound_0__1epzxy7e"], [{ kind: "brand", isToggled: true }, "IconAndTextButton_iconAndTextButton_compound_1__1epzxy7f"]] });
var leadingIconContainer = "IconAndTextButton_leadingIconContainer__1epzxy7g";
var textContainer = "IconAndTextButton_textContainer__1epzxy7i";
var trailingIconContainer = "IconAndTextButton_trailingIconContainer__1epzxy7h";

// src/components/IconAndTextButton/IconAndTextButton.tsx
import { jsx as jsx16, jsxs as jsxs10 } from "react/jsx-runtime";
var IconAndTextButton = forwardRef8(
  // eslint-disable-next-line complexity
  ({
    children,
    leadingIcon,
    trailingIcon,
    leadingIconClassName,
    trailingIconClassName,
    leadingIconSize = "medium",
    trailingIconSize = "medium",
    size = "standard",
    kind = "standard",
    textStyle = "cta",
    alignment = "center",
    isToggled = false,
    onToggle,
    className,
    onClick,
    ...restProps
  }, ref) => {
    if (leadingIcon && trailingIcon) {
      console.warn("IconAndTextButton: Both leadingIcon and trailingIcon provided. Only leadingIcon will be used.");
    }
    const handleClick = (event) => {
      onToggle?.();
      onClick?.(event);
    };
    const buttonClassName = `${iconAndTextButton({
      size,
      textStyle,
      alignment,
      kind,
      isToggled
    })} ${className || ""}`.trim();
    return /* @__PURE__ */ jsxs10(
      "button",
      {
        ref,
        "aria-pressed": onToggle ? isToggled : void 0,
        className: buttonClassName,
        onClick: handleClick,
        ...restProps,
        children: [
          leadingIcon && !trailingIcon && /* @__PURE__ */ jsx16("span", { className: leadingIconContainer, children: /* @__PURE__ */ jsx16(Icon, { className: leadingIconClassName, icon: leadingIcon, iconSize: leadingIconSize }) }),
          /* @__PURE__ */ jsx16("span", { className: textContainer, children }),
          trailingIcon && !leadingIcon && /* @__PURE__ */ jsx16("span", { className: trailingIconContainer, children: /* @__PURE__ */ jsx16(Icon, { className: trailingIconClassName, icon: trailingIcon, iconSize: trailingIconSize }) })
        ]
      }
    );
  }
);
IconAndTextButton.displayName = "IconAndTextButton";

// src/components/Dropdown/Dropdown.css.ts
import { createRuntimeFn as _7a4689 } from "@vanilla-extract/recipes/createRuntimeFn";
var chevron = _7a4689({ defaultClassName: "Dropdown__1gwbirai Dropdown_chevronStyle_base__1gwbiraf", variantClassNames: { isOpen: { true: "Dropdown_chevronStyle_variants_isOpen_true__1gwbirag", false: "Dropdown_chevronStyle_variants_isOpen_false__1gwbirah" } }, defaultVariants: {}, compoundVariants: [] });
var chevronStyle = _7a4689({ defaultClassName: "Dropdown__1gwbirai Dropdown_chevronStyle_base__1gwbiraf", variantClassNames: { isOpen: { true: "Dropdown_chevronStyle_variants_isOpen_true__1gwbirag", false: "Dropdown_chevronStyle_variants_isOpen_false__1gwbirah" } }, defaultVariants: {}, compoundVariants: [] });
var container2 = "Dropdown_containerStyle__1gwbira0";
var dropdownItem = "Dropdown_dropdownItem__1gwbirao";
var dropdownItemSelected = "Dropdown_dropdownItemSelected__1gwbirap Dropdown_dropdownItem__1gwbirao";
var dropdownList = "Dropdown_dropdownList__1gwbiran";
var dropdownMessage = "Dropdown_dropdownMessage__1gwbiram";
var dropdownStyles = { container: "Dropdown_containerStyle__1gwbira0", trigger: _7a4689({ defaultClassName: "Dropdown__1gwbira7 Dropdown_triggerStyle_base__1gwbira1", variantClassNames: { isPlaceholder: { true: "Dropdown_triggerStyle_variants_isPlaceholder_true__1gwbira2", false: "Dropdown_triggerStyle_variants_isPlaceholder_false__1gwbira3" }, size: { small: "Dropdown_triggerStyle_variants_size_small__1gwbira4", medium: "Dropdown_triggerStyle_variants_size_medium__1gwbira5", large: "Dropdown_triggerStyle_variants_size_large__1gwbira6" } }, defaultVariants: { size: "medium" }, compoundVariants: [] }), triggerContent: "Dropdown_triggerContentStyle__1gwbirad", iconOnlyContent: "Dropdown_iconOnlyContentStyle__1gwbirae", chevron: _7a4689({ defaultClassName: "Dropdown__1gwbirai Dropdown_chevronStyle_base__1gwbiraf", variantClassNames: { isOpen: { true: "Dropdown_chevronStyle_variants_isOpen_true__1gwbirag", false: "Dropdown_chevronStyle_variants_isOpen_false__1gwbirah" } }, defaultVariants: {}, compoundVariants: [] }), menu: "Dropdown_menuStyle__1gwbiral", menuItem: _7a4689({ defaultClassName: "Dropdown__1gwbirat Dropdown_dropdownItem__1gwbirao", variantClassNames: { isSelected: { true: "Dropdown_dropdownItemSelected__1gwbirap Dropdown_dropdownItem__1gwbirao", false: "Dropdown_dropdownItem__1gwbirao" } }, defaultVariants: {}, compoundVariants: [] }), menuItemIcon: "Dropdown_menuItemIconStyle__1gwbiraw", menuItemLabel: "Dropdown_menuItemLabelStyle__1gwbirax", selectedIcon: "Dropdown_selectedIconStyle__1gwbiray" };
var iconOnlyContent = "Dropdown_iconOnlyContentStyle__1gwbirae";
var menu = "Dropdown_menuStyle__1gwbiral";
var menuItem2 = _7a4689({ defaultClassName: "Dropdown__1gwbirat Dropdown_dropdownItem__1gwbirao", variantClassNames: { isSelected: { true: "Dropdown_dropdownItemSelected__1gwbirap Dropdown_dropdownItem__1gwbirao", false: "Dropdown_dropdownItem__1gwbirao" } }, defaultVariants: {}, compoundVariants: [] });
var menuItemIcon2 = "Dropdown_menuItemIconStyle__1gwbiraw";
var menuItemStyle = _7a4689({ defaultClassName: "Dropdown__1gwbirat Dropdown_dropdownItem__1gwbirao", variantClassNames: { isSelected: { true: "Dropdown_dropdownItemSelected__1gwbirap Dropdown_dropdownItem__1gwbirao", false: "Dropdown_dropdownItem__1gwbirao" } }, defaultVariants: {}, compoundVariants: [] });
var optionDescriptionStyle = "Dropdown_optionDescriptionStyle__1gwbiras";
var optionInfo = "Dropdown_optionInfo__1gwbiraq";
var optionLabel = "Dropdown_optionLabel__1gwbirar";
var selectedIcon = "Dropdown_selectedIconStyle__1gwbiray";
var trigger = _7a4689({ defaultClassName: "Dropdown__1gwbira7 Dropdown_triggerStyle_base__1gwbira1", variantClassNames: { isPlaceholder: { true: "Dropdown_triggerStyle_variants_isPlaceholder_true__1gwbira2", false: "Dropdown_triggerStyle_variants_isPlaceholder_false__1gwbira3" }, size: { small: "Dropdown_triggerStyle_variants_size_small__1gwbira4", medium: "Dropdown_triggerStyle_variants_size_medium__1gwbira5", large: "Dropdown_triggerStyle_variants_size_large__1gwbira6" } }, defaultVariants: { size: "medium" }, compoundVariants: [] });
var triggerContent = "Dropdown_triggerContentStyle__1gwbirad";
var triggerStyle = _7a4689({ defaultClassName: "Dropdown__1gwbira7 Dropdown_triggerStyle_base__1gwbira1", variantClassNames: { isPlaceholder: { true: "Dropdown_triggerStyle_variants_isPlaceholder_true__1gwbira2", false: "Dropdown_triggerStyle_variants_isPlaceholder_false__1gwbira3" }, size: { small: "Dropdown_triggerStyle_variants_size_small__1gwbira4", medium: "Dropdown_triggerStyle_variants_size_medium__1gwbira5", large: "Dropdown_triggerStyle_variants_size_large__1gwbira6" } }, defaultVariants: { size: "medium" }, compoundVariants: [] });

// src/components/Dropdown/Dropdown.tsx
import { jsx as jsx17, jsxs as jsxs11 } from "react/jsx-runtime";
function DropdownContent({
  loading = false,
  error: error2,
  options,
  selectedItem,
  handleOptionSelect,
  handleItemKeyDown,
  emptyMessage = "No options available",
  showCheckmark = true
}) {
  if (loading) {
    return /* @__PURE__ */ jsx17("div", { className: dropdownMessage, children: "Loading..." });
  }
  if (error2) {
    return /* @__PURE__ */ jsx17("div", { className: dropdownMessage, children: error2 });
  }
  if (options.length === 0) {
    return /* @__PURE__ */ jsx17("div", { className: dropdownMessage, children: emptyMessage });
  }
  return /* @__PURE__ */ jsx17("div", { className: dropdownList, role: "listbox", children: options.map((option) => {
    const isSelected = selectedItem === option.id;
    return /* @__PURE__ */ jsxs11(
      "div",
      {
        "aria-selected": isSelected,
        className: isSelected ? dropdownItemSelected : dropdownItem,
        role: "option",
        tabIndex: 0,
        onClick: () => handleOptionSelect(option.id),
        onKeyDown: (e) => handleItemKeyDown(e, option.id),
        children: [
          option.icon && /* @__PURE__ */ jsx17("div", { className: menuItemIcon2, children: option.icon }),
          /* @__PURE__ */ jsxs11("div", { className: optionInfo, children: [
            /* @__PURE__ */ jsx17("div", { className: optionLabel, children: option.label }),
            option.description && /* @__PURE__ */ jsx17("div", { className: optionDescriptionStyle, children: option.description })
          ] }),
          isSelected && showCheckmark && /* @__PURE__ */ jsx17(Icon, { className: selectedIcon, icon: StatusCircleCheckmark_default })
        ]
      },
      option.id
    );
  }) });
}
var Dropdown = forwardRef9(
  // eslint-disable-next-line complexity
  ({
    id,
    placeholder: placeholder3 = "Select an option",
    selectedItem,
    onSelectionChange,
    onItemClick,
    options = [],
    isOpen: controlledIsOpen,
    onOpenChange,
    className,
    triggerClassName,
    disabled = false,
    show = "text",
    selectedItemIcon,
    size = "medium",
    showCheckmark = true
  }, ref) => {
    const [internalIsOpen, setInternalIsOpen] = useState3(false);
    const triggerRef = useRef2(null);
    const uniqueId = useId();
    const isOpen = controlledIsOpen !== void 0 ? controlledIsOpen : internalIsOpen;
    const setIsOpen = (newIsOpen) => {
      if (controlledIsOpen === void 0) {
        setInternalIsOpen(newIsOpen);
      }
      onOpenChange?.(newIsOpen);
    };
    const selectedOption = useMemo2(() => options.find((option) => option.id === selectedItem), [options, selectedItem]);
    const displayText = selectedOption?.label || placeholder3;
    const isPlaceholder = !selectedOption;
    const displayContent = useMemo2(() => {
      if (show === "icon") {
        return null;
      }
      if (show === "both" && selectedItemIcon) {
        return /* @__PURE__ */ jsxs11("span", { className: triggerContent, children: [
          selectedItemIcon,
          /* @__PURE__ */ jsx17("span", { children: displayText })
        ] });
      }
      return displayText;
    }, [show, selectedItemIcon, displayText]);
    const handleToggle = () => {
      if (!disabled) {
        setIsOpen(!isOpen);
      }
    };
    const handleOptionSelect = (optionId) => {
      onItemClick?.(optionId);
      onSelectionChange?.(optionId);
      setIsOpen(false);
    };
    const handleItemKeyDown = (e, optionId) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        handleOptionSelect(optionId);
      }
    };
    useImperativeHandle2(ref, () => ({
      focus: () => triggerRef.current?.focus(),
      blur: () => triggerRef.current?.blur()
    }));
    const triggerId = id ? `${id}-trigger` : `dropdown-trigger-${uniqueId}`;
    return /* @__PURE__ */ jsxs11("div", { className: `${container2} ${className || ""}`, children: [
      /* @__PURE__ */ jsx17(
        IconAndTextButton,
        {
          ref: triggerRef,
          "aria-expanded": isOpen,
          "aria-haspopup": "listbox",
          "aria-label": show === "icon" ? displayText : void 0,
          className: `${trigger({ isPlaceholder, size })} ${triggerClassName || ""}`,
          disabled,
          id: triggerId,
          kind: "standard",
          trailingIcon: ChevronDown_default,
          trailingIconClassName: chevron({ isOpen }),
          trailingIconSize: "xxsmall",
          onClick: handleToggle,
          children: show === "icon" && selectedItemIcon ? /* @__PURE__ */ jsx17("span", { className: iconOnlyContent, children: selectedItemIcon }) : displayContent
        }
      ),
      /* @__PURE__ */ jsx17(
        Menu,
        {
          className: menu,
          dismissBehavior: {
            onEscape: true,
            onClickOutside: true,
            onResize: true
          },
          isOpen,
          offset: 8,
          showCloseButton: false,
          triggerId,
          onOpenChange: (open) => !open && setIsOpen(false),
          children: /* @__PURE__ */ jsx17(
            DropdownContent,
            {
              emptyMessage: "No options available",
              handleItemKeyDown,
              handleOptionSelect,
              options,
              selectedItem,
              showCheckmark
            }
          )
        }
      )
    ] });
  }
);
Dropdown.displayName = "Dropdown";

// src/components/Select/Select.tsx
import { forwardRef as forwardRef11, useState as useState5, useRef as useRef3, useId as useId2, useMemo as useMemo4 } from "react";

// src/components/TextInput/TextInput.tsx
import { forwardRef as forwardRef10, useCallback as useCallback2, useEffect as useEffect3, useMemo as useMemo3, useState as useState4 } from "react";

// src/styles/xds-theme.css.ts
var xdsVars = { colors: { secondaryLabelOpacity: "var(--colors-secondaryLabelOpacity__uhesuc0)", contentPrimary: "var(--colors-contentPrimary__uhesuc1)", contentSecondary: "var(--colors-contentSecondary__uhesuc2)", contentDisabled: "var(--colors-contentDisabled__uhesuc3)", contentError: "var(--colors-contentError__uhesuc4)", contentAccent: "var(--colors-contentAccent__uhesuc5)", contentOnBackplatePrimary: "var(--colors-contentOnBackplatePrimary__uhesuc6)", contentOnBackplateSecondary: "var(--colors-contentOnBackplateSecondary__uhesuc7)", contentOnBackplateTertiary: "var(--colors-contentOnBackplateTertiary__uhesuc8)", contentOnBackplateAccent: "var(--colors-contentOnBackplateAccent__uhesuc9)", contentOnBackplateDisabled: "var(--colors-contentOnBackplateDisabled__uhesuca)", contentOnBackplateTransparentPrimary: "var(--colors-contentOnBackplateTransparentPrimary__uhesucb)", contentOnBackplateTransparentSecondary: "var(--colors-contentOnBackplateTransparentSecondary__uhesucc)", contentOnBackplateTransparentTertiary: "var(--colors-contentOnBackplateTransparentTertiary__uhesucd)", contentOnBackplateTransparentAccent: "var(--colors-contentOnBackplateTransparentAccent__uhesuce)", contentOnBackplateTransparentDisabled: "var(--colors-contentOnBackplateTransparentDisabled__uhesucf)", contentOnBackplateAcrylicPrimaryRest: "var(--colors-contentOnBackplateAcrylicPrimaryRest__uhesucg)", contentOnHover: "var(--colors-contentOnHover__uhesuch)", contentOnHoverTransparent: "var(--colors-contentOnHoverTransparent__uhesuci)", contentOnPress: "var(--colors-contentOnPress__uhesucj)", contentOnPressTransparent: "var(--colors-contentOnPressTransparent__uhesuck)", contentPrimaryDisabled: "var(--colors-contentPrimaryDisabled__uhesucl)", contentPrimaryOnHover: "var(--colors-contentPrimaryOnHover__uhesucm)", contentPrimaryOnPress: "var(--colors-contentPrimaryOnPress__uhesucn)", contentHyperlinkRest: "var(--colors-contentHyperlinkRest__uhesuco)", contentHyperlinkHover: "var(--colors-contentHyperlinkHover__uhesucp)", contentHyperlinkPress: "var(--colors-contentHyperlinkPress__uhesucq)", contentHyperlinkVisited: "var(--colors-contentHyperlinkVisited__uhesucr)", containerSolidAppBackground: "var(--colors-containerSolidAppBackground__uhesucs)", containerSolidContainer: "var(--colors-containerSolidContainer__uhesuct)", containerSolidContainerDark: "var(--colors-containerSolidContainerDark__uhesucu)", containerSolidContainerLight: "var(--colors-containerSolidContainerLight__uhesucv)", containerAcrylicDark: "var(--colors-containerAcrylicDark__uhesucw)", containerAcrylicExtraDark: "var(--colors-containerAcrylicExtraDark__uhesucx)", containerAcrylicExtraLight: "var(--colors-containerAcrylicExtraLight__uhesucy)", containerAcrylicLight: "var(--colors-containerAcrylicLight__uhesucz)", containerAcrylicWhiteHeavy: "var(--colors-containerAcrylicWhiteHeavy__uhesuc10)", containerAcrylicWhiteLight: "var(--colors-containerAcrylicWhiteLight__uhesuc11)", containerSemitransparentFogHeavy: "var(--colors-containerSemitransparentFogHeavy__uhesuc12)", containerSemitransparentFogLight: "var(--colors-containerSemitransparentFogLight__uhesuc13)", containerSemitransparentSmokeDark: "var(--colors-containerSemitransparentSmokeDark__uhesuc14)", containerSemitransparentSmokeExtraDark: "var(--colors-containerSemitransparentSmokeExtraDark__uhesuc15)", containerSemitransparentSmokeExtraLight: "var(--colors-containerSemitransparentSmokeExtraLight__uhesuc16)", containerSemitransparentSmokeLight: "var(--colors-containerSemitransparentSmokeLight__uhesuc17)", stateHover: "var(--colors-stateHover__uhesuc18)", statePress: "var(--colors-statePress__uhesuc19)", stateFocus: "var(--colors-stateFocus__uhesuc1a)", stateRest: "var(--colors-stateRest__uhesuc1b)", stateDisabled: "var(--colors-stateDisabled__uhesuc1c)", backplateAcrylicAccentDisabled: "var(--colors-backplateAcrylicAccentDisabled__uhesuc1d)", backplateAcrylicAccentFocus: "var(--colors-backplateAcrylicAccentFocus__uhesuc1e)", backplateAcrylicAccentHover: "var(--colors-backplateAcrylicAccentHover__uhesuc1f)", backplateAcrylicAccentPress: "var(--colors-backplateAcrylicAccentPress__uhesuc1g)", backplateAcrylicAccentRest: "var(--colors-backplateAcrylicAccentRest__uhesuc1h)", backplateAcrylicPrimaryDisabled: "var(--colors-backplateAcrylicPrimaryDisabled__uhesuc1i)", backplateAcrylicPrimaryFocus: "var(--colors-backplateAcrylicPrimaryFocus__uhesuc1j)", backplateAcrylicPrimaryHover: "var(--colors-backplateAcrylicPrimaryHover__uhesuc1k)", backplateAcrylicPrimaryPress: "var(--colors-backplateAcrylicPrimaryPress__uhesuc1l)", backplateAcrylicPrimaryRest: "var(--colors-backplateAcrylicPrimaryRest__uhesuc1m)", backplateAcrylicSecondaryDisabled: "var(--colors-backplateAcrylicSecondaryDisabled__uhesuc1n)", backplateAcrylicSecondaryFocus: "var(--colors-backplateAcrylicSecondaryFocus__uhesuc1o)", backplateAcrylicSecondaryHover: "var(--colors-backplateAcrylicSecondaryHover__uhesuc1p)", backplateAcrylicSecondaryPress: "var(--colors-backplateAcrylicSecondaryPress__uhesuc1q)", backplateAcrylicSecondaryRest: "var(--colors-backplateAcrylicSecondaryRest__uhesuc1r)", backplateAcrylicTertiaryDisabled: "var(--colors-backplateAcrylicTertiaryDisabled__uhesuc1s)", backplateAcrylicTertiaryFocus: "var(--colors-backplateAcrylicTertiaryFocus__uhesuc1t)", backplateAcrylicTertiaryHover: "var(--colors-backplateAcrylicTertiaryHover__uhesuc1u)", backplateAcrylicTertiaryPress: "var(--colors-backplateAcrylicTertiaryPress__uhesuc1v)", backplateAcrylicTertiaryRest: "var(--colors-backplateAcrylicTertiaryRest__uhesuc1w)", backplateSemitransparentAccentDisabled: "var(--colors-backplateSemitransparentAccentDisabled__uhesuc1x)", backplateSemitransparentAccentFocus: "var(--colors-backplateSemitransparentAccentFocus__uhesuc1y)", backplateSemitransparentAccentHover: "var(--colors-backplateSemitransparentAccentHover__uhesuc1z)", backplateSemitransparentAccentPress: "var(--colors-backplateSemitransparentAccentPress__uhesuc20)", backplateSemitransparentAccentRest: "var(--colors-backplateSemitransparentAccentRest__uhesuc21)", backplateSemitransparentPrimaryDisabled: "var(--colors-backplateSemitransparentPrimaryDisabled__uhesuc22)", backplateSemitransparentPrimaryFocus: "var(--colors-backplateSemitransparentPrimaryFocus__uhesuc23)", backplateSemitransparentPrimaryHover: "var(--colors-backplateSemitransparentPrimaryHover__uhesuc24)", backplateSemitransparentPrimaryPress: "var(--colors-backplateSemitransparentPrimaryPress__uhesuc25)", backplateSemitransparentPrimaryRest: "var(--colors-backplateSemitransparentPrimaryRest__uhesuc26)", backplateSemitransparentSecondaryDisabled: "var(--colors-backplateSemitransparentSecondaryDisabled__uhesuc27)", backplateSemitransparentSecondaryFocus: "var(--colors-backplateSemitransparentSecondaryFocus__uhesuc28)", backplateSemitransparentSecondaryHover: "var(--colors-backplateSemitransparentSecondaryHover__uhesuc29)", backplateSemitransparentSecondaryPress: "var(--colors-backplateSemitransparentSecondaryPress__uhesuc2a)", backplateSemitransparentSecondaryRest: "var(--colors-backplateSemitransparentSecondaryRest__uhesuc2b)", backplateSemitransparentTertiaryDisabled: "var(--colors-backplateSemitransparentTertiaryDisabled__uhesuc2c)", backplateSemitransparentTertiaryFocus: "var(--colors-backplateSemitransparentTertiaryFocus__uhesuc2d)", backplateSemitransparentTertiaryHover: "var(--colors-backplateSemitransparentTertiaryHover__uhesuc2e)", backplateSemitransparentTertiaryPress: "var(--colors-backplateSemitransparentTertiaryPress__uhesuc2f)", backplateSemitransparentTertiaryRest: "var(--colors-backplateSemitransparentTertiaryRest__uhesuc2g)", backplateSolidAccentDisabled: "var(--colors-backplateSolidAccentDisabled__uhesuc2h)", backplateSolidAccentFocus: "var(--colors-backplateSolidAccentFocus__uhesuc2i)", backplateSolidAccentHover: "var(--colors-backplateSolidAccentHover__uhesuc2j)", backplateSolidAccentPress: "var(--colors-backplateSolidAccentPress__uhesuc2k)", backplateSolidAccentRest: "var(--colors-backplateSolidAccentRest__uhesuc2l)", backplateSolidBrandRest: "var(--colors-backplateSolidBrandRest__uhesuc2m)", backplateSolidPrimaryDisabled: "var(--colors-backplateSolidPrimaryDisabled__uhesuc2n)", backplateSolidPrimaryFocus: "var(--colors-backplateSolidPrimaryFocus__uhesuc2o)", backplateSolidPrimaryHover: "var(--colors-backplateSolidPrimaryHover__uhesuc2p)", backplateSolidPrimaryPress: "var(--colors-backplateSolidPrimaryPress__uhesuc2q)", backplateSolidPrimaryRest: "var(--colors-backplateSolidPrimaryRest__uhesuc2r)", backplateSolidSecondaryDisabled: "var(--colors-backplateSolidSecondaryDisabled__uhesuc2s)", backplateSolidSecondaryFocus: "var(--colors-backplateSolidSecondaryFocus__uhesuc2t)", backplateSolidSecondaryHover: "var(--colors-backplateSolidSecondaryHover__uhesuc2u)", backplateSolidSecondaryPress: "var(--colors-backplateSolidSecondaryPress__uhesuc2v)", backplateSolidSecondaryRest: "var(--colors-backplateSolidSecondaryRest__uhesuc2w)", backplateSolidTertiaryDisabled: "var(--colors-backplateSolidTertiaryDisabled__uhesuc2x)", backplateSolidTertiaryFocus: "var(--colors-backplateSolidTertiaryFocus__uhesuc2y)", backplateSolidTertiaryHover: "var(--colors-backplateSolidTertiaryHover__uhesuc2z)", backplateSolidTertiaryPress: "var(--colors-backplateSolidTertiaryPress__uhesuc30)", backplateSolidTertiaryRest: "var(--colors-backplateSolidTertiaryRest__uhesuc31)", dividerLight: "var(--colors-dividerLight__uhesuc32)", dividerMedium: "var(--colors-dividerMedium__uhesuc33)", dividerStrong: "var(--colors-dividerStrong__uhesuc34)", activityOnline: "var(--colors-activityOnline__uhesuc35)", activityOffline: "var(--colors-activityOffline__uhesuc36)", activityError: "var(--colors-activityError__uhesuc37)", activityWarning: "var(--colors-activityWarning__uhesuc38)", activityFavorite: "var(--colors-activityFavorite__uhesuc39)", productXboxGreen: "var(--colors-productXboxGreen__uhesuc3a)", productDataVizXbox: "var(--colors-productDataVizXbox__uhesuc3b)", productDataVizWindows: "var(--colors-productDataVizWindows__uhesuc3c)", productDataVizChevron: "var(--colors-productDataVizChevron__uhesuc3d)", hCBlack: "var(--colors-hCBlack__uhesuc3e)", hCDisabled: "var(--colors-hCDisabled__uhesuc3f)", hCHyperlink: "var(--colors-hCHyperlink__uhesuc3g)", hCPrimary: "var(--colors-hCPrimary__uhesuc3h)", hCSecondary: "var(--colors-hCSecondary__uhesuc3i)", hCWhite: "var(--colors-hCWhite__uhesuc3j)", smokeLight: "var(--colors-smokeLight__uhesuc3k)", smokeStrong: "var(--colors-smokeStrong__uhesuc3l)", focusActive: "var(--colors-focusActive__uhesuc3m)" }, shadows: { shadowLayer1: "var(--shadows-shadowLayer1__uhesuc3n)", shadowLayer2: "var(--shadows-shadowLayer2__uhesuc3o)", shadowLayer3: "var(--shadows-shadowLayer3__uhesuc3p)", elevation1: "var(--shadows-elevation1__uhesuc3q)", elevation2: "var(--shadows-elevation2__uhesuc3r)", elevation3: "var(--shadows-elevation3__uhesuc3s)", elevation4: "var(--shadows-elevation4__uhesuc3t)", glowBrand: "var(--shadows-glowBrand__uhesuc3u)", glowUserColor: "var(--shadows-glowUserColor__uhesuc3v)", focusRing: "var(--shadows-focusRing__uhesuc3w)" }, space: { "0": "var(--space-0__uhesuc3x)", "1": "var(--space-1__uhesuc3y)", "2": "var(--space-2__uhesuc3z)", "3": "var(--space-3__uhesuc40)", "4": "var(--space-4__uhesuc41)", "5": "var(--space-5__uhesuc42)", "6": "var(--space-6__uhesuc43)", "8": "var(--space-8__uhesuc44)", "10": "var(--space-10__uhesuc45)", "12": "var(--space-12__uhesuc46)" }, fontSizes: { h1: "var(--fontSizes-h1__uhesuc47)", h2: "var(--fontSizes-h2__uhesuc48)", h3: "var(--fontSizes-h3__uhesuc49)", h4: "var(--fontSizes-h4__uhesuc4a)", h5: "var(--fontSizes-h5__uhesuc4b)", h6: "var(--fontSizes-h6__uhesuc4c)", subTitle1: "var(--fontSizes-subTitle1__uhesuc4d)", subTitle2: "var(--fontSizes-subTitle2__uhesuc4e)", body1: "var(--fontSizes-body1__uhesuc4f)", body2: "var(--fontSizes-body2__uhesuc4g)", caption: "var(--fontSizes-caption__uhesuc4h)", caption2: "var(--fontSizes-caption2__uhesuc4i)", buttonText: "var(--fontSizes-buttonText__uhesuc4j)", tag: "var(--fontSizes-tag__uhesuc4k)" }, fonts: { system: "var(--fonts-system__uhesuc4l)", primary: "var(--fonts-primary__uhesuc4m)", bahnschrift: "var(--fonts-bahnschrift__uhesuc4n)" }, fontWeights: { light: "var(--fontWeights-light__uhesuc4o)", normal: "var(--fontWeights-normal__uhesuc4p)", medium: "var(--fontWeights-medium__uhesuc4q)", semibold: "var(--fontWeights-semibold__uhesuc4r)", bold: "var(--fontWeights-bold__uhesuc4s)" }, lineHeights: { h1: "var(--lineHeights-h1__uhesuc4t)", h2: "var(--lineHeights-h2__uhesuc4u)", h3: "var(--lineHeights-h3__uhesuc4v)", h4: "var(--lineHeights-h4__uhesuc4w)", h5: "var(--lineHeights-h5__uhesuc4x)", h6: "var(--lineHeights-h6__uhesuc4y)", subTitle1: "var(--lineHeights-subTitle1__uhesuc4z)", subTitle2: "var(--lineHeights-subTitle2__uhesuc50)", body1: "var(--lineHeights-body1__uhesuc51)", body2: "var(--lineHeights-body2__uhesuc52)", caption: "var(--lineHeights-caption__uhesuc53)", caption2: "var(--lineHeights-caption2__uhesuc54)", buttonText: "var(--lineHeights-buttonText__uhesuc55)", tag: "var(--lineHeights-tag__uhesuc56)", none: "var(--lineHeights-none__uhesuc57)", tight: "var(--lineHeights-tight__uhesuc58)", normal: "var(--lineHeights-normal__uhesuc59)", relaxed: "var(--lineHeights-relaxed__uhesuc5a)" }, radii: { none: "var(--radii-none__uhesuc5b)", sm: "var(--radii-sm__uhesuc5c)", md: "var(--radii-md__uhesuc5d)", lg: "var(--radii-lg__uhesuc5e)", full: "var(--radii-full__uhesuc5f)", buttonBasic: "var(--radii-buttonBasic__uhesuc5g)", buttonBasicFocus: "var(--radii-buttonBasicFocus__uhesuc5h)", buttonHero: "var(--radii-buttonHero__uhesuc5i)", buttonHeroFocus: "var(--radii-buttonHeroFocus__uhesuc5j)", card: "var(--radii-card__uhesuc5k)", focus: "var(--radii-focus__uhesuc5l)", "switch": "var(--radii-switch__uhesuc5m)", switchThumb: "var(--radii-switchThumb__uhesuc5n)", picker: "var(--radii-picker__uhesuc5o)", pickerItem: "var(--radii-pickerItem__uhesuc5p)", pickerItemFocus: "var(--radii-pickerItemFocus__uhesuc5q)" }, transitions: { fast: "var(--transitions-fast__uhesuc5r)", normal: "var(--transitions-normal__uhesuc5s)", slow: "var(--transitions-slow__uhesuc5t)" } };

// src/components/TextInput/TextInput.css.ts
import { createRuntimeFn as _7a46810 } from "@vanilla-extract/recipes/createRuntimeFn";
var accelerator = "TextInput_accelerator__q0v45a4";
var bottomContainer = "TextInput_bottomContainer__q0v45a5";
var characterContainer = "TextInput_characterContainer__q0v45a6";
var errorMessage = "TextInput_errorMessage__q0v45a9";
var helperText = "TextInput_helperText__q0v45aa";
var input = _7a46810({ defaultClassName: "TextInput__q0v45an TextInput_baseInput__q0v45a2", variantClassNames: { size: { small: "TextInput_input_size_small__q0v45ao", medium: "TextInput_input_size_medium__q0v45ap", large: "TextInput_input_size_large__q0v45aq" } }, defaultVariants: { size: "medium" }, compoundVariants: [] });
var inputBox = _7a46810({ defaultClassName: "TextInput__q0v45af TextInput_baseInputBox__q0v45a1", variantClassNames: { size: { small: "TextInput_inputBox_size_small__q0v45ag", medium: "TextInput_inputBox_size_medium__q0v45ah", large: "TextInput_inputBox_size_large__q0v45ai" }, variant: { "default": "TextInput_inputBox_variant_default__q0v45aj", filled: "TextInput_inputBox_variant_filled__q0v45ak", error: "TextInput_inputBox_variant_error__q0v45al" }, hasError: { true: "TextInput_inputBox_hasError_true__q0v45am" } }, defaultVariants: { size: "medium", variant: "default" }, compoundVariants: [] });
var inputContainer = _7a46810({ defaultClassName: "TextInput__q0v45ac TextInput_baseInputContainer__q0v45a0", variantClassNames: { fullWidth: { true: "TextInput_inputContainer_fullWidth_true__q0v45ad", false: "TextInput_inputContainer_fullWidth_false__q0v45ae" } }, defaultVariants: { fullWidth: true }, compoundVariants: [] });
var inputLabel = "TextInput_inputLabel__q0v45a8";
var statusInfo = "TextInput_statusInfo__q0v45a7";

// src/components/TextInput/TextInput.tsx
import { jsx as jsx18, jsxs as jsxs12 } from "react/jsx-runtime";
var TextInput = forwardRef10(
  // eslint-disable-next-line complexity
  ({
    value,
    maxLength,
    statusInfo: statusInfo2,
    prefixIcon: prefixIconProp,
    accelerator: acceleratorProp,
    onChange,
    label: label5,
    error: error2,
    helperText: helperTextProp,
    hasError,
    sizeVariant = "medium",
    variant = "default",
    fullWidth = true,
    className,
    type = "text",
    placeholder: placeholder3,
    required,
    ...props
  }, ref) => {
    const containerClass = useMemo3(() => inputContainer({ fullWidth }), [fullWidth]);
    const inputBoxClass = useMemo3(
      () => inputBox({
        size: sizeVariant,
        variant: hasError ? "error" : variant,
        hasError: hasError || Boolean(error2)
      }),
      [sizeVariant, variant, hasError, error2]
    );
    const inputClass = useMemo3(() => input({ size: sizeVariant }), [sizeVariant]);
    const [characterCount, setCharacterCount] = useState4(value?.length || 0);
    useEffect3(() => {
      setCharacterCount(value ? value.length : 0);
    }, [value]);
    const handleInputChange = useCallback2(
      (event) => {
        const newValue = event.target.value;
        setCharacterCount(newValue ? newValue.length : 0);
      },
      []
    );
    const handleChange = useCallback2(
      (event) => {
        handleInputChange(event);
        if (onChange) {
          onChange(event.target.value);
        }
      },
      [handleInputChange, onChange]
    );
    const showBottomContainer = statusInfo2 || maxLength || error2 || helperTextProp;
    return /* @__PURE__ */ jsxs12("div", { className: `${containerClass} ${className || ""}`, children: [
      label5 && /* @__PURE__ */ jsxs12("label", { className: inputLabel, children: [
        label5,
        required && /* @__PURE__ */ jsx18("span", { style: { color: xdsVars.colors.contentError, marginLeft: "4px" }, children: "*" })
      ] }),
      /* @__PURE__ */ jsxs12("div", { className: inputBoxClass, children: [
        prefixIconProp && /* @__PURE__ */ jsx18(Icon, { icon: prefixIconProp, iconSize: "xSmall" /* XSmall */ }),
        /* @__PURE__ */ jsx18(
          "input",
          {
            ref,
            className: inputClass,
            maxLength,
            placeholder: placeholder3,
            required,
            style: {
              backgroundColor: "transparent",
              // Add padding to the left when prefix icon is present
              ...prefixIconProp && {
                paddingLeft: "8px"
              },
              // Fix number input spinners
              ...type === "number" && {
                MozAppearance: "textfield"
              }
            },
            type,
            value,
            onChange: handleChange,
            ...props
          }
        ),
        type === "number" && /* @__PURE__ */ jsx18("style", { dangerouslySetInnerHTML: {
          __html: `
                input[type="number"]::-webkit-outer-spin-button,
                input[type="number"]::-webkit-inner-spin-button {
                  -webkit-appearance: none !important;
                  background: transparent !important;
                  margin: 0 !important;
                }
                input[type="number"] {
                  -moz-appearance: textfield !important;
                  background: transparent !important;
                }
              `
        } }),
        acceleratorProp && /* @__PURE__ */ jsx18("div", { className: accelerator, children: acceleratorProp })
      ] }),
      showBottomContainer && /* @__PURE__ */ jsxs12("div", { className: bottomContainer, children: [
        /* @__PURE__ */ jsxs12("div", { style: { flex: 1 }, children: [
          error2 && /* @__PURE__ */ jsx18("div", { className: errorMessage, children: error2 }),
          !error2 && helperTextProp && /* @__PURE__ */ jsx18("div", { className: helperText, children: helperTextProp }),
          !error2 && !helperTextProp && statusInfo2 && /* @__PURE__ */ jsx18("div", { className: statusInfo, children: statusInfo2 })
        ] }),
        maxLength && /* @__PURE__ */ jsxs12("div", { className: characterContainer, children: [
          characterCount,
          "/",
          maxLength
        ] })
      ] })
    ] });
  }
);
TextInput.displayName = "TextInput";

// src/components/Select/Select.css.ts
var container3 = "Select_container__1cv4yqd0";
var dropdownArrowDown = "Select_dropdownArrowDown__1cv4yqd6";
var dropdownArrowUp = "Select_dropdownArrowUp__1cv4yqd7";
var dropdownItem2 = "Select_dropdownItem__1cv4yqda";
var dropdownItemSelected2 = "Select_dropdownItemSelected__1cv4yqdb Select_dropdownItem__1cv4yqda";
var dropdownList2 = "Select_dropdownList__1cv4yqd9";
var dropdownMessage2 = "Select_dropdownMessage__1cv4yqd8";
var error = "Select_error__1cv4yqdf";
var helperText2 = "Select_helperText__1cv4yqdg";
var inputContainer2 = "Select_inputContainer__1cv4yqd3";
var label = "Select_label__1cv4yqd1";
var optionDescription = "Select_optionDescription__1cv4yqde";
var optionInfo2 = "Select_optionInfo__1cv4yqdc";
var optionLabel2 = "Select_optionLabel__1cv4yqdd";
var placeholder = "Select_placeholder__1cv4yqd5";
var requiredIndicator = "Select_requiredIndicator__1cv4yqd2";
var searchContainer = "Select_searchContainer__1cv4yqdh";
var selectedDisplay = "Select_selectedDisplay__1cv4yqd4";

// src/components/Select/Select.tsx
import { jsx as jsx19, jsxs as jsxs13 } from "react/jsx-runtime";
function DropdownContent2({
  loading = false,
  error: error2,
  options,
  selectedValue,
  handleOptionSelect,
  handleItemKeyDown,
  emptyMessage = "No options available",
  searchable = false,
  searchPlaceholder = "Search options...",
  searchValue,
  onSearchChange
}) {
  if (loading) {
    return /* @__PURE__ */ jsx19("div", { className: dropdownMessage2, children: "Loading..." });
  }
  if (error2) {
    return /* @__PURE__ */ jsx19("div", { className: dropdownMessage2, children: error2 });
  }
  const renderSearchField = () => {
    if (!searchable) {
      return null;
    }
    return /* @__PURE__ */ jsx19("div", { className: searchContainer, children: /* @__PURE__ */ jsx19(
      TextInput,
      {
        fullWidth: true,
        placeholder: searchPlaceholder,
        sizeVariant: "small",
        value: searchValue || "",
        onChange: (value) => onSearchChange?.(value)
      }
    ) });
  };
  const renderEmptyMessage = () => /* @__PURE__ */ jsx19("div", { className: dropdownMessage2, children: searchValue ? "No matching options found" : emptyMessage });
  const renderOptionsList = () => {
    if (options.length === 0) {
      return null;
    }
    return /* @__PURE__ */ jsx19("div", { className: dropdownList2, role: "listbox", children: options.map((option) => {
      const isSelected = selectedValue === option.value;
      return /* @__PURE__ */ jsx19(
        "div",
        {
          "aria-selected": isSelected,
          className: isSelected ? dropdownItemSelected2 : dropdownItem2,
          role: "option",
          tabIndex: 0,
          onClick: () => handleOptionSelect(option.value),
          onKeyDown: (e) => handleItemKeyDown(e, option.value),
          children: /* @__PURE__ */ jsxs13("div", { className: optionInfo2, children: [
            /* @__PURE__ */ jsx19("div", { className: optionLabel2, children: option.label }),
            option.description && /* @__PURE__ */ jsx19("div", { className: optionDescription, children: option.description })
          ] })
        },
        option.key || option.value
      );
    }) });
  };
  const hasOptions = options.length > 0;
  return /* @__PURE__ */ jsxs13("div", { children: [
    renderSearchField(),
    !hasOptions ? renderEmptyMessage() : renderOptionsList()
  ] });
}
var Select = forwardRef11(
  // eslint-disable-next-line complexity
  ({
    label: label5,
    title: title3,
    options,
    value,
    onChange,
    placeholder: placeholder3 = "Select an option",
    error: error2,
    helperText: helperText3,
    disabled = false,
    required = false,
    loading = false,
    emptyMessage = "No options available",
    searchable = false,
    searchPlaceholder = "Search options..."
  }, ref) => {
    const [isOpen, setIsOpen] = useState5(false);
    const [searchValue, setSearchValue] = useState5("");
    const containerRef = useRef3(null);
    const uniqueId = useId2();
    const filteredOptions = useMemo4(() => {
      if (!searchable || !searchValue.trim()) {
        return options;
      }
      const searchTerm = searchValue.toLowerCase().trim();
      return options.filter((option) => option.label.toLowerCase().includes(searchTerm) || option.description && option.description.toLowerCase().includes(searchTerm));
    }, [options, searchValue, searchable]);
    const handleSearchChange = (value2) => {
      setSearchValue(value2);
    };
    const handleOptionSelect = (optionValue) => {
      if (onChange) {
        onChange(optionValue);
      }
      setIsOpen(false);
    };
    const handleDropdownToggle = () => {
      if (!disabled) {
        setIsOpen(!isOpen);
      }
    };
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setIsOpen(false);
      }
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        handleDropdownToggle();
      }
    };
    const handleItemKeyDown = (e, optionValue) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        handleOptionSelect(optionValue);
      }
    };
    const selectedOption = options.find((option) => option.value === value);
    const containerId = `select-${uniqueId}`;
    return /* @__PURE__ */ jsxs13("div", { ref: containerRef || ref, className: container3, children: [
      (title3 || label5) && /* @__PURE__ */ jsxs13("label", { className: label, children: [
        title3 || label5,
        required && /* @__PURE__ */ jsx19("span", { className: requiredIndicator, children: " *" })
      ] }),
      /* @__PURE__ */ jsxs13(
        "div",
        {
          "aria-expanded": isOpen,
          "aria-haspopup": "listbox",
          className: inputContainer2,
          id: containerId,
          role: "button",
          tabIndex: disabled ? -1 : 0,
          onClick: handleDropdownToggle,
          onKeyDown: handleKeyDown,
          children: [
            selectedOption ? /* @__PURE__ */ jsx19("div", { className: selectedDisplay, children: selectedOption.label }) : /* @__PURE__ */ jsx19("span", { className: placeholder, children: placeholder3 }),
            /* @__PURE__ */ jsx19("div", { className: isOpen ? dropdownArrowUp : dropdownArrowDown })
          ]
        }
      ),
      /* @__PURE__ */ jsx19(
        Menu,
        {
          dismissBehavior: {
            onEscape: true,
            onClickOutside: true,
            onResize: true
          },
          isOpen: isOpen && !disabled,
          offset: 8,
          showCloseButton: false,
          triggerId: containerId,
          onOpenChange: (open) => !open && setIsOpen(false),
          children: /* @__PURE__ */ jsx19(
            DropdownContent2,
            {
              emptyMessage,
              error: error2,
              handleItemKeyDown,
              handleOptionSelect,
              loading,
              options: filteredOptions,
              searchPlaceholder,
              searchValue,
              searchable,
              selectedValue: value,
              onSearchChange: handleSearchChange
            }
          )
        }
      ),
      error2 && /* @__PURE__ */ jsx19("div", { className: error, children: error2 }),
      helperText3 && !error2 && /* @__PURE__ */ jsx19("div", { className: helperText2, children: helperText3 })
    ] });
  }
);
Select.displayName = "Select";

// src/components/MultiSelect/MultiSelect.tsx
import { useState as useState6, useRef as useRef4, useId as useId3, useMemo as useMemo6 } from "react";

// src/components/Icon/icons/Add.tsx
import { jsx as jsx20, jsxs as jsxs14 } from "react/jsx-runtime";
function SvgAdd({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs14(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx20("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx20("path", { d: "M1664 896v128h-640v640H896v-640H256V896h640V256h128v640h640z" })
      ]
    }
  );
}
var Add_default = SvgAdd;

// src/components/IconButton/IconButton.tsx
import { forwardRef as forwardRef14, memo as memo3 } from "react";

// src/components/Badge/Badge.tsx
import { memo as memo2, forwardRef as forwardRef12, useMemo as useMemo5 } from "react";

// src/components/Badge/Badge.css.ts
import { createRuntimeFn as _7a46811 } from "@vanilla-extract/recipes/createRuntimeFn";
var badgeContainer = _7a46811({ defaultClassName: "Badge__js4abm2 Badge_badgeBaseStyle__js4abm0", variantClassNames: { size: { XSmall: "Badge_badgeContainer_size_XSmall__js4abm3", Small: "Badge_badgeContainer_size_Small__js4abm4", Medium: "Badge_badgeContainer_size_Medium__js4abm5", Large: "Badge_badgeContainer_size_Large__js4abm6", XLarge: "Badge_badgeContainer_size_XLarge__js4abm7" }, variant: { "default": "Badge_badgeContainer_variant_default__js4abm8", success: "Badge_badgeContainer_variant_success__js4abm9", error: "Badge_badgeContainer_variant_error__js4abma", warning: "Badge_badgeContainer_variant_warning__js4abmb", approved: "Badge_badgeContainer_variant_approved__js4abmc", pending: "Badge_badgeContainer_variant_pending__js4abmd" } }, defaultVariants: { size: "Medium", variant: "default" }, compoundVariants: [] });
var badgeIcon = "Badge_badgeIcon__js4abme";
var badgeInteractiveContainer = _7a46811({ defaultClassName: "Badge__js4abmf Badge_badgeInteractiveBaseStyle__js4abm1", variantClassNames: { size: { XSmall: "Badge_badgeInteractiveContainer_size_XSmall__js4abmg", Small: "Badge_badgeInteractiveContainer_size_Small__js4abmh", Medium: "Badge_badgeInteractiveContainer_size_Medium__js4abmi", Large: "Badge_badgeInteractiveContainer_size_Large__js4abmj", XLarge: "Badge_badgeInteractiveContainer_size_XLarge__js4abmk" }, variant: { "default": "Badge_badgeInteractiveContainer_variant_default__js4abml", success: "Badge_badgeInteractiveContainer_variant_success__js4abmm", error: "Badge_badgeInteractiveContainer_variant_error__js4abmn", warning: "Badge_badgeInteractiveContainer_variant_warning__js4abmo", approved: "Badge_badgeInteractiveContainer_variant_approved__js4abmp", pending: "Badge_badgeInteractiveContainer_variant_pending__js4abmq" } }, defaultVariants: { size: "Medium", variant: "default" }, compoundVariants: [] });
var badgeText = "Badge_badgeText__js4abmr";
var srOnly = "Badge_srOnly__js4abms";

// src/components/Badge/Badge.tsx
import { jsx as jsx21 } from "react/jsx-runtime";
var BadgeSize = /* @__PURE__ */ ((BadgeSize2) => {
  BadgeSize2["XSmall"] = "XSmall";
  BadgeSize2["Small"] = "Small";
  BadgeSize2["Medium"] = "Medium";
  BadgeSize2["Large"] = "Large";
  BadgeSize2["XLarge"] = "XLarge";
  return BadgeSize2;
})(BadgeSize || {});
var BadgeVariant = /* @__PURE__ */ ((BadgeVariant2) => {
  BadgeVariant2["Default"] = "default";
  BadgeVariant2["Success"] = "success";
  BadgeVariant2["Error"] = "error";
  BadgeVariant2["Warning"] = "warning";
  BadgeVariant2["Approved"] = "approved";
  BadgeVariant2["Pending"] = "pending";
  return BadgeVariant2;
})(BadgeVariant || {});
var badgeToIconSizeMap = {
  ["XSmall" /* XSmall */]: "xxSmall" /* XXSmall */,
  ["Small" /* Small */]: "xSmall" /* XSmall */,
  ["Medium" /* Medium */]: "small" /* Small */,
  ["Large" /* Large */]: "medium" /* Medium */,
  ["XLarge" /* XLarge */]: "large" /* Large */
};
var mapBadgeSize = (size) => size;
var mapBadgeVariant = (variant) => variant;
var getEffectiveIconSize = (badgeSize, iconSize) => {
  if (iconSize) {
    return iconSize;
  }
  return badgeToIconSizeMap[badgeSize] || "small" /* Small */;
};
var renderIconChildren = (icons, effectiveIconSize, iconClassName) => icons.map((icon2, index) => /* @__PURE__ */ jsx21(
  Icon,
  {
    className: iconClassName ? `${badgeIcon} ${iconClassName}` : badgeIcon,
    icon: icon2,
    iconSize: effectiveIconSize
  },
  `icon-${index}`
));
var renderTextContent = (text2, textClassName) => /* @__PURE__ */ jsx21("span", { className: textClassName ? `${badgeText} ${textClassName}` : badgeText, children: text2 });
var isExternalUrl = (url) => {
  try {
    const urlObj = new URL(url, window.location.origin);
    return urlObj.origin !== window.location.origin;
  } catch {
    return url.startsWith("http://") || url.startsWith("https://") || url.startsWith("mailto:") || url.startsWith("tel:");
  }
};
var getSecurityAttributes = (href, disableAutoSecurity) => {
  if (disableAutoSecurity) {
    return {};
  }
  const isExternal = isExternalUrl(href);
  if (isExternal) {
    return {
      target: "_blank",
      rel: "noopener noreferrer"
    };
  }
  return {};
};
var renderScreenReaderText = (href, disableAutoSecurity) => {
  if (disableAutoSecurity || !isExternalUrl(href)) {
    return null;
  }
  return /* @__PURE__ */ jsx21("span", { className: srOnly, children: "(opens in new tab)" });
};
var BadgeUnmanaged = forwardRef12(
  // eslint-disable-next-line complexity, max-statements
  (props, ref) => {
    const {
      icons,
      text: text2,
      size = "Medium" /* Medium */,
      variant = "default" /* Default */,
      iconSize,
      iconClassName,
      textClassName,
      className,
      ...rest
    } = props;
    const onPress = "onPress" in props ? props.onPress : void 0;
    const href = "href" in props ? props.href : void 0;
    const disableAutoSecurity = "disableAutoSecurity" in props ? props.disableAutoSecurity ?? false : false;
    const securityAttributes = useMemo5(
      () => href ? getSecurityAttributes(href, disableAutoSecurity) : {},
      [href, disableAutoSecurity]
    );
    const screenReaderText = useMemo5(
      () => href ? renderScreenReaderText(href, disableAutoSecurity) : null,
      [href, disableAutoSecurity]
    );
    if ((!icons || icons.length === 0) && !text2) {
      return null;
    }
    if (icons && icons.length > 0 && text2) {
      console.warn("Badge: Both icons and text provided. Only one should be used. Using icons.");
    }
    const effectiveIconSize = getEffectiveIconSize(size, iconSize);
    const isInteractive = Boolean(onPress || href);
    const containerRecipe = isInteractive ? badgeInteractiveContainer : badgeContainer;
    const badgeClassName = containerRecipe({
      size: mapBadgeSize(size),
      variant: mapBadgeVariant(variant)
    });
    const finalClassName = className ? `${badgeClassName} ${className}` : badgeClassName;
    const iconChildren = icons && icons.length > 0 ? renderIconChildren(icons, effectiveIconSize, iconClassName) : null;
    const textContent = text2 ? renderTextContent(text2, textClassName) : null;
    const content4 = [
      ...iconChildren || [],
      textContent,
      screenReaderText
    ].filter(Boolean);
    if (href) {
      const handleClick = onPress ? (_e) => {
        onPress();
      } : void 0;
      return /* @__PURE__ */ jsx21(
        "a",
        {
          ref,
          className: finalClassName,
          href,
          onClick: handleClick,
          ...securityAttributes,
          ...rest,
          children: content4
        }
      );
    }
    if (onPress) {
      return /* @__PURE__ */ jsx21(
        "button",
        {
          ref,
          className: finalClassName,
          type: "button",
          onClick: onPress,
          ...rest,
          children: content4
        }
      );
    }
    return /* @__PURE__ */ jsx21(
      "div",
      {
        ref,
        className: finalClassName,
        ...rest,
        children: content4
      }
    );
  }
);
BadgeUnmanaged.displayName = "BadgeUnmanaged";
var Badge = memo2(BadgeUnmanaged);
Badge.displayName = "Badge";

// src/components/Button/Button.tsx
import { forwardRef as forwardRef13 } from "react";

// src/components/Button/Button.css.ts
import { createRuntimeFn as _7a46812 } from "@vanilla-extract/recipes/createRuntimeFn";
var button = _7a46812({ defaultClassName: "Button__18s2jog1 Button_buttonBaseStyle__18s2jog0", variantClassNames: { buttonType: { Primary: "Button_button_buttonType_Primary__18s2jog2", Secondary: "Button_button_buttonType_Secondary__18s2jog3", Tertiary: "Button_button_buttonType_Tertiary__18s2jog4", Brand: "Button_button_buttonType_Brand__18s2jog5", UserAccent: "Button_button_buttonType_UserAccent__18s2jog6", Danger: "Button_button_buttonType_Danger__18s2jog7" }, buttonSize: { Default: "Button_button_buttonSize_Default__18s2jog8", Action: "Button_button_buttonSize_Action__18s2jog9", Accelerator: "Button_button_buttonSize_Accelerator__18s2joga" }, overlayMode: { Solid: "Button_button_overlayMode_Solid__18s2jogb", SemiTransparent: "Button_button_overlayMode_SemiTransparent__18s2jogc", Acrylic: "Button_button_overlayMode_Acrylic__18s2jogd" }, fullWidth: { true: "Button_button_fullWidth_true__18s2joge" } }, defaultVariants: { buttonType: "Primary", buttonSize: "Default", overlayMode: "Solid" }, compoundVariants: [] });

// src/components/Button/Button.tsx
import { jsx as jsx22, jsxs as jsxs15 } from "react/jsx-runtime";
var ButtonSize = /* @__PURE__ */ ((ButtonSize2) => {
  ButtonSize2[ButtonSize2["Default"] = 0] = "Default";
  ButtonSize2[ButtonSize2["Action"] = 1] = "Action";
  ButtonSize2[ButtonSize2["Accelerator"] = 2] = "Accelerator";
  return ButtonSize2;
})(ButtonSize || {});
var ButtonType = /* @__PURE__ */ ((ButtonType2) => {
  ButtonType2["Primary"] = "Primary";
  ButtonType2["Secondary"] = "Secondary";
  ButtonType2["Tertiary"] = "Tertiary";
  ButtonType2["Brand"] = "Brand";
  ButtonType2["UserAccent"] = "UserAccent";
  ButtonType2["Danger"] = "Danger";
  return ButtonType2;
})(ButtonType || {});
var OverlayMode = /* @__PURE__ */ ((OverlayMode2) => {
  OverlayMode2["Solid"] = "Solid";
  OverlayMode2["SemiTransparent"] = "SemiTransparent";
  OverlayMode2["Acrylic"] = "Acrylic";
  return OverlayMode2;
})(OverlayMode || {});
var mapButtonSize = (buttonSize) => {
  switch (buttonSize) {
    case 1 /* Action */:
      return "Action";
    case 2 /* Accelerator */:
      return "Accelerator";
    default:
      return "Default";
  }
};
var mapOverlayMode = (overlayMode) => {
  switch (overlayMode) {
    case "SemiTransparent" /* SemiTransparent */:
      return "SemiTransparent";
    case "Acrylic" /* Acrylic */:
      return "Acrylic";
    default:
      return "Solid";
  }
};
var createTextStyle = (numberOfLines, labelStyle) => ({
  overflow: "hidden",
  textOverflow: "ellipsis",
  display: numberOfLines === 1 ? "block" : "-webkit-box",
  WebkitLineClamp: numberOfLines > 1 ? numberOfLines : void 0,
  WebkitBoxOrient: numberOfLines > 1 ? "vertical" : void 0,
  fontFamily: xdsVars.fonts.bahnschrift,
  ...labelStyle
});
var Button = forwardRef13(
  ({
    label: label5,
    numberOfLines = 1,
    buttonType = "Primary" /* Primary */,
    buttonSize = 0 /* Default */,
    overlayMode = "Solid" /* Solid */,
    fullWidth = false,
    labelStyle,
    childrenStyle,
    children,
    className,
    ...props
  }, ref) => {
    const textStyle = createTextStyle(numberOfLines, labelStyle);
    const buttonClasses = button({
      buttonType,
      buttonSize: mapButtonSize(buttonSize),
      overlayMode: mapOverlayMode(overlayMode),
      fullWidth
    });
    const combinedClassName = className ? `${buttonClasses} ${className}` : buttonClasses;
    return /* @__PURE__ */ jsxs15(
      "button",
      {
        ref,
        className: combinedClassName,
        ...props,
        children: [
          label5 && /* @__PURE__ */ jsx22("span", { style: textStyle, children: label5 }),
          children && /* @__PURE__ */ jsx22("span", { style: childrenStyle, children })
        ]
      }
    );
  }
);
Button.displayName = "Button";

// src/components/IconButton/IconButton.css.ts
import { createRuntimeFn as _7a46813 } from "@vanilla-extract/recipes/createRuntimeFn";
var iconButton = _7a46813({ defaultClassName: "Button_buttonBaseStyle__18s2jog0 IconButton_iconButtonBaseStyle__va5qjb0", variantClassNames: { buttonType: { Primary: "IconButton_iconButton_buttonType_Primary__va5qjb2", Secondary: "IconButton_iconButton_buttonType_Secondary__va5qjb3", Tertiary: "IconButton_iconButton_buttonType_Tertiary__va5qjb4", Brand: "IconButton_iconButton_buttonType_Brand__va5qjb5", UserAccent: "IconButton_iconButton_buttonType_UserAccent__va5qjb6", Danger: "IconButton_iconButton_buttonType_Danger__va5qjb7" }, buttonSize: { XXSmall: "IconButton_iconButton_buttonSize_XXSmall__va5qjb8", XSmall: "IconButton_iconButton_buttonSize_XSmall__va5qjb9", Small: "IconButton_iconButton_buttonSize_Small__va5qjba", Default: "IconButton_iconButton_buttonSize_Default__va5qjbb", Medium: "IconButton_iconButton_buttonSize_Medium__va5qjbc", Action: "IconButton_iconButton_buttonSize_Action__va5qjbd", Large: "IconButton_iconButton_buttonSize_Large__va5qjbe", XLarge: "IconButton_iconButton_buttonSize_XLarge__va5qjbf", XXLarge: "IconButton_iconButton_buttonSize_XXLarge__va5qjbg" }, overlayMode: { Solid: "IconButton_iconButton_overlayMode_Solid__va5qjbh", SemiTransparent: "IconButton_iconButton_overlayMode_SemiTransparent__va5qjbi", Acrylic: "IconButton_iconButton_overlayMode_Acrylic__va5qjbj" }, showBackground: { true: "IconButton_iconButton_showBackground_true__va5qjbk", false: "IconButton_iconButton_showBackground_false__va5qjbl" } }, defaultVariants: { buttonType: "Primary", buttonSize: "Default", overlayMode: "Solid", showBackground: true }, compoundVariants: [] });

// src/components/IconButton/IconButton.tsx
import { jsx as jsx23, jsxs as jsxs16 } from "react/jsx-runtime";
var IconButtonSize = /* @__PURE__ */ ((IconButtonSize2) => {
  IconButtonSize2["XXSmall"] = "XXSmall";
  IconButtonSize2["XSmall"] = "XSmall";
  IconButtonSize2["Small"] = "Small";
  IconButtonSize2["Default"] = "Default";
  IconButtonSize2["Medium"] = "Medium";
  IconButtonSize2["Action"] = "Action";
  IconButtonSize2["Large"] = "Large";
  IconButtonSize2["XLarge"] = "XLarge";
  IconButtonSize2["XXLarge"] = "XXLarge";
  return IconButtonSize2;
})(IconButtonSize || {});
var buttonToIconSizeMap = {
  ["XXSmall" /* XXSmall */]: "xxSmall" /* XXSmall */,
  ["XSmall" /* XSmall */]: "xSmall" /* XSmall */,
  ["Small" /* Small */]: "small" /* Small */,
  ["Default" /* Default */]: "medium" /* Medium */,
  ["Medium" /* Medium */]: "medium" /* Medium */,
  ["Action" /* Action */]: "large" /* Large */,
  ["Large" /* Large */]: "large" /* Large */,
  ["XLarge" /* XLarge */]: "xLarge" /* XLarge */,
  ["XXLarge" /* XXLarge */]: "xxLarge" /* XXLarge */
};
var getEffectiveIconSize2 = (buttonSize, iconSize) => {
  if (iconSize) {
    return iconSize;
  }
  return buttonToIconSizeMap[buttonSize] || "medium" /* Medium */;
};
var mapButtonSize2 = (buttonSize) => buttonSize;
var mapOverlayMode2 = (overlayMode) => {
  switch (overlayMode) {
    case "SemiTransparent" /* SemiTransparent */:
      return "SemiTransparent";
    case "Acrylic" /* Acrylic */:
      return "Acrylic";
    default:
      return "Solid";
  }
};
var IconButtonUnmanaged = forwardRef14(
  // eslint-disable-next-line complexity
  ({
    badgeIconSize = "xxSmall" /* XXSmall */,
    badgeIcons = [],
    badgeStyle,
    buttonSize = "Default" /* Default */,
    buttonType = "Primary" /* Primary */,
    className,
    enableBadge = false,
    icon: icon2,
    iconSize = "medium" /* Medium */,
    iconStyle,
    overlayMode = "Solid" /* Solid */,
    showBackground = true,
    ...rest
  }, ref) => {
    const effectiveIconSize = getEffectiveIconSize2(buttonSize, iconSize);
    const buttonClassName = iconButton({
      buttonType,
      buttonSize: mapButtonSize2(buttonSize),
      overlayMode: mapOverlayMode2(overlayMode),
      showBackground
    });
    return /* @__PURE__ */ jsxs16(
      "button",
      {
        ref,
        className: className ? `${buttonClassName} ${className}` : buttonClassName,
        ...rest,
        children: [
          icon2 && /* @__PURE__ */ jsx23(Icon, { icon: icon2, iconSize: effectiveIconSize, style: iconStyle }),
          enableBadge && badgeIcons.length > 0 && /* @__PURE__ */ jsx23(Badge, { iconSize: badgeIconSize, icons: badgeIcons, style: badgeStyle })
        ]
      }
    );
  }
);
IconButtonUnmanaged.displayName = "IconButtonUnmanaged";
var IconButton = memo3(IconButtonUnmanaged);
IconButton.displayName = "IconButton";

// src/components/MultiSelect/MultiSelect.css.ts
var checkbox = "MultiSelect_checkbox__rh6adfe";
var checkboxInput = "MultiSelect_checkboxInput__rh6adff";
var container4 = "MultiSelect_container__rh6adf0";
var dropdownArrowDown2 = "MultiSelect_dropdownArrowDown__rh6adf8";
var dropdownArrowUp2 = "MultiSelect_dropdownArrowUp__rh6adf9";
var dropdownItem3 = "MultiSelect_dropdownItem__rh6adfc";
var dropdownItemSelected3 = "MultiSelect_dropdownItemSelected__rh6adfd MultiSelect_dropdownItem__rh6adfc";
var dropdownList3 = "MultiSelect_dropdownList__rh6adfb";
var dropdownMessage3 = "MultiSelect_dropdownMessage__rh6adfa";
var emptyMessageWithHint = "MultiSelect_emptyMessageWithHint__rh6adfn";
var inputContainer3 = "MultiSelect_inputContainer__rh6adf2";
var label2 = "MultiSelect_label__rh6adf1";
var optionChip = "MultiSelect_optionChip__rh6adf4";
var optionChipRemove = "MultiSelect_optionChipRemove__rh6adf6";
var optionChipText = "MultiSelect_optionChipText__rh6adf5";
var optionDescription2 = "MultiSelect_optionDescription__rh6adfi";
var optionGroup = "MultiSelect_optionGroup__rh6adfk";
var optionGroupHeader = "MultiSelect_optionGroupHeader__rh6adfl";
var optionGroupItems = "MultiSelect_optionGroupItems__rh6adfm";
var optionInfo3 = "MultiSelect_optionInfo__rh6adfg";
var optionLabel3 = "MultiSelect_optionLabel__rh6adfh";
var placeholder2 = "MultiSelect_placeholder__rh6adf7";
var searchContainer2 = "MultiSelect_searchContainer__rh6adfj";
var selectedOptions = "MultiSelect_selectedOptions__rh6adf3";

// src/components/MultiSelect/MultiSelect.tsx
import { jsx as jsx24, jsxs as jsxs17 } from "react/jsx-runtime";
function DropdownContent3({
  loading,
  error: error2,
  groupedOptions,
  ungroupedOptions,
  selectedValues,
  handleOptionToggle,
  handleItemKeyDown,
  emptyMessage = "No options available",
  showCheckboxes = false,
  searchable = false,
  searchPlaceholder = "Search options...",
  searchValue,
  onSearchChange,
  allowCustomCreate = false,
  validateCustomOption,
  onCustomCreate,
  onSearchKeyDown
}) {
  if (loading) {
    return /* @__PURE__ */ jsx24("div", { className: dropdownMessage3, children: "Loading..." });
  }
  if (error2) {
    return /* @__PURE__ */ jsx24("div", { className: dropdownMessage3, children: error2 });
  }
  const renderSearchField = () => {
    if (!searchable) {
      return null;
    }
    const validation = allowCustomCreate && validateCustomOption && searchValue?.trim() ? validateCustomOption(searchValue) : null;
    const canAdd = validation?.isValid && validation.key && validation.value;
    return /* @__PURE__ */ jsx24("div", { className: searchContainer2, children: /* @__PURE__ */ jsxs17("div", { style: { display: "flex", gap: "8px", alignItems: "center" }, children: [
      /* @__PURE__ */ jsx24("div", { style: { flex: 1 }, children: /* @__PURE__ */ jsx24(
        TextInput,
        {
          fullWidth: true,
          placeholder: searchPlaceholder,
          sizeVariant: "small",
          value: searchValue || "",
          onChange: (value) => onSearchChange?.(value),
          onKeyDown: onSearchKeyDown
        }
      ) }),
      allowCustomCreate && /* @__PURE__ */ jsx24(
        IconButton,
        {
          buttonSize: "XSmall" /* XSmall */,
          disabled: !canAdd,
          icon: Add_default,
          iconSize: "xxSmall" /* XXSmall */,
          style: { borderRadius: "50%" },
          onClick: () => {
            if (canAdd && validation && validation.key && validation.value) {
              onCustomCreate?.(validation.key, validation.value);
            }
          }
        }
      )
    ] }) });
  };
  const renderEmptyMessage = () => {
    if (!allowCustomCreate) {
      return /* @__PURE__ */ jsx24("div", { className: dropdownMessage3, children: searchValue ? "No matching options found" : emptyMessage });
    }
    const validation = searchValue?.trim() && validateCustomOption ? validateCustomOption(searchValue) : null;
    const canAdd = validation?.isValid && validation.key && validation.value;
    const message2 = searchValue ? "No matching options found" : emptyMessage;
    let hint = "";
    if (searchValue?.trim()) {
      if (canAdd) {
        hint = "Add custom value";
      } else {
        hint = 'Use format "key: value" to add custom value';
      }
    } else {
      hint = 'Use format "key: value" to add custom value';
    }
    return /* @__PURE__ */ jsxs17("div", { className: emptyMessageWithHint, children: [
      /* @__PURE__ */ jsx24("div", { children: message2 }),
      /* @__PURE__ */ jsx24("div", { style: { marginTop: "4px", fontSize: "12px", opacity: 0.8 }, children: hint })
    ] });
  };
  const renderOption = (option) => {
    const isSelected = selectedValues.includes(option.value);
    return /* @__PURE__ */ jsxs17(
      "div",
      {
        "aria-selected": isSelected,
        className: isSelected ? dropdownItemSelected3 : dropdownItem3,
        role: "option",
        tabIndex: 0,
        onClick: () => handleOptionToggle(option.value),
        onKeyDown: (e) => handleItemKeyDown(e, option.value),
        children: [
          showCheckboxes && /* @__PURE__ */ jsx24("div", { className: checkbox, children: /* @__PURE__ */ jsx24(
            "input",
            {
              checked: isSelected,
              className: checkboxInput,
              tabIndex: -1,
              type: "checkbox",
              onChange: () => handleOptionToggle(option.value)
            }
          ) }),
          /* @__PURE__ */ jsxs17("div", { className: optionInfo3, children: [
            /* @__PURE__ */ jsx24("div", { className: optionLabel3, children: option.label }),
            option.description && /* @__PURE__ */ jsx24("div", { className: optionDescription2, children: option.description })
          ] })
        ]
      },
      option.id
    );
  };
  const renderOptionsList = () => {
    const hasGroupedOptions = groupedOptions.length > 0;
    const hasUngroupedOptions = ungroupedOptions.length > 0;
    if (!hasGroupedOptions && !hasUngroupedOptions) {
      return null;
    }
    return /* @__PURE__ */ jsxs17("div", { className: dropdownList3, role: "listbox", children: [
      groupedOptions.map((group) => /* @__PURE__ */ jsxs17("div", { className: optionGroup, children: [
        /* @__PURE__ */ jsx24("div", { className: optionGroupHeader, children: group.label }),
        /* @__PURE__ */ jsx24("div", { className: optionGroupItems, children: group.options.map(renderOption) })
      ] }, group.id)),
      ungroupedOptions.map(renderOption)
    ] });
  };
  const hasOptions = groupedOptions.length > 0 || ungroupedOptions.length > 0;
  return /* @__PURE__ */ jsxs17("div", { children: [
    renderSearchField(),
    !hasOptions ? renderEmptyMessage() : renderOptionsList()
  ] });
}
function MultiSelect({
  options,
  selectedValues,
  onSelectionChange,
  placeholder: placeholder3 = "No items selected",
  label: label5,
  title: title3,
  disabled = false,
  loading = false,
  error: error2,
  emptyMessage = "No options available",
  showCheckboxes = false,
  searchable = false,
  searchPlaceholder = "Search options...",
  allowCustomCreate = false,
  validateCustomOption,
  onCustomOptionCreate
}) {
  const [isOpen, setIsOpen] = useState6(false);
  const [searchValue, setSearchValue] = useState6("");
  const containerRef = useRef4(null);
  const { groupedOptions, ungroupedOptions } = useMemo6(() => {
    const groupMap = /* @__PURE__ */ new Map();
    const ungrouped = [];
    options.forEach((option) => {
      if (option.group) {
        if (!groupMap.has(option.group)) {
          groupMap.set(option.group, []);
        }
        groupMap.get(option.group)?.push(option);
      } else {
        ungrouped.push(option);
      }
    });
    const groups = Array.from(groupMap.entries()).map(([groupName, groupOptions]) => ({
      id: groupName,
      label: groupName,
      options: groupOptions
    }));
    return { groupedOptions: groups, ungroupedOptions: ungrouped };
  }, [options]);
  const { filteredGroupedOptions, filteredUngroupedOptions } = useMemo6(() => {
    if (!searchable || !searchValue.trim()) {
      return { filteredGroupedOptions: groupedOptions, filteredUngroupedOptions: ungroupedOptions };
    }
    const searchTerm = searchValue.toLowerCase().trim();
    const colonIndex = searchTerm.indexOf(":");
    const hasColon = colonIndex > 0;
    let searchKey = "";
    let searchValuePart = "";
    let isKeyOnlyPattern = false;
    let isKeyValuePattern = false;
    if (hasColon) {
      searchKey = searchTerm.substring(0, colonIndex).trim();
      searchValuePart = searchTerm.substring(colonIndex + 1).trim();
      isKeyOnlyPattern = searchValuePart === "";
      isKeyValuePattern = searchValuePart !== "";
    }
    const filterOption = (option) => {
      const standardMatch = option.label.toLowerCase().includes(searchTerm) || option.description && option.description.toLowerCase().includes(searchTerm);
      if (isKeyOnlyPattern && option.group) {
        const groupMatch = option.group.toLowerCase().includes(searchKey);
        return standardMatch || groupMatch;
      }
      if (isKeyValuePattern && option.group) {
        const groupMatch = option.group.toLowerCase().includes(searchKey);
        const labelMatch = option.label.toLowerCase().includes(searchValuePart);
        const exactGroupLabelMatch = groupMatch && labelMatch;
        return standardMatch || exactGroupLabelMatch;
      }
      return standardMatch;
    };
    const filteredGroups = groupedOptions.map((group) => {
      const groupHeaderMatches = group.label.toLowerCase().includes(searchTerm);
      if (groupHeaderMatches) {
        return group;
      }
      if (isKeyOnlyPattern && group.label.toLowerCase().includes(searchKey)) {
        return group;
      }
      if (isKeyValuePattern && group.label.toLowerCase().includes(searchKey)) {
        return {
          ...group,
          options: group.options.filter((option) => option.label.toLowerCase().includes(searchValuePart))
        };
      }
      return {
        ...group,
        options: group.options.filter(filterOption)
      };
    }).filter((group) => group.options.length > 0);
    const filteredUngrouped = ungroupedOptions.filter(filterOption);
    return { filteredGroupedOptions: filteredGroups, filteredUngroupedOptions: filteredUngrouped };
  }, [groupedOptions, ungroupedOptions, searchValue, searchable]);
  const handleSearchChange = (value) => {
    setSearchValue(value);
  };
  const handleCustomOptionCreate = (key, value) => {
    onCustomOptionCreate?.(key, value);
    setSearchValue("");
  };
  const handleSearchKeyDown = (e) => {
    if (e.key === "Enter" && allowCustomCreate && searchValue?.trim() && validateCustomOption) {
      const validation = validateCustomOption(searchValue);
      if (validation.isValid && validation.key && validation.value) {
        e.preventDefault();
        handleCustomOptionCreate(validation.key, validation.value);
      }
    }
  };
  const handleOptionToggle = (value) => {
    const isSelected = selectedValues.includes(value);
    const newValues = isSelected ? selectedValues.filter((v) => v !== value) : [...selectedValues, value];
    onSelectionChange(newValues);
  };
  const handleRemoveOption = (value) => {
    onSelectionChange(selectedValues.filter((v) => v !== value));
  };
  const handleDropdownToggle = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };
  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      setIsOpen(false);
    }
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleDropdownToggle();
    }
  };
  const handleItemKeyDown = (e, value) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleOptionToggle(value);
    }
  };
  const getSelectedLabels = () => selectedValues.map((value) => {
    const option = options.find((opt) => opt.value === value);
    if (!option) {
      if (value.includes(":")) {
        const [key, val] = value.split(":");
        return `${key}: ${val}`;
      }
      return value;
    }
    return option.group ? `${option.group}: ${option.label}` : option.label;
  });
  const selectedLabels = getSelectedLabels();
  const containerId = useId3();
  return /* @__PURE__ */ jsxs17("div", { ref: containerRef, className: container4, children: [
    (title3 || label5) && /* @__PURE__ */ jsx24("label", { className: label2, children: title3 || label5 }),
    /* @__PURE__ */ jsxs17(
      "div",
      {
        "aria-expanded": isOpen,
        "aria-haspopup": "listbox",
        className: inputContainer3,
        id: containerId,
        role: "button",
        tabIndex: disabled ? -1 : 0,
        onClick: handleDropdownToggle,
        onKeyDown: handleKeyDown,
        children: [
          selectedLabels.length > 0 ? /* @__PURE__ */ jsx24("div", { className: selectedOptions, children: selectedLabels.map((label6, index) => {
            const value = selectedValues[index];
            return /* @__PURE__ */ jsxs17("div", { className: optionChip, children: [
              /* @__PURE__ */ jsx24("span", { className: optionChipText, children: label6 }),
              /* @__PURE__ */ jsx24(
                "button",
                {
                  "aria-label": `Remove ${label6}`,
                  className: optionChipRemove,
                  disabled,
                  type: "button",
                  onClick: (e) => {
                    e.stopPropagation();
                    handleRemoveOption(value);
                  },
                  children: "\xD7"
                }
              )
            ] }, value);
          }) }) : /* @__PURE__ */ jsx24("span", { className: placeholder2, children: placeholder3 }),
          /* @__PURE__ */ jsx24("div", { className: isOpen ? dropdownArrowUp2 : dropdownArrowDown2 })
        ]
      }
    ),
    /* @__PURE__ */ jsx24(
      Menu,
      {
        dismissBehavior: {
          onEscape: true,
          onClickOutside: true,
          onResize: true
        },
        isOpen: isOpen && !disabled,
        offset: 8,
        showCloseButton: false,
        triggerId: containerId,
        onOpenChange: (open) => !open && setIsOpen(false),
        children: /* @__PURE__ */ jsx24(
          DropdownContent3,
          {
            allowCustomCreate,
            emptyMessage,
            error: error2,
            groupedOptions: filteredGroupedOptions,
            handleItemKeyDown,
            handleOptionToggle,
            loading,
            searchPlaceholder,
            searchValue,
            searchable,
            selectedValues,
            showCheckboxes,
            ungroupedOptions: filteredUngroupedOptions,
            validateCustomOption,
            onCustomCreate: handleCustomOptionCreate,
            onSearchChange: handleSearchChange,
            onSearchKeyDown: handleSearchKeyDown
          }
        )
      }
    )
  ] });
}

// src/components/Icon/icons/AbxyButtonBaseLowerLeft.tsx
import { jsx as jsx25, jsxs as jsxs18 } from "react/jsx-runtime";
function SvgAbxyButtonBaseLowerLeft({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs18(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx25("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx25("path", { d: "M1088 384q119 0 224 45t183 124 123 183 46 224q0 119-45 224t-124 183-183 123-224 46H512V960q0-119 45-224t124-183 183-123 224-46zm0 1024q93 0 174-35t142-96 96-142 36-175q0-93-35-174t-96-142-142-96-175-36q-93 0-174 35t-142 96-96 142-36 175v256l192 192h256z" })
      ]
    }
  );
}
var AbxyButtonBaseLowerLeft_default = SvgAbxyButtonBaseLowerLeft;

// src/components/Icon/icons/AbxyButtonBaseLowerRight.tsx
import { jsx as jsx26, jsxs as jsxs19 } from "react/jsx-runtime";
function SvgAbxyButtonBaseLowerRight({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs19(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx26("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx26("path", { d: "M1088 384q119 0 224 45t183 124 123 183 46 224v576h-576q-119 0-224-45t-183-124-123-183-46-224q0-119 45-224t124-183 183-123 224-46zm448 832V960q0-93-35-174t-96-142-142-96-175-36q-93 0-174 35t-142 96-96 142-36 175q0 93 35 174t96 142 142 96 175 36h256l192-192z" })
      ]
    }
  );
}
var AbxyButtonBaseLowerRight_default = SvgAbxyButtonBaseLowerRight;

// src/components/Icon/icons/AbxyButtonBaseTopLeft.tsx
import { jsx as jsx27, jsxs as jsxs20 } from "react/jsx-runtime";
function SvgAbxyButtonBaseTopLeft({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs20(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx27("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx27("path", { d: "M1088 384q119 0 224 45t183 124 123 183 46 224q0 119-45 224t-124 183-183 123-224 46q-119 0-224-45t-183-124-123-183-46-224V384h576zm0 1024q93 0 174-35t142-96 96-142 36-175q0-93-35-174t-96-142-142-96-175-36H832L640 704v256q0 93 35 174t96 142 142 96 175 36z" })
      ]
    }
  );
}
var AbxyButtonBaseTopLeft_default = SvgAbxyButtonBaseTopLeft;

// src/components/Icon/icons/AbxyButtonBaseTopRight.tsx
import { jsx as jsx28, jsxs as jsxs21 } from "react/jsx-runtime";
function SvgAbxyButtonBaseTopRight({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs21(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx28("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx28("path", { d: "M1664 384v576q0 119-45 224t-124 183-183 123-224 46q-119 0-224-45t-183-124-123-183-46-224q0-119 45-224t124-183 183-123 224-46h576zm-128 320l-192-192h-256q-93 0-174 35t-142 96-96 142-36 175q0 93 35 174t96 142 142 96 175 36q93 0 174-35t142-96 96-142 36-175V704z" })
      ]
    }
  );
}
var AbxyButtonBaseTopRight_default = SvgAbxyButtonBaseTopRight;

// src/components/Icon/icons/AbxydlSet.tsx
import { jsx as jsx29, jsxs as jsxs22 } from "react/jsx-runtime";
function SvgAbxydlSet({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs22(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx29("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx29("path", { d: "M960 640q-66 0-124-25t-102-68-69-102-25-125q0-66 25-124t68-101 102-69T960 0q66 0 124 25t101 69 69 102 26 124q0 66-25 124t-69 102-102 69-124 25zm0-512q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15zm0 1152q66 0 124 25t101 69 69 102 26 124q0 66-25 124t-69 102-102 69-124 25q-66 0-124-25t-102-68-69-102-25-125q0-66 25-124t68-101 102-69 125-26zm0 512q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15zm640-1152q66 0 124 25t101 69 69 102 26 124q0 66-25 124t-69 102-102 69-124 25q-66 0-124-25t-102-68-69-102-25-125q0-66 25-124t68-101 102-69 125-26zm0 512q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15zM320 640q66 0 124 25t101 69 69 102 26 124q0 66-25 124t-69 102-102 69-124 25q-66 0-124-25t-102-68-69-102T0 960q0-66 25-124t68-101 102-69 125-26zm0 512q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15z" })
      ]
    }
  );
}
var AbxydlSet_default = SvgAbxydlSet;

// src/components/Icon/icons/Accept.tsx
import { jsx as jsx30, jsxs as jsxs23 } from "react/jsx-runtime";
function SvgAccept({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs23(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx30("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx30("path", { d: "M640 1755L19 1133l90-90 531 531L1939 275l90 90L640 1755z" })
      ]
    }
  );
}
var Accept_default = SvgAccept;

// src/components/Icon/icons/AccessoriesApp.tsx
import { jsx as jsx31, jsxs as jsxs24 } from "react/jsx-runtime";
function SvgAccessoriesApp({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs24(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx31("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx31("path", { d: "M1024 320q-44 0-87-3t-87-10q-17-2-43-7t-57-14-62-21-56-27-40-35-16-43q0-23 15-42t41-35 56-28 61-20 57-14 44-8q43-7 86-10t88-3q44 0 87 3t87 10q17 2 43 7t57 14 62 21 56 27 40 35 16 43q0 24-15 43t-41 34-56 28-61 20-57 14-44 8q-43 7-86 10t-88 3zm0 448q-88 0-175-8t-174-25q-45-9-102-24t-119-39-119-55-105-70-74-88-28-107q0-40 15-75t39-67 54-56 63-46q-18 20-30 46t-13 54q0 43 25 79t65 65 90 51 102 39 97 28 78 16q78 14 155 20t156 6q78 0 155-6t156-20q32-6 78-16t97-27 101-39 91-52 65-65 25-79q0-28-12-54t-31-46q31 20 62 45t55 57 39 66 15 76q0 58-28 106t-74 88-104 71-120 54-119 39-102 25q-87 17-174 25t-175 8zm512 444q43 11 97 28t112 42 111 57 97 71 69 87 26 103q0 62-32 114t-84 95-119 76-134 58-132 41-111 26q-103 20-205 29t-207 9q-104 0-206-9t-206-29q-47-9-111-25t-132-42-134-58-118-76-85-95-32-114q0-55 26-102t68-87 97-72 112-56 111-42 98-29v43q-21 11-43 26t-42 35-31 43-12 49q0 37 21 67t56 55 78 44 86 33 83 23 67 14q62 11 124 15t125 5q63 0 125-4t124-16q27-4 66-13t83-23 87-33 77-44 56-55 22-68q0-26-12-49t-31-42-41-35-44-27v-43zM512 855q125 38 253 55t259 18q131 0 259-17t253-56v169q0 29-18 52t-47 42-66 33-72 25-68 17-52 10q-48 7-94 10t-95 3q-48 0-94-3t-95-10q-21-3-52-9t-68-17-72-25-65-33-48-42-18-53V855z" })
      ]
    }
  );
}
var AccessoriesApp_default = SvgAccessoriesApp;

// src/components/Icon/icons/AccountHacked.tsx
import { jsx as jsx32, jsxs as jsxs25 } from "react/jsx-runtime";
function SvgAccountHacked({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs25(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx32("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx32("path", { d: "M1792 896v1152H256V896h1152V512q0-82-29-152t-80-122-122-81-153-29q-82 0-152 29t-122 80-81 122-29 153H512q0-108 39-201t109-163T822 40t202-40q108 0 201 39t163 109 108 162 40 202v384h256zm-128 128h-509l-114 183 265 265-301 301-90-90 211-211-247-247 126-201H384v896h1280v-896z" })
      ]
    }
  );
}
var AccountHacked_default = SvgAccountHacked;

// src/components/Icon/icons/AchievementLocked.tsx
import { jsx as jsx33, jsxs as jsxs26 } from "react/jsx-runtime";
function SvgAchievementLocked({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs26(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx33("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx33("path", { d: "M1152 1920H256v-128h128v-256h384v-133q-74-10-139-44t-116-85-83-117-42-140q-56-11-104-40t-82-70-54-94-20-110V256h256V128h896v128h256v447q0 57-19 109t-54 94-83 71-104 40q-9 74-42 140t-83 117-115 85-140 44v133h256v128H512v128h640v128zm128-1036q28-10 52-28t40-43 26-52 10-58V384h-128v500zM384 384H256v319q0 30 9 58t26 53 40 42 53 28V384zm128 576q0 66 25 124t68 102 102 69 125 25q66 0 124-25t101-68 69-102 26-125V256H512v704zm1536 448v640h-768v-640h128v-128q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100v128h128zm-512 0h256v-128q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50v128zm384 128h-512v384h512v-384z" })
      ]
    }
  );
}
var AchievementLocked_default = SvgAchievementLocked;

// src/components/Icon/icons/Achievements.tsx
import { jsx as jsx34, jsxs as jsxs27 } from "react/jsx-runtime";
function SvgAchievements({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs27(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx34("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx34("path", { d: "M1664 256v447q0 57-19 109t-54 94-83 71-104 40q-9 75-41 141t-83 117-116 84-140 45v132h384v256h128v128H384v-128h128v-256h384v-132q-75-11-140-44t-115-85-83-117-42-141q-56-11-104-40t-82-70-54-94-20-110V256h256V128h896v128h256zM640 1664v128h640v-128H640zM384 703q0 30 9 58t26 53 40 42 53 28V384H384v319zm576 577q66 0 124-25t101-68 69-102 26-125V256H640v704q0 66 25 124t68 102 102 69 125 25zm576-896h-128v500q28-10 52-28t40-43 26-52 10-58V384z" })
      ]
    }
  );
}
var Achievements_default = SvgAchievements;

// src/components/Icon/icons/ActionCenter.tsx
import { jsx as jsx35, jsxs as jsxs28 } from "react/jsx-runtime";
function SvgActionCenter({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs28(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx35("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx35("path", { d: "M0 0h2048v1664h-640l-384 384-384-384H0V0zm1920 1536V128H128v1408h565l331 331 331-331h565zm-256-768v128H384V768h1280zm0-384v128H384V384h1280zm-512 768v128H384v-128h768z" })
      ]
    }
  );
}
var ActionCenter_default = SvgActionCenter;

// src/components/Icon/icons/ActionCenter2.tsx
import { jsx as jsx36, jsxs as jsxs29 } from "react/jsx-runtime";
function SvgActionCenter2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs29(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx36("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx36("path", { d: "M0 0h2048v1664h-640l-384 384-384-384H0V0zm1920 1536V128H128v1408h565l331 331 331-331h565z" })
      ]
    }
  );
}
var ActionCenter2_default = SvgActionCenter2;

// src/components/Icon/icons/ActionCenterMirrored.tsx
import { jsx as jsx37, jsxs as jsxs30 } from "react/jsx-runtime";
function SvgActionCenterMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs30(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx37("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx37("path", { d: "M2048 0H0v1664h640l384 384 384-384h640V0zM128 1536V128h1792v1408h-565l-331 331-331-331H128zm256-768v128h1280V768H384zm0-384v128h1280V384H384zm512 768v128h768v-128H896z" })
      ]
    }
  );
}
var ActionCenterMirrored_default = SvgActionCenterMirrored;

// src/components/Icon/icons/ActionCenterNotification.tsx
import { jsx as jsx38, jsxs as jsxs31 } from "react/jsx-runtime";
function SvgActionCenterNotification({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs31(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx38("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx38("path", { d: "M0 0h2048v1664h-640l-384 384-384-384H0V0zm1664 768H384v128h1280V768zm0-384H384v128h1280V384zm-512 768H384v128h768v-128z" })
      ]
    }
  );
}
var ActionCenterNotification_default = SvgActionCenterNotification;

// src/components/Icon/icons/ActionCenterNotificationMirrored.tsx
import { jsx as jsx39, jsxs as jsxs32 } from "react/jsx-runtime";
function SvgActionCenterNotificationMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs32(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx39("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx39("path", { d: "M2048 0H0v1664h640l384 384 384-384h640V0zM384 768h1280v128H384V768zm0-384h1280v128H384V384zm512 768h768v128H896v-128z" })
      ]
    }
  );
}
var ActionCenterNotificationMirrored_default = SvgActionCenterNotificationMirrored;

// src/components/Icon/icons/ActionCenterQuiet.tsx
import { jsx as jsx40, jsxs as jsxs33 } from "react/jsx-runtime";
function SvgActionCenterQuiet({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs33(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx40("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx40("path", { d: "M2048 0v1189q-28-31-60-57t-68-49V128H128v1408h565l422 421-91 91-384-384H0V0h2048zm-403 1157q85 8 159 46t128 97 85 137 31 163q0 93-35 174t-96 143-142 96-175 35q-75 0-143-24t-125-66-98-102-63-132l22 2q11 1 23 2 93 0 174-35t142-96 96-142 36-175q0-32-5-62t-14-61zm-45 763q66 0 124-25t102-68 69-102 25-125q0-79-34-144t-97-113q-10 86-44 164t-87 142-123 111-154 72q45 42 101 65t118 23z" })
      ]
    }
  );
}
var ActionCenterQuiet_default = SvgActionCenterQuiet;

// src/components/Icon/icons/ActionCenterSettings.tsx
import { jsx as jsx41, jsxs as jsxs34 } from "react/jsx-runtime";
function SvgActionCenterSettings({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs34(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx41("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx41("path", { d: "M782 1902l114-182v211l-69 111-383-159 68-297q-26-24-50-50l-297 68L6 1221l259-161v-18q0-9-1-18v-18q0-9 1-18L6 827l159-383 297 68q24-26 50-50l-68-297L827 6l161 259h18q9 0 18-1h18q9 0 18 1L1221 6l383 159-68 297q26 24 50 50l297-68 159 383-111 69h-211l182-114-86-208-271 63q-31-38-63-70t-71-64l63-271-208-86-148 236q-23-2-47-4t-47-2q-24 0-47 2t-48 4L782 146l-208 86 63 271q-38 31-70 63t-64 71l-271-63-86 208 236 148q-2 24-4 47t-2 48q0 23 2 47t4 47l-236 147 86 208 271-63q31 38 63 70t71 64l-63 271 208 86zm-22-878q0 36 9 70t28 63 43 54 56 42v123q-56-20-101-55t-78-82-51-101-18-114q0-78 29-146t81-120 119-80 147-30q59 0 114 18t101 50 81 79 56 101h-123q-35-62-96-99t-133-37q-55 0-103 20t-84 57-56 84-21 103zm1288 0v768h-256l-256 256-256-256h-256v-768h1024zm-128 128h-768v512h181q53 50 102 101t101 102q51-51 100-102t103-101h181v-512zm-128 256h-512v-128h512v128z" })
      ]
    }
  );
}
var ActionCenterSettings_default = SvgActionCenterSettings;

// src/components/Icon/icons/ActivityFeed.tsx
import { jsx as jsx42, jsxs as jsxs35 } from "react/jsx-runtime";
function SvgActivityFeed({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs35(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx42("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx42("path", { d: "M64 1088V768H0V64h1664v704H384L64 1088zm64-448h64v139l139-139h1205V192H128v448zm1920 320v704h-64v320l-320-320H384V960h1664zm-128 128H512v448h1205q34 36 69 70t70 69v-139h64v-448z" })
      ]
    }
  );
}
var ActivityFeed_default = SvgActivityFeed;

// src/components/Icon/icons/ActivityFeed2.tsx
import { jsx as jsx43, jsxs as jsxs36 } from "react/jsx-runtime";
function SvgActivityFeed2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs36(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx43("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx43("path", { d: "M2048 128v1408H731l-475 475v-475H0V128h2048zm-128 128H128v1152h256v293l293-293h1243V256zm-576 704q-40 0-75 15t-61 41-41 61-15 75h-128q0-83 40-154t110-117q-26-30-40-67t-14-78q0-46 17-87t48-71 72-48 87-18q46 0 87 17t71 48 48 72 18 87q0 40-14 77t-40 68q70 45 110 116t40 155h-128q0-40-15-75t-41-61-61-41-75-15zm0-320q-40 0-68 28t-28 68q0 40 28 68t68 28q40 0 68-28t28-68q0-40-28-68t-68-28zm-448 0H384V512h512v128zm0 256H384V768h512v128zm0 256H384v-128h512v128z" })
      ]
    }
  );
}
var ActivityFeed2_default = SvgActivityFeed2;

// src/components/Icon/icons/ActivityFeed2Mirrored.tsx
import { jsx as jsx44, jsxs as jsxs37 } from "react/jsx-runtime";
function SvgActivityFeed2Mirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs37(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx44("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx44("path", { d: "M2048 128v1408H731l-475 475v-475H0V128h2048zm-128 128H128v1152h256v293l293-293h1243V256zM704 960q-40 0-75 15t-61 41-41 61-15 75H384q0-83 40-154t110-117q-26-30-40-67t-14-78q0-46 17-87t48-71 72-48 87-18q46 0 87 17t71 48 48 72 18 87q0 40-14 77t-40 68q70 45 110 116t40 155H896q0-40-15-75t-41-61-61-41-75-15zm0-320q-40 0-68 28t-28 68q0 40 28 68t68 28q40 0 68-28t28-68q0-40-28-68t-68-28zm960 0h-512V512h512v128zm0 256h-512V768h512v128zm0 256h-512v-128h512v128z" })
      ]
    }
  );
}
var ActivityFeed2Mirrored_default = SvgActivityFeed2Mirrored;

// src/components/Icon/icons/ActivityFeedConfiguration.tsx
import { jsx as jsx45, jsxs as jsxs38 } from "react/jsx-runtime";
function SvgActivityFeedConfiguration({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs38(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx45("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx45("path", { d: "M0 0h2048v1024H731l-475 475v-475H0V0zm1920 896V128H128v768h256v293l293-293h1243zm69 473l49 119-124 51q6 30 6 61t-6 61l124 51-49 119-124-52q-17 26-38 47t-48 39l52 124-119 49-51-124q-30 6-61 6t-61-6l-51 124-119-49 52-124q-52-34-86-86l-124 52-49-119 124-51q-6-30-6-61t6-61l-124-51 49-119 124 52q17-26 38-47t48-39l-52-124 119-49 51 124q14-2 27-3t28-2q17 0 33 2t33 5l52-126 119 49-53 126q26 17 48 37t39 47l124-52zm-197 231q0-40-15-75t-41-61-61-41-75-15q-39 0-74 15t-61 41-42 62-15 74q0 40 15 75t42 61 61 41 75 15q39 0 74-15t61-42 41-61 15-74z" })
      ]
    }
  );
}
var ActivityFeedConfiguration_default = SvgActivityFeedConfiguration;

// src/components/Icon/icons/ActivityFeedRules.tsx
import { jsx as jsx46, jsxs as jsxs39 } from "react/jsx-runtime";
function SvgActivityFeedRules({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs39(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx46("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx46("path", { d: "M1152 2048v-128h640v128h-640zm-256 0v-128h128v128H896zm0-384v-128h128v128H896zm256 0v-128h640v128h-640zm-256-384v-128h128v128H896zm256 0v-128h640v128h-640zM0 0h2048v896H731l-475 475V896H0V0zm1920 768V128H128v640h256v293l293-293h1243z" })
      ]
    }
  );
}
var ActivityFeedRules_default = SvgActivityFeedRules;

// src/components/Icon/icons/AdaptiveController.tsx
import { jsx as jsx47, jsxs as jsxs40 } from "react/jsx-runtime";
function SvgAdaptiveController({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs40(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2176 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx47("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx47("path", { d: "M1600 640q66 0 124 25t102 68 69 102 25 125q0 66-25 124t-68 102-102 69-125 25q-66 0-124-25t-102-68-69-102-25-125q0-66 25-124t68-102 102-69 125-25zm-768 0q66 0 124 25t102 68 69 102 25 125q0 66-25 124t-68 102-102 69-125 25q-66 0-124-25t-102-68-69-102-25-125q0-66 25-124t68-102 102-69 125-25zm1216-256q27 0 50 10t40 27 28 41 10 50v896q0 27-10 50t-27 40-41 28-50 10H128q-27 0-50-10t-40-27-28-41-10-50V512q0-27 10-50t27-40 41-28 50-10h1920zm0 1024V512H128v896h1920zM256 768V640h128v128H256zm0 256V896h128v128H256z" })
      ]
    }
  );
}
var AdaptiveController_default = SvgAdaptiveController;

// src/components/Icon/icons/AddConsole.tsx
import { jsx as jsx48, jsxs as jsxs41 } from "react/jsx-runtime";
function SvgAddConsole({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs41(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx48("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx48("path", { d: "M2048 512v768h-128v-128H384v128h1152v128H256v-256H0V512h2048zm-128 512V640H128v384h1792zm-320-256q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45q0-26 19-45t45-19zm192 768h256v128h-256v256h-128v-256h-256v-128h256v-256h128v256z" })
      ]
    }
  );
}
var AddConsole_default = SvgAddConsole;

// src/components/Icon/icons/AddEvent.tsx
import { jsx as jsx49, jsxs as jsxs42 } from "react/jsx-runtime";
function SvgAddEvent({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs42(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx49("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx49("path", { d: "M1664 128h384v1792H0V128h384V0h128v128h1024V0h128v128zM384 256H128v256h1792V256h-256v128h-128V256H512v128H384V256zM128 1792h1792V640H128v1152zm960-1024v384h384v128h-384v384H960v-384H576v-128h384V768h128z" })
      ]
    }
  );
}
var AddEvent_default = SvgAddEvent;

// src/components/Icon/icons/AddEventSolid.tsx
import { jsx as jsx50, jsxs as jsxs43 } from "react/jsx-runtime";
function SvgAddEventSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs43(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx50("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx50("path", { d: "M0 1920V512h2048v1408H0zm576-768v128h384v384h128v-384h384v-128h-384V768H960v384H576zM1664 128h384v256H0V128h384V0h128v128h1024V0h128v128z" })
      ]
    }
  );
}
var AddEventSolid_default = SvgAddEventSolid;

// src/components/Icon/icons/AddHome.tsx
import { jsx as jsx51, jsxs as jsxs44 } from "react/jsx-runtime";
function SvgAddHome({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs44(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx51("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx51("path", { d: "M768 1664v-640h512v768h-128v-640H896v640H256V987l-83 82-90-90 941-942 941 942-90 90-83-82v293h-128V859l-640-640-640 640v805h384zm1024 0h256v128h-256v256h-128v-256h-256v-128h256v-256h128v256z" })
      ]
    }
  );
}
var AddHome_default = SvgAddHome;

// src/components/Icon/icons/AddTo.tsx
import { jsx as jsx52, jsxs as jsxs45 } from "react/jsx-runtime";
function SvgAddTo({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs45(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx52("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx52("path", { d: "M1088 960h320v128h-320v320H960v-320H640V960h320V640h128v320zm-64-832q124 0 238 32t214 90 181 140 140 181 91 214 32 239q0 124-32 238t-90 214-140 181-181 140-214 91-239 32q-124 0-238-32t-214-90-181-140-140-181-91-214-32-239q0-124 32-238t90-214 140-181 181-140 214-91 239-32zm0 1664q159 0 298-60t244-165 165-244 61-299q0-159-60-298t-165-244-244-165-299-61q-159 0-298 60T482 481 317 725t-61 299q0 106 27 204t78 183 120 156 155 120 184 77 204 28z" })
      ]
    }
  );
}
var AddTo_default = SvgAddTo;

// src/components/Icon/icons/AddToCollection.tsx
import { jsx as jsx53, jsxs as jsxs46 } from "react/jsx-runtime";
function SvgAddToCollection({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs46(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx53("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx53("path", { d: "M2048 1792h-256v256h-128v-256h-256v-128h256v-256h128v256h256v128zm-512-512q0 62-29 109t-76 80-104 50-111 17q-54 0-111-17t-103-49-76-80-30-110q0-61 29-109t76-80 104-50 111-17q51 0 100 12t92 39V322L640 514v1022q0 62-29 109t-76 80-104 50-111 17q-54 0-111-17t-103-49-76-80-30-110q0-61 29-109t76-80 104-50 111-17q51 0 100 12t92 39V414l1024-256v1122zM320 1664q27 0 60-8t62-23 50-40 20-57q0-33-20-57t-49-39-63-24-60-8q-27 0-60 8t-62 23-50 40-20 57q0 33 20 57t49 39 63 24 60 8zm896-256q27 0 60-8t62-23 50-40 20-57q0-33-20-57t-49-39-63-24-60-8q-27 0-60 8t-62 23-50 40-20 57q0 33 20 57t49 39 63 24 60 8z" })
      ]
    }
  );
}
var AddToCollection_default = SvgAddToCollection;

// src/components/Icon/icons/AddToNowPlaying.tsx
import { jsx as jsx54, jsxs as jsxs47 } from "react/jsx-runtime";
function SvgAddToNowPlaying({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs47(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx54("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx54("path", { d: "M512 256l1024 768-1024 768V256zm128 256v1024l683-512-683-512zm1408 1057v125h-385v354h-125v-354h-387v-125h387v-416h125v416h385z" })
      ]
    }
  );
}
var AddToNowPlaying_default = SvgAddToNowPlaying;

// src/components/Icon/icons/AddToNowPlaying2.tsx
import { jsx as jsx55, jsxs as jsxs48 } from "react/jsx-runtime";
function SvgAddToNowPlaying2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs48(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx55("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx55("path", { d: "M127 1409V897h129v512H127zm768 0V0h129v1409H895zm-383 0V705h127v704H512zm895-704v704h-127V705h127zm641 960v127h-256v256h-129v-256h-256v-127h256v-256h129v256h256z" })
      ]
    }
  );
}
var AddToNowPlaying2_default = SvgAddToNowPlaying2;

// src/components/Icon/icons/AdornerConnected.tsx
import { jsx as jsx56, jsxs as jsxs49 } from "react/jsx-runtime";
function SvgAdornerConnected({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs49(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx56("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx56("path", { d: "M481 469Q372 578 314 718t-58 294q0 153 58 293t167 250l-91 90q-127-127-194-290t-68-343q0-90 17-176t51-167 82-154 112-137l91 91zm1177-91q63 63 112 136t82 154 50 167 18 177q0 179-67 342t-195 291l-91-90q109-109 166-249t58-294q0-154-57-294t-167-249l91-91zM707 695q-63 63-97 145t-34 172q0 90 34 172t97 145l-90 90q-81-81-125-186t-44-221q0-115 44-221t125-187l90 91zm724-91q81 81 125 187t44 221q0 115-44 220t-125 187l-90-90q63-63 96-145t34-172q0-90-33-172t-97-145l90-91zM933 921q-18 18-27 41t-10 50q0 53 37 90l-90 91q-35-36-55-83t-20-98q0-51 19-98t56-83l90 90zm272-90q36 36 55 83t20 98q0 51-20 98t-55 83l-91-91q18-17 28-40t10-50q0-26-9-49t-29-42l91-90z" })
      ]
    }
  );
}
var AdornerConnected_default = SvgAdornerConnected;

// src/components/Icon/icons/Aggressive.tsx
import { jsx as jsx57, jsxs as jsxs50 } from "react/jsx-runtime";
function SvgAggressive({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs50(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx57("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx57("path", { d: "M1024 0q141 0 272 36t245 103 207 160 160 208 103 245 37 272q0 141-36 272t-103 245-160 207-208 160-245 103-272 37q-141 0-272-36t-245-104-207-160-160-207-103-245-37-272q0-141 36-272t103-245 160-207 208-160T751 37t273-37zm0 128q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 65 9 128h412l475-475 475 475h412q9-63 9-128 0-123-32-237t-90-214-141-182-181-140-214-91-238-32zm0 1792q148 0 285-46t250-131 197-203 127-260h-438l-421-421-421 421H165q43 142 126 260t197 202 250 131 286 47z" })
      ]
    }
  );
}
var Aggressive_default = SvgAggressive;

// src/components/Icon/icons/AllDevices.tsx
import { jsx as jsx58, jsxs as jsxs51 } from "react/jsx-runtime";
function SvgAllDevices({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs51(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx58("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx58("path", { d: "M1024 1024q-53 0-99 20t-82 55-55 81-20 100h317q-19 30-33 62t-26 66H512v256h486q4 32 10 64t18 64H384V256h1280v742l-32-4q-16-2-32-2t-32 2-32 4V384H512v896h128q0-52 14-101t40-93 63-80 83-61q-34-35-53-81t-19-96q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100q0 50-19 96t-53 81q37 20 68 48t57 63q-57 28-107 68-37-47-89-73t-113-27zm0-384q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10zm890 899q6 30 6 61t-6 61l124 51-49 119-124-52q-35 51-86 86l52 124-119 49-51-124q-30 6-61 6t-61-6l-51 124-119-49 52-124q-51-35-86-86l-124 52-49-119 124-51q-6-30-6-61t6-61l-124-51 49-119 124 52q35-51 86-86l-52-124 119-49 51 124q30-6 61-6t61 6l51-124 119 49-52 124q51 35 86 86l124-52 49 119-124 51zm-314 253q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15z" })
      ]
    }
  );
}
var AllDevices_default = SvgAllDevices;

// src/components/Icon/icons/AnalyticsView.tsx
import { jsx as jsx59, jsxs as jsxs52 } from "react/jsx-runtime";
function SvgAnalyticsView({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs52(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx59("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx59("path", { d: "M0 128h2048v1664H0V128zm1920 128H128v256h1792V256zM128 1664h1792V640H128v1024zm128-128V896h128v640H256zm256 0v-256h128v256H512zm256 0v-384h128v384H768zm256 0V768h128v768h-128zm512 0V896h128v640h-128zm-256 0v-384h128v384h-128z" })
      ]
    }
  );
}
var AnalyticsView_default = SvgAnalyticsView;

// src/components/Icon/icons/Anklewear.tsx
import { jsx as jsx60, jsxs as jsxs53 } from "react/jsx-runtime";
function SvgAnklewear({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs53(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx60("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx60("path", { d: "M1525 901q57 6 106 35t85 72 56 98 20 110q0 90-42 161t-118 118l-3 2-244 122q-58 28-86 86l-118 237q-24 49-71 77t-101 29H320q-40 0-75-15t-61-41-41-61-15-75q0-40 15-75t41-61 61-41 75-15h166l7-7 12-12 12-12 6-6 183-390q10-22 17-44t11-46q-42-6-82-21t-71-40-50-60-19-84q0-33 10-65t26-63 36-57 43-50L419 84l122-40 301 904q12 36 18 74 66-6 135-24t137-46 130-63 115-76L1230 77l126-26 67 336q44 4 87 18t77 39 56 62 21 88q0 38-13 75t-33 71-47 65-53 56l7 40zm11-306q0-18-8-30t-21-22-28-14-30-9l37 186q17-23 33-52t17-59zM640 941q0 18 8 31t21 21 29 14 31 9l-54-165q-13 19-24 43t-11 47zm369 979q17 0 33-9t24-26l119-237q48-95 143-143 121-60 242-121 22-11 39-29t30-42 18-48 7-49q0-40-15-75t-41-61-61-41-75-15q-34 0-48-22t-19-51q-58 39-124 73t-135 60-142 44-141 22q-9 75-41 142l-188 399q-4 9-14 20t-21 22-23 22-19 18q-16 15-44 18t-61 3-68-4-63 2-47 18-18 46q0 26 19 45t45 19h689zm207-720q12 0 16 14 6 32 13 51t18 31 31 19 52 13q14 4 14 16 0 13-14 16-32 6-51 13t-31 18-19 31-13 52q-4 14-16 14-13 0-16-14-6-32-13-51t-18-31-31-19-52-13q-14-3-14-16 0-12 14-16 32-6 51-13t31-18 19-31 13-52q3-14 16-14zm640-512q12 0 16 14 6 32 13 51t18 31 31 19 52 13q14 4 14 16 0 13-14 16-32 6-51 13t-31 18-19 31-13 52q-4 14-16 14-13 0-16-14-6-32-13-51t-18-31-31-19-52-13q-14-3-14-16 0-12 14-16 32-6 51-13t31-18 19-31 13-52q3-14 16-14z" })
      ]
    }
  );
}
var Anklewear_default = SvgAnklewear;

// src/components/Icon/icons/AppChannels.tsx
import { jsx as jsx61, jsxs as jsxs54 } from "react/jsx-runtime";
function SvgAppChannels({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs54(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx61("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx61("path", { d: "M128 128h1792v768H128V128zm128 128v512h384V256H256zm1536 512V256H768v512h1024zM128 1792v-768h1792v768H128zm1664-128v-512H768v512h1024zM256 1152v512h384v-512H256z" })
      ]
    }
  );
}
var AppChannels_default = SvgAppChannels;

// src/components/Icon/icons/AppFill.tsx
import { jsx as jsx62, jsxs as jsxs55 } from "react/jsx-runtime";
function SvgAppFill({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs55(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx62("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx62("path", { d: "M384 768v384h896V768H384zm1024 512H256V640h1152v640zm512 128V512H128v896h1792zM0 384h2048v1152h-960v128h256v128H704v-128h256v-128H0V384z" })
      ]
    }
  );
}
var AppFill_default = SvgAppFill;

// src/components/Icon/icons/AppFillMirrored.tsx
import { jsx as jsx63, jsxs as jsxs56 } from "react/jsx-runtime";
function SvgAppFillMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs56(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx63("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx63("path", { d: "M1664 768v384H768V768h896zM640 1280h1152V640H640v640zm-512 128V512h1792v896H128zM2048 384H0v1152h960v128H704v128h640v-128h-256v-128h960V384z" })
      ]
    }
  );
}
var AppFillMirrored_default = SvgAppFillMirrored;

// src/components/Icon/icons/AppFull.tsx
import { jsx as jsx64, jsxs as jsxs57 } from "react/jsx-runtime";
function SvgAppFull({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs57(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx64("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx64("path", { d: "M0 384h2048v1152h-960v128h256v128H704v-128h256v-128H0V384zm1920 1024V512H128v896h1792zm-128-128H256V640h1536v640zM384 768v384h1280V768H384z" })
      ]
    }
  );
}
var AppFull_default = SvgAppFull;

// src/components/Icon/icons/AppIconAvatar.tsx
import { jsx as jsx65, jsxs as jsxs58 } from "react/jsx-runtime";
function SvgAppIconAvatar({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs58(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx65("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx65("path", { d: "M508 873q-5-3-5-7t-1-9q1-14 1-28t0-30v-42q0-21-1-43 0-42 2-82t11-82q5-29 4-59t5-60q11-57 37-106t56-97q4-6 17-19t32-28 37-31 34-26q41-31 89-55t97-39q26-8 50-11t50-3q52 0 102 12t102 30q27 12 46 29t32 34 21 33 14 23q10 15 20 26t21 20 22 20 23 23q48 54 71 115t23 130q0 26-3 53-5 38-7 75t-11 76q-3 16-7 30t-23 23q-7 3-10 10t-6 16q-5 16-10 31t-7 30q-3 31-19 54t-36 45q-16 17-26 36t-17 42q-5 20-11 41t-17 41q-6-2-9-6t-5-10-5-10-10-8q-20 11-41 22t-43 25q-21 12-34 36t-14 51q0 7 2 17 5 17 12 24t17 7q6 0 9-1h14q-49 23-102 34t-107 11q-99 0-190-38 1 1 3 1h4q4 1 10 1 24 0 33-30 11-33 11-64 0-30-12-60-8-20-20-34t-39-17q-13-1-24-7t-19-21q-1-1-1-2l-1-1q-4-6-8-10t-16-7q5 35 17 67t18 71q-12-14-20-29t-16-31-15-29-18-29q-6 6-8 13t-2 14-2 13-6 13q-7-5-8-11t-2-13v-5q-3-26-13-48t-30-41q-23-20-37-46t-28-53q-4-7-6-14t-10-13q-7 0-10 4t-6 9-6 9-9 5zm1150 816q3 32 7 62t12 62q-134 111-300 173t-353 62q-198 0-371-69t-310-192q3-20 5-40t4-42q5-49 15-96t26-95q20-60 61-99t94-65q20-10 41-18t42-17q79 60 171 92t194 33q106 0 202-35t177-102l4 2q2 1 5 1 51 14 93 40t81 61q20 18 32 41t22 48q20 46 30 94t16 99z" })
      ]
    }
  );
}
var AppIconAvatar_default = SvgAppIconAvatar;

// src/components/Icon/icons/AppIconDefault.tsx
import { jsx as jsx66, jsxs as jsxs59 } from "react/jsx-runtime";
function SvgAppIconDefault({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs59(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx66("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx66("path", { d: "M0 0h1920v1024h-896v896H0V0zm128 128v768h768V128H128zm768 1664v-768H128v768h768zm896-896V128h-768v768h768z" })
      ]
    }
  );
}
var AppIconDefault_default = SvgAppIconDefault;

// src/components/Icon/icons/AppIconHelp.tsx
import { jsx as jsx67, jsxs as jsxs60 } from "react/jsx-runtime";
function SvgAppIconHelp({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs60(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx67("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx67("path", { d: "M1536 1920h128v128h-128v-128zm64-704q53 0 99 20t82 55 55 81 20 100q0 47-17 89t-49 76h-1l-95 96q-14 14-20 28t-8 29-3 32 1 34h-128v-48q0-46 14-81t35-63 47-50 46-45 36-45 14-52q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50h-128q0-53 20-99t55-82 81-55 100-20zm-560-270q84 34 154 81t133 113l-94 88q-92-99-211-151t-255-53q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170H-1q0-116 36-228t101-208 156-169 203-113q-56-36-100-83t-75-103-47-118-17-130q0-106 40-199t109-163T568 40 768 0q106 0 199 40t163 109 110 163 40 200q0 66-16 129t-48 119-75 103-101 83zM384 512q0 80 30 149t82 122 122 83 150 30q79 0 149-30t122-82 83-122 30-150q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149z" })
      ]
    }
  );
}
var AppIconHelp_default = SvgAppIconHelp;

// src/components/Icon/icons/AppIconHelpMirrored.tsx
import { jsx as jsx68, jsxs as jsxs61 } from "react/jsx-runtime";
function SvgAppIconHelpMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs61(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx68("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx68("path", { d: "M1536 1920h128v128h-128v-128zm64-704q53 0 99 20t82 55 55 81 20 100h-128q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50q0 29 14 52t35 45 47 44 46 51 36 63 14 81v48h-128v-33q0-16-1-32t-9-30-20-28q-30-30-59-57t-52-58-37-65-14-81q0-53 20-99t55-82 81-55 100-20zm-560-270q84 34 154 81t133 113l-94 88q-92-99-211-151t-255-53q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170H-1q0-116 36-228t101-208 156-169 203-113q-56-36-100-83t-75-103-47-118-17-130q0-106 40-199t109-163T568 40 768 0q106 0 199 40t163 109 110 163 40 200q0 66-16 129t-48 119-75 103-101 83zM384 512q0 80 30 149t82 122 122 83 150 30q79 0 149-30t122-82 83-122 30-150q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149z" })
      ]
    }
  );
}
var AppIconHelpMirrored_default = SvgAppIconHelpMirrored;

// src/components/Icon/icons/AppIconParty.tsx
import { jsx as jsx69, jsxs as jsxs62 } from "react/jsx-runtime";
function SvgAppIconParty({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs62(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx69("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx69("path", { d: "M1850 688q46 26 82 62t62 79 40 93 14 102h-128q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100q0 92-41 173t-115 136q65 33 117 81t90 108 57 128 20 142h-128q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149H512q0-73 20-141t57-128 89-108 118-82q-74-55-115-136t-41-173q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100H0q0-52 14-101t39-93 62-80 83-62q-33-35-51-81t-19-95q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100q0 49-18 95t-52 81q82 45 134 124 27-40 62-72t76-54 87-34 95-12q48 0 94 12t87 34 77 54 62 72q52-79 134-124-33-35-51-81t-19-95q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100q0 49-18 95t-52 81zM256 512q0 27 10 50t27 40 41 28 50 10q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50zm768 768q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100q0 53 20 99t55 82 81 55 100 20zm512-768q0 27 10 50t27 40 41 28 50 10q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50z" })
      ]
    }
  );
}
var AppIconParty_default = SvgAppIconParty;

// src/components/Icon/icons/AppIconPeople.tsx
import { jsx as jsx70, jsxs as jsxs63 } from "react/jsx-runtime";
function SvgAppIconPeople({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs63(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx70("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx70("path", { d: "M1636 693q65 33 117 81t90 108 57 128 20 142h-128q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149q0 92-41 173t-115 136q65 33 117 81t90 108 57 128 20 142h-128q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149H128q0-73 20-141t57-128 89-108 118-82q-74-55-115-136t-41-173q0-79 30-149t82-122 122-83 150-30q92 0 173 41t136 115q37-75 97-134t134-97q-74-55-115-136t-41-173q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 92-41 173t-115 136zm-996 715q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100q0 53 20 99t55 82 81 55 100 20zm512-1024q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100z" })
      ]
    }
  );
}
var AppIconPeople_default = SvgAppIconPeople;

// src/components/Icon/icons/ApplicationInstall.tsx
import { jsx as jsx71, jsxs as jsxs64 } from "react/jsx-runtime";
function SvgApplicationInstall({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs64(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx71("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx71("path", { d: "M384 2048v-128h1152v128H384zm1197-851l-621 626-621-626 90-90 467 470V0h128v1577l467-470 90 90z" })
      ]
    }
  );
}
var ApplicationInstall_default = SvgApplicationInstall;

// src/components/Icon/icons/ApplicationLaunch.tsx
import { jsx as jsx72, jsxs as jsxs65 } from "react/jsx-runtime";
function SvgApplicationLaunch({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs65(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx72("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx72("path", { d: "M1663 1921v-641h129v768H0V256h768v129H127v1536h1536zM896 0h1152v1152h-128V219L557 1581l-90-90L1829 128H896V0z" })
      ]
    }
  );
}
var ApplicationLaunch_default = SvgApplicationLaunch;

// src/components/Icon/icons/ApplicationLaunchMirrored.tsx
import { jsx as jsx73, jsxs as jsxs66 } from "react/jsx-runtime";
function SvgApplicationLaunchMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs66(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx73("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx73("path", { d: "M385 1921v-641H256v768h1792V256h-768v129h641v1536H385zM1152 0H0v1152h128V219l1363 1362 90-90L219 128h933V0z" })
      ]
    }
  );
}
var ApplicationLaunchMirrored_default = SvgApplicationLaunchMirrored;

// src/components/Icon/icons/ApplyAction.tsx
import { jsx as jsx74, jsxs as jsxs67 } from "react/jsx-runtime";
function SvgApplyAction({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs67(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx74("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx74("path", { d: "M1408 384l640 640-640 640H0V384h1408zm-53 1152l512-512-512-512H128v1024h1227z" })
      ]
    }
  );
}
var ApplyAction_default = SvgApplyAction;

// src/components/Icon/icons/Apps.tsx
import { jsx as jsx75, jsxs as jsxs68 } from "react/jsx-runtime";
function SvgApps({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs68(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx75("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx75("path", { d: "M2048 1806l-384-77v216l-896-299v-366H496q-21 0-35 14l-208 207q-17 16-35 25t-42 10q-20 0-40-7t-38-20-33-27-26-31q-22-33-30-71t-9-77q0-28 3-55t8-55q4-20 14-57t26-81 33-92 38-90 37-76 33-48v-43q54-32 117-49t126-17q23 0 42 6t38 15 36 21 38 22h102q20-10 39-20t38-22V402l896-299v276l384-154v1581zM371 1203q25-25 57-38t68-13h288q34 0 67 13t58 37l201 201q13-7 21-18t13-24 6-28 2-28q0-23-2-45t-7-44q-6-33-22-83t-36-104-41-102-39-79q-5-9-20-16t-25-12v-33q-29-8-57-13t-61-6q-4 0-21 10t-38 22-41 22-31 10h-97q-23 0-37-1t-27-5-29-13-40-22q-8-5-18-10t-22-13h-12q-28 0-55 6t-54 14v32q-11 5-25 12t-21 17q-8 11-13 26t-11 27l-4 10q-32 72-63 149t-46 155q-4 22-6 44t-3 45q0 13 1 27t6 28 13 25 22 18l201-200zm1165-922L896 494v149q51 7 99 21t93 42v43q15 15 33 48t38 75 37 90 33 92 25 81 15 58q5 28 8 55t3 57q0 39-8 76t-31 70q-11 16-26 31t-33 28-38 19-40 7q-23 0-42-9t-36-26l-130-131v184l640 213V281zm384 134l-256 102v1082l256 51V415zM640 912q20 0 34 14t14 34q0 20-14 34t-34 14q-20 0-34-14t-14-34q0-20 14-34t34-14z" })
      ]
    }
  );
}
var Apps_default = SvgApps;

// src/components/Icon/icons/Apps2.tsx
import { jsx as jsx76, jsxs as jsxs69 } from "react/jsx-runtime";
function SvgApps2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs69(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx76("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx76("path", { d: "M2048 576l-448 448h192v896H128V256h896v192L1472 0l576 576zm-576-418l-418 418 418 418 418-418-418-418zm-448 546v320h320l-320-320zM896 1792v-640H256v640h640zm0-768V384H256v640h640zm768 128h-640v640h640v-640z" })
      ]
    }
  );
}
var Apps2_default = SvgApps2;

// src/components/Icon/icons/Apps2Solid.tsx
import { jsx as jsx77, jsxs as jsxs70 } from "react/jsx-runtime";
function SvgApps2Solid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs70(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx77("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx77("path", { d: "M2048 576l-448 448h192v896H128V256h896v192L1472 0l576 576zM1024 704v320h320l-320-320zM896 1792v-640H256v640h640zm0-768V384H256v640h640zm768 128h-640v640h640v-640z" })
      ]
    }
  );
}
var Apps2Solid_default = SvgApps2Solid;

// src/components/Icon/icons/AppSnap.tsx
import { jsx as jsx78, jsxs as jsxs71 } from "react/jsx-runtime";
function SvgAppSnap({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs71(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx78("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx78("path", { d: "M0 384h2048v1152h-960v128h320v128H640v-128h320v-128H0V384zm128 128v896h1280V512H128zm1792 896V512h-384v896h384z" })
      ]
    }
  );
}
var AppSnap_default = SvgAppSnap;

// src/components/Icon/icons/AppSnapMirrored.tsx
import { jsx as jsx79, jsxs as jsxs72 } from "react/jsx-runtime";
function SvgAppSnapMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs72(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx79("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx79("path", { d: "M2048 384H0v1152h960v128H640v128h768v-128h-320v-128h960V384zm-128 128v896H640V512h1280zM128 1408V512h384v896H128z" })
      ]
    }
  );
}
var AppSnapMirrored_default = SvgAppSnapMirrored;

// src/components/Icon/icons/AppSwap.tsx
import { jsx as jsx80, jsxs as jsxs73 } from "react/jsx-runtime";
function SvgAppSwap({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs73(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx80("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx80("path", { d: "M1920 1408V512h-640v384h293l-82-83 90-90 237 237-237 238-90-90 83-84h-294v384h640zm-768-512V512H128v896h1024v-384H858l83 84-90 90-237-238 237-237 90 90-82 83h293zM0 384h2048v1152h-960v128h256v128H704v-128h256v-128H0V384z" })
      ]
    }
  );
}
var AppSwap_default = SvgAppSwap;

// src/components/Icon/icons/AppSwapMirrored.tsx
import { jsx as jsx81, jsxs as jsxs74 } from "react/jsx-runtime";
function SvgAppSwapMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs74(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx81("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx81("path", { d: "M128 1408V512h640v384H475l82-83-90-90-237 237 237 238 90-90-83-84h294v384H128zm768-512V512h1024v896H896v-384h294l-83 84 90 90 237-238-237-237-90 90 82 83H896zm1152-512H0v1152h960v128H704v128h640v-128h-256v-128h960V384z" })
      ]
    }
  );
}
var AppSwapMirrored_default = SvgAppSwapMirrored;

// src/components/Icon/icons/ArcadeGame.tsx
import { jsx as jsx82, jsxs as jsxs75 } from "react/jsx-runtime";
function SvgArcadeGame({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs75(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx82("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx82("path", { d: "M1600 1408q40 0 75 15t61 41 41 61 15 75v448H128v-448q0-40 15-75t41-61 61-41 75-15h64v-128h256v128h256V634q-56-12-103-41t-81-70-53-94-19-109q0-66 25-124t68-101 102-69T960 0q66 0 124 25t101 69 69 102 26 124q0 57-19 109t-53 93-81 71-103 41v774h576zM768 320q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75zm896 1280q0-26-19-45t-45-19H320q-26 0-45 19t-19 45v320h1408v-320z" })
      ]
    }
  );
}
var ArcadeGame_default = SvgArcadeGame;

// src/components/Icon/icons/ArcadeGameArt160.tsx
import { jsx as jsx83, jsxs as jsxs76 } from "react/jsx-runtime";
function SvgArcadeGameArt160({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs76(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx83("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx83("path", { d: "M1664 1434q34 0 64 13t53 35 36 53 13 65v422H217v-422q0-34 13-64t36-53 53-36 65-13h64v-77h256v77h281V612q-55-7-101-33t-81-65-54-89-20-105q0-61 23-114t64-94 93-63 115-23q61 0 114 23t94 63 63 93 23 115q0 55-19 105t-54 89-81 65-102 33v822h602zM806 320q0 45 17 84t47 70 69 47 85 17q45 0 84-17t69-47 47-69 17-85q0-45-17-84t-46-70-69-47-85-17q-45 0-84 17t-70 47-47 69-17 85zm947 1280q0-37-26-63t-63-27H384q-37 0-63 26t-27 64v346h1459v-346z" })
      ]
    }
  );
}
var ArcadeGameArt160_default = SvgArcadeGameArt160;

// src/components/Icon/icons/ArcadeGameArt224.tsx
import { jsx as jsx84, jsxs as jsxs77 } from "react/jsx-runtime";
function SvgArcadeGameArt224({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs77(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx84("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx84("path", { d: "M1664 1445q32 0 60 12t50 33 33 49 12 61v411H229v-411q0-32 12-60t33-50 49-33 61-12h64v-55h256v55h293V602q-54-5-101-29t-81-62-54-87-20-104q0-58 22-110t61-90 89-60 111-23q58 0 110 22t90 61 60 90 23 110q0 55-19 104t-54 86-82 62-101 30v843h613zM795 320q0 47 18 89t49 73 73 49 89 18q47 0 89-18t73-49 49-73 18-89q0-47-18-89t-49-73-73-49-89-18q-47 0-89 18t-73 49-49 73-18 89zm970 1280q0-21-8-39t-22-32-32-22-39-8H384q-21 0-39 8t-32 22-22 32-8 39v357h1482v-357z" })
      ]
    }
  );
}
var ArcadeGameArt224_default = SvgArcadeGameArt224;

// src/components/Icon/icons/Arrow2Down.tsx
import { jsx as jsx85, jsxs as jsxs78 } from "react/jsx-runtime";
function SvgArrow2Down({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs78(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx85("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx85("path", { d: "M128 384h1792l-896 1280L128 384zm246 128l650 929 650-929H374z" })
      ]
    }
  );
}
var Arrow2Down_default = SvgArrow2Down;

// src/components/Icon/icons/Arrow2DownSolid.tsx
import { jsx as jsx86, jsxs as jsxs79 } from "react/jsx-runtime";
function SvgArrow2DownSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs79(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx86("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx86("path", { d: "M1920 384l-896 1280L128 384h1792z" })
      ]
    }
  );
}
var Arrow2DownSolid_default = SvgArrow2DownSolid;

// src/components/Icon/icons/Arrow2Left.tsx
import { jsx as jsx87, jsxs as jsxs80 } from "react/jsx-runtime";
function SvgArrow2Left({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs80(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx87("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx87("path", { d: "M384 1024l1280-896v1792L384 1024zm1152 650V374l-929 650 929 650z" })
      ]
    }
  );
}
var Arrow2Left_default = SvgArrow2Left;

// src/components/Icon/icons/Arrow2LeftMirrored.tsx
import { jsx as jsx88, jsxs as jsxs81 } from "react/jsx-runtime";
function SvgArrow2LeftMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs81(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx88("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx88("path", { d: "M1664 1024L384 128v1792l1280-896zM512 1674V374l929 650-929 650z" })
      ]
    }
  );
}
var Arrow2LeftMirrored_default = SvgArrow2LeftMirrored;

// src/components/Icon/icons/Arrow2LeftSolid.tsx
import { jsx as jsx89, jsxs as jsxs82 } from "react/jsx-runtime";
function SvgArrow2LeftSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs82(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx89("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx89("path", { d: "M1664 128v1792L384 1024l1280-896z" })
      ]
    }
  );
}
var Arrow2LeftSolid_default = SvgArrow2LeftSolid;

// src/components/Icon/icons/Arrow2Right.tsx
import { jsx as jsx90, jsxs as jsxs83 } from "react/jsx-runtime";
function SvgArrow2Right({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs83(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx90("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx90("path", { d: "M384 128l1280 896-1280 896V128zm128 246v1300l929-650-929-650z" })
      ]
    }
  );
}
var Arrow2Right_default = SvgArrow2Right;

// src/components/Icon/icons/Arrow2RightMirrored.tsx
import { jsx as jsx91, jsxs as jsxs84 } from "react/jsx-runtime";
function SvgArrow2RightMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs84(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx91("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx91("path", { d: "M1664 128L384 1024l1280 896V128zm-128 246v1300l-929-650 929-650z" })
      ]
    }
  );
}
var Arrow2RightMirrored_default = SvgArrow2RightMirrored;

// src/components/Icon/icons/Arrow2RightSolid.tsx
import { jsx as jsx92, jsxs as jsxs85 } from "react/jsx-runtime";
function SvgArrow2RightSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs85(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx92("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx92("path", { d: "M1664 1024L384 1920V128l1280 896z" })
      ]
    }
  );
}
var Arrow2RightSolid_default = SvgArrow2RightSolid;

// src/components/Icon/icons/Arrow2Up.tsx
import { jsx as jsx93, jsxs as jsxs86 } from "react/jsx-runtime";
function SvgArrow2Up({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs86(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx93("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx93("path", { d: "M1024 384l896 1280H128l896-1280zm0 223l-650 929h1300l-650-929z" })
      ]
    }
  );
}
var Arrow2Up_default = SvgArrow2Up;

// src/components/Icon/icons/Arrow2UpSolid.tsx
import { jsx as jsx94, jsxs as jsxs87 } from "react/jsx-runtime";
function SvgArrow2UpSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs87(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx94("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx94("path", { d: "M1920 1664H128l896-1280 896 1280z" })
      ]
    }
  );
}
var Arrow2UpSolid_default = SvgArrow2UpSolid;

// src/components/Icon/icons/Arrow3Down.tsx
import { jsx as jsx95, jsxs as jsxs88 } from "react/jsx-runtime";
function SvgArrow3Down({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs88(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx95("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx95("path", { d: "M1939 947l90 90-1005 1005L19 1037l90-90 851 851V0h128v1798l851-851z" })
      ]
    }
  );
}
var Arrow3Down_default = SvgArrow3Down;

// src/components/Icon/icons/Arrow3Left.tsx
import { jsx as jsx96, jsxs as jsxs89 } from "react/jsx-runtime";
function SvgArrow3Left({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs89(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx96("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx96("path", { d: "M967 301L373 896h1573v128H373l594 595-90 90-749-749 749-749 90 90z" })
      ]
    }
  );
}
var Arrow3Left_default = SvgArrow3Left;

// src/components/Icon/icons/Arrow3LeftMirrored.tsx
import { jsx as jsx97, jsxs as jsxs90 } from "react/jsx-runtime";
function SvgArrow3LeftMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs90(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx97("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx97("path", { d: "M1107 301l594 595H128v128h1573l-594 595 90 90 749-749-749-749-90 90z" })
      ]
    }
  );
}
var Arrow3LeftMirrored_default = SvgArrow3LeftMirrored;

// src/components/Icon/icons/Arrow3Right.tsx
import { jsx as jsx98, jsxs as jsxs91 } from "react/jsx-runtime";
function SvgArrow3Right({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs91(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx98("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx98("path", { d: "M1197 211l749 749-749 749-90-90 594-595H128V896h1573l-594-595 90-90z" })
      ]
    }
  );
}
var Arrow3Right_default = SvgArrow3Right;

// src/components/Icon/icons/Arrow3RightMirrored.tsx
import { jsx as jsx99, jsxs as jsxs92 } from "react/jsx-runtime";
function SvgArrow3RightMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs92(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx99("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx99("path", { d: "M877 211L128 960l749 749 90-90-594-595h1573V896H373l594-595-90-90z" })
      ]
    }
  );
}
var Arrow3RightMirrored_default = SvgArrow3RightMirrored;

// src/components/Icon/icons/Arrow3Up.tsx
import { jsx as jsx100, jsxs as jsxs93 } from "react/jsx-runtime";
function SvgArrow3Up({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs93(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx100("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx100("path", { d: "M2029 1011l-90 90-851-851v1798H960V250l-851 851-90-90L1024 6l1005 1005z" })
      ]
    }
  );
}
var Arrow3Up_default = SvgArrow3Up;

// src/components/Icon/icons/ArrowDown.tsx
import { jsx as jsx101, jsxs as jsxs94 } from "react/jsx-runtime";
function SvgArrowDown({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs94(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx101("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx101("path", { d: "M1939 947l90 90-1005 1005L19 1037l90-90 851 851V0h128v1798l851-851z" })
      ]
    }
  );
}
var ArrowDown_default = SvgArrowDown;

// src/components/Icon/icons/ArrowLeft.tsx
import { jsx as jsx102, jsxs as jsxs95 } from "react/jsx-runtime";
function SvgArrowLeft({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs95(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx102("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx102("path", { d: "M967 301L373 896h1573v128H373l594 595-90 90-749-749 749-749 90 90z" })
      ]
    }
  );
}
var ArrowLeft_default = SvgArrowLeft;

// src/components/Icon/icons/ArrowLeftMirrored.tsx
import { jsx as jsx103, jsxs as jsxs96 } from "react/jsx-runtime";
function SvgArrowLeftMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs96(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx103("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx103("path", { d: "M1107 301l594 595H128v128h1573l-594 595 90 90 749-749-749-749-90 90z" })
      ]
    }
  );
}
var ArrowLeftMirrored_default = SvgArrowLeftMirrored;

// src/components/Icon/icons/ArrowRight.tsx
import { jsx as jsx104, jsxs as jsxs97 } from "react/jsx-runtime";
function SvgArrowRight({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs97(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx104("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx104("path", { d: "M1197 211l749 749-749 749-90-90 594-595H128V896h1573l-594-595 90-90z" })
      ]
    }
  );
}
var ArrowRight_default = SvgArrowRight;

// src/components/Icon/icons/ArrowRightMirrored.tsx
import { jsx as jsx105, jsxs as jsxs98 } from "react/jsx-runtime";
function SvgArrowRightMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs98(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx105("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx105("path", { d: "M877 211L128 960l749 749 90-90-594-595h1573V896H373l594-595-90-90z" })
      ]
    }
  );
}
var ArrowRightMirrored_default = SvgArrowRightMirrored;

// src/components/Icon/icons/ArrowsLeftRight.tsx
import { jsx as jsx106, jsxs as jsxs99 } from "react/jsx-runtime";
function SvgArrowsLeftRight({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs99(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx106("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx106("path", { d: "M1491 1197l90-90 365 365-365 365-90-90 210-211H0v-128h1701l-210-211zM346 512h1702v128H346l211 211-90 90-366-365 366-365 90 90-211 211z" })
      ]
    }
  );
}
var ArrowsLeftRight_default = SvgArrowsLeftRight;

// src/components/Icon/icons/ArrowsLeftRight2.tsx
import { jsx as jsx107, jsxs as jsxs100 } from "react/jsx-runtime";
function SvgArrowsLeftRight2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs100(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx107("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx107("path", { d: "M512 2048V896l896 576-896 576zm128-917v683l531-342-531-341zM512 576L1408 0v1152L512 576zm768 342V235L749 576l531 342z" })
      ]
    }
  );
}
var ArrowsLeftRight2_default = SvgArrowsLeftRight2;

// src/components/Icon/icons/ArrowsUpDown.tsx
import { jsx as jsx108, jsxs as jsxs101 } from "react/jsx-runtime";
function SvgArrowsUpDown({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs101(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx108("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx108("path", { d: "M211 467l365-365 365 365-90 90-211-210v1701H512V347L301 557l-90-90zm1536 1024l90 90-365 366-365-366 90-90 211 211V0h128v1702l211-211z" })
      ]
    }
  );
}
var ArrowsUpDown_default = SvgArrowsUpDown;

// src/components/Icon/icons/ArrowsUpDown2.tsx
import { jsx as jsx109, jsxs as jsxs102 } from "react/jsx-runtime";
function SvgArrowsUpDown2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs102(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx109("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx109("path", { d: "M0 512h1152l-576 896L0 512zm234 128l342 531 341-531H234zm1238-128l576 896H896l576-896zm0 237l-342 531h683l-341-531z" })
      ]
    }
  );
}
var ArrowsUpDown2_default = SvgArrowsUpDown2;

// src/components/Icon/icons/ArrowUp.tsx
import { jsx as jsx110, jsxs as jsxs103 } from "react/jsx-runtime";
function SvgArrowUp({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs103(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx110("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx110("path", { d: "M2029 1011l-90 90-851-851v1798H960V250l-851 851-90-90L1024 6l1005 1005z" })
      ]
    }
  );
}
var ArrowUp_default = SvgArrowUp;

// src/components/Icon/icons/Ascending.tsx
import { jsx as jsx111, jsxs as jsxs104 } from "react/jsx-runtime";
function SvgAscending({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs104(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx111("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx111("path", { d: "M1728 1024l-320 640h320v128h-512l320-640h-320v-128h512zM675 1475l90 90-317 318-317-318 90-90 163 163V128h128v1510l163-163zm605-579h-128l256-768h128l256 768h-128l-43-128h-298l-43 128zm85-256h214l-107-320-107 320z" })
      ]
    }
  );
}
var Ascending_default = SvgAscending;

// src/components/Icon/icons/AspectRatio.tsx
import { jsx as jsx112, jsxs as jsxs105 } from "react/jsx-runtime";
function SvgAspectRatio({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs105(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx112("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx112("path", { d: "M0 384h2048v1152H0V384zm128 1024h256V512H128v896zm384 0h1024V512H512v896zm1408 0V512h-256v896h256z" })
      ]
    }
  );
}
var AspectRatio_default = SvgAspectRatio;

// src/components/Icon/icons/AspectRatio2.tsx
import { jsx as jsx113, jsxs as jsxs106 } from "react/jsx-runtime";
function SvgAspectRatio2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs106(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx113("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx113("path", { d: "M0 384V256h128v128H0zm0 256V512h128v128H0zm0 256V768h128v128H0zm0 256v-128h128v128H0zm0 512v-128h128v128H0zM256 384V256h128v128H256zm0 1280v-128h128v128H256zm1664 0v-128h128v128h-128zM0 1408v-128h128v128H0zm1920 0v-128h128v128h-128zm0-256v-128h128v128h-128zm0-256V768h128v128h-128zm0-256V512h128v128h-128zm0-384h128v128h-128V256zm-256 1408v-128h128v128h-128zm0-1280V256h128v128h-128zM512 1664V256h1024v1408H512zM640 384v1152h768V384H640z" })
      ]
    }
  );
}
var AspectRatio2_default = SvgAspectRatio2;

// src/components/Icon/icons/Attach.tsx
import { jsx as jsx114, jsxs as jsxs107 } from "react/jsx-runtime";
function SvgAttach({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs107(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx114("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx114("path", { d: "M1536 384v1216q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175V320q0-66 25-124t68-101 102-69T960 0q66 0 124 25t101 69 69 102 26 124v1280q0 40-15 75t-41 61-61 41-75 15q-40 0-75-15t-61-41-41-61-15-75V512h128v1088q0 26 19 45t45 19q26 0 45-19t19-45V320q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75v1280q0 66 25 124t68 102 102 69 125 25q66 0 124-25t101-68 69-102 26-125V384h128z" })
      ]
    }
  );
}
var Attach_default = SvgAttach;

// src/components/Icon/icons/AttractMode.tsx
import { jsx as jsx115, jsxs as jsxs108 } from "react/jsx-runtime";
function SvgAttractMode({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs108(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx115("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx115("path", { d: "M1920 1408h-896v128h256v128H640v-128h256v-128H0V256h1920v1152zM1792 384h-768v896h768V384zm-1664 0v896h768V384H128zm1536 128v128h-512V512h512zm0 256v128h-512V768h512zm-384 256v128h-128v-128h128zm128 128v-128h256v128h-256z" })
      ]
    }
  );
}
var AttractMode_default = SvgAttractMode;

// src/components/Icon/icons/AvatarAward.tsx
import { jsx as jsx116, jsxs as jsxs109 } from "react/jsx-runtime";
function SvgAvatarAward({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs109(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx116("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx116("path", { d: "M1500 768h292v1280H128V768h292q-35-59-35-128 0-52 20-98t55-82 81-55 99-21q97 0 181 46t139 126q54-80 138-126t182-46q52 0 98 20t82 56 55 81 21 99q0 34-9 66t-27 62zM896 1920V896H256v1024h640zM640 768h256q0-52-20-99t-55-81-82-55-99-21q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10zm640-256q-53 0-99 20t-81 55-55 82-21 99h256q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10zm384 1408V896h-640v1024h640z" })
      ]
    }
  );
}
var AvatarAward_default = SvgAvatarAward;

// src/components/Icon/icons/AvatarItem.tsx
import { jsx as jsx117, jsxs as jsxs110 } from "react/jsx-runtime";
function SvgAvatarItem({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs110(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx117("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx117("path", { d: "M2048 384l-128 512h-256v1024H384V896H128L0 384l768-256q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100l768 256zm-153 84l-524-175q-24 50-60 90t-82 69-97 44-108 16q-56 0-108-15t-97-44-81-69-61-91L153 468l75 300h284v1024h1024V768h284l75-300z" })
      ]
    }
  );
}
var AvatarItem_default = SvgAvatarItem;

// src/components/Icon/icons/AvatarMyFeatures.tsx
import { jsx as jsx118, jsxs as jsxs111 } from "react/jsx-runtime";
function SvgAvatarMyFeatures({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs111(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx118("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx118("path", { d: "M1792 512q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10zm-468 0q52 0 101 20 71 29 113 73t72 95 57 106 70 107q15 18 36 34t45 32 48 27 46 22q18 8 29 23t11 36q0 26-19 45t-45 19q-35 0-66 5t-64 20q-50 21-82 44t-53 48-34 52-28 55-34 59-49 61q-42 42-96 73t-116 53-123 32-121 11q-58 0-120-10t-124-32-115-53-96-74q-25-25-41-52t-31-56-28-55-36-52l-2-1q-14-21-42-43t-63-41-68-31-60-13h-40q-27 0-45-19t-18-46q0-20 10-35t29-23q21-9 45-21t49-27 45-32 36-35q28-34 49-70t40-72 38-71 45-65 59-57 81-46q49-20 101-20 41 0 71 9t55 24 44 31 40 31 42 23 50 10q28 0 50-9t42-24 40-31 44-31 55-23 71-10zM720 640q-44 0-77 21t-62 55-53 76-47 85-49 81-55 65h322q160 0 323 1h323q161 0 323-1-31-24-55-61t-48-81-46-85-52-78-63-56-80-22q-26 0-47 9t-40 24-40 31-44 31-57 23-74 10q-42 0-73-9t-56-24-45-31-40-31-41-23-47-10zm302 896q45 0 95-8t100-25 93-41 77-57q21-20 34-45t27-52q23-45 48-83t62-74q-536 2-1072 0 37 33 62 73t48 84q13 25 27 51t34 46q31 32 75 56t94 41 101 25 95 9z" })
      ]
    }
  );
}
var AvatarMyFeatures_default = SvgAvatarMyFeatures;

// src/components/Icon/icons/AvatarNew.tsx
import { jsx as jsx119, jsxs as jsxs112 } from "react/jsx-runtime";
function SvgAvatarNew({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs112(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx119("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx119("path", { d: "M1280 1196q0 30-9 61t-25 58-41 49-53 32v652H512v-652q-58-22-93-69t-35-111V768q0-44 16-83t43-72 63-56 77-36q-34-43-52-94t-19-107q0-66 25-124t68-101 102-69T832 0q66 0 124 25t101 69 69 102 26 124q0 55-18 106t-53 95q41 12 77 35t64 56 42 72 16 84v428zM832 128q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15zm320 640q0-23-11-46t-30-41-41-29-46-12H640q-22 0-45 11t-41 30-30 42-12 45v448q0 27 13 40t32 19 42 6 41-1v640h128v-512h128v512h128v-640h64q15 0 27-8t20-20 12-28 5-28V768zm768 896v128h-256v256h-128v-256h-256v-128h256v-256h128v256h256z" })
      ]
    }
  );
}
var AvatarNew_default = SvgAvatarNew;

// src/components/Icon/icons/AvatarRotateLeft.tsx
import { jsx as jsx120, jsxs as jsxs113 } from "react/jsx-runtime";
function SvgAvatarRotateLeft({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs113(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx120("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx120("path", { d: "M1280 1271q38 6 91 17t110 29 112 43 100 57 71 75 28 94q0 60-35 107t-92 82-128 60-142 42-135 26-108 14v-129q50-5 116-16t134-29 129-43 101-61q11-10 21-23t11-30q0-14-9-26t-18-22q-30-28-75-50t-94-40-99-28-89-19v135h-128v-384h40q22 0 42-4t33-19 13-41V768q0-22-11-45t-30-41-42-30-45-12H768q-23 0-46 11t-41 30-29 41-12 46v300q0 13 4 28t13 27 20 21 27 8h64v384H640v-137q-39 7-88 18t-100 29-95 39-74 51q-9 9-18 22t-9 27q0 20 15 37t30 28q44 34 107 58t133 42 136 27 122 14l-49-60 99-81 169 208-207 190-87-94 40-36q-43-4-107-14t-134-27-141-42-127-61-92-82-35-107q0-52 27-94t71-75 100-58 113-42 109-29 92-18v-1q-29-11-53-32t-40-48-26-59-9-61V768q0-44 15-83t43-72 63-56 78-36q-34-43-52-94t-19-107q0-66 25-124t68-101 102-69T960 0q66 0 124 25t101 69 69 102 26 124q0 55-18 106t-53 95q40 12 76 35t64 56 43 72 16 84v320q0 63-35 110t-93 70v3zM960 128q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15zm-64 1152h128v256H896v-256z" })
      ]
    }
  );
}
var AvatarRotateLeft_default = SvgAvatarRotateLeft;

// src/components/Icon/icons/AvatarRotateRight.tsx
import { jsx as jsx121, jsxs as jsxs114 } from "react/jsx-runtime";
function SvgAvatarRotateRight({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs114(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx121("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx121("path", { d: "M1792 1585q0 60-35 106t-91 82-127 61-141 43-135 27-107 14l40 36-87 94-207-190 169-208 99 81-49 60q54-4 121-14t137-27 132-41 108-59q14-11 29-28t16-37q0-14-9-27t-18-22q-29-28-74-50t-95-40-99-28-89-19v137h-128v-384h64q15 0 27-8t20-20 12-28 5-28V768q0-23-11-46t-30-41-41-29-46-12H768q-22 0-45 11t-41 30-30 42-12 45v320q0 27 13 40t32 19 42 6 41-1v384H640v-135q-39 7-88 18t-99 29-95 39-75 51q-9 9-18 21t-9 27q0 16 10 29t22 24q39 35 100 60t129 44 134 29 117 16v129q-44-4-108-13t-135-27-142-41-127-60-92-83-36-107q0-52 27-94t72-74 99-58 113-42 110-29 91-18v-3q-58-22-93-69t-35-111V768q0-44 16-83t43-72 63-56 77-36q-34-43-52-94t-19-107q0-66 25-124t68-101 102-69T960 0q66 0 124 25t101 69 69 102 26 124q0 55-18 106t-53 95q41 12 77 35t64 56 42 72 16 84v300q0 30-9 61t-25 58-41 49-53 32v1q38 6 91 17t110 29 112 43 100 58 72 75 27 94zM960 128q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15zm64 1408H896v-256h128v256z" })
      ]
    }
  );
}
var AvatarRotateRight_default = SvgAvatarRotateRight;

// src/components/Icon/icons/BackCaseDlSet.tsx
import { jsx as jsx122, jsxs as jsxs115 } from "react/jsx-runtime";
function SvgBackCaseDlSet({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs115(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx122("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx122("path", { d: "M1408 256q26 0 45 19t19 45q0 40 15 75t41 61 61 41 75 15q21 0 37 12t24 33l273 860q9 27 9 55 0 40-15 75t-42 61-61 41-75 15h-86q-26 0-45-19l-272-271q-46-46-103-70t-123-24H863q-65 0-122 24t-104 70l-272 271q-19 19-45 19h-86q-40 0-75-15t-61-41-42-61-15-75q0-28 9-55l273-860q7-20 23-32t38-13q40 0 75-15t61-41 41-61 15-75q0-26 19-45t45-19h768zM768 768h512V384H768v384zm1020 768q16 0 32-2t29-8 21-20 8-35q0-5-10-40t-28-90-39-124-45-143-46-146-43-132-33-102-18-57q-62-10-116-42t-92-83v384H640V512q-38 51-92 83t-116 42q-5 14-18 56t-33 103-42 132-47 145-45 143-39 125-27 90-11 40q0 28 18 46t46 19h59l253-253q63-63 145-97t172-34h322q89 0 171 34t146 97l253 253h33z" })
      ]
    }
  );
}
var BackCaseDlSet_default = SvgBackCaseDlSet;

// src/components/Icon/icons/Backspace.tsx
import { jsx as jsx123, jsxs as jsxs116 } from "react/jsx-runtime";
function SvgBackspace({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs116(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx123("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx123("path", { d: "M1005 1389l-90-90 274-275-274-275 90-90 275 275 275-275 90 90-275 275 275 275-90 90-275-274-275 274zM768 256h1280v1536H768L0 1024l768-768zm1152 1408V384H821l-640 640 640 640h1099z" })
      ]
    }
  );
}
var Backspace_default = SvgBackspace;

// src/components/Icon/icons/BackToWindow.tsx
import { jsx as jsx124, jsxs as jsxs117 } from "react/jsx-runtime";
function SvgBackToWindow({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs117(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx124("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx124("path", { d: "M256 1152h640v640H768v-421L93 2045l-90-90 674-675H256v-128zm1115-384h421v128h-640V256h128v421L1955 3l90 90-674 675z" })
      ]
    }
  );
}
var BackToWindow_default = SvgBackToWindow;

// src/components/Icon/icons/BadRecommendation.tsx
import { jsx as jsx125, jsxs as jsxs118 } from "react/jsx-runtime";
function SvgBadRecommendation({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs118(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx125("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx125("path", { d: "M1024 0q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 141-36 272t-104 244-160 207-207 161-245 103-272 37q-141 0-272-36t-245-103-207-160-160-208-103-244-37-273q0-141 36-272t104-244 160-207 207-161T752 37t272-37zm0 1920q163 0 313-56t274-163L347 437Q240 560 184 710t-56 314q0 124 32 238t90 214 140 182 181 140 214 90 239 32zm677-309q107-123 163-273t56-314q0-124-32-238t-90-214-140-181-181-140-214-91-239-32q-163 0-313 56T437 347l1264 1264z" })
      ]
    }
  );
}
var BadRecommendation_default = SvgBadRecommendation;

// src/components/Icon/icons/Batteries.tsx
import { jsx as jsx126, jsxs as jsxs119 } from "react/jsx-runtime";
function SvgBatteries({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs119(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx126("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx126("path", { d: "M1920 384h128v256h-128v256H128V128h1792v256zm-128 384V256H256v512h1536zm128 256v256h128v256h-128v256H128v-768h1792zm-128 640v-512H256v512h1536z" })
      ]
    }
  );
}
var Batteries_default = SvgBatteries;

// src/components/Icon/icons/Battery1.tsx
import { jsx as jsx127, jsxs as jsxs120 } from "react/jsx-runtime";
function SvgBattery1({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs120(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx127("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx127("path", { d: "M1920 896h128v256h-128v384H128V512h1792v384zm-128 512V640H256v768h1536zM640 768v512H384V768h256z" })
      ]
    }
  );
}
var Battery1_default = SvgBattery1;

// src/components/Icon/icons/Battery2.tsx
import { jsx as jsx128, jsxs as jsxs121 } from "react/jsx-runtime";
function SvgBattery2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs121(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx128("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx128("path", { d: "M1920 896h128v256h-128v384H128V512h1792v384zm-128 512V640H256v768h1536zm-768-640v512H384V768h640z" })
      ]
    }
  );
}
var Battery2_default = SvgBattery2;

// src/components/Icon/icons/Battery3.tsx
import { jsx as jsx129, jsxs as jsxs122 } from "react/jsx-runtime";
function SvgBattery3({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs122(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx129("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx129("path", { d: "M1920 896h128v256h-128v384H128V512h1792v384zm-128 512V640H256v768h1536zm-384-640v512H384V768h1024z" })
      ]
    }
  );
}
var Battery3_default = SvgBattery3;

// src/components/Icon/icons/Battery4.tsx
import { jsx as jsx130, jsxs as jsxs123 } from "react/jsx-runtime";
function SvgBattery4({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs123(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx130("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx130("path", { d: "M1920 896h128v256h-128v384H128V512h1792v384zm-128 512V640H256v768h1536zm-128-640v512H384V768h1280z" })
      ]
    }
  );
}
var Battery4_default = SvgBattery4;

// src/components/Icon/icons/BatteryCharging.tsx
import { jsx as jsx131, jsxs as jsxs124 } from "react/jsx-runtime";
function SvgBatteryCharging({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs124(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx131("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx131("path", { d: "M2048 768v512h-128v256H512v-128h1280V640H768V512h1152v256h128zM640 832q0 57-19 109t-53 93-81 71-103 41v390H256v-390q-56-12-103-41t-81-70-53-94T0 832V512h128V256h128v256h128V256h128v256h128v320zm-512 0q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75V640H128v192z" })
      ]
    }
  );
}
var BatteryCharging_default = SvgBatteryCharging;

// src/components/Icon/icons/BatteryPack.tsx
import { jsx as jsx132, jsxs as jsxs125 } from "react/jsx-runtime";
function SvgBatteryPack({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs125(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx132("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx132("path", { d: "M1791 420v1371q0 29-12 53t-33 42-46 26-54 10H398q-27 0-52-9t-46-26-33-40-12-53V420l166-166h349V126h511v128h347l163 166zm-128 52l-88-90h-422V256H898v126H474l-91 91v1317q3 3 7 3t8 1h1248q4 0 9-1t8-4V472z" })
      ]
    }
  );
}
var BatteryPack_default = SvgBatteryPack;

// src/components/Icon/icons/Bde.tsx
import { jsx as jsx133, jsxs as jsxs126 } from "react/jsx-runtime";
function SvgBde({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs126(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx133("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx133("path", { d: "M512 896H0V384h512v512zm768 0H768V384h512v512zm-768 768H0v-512h512v512zm768 0H768v-512h512v512zm768-768h-512V384h512v512zm0 768h-512v-512h512v512z" })
      ]
    }
  );
}
var Bde_default = SvgBde;

// src/components/Icon/icons/BeaconsActivity.tsx
import { jsx as jsx134, jsxs as jsxs127 } from "react/jsx-runtime";
function SvgBeaconsActivity({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs127(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx134("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx134("path", { d: "M1856 1280v128h-512v-128q0-66-25-124t-68-102-102-69-125-25q-66 0-124 25t-102 68-69 102-25 125v128H192v-128h384q0-74 22-142t67-126L390 737l91-91 275 275q92-69 204-84V448h128v389q112 15 204 84l275-275 91 91-275 275q44 58 66 126t23 142h384z" })
      ]
    }
  );
}
var BeaconsActivity_default = SvgBeaconsActivity;

// src/components/Icon/icons/BingCloseSmall.tsx
import { jsx as jsx135, jsxs as jsxs128 } from "react/jsx-runtime";
function SvgBingCloseSmall({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs128(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx135("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx135("path", { d: "M1998 291l-733 733 733 733-241 241-733-733-733 733-241-241 733-733L50 291 291 50l733 733 733-733 241 241z" })
      ]
    }
  );
}
var BingCloseSmall_default = SvgBingCloseSmall;

// src/components/Icon/icons/Block.tsx
import { jsx as jsx136, jsxs as jsxs129 } from "react/jsx-runtime";
function SvgBlock({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs129(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx136("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx136("path", { d: "M1301 1110q-54 33-101 77-91-81-201-121t-231-41q-135 0-251 49t-203 136-136 203-50 252H0q0-121 35-233t99-206 157-167 206-114q-56-35-100-82t-76-104-48-118-17-129q0-106 40-199t110-162T569 41 768 0q106 0 199 40t162 110 110 163 41 199q0 66-17 128t-48 119-76 103-100 83q74 26 139 68t123 97zM384 512q0 80 30 149t82 122 122 83 150 30q79 0 149-30t122-82 83-122 30-150q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149zm1216 640q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm-320 448q0 66 25 124t68 102 102 69 125 25q47 0 92-13t84-40l-443-443q-26 39-39 84t-14 92zm587 176q26-39 39-84t14-92q0-66-25-124t-69-101-102-69-124-26q-47 0-92 13t-84 40l443 443z" })
      ]
    }
  );
}
var Block_default = SvgBlock;

// src/components/Icon/icons/Blueray.tsx
import { jsx as jsx137, jsxs as jsxs130 } from "react/jsx-runtime";
function SvgBlueray({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs130(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx137("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx137("path", { d: "M1189 646q86 6 170 19t170 33q43 11 98 28t113 42 113 57 98 72 70 87 27 104q0 63-33 116t-86 96-122 76-137 58-135 41-113 26q-99 18-198 26t-200 9q-139 0-277-16t-272-54q42 2 82 4t83 2q100 0 199-8t199-27q48-9 113-25t134-42 138-58 121-77 87-95 33-116q0-52-24-97t-63-84-89-69-103-56-104-42-92-30zm91 442q0 29-22 52t-59 41-79 33-86 24-78 16-55 9q-65 9-130 13t-131 4q-66 0-131-4t-130-13q-20-2-55-8t-78-16-85-24-79-33-59-42-23-52l256-384h320L432 921q51-13 103-19t105-6q66 0 131 4t130 13q19 3 55 9t78 15 85 24 80 33 58 42 23 52zm-960 0q0 14 19 24t50 17 66 11 69 7 58 4 34 1q9 0 34-1t58-3 69-7 66-12 49-17 20-24q0-14-19-24t-50-17-66-11-69-7-58-4-34-1q-9 0-34 1t-58 3-69 7-66 12-49 17-20 24z" })
      ]
    }
  );
}
var Blueray_default = SvgBlueray;

// src/components/Icon/icons/Bluetooth.tsx
import { jsx as jsx138, jsxs as jsxs131 } from "react/jsx-runtime";
function SvgBluetooth({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs131(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx138("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx138("path", { d: "M1024 2011v-768l-339 338-90-90 402-403-402-403 90-90 339 339V166l538 538-384 384 384 384-538 539zm128-768v459l229-230-229-229zm0-768v459l229-230-229-229z" })
      ]
    }
  );
}
var Bluetooth_default = SvgBluetooth;

// src/components/Icon/icons/BluRayRgby.tsx
import { jsx as jsx139, jsxs as jsxs132 } from "react/jsx-runtime";
function SvgBluRayRgby({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs132(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx139("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx139("path", { d: "M384 384h1280v1280H384V384zm1152 1152V512H512v1024h1024z" })
      ]
    }
  );
}
var BluRayRgby_default = SvgBluRayRgby;

// src/components/Icon/icons/BluRaySubtitles.tsx
import { jsx as jsx140, jsxs as jsxs133 } from "react/jsx-runtime";
function SvgBluRaySubtitles({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs133(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx140("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx140("path", { d: "M0 192h2048v1408H704l-448 448v-448H0V192zm1920 1280V320H128v1152h256v267l267-267h1269zm-128-256v128H256v-128h1536zm0-256v128H256V960h1536z" })
      ]
    }
  );
}
var BluRaySubtitles_default = SvgBluRaySubtitles;

// src/components/Icon/icons/Body.tsx
import { jsx as jsx141, jsxs as jsxs134 } from "react/jsx-runtime";
function SvgBody({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs134(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx141("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx141("path", { d: "M1209 521q41 12 77 35t64 56 42 72 16 84v428q0 30-9 61t-25 58-41 49-53 32v652H640v-652q-58-22-93-69t-35-111V768q0-44 16-83t43-72 63-56 77-36q-34-43-52-94t-19-107q0-66 25-124t68-101 102-69T960 0q66 0 124 25t101 69 69 102 26 124q0 55-18 106t-53 95zM960 128q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15zm320 640q0-23-11-46t-30-41-41-29-46-12H768q-22 0-45 11t-41 30-30 42-12 45v448q0 27 13 40t32 19 42 6 41-1v640h128v-512h128v512h128v-640h64q15 0 27-8t20-20 12-28 5-28V768z" })
      ]
    }
  );
}
var Body_default = SvgBody;

// src/components/Icon/icons/BodyAthleticFeminine.tsx
import { jsx as jsx142, jsxs as jsxs135 } from "react/jsx-runtime";
function SvgBodyAthleticFeminine({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs135(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx142("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx142("path", { d: "M1536 384q0 60-18 116t-51 103-79 83-102 58q58 54 90 127t32 153q0 69-24 133l-252 682q-18 47-48 85t-69 66-85 43-98 15q-66 0-124-25t-102-68-69-102-25-125q0-14 1-28t4-29l129-716q9-50 30-95t53-82 73-67 88-47q-58-54-90-127t-32-153q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149zM832 1920q30 0 57-9t52-25 42-40 29-51l153-414q-68 27-141 27h-64q-26 0-45-19t-19-45q0-26 19-45t45-19h64q53 0 100-20t81-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-47 0-89 15t-75 44-57 66-31 85l-129 716q-3 17-3 34 0 40 15 75t41 61 61 41 75 15zm320-1280q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100q0 53 20 99t55 82 81 55 100 20z" })
      ]
    }
  );
}
var BodyAthleticFeminine_default = SvgBodyAthleticFeminine;

// src/components/Icon/icons/BodyAthleticMasculine.tsx
import { jsx as jsx143, jsxs as jsxs136 } from "react/jsx-runtime";
function SvgBodyAthleticMasculine({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs136(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx143("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx143("path", { d: "M1326 726q47 30 85 69t67 85 43 98 15 110q0 74-25 141t-74 124l-488 581q-45 54-109 84t-136 30q-66 0-124-25t-102-68-69-102-25-125q0-32 6-62l130-655q13-67 47-125t82-103 109-78 125-48q-56-54-85-124t-30-149q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 54-14 105t-42 95-67 81-87 61zm-174-598q-53 0-99 20t-82 55-55 81-20 100q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20zm161 1174q21-25 38-48t30-49 20-54 7-63q0-75-34-134t-90-101-123-63-137-22q-62 0-124 17t-114 52-90 84-51 115l-129 654q-4 17-4 38 0 40 15 75t41 61 61 41 75 15q43 0 81-18t66-51l272-323q-25 4-49 6t-50 2H832q-26 0-45-19t-19-45q0-26 19-45t45-19q66 0 127 1t119-5 113-27 108-66q6-6 14-9z" })
      ]
    }
  );
}
var BodyAthleticMasculine_default = SvgBodyAthleticMasculine;

// src/components/Icon/icons/BodyAverageFeminine.tsx
import { jsx as jsx144, jsxs as jsxs137 } from "react/jsx-runtime";
function SvgBodyAverageFeminine({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs137(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx144("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx144("path", { d: "M1236 704q35 22 64 53t51 67 36 76 19 81l63 569q3 26 3 50 0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-24 3-50l63-569q4-41 18-81t37-76 51-67 64-53q-40-27-72-62t-54-76-34-87-12-95q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 48-12 94t-34 88-54 76-72 62zM768 384q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100zm256 1536q66 0 124-25t101-68 69-102 26-125v-18q0-9-2-18l-64-569q-6-48-28-89t-56-72-77-48-93-18q-49 0-92 17t-78 48-56 72-28 90l-64 569q-1 9-1 18t-1 18q0 66 25 124t68 102 102 69 125 25z" })
      ]
    }
  );
}
var BodyAverageFeminine_default = SvgBodyAverageFeminine;

// src/components/Icon/icons/BodyAverageMasculine.tsx
import { jsx as jsx145, jsxs as jsxs138 } from "react/jsx-runtime";
function SvgBodyAverageMasculine({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs138(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx145("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx145("path", { d: "M1245 698q52 30 94 72t72 92 45 108 16 118q0 25-3 50l-63 569q-8 72-41 134t-85 109-117 72-139 26q-73 0-138-26t-117-72-85-108-42-135l-63-569q-3-25-3-50 0-61 16-118t45-107 71-93 95-72q-77-55-120-137t-43-177q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 94-43 176t-120 138zM768 384q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100zm256 1536q49 0 92-17t78-48 56-72 28-90l64-569q1-9 1-18t1-18q0-66-25-124t-69-101-102-69-124-26q-66 0-124 25t-102 69-69 102-25 124v18q0 9 2 18l64 569q6 48 28 89t56 72 77 48 93 18z" })
      ]
    }
  );
}
var BodyAverageMasculine_default = SvgBodyAverageMasculine;

// src/components/Icon/icons/BodyChubbyFeminine.tsx
import { jsx as jsx146, jsxs as jsxs139 } from "react/jsx-runtime";
function SvgBodyChubbyFeminine({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs139(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx146("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx146("path", { d: "M1263 684q50 20 96 49t83 68 61 86 31 104l64 569q1 10 1 20t1 20q0 73-25 135t-67 112-99 87-121 63-132 38-132 13q-64 0-132-13t-132-38-120-62-99-88-68-111-25-136v-20q0-10 2-20l64-569q6-56 30-103t62-87 83-68 96-49q-69-54-107-133t-38-167q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 88-38 167t-107 133zM768 384q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100zm256 1536q45 0 96-8t101-26 95-44 80-62 55-81 21-99v-12q0-6-1-13l-64-570q-7-62-48-106t-98-74-120-43-117-14q-53 0-116 14t-121 43-98 73-48 107l-64 570q-1 6-1 12t0 13q0 54 20 99t55 80 80 62 96 44 100 26 97 9z" })
      ]
    }
  );
}
var BodyChubbyFeminine_default = SvgBodyChubbyFeminine;

// src/components/Icon/icons/BodyChubbyMasculine.tsx
import { jsx as jsx147, jsxs as jsxs140 } from "react/jsx-runtime";
function SvgBodyChubbyMasculine({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs140(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx147("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx147("path", { d: "M1267 681q66 24 126 62t106 90 73 116 28 139v20q0 10-2 20l-64 569q-7 59-32 108t-65 89-88 68-104 48-111 28-110 10q-80 0-165-21t-159-65-125-110-61-155l-64-569q-1-10-1-20t-1-20q0-75 27-139t74-115 106-90 126-63q-67-55-104-132t-37-165q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 87-37 164t-104 133zM768 384q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100zm256 1536q53 0 116-14t121-43 98-73 48-107l64-570q1-6 1-12t0-13q0-54-20-99t-55-80-80-62-96-44-101-26-96-9q-45 0-96 8t-101 26-95 44-80 62-55 81-21 99v12q0 6 1 13l64 570q7 62 48 106t98 74 120 43 117 14z" })
      ]
    }
  );
}
var BodyChubbyMasculine_default = SvgBodyChubbyMasculine;

// src/components/Icon/icons/BodyHeavyFeminine.tsx
import { jsx as jsx148, jsxs as jsxs141 } from "react/jsx-runtime";
function SvgBodyHeavyFeminine({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs141(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx148("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx148("path", { d: "M1280 670q70 17 144 48t137 79 108 109 56 142l65 482q2 9 2 19t0 19q0 54-18 104t-49 95q-54 77-137 130t-179 87-196 49-189 15q-89 0-189-15t-196-48-179-87-137-131q-31-45-49-95t-18-104q0-20 3-41l64-479q10-79 55-141t108-110 138-78 144-49q-61-54-94-129t-34-157q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 82-33 157t-95 129zM768 384q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100zm256 1536q129 0 254-30 36-9 79-24t86-35 83-47 70-60 49-72 19-84v-14q0-7-2-15l-64-474q-5-34-21-64t-40-55-52-47-57-37q-44-25-94-42t-102-29-105-17-103-6q-50 0-103 5t-105 17-102 29-94 43q-29 16-57 37t-52 46-40 56-21 64l-64 478q-1 6-1 12t-1 13q0 45 18 84t49 72 71 59 83 47 85 36 80 24q124 30 254 30z" })
      ]
    }
  );
}
var BodyHeavyFeminine_default = SvgBodyHeavyFeminine;

// src/components/Icon/icons/BodyHeavyMasculine.tsx
import { jsx as jsx149, jsxs as jsxs142 } from "react/jsx-runtime";
function SvgBodyHeavyMasculine({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs142(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx149("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx149("path", { d: "M1283 667q54 12 113 32t115 49 108 66 89 84 61 101 23 121q0 20-3 41-16 121-31 239t-33 240q-11 77-54 139t-104 108-134 78-140 50q-66 17-133 25t-136 8q-68 0-135-8t-134-25q-68-18-140-49t-133-78-105-109-54-139q-17-120-32-238t-32-238q-3-21-3-44 0-65 22-120t61-102 90-83 107-67 115-49 114-32q-60-54-92-128t-33-155q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 81-32 155t-93 128zM768 384q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100zm256 1536q50 0 103-5t105-17 102-29 94-43q28-16 56-37t53-46 40-55 21-65l64-478q1-6 1-12t1-13q0-45-18-84t-49-72-71-59-83-47-86-36-79-24q-125-30-254-30-130 0-254 30-36 9-79 24t-86 35-83 47-70 60-49 72-19 84v14q0 6 2 15l64 474q4 35 20 64t41 55 52 47 57 37q44 25 94 42t102 29 105 17 103 6z" })
      ]
    }
  );
}
var BodyHeavyMasculine_default = SvgBodyHeavyMasculine;

// src/components/Icon/icons/BodyMannequin.tsx
import { jsx as jsx150, jsxs as jsxs143 } from "react/jsx-runtime";
function SvgBodyMannequin({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs143(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx150("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx150("path", { d: "M1236 704q40 27 72 62t54 76 34 88 12 94v640q0 80-30 149t-82 122-123 83-149 30q-80 0-149-30t-122-82-83-122-30-150v-640q0-48 12-94t34-87 54-77 72-62q-40-27-72-62t-54-76-34-87-12-95q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 48-12 94t-34 88-54 76-72 62zM768 384q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100zm512 640q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100v640q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100v-640z" })
      ]
    }
  );
}
var BodyMannequin_default = SvgBodyMannequin;

// src/components/Icon/icons/BodyPregnant.tsx
import { jsx as jsx151, jsxs as jsxs144 } from "react/jsx-runtime";
function SvgBodyPregnant({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs144(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx151("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx151("path", { d: "M1236 704q35 22 64 53t51 67 36 76 19 81l63 569q3 26 3 50 0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-24 3-50l63-569q4-41 18-81t37-76 51-67 64-53q-40-27-72-62t-54-76-34-87-12-95q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 48-12 94t-34 88-54 76-72 62zM768 384q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100zm256 1536q66 0 124-25t101-68 69-102 26-125v-18q0-9-2-18l-64-569q-6-48-28-89t-56-72-77-48-93-18q-49 0-92 17t-78 48-56 72-28 90l-64 569q-1 9-1 18t-1 18q0 66 25 124t68 102 102 69 125 25zm0-512q40 0 75 15t61 41 41 61 15 75q0 40-15 75t-41 61-61 41-75 15q-40 0-75-15t-61-41-41-61-15-75q0-40 15-75t41-61 61-41 75-15z" })
      ]
    }
  );
}
var BodyPregnant_default = SvgBodyPregnant;

// src/components/Icon/icons/BodySkinnyFeminine.tsx
import { jsx as jsx152, jsxs as jsxs145 } from "react/jsx-runtime";
function SvgBodySkinnyFeminine({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs145(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx152("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx152("path", { d: "M1225 711q51 42 81 98t37 122l63 698q1 9 1 17t1 18q0 80-30 149t-82 122-123 83-149 30q-80 0-149-30t-122-82-83-122-30-150v-17q0-8 2-18l63-698q6-66 36-122t82-98q-42-26-76-62t-58-78-36-89-13-98q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 50-12 97t-37 90-58 78-76 62zM768 384q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100zm256 1536q53 0 99-20t82-55 55-81 20-100v-12q0-6-1-12l-64-698q-3-37-19-69t-42-55-59-36-71-14q-38 0-71 13t-58 37-42 55-20 69l-64 698q-1 6-1 12t0 12q0 53 20 99t55 82 81 55 100 20z" })
      ]
    }
  );
}
var BodySkinnyFeminine_default = SvgBodySkinnyFeminine;

// src/components/Icon/icons/BodySkinnyMasculine.tsx
import { jsx as jsx153, jsxs as jsxs146 } from "react/jsx-runtime";
function SvgBodySkinnyMasculine({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs146(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx153("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx153("path", { d: "M1236 704q40 27 72 62t54 76 34 88 12 94v17q0 8-2 18l-63 698q-6 62-33 115t-70 92-98 61-118 23q-62 0-117-22t-99-62-70-92-33-115l-63-698q-1-9-1-17t-1-18q0-48 12-94t34-87 54-77 72-62q-40-27-72-62t-54-76-34-87-12-95q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 48-12 94t-34 88-54 76-72 62zM768 384q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100zm256 1536q37 0 70-13t59-37 42-55 20-69l64-698q1-6 1-12t0-12q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100v12q0 6 1 12l64 698q3 37 19 69t42 55 59 36 71 14z" })
      ]
    }
  );
}
var BodySkinnyMasculine_default = SvgBodySkinnyMasculine;

// src/components/Icon/icons/BodyStrongFeminine.tsx
import { jsx as jsx154, jsxs as jsxs147 } from "react/jsx-runtime";
function SvgBodyStrongFeminine({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs147(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx154("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx154("path", { d: "M1309 641q61 6 114 33t93 70 61 98 23 118v192q0 58-20 113l-248 659q-11 28-29 50t-42 39-51 26-58 9H896q-30 0-58-9t-51-25-42-40-29-51l-248-658q-20-55-20-113V960q0-62 22-117t62-99 92-70 115-33q-48-53-73-119t-26-138q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 72-25 138t-74 119zm-285-513q-53 0-99 20t-82 55-55 81-20 100q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20zm448 832q0-40-15-75t-41-61-61-41-75-15H768q-40 0-75 15t-61 41-41 61-15 75v192q0 35 12 68l248 658q7 19 23 30t37 12h256q20 0 36-11t24-31l248-658q12-33 12-68V960z" })
      ]
    }
  );
}
var BodyStrongFeminine_default = SvgBodyStrongFeminine;

// src/components/Icon/icons/BodyStrongMasculine.tsx
import { jsx as jsx155, jsxs as jsxs148 } from "react/jsx-runtime";
function SvgBodyStrongMasculine({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs148(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx155("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx155("path", { d: "M1344 640q66 0 124 25t101 69 69 102 26 124v256q0 62-25 123l-246 591q-23 54-70 86t-107 32H832q-59 0-106-32t-71-86l-246-591q-25-61-25-123V960q0-66 25-124t68-101 102-69 125-26h34q-48-53-73-119t-25-137q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 71-25 137t-73 119h34zM768 384q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100zm768 576q0-40-15-75t-41-61-61-41-75-15H704q-40 0-75 15t-61 41-41 61-15 75v256q0 40 15 74l246 591q8 17 24 28t35 11h384q19 0 35-11t24-28l246-591q15-34 15-74V960z" })
      ]
    }
  );
}
var BodyStrongMasculine_default = SvgBodyStrongMasculine;

// src/components/Icon/icons/Brightness.tsx
import { jsx as jsx156, jsxs as jsxs149 } from "react/jsx-runtime";
function SvgBrightness({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs149(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx156("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx156("path", { d: "M1408 960q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35q93 0 174 35t143 96 96 142 35 175zm-448 320q66 0 124-25t101-68 69-102 26-125q0-66-25-124t-69-101-102-69-124-26q-66 0-124 25t-102 69-69 102-25 124q0 66 25 124t68 102 102 69 125 25zM1024 0v384H896V0h128zM896 1920v-384h128v384H896zm640-1024h384v128h-384V896zm-1152 0v128H0V896h384zm214-389l-91 91-271-272 90-90 272 271zm724 906l91-91 271 272-90 90-272-271zm362-1087l-271 272-91-91 272-271 90 90zM236 1594l271-272 91 91-272 271-90-90z" })
      ]
    }
  );
}
var Brightness_default = SvgBrightness;

// src/components/Icon/icons/Broadcasting.tsx
import { jsx as jsx157, jsxs as jsxs150 } from "react/jsx-runtime";
function SvgBroadcasting({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs150(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx157("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx157("path", { d: "M986 1152l589 588-45 46q-62 63-136 111t-155 82-168 51-175 18q-124 0-238-32t-214-90-181-140-140-181-91-214-32-239q0-88 17-174t51-168 82-156 112-136l46-45 588 589 132-133q-4-15-4-33 0-27 10-50t27-40 41-28 50-10q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10q-18 0-33-4l-133 132zm-90 768q137 0 264-46t232-135L310 656q-88 105-135 232t-47 264q0 106 27 204t78 183 120 156 155 120 184 77 204 28zm128-1536q88 0 170 23t153 64 129 100 100 130 65 153 23 170h-128q0-106-40-199t-110-162-163-110-199-41V384zm0-384q141 0 272 36t244 104 207 160 161 207 103 245 37 272h-128q0-123-32-237t-90-214-141-182-181-140-214-91-238-32V0z" })
      ]
    }
  );
}
var Broadcasting_default = SvgBroadcasting;

// src/components/Icon/icons/Browser.tsx
import { jsx as jsx158, jsxs as jsxs151 } from "react/jsx-runtime";
function SvgBrowser({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs151(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx158("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx158("path", { d: "M128 256h1792v1536H128V256zm1664 256V384H768v128h1024zm-1280 0h128V384H512v128zM384 384H256v128h128V384zM256 1664h1536V640H256v1024z" })
      ]
    }
  );
}
var Browser_default = SvgBrowser;

// src/components/Icon/icons/BrowserCursor.tsx
import { jsx as jsx159, jsxs as jsxs152 } from "react/jsx-runtime";
function SvgBrowserCursor({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs152(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx159("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx159("path", { d: "M1024 128q124 0 238 32t214 90 181 140 140 181 91 214 32 239q0 124-32 238t-90 214-140 181-181 140-214 91-239 32q-124 0-238-32t-214-90-181-140-140-181-91-214-32-239V128h896zm0 1664q106 0 204-27t183-78 156-120 120-155 77-184 28-204q0-106-27-204t-78-183-120-156-155-120-184-77-204-28H256v768q0 106 27 204t78 183 120 156 155 120 184 77 204 28zm0-1280q106 0 199 40t163 109 110 163 40 200q0 106-40 199t-109 163-163 110-200 40q-106 0-199-40t-163-109-110-163-40-200q0-106 40-199t109-163 163-110 200-40zm0 896q79 0 149-30t122-82 83-122 30-150q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149q0 80 30 149t82 122 122 83 150 30z" })
      ]
    }
  );
}
var BrowserCursor_default = SvgBrowserCursor;

// src/components/Icon/icons/BrowserHistory.tsx
import { jsx as jsx160, jsxs as jsxs153 } from "react/jsx-runtime";
function SvgBrowserHistory({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs153(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx160("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx160("path", { d: "M1024 512v550l365 365-90 90-403-402V512h128zm0-512q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 141-36 272t-103 245-160 207-208 160-245 103-272 37q-172 0-330-55t-289-154-226-238-141-304l123-34q40 145 123 265t198 208 253 135 289 49q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-129 0-251 36T546 267 355 428 215 640h297v128H0V256h128v274q67-123 163-221t212-166T752 37t272-37z" })
      ]
    }
  );
}
var BrowserHistory_default = SvgBrowserHistory;

// src/components/Icon/icons/BrowserPrivate.tsx
import { jsx as jsx161, jsxs as jsxs154 } from "react/jsx-runtime";
function SvgBrowserPrivate({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs154(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx161("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx161("path", { d: "M512 768H0V256h128v274q67-122 163-220t213-167T752 37t272-37q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 44-4 87t-12 87q-52-57-116-97 2-20 3-38t1-39q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-129 0-251 36T546 267 355 428 215 640h297v128zm1088 384q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm-320 448q0 66 25 124t68 102 102 69 125 25q47 0 92-13t84-40l-443-443q-26 39-39 84t-14 92zm587 176q26-39 39-84t14-92q0-66-25-124t-69-101-102-69-124-26q-47 0-92 13t-84 40l443 443zm-766 140q40 64 97 116-43 8-86 12t-88 4q-114 0-223-25t-209-71-187-114-159-150-124-182-84-209l123-34q40 145 123 265t198 208 253 135 289 49q20 0 38-1t39-3zm-77-1404v549l140 141q-44 48-75 105l-193-192V512h128z" })
      ]
    }
  );
}
var BrowserPrivate_default = SvgBrowserPrivate;

// src/components/Icon/icons/Bug.tsx
import { jsx as jsx162, jsxs as jsxs155 } from "react/jsx-runtime";
function SvgBug({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs155(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx162("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx162("path", { d: "M1608 897q65 2 122 27t99 69 66 100 25 123v192h-128v-192q0-32-10-61t-29-54-45-42-57-27q6 29 9 59t4 61v256q0 7-1 13t-2 13l6-6q60 60 92 138t32 163q0 85-32 162t-92 138l-90-90q42-42 64-95t22-114q0-68-31-132-31 100-90 183t-140 142-176 92-202 33q-105 0-201-33t-177-92-139-142-91-183q-31 64-31 132 0 60 22 113t64 96l-90 90q-60-60-92-137t-33-163q0-85 32-163t93-138l6 6q-1-7-2-13t-1-13v-256q0-30 3-60t10-60q-31 9-57 26t-44 42-29 54-11 62v192H128v-192q0-65 24-122t67-101 99-68 122-28q31-70 80-135-57-10-105-38t-84-71-55-94-20-111V256h128v192q0 40 15 75t41 61 61 41 75 15h64v3q47-35 96-59-15-32-23-66t-9-70q0-70 31-135L595 173l90-90 127 127q45-39 98-60t114-22q60 0 113 21t99 61l127-127 90 90-140 140q31 65 31 135 0 35-8 69t-24 67q26 13 49 27t47 32v-3h64q40 0 75-15t61-41 41-61 15-75V256h128v192q0 58-20 110t-55 95-83 70-106 39q49 65 80 135zm-584-641q-40 0-75 15t-61 41-41 61-15 75q0 50 24 90 42-11 83-17t85-7q43 0 84 6t84 18q24-40 24-90 0-40-15-75t-41-61-61-41-75-15zm512 1152v-256q0-104-41-197t-110-163-163-111-198-41q-105 0-198 41T664 792 553 955t-41 197v256q0 106 40 199t110 162 163 110 199 41q106 0 199-40t162-110 110-163 41-199z" })
      ]
    }
  );
}
var Bug_default = SvgBug;

// src/components/Icon/icons/BuildRelationship.tsx
import { jsx as jsx163, jsxs as jsxs156 } from "react/jsx-runtime";
function SvgBuildRelationship({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs156(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx163("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx163("path", { d: "M1760 1134q61 0 113 21t92 59 61 90 22 113q0 57-21 109t-63 94l-428 428-428-428q-41-41-62-93t-22-110q0-61 22-113t62-90 91-61 113-22q69 0 123 26t101 77q49-49 101-74t123-26zm114 396q23-23 34-52t12-61q0-35-12-64t-33-49-51-32-64-12q-31 0-60 10t-53 33l-111 111-111-111q-23-23-52-34t-61-11q-34 0-63 12t-51 33-34 51-13 63q0 31 12 60t35 53l338 338 338-338zm-668-491q-36 10-70 25t-65 39q-70-38-146-58t-157-21q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170H0q0-120 35-231t101-205 156-167 204-115q-113-74-176-186t-64-248q0-106 40-199t109-163T568 40 768 0q106 0 199 40t163 109 110 163 40 200q0 68-16 131t-48 118-77 103-102 84q89 34 169 91zM384 512q0 80 30 149t82 122 122 83 150 30q79 0 149-30t122-82 83-122 30-150q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149z" })
      ]
    }
  );
}
var BuildRelationship_default = SvgBuildRelationship;

// src/components/Icon/icons/BumperLeft.tsx
import { jsx as jsx164, jsxs as jsxs157 } from "react/jsx-runtime";
function SvgBumperLeft({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs157(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx164("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx164("path", { d: "M640 1280h256v128H512V768h128v512zm765-210q32 28 49 66t18 80q0 40-15 75t-41 61-61 41-75 15h-256V768h224q40 0 75 15t61 41 41 61 15 75q0 61-35 110zm-253-46h96q26 0 45-19t19-45q0-26-19-45t-45-19h-96v128zm128 256q26 0 45-19t19-45q0-26-19-45t-45-19h-128v128h128zm224-896q57 0 110 21t95 62l256 256q41 41 62 94t21 111q0 60-8 123t-27 121l-96 286q-5 13-8 24t-9 23q-19 38-47 68t-64 50-75 30-82 11H256q-53 0-99-20t-82-55-55-81-20-100v-8l64-508q2-13 2-25t4-25q12-51 42-93t69-76q64-57 152-101t191-76 212-53 217-35 208-18 183-6h160zm128 1152q47 0 89-21t64-65q4-8 6-15t4-15l96-287q16-48 22-101t7-104q0-32-11-62t-35-53l-255-255q-23-23-53-34t-62-12h-160q-102 0-209 6t-216 22-212 39-201 60q-24 9-56 22t-68 32-69 41-61 47-43 55-17 60v4q0 2-1 4l-63 507q-1 5 1 14t3 15q6 21 17 38t28 31 37 20 42 7h1376z" })
      ]
    }
  );
}
var BumperLeft_default = SvgBumperLeft;

// src/components/Icon/icons/BumperLeftDlSet.tsx
import { jsx as jsx165, jsxs as jsxs158 } from "react/jsx-runtime";
function SvgBumperLeftDlSet({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs158(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx165("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx165("path", { d: "M1504 384q57 0 110 21t95 62l256 256q41 41 62 94t21 111q0 60-8 123t-27 121l-96 286q-5 13-8 24t-9 23q-19 38-47 68t-64 50-75 30-82 11H256q-53 0-99-20t-82-55-55-81-20-100v-8l64-508q2-13 2-25t4-25q12-51 42-93t69-76q64-57 152-101t191-76 212-53 217-35 208-18 183-6h160zm128 1152q47 0 89-21t64-65q4-8 6-15t4-15l96-287q16-48 22-101t7-104q0-32-11-62t-35-53l-255-255q-23-23-53-34t-62-12h-160q-102 0-209 6t-216 22-212 39-201 60q-24 9-56 22t-68 32-69 41-61 47-43 55-17 60v4q0 2-1 4l-63 509q0 5 1 14t3 13q6 21 17 38t28 31 37 20 42 7h1376z" })
      ]
    }
  );
}
var BumperLeftDlSet_default = SvgBumperLeftDlSet;

// src/components/Icon/icons/BumperLeftSolid.tsx
import { jsx as jsx166, jsxs as jsxs159 } from "react/jsx-runtime";
function SvgBumperLeftSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs159(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx166("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx166("path", { d: "M2048 928q0 62-7 123t-28 121l-96 286-8 24q-4 12-9 23-19 38-47 68t-64 50-75 30-82 11H256q-38 0-74-11t-67-31-55-50-40-64q-8-18-14-45t-7-50q0-9 1-13l64-508q3-21 6-39t8-36 13-34 21-34q48-67 123-118t166-90 192-66 201-44 195-27 172-14q87-5 171-5t172-1q57 0 110 21t95 62l256 256q41 41 62 94t21 111zM896 1408v-128H640V768H512v640h384zm576-192q0-43-17-80t-50-66q35-50 35-110 0-40-15-75t-41-61-61-41-75-15h-224v640h256q40 0 75-15t61-41 41-61 15-75zm-224-192h-96V896h96q26 0 45 19t19 45q0 26-19 45t-45 19zm32 128q26 0 45 19t19 45q0 26-19 45t-45 19h-128v-128h128z" })
      ]
    }
  );
}
var BumperLeftSolid_default = SvgBumperLeftSolid;

// src/components/Icon/icons/BumperRight.tsx
import { jsx as jsx167, jsxs as jsxs160 } from "react/jsx-runtime";
function SvgBumperRight({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs160(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx167("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx167("path", { d: "M960 992q0 58-28 108t-77 82l112 226H825l-97-192h-88v192H512V768h224q46 0 87 17t71 48 48 72 18 87zm-320 96h96q40 0 68-28t28-68q0-40-28-68t-68-28h-96v192zm893-18q32 28 49 66t18 80q0 40-15 75t-41 61-61 41-75 15h-256V768h224q40 0 75 15t61 41 41 61 15 75q0 61-35 110zm-253-46h96q26 0 45-19t19-45q0-26-19-45t-45-19h-96v128zm128 256q26 0 45-19t19-45q0-26-19-45t-45-19h-128v128h128zm640 128q0 53-20 99t-55 82-81 55-100 20H416q-103 0-178-54t-108-152l-95-286q-19-57-27-120T0 928q0-57 21-110t62-95l256-256q41-41 94-62t111-21h160q82 0 182 5t208 19 218 34 211 54 190 76 154 101q38 34 68 76t43 93q3 13 3 25t3 25l64 508v8zm-256 128q22 0 42-7t36-20 28-30 18-39q1-4 3-13t1-15l-63-508v-4q0-2-1-4 0-31-16-60t-44-54-61-48-69-40-67-32-57-23q-96-35-200-59t-213-40-215-21-210-7H544q-32 0-62 11t-53 35L174 813q-23 23-34 53t-12 62q0 51 6 104t23 101l96 287q2 8 4 15t6 15q23 43 64 64t89 22h1376z" })
      ]
    }
  );
}
var BumperRight_default = SvgBumperRight;

// src/components/Icon/icons/BumperRightDlSet.tsx
import { jsx as jsx168, jsxs as jsxs161 } from "react/jsx-runtime";
function SvgBumperRightDlSet({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs161(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx168("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx168("path", { d: "M2048 1408q0 53-20 99t-55 82-81 55-100 20H416q-103 0-178-54t-108-152l-95-286q-19-57-27-120T0 928q0-57 21-110t62-95l256-256q41-41 94-62t111-21h160q82 0 182 5t208 19 218 34 211 54 190 76 154 101q38 34 68 76t43 93q3 13 3 25t3 25l64 508v8zm-256 128q22 0 42-7t36-20 28-30 18-39q1-3 2-12t2-16l-63-508v-4q0-2-1-4 0-31-16-60t-44-54-61-48-69-40-67-32-57-23q-96-35-200-59t-213-40-215-21-210-7H544q-32 0-62 11t-53 35L174 813q-23 23-34 53t-12 62q0 51 6 104t23 101l96 287q2 8 4 15t6 15q23 43 64 64t89 22h1376z" })
      ]
    }
  );
}
var BumperRightDlSet_default = SvgBumperRightDlSet;

// src/components/Icon/icons/BumperRightSolid.tsx
import { jsx as jsx169, jsxs as jsxs162 } from "react/jsx-runtime";
function SvgBumperRightSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs162(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx169("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx169("path", { d: "M1376 1024h-96V896h96q26 0 45 19t19 45q0 26-19 45t-45 19zM736 896q41 0 68 27t28 69q0 41-27 68t-69 28h-96V896h96zm672 256q26 0 45 19t19 45q0 26-19 45t-45 19h-128v-128h128zm640 256q0 53-20 99t-55 82-81 55-100 20H398q-48 0-90-16t-77-43-60-65-41-82l-95-286q-20-59-27-120T0 928q0-57 21-110t62-95l256-256q28-28 58-44t62-26 65-11 69-3h54q27 0 57 1 86 0 195 6t228 22 239 42 229 67 197 97 144 131q26 35 34 68t14 75l64 508v8zm-1223 0h142l-112-226q50-32 77-81t28-109q0-33-10-65t-28-59-43-48-56-35q-14-6-35-11t-37-6H512v640h128v-192h88l97 192zm775-192q0-43-17-80t-50-66q35-50 35-110 0-40-15-75t-41-61-61-41-75-15h-224v640h256q40 0 75-15t61-41 41-61 15-75z" })
      ]
    }
  );
}
var BumperRightSolid_default = SvgBumperRightSolid;

// src/components/Icon/icons/Bundle.tsx
import { jsx as jsx170, jsxs as jsxs163 } from "react/jsx-runtime";
function SvgBundle({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs163(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx170("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx170("path", { d: "M960 88l832 416v1040l-832 416-832-416V504L960 88zM256 583v882l256 128V697l305-153-241-120-320 159zm384 1073l320 160 320-160V776L960 616 640 776v880zm1024-191V583l-320-159-97 48-143-72 97-48-241-120-241 120 241 120h1l143 72h-1l305 153v896l256-128z" })
      ]
    }
  );
}
var Bundle_default = SvgBundle;

// src/components/Icon/icons/BundleSolid.tsx
import { jsx as jsx171, jsxs as jsxs164 } from "react/jsx-runtime";
function SvgBundleSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs164(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx171("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx171("path", { d: "M640 766l384-198 384 198v976l-384 194-384-194V766zM525 314l360 183-373 190v993l-320-160V480l333-166zm998 0l333 166v1040l-320 160V687L666 243l358-179 358 179-145 74 133 75 153-78z" })
      ]
    }
  );
}
var BundleSolid_default = SvgBundleSolid;

// src/components/Icon/icons/BusinessRule.tsx
import { jsx as jsx172, jsxs as jsxs165 } from "react/jsx-runtime";
function SvgBusinessRule({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs165(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx172("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx172("path", { d: "M0 896h128v128H0V896zm0-384h128v128H0V512zm384 0h1664v128H384V512zM0 128h128v128H0V128zm2048 0v128H384V128h1664zm-1024 896H384V896h640v128zm1019 276l-137 57q14 56 14 111 0 54-14 110l137 57-48 118-138-57q-29 48-68 88t-88 69l57 137-119 49-56-137q-27 7-55 10t-56 3q-28 0-56-3t-55-10l-56 137-119-49 57-137q-48-29-87-69t-69-88l-138 57-48-118 137-57q-14-56-14-110 0-55 14-111l-137-57 48-118 138 57q29-48 68-88t88-69l-57-137 119-49 56 137q56-14 111-14t111 14l56-137 119 49-57 137q48 29 87 69t69 88l138-57 48 118zm-571 487q66 0 124-25t101-68 69-102 26-124q0-66-25-124t-69-102-102-69-124-26q-66 0-124 25t-102 69-69 102-25 125q0 66 25 124t68 101 102 69 125 25z" })
      ]
    }
  );
}
var BusinessRule_default = SvgBusinessRule;

// src/components/Icon/icons/ButtonA.tsx
import { jsx as jsx173, jsxs as jsxs166 } from "react/jsx-runtime";
function SvgButtonA({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs166(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx173("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx173("path", { d: "M1024 0q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 142-36 273t-103 244-160 207-207 160-245 103-273 37q-142 0-273-36t-244-103-207-160-160-207-103-245-37-273q0-142 36-273t103-244 160-207 207-160T751 37t273-37zm0 1920q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 123 32 237t90 214 141 182 181 140 214 91 238 32zm107-1286l278 780h-192l-55-174H885l-55 174H639l284-780h208zm-10 471l-84-262q-5-17-7-35t-5-35h-5q-2 17-5 34t-8 35l-85 263h199z" })
      ]
    }
  );
}
var ButtonA_default = SvgButtonA;

// src/components/Icon/icons/ButtonASolid.tsx
import { jsx as jsx174, jsxs as jsxs167 } from "react/jsx-runtime";
function SvgButtonASolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs167(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx174("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx174("path", { d: "M2048 1024q0 142-36 273t-103 245-160 207-207 159-245 103-273 37q-142 0-273-36t-245-103-207-160-159-207-103-245-37-273q0-142 36-273t103-245 160-207 207-159T751 37t273-37q141 0 272 36t244 104 207 160 161 207 103 245 37 272zm-831 390h192l-278-780H923l-284 780h191l55-174h277l55 174zm-96-309H922l85-263q5-17 8-34t5-35h5q2 17 4 35t8 35l84 262z" })
      ]
    }
  );
}
var ButtonASolid_default = SvgButtonASolid;

// src/components/Icon/icons/ButtonB.tsx
import { jsx as jsx175, jsxs as jsxs168 } from "react/jsx-runtime";
function SvgButtonB({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs168(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx175("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx175("path", { d: "M1024 0q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 142-36 273t-103 244-160 207-207 160-245 103-273 37q-142 0-273-36t-244-103-207-160-160-207-103-245-37-273q0-142 36-273t103-244 160-207 207-160T751 37t273-37zm0 1920q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 123 32 237t90 214 141 182 181 140 214 91 238 32zm137-925q38 5 71 19t58 38 39 56 14 73q0 62-24 106t-64 72-91 42-107 13H758V634h284q45 0 92 8t88 28 65 56 26 91q0 33-12 61t-34 51-48 39-58 25v2zm-228-47h77q24 0 45-5t37-18 25-31 10-45q0-27-11-44t-30-26-42-12-45-4h-66v185zm96 337q25 0 48-6t42-19 29-33 11-48q0-28-11-47t-29-31-42-17-48-5h-96v206h96z" })
      ]
    }
  );
}
var ButtonB_default = SvgButtonB;

// src/components/Icon/icons/ButtonBSolid.tsx
import { jsx as jsx176, jsxs as jsxs169 } from "react/jsx-runtime";
function SvgButtonBSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs169(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx176("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx176("path", { d: "M1010 948h-77V763h66q22 0 45 3t41 13 30 26 12 44q0 26-9 45t-25 31-37 17-46 6zm149 231q0 28-11 48t-29 33-41 19-49 6h-96v-206h96q24 0 47 5t42 17 30 31 11 47zm889-155q0 142-36 273t-103 245-160 207-207 159-245 103-273 37q-142 0-273-36t-245-103-207-160-159-207-103-245-37-273q0-142 36-273t103-245 160-207 207-159T751 37t273-37q141 0 272 36t244 104 207 160 161 207 103 245 37 272zm-705 157q0-40-14-72t-39-57-58-38-71-19v-2q30-7 57-23t49-40 33-52 13-61q0-50-22-85t-59-56-80-32-87-10H758v780h299q55 0 106-13t92-41 64-73 24-106z" })
      ]
    }
  );
}
var ButtonBSolid_default = SvgButtonBSolid;

// src/components/Icon/icons/ButtonLetterA.tsx
import { jsx as jsx177, jsxs as jsxs170 } from "react/jsx-runtime";
function SvgButtonLetterA({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs170(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx177("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx177("path", { d: "M1101 666l278 780h-192l-55-174H855l-55 174H610l283-780h208zm-9 471l-85-262q-5-17-7-35t-5-35h-5q-1 17-4 34t-9 35l-85 263h200z" })
      ]
    }
  );
}
var ButtonLetterA_default = SvgButtonLetterA;

// src/components/Icon/icons/ButtonLetterB.tsx
import { jsx as jsx178, jsxs as jsxs171 } from "react/jsx-runtime";
function SvgButtonLetterB({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs171(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx178("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx178("path", { d: "M1183 1027q38 5 71 19t58 38 39 56 14 73q0 63-24 107t-63 72-92 41-107 13H779V666h285q45 0 92 8t88 28 65 56 26 91q0 33-12 62t-34 51-48 39-58 24v2zm-228-47h77q24 0 45-5t37-18 25-31 10-45q0-27-11-44t-30-26-42-13-45-3h-66v185zm95 337q25 0 48-6t42-19 30-33 11-48q0-28-11-47t-29-31-42-17-48-5h-96v206h95z" })
      ]
    }
  );
}
var ButtonLetterB_default = SvgButtonLetterB;

// src/components/Icon/icons/ButtonLetterX.tsx
import { jsx as jsx179, jsxs as jsxs172 } from "react/jsx-runtime";
function SvgButtonLetterX({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs172(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx179("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx179("path", { d: "M1186 1052l240 394h-208l-134-254q-6-12-9-25t-7-27h-2q-3 13-7 28t-11 26l-134 252H704l248-390-227-390h214l110 234q8 16 14 32t10 34h3q4-16 10-35t14-34l124-231h195l-233 386z" })
      ]
    }
  );
}
var ButtonLetterX_default = SvgButtonLetterX;

// src/components/Icon/icons/ButtonLetterY.tsx
import { jsx as jsx180, jsxs as jsxs173 } from "react/jsx-runtime";
function SvgButtonLetterY({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs173(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx180("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx180("path", { d: "M1053 1021q2-15 6-31t10-31l128-293h186l-253 502v278H953v-274L706 666h201l126 291q6 14 10 31t8 33h2z" })
      ]
    }
  );
}
var ButtonLetterY_default = SvgButtonLetterY;

// src/components/Icon/icons/ButtonMenu.tsx
import { jsx as jsx181, jsxs as jsxs174 } from "react/jsx-runtime";
function SvgButtonMenu({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs174(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx181("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx181("path", { d: "M1024 0q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 141-36 272t-104 244-160 207-207 161-245 103-272 37q-141 0-272-36t-244-104-207-160-161-207-103-245-37-272q0-141 36-272t104-244 160-207 207-161T752 37t272-37zm0 1920q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 123 32 237t90 214 141 182 181 140 214 91 238 32zM576 960h896v128H576V960zm0-320h896v128H576V640zm0 640h896v128H576v-128z" })
      ]
    }
  );
}
var ButtonMenu_default = SvgButtonMenu;

// src/components/Icon/icons/ButtonMenuSolid.tsx
import { jsx as jsx182, jsxs as jsxs175 } from "react/jsx-runtime";
function SvgButtonMenuSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs175(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx182("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx182("path", { d: "M2048 1024q0 141-36 272t-104 244-160 207-207 161-245 103-272 37q-141 0-272-36t-244-104-207-160-161-207-103-245-37-272q0-141 36-272t104-244 160-207 207-161T752 37t272-37q141 0 272 36t244 104 207 160 161 207 103 245 37 272zm-576 384v-128H576v128h896zm0-320V960H576v128h896zm0-320V640H576v128h896z" })
      ]
    }
  );
}
var ButtonMenuSolid_default = SvgButtonMenuSolid;

// src/components/Icon/icons/ButtonView.tsx
import { jsx as jsx183, jsxs as jsxs176 } from "react/jsx-runtime";
function SvgButtonView({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs176(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx183("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx183("path", { d: "M128 384v640h512v128H0V256h1280v512h-128V384H128zm640 512h1280v896H768V896zm1152 768v-640H896v640h1024z" })
      ]
    }
  );
}
var ButtonView_default = SvgButtonView;

// src/components/Icon/icons/ButtonView2.tsx
import { jsx as jsx184, jsxs as jsxs177 } from "react/jsx-runtime";
function SvgButtonView2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs177(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx184("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx184("path", { d: "M1024 0q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 141-36 272t-104 244-160 207-207 161-245 103-272 37q-141 0-272-36t-244-104-207-160-161-207-103-245-37-272q0-141 36-272t104-244 160-207 207-161T752 37t272-37zm0 1920q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 123 32 237t90 214 141 182 181 140 214 91 238 32zM896 896h640v512H896V896zm128 384h384v-256h-384v256zM640 768v256h128v128H512V640h640v128H640z" })
      ]
    }
  );
}
var ButtonView2_default = SvgButtonView2;

// src/components/Icon/icons/ButtonViewSolid.tsx
import { jsx as jsx185, jsxs as jsxs178 } from "react/jsx-runtime";
function SvgButtonViewSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs178(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx185("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx185("path", { d: "M1408 1024v256h-384v-256h384zm640 0q0 141-36 272t-104 244-160 207-207 161-245 103-272 37q-141 0-272-36t-244-104-207-160-161-207-103-245-37-272q0-141 36-272t104-244 160-207 207-161T752 37t272-37q141 0 272 36t244 104 207 160 161 207 103 245 37 272zM768 1152v-128H640V768h512V640H512v512h256zm768 256V896H896v512h640z" })
      ]
    }
  );
}
var ButtonViewSolid_default = SvgButtonViewSolid;

// src/components/Icon/icons/ButtonX.tsx
import { jsx as jsx186, jsxs as jsxs179 } from "react/jsx-runtime";
function SvgButtonX({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs179(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx186("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx186("path", { d: "M1024 0q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 142-36 273t-103 244-160 207-207 160-245 103-273 37q-142 0-273-36t-244-103-207-160-160-207-103-245-37-273q0-142 36-273t103-244 160-207 207-160T751 37t273-37zm0 1920q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-124 0-238 32t-213 90-182 141-140 181-91 214-32 238q0 124 32 238t90 213 141 182 181 140 214 91 238 32zm354-1286h-195l-124 231q-8 14-14 33t-10 36h-3q-4-17-10-33t-14-33L898 634H684l227 390-248 390h209l135-252q6-11 10-26t8-28h2l6 26q3 13 10 26l133 254h209l-240-394 233-386z" })
      ]
    }
  );
}
var ButtonX_default = SvgButtonX;

// src/components/Icon/icons/ButtonXSolid.tsx
import { jsx as jsx187, jsxs as jsxs180 } from "react/jsx-runtime";
function SvgButtonXSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs180(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx187("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx187("path", { d: "M2048 1024q0 142-36 273t-103 245-160 207-207 159-245 103-273 37q-142 0-273-36t-245-103-207-160-159-207-103-245-37-273q0-142 36-273t103-245 160-207 207-159T751 37t273-37q141 0 272 36t244 104 207 160 161 207 103 245 37 272zm-872 390h209l-240-394 233-386h-195l-124 231q-9 17-14 34t-10 35h-3q-5-17-10-33t-14-33L898 634H684l227 390-248 390h209l135-252q7-12 11-26t7-28h2q3 14 6 26t10 26l133 254z" })
      ]
    }
  );
}
var ButtonXSolid_default = SvgButtonXSolid;

// src/components/Icon/icons/ButtonY.tsx
import { jsx as jsx188, jsxs as jsxs181 } from "react/jsx-runtime";
function SvgButtonY({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs181(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx188("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx188("path", { d: "M1024 0q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 142-36 273t-103 244-160 207-207 160-245 103-273 37q-142 0-273-36t-244-103-207-160-160-207-103-245-37-273q0-142 36-273t103-244 160-207 207-160T751 37t273-37zm0 1920q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-124 0-238 32t-213 90-182 141-140 181-91 214-32 238q0 124 32 238t90 213 141 182 181 140 214 91 238 32zm8-931h-2q-4-15-8-32t-10-32L886 634H685l248 506v274h176v-278l254-502h-187l-127 293q-7 15-11 30t-6 32z" })
      ]
    }
  );
}
var ButtonY_default = SvgButtonY;

// src/components/Icon/icons/ButtonYSolid.tsx
import { jsx as jsx189, jsxs as jsxs182 } from "react/jsx-runtime";
function SvgButtonYSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs182(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx189("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx189("path", { d: "M2048 1024q0 142-36 273t-103 245-160 207-207 159-245 103-273 37q-142 0-273-36t-245-103-207-160-159-207-103-245-37-273q0-142 36-273t103-245 160-207 207-159T751 37t273-37q141 0 272 36t244 104 207 160 161 207 103 245 37 272zm-939 112l254-502h-187l-127 293q-7 15-11 30t-6 32h-2q-4-14-6-27t-8-27q-29-76-63-151t-67-150H685l248 506v274h176v-278z" })
      ]
    }
  );
}
var ButtonYSolid_default = SvgButtonYSolid;

// src/components/Icon/icons/Cables.tsx
import { jsx as jsx190, jsxs as jsxs183 } from "react/jsx-runtime";
function SvgCables({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs183(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx190("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx190("path", { d: "M448 0q26 0 45 19t19 45v320h128v576q0 30-9 58t-26 52-41 42-52 29v907H384v-907q-29-10-52-28t-41-42-26-52-9-59V384h128V64q0-26 19-45t45-19zm64 512H384v448q0 26 19 45t45 19q26 0 45-19t19-45V512zM960 0q26 0 45 19t19 45v320h128v576q0 30-9 58t-26 52-41 42-52 29v907H896v-907q-29-10-52-28t-41-42-26-52-9-59V384h128V64q0-26 19-45t45-19zm64 512H896v448q0 26 19 45t45 19q26 0 45-19t19-45V512zm640-128v576q0 30-9 58t-26 52-41 42-52 29v907h-128v-907q-29-10-52-28t-41-42-26-52-9-59V384h128V64q0-26 19-45t45-19q26 0 45 19t19 45v320h128zm-128 128h-128v448q0 26 19 45t45 19q26 0 45-19t19-45V512z" })
      ]
    }
  );
}
var Cables_default = SvgCables;

// src/components/Icon/icons/Calculator.tsx
import { jsx as jsx191, jsxs as jsxs184 } from "react/jsx-runtime";
function SvgCalculator({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs184(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx191("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx191("path", { d: "M256 0h1408v2048H256V0zm1280 1920V128H384v1792h1152zM1408 256v384H512V256h896zm-128 256V384H640v128h640zM640 896v128H512V896h128zm256 128V896h128v128H896zm384 0V896h128v128h-128zm-640 256v128H512v-128h128zm256 128v-128h128v128H896zm384 0v-128h128v128h-128zm-640 256v128H512v-128h128zm256 128v-128h128v128H896zm384 0v-128h128v128h-128z" })
      ]
    }
  );
}
var Calculator_default = SvgCalculator;

// src/components/Icon/icons/CalendarSolid.tsx
import { jsx as jsx192, jsxs as jsxs185 } from "react/jsx-runtime";
function SvgCalendarSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs185(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx192("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx192("path", { d: "M0 1920V512h2048v1408H0zM1536 768v128h128V768h-128zm0 256v128h128v-128h-128zm0 256v128h128v-128h-128zm-384-512v128h128V768h-128zm0 256v128h128v-128h-128zm0 256v128h128v-128h-128zm0 256v128h128v-128h-128zM768 768v128h128V768H768zm0 256v128h128v-128H768zm0 256v128h128v-128H768zm0 256v128h128v-128H768zm-384-512v128h128v-128H384zm0 256v128h128v-128H384zm0 256v128h128v-128H384zM1664 128h384v256H0V128h384V0h128v128h1024V0h128v128z" })
      ]
    }
  );
}
var CalendarSolid_default = SvgCalendarSolid;

// src/components/Icon/icons/Camera.tsx
import { jsx as jsx193, jsxs as jsxs186 } from "react/jsx-runtime";
function SvgCamera({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs186(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx193("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx193("path", { d: "M2048 256v1536H0V256h549l128-128h693l128 128h550zm-128 128h-475l-128-128H730L602 384H128v1280h1792V384zm-896 128q106 0 199 40t163 109 110 163 40 200q0 106-40 199t-109 163-163 110-200 40q-106 0-199-40t-163-109-110-163-40-200q0-106 40-199t109-163 163-110 200-40zm0 896q79 0 149-30t122-82 83-122 30-150q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149q0 80 30 149t82 122 122 83 150 30zM320 512q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45q0-26 19-45t45-19z" })
      ]
    }
  );
}
var Camera_default = SvgCamera;

// src/components/Icon/icons/CameraReset.tsx
import { jsx as jsx194, jsxs as jsxs187 } from "react/jsx-runtime";
function SvgCameraReset({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs187(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx194("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx194("path", { d: "M1499 256h549v936q-57-62-128-107V384h-475l-128-128H731L603 384H128v1280h870q4 32 10 64t18 64H0V256h549l128-128h694l128 128zM256 576q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45zm768 64q-80 0-149 30t-122 82-83 123-30 149q0 80 30 149t82 122 122 83 150 30q16 0 31-1t31-4l105 105q-80 28-167 28-106 0-199-40t-162-110-110-163-41-199q0-106 40-199t110-162 163-110 199-41q115 0 218 48t176 137l-91 91q-55-70-134-109t-169-39zm1024 960q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175h128q0 66 25 124t68 102 102 69 125 25q66 0 124-25t101-68 69-102 26-125q0-66-25-124t-69-101-102-69-124-26h-229l146 147-90 90-301-301 301-301 90 90-146 147h229q93 0 174 35t143 96 96 142 35 175z" })
      ]
    }
  );
}
var CameraReset_default = SvgCameraReset;

// src/components/Icon/icons/CameraTimer.tsx
import { jsx as jsx195, jsxs as jsxs188 } from "react/jsx-runtime";
function SvgCameraTimer({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs188(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx195("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx195("path", { d: "M256 576q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45zm1344 576q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm0 768q66 0 124-25t101-68 69-102 26-125q0-66-25-124t-69-101-102-69-124-26q-66 0-124 25t-102 69-69 102-25 124q0 66 25 124t68 102 102 69 125 25zm64-384h128v128h-256v-256h128v128zm384-1280v961q-28-33-59-62t-69-52V384h-475l-128-128H731L603 384H128v1280h887q3 33 10 65t18 63H0V256h549l128-128h694l128 128h549zm-513 759q-33 3-65 10t-64 18q4-82-24-155t-80-129-123-87-155-32q-80 0-149 30t-122 82-83 123-30 149q0 80 30 149t82 122 122 83 150 30q5 0 9-1t10-1q-11 32-18 64t-10 65q-70-1-134-20t-120-52-102-80-78-103-51-121-18-135q0-106 40-199t110-162 163-110 199-41q105 0 197 39t161 108 110 160 43 196z" })
      ]
    }
  );
}
var CameraTimer_default = SvgCameraTimer;

// src/components/Icon/icons/CaptureShare.tsx
import { jsx as jsx196, jsxs as jsxs189 } from "react/jsx-runtime";
function SvgCaptureShare({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs189(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx196("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx196("path", { d: "M1792 896h128v896H0V896h128v768h1664V896zM896 245L621 519l-90-90L960 0l429 429-90 90-275-274v907H896V245z" })
      ]
    }
  );
}
var CaptureShare_default = SvgCaptureShare;

// src/components/Icon/icons/CardPrepaid.tsx
import { jsx as jsx197, jsxs as jsxs190 } from "react/jsx-runtime";
function SvgCardPrepaid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs190(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx197("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx197("path", { d: "M1888 256q33 0 62 12t51 35 34 51 13 62v1088q0 33-12 62t-35 51-51 34-62 13H160q-33 0-62-12t-51-35-34-51-13-62V416q0-33 12-62t35-51 51-34 62-13h1728zM160 384q-14 0-23 9t-9 23v224h1792V416q0-14-9-23t-23-9H160zm1728 1152q14 0 23-9t9-23V768H128v736q0 14 9 23t23 9h1728zm-480-384h256v128h-256v-128z" })
      ]
    }
  );
}
var CardPrepaid_default = SvgCardPrepaid;

// src/components/Icon/icons/Cart.tsx
import { jsx as jsx198, jsxs as jsxs191 } from "react/jsx-runtime";
function SvgCart({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs191(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx198("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx198("path", { d: "M1600 1536q40 0 75 15t61 41 41 61 15 75q0 40-15 75t-41 61-61 41-75 15q-40 0-75-15t-61-41-41-61-15-75q0-31 11-64H885q11 33 11 64 0 40-15 75t-41 61-61 41-75 15q-40 0-75-15t-61-41-41-61-15-75q0-55 29-102t80-71L188 256H0V128h281l85 256h1682l-299 896H665l85 256h850zM409 512l213 640h1035l213-640H409zm359 1216q0-26-19-45t-45-19q-26 0-45 19t-19 45q0 26 19 45t45 19q26 0 45-19t19-45zm832 64q26 0 45-19t19-45q0-26-19-45t-45-19q-26 0-45 19t-19 45q0 26 19 45t45 19z" })
      ]
    }
  );
}
var Cart_default = SvgCart;

// src/components/Icon/icons/Cast.tsx
import { jsx as jsx199, jsxs as jsxs192 } from "react/jsx-runtime";
function SvgCast({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs192(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx199("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx199("path", { d: "M1139 947l562-563h-293V256h512v512h-128V475l-563 562-90-90zm781-51v896H128V256h1152v128H256v768h768v512h768V896h128zM896 1664v-384H256v384h640z" })
      ]
    }
  );
}
var Cast_default = SvgCast;

// src/components/Icon/icons/CastMirrored.tsx
import { jsx as jsx200, jsxs as jsxs193 } from "react/jsx-runtime";
function SvgCastMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs193(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx200("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx200("path", { d: "M909 947L347 384h293V256H128v512h128V475l563 562 90-90zm-781-51v896h1792V256H768v128h1024v768h-768v512H256V896H128zm1024 768v-384h640v384h-640z" })
      ]
    }
  );
}
var CastMirrored_default = SvgCastMirrored;

// src/components/Icon/icons/CellPhone.tsx
import { jsx as jsx201, jsxs as jsxs194 } from "react/jsx-runtime";
function SvgCellPhone({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs194(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx201("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx201("path", { d: "M1536 0q27 0 50 10t40 27 28 41 10 50v1792q0 27-10 50t-27 40-41 28-50 10H512q-27 0-50-10t-40-27-28-41-10-50V128q0-27 10-50t27-40 41-28 50-10h1024zm0 128H512v1792h1024V128zM896 1664h256v128H896v-128z" })
      ]
    }
  );
}
var CellPhone_default = SvgCellPhone;

// src/components/Icon/icons/ChangeTheme.tsx
import { jsx as jsx202, jsxs as jsxs195 } from "react/jsx-runtime";
function SvgChangeTheme({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs195(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx202("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx202("path", { d: "M1088 1536v128h256v128H704v-128h256v-128H64V384h1024L960 512H192v896h1664V640l128-128v1024h-896zm-512-384q27 0 50-10t40-27 28-41 10-50q0-49 17-92t48-78 73-57 90-27l711-711q28-28 65-43t76-15q42 0 78 15t64 43 42 63 16 78q0 39-15 76t-43 65l-712 711q-5 49-27 90t-56 72-78 48-93 18H320v-128h256zm723-365q-42-60-102-102l-114 115q32 17 58 43t44 58l114-114zm-339 365q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50q0 68-34 128h162zm824-1024q-30 0-51 21l-444 445q57 44 101 101l445-445q21-21 21-50 0-30-21-51t-51-21z" })
      ]
    }
  );
}
var ChangeTheme_default = SvgChangeTheme;

// src/components/Icon/icons/Characters.tsx
import { jsx as jsx203, jsxs as jsxs196 } from "react/jsx-runtime";
function SvgCharacters({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs196(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx203("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx203("path", { d: "M651 896l341 1024H853l-85-256H384l-85 256H160L501 896h150zm74 640l-149-448-149 448h298zm81-992q1-69 1-137t-1-137q0-5 2-11 8-2 13-2 42 1 83 2t84 1h275v-66q0-34-9-66 69 0 137 6 6 1 12 3t7 10q0 6-3 12t-5 12q-2 5-3 15t-2 22-1 22 0 17v13h296q42 0 83-1t84-2q7 0 13 3 3 5 3 10-1 17-2 35t-1 36v58q0 36 1 72t2 73v7q0 4-3 6-8 2-13 2h-23q-18 0-38 1t-36 0-20-4q-2-11-2-35t-1-52 1-53 1-40H939v20q0 15 1 34t0 42 0 40-1 31-3 15q-8 2-13 2H821q-11 0-13-3t-2-13zm1096 258q2 8 2 13v96q0 4-2 12-8 2-13 2-40-1-79-2t-79-1h-321q-1 60 0 120t4 121q1 25-8 50t-30 40q-14 10-39 15t-55 8-56 3-44 1h-19q-13 0-18-6-3-3-7-16t-6-18q-7-26-16-48t-24-46q34 4 68 5t68 2q24 0 36-7t13-34V922H958q-40 0-80 1t-80 2q-8 0-12-3-2-6-2-11V808q0-4 3-7 6-2 11-2l80 2q40 1 80 1h319q-2-26-2-52t-6-53q22 2 43 4t43 4q35-25 67-53t64-57h-308q-42 0-83 1t-84 2q-8 0-12-3-2-6-2-11v-95q0-4 2-12 8-2 12-2 42 1 83 2t84 1h373q16 0 30-4t25-5q8 0 23 12t30 28 26 32 12 25q0 10-6 15t-15 10q-14 7-27 18t-25 21q-52 43-104 83t-110 78v11h321q40 0 79-1t79-2q7 0 13 3z" })
      ]
    }
  );
}
var Characters_default = SvgCharacters;

// src/components/Icon/icons/ChargingCable.tsx
import { jsx as jsx204, jsxs as jsxs197 } from "react/jsx-runtime";
function SvgChargingCable({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs197(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx204("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx204("path", { d: "M640 128h128v512H640v1408H512V640H384V128h128V0h128v128zm0 128H512v256h128V256zm1024 128h41q22 0 42 4t32 19 13 42q0 8-1 12l-128 640q-5 22-22 36t-41 15h-192v896h-128v-896h-192q-23 0-40-14t-23-37L897 461q-1-3-1-6t0-7q0-28 13-41t32-19 42-5 41 1V0h640v384zm-512 0h384V128h-384v256zm498 128h-612l102 512h407l103-512z" })
      ]
    }
  );
}
var ChargingCable_default = SvgChargingCable;

// src/components/Icon/icons/Chat.tsx
import { jsx as jsx205, jsxs as jsxs198 } from "react/jsx-runtime";
function SvgChat({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs198(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx205("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx205("path", { d: "M0 128h2048v1408H730l-474 475v-475H0V128zm1920 1280V256H128v1152h256v294l293-294h1243z" })
      ]
    }
  );
}
var Chat_default = SvgChat;

// src/components/Icon/icons/ChatBot.tsx
import { jsx as jsx206, jsxs as jsxs199 } from "react/jsx-runtime";
function SvgChatBot({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs199(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx206("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx206("path", { d: "M768 896v128H640V896h128zm512 0v128h-128V896h128zm384 0h128v256h-128v320q0 40-15 75t-41 61-61 41-75 15h-264l-440 376v-376H448q-40 0-75-15t-61-41-41-61-15-75v-320H128V896h128V704q0-40 15-75t41-61 61-41 75-15h448V303q-29-17-46-47t-18-64q0-27 10-50t27-40 41-28 50-10q27 0 50 10t40 27 28 41 10 50q0 34-17 64t-47 47v209h448q40 0 75 15t61 41 41 61 15 75v192zm-128 576V704q0-26-19-45t-45-19H448q-26 0-45 19t-19 45v768q0 26 19 45t45 19h448v226l264-226h312q26 0 45-19t19-45zm-851-306q55 55 126 84t149 30q78 0 149-29t126-85l90 91q-73 73-167 112t-198 39q-103 0-197-39t-168-112l90-91z" })
      ]
    }
  );
}
var ChatBot_default = SvgChatBot;

// src/components/Icon/icons/ChatBubbles.tsx
import { jsx as jsx207, jsxs as jsxs200 } from "react/jsx-runtime";
function SvgChatBubbles({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs200(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx207("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx207("path", { d: "M2048 1280h-384v256H640l-384 384v-384H0V384h256V0h1792v1280zm-512-768H128v896h256v203q51-51 100-102t103-101h949V512zm384-384H384v256h1280v768h256V128z" })
      ]
    }
  );
}
var ChatBubbles_default = SvgChatBubbles;

// src/components/Icon/icons/ChatHeadset.tsx
import { jsx as jsx208, jsxs as jsxs201 } from "react/jsx-runtime";
function SvgChatHeadset({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs201(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx208("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx208("path", { d: "M1024 0q159 0 298 60t244 165 165 244 61 299v448q0 40-15 75t-41 61-61 41-75 15h-192V768h192q17 0 33 3t31 9q0-135-49-253t-134-207-203-140-254-52q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170v12q15-5 31-8t33-4h192v640H512v128q0 53 20 99t55 82 81 55 100 20q0-27 10-50t27-40 41-28 50-10h256q27 0 50 10t40 27 28 41 10 50v128q0 27-10 50t-27 40-41 28-50 10H896q-27 0-50-10t-40-27-28-41-10-50q-80 0-149-30t-122-82-83-122-30-150v-140q-29-10-52-28t-40-41-26-52-10-59V768q0-159 60-298t165-244T725 61t299-61zM896 1920h256v-128H896v128zM448 896q-26 0-45 19t-19 45v256q0 26 19 45t45 19h64V896h-64zm1216 64q0-26-19-45t-45-19h-64v384h64q26 0 45-19t19-45V960z" })
      ]
    }
  );
}
var ChatHeadset_default = SvgChatHeadset;

// src/components/Icon/icons/ChatHeadsetArt160.tsx
import { jsx as jsx209, jsxs as jsxs202 } from "react/jsx-runtime";
function SvgChatHeadsetArt160({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs202(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx209("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx209("path", { d: "M1024 26q103 0 198 26t177 75 150 116 116 150 74 177 27 198v448q0 35-13 65t-35 52-53 36-65 13h-166V794h166q49 0 90 26v-52q0-138-52-259t-143-211-212-143-259-53q-138 0-259 52T554 297 411 509t-53 259v52q41-26 90-26h166v588H486v154q0 58 22 109t61 90 89 60 110 23h26v-26q0-43 29-72t73-30h256q43 0 72 29t30 73q0 31 2 70t-5 75-29 60-70 25H896q-43 0-72-29t-30-73v-26h-26q-75 0-140-28t-114-76-76-113-28-141v-158q-28-7-51-22t-41-36-26-48-10-56V768q0-103 26-198t75-177 116-150 150-116 177-74 198-27zM870 1920q0 11 7 18t19 8h256q11 0 18-7t8-19v-128q0-11-7-18t-19-8H896q-11 0-18 7t-8 19v128zM448 870q-37 0-63 26t-27 64v256q0 37 26 63t64 27h90V870h-90zm1242 90q0-37-26-63t-64-27h-90v436h90q37 0 63-26t27-64V960z" })
      ]
    }
  );
}
var ChatHeadsetArt160_default = SvgChatHeadsetArt160;

// src/components/Icon/icons/ChatHeadsetArt224.tsx
import { jsx as jsx210, jsxs as jsxs203 } from "react/jsx-runtime";
function SvgChatHeadsetArt224({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs203(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx210("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx210("path", { d: "M1024 36q101 0 194 26t175 74 148 115 114 148 74 174 26 195v448q0 32-12 60t-33 50-49 33-61 12h-155V805h155q28 0 54 10t47 27v-74q0-140-53-263t-146-215-215-145-263-54q-140 0-263 53T546 290 401 505t-54 263v74q21-17 47-27t54-10h155v566H475v165q0 60 23 113t63 94 93 63 114 23h37v-37q0-38 26-64t65-27h256q38 0 64 26t27 65v128q0 38-26 64t-65 27H896q-38 0-64-26t-27-65v-37h-37q-72 0-135-27t-111-74-74-110-27-136v-167q-28-5-51-19t-41-34-26-46-10-54V768q0-101 26-194t73-175 115-148 148-115 174-74 195-26zM859 1920q0 15 11 26t26 11h256q15 0 26-11t11-26v-128q0-15-11-26t-26-11H896q-15 0-26 11t-11 26v128zm-512-704q0 21 8 39t22 32 32 22 39 8h101V859H448q-21 0-39 8t-32 22-22 32-8 39v256zm1354-256q0-21-8-39t-22-32-32-22-39-8h-100v458h100q21 0 39-8t32-22 22-32 8-39V960z" })
      ]
    }
  );
}
var ChatHeadsetArt224_default = SvgChatHeadsetArt224;

// src/components/Icon/icons/ChatInviteFriend.tsx
import { jsx as jsx211, jsxs as jsxs204 } from "react/jsx-runtime";
function SvgChatInviteFriend({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs204(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx211("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx211("path", { d: "M1762 1590q66 32 118 80t90 108 58 128 20 142h-128q0-79-30-149t-83-122-122-82-149-31q-79 0-149 30t-122 83-82 122-31 149h-128q0-73 20-141t57-128 90-108 119-81q-75-54-116-135t-42-175q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 93-41 174t-117 136zm-226-54q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100q0 53 20 99t55 82 81 55 100 20zm512-1408v1024q0-48-9-84t-25-67-40-60-54-63V256H128v1152h256v267l267-267h390q8 34 21 66t31 62H704l-448 448v-448H0V128h2048z" })
      ]
    }
  );
}
var ChatInviteFriend_default = SvgChatInviteFriend;

// src/components/Icon/icons/ChatMute.tsx
import { jsx as jsx212, jsxs as jsxs205 } from "react/jsx-runtime";
function SvgChatMute({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs205(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx212("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx212("path", { d: "M1600 1152q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm-320 448q0 66 25 124t68 102 102 69 125 25q47 0 92-13t84-40l-443-443q-26 39-39 84t-14 92zm587 176q26-39 39-84t14-92q0-66-25-124t-69-101-102-69-124-26q-47 0-92 13t-84 40l443 443zm181-1648v1089q-28-33-59-62t-69-52V256H128v1152h256v267l267-267h392q-22 63-29 128H704l-448 448v-448H0V128h2048z" })
      ]
    }
  );
}
var ChatMute_default = SvgChatMute;

// src/components/Icon/icons/ChatPad.tsx
import { jsx as jsx213, jsxs as jsxs206 } from "react/jsx-runtime";
function SvgChatPad({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs206(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx213("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx213("path", { d: "M2048 1280q0 53-20 100t-54 81-82 55-100 20l-128-128-181 181q-36 36-83 55t-98 20H746q-51 0-98-19t-83-56l-181-181-128 128q-53 0-100-20t-81-54-55-82-20-100l384-768h152l75-150q25-49 71-77t101-29h482q55 0 101 28t71 78l75 150h152l384 768zM783 384q-17 0-33 9t-24 26l-46 93h688l-46-93q-8-16-24-25t-33-10H783zm1054 1016q32-11 53-37t28-58l-333-665H463l-333 665q7 32 28 58t53 37q86-87 173-173l45 45q22 22 46 45l90 90q45 45 91 92 37 37 90 37h556q53 0 90-37 45-46 90-91t91-91l45-45q22-22 46-45 87 86 173 173zM768 1280h512v128H768v-128zm-256-256h128v128H512v-128zm384 128H768v-128h128v128zm0-256H768V768h128v128zm256 0h-128V768h128v128zm256 0h-128V768h128v128zm-256 256h-128v-128h128v128zm128-128h256v128h-256v-128zM512 768h128v128H512V768z" })
      ]
    }
  );
}
var ChatPad_default = SvgChatPad;

// src/components/Icon/icons/ChatSettings.tsx
import { jsx as jsx214, jsxs as jsxs207 } from "react/jsx-runtime";
function SvgChatSettings({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs207(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx214("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx214("path", { d: "M0 128h2048v1064q-57-62-128-107V256H128v1152h256v293l293-293h349q-11 31-17 63t-11 65H731l-475 475v-475H0V128zm1989 1241l49 119-124 51q6 30 6 61t-6 61l124 51-49 119-124-52q-35 51-86 86l52 124-119 49-51-124q-30 6-61 6t-61-6l-51 124-119-49 52-124q-51-35-86-86l-124 52-49-119 124-51q-6-30-6-61t6-61l-124-51 49-119 124 52q35-51 86-86l-52-124 119-49 51 124q30-6 61-6t61 6l51-124 119 49-52 124q51 35 86 86l124-52zm-197 231q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75z" })
      ]
    }
  );
}
var ChatSettings_default = SvgChatSettings;

// src/components/Icon/icons/ChatSolid.tsx
import { jsx as jsx215, jsxs as jsxs208 } from "react/jsx-runtime";
function SvgChatSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs208(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx215("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx215("path", { d: "M2048 128v1408H704l-448 448v-448H0V128h2048z" })
      ]
    }
  );
}
var ChatSolid_default = SvgChatSolid;

// src/components/Icon/icons/ChatVideo.tsx
import { jsx as jsx216, jsxs as jsxs209 } from "react/jsx-runtime";
function SvgChatVideo({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs209(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx216("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx216("path", { d: "M2048 128v512h-128V256H128v1152h256v267l267-267h117v128h-64l-448 448v-448H0V128h2048zM896 768h1152v1152h-384v128h-384v-128H896V768zm128 1024h896V896h-896v896zm448-768q66 0 124 25t102 68 69 102 25 125q0 66-25 124t-68 102-102 69-125 25q-66 0-124-25t-102-68-69-102-25-125q0-66 25-124t68-102 102-69 125-25zm0 512q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15z" })
      ]
    }
  );
}
var ChatVideo_default = SvgChatVideo;

// src/components/Icon/icons/CheckBox.tsx
import { jsx as jsx217, jsxs as jsxs210 } from "react/jsx-runtime";
function SvgCheckBox({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs210(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx217("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx217("path", { d: "M0 0h2048v2048H0V0zm1920 1920V128H128v1792h1792z" })
      ]
    }
  );
}
var CheckBox_default = SvgCheckBox;

// src/components/Icon/icons/CheckBox2.tsx
import { jsx as jsx218, jsxs as jsxs211 } from "react/jsx-runtime";
function SvgCheckBox2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs211(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx218("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx218("path", { d: "M2048 1024q0 142-36 272t-103 245-160 207-208 160-245 103-272 37q-142 0-272-36t-245-103-207-160-160-208-103-245-37-272q0-141 36-272t103-245 160-207 208-160T752 37t272-37q141 0 272 36t245 103 207 160 160 208 103 245 37 272zm-1024 896q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-124 0-238 32t-213 90-182 141-140 181-91 214-32 238q0 124 32 238t90 213 141 182 181 140 214 91 238 32z" })
      ]
    }
  );
}
var CheckBox2_default = SvgCheckBox2;

// src/components/Icon/icons/CheckBoxChecked.tsx
import { jsx as jsx219, jsxs as jsxs212 } from "react/jsx-runtime";
function SvgCheckBoxChecked({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs212(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx219("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx219("path", { d: "M0 0h2048v2048H0V0zm1920 1920V128H128v1792h1792zM768 1627l-429-430 90-90 339 339 851-851 90 90-941 942z" })
      ]
    }
  );
}
var CheckBoxChecked_default = SvgCheckBoxChecked;

// src/components/Icon/icons/CheckBoxChecked2.tsx
import { jsx as jsx220, jsxs as jsxs213 } from "react/jsx-runtime";
function SvgCheckBoxChecked2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs213(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx220("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx220("path", { d: "M2048 1024q0 142-36 272t-103 245-160 207-208 160-245 103-272 37q-142 0-272-36t-245-103-207-160-160-208-103-245-37-272q0-141 36-272t103-245 160-207 208-160T752 37t272-37q141 0 272 36t245 103 207 160 160 208 103 245 37 272zm-1024 896q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-124 0-238 32t-213 90-182 141-140 181-91 214-32 238q0 124 32 238t90 213 141 182 181 140 214 91 238 32zm-233-553l774-774 82 82-856 856-390-390 82-82 308 308z" })
      ]
    }
  );
}
var CheckBoxChecked2_default = SvgCheckBoxChecked2;

// src/components/Icon/icons/ChevronDownSmall.tsx
import { jsx as jsx221, jsxs as jsxs214 } from "react/jsx-runtime";
function SvgChevronDownSmall({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs214(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx221("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx221("path", { d: "M1799 349l242 241-1017 1017L7 590l242-241 775 775 775-775z" })
      ]
    }
  );
}
var ChevronDownSmall_default = SvgChevronDownSmall;

// src/components/Icon/icons/ChevronLeft.tsx
import { jsx as jsx222, jsxs as jsxs215 } from "react/jsx-runtime";
function SvgChevronLeft({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs215(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx222("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx222("path", { d: "M1533 93l-930 931 930 931-90 90L421 1024 1443 3l90 90z" })
      ]
    }
  );
}
var ChevronLeft_default = SvgChevronLeft;

// src/components/Icon/icons/ChevronLeftMirrored.tsx
import { jsx as jsx223, jsxs as jsxs216 } from "react/jsx-runtime";
function SvgChevronLeftMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs216(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx223("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx223("path", { d: "M421 93l930 931-930 931 90 90 1022-1021L511 3l-90 90z" })
      ]
    }
  );
}
var ChevronLeftMirrored_default = SvgChevronLeftMirrored;

// src/components/Icon/icons/ChevronLeftSmall.tsx
import { jsx as jsx224, jsxs as jsxs217 } from "react/jsx-runtime";
function SvgChevronLeftSmall({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs217(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx224("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx224("path", { d: "M1699 249l-775 775 775 775-241 242L441 1024 1458 7l241 242z" })
      ]
    }
  );
}
var ChevronLeftSmall_default = SvgChevronLeftSmall;

// src/components/Icon/icons/ChevronRight.tsx
import { jsx as jsx225, jsxs as jsxs218 } from "react/jsx-runtime";
function SvgChevronRight({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs218(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx225("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx225("path", { d: "M605 3l1022 1021L605 2045l-90-90 930-931L515 93l90-90z" })
      ]
    }
  );
}
var ChevronRight_default = SvgChevronRight;

// src/components/Icon/icons/ChevronRightMirrored.tsx
import { jsx as jsx226, jsxs as jsxs219 } from "react/jsx-runtime";
function SvgChevronRightMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs219(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx226("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx226("path", { d: "M1537 3L515 1024l1022 1021 90-90-930-931 930-931-90-90z" })
      ]
    }
  );
}
var ChevronRightMirrored_default = SvgChevronRightMirrored;

// src/components/Icon/icons/ChevronRightSmall.tsx
import { jsx as jsx227, jsxs as jsxs220 } from "react/jsx-runtime";
function SvgChevronRightSmall({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs220(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx227("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx227("path", { d: "M590 7l1017 1017L590 2041l-241-242 775-775-775-775L590 7z" })
      ]
    }
  );
}
var ChevronRightSmall_default = SvgChevronRightSmall;

// src/components/Icon/icons/ChevronUp.tsx
import { jsx as jsx228, jsxs as jsxs221 } from "react/jsx-runtime";
function SvgChevronUp({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs221(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx228("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx228("path", { d: "M1955 1533l-931-930-931 930-90-90L1024 422l1021 1021-90 90z" })
      ]
    }
  );
}
var ChevronUp_default = SvgChevronUp;

// src/components/Icon/icons/ChevronUpSmall.tsx
import { jsx as jsx229, jsxs as jsxs222 } from "react/jsx-runtime";
function SvgChevronUpSmall({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs222(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx229("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx229("path", { d: "M1024 441l1017 1017-242 241-775-775-775 775L7 1458 1024 441z" })
      ]
    }
  );
}
var ChevronUpSmall_default = SvgChevronUpSmall;

// src/components/Icon/icons/Chin.tsx
import { jsx as jsx230, jsxs as jsxs223 } from "react/jsx-runtime";
function SvgChin({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs223(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx230("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx230("path", { d: "M1280 768H768V640h512v128zm765-99l-561 561v1q-94 87-213 132t-247 45q-128 0-247-45t-213-132l-22-23q-22-23-60-60t-85-85-98-98-101-101-90-90-69-69-36-36l90-90 559 559q35 35 79 61t93 45 100 27 100 10q49 0 100-9t100-28 93-44 79-62l559-559 90 90z" })
      ]
    }
  );
}
var Chin_default = SvgChin;

// src/components/Icon/icons/ChromeCollapse.tsx
import { jsx as jsx231, jsxs as jsxs224 } from "react/jsx-runtime";
function SvgChromeCollapse({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs224(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx231("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx231("path", { d: "M1536 896v128H737l291 291-91 90-445-445 445-445 91 90-291 291h799zM256 1664V256h128v1408H256z" })
      ]
    }
  );
}
var ChromeCollapse_default = SvgChromeCollapse;

// src/components/Icon/icons/ChromeCollapseMirrored.tsx
import { jsx as jsx232, jsxs as jsxs225 } from "react/jsx-runtime";
function SvgChromeCollapseMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs225(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx232("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx232("path", { d: "M512 896v128h799l-291 291 91 90 445-445-445-445-91 90 291 291H512zm1280 768V256h-128v1408h128z" })
      ]
    }
  );
}
var ChromeCollapseMirrored_default = SvgChromeCollapseMirrored;

// src/components/Icon/icons/ChromeExpand.tsx
import { jsx as jsx233, jsxs as jsxs226 } from "react/jsx-runtime";
function SvgChromeExpand({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs226(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx233("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx233("path", { d: "M1020 605l91-90 445 445-445 445-91-90 291-291H512V896h799l-291-291zm644-349h128v1408h-128V256z" })
      ]
    }
  );
}
var ChromeExpand_default = SvgChromeExpand;

// src/components/Icon/icons/ChromeExpandMirrored.tsx
import { jsx as jsx234, jsxs as jsxs227 } from "react/jsx-runtime";
function SvgChromeExpandMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs227(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx234("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx234("path", { d: "M1028 605l-91-90-445 445 445 445 91-90-291-291h799V896H737l291-291zM384 256H256v1408h128V256z" })
      ]
    }
  );
}
var ChromeExpandMirrored_default = SvgChromeExpandMirrored;

// src/components/Icon/icons/CircleButtonBackground.tsx
import { jsx as jsx235, jsxs as jsxs228 } from "react/jsx-runtime";
function SvgCircleButtonBackground({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs228(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx235("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx235("path", { d: "M1024 0q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 141-36 272t-103 245-160 207-208 160-245 103-272 37q-141 0-272-36t-245-103-207-160-160-208-103-244-37-273q0-141 36-272t103-245 160-207 208-160T751 37t273-37zm0 1920q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 123 32 237t90 214 141 182 181 140 214 91 238 32z" })
      ]
    }
  );
}
var CircleButtonBackground_default = SvgCircleButtonBackground;

// src/components/Icon/icons/CirclePause.tsx
import { jsx as jsx236, jsxs as jsxs229 } from "react/jsx-runtime";
function SvgCirclePause({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs229(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx236("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx236("path", { d: "M1024 0q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 141-36 272t-104 244-160 207-207 161-245 103-272 37q-141 0-272-36t-244-104-207-160-161-207-103-245-37-272q0-141 36-272t104-244 160-207 207-161T752 37t272-37zm896 1024q0-124-32-238t-90-214-140-181-181-140-214-91-239-32q-124 0-238 32t-214 90-181 140-140 181-91 214-32 239q0 124 32 238t90 214 140 181 181 140 214 91 239 32q124 0 238-32t214-90 181-140 140-181 91-214 32-239zm-768 384V640h128v768h-128zm-384 0V640h128v768H768z" })
      ]
    }
  );
}
var CirclePause_default = SvgCirclePause;

// src/components/Icon/icons/CirclePauseSolid.tsx
import { jsx as jsx237, jsxs as jsxs230 } from "react/jsx-runtime";
function SvgCirclePauseSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs230(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx237("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx237("path", { d: "M1024 0q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 141-36 272t-104 244-160 207-207 161-245 103-272 37q-141 0-272-36t-244-104-207-160-161-207-103-245-37-272q0-141 36-272t104-244 160-207 207-161T752 37t272-37zM896 1408V640H768v768h128zm384 0V640h-128v768h128z" })
      ]
    }
  );
}
var CirclePauseSolid_default = SvgCirclePauseSolid;

// src/components/Icon/icons/CircleStop.tsx
import { jsx as jsx238, jsxs as jsxs231 } from "react/jsx-runtime";
function SvgCircleStop({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs231(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx238("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx238("path", { d: "M1024 0q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 141-36 272t-104 244-160 207-207 161-245 103-272 37q-141 0-272-36t-244-104-207-160-161-207-103-245-37-272q0-141 36-272t104-244 160-207 207-161T752 37t272-37zm896 1024q0-124-32-238t-90-214-140-181-181-140-214-91-239-32q-124 0-238 32t-214 90-181 140-140 181-91 214-32 239q0 124 32 238t90 214 140 181 181 140 214 91 239 32q124 0 238-32t214-90 181-140 140-181 91-214 32-239zM640 1408V640h768v768H640zm128-640v512h512V768H768z" })
      ]
    }
  );
}
var CircleStop_default = SvgCircleStop;

// src/components/Icon/icons/CircleStopSolid.tsx
import { jsx as jsx239, jsxs as jsxs232 } from "react/jsx-runtime";
function SvgCircleStopSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs232(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx239("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx239("path", { d: "M1024 0q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 141-36 272t-104 244-160 207-207 161-245 103-272 37q-141 0-272-36t-244-104-207-160-161-207-103-245-37-272q0-141 36-272t104-244 160-207 207-161T752 37t272-37zm384 1408V640H640v768h768z" })
      ]
    }
  );
}
var CircleStopSolid_default = SvgCircleStopSolid;

// src/components/Icon/icons/Clock.tsx
import { jsx as jsx240, jsxs as jsxs233 } from "react/jsx-runtime";
function SvgClock({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs233(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx240("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx240("path", { d: "M1024 0q141 0 272 36t245 103 207 160 160 208 103 245 37 272q0 141-36 272t-103 245-160 207-208 160-245 103-272 37q-141 0-272-36t-245-103-207-160-160-208-103-244-37-273q0-141 36-272t103-245 160-207 208-160T751 37t273-37zm0 1920q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 123 32 237t90 214 141 182 181 140 214 91 238 32zm0-896h384v128H896V384h128v640z" })
      ]
    }
  );
}
var Clock_default = SvgClock;

// src/components/Icon/icons/Close.tsx
import { jsx as jsx241, jsxs as jsxs234 } from "react/jsx-runtime";
function SvgClose({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs234(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx241("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx241("path", { d: "M2029 109l-914 915 914 915-90 90-915-914-915 914-90-90 914-915L19 109l90-90 915 914 915-914 90 90z" })
      ]
    }
  );
}
var Close_default = SvgClose;

// src/components/Icon/icons/ClosedCaptions.tsx
import { jsx as jsx242, jsxs as jsxs235 } from "react/jsx-runtime";
function SvgClosedCaptions({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs235(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx242("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx242("path", { d: "M2048 384v1280H0V384h2048zm-128 128H128v1024h1792V512zM704 1408q-80 0-149-30t-122-82-83-122-30-150q0-79 30-149t82-122 122-83 150-30q77 0 147 29t124 83l-90 91q-36-36-83-55t-98-20q-53 0-99 20t-82 55-55 81-20 100q0 53 20 99t55 82 81 55 100 20q51 0 98-19t83-56l90 91q-54 54-124 83t-147 29zm768 0q-80 0-149-30t-122-82-83-122-30-150q0-79 30-149t82-122 122-83 150-30q77 0 147 29t124 83l-90 91q-36-36-83-55t-98-20q-53 0-99 20t-82 55-55 81-20 100q0 53 20 99t55 82 81 55 100 20q51 0 98-19t83-56l90 91q-54 54-124 83t-147 29z" })
      ]
    }
  );
}
var ClosedCaptions_default = SvgClosedCaptions;

// src/components/Icon/icons/ClosedCaptionsInternational.tsx
import { jsx as jsx243, jsxs as jsxs236 } from "react/jsx-runtime";
function SvgClosedCaptionsInternational({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs236(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx243("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx243("path", { d: "M0 256h2048v1408H0V256zm1920 1280V384H128v1152h1792zm-128-256v128H256v-128h1536zm0-256v128H256v-128h1536z" })
      ]
    }
  );
}
var ClosedCaptionsInternational_default = SvgClosedCaptionsInternational;

// src/components/Icon/icons/CloseSmall.tsx
import { jsx as jsx244, jsxs as jsxs237 } from "react/jsx-runtime";
function SvgCloseSmall({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs237(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx244("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx244("path", { d: "M1116 1025l724 724-91 91-724-724-678 679-91-91 679-679-634-633 91-91 633 634 679-679 91 91-679 678z" })
      ]
    }
  );
}
var CloseSmall_default = SvgCloseSmall;

// src/components/Icon/icons/Cloud.tsx
import { jsx as jsx245, jsxs as jsxs238 } from "react/jsx-runtime";
function SvgCloud({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs238(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx245("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx245("path", { d: "M1661 896q80 0 150 30t123 81 83 122 31 151q0 80-30 149t-82 122-123 83-149 30H512q-106 0-199-40t-163-109-110-163-40-200q0-106 40-199t109-163 163-110 200-40q46 0 93 9 37-62 90-111t117-83 133-53 143-18q111 0 209 39t175 107 125 163 64 203zm3 640q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20h-128v-64q0-93-35-174t-96-143-142-96-175-35q-70 0-135 21t-119 59-97 91-67 120q-75-35-158-35-80 0-149 30t-122 82-83 123-30 149q0 80 30 149t82 122 122 83 150 30h1152z" })
      ]
    }
  );
}
var Cloud_default = SvgCloud;

// src/components/Icon/icons/CloudImportExport.tsx
import { jsx as jsx246, jsxs as jsxs239 } from "react/jsx-runtime";
function SvgCloudImportExport({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs239(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx246("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx246("path", { d: "M1629 769q88 6 164 43t133 97 89 140 33 167q0 93-35 174t-96 142-142 96-175 36h-64v-128h64q66 0 124-25t102-68 69-102 25-125q0-66-25-124t-68-102-102-69-125-25q-18 0-35 2t-35 6q-10-84-49-155t-98-124-135-83-160-30q-70 0-135 21t-119 59-97 91-67 120q-75-35-158-35-80 0-149 30t-122 82-83 123-30 149q0 61 18 117t52 103 81 84 105 56v134q-84-22-154-69t-122-112-79-146-29-167q0-106 40-199t110-162 163-110 199-41q46 0 93 9 40-61 93-110t115-83 132-53 143-19q91 0 175 28t156 78 126 122 84 157zm-733 932l147-146 90 90-301 301-301-301 90-90 147 146v-677h128v677zm659-312l-147-146v677h-128v-677l-147 146-90-90 301-301 301 301-90 90z" })
      ]
    }
  );
}
var CloudImportExport_default = SvgCloudImportExport;

// src/components/Icon/icons/CloudNotSynced.tsx
import { jsx as jsx247, jsxs as jsxs240 } from "react/jsx-runtime";
function SvgCloudNotSynced({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs240(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx247("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx247("path", { d: "M512 768q-80 0-149 30t-122 82-83 123-30 149q0 80 30 149t82 122 122 83 150 30h512v128H512q-106 0-199-40t-162-110-110-163-41-199q0-106 40-199t110-162 163-110 199-41q46 0 93 9 40-61 93-110t115-83 132-53 143-19q91 0 175 28t156 78 126 122 84 157q84 6 158 40t129 91 90 131 39 158q-35-39-77-70t-89-56q-21-38-51-69t-66-52-77-34-85-12q-18 0-35 2t-35 6q-10-84-49-155t-98-124-135-83-160-30q-70 0-135 21t-119 59-97 91-67 120q-75-35-158-35zm1088 384q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm-320 448q0 66 25 124t68 102 102 69 125 25q47 0 92-13t84-40l-443-443q-26 39-39 84t-14 92zm587 176q26-39 39-84t14-92q0-66-25-124t-69-101-102-69-124-26q-47 0-92 13t-84 40l443 443z" })
      ]
    }
  );
}
var CloudNotSynced_default = SvgCloudNotSynced;

// src/components/Icon/icons/CloudNotSynced2.tsx
import { jsx as jsx248, jsxs as jsxs241 } from "react/jsx-runtime";
function SvgCloudNotSynced2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs241(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx248("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx248("path", { d: "M512 768q-80 0-149 30t-122 82-83 123-30 149q0 80 30 149t82 122 122 83 150 30h512v128H512q-106 0-199-40t-162-110-110-163-41-199q0-106 40-199t110-162 163-110 199-41q46 0 93 9 40-61 93-110t115-83 132-53 143-19q91 0 175 28t156 78 126 122 84 157q84 6 158 40t129 91 90 131 39 158q-35-39-77-70t-89-56q-21-38-51-69t-66-52-77-34-85-12q-18 0-35 2t-35 6q-10-84-49-155t-98-124-135-83-160-30q-70 0-135 21t-119 59-97 91-67 120q-75-35-158-35zm1088 384q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm-320 448q0 66 25 124t68 102 102 69 125 25q47 0 92-13t84-40l-443-443q-26 39-39 84t-14 92zm587 176q26-39 39-84t14-92q0-66-25-124t-69-101-102-69-124-26q-47 0-92 13t-84 40l443 443z" })
      ]
    }
  );
}
var CloudNotSynced2_default = SvgCloudNotSynced2;

// src/components/Icon/icons/CloudSyncing.tsx
import { jsx as jsx249, jsxs as jsxs242 } from "react/jsx-runtime";
function SvgCloudSyncing({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs242(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx249("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx249("path", { d: "M512 768q-80 0-149 30t-122 82-83 123-30 149q0 80 30 149t82 122 122 83 150 30h512v128H512q-106 0-199-40t-162-110-110-163-41-199q0-106 40-199t110-162 163-110 199-41q46 0 93 9 40-61 93-110t115-83 132-53 143-19q91 0 175 28t156 78 126 122 84 157q61 4 117 24t104 53 88 78 65 100h-149q-45-60-112-94t-142-34q-18 0-35 2t-35 6q-10-84-49-155t-98-124-135-83-160-30q-70 0-135 21t-119 59-97 91-67 120q-75-35-158-35zm1536 384v384h-384v-128h190q-45-60-112-94t-142-34q-59 0-111 20t-95 55-70 85-38 107l-127-22q14-81 54-149t98-118 133-78 156-28q91 0 174 35t146 102v-137h128zm-448 768q58 0 111-20t95-55 70-85 38-107l127 22q-14 81-54 149t-98 118-133 78-156 28q-91 0-174-35t-146-102v137h-128v-384h384v128h-190q45 60 112 94t142 34z" })
      ]
    }
  );
}
var CloudSyncing_default = SvgCloudSyncing;

// src/components/Icon/icons/Clubs.tsx
import { jsx as jsx250, jsxs as jsxs243 } from "react/jsx-runtime";
function SvgClubs({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs243(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx250("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx250("path", { d: "M2048 0v128H0V0h2048zm0 256v128h-256v512q0 189-54 365t-155 327-243 269-316 191q-174-73-316-191t-242-268-155-327-55-366V384H0V256h2048zm-384 128H384v512q0 162 45 314t128 284 202 238 265 176q147-70 265-176t201-237 129-284 45-315V384zm-640 640q-53 0-99 20t-82 55-55 81-20 100H640q0-52 14-101t39-93 62-80 83-62q-33-35-51-81t-19-95q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100q0 49-18 95t-52 81q46 26 82 62t62 79 40 93 14 102h-128q0-53-20-99t-55-82-81-55-100-20zM896 768q0 27 10 50t27 40 41 28 50 10q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50z" })
      ]
    }
  );
}
var Clubs_default = SvgClubs;

// src/components/Icon/icons/CollectionListView.tsx
import { jsx as jsx251, jsxs as jsxs244 } from "react/jsx-runtime";
function SvgCollectionListView({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs244(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx251("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx251("path", { d: "M128 384V0h384v384H128zm128-256v128h128V128H256zM128 896V512h384v384H128zm128-256v128h128V640H256zm-128 768v-384h384v384H128zm128-256v128h128v-128H256zm-128 768v-384h384v384H128zm128-256v128h128v-128H256zM640 128h1280v128H640V128zm0 640V640h1280v128H640zm0 512v-128h1280v128H640zm0 512v-128h1280v128H640z" })
      ]
    }
  );
}
var CollectionListView_default = SvgCollectionListView;

// src/components/Icon/icons/CollectionListViewMirrored.tsx
import { jsx as jsx252, jsxs as jsxs245 } from "react/jsx-runtime";
function SvgCollectionListViewMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs245(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx252("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx252("path", { d: "M1920 384V0h-384v384h384zm-128-256v128h-128V128h128zm128 768V512h-384v384h384zm-128-256v128h-128V640h128zm128 768v-384h-384v384h384zm-128-256v128h-128v-128h128zm128 768v-384h-384v384h384zm-128-256v128h-128v-128h128zM1408 128H128v128h1280V128zm0 640V640H128v128h1280zm0 512v-128H128v128h1280zm0 512v-128H128v128h1280z" })
      ]
    }
  );
}
var CollectionListViewMirrored_default = SvgCollectionListViewMirrored;

// src/components/Icon/icons/Color.tsx
import { jsx as jsx253, jsxs as jsxs246 } from "react/jsx-runtime";
function SvgColor({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs246(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx253("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx253("path", { d: "M1803 128q51 0 95 19t78 53 52 77 20 96q0 49-18 93t-54 80q-303 303-605 606t-606 606q-6 61-33 114t-69 92-98 61-117 23H192q-40 0-75-15t-61-41-41-61-15-75v-64h64q26 0 45-19t19-45q0-61 22-116t62-98 92-70 114-33q303-303 606-605t606-606q35-35 79-53t94-19zM576 1435q55 24 98 67t67 98l116-116q-61-104-165-165l-116 116zm-128 485q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 55-29 102t-80 71q18 19 45 19h256zM1886 456q34-34 34-83 0-24-9-45t-25-38-37-25-46-9q-49 0-83 34l-935 936q99 66 165 165l936-935z" })
      ]
    }
  );
}
var Color_default = SvgColor;

// src/components/Icon/icons/ColorEdit96.tsx
import { jsx as jsx254, jsxs as jsxs247 } from "react/jsx-runtime";
function SvgColorEdit96({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs247(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx254("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx254("path", { d: "M1600 1009q-5-108-45-202t-109-169l166-166q101 106 159 243t63 294h-234zm-1152 36q5 108 45 202t109 169l-166 166q-101-106-159-243t-63-294h234zm184-437L466 442q106-100 243-159t294-63v234q-108 5-202 45T632 608zm950-166l-166 166q-74-69-168-109t-203-45V220q157 4 294 63t243 159zM602 638q-69 74-109 168t-45 203H214q4-157 62-294t160-243l166 166zm844 778q69-74 109-168t45-203h234q-4 157-62 294t-160 243l-166-166zm-980 196l166-166q74 69 168 109t203 45v234q-157-4-294-62t-243-160zm579-12q108-5 202-45t169-109l166 166q-106 101-243 159t-294 63v-234z" })
      ]
    }
  );
}
var ColorEdit96_default = SvgColorEdit96;

// src/components/Icon/icons/ColorEdit961.tsx
import { jsx as jsx255, jsxs as jsxs248 } from "react/jsx-runtime";
function SvgColorEdit961({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs248(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx255("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx255("path", { d: "M632 608L466 442q106-100 243-159t294-63v234q-108 5-202 45T632 608z" })
      ]
    }
  );
}
var ColorEdit961_default = SvgColorEdit961;

// src/components/Icon/icons/ColorEdit962.tsx
import { jsx as jsx256, jsxs as jsxs249 } from "react/jsx-runtime";
function SvgColorEdit962({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs249(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx256("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx256("path", { d: "M602 638q-69 74-109 168t-45 203H214q4-157 62-294t160-243l166 166z" })
      ]
    }
  );
}
var ColorEdit962_default = SvgColorEdit962;

// src/components/Icon/icons/ColorEdit963.tsx
import { jsx as jsx257, jsxs as jsxs250 } from "react/jsx-runtime";
function SvgColorEdit963({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs250(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx257("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx257("path", { d: "M448 1045q5 108 45 202t109 169l-166 166q-101-106-159-243t-63-294h234z" })
      ]
    }
  );
}
var ColorEdit963_default = SvgColorEdit963;

// src/components/Icon/icons/ColorEdit964.tsx
import { jsx as jsx258, jsxs as jsxs251 } from "react/jsx-runtime";
function SvgColorEdit964({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs251(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx258("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx258("path", { d: "M466 1612l166-166q74 69 168 109t203 45v234q-157-4-294-62t-243-160z" })
      ]
    }
  );
}
var ColorEdit964_default = SvgColorEdit964;

// src/components/Icon/icons/ColorEdit965.tsx
import { jsx as jsx259, jsxs as jsxs252 } from "react/jsx-runtime";
function SvgColorEdit965({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs252(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx259("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx259("path", { d: "M1045 1600q108-5 202-45t169-109l166 166q-106 101-243 159t-294 63v-234z" })
      ]
    }
  );
}
var ColorEdit965_default = SvgColorEdit965;

// src/components/Icon/icons/ColorEdit966.tsx
import { jsx as jsx260, jsxs as jsxs253 } from "react/jsx-runtime";
function SvgColorEdit966({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs253(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx260("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx260("path", { d: "M1446 1416q69-74 109-168t45-203h234q-4 157-62 294t-160 243l-166-166z" })
      ]
    }
  );
}
var ColorEdit966_default = SvgColorEdit966;

// src/components/Icon/icons/ColorEdit967.tsx
import { jsx as jsx261, jsxs as jsxs254 } from "react/jsx-runtime";
function SvgColorEdit967({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs254(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx261("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx261("path", { d: "M1600 1009q-5-108-45-202t-109-169l166-166q101 106 159 243t63 294h-234z" })
      ]
    }
  );
}
var ColorEdit967_default = SvgColorEdit967;

// src/components/Icon/icons/ColorEdit968.tsx
import { jsx as jsx262, jsxs as jsxs255 } from "react/jsx-runtime";
function SvgColorEdit968({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs255(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx262("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx262("path", { d: "M1582 442l-166 166q-74-69-168-109t-203-45V220q157 4 294 63t243 159z" })
      ]
    }
  );
}
var ColorEdit968_default = SvgColorEdit968;

// src/components/Icon/icons/ColorWheel.tsx
import { jsx as jsx263, jsxs as jsxs256 } from "react/jsx-runtime";
function SvgColorWheel({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs256(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx263("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx263("path", { d: "M1024 0q141 0 272 36t245 103 207 160 160 208 103 245 37 272q0 141-36 272t-103 245-160 207-208 160-245 103-272 37q-53 0-99-20t-82-55-55-81-20-100q0-67 19-122t59-110q26-35 38-71t12-81q0-53-20-99t-55-82-81-55-100-20q-44 0-80 12t-72 38q-54 39-109 58t-123 20q-53 0-99-20t-82-55-55-81-20-100q0-141 36-272t103-245 160-207 208-160T751 37t273-37zm0 1920q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 27 10 50t27 40 41 28 50 10q46 0 80-12t72-38q28-19 54-33t55-25 58-15 65-5q80 0 150 30t122 82 82 122 30 150q0 35-5 65t-15 58-24 54-34 55q-26 37-38 71t-12 81q0 27 10 50t27 40 41 28 50 10zM512 640q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10zm384-256q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10zm512 384q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10zm128 256q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10zm-256 384q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10z" })
      ]
    }
  );
}
var ColorWheel_default = SvgColorWheel;

// src/components/Icon/icons/ColorWheelAvatar.tsx
import { jsx as jsx264, jsxs as jsxs257 } from "react/jsx-runtime";
function SvgColorWheelAvatar({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs257(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx264("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx264("path", { d: "M1024 256q106 0 204 27t183 78 156 120 120 155 77 184 28 204q0 106-27 204t-78 183-120 156-155 120-184 77-204 28q-106 0-204-27t-183-78-156-120-120-155-77-184-28-204q0-106 27-204t78-183 120-156 155-120 184-77 204-28zm0 1408q111 0 215-37t190-108l-91-91q-67 53-147 80t-167 28q-86 0-166-27t-148-81l-91 91q86 71 190 108t215 37zm495-235q71-86 108-190t37-215q0-88-23-170t-64-153-100-129-130-100-153-65-170-23q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170q0 111 37 215t108 190l178-179q34 36 68 65t72 50 82 32 95 11q52 0 95-11t81-31 73-50 68-66l178 179zM1024 0q141 0 272 36t245 103 207 160 160 208 103 245 37 272q0 141-36 272t-103 245-160 207-208 160-245 103-272 37q-141 0-272-36t-245-103-207-160-160-208-103-244-37-273q0-141 36-272t103-245 160-207 208-160T751 37t273-37zm0 1920q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 123 32 237t90 214 141 182 181 140 214 91 238 32z" })
      ]
    }
  );
}
var ColorWheelAvatar_default = SvgColorWheelAvatar;

// src/components/Icon/icons/Commitments.tsx
import { jsx as jsx265, jsxs as jsxs258 } from "react/jsx-runtime";
function SvgCommitments({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs258(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx265("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx265("path", { d: "M1344 0q26 0 45 19l640 640q19 19 19 45t-19 45l-243 243q25 25 49 48t42 47 30 54 12 67q0 40-15 76t-41 63-61 43-75 17q-2 41-17 75t-40 60-60 41-75 16q-1 40-17 75t-43 61-63 42-76 15q-32 0-65-11-11 31-29 56t-44 44-55 29-63 10q-26 0-46-4t-37-14-34-22-35-29q-35 32-68 50t-84 19q-40 0-76-15t-63-41-43-61-17-76q-39-1-74-16t-61-41-41-61-16-74q-40-1-74-16t-60-41-41-61-17-74q-41-1-76-17t-61-43-41-62-15-76q0-41 15-77t44-65l106-107L19 749Q0 730 0 704t19-45L659 19q19-19 45-19t45 19l132 132q13-4 50-17t87-29 103-35 102-34 81-26 40-10zM312 960q-29 0-50 21l-113 112q-21 21-21 51t20 50 51 21q31 0 51-20l113-112q21-21 21-51t-21-51-51-21zm192 192q-14 0-27 5t-24 16l-112 113q-21 21-21 51 0 29 21 49t51 21q14 0 27-5t24-15l112-113q21-21 21-50 0-30-21-51t-51-21zm192 192q-29 0-50 21l-113 112q-21 21-21 51t20 50 51 21q31 0 51-20l113-112q21-21 21-51t-21-51-51-21zm8 377q0 29 21 49t51 21q14 0 27-5t24-15l112-113q21-21 21-50 0-30-21-51t-51-21q-14 0-27 5t-24 16l-112 113q-21 21-21 51zm1016-441q29 0 50-21t22-50q0-30-21-51l-632-633q-3-3-10-5t-14-4-15-3-12-1q-26 0-49 10t-41 27-28 41-10 50q0 53-20 99t-55 82-81 55-100 20q-40 0-75-15t-61-41-41-61-15-75q0-24 5-53t16-52l187-375q9-16 27-26l-43-43-550 549 137 134q6-1 12-1t12-1q40 0 75 14t62 39 42 61 17 77q40 2 75 16t60 40 41 60 16 76q40 2 75 16t60 40 41 60 16 76q41 2 76 17t61 41 41 62 15 77q0 45-18 84t-52 68q2 1 2 2t2 2q14 12 26 20t32 8q29 0 50-21t22-50q0-30-21-51l90-91 65 64q23 21 50 21 29 0 50-21t22-50q0-30-21-51l-113-113 91-90 112 112q21 21 51 21t51-21 21-51q0-30-21-51l-113-112 91-91 113 113q21 21 50 21zm173-576l-566-567-504 168-174 348q-5 9-7 25t-2 26q0 26 19 45t45 19q27 0 50-10t40-27 28-41 10-50q0-53 20-99t55-82 81-55 100-20q16 0 34 3t38 8 35 14 29 21l472 472 197-198z" })
      ]
    }
  );
}
var Commitments_default = SvgCommitments;

// src/components/Icon/icons/CommunityProgramming.tsx
import { jsx as jsx266, jsxs as jsxs259 } from "react/jsx-runtime";
function SvgCommunityProgramming({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs259(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx266("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx266("path", { d: "M384 640H256V512h128v128zm0 256H256V768h128v128zm-128 128h128v128H256v-128zm1536-384h-128V512h128v128zm256-512v593q-59-41-128-62V256h-128v128h-128V256H384v128H256V256H128v1152h128v-128h128v128h531q-9 32-14 64t-5 64H0V128h2048zm-141 1079q66 45 103 115t38 150h-128q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 52-20 99t-57 84q66 45 103 115t38 150h-128q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75H960q0-80 37-150t104-115q-37-36-57-83t-20-100q0-53 20-99t55-82 81-55 100-20q51 0 99 20t84 57q35-51 86-86-36-36-56-84t-21-99q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100q0 51-20 99t-57 84zm-627 393q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10zm320-576q0 27 10 50t27 40 41 28 50 10q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50z" })
      ]
    }
  );
}
var CommunityProgramming_default = SvgCommunityProgramming;

// src/components/Icon/icons/Compare.tsx
import { jsx as jsx267, jsxs as jsxs260 } from "react/jsx-runtime";
function SvgCompare({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs260(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx267("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx267("path", { d: "M1603 256l214 640h103v128h-22q-20 57-56 104t-84 81-104 52-118 19q-61 0-117-18t-104-52-84-81-57-105h-22V896h103l214-640h-445v1410q167 11 316 75t273 179h179v128H128v-128h179q123-114 272-178t317-76V256H451l214 640h103v128h-22q-20 57-56 104t-84 81-104 52-118 19q-61 0-117-18t-104-52-84-81-57-105H0V896h103l214-640H0V128h896V0h128v128h896v128h-317zM384 458L238 896h292L384 458zm0 694q69 0 128-34t94-94H162q35 60 94 94t128 34zm1020 768q-100-63-213-95t-231-33q-118 0-231 32t-213 96h888zm132-1462l-146 438h292l-146-438zm0 694q69 0 128-34t94-94h-444q35 60 94 94t128 34z" })
      ]
    }
  );
}
var Compare_default = SvgCompare;

// src/components/Icon/icons/CompareGames.tsx
import { jsx as jsx268, jsxs as jsxs261 } from "react/jsx-runtime";
function SvgCompareGames({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs261(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx268("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx268("path", { d: "M576 445q-14 0-24-9t-10-23q0-14 10-23t24-9q14 0 24 9t10 23q0 14-10 23t-24 9zM168 854q-36 0-66-15t-52-41-34-57-12-68q0-32 5-64t16-64l1-1 120-288q6-4 13-15t15-19v-37q28-13 53-23t51-16 52-10 59-3q30 0 49 8t46 20l1 1h182l1-1q27-12 46-20t49-8q31 0 58 3t52 9 51 17 54 23v37q6 6 15 16t12 18l122 289q11 27 16 63t5 65q0 35-12 67t-33 58-52 40-67 16v-62 62q-27 0-41-9t-23-11L763 697q-11-9-31-13t-34-4H460q-14 0-33 4t-31 13L231 834q-13 11-30 15t-33 5zm-40-181q0 16 9 34t26 23l158-131q13-11 30-19t36-13 37-8 36-3h238q22 0 39 3t33 8 31 13 35 18l3 1 150 131q17-4 26-22t9-35q0-18-2-41t-10-41L896 315q-8-8-19-12t-23-9v-26q-22-7-45-9t-46-3q-4 0-6 1l-1 1q-27 12-46 20t-49 8H491q-30 0-49-8t-46-20l-1-1q-2-1-6-1-23 0-46 2t-45 10v26q-11 5-22 9t-20 12L140 591q-7 17-9 40t-3 42zm1344 776q14 0 24 9t10 23q0 14-10 23t-24 9q-13 0-23-9t-11-23q0-14 10-23t24-9zm402-151q8 7 16 16t12 19l121 292q11 27 16 63t5 65q0 34-11 66t-31 56-49 40-66 15q-17 0-34-5t-30-16l-164-131q-13-10-31-14t-34-4h-238q-14 0-33 4t-31 13l-158 132q-13 11-30 16t-33 5q-36 0-67-14t-54-39-37-57-13-67q0-32 5-64t16-64l1-1 120-291q4-9 12-18t16-17v-37q55-27 104-40t111-13q29 0 49 9t46 20l1 1h181q21-12 46-21t51-9q62 0 111 13t104 40v37zm18 507q16-2 22-20t6-32q0-19-2-42t-10-41l-116-279q-8-8-19-12t-23-9v-27q-23-6-45-8t-46-3h-6l-1 1q-26 11-46 20t-49 9h-170q-25 0-50-9t-47-21q-24 0-48 2t-48 9v27q-11 5-22 9t-20 12l-116 279q-7 17-9 40t-3 43q0 18 11 34t30 18l152-126q13-11 30-19t36-13 37-8 36-3h238q36 0 74 10t67 34l157 125zm70-1506L170 1974l-84-91L1878 209l84 90z" })
      ]
    }
  );
}
var CompareGames_default = SvgCompareGames;

// src/components/Icon/icons/Complaint.tsx
import { jsx as jsx269, jsxs as jsxs262 } from "react/jsx-runtime";
function SvgComplaint({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs262(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx269("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx269("path", { d: "M2029 1939q19 19 19 45t-19 45-45 19q-26 0-45-19L896 986l-143 143q7 14 11 29t4 31q0 53-38 91l-90 90q-18 18-41 28t-50 10q-26 0-49-10t-41-28L37 948Q0 911 0 858q0-26 9-49t28-42l91-90q18-18 41-27t49-9q32 0 60 14l377-378q-7-14-11-29t-4-31q0-53 37-90l91-91q18-18 41-27t49-9q26 0 49 9t42 27l421 422q38 38 38 91 0 52-38 90l-90 91q-18 18-41 27t-50 10q-32 0-59-15L986 895l1043 1044zM666 1034l369-368-294-294-368 369 293 293zm102-817l421 422v64l1-64h-1l91-90-422-422-90 90zm-128 972L218 767l-90 91 421 422v64l1-64h-1l91-91z" })
      ]
    }
  );
}
var Complaint_default = SvgComplaint;

// src/components/Icon/icons/ComplaintError.tsx
import { jsx as jsx270, jsxs as jsxs263 } from "react/jsx-runtime";
function SvgComplaintError({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs263(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx270("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx270("path", { d: "M858 1q26 0 49 9t42 27l422 422q37 37 37 90 0 26-9 49t-28 42l-91 91q-18 18-41 27t-50 10q-16 0-30-4t-29-11L987 896l357 358v180L896 987l-143 143q7 14 11 28t4 31q0 26-9 49t-28 42l-91 91q-18 18-41 27t-50 10q-53 0-90-37L37 949Q0 912 0 859q0-26 9-49t28-42l91-91q17-17 40-26t49-10q32 0 61 15l377-378q-7-14-11-28t-4-31q0-26 9-49t28-42l91-91q18-18 41-27t49-9zM640 1189L219 768l-91 91 421 421 91-91zm395-523L742 373 373 742l293 293 369-369zm245-117L859 128l-91 91 421 421 91-91zm384 1371h128v128h-128v-128zm64-704q53 0 99 20t82 55 55 81 20 100q0 47-17 89t-49 76h-1l-95 96q-14 14-20 28t-8 29-3 32 1 34h-128v-48q0-46 14-81t35-63 47-50 46-45 36-45 14-52q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50h-128q0-53 20-99t55-82 81-55 100-20z" })
      ]
    }
  );
}
var ComplaintError_default = SvgComplaintError;

// src/components/Icon/icons/ComplaintErrorMirrored.tsx
import { jsx as jsx271, jsxs as jsxs264 } from "react/jsx-runtime";
function SvgComplaintErrorMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs264(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx271("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx271("path", { d: "M858 1q26 0 49 9t42 27l422 422q37 37 37 90 0 26-9 49t-28 42l-91 91q-18 18-41 27t-50 10q-16 0-30-4t-29-11L987 896l357 358v180L896 987l-143 143q7 14 11 28t4 31q0 26-9 49t-28 42l-91 91q-18 18-41 27t-50 10q-53 0-90-37L37 949Q0 912 0 859q0-26 9-49t28-42l91-91q17-17 40-26t49-10q32 0 61 15l377-378q-7-14-11-28t-4-31q0-26 9-49t28-42l91-91q18-18 41-27t49-9zM640 1189L219 768l-91 91 421 421 91-91zm395-523L742 373 373 742l293 293 369-369zm245-117L859 128l-91 91 421 421 91-91zm384 1371h128v128h-128v-128zm64-704q53 0 99 20t82 55 55 81 20 100h-128q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50q0 29 14 52t35 45 47 44 46 51 36 63 14 81v48h-128v-33q0-16-1-32t-9-30-20-28q-30-30-59-57t-52-58-37-65-14-81q0-53 20-99t55-82 81-55 100-20z" })
      ]
    }
  );
}
var ComplaintErrorMirrored_default = SvgComplaintErrorMirrored;

// src/components/Icon/icons/Completed.tsx
import { jsx as jsx272, jsxs as jsxs265 } from "react/jsx-runtime";
function SvgCompleted({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs265(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx272("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx272("path", { d: "M832 1254l659-659 90 90-749 749-365-365 90-90 275 275zm1216-230q0 142-36 272t-103 245-160 207-208 160-245 103-272 37q-142 0-272-36t-245-103-207-160-160-208-103-245-37-272q0-141 36-272t103-245 160-207 208-160T752 37t272-37q141 0 272 36t245 103 207 160 160 208 103 245 37 272zm-1024 896q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-124 0-238 32t-213 90-182 141-140 181-91 214-32 238q0 124 32 238t90 213 141 182 181 140 214 91 238 32z" })
      ]
    }
  );
}
var Completed_default = SvgCompleted;

// src/components/Icon/icons/CompletedSolid.tsx
import { jsx as jsx273, jsxs as jsxs266 } from "react/jsx-runtime";
function SvgCompletedSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs266(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx273("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx273("path", { d: "M1024 0q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 141-36 272t-104 244-160 207-207 161-245 103-272 37q-141 0-272-36t-244-104-207-160-161-207-103-245-37-272q0-141 36-272t104-244 160-207 207-161T752 37t272-37zM832 1480l795-795-136-136-659 659-275-275-136 136 411 411z" })
      ]
    }
  );
}
var CompletedSolid_default = SvgCompletedSolid;

// src/components/Icon/icons/Computer.tsx
import { jsx as jsx274, jsxs as jsxs267 } from "react/jsx-runtime";
function SvgComputer({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs267(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx274("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx274("path", { d: "M2000 1525q12 12 21 29t15 36 9 38 3 36q0 27-10 50t-27 40-41 28-50 10H128q-27 0-50-10t-40-27-28-41-10-50q0-16 3-35t9-39 15-36 21-29l208-207V384h1536v934l208 207zM384 1280h1280V512H384v768zm1536 384q0-11-4-28t-12-26l-203-202H346l-202 202q-8 8-12 25t-4 29h1792z" })
      ]
    }
  );
}
var Computer_default = SvgComputer;

// src/components/Icon/icons/ConnectToConsole.tsx
import { jsx as jsx275, jsxs as jsxs268 } from "react/jsx-runtime";
function SvgConnectToConsole({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs268(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx275("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx275("path", { d: "M2048 576v896H256v-256H0V576h2048zm-128 640H384v128h1536v-128zm0-128V704H128v384h1792zm-320-256q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45q0-26 19-45t45-19zm-576-704q-138 0-258 60T563 358l-102-76q50-67 113-119t135-89 151-55 164-19q84 0 163 19t152 55 135 88 113 119l-102 77q-83-110-203-170t-258-60zM717 410q55-74 135-114t172-40q92 0 172 40t135 114l-102 76q-37-48-90-75t-115-27q-61 0-114 27t-91 75l-102-76zm307 1510q138 0 258-60t203-170l102 77q-50 67-113 119t-135 88-151 55-164 19q-84 0-163-19t-152-55-135-88-113-120l102-76q83 110 203 170t258 60zm307-282q-55 74-135 114t-172 40q-92 0-172-40t-135-114l102-76q37 48 90 75t115 27q61 0 114-27t91-75l102 76z" })
      ]
    }
  );
}
var ConnectToConsole_default = SvgConnectToConsole;

// src/components/Icon/icons/Console.tsx
import { jsx as jsx276, jsxs as jsxs269 } from "react/jsx-runtime";
function SvgConsole({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs269(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx276("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx276("path", { d: "M2048 512v896H256v-256H0V512h2048zm-128 640H384v128h1536v-128zm0-128V640H128v384h1792zm-320-256q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45q0-26 19-45t45-19z" })
      ]
    }
  );
}
var Console_default = SvgConsole;

// src/components/Icon/icons/ConsoleControllerPluggedIn.tsx
import { jsx as jsx277, jsxs as jsxs270 } from "react/jsx-runtime";
function SvgConsoleControllerPluggedIn({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs270(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx277("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx277("path", { d: "M1600 768q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45q0-26 19-45t45-19zm288 609q12 12 27 39t31 64 31 76 28 78 22 68 12 48q9 47 9 93 0 34-7 67t-27 62q-20 29-54 52t-72 24q-22 0-43-12t-42-32-40-43-38-45-35-36-31-20q-12-4-29-4t-30-1h-196q-16 0-36 1t-33 11q-23 16-48 46t-52 61-57 52-58 22q-37 0-71-23t-55-53q-19-29-26-61t-8-66q0-46 9-91t23-90H640q-27 0-50 10t-40 27-28 41-10 50q0 53-20 99t-55 82-81 55-100 20q-53 0-99-20t-82-55-55-81-20-100V512h2048v768q-9-12-25-29t-35-35-37-35-31-29H384v128h600q-7 14-19 29t-24 31-25 33-20 35H256v-256H128v640q0 27 10 50t27 40 41 28 50 10q27 0 50-10t40-27 28-41 10-50q0-53 20-99t55-82 81-55 100-20h400q7-17 15-39t19-44 21-42 25-34q0-17 8-32t23-24q13-9 37-16t50-13 52-9 42-3q18 0 29 2t19 6 18 10 24 13h164q15-7 24-13t17-10 20-6 29-2q16 0 41 3t52 8 50 13 38 17q14 9 22 24t9 32zM128 1024h1792V640H128v384zm1767 890q17-10 21-31t4-38q0-18-2-36t-6-37q-2-12-9-36t-18-55-23-64-24-64-22-52-17-31q-6-7-11-11t-10-8-9-10-8-19q-22-7-43-10t-44-4q-18 8-32 18t-35 13q-10 2-20 2t-21 0h-31q-15 0-31-1h-30q-15 0-32 1h-21q-10 0-20-2-20-2-34-12t-33-19q-23 0-44 4t-44 10q-2 12-6 18t-9 10-11 9-11 11q-6 8-16 30t-23 52-24 64-23 64-18 56-10 36q-3 17-5 35t-2 36q0 19 4 39t21 32q29-26 49-50t39-45 35-38 41-29 54-18 77-7h192q45 0 76 6t55 19 40 29 36 38 38 45 50 50zm-391-443q14 0 23 9t9 23q0 14-9 23t-23 9q-14 0-23-9t-9-23q0-14 9-23t23-9z" })
      ]
    }
  );
}
var ConsoleControllerPluggedIn_default = SvgConsoleControllerPluggedIn;

// src/components/Icon/icons/ConsoleInitialSetup.tsx
import { jsx as jsx278, jsxs as jsxs271 } from "react/jsx-runtime";
function SvgConsoleInitialSetup({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs271(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx278("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx278("path", { d: "M984 1280q-15 32-31 64t-31 64H256v-256H0V512h2048v768q-11-14-27-31t-34-34-35-33-32-30H384v128h600zm936-256V640H128v384h1792zm-320-256q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45q0-26 19-45t45-19zm288 609q12 12 27 40t31 63 31 76 28 78 22 68 12 48q9 47 9 93 0 35-7 67t-27 62q-20 29-54 52t-72 24q-22 0-43-12t-42-32-40-43-38-44-35-36-31-21q-11-4-29-4t-30-1h-222q-19 0-30 5-14 5-30 20t-35 37-37 44-41 42-42 32-43 13q-37 0-71-23t-55-53q-19-29-26-61t-8-66q0-24 2-48t8-47q3-18 12-49t21-67 28-76 30-75 31-64 28-42q0-17 8-32t23-24q14-9 38-16t50-13 51-9 42-3q18 0 29 2t19 6 18 10 24 13h164q15-7 24-13t17-10 20-6 29-2q16 0 41 3t52 8 50 13 38 17q14 9 22 24t9 32zm7 537q17-10 21-31t4-38q0-18-2-36t-6-37q-2-12-9-36t-18-55-23-64-24-64-22-52-17-31q-6-7-11-11t-10-8-9-10-8-19q-22-7-43-10t-44-4q-18 8-32 18t-35 13q-10 2-20 2t-21 0h-31q-15 0-31-1h-30q-15 0-32 1h-21q-10 0-20-2-20-2-34-12t-33-19q-23 0-44 4t-44 10q-2 12-6 18t-9 10-11 9-11 11q-6 8-16 30t-23 52-24 64-23 64-18 56-10 36q-3 17-5 35t-2 36q0 19 4 39t21 32q29-26 49-50t39-45 35-38 41-29 54-18 77-7h192q45 0 76 6t55 19 40 29 36 38 38 45 50 50zm-391-443q14 0 23 9t9 23q0 14-9 23t-23 9q-14 0-23-9t-9-23q0-14 9-23t23-9z" })
      ]
    }
  );
}
var ConsoleInitialSetup_default = SvgConsoleInitialSetup;

// src/components/Icon/icons/ConsoleMultiGuest.tsx
import { jsx as jsx279, jsxs as jsxs272 } from "react/jsx-runtime";
function SvgConsoleMultiGuest({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs272(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx279("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx279("path", { d: "M1850 688q46 26 82 62t62 79 40 93 14 102h-128q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100q0 92-41 173t-115 136q65 33 117 81t90 108 57 128 20 142h-128q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149H512q0-73 20-141t57-128 89-108 118-82q-74-55-115-136t-41-173q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100H0q0-52 14-101t39-93 62-80 83-62q-33-35-51-81t-19-95q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100q0 49-18 95t-52 81q82 45 134 124 27-40 62-72t76-54 87-34 95-12q48 0 94 12t87 34 77 54 62 72q52-79 134-124-33-35-51-81t-19-95q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100q0 49-18 95t-52 81zM256 512q0 27 10 50t27 40 41 28 50 10q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50zm768 768q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100q0 53 20 99t55 82 81 55 100 20zm512-768q0 27 10 50t27 40 41 28 50 10q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50z" })
      ]
    }
  );
}
var ConsoleMultiGuest_default = SvgConsoleMultiGuest;

// src/components/Icon/icons/ConsoleSettings.tsx
import { jsx as jsx280, jsxs as jsxs273 } from "react/jsx-runtime";
function SvgConsoleSettings({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs273(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx280("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx280("path", { d: "M1664 832q0 26-19 45t-45 19q-26 0-45-19t-19-45q0-26 19-45t45-19q26 0 45 19t19 45zm384-320v640h-40q-41-37-88-67V640H128v384h1287q-62 20-118 52t-105 76H384v128h700q-19 30-33 62t-27 66H256v-256H0V512h2048zm-10 976l-124 51q6 30 6 61t-6 61l124 51-49 119-124-52q-35 51-86 86l52 124-119 49-51-124q-30 6-61 6t-61-6l-51 124-119-49 52-124q-51-35-86-86l-124 52-49-119 124-51q-6-30-6-61t6-61l-124-51 49-119 124 52q35-51 86-86l-52-124 119-49 51 124q30-6 61-6t61 6l51-124 119 49-52 124q51 35 86 86l124-52 49 119zm-438 304q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15z" })
      ]
    }
  );
}
var ConsoleSettings_default = SvgConsoleSettings;

// src/components/Icon/icons/ConsoleSleep.tsx
import { jsx as jsx281, jsxs as jsxs274 } from "react/jsx-runtime";
function SvgConsoleSleep({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs274(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx281("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx281("path", { d: "M768 512q0 141 36 272t104 244 160 207 207 161 245 103 272 37q31 0 61-2t62-6q-68 120-164 216t-211 164-247 104-269 36q-141 0-272-36t-244-104-207-160-161-207-103-245-37-272q0-129 31-250t88-229 139-199 181-162T655 69 901 8q-65 115-99 243t-34 261zm256 1408q181 0 343-68t291-196q-145-17-276-67t-245-129-205-182-157-225-100-258-35-283q0-162 45-317-126 51-229 136T281 524 168 760t-40 264q0 124 32 238t90 214 140 181 181 140 214 91 239 32zm907-1493q55 35 86 91t31 122q0 53-20 99t-55 82-81 55-100 20h-480q-60 0-112-22t-92-62-61-91-23-113q0-60 22-112t62-92 91-61 113-23h8q3 0 9 1 51-62 120-95t151-34q55 0 107 17t95 48 77 74 52 96zm-139 341q27 0 50-10t40-27 28-41 10-50q0-45-28-78t-71-44q-5-42-24-78t-49-63-68-42-80-15q-36 0-69 11t-60 31-49 47-33 62q-18-10-37-16t-40-7q-33 0-62 12t-51 35-34 51-13 62q0 33 12 62t35 51 51 34 62 13h480z" })
      ]
    }
  );
}
var ConsoleSleep_default = SvgConsoleSleep;

// src/components/Icon/icons/ConsoleSolid.tsx
import { jsx as jsx282, jsxs as jsxs275 } from "react/jsx-runtime";
function SvgConsoleSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs275(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx282("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx282("path", { d: "M256 1408v-128h1792v128H256zM0 512h2048v640H0V512zm1600 416q40 0 68-28t28-68q0-40-28-68t-68-28q-40 0-68 28t-28 68q0 40 28 68t68 28z" })
      ]
    }
  );
}
var ConsoleSolid_default = SvgConsoleSolid;

// src/components/Icon/icons/ControllerBatteryFull.tsx
import { jsx as jsx283, jsxs as jsxs276 } from "react/jsx-runtime";
function SvgControllerBatteryFull({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs276(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx283("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx283("path", { d: "M960 704q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45zm1088 768v128h-128v256H896v-640h1024v256h128zm-256-128h-768v384h768v-384zm-640 256v-128h512v128h-512zM448 554q-18 8-39 17t-30 30l-223 605q-17 44-22 99t-6 103q0 27 7 60t24 62 40 50 57 20l307-301q18-18 43-32t53-24 56-16 53-8v130q-14 2-30 5t-33 9-32 13-25 18l-299 299q-17 17-43 26t-50 9q-62 0-109-29t-80-76-50-104-17-111q0-28 1-60t6-64 11-63 17-58l225-609q8-23 24-43t36-35v-66q44-23 85-40t84-28 88-16 95-6q33 0 60 10t51 22 42 22 39 10h320q19 0 39-10t43-22 50-22 60-10q50 0 95 5t87 17 84 28 86 40v66q20 14 36 34t24 44l197 534h-137l-179-488q-3-10-11-17t-19-12-20-9-19-8v-66q-54-21-110-30t-114-10q-19 0-39 10t-43 22-50 22-60 10H864q-33 0-60-10t-51-22-42-22-39-10q-57 0-113 9t-111 31v66z" })
      ]
    }
  );
}
var ControllerBatteryFull_default = SvgControllerBatteryFull;

// src/components/Icon/icons/ControllerBatteryHalf.tsx
import { jsx as jsx284, jsxs as jsxs277 } from "react/jsx-runtime";
function SvgControllerBatteryHalf({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs277(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx284("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx284("path", { d: "M960 704q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45zm1088 768v128h-128v256H896v-640h1024v256h128zm-256-128h-768v384h768v-384zm-640 256v-128h256v128h-256zM448 554q-18 8-39 17t-30 30l-223 605q-17 44-22 99t-6 103q0 27 7 60t24 62 40 50 57 20l307-301q18-18 43-32t53-24 56-16 53-8v130q-14 2-30 5t-33 9-32 13-25 18l-299 299q-17 17-43 26t-50 9q-62 0-109-29t-80-76-50-104-17-111q0-28 1-60t6-64 11-63 17-58l225-609q8-23 24-43t36-35v-66q44-23 85-40t84-28 88-16 95-6q33 0 60 10t51 22 42 22 39 10h320q19 0 39-10t43-22 50-22 60-10q50 0 95 5t87 17 84 28 86 40v66q20 14 36 34t24 44l197 534h-137l-179-488q-3-10-11-17t-19-12-20-9-19-8v-66q-54-21-110-30t-114-10q-19 0-39 10t-43 22-50 22-60 10H864q-33 0-60-10t-51-22-42-22-39-10q-57 0-113 9t-111 31v66z" })
      ]
    }
  );
}
var ControllerBatteryHalf_default = SvgControllerBatteryHalf;

// src/components/Icon/icons/ControllerBatteryLow.tsx
import { jsx as jsx285, jsxs as jsxs278 } from "react/jsx-runtime";
function SvgControllerBatteryLow({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs278(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx285("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx285("path", { d: "M960 704q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45zm1088 768v128h-128v256H896v-640h1024v256h128zm-256-128h-768v384h768v-384zm-512 256h-128v-128h128v128zM448 554q-18 8-39 17t-30 30l-223 605q-17 44-22 99t-6 103q0 27 7 60t24 62 40 50 57 20l307-301q18-18 43-32t53-24 56-16 53-8v130q-14 2-30 5t-33 9-32 13-25 18l-299 299q-17 17-43 26t-50 9q-62 0-109-29t-80-76-50-104-17-111q0-28 1-60t6-64 11-63 17-58l225-609q8-23 24-43t36-35v-66q44-23 85-40t84-28 88-16 95-6q33 0 60 10t51 22 42 22 39 10h320q19 0 39-10t43-22 50-22 60-10q50 0 95 5t87 17 84 28 86 40v66q20 14 36 34t24 44l197 534h-137l-179-488q-3-10-11-17t-19-12-20-9-19-8v-66q-54-21-110-30t-114-10q-19 0-39 10t-43 22-50 22-60 10H864q-33 0-60-10t-51-22-42-22-39-10q-57 0-113 9t-111 31v66z" })
      ]
    }
  );
}
var ControllerBatteryLow_default = SvgControllerBatteryLow;

// src/components/Icon/icons/ControllerBatteryThreeQuarter.tsx
import { jsx as jsx286, jsxs as jsxs279 } from "react/jsx-runtime";
function SvgControllerBatteryThreeQuarter({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs279(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx286("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx286("path", { d: "M960 704q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45zm1088 768v128h-128v256H896v-640h1024v256h128zm-256-128h-768v384h768v-384zm-640 256v-128h384v128h-384zM448 554q-18 8-39 17t-30 30l-223 605q-17 44-22 99t-6 103q0 27 7 60t24 62 40 50 57 20l307-301q18-18 43-32t53-24 56-16 53-8v130q-14 2-30 5t-33 9-32 13-25 18l-299 299q-17 17-43 26t-50 9q-62 0-109-29t-80-76-50-104-17-111q0-28 1-60t6-64 11-63 17-58l225-609q8-23 24-43t36-35v-66q44-23 85-40t84-28 88-16 95-6q33 0 60 10t51 22 42 22 39 10h320q19 0 39-10t43-22 50-22 60-10q50 0 95 5t87 17 84 28 86 40v66q20 14 36 34t24 44l197 534h-137l-179-488q-3-10-11-17t-19-12-20-9-19-8v-66q-54-21-110-30t-114-10q-19 0-39 10t-43 22-50 22-60 10H864q-33 0-60-10t-51-22-42-22-39-10q-57 0-113 9t-111 31v66z" })
      ]
    }
  );
}
var ControllerBatteryThreeQuarter_default = SvgControllerBatteryThreeQuarter;

// src/components/Icon/icons/ControllerNewRelease.tsx
import { jsx as jsx287, jsxs as jsxs280 } from "react/jsx-runtime";
function SvgControllerNewRelease({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs280(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx287("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx287("path", { d: "M1536 1152h128v256h-128v-256zm-207 86l181 181-91 91-181-181 91-91zm79 426h-256v-128h256v128zm11 26l91 91-181 181-91-91 181-181zm117 102h128v256h-128v-256zm245-102l181 181-91 91-181-181 91-91zm267-154v128h-256v-128h256zm-358-117l181-181 91 91-181 181-91-91zM960 704q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45zm1057 476q-78-78-180-122l-168-458q-3-10-11-17t-19-12-20-9-19-8v-66q-53-22-110-31t-114-9q-19 0-39 10t-43 22-50 22-60 10H864q-33 0-60-10t-51-22-42-22-39-10q-57 0-114 9t-110 31v66q-18 8-39 17t-30 30l-223 605q-17 44-22 99t-6 103q0 27 7 60t24 62 40 50 57 20q5 0 7-1l305-305q19-19 48-34t61-24 64-15 59-5h350q-50 59-83 128H800q-17 0-37 3t-42 9-39 15-31 21l-307 306q-15 14-41 22t-47 8q-62 0-109-29t-80-76-50-104-17-111q0-29 1-60t6-64 11-63 17-58l225-609q8-23 24-43t36-35v-66q44-23 85-40t84-28 88-16 95-6q33 0 60 10t51 22 42 22 39 10h320q19 0 39-10t43-22 50-22 60-10q50 0 95 5t87 17 84 28 86 40v66q20 14 36 34t24 44l224 608q2 5 2 9t3 9z" })
      ]
    }
  );
}
var ControllerNewRelease_default = SvgControllerNewRelease;

// src/components/Icon/icons/ControllerOff.tsx
import { jsx as jsx288, jsxs as jsxs281 } from "react/jsx-runtime";
function SvgControllerOff({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs281(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx288("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx288("path", { d: "M1536 1024h128v448h-128v-448zM960 704q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45zm-397 595q21-21 50-36t61-26 64-16 62-5h303q-37 59-60 128H800q-17 0-38 3t-43 9-39 15-32 23l-299 299q-17 17-43 26t-50 9q-62 0-109-29t-80-76-50-104-17-111q0-58 8-124t28-121l224-609q8-20 25-42t35-36v-66q44-23 85-40t84-28 88-16 95-6q33 0 60 10t51 22 42 22 39 10h320q19 0 39-10t43-22 50-22 60-10q50 0 95 5t87 17 84 28 86 40v66q20 14 36 35t24 43l198 536q-39-33-83-60t-93-46l-141-384q-3-10-11-17t-19-12-20-9-19-8v-66q-53-22-110-31t-114-9q-19 0-39 10t-43 22-50 22-60 10H864q-33 0-60-10t-51-22-42-22-39-10q-57 0-114 9t-110 31v66q-18 8-39 17t-30 30l-223 605q-16 44-22 99t-6 103q0 27 7 60t24 62 40 50 57 20l307-301zm1298-126q44 32 78 72t59 87 37 98 13 106q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-54 13-105t37-99 58-87 79-72l74 104q-63 45-98 113t-35 146q0 66 25 124t68 102 102 69 125 25q66 0 124-25t101-68 69-102 26-125q0-77-35-145t-98-114l74-104z" })
      ]
    }
  );
}
var ControllerOff_default = SvgControllerOff;

// src/components/Icon/icons/ControllerSettings.tsx
import { jsx as jsx289, jsxs as jsxs282 } from "react/jsx-runtime";
function SvgControllerSettings({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs282(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx289("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx289("path", { d: "M960 704q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45zm-397 595q21-20 49-35t61-26 65-16 62-6h333q-51 60-82 128H800q-17 0-38 3t-43 9-39 15-32 23l-299 299q-17 17-43 26t-50 9q-62 0-109-29t-80-76-50-104-17-111q0-28 1-60t6-64 11-63 17-58l225-609q8-23 24-43t36-35v-66q44-23 85-40t84-28 88-16 95-6q33 0 60 10t50 22 43 22 39 10h320q19 0 39-10t43-22 50-22 60-10q50 0 95 5t87 17 84 28 86 40v66q20 14 36 34t24 44l221 599q-40-36-84-65t-95-50l-161-438q-3-10-11-17t-19-12-20-9-19-8v-66q-54-21-110-30t-114-10q-19 0-39 10t-43 22-50 22-60 10H864q-33 0-60-10t-51-22-42-22-39-10q-57 0-113 9t-111 31v66q-18 8-39 17t-30 30l-223 605q-16 44-22 99t-6 103q0 27 7 60t24 62 40 50 57 20l307-301zm1351 240q6 30 6 61t-6 61l124 51-49 119-124-52q-35 51-86 86l52 124-119 49-51-124q-30 6-61 6t-61-6l-51 124-119-49 52-124q-51-35-86-86l-124 52-49-119 124-51q-6-30-6-61t6-61l-124-51 49-119 124 52q35-51 86-86l-52-124 119-49 51 124q30-6 61-6t61 6l51-124 119 49-52 124q51 35 86 86l124-52 49 119-124 51zm-314 253q39 0 74-15t61-41 42-62 15-74q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 39 15 74t41 61 62 42 74 15z" })
      ]
    }
  );
}
var ControllerSettings_default = SvgControllerSettings;

// src/components/Icon/icons/Copilot.tsx
import { jsx as jsx290, jsxs as jsxs283 } from "react/jsx-runtime";
function SvgCopilot({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs283(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx290("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx290("path", { d: "M768 1088q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45q0-26 19-45t45-19zm533-112q14 11 25 27t18 33l165 447q15 42 21 91t6 94q0 44-13 89t-40 81-64 59-88 23q-20 0-41-7t-37-21l-221-199q-18-17-47-23t-53-6H604q-23 0-52 6t-48 23l-222 200q-15 14-36 20t-41 7q-50 0-88-23t-64-59-39-81-14-89q0-48 7-93t20-92v-1l165-447q6-16 17-32t26-27v-50q67-37 132-55t143-18q36 0 64 14t61 29l2 2q8 2 14 2h234q6 0 14-2l2-2q32-15 60-29t65-14q78 0 142 18t133 55v50zm32 816q20-1 34-14t24-33 13-40 4-37q0-33-4-72t-16-71l-163-443q-2-5-9-9t-15-8-16-6-12-5v-48q-35-14-72-19t-75-6q-10 0-23 7t-31 16-39 16-48 8H651q-26 0-47-7t-39-16-31-16-24-8q-38 0-75 5t-72 20v48q-4 2-12 4t-16 7-15 8-9 9l-163 444q-11 32-15 70t-5 72q0 16 4 37t13 40 23 32 35 15l218-197q35-32 86-45t97-14h328q23 0 48 3t49 11 47 18 40 28l217 196zm11-1344q0 26-19 45t-45 19q-26 0-45-19t-19-45q0-26 19-45t45-19q26 0 45 19t19 45zm469-176q14 11 25 27t18 33l165 446q15 42 21 92t6 94q0 44-13 89t-40 81-64 59-88 23q-19 0-40-6t-35-20l-226-203q-13-11-33-17t-37-8V833q38 3 81 17t72 40l220 198q20-1 34-14t23-33 13-40 5-37q0-33-4-72t-16-71l-163-443q-2-5-9-9t-15-8-16-6-12-5v-48q-35-14-72-19t-75-6q-10 0-24 7t-31 16-39 16-47 8h-234q-24 0-45-7t-39-16-32-16-25-8q-38 0-75 5t-72 20v48q-11 5-29 11t-23 18L703 704H567l137-372q6-17 17-33t26-27v-50q67-37 132-55t143-18q24 0 45 7t39 16 32 16 25 8h234q12 0 26-7t31-16 38-16 46-8q78 0 142 18t133 55v50z" })
      ]
    }
  );
}
var Copilot_default = SvgCopilot;

// src/components/Icon/icons/CopyAllGames.tsx
import { jsx as jsx291, jsxs as jsxs284 } from "react/jsx-runtime";
function SvgCopyAllGames({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs284(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx291("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx291("path", { d: "M2048 512v1536H384v-256H128v-256H0V0h1536v256h256v256h256zM128 1408h1280V128H128v1280zm1536 256V384h-128v1152H256v128h1408zm256-1024h-128v1152H512v128h1408V640zm-775-124q5 10 22 48t38 88 39 105 27 97q14 76 8 128t-33 94q-12 19-28 33t-33 23-34 15-31 5q-17 0-32-6t-34-22-40-39-53-58q-14-16-26-29t-19-19l-11-7q-3-3-7-5t-11-4-21-3-34-1H704q-21 0-34 1t-20 3-12 4-7 5l-14 9q-5 4-16 17t-26 29q-30 34-52 58t-41 39-33 21-33 7q-14 0-31-5t-34-14-33-24-28-33q-26-41-32-93t7-129q7-42 25-95t39-104 38-88 24-51q8-18 25-35v-1q0-37 32-55 6-3 17-7t26-9 29-9 27-7l15-2q15-2 35-5t43-2 37 8q7 3 24 13 4 2 8 5t9 5h101q4-2 8-5t9-5q8-5 13-8t9-5q15-7 37-7t43 1 36 4 15 3q12 3 27 7t29 8 26 9 18 8q14 9 22 23t9 32v1q9 9 15 18t10 17zm-6 491q2-4 5-11t6-23 1-38-7-59q-6-33-21-79t-34-91-34-82-24-51q-13-7-23-19t-14-28l-16-4-16-4q-15-4-31-4t-25-2l-4 2q-21 14-35 20t-28 9H696q-14-2-27-8t-35-21l-4-2q-8 1-24 1t-32 5q-8 2-15 4t-16 4q-8 29-34 43-9 16-26 53t-35 83-34 92-22 79q-6 36-7 59t1 38 5 22 7 12q2 6 11 11l16-16q9-9 19-20t19-21 16-19q28-31 43-47t29-24q15-10 29-18t32-12 39-7 53-3h128q31 0 52 2t38 7 30 11 26 16q19 11 35 27t44 48q14 17 34 39t36 37l6-4q3-2 6-7zM768 608q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45q0-26 19-45t45-19z" })
      ]
    }
  );
}
var CopyAllGames_default = SvgCopyAllGames;

// src/components/Icon/icons/CopyGames.tsx
import { jsx as jsx292, jsxs as jsxs285 } from "react/jsx-runtime";
function SvgCopyGames({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs285(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx292("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx292("path", { d: "M1920 384v1536H256v-384H0V0h1536v384h384zm-512 1024V128H128v1280h1280zm384-896h-256v1024H384v256h1408V512zm-647 4q5 10 22 48t38 88 39 105 27 97q14 76 8 128t-33 94q-12 19-28 33t-33 23-34 15-31 5q-17 0-32-6t-34-22-40-39-53-58q-14-16-26-29t-19-19l-11-7q-3-3-7-5t-11-4-21-3-34-1H704q-21 0-34 1t-20 3-12 4-7 5l-14 9q-5 4-16 17t-26 29q-30 34-52 58t-41 39-33 21-33 7q-14 0-31-5t-34-14-33-24-28-33q-26-41-32-93t7-129q7-42 25-95t39-104 38-88 24-51q8-18 25-35v-1q0-37 32-55 6-3 17-7t26-9 29-9 27-7l15-2q15-2 35-5t43-2 37 8q7 3 24 13 4 2 8 5t9 5h101q4-2 8-5t9-5q8-5 13-8t9-5q15-7 37-7t43 1 36 4 15 3q12 3 27 7t29 8 26 9 18 8q14 9 22 23t9 32v1q9 9 15 18t10 17zm-6 491q2-4 5-11t6-23 1-38-7-59q-6-33-21-79t-34-91-34-82-24-51q-13-7-23-19t-14-28l-16-4-16-4q-15-4-31-4t-25-2l-4 2q-21 14-35 20t-28 9H696q-14-2-27-8t-35-21l-4-2q-8 1-24 1t-32 5q-8 2-15 4t-16 4q-8 29-34 43-9 16-26 53t-35 83-34 92-22 79q-6 36-7 59t1 38 5 22 7 12q2 6 11 11l16-16q9-9 19-20t19-21 16-19q28-31 43-47t29-24q15-10 29-18t32-12 39-7 53-3h128q31 0 52 2t38 7 30 11 26 16q19 11 35 27t44 48q14 17 34 39t36 37l6-4q3-2 6-7zM768 608q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45q0-26 19-45t45-19z" })
      ]
    }
  );
}
var CopyGames_default = SvgCopyGames;

// src/components/Icon/icons/CortanaLogoInner.tsx
import { jsx as jsx293, jsxs as jsxs286 } from "react/jsx-runtime";
function SvgCortanaLogoInner({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs286(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx293("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx293("path", { d: "M1024 128q124 0 238 32t214 90 181 140 140 181 91 214 32 239q0 124-32 238t-90 214-140 181-181 140-214 91-239 32q-124 0-238-32t-214-90-181-140-140-181-91-214-32-239q0-124 32-238t90-214 140-181 181-140 214-91 239-32zm0 1617q99 0 191-26t173-72 146-113 112-146 73-172 26-192q0-99-26-191t-72-173-113-146-146-112-172-73-192-26q-99 0-191 26t-173 72-146 113-112 146-73 172-26 192q0 99 26 191t72 173 113 146 146 112 172 73 192 26z" })
      ]
    }
  );
}
var CortanaLogoInner_default = SvgCortanaLogoInner;

// src/components/Icon/icons/CortanaLogoOuter.tsx
import { jsx as jsx294, jsxs as jsxs287 } from "react/jsx-runtime";
function SvgCortanaLogoOuter({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs287(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx294("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx294("path", { d: "M1024 0q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 141-36 272t-104 244-160 207-207 161-245 103-272 37q-141 0-272-36t-244-104-207-160-161-207-103-245-37-272q0-141 36-272t104-244 160-207 207-161T752 37t272-37zm0 1907q122 0 234-31t211-89 179-139 138-179 89-210 32-235q0-122-31-234t-89-211-139-179-179-138-210-89-235-32q-122 0-234 31t-211 89-179 139-138 179-89 210-32 235q0 122 31 234t89 211 139 179 179 138 210 89 235 32z" })
      ]
    }
  );
}
var CortanaLogoOuter_default = SvgCortanaLogoOuter;

// src/components/Icon/icons/CreateAppointment.tsx
import { jsx as jsx295, jsxs as jsxs288 } from "react/jsx-runtime";
function SvgCreateAppointment({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs288(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx295("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx295("path", { d: "M128 768v896h1152v128H0V256h384V128h128v128h768V128h128v128h384v1024h-128V768H128zm256-384H128v256h1536V384h-256v128h-128V384H512v128H384V384zm1408 1280h256v128h-256v256h-128v-256h-256v-128h256v-256h128v256z" })
      ]
    }
  );
}
var CreateAppointment_default = SvgCreateAppointment;

// src/components/Icon/icons/CreateClub.tsx
import { jsx as jsx296, jsxs as jsxs289 } from "react/jsx-runtime";
function SvgCreateClub({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs289(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx296("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx296("path", { d: "M640 1280q0-52 14-101t40-93 63-80 83-61q-34-35-53-81t-19-96q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100q0 50-19 96t-53 81q46 25 83 61t63 79 40 93 14 102h-128q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100H640zm384-640q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10zM0 256h2048v128h-256v512q0 98-15 194t-46 190h-137q34-93 52-189t18-195V384H384v512q0 163 45 315t128 284 201 237 266 176q140-67 256-168v163q-120 88-256 145-174-73-316-191t-242-268-155-327-55-366V384H0V256zM2048 0v128H0V0h2048zm-256 1664h256v128h-256v256h-128v-256h-256v-128h256v-256h128v256z" })
      ]
    }
  );
}
var CreateClub_default = SvgCreateClub;

// src/components/Icon/icons/CreateGameClubs.tsx
import { jsx as jsx297, jsxs as jsxs290 } from "react/jsx-runtime";
function SvgCreateGameClubs({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs290(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx297("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx297("path", { d: "M0 0h2048v128H0V0zm1533 1198q0 35-9 72t-28 68-48 50-71 20q-22 0-43-13t-42-32-37-39-30-36q-18-21-29-33t-24-20-30-9-45-3H951q-29 0-45 2t-29 10-24 19-30 34q-13 15-30 35t-37 39-41 32-44 14q-41 0-70-19t-49-50-28-68-9-73q0-20 2-38t5-38q3-17 10-47t18-66 23-76 24-74 23-63 19-41q0-33 12-56t48-26q23-2 40-9t39-13q20-5 40-8t42-3q16 0 27 2t22 6 21 10 23 15h142q13-8 23-14t20-11 22-6 28-2q21 0 41 3t41 8q21 5 38 12t41 10q35 3 47 26t13 56q8 13 19 40t23 63 24 75 22 75 18 67 11 47q3 19 5 37t2 39zm-149 76q15-12 19-31t4-37q0-45-13-98t-32-109-40-109-36-97q-19-5-27-9t-15-8-18-4-35-2h-12q-14 10-25 16t-21 10-23 5-30 2H968q-17 0-29-1t-23-5-22-10-25-17h-12q-24 0-35 1t-18 5-15 7-27 10q-15 44-36 97t-39 108-32 109-14 99q0 17 4 36t19 32q42-41 67-70t43-49 34-31 43-17 66-7 107-2q66 0 106 1t67 8 42 17 35 31 43 49 67 70zm408 134v256h256v128h-256v256h-128v-256h-256v-128h256v-256h128zm256-1152v128h-256v896h-128V384H384v1201l640 320 256-128v143l-256 128-768-384V384H0V256h2048z" })
      ]
    }
  );
}
var CreateGameClubs_default = SvgCreateGameClubs;

// src/components/Icon/icons/CreateTournament.tsx
import { jsx as jsx298, jsxs as jsxs291 } from "react/jsx-runtime";
function SvgCreateTournament({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs291(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx298("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx298("path", { d: "M1337 1337q24 48 43 98t35 101h-135q-19-57-45-114t-59-111-70-104-82-92l-19 18q-72 74-127 164t-92 189-58 203-23 206q13 11 22 25t9 32q0 26-19 45t-45 19q-26 0-45-19-63-59-122-120t-121-122l-275 274-90-90 274-275-210-211q-8-8-17-16t-16-18-13-19-5-24q0-26 19-45t45-19q18 0 32 9t25 22q103-2 211-23t210-62 194-99 165-135Q710 801 491 579T45 136L0 0l136 45q220 226 442 445t446 443q223-223 445-442t443-446l136-45-45 136q-226 220-445 442t-443 446q37 42 88 80t107 72 115 59 111 45v135q-51-16-101-35t-98-43zm-753 437q13-115 44-224t83-213q-103 51-212 82t-225 45l310 310zm1208-110h256v128h-256v256h-128v-256h-256v-128h256v-256h128v256z" })
      ]
    }
  );
}
var CreateTournament_default = SvgCreateTournament;

// src/components/Icon/icons/Crown.tsx
import { jsx as jsx299, jsxs as jsxs292 } from "react/jsx-runtime";
function SvgCrown({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs292(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx299("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx299("path", { d: "M1793 321q40 0 75 15t61 41 41 61 15 75q0 40-15 75t-42 61-61 41-75 15v1216H256V705q-40 0-74-15t-61-41-41-62-15-74q0-40 15-75t41-61 61-41 75-15q40 0 75 15t61 41 41 61 15 75q0 55-29 102t-80 71l361 479 260-471q-29-10-52-28t-41-42-26-52-9-59q0-40 15-75t41-61 61-41 75-15q40 0 75 15t61 41 41 61 15 75q0 61-34 110t-92 70l263 473 354-481q-49-24-78-70t-29-102q0-40 15-75t41-61 61-41 75-15zM961 513q0 27 19 45t46 19v-1l1 1q26-1 44-19t18-45q0-26-19-45t-45-19q-26 0-45 19t-19 45zm-768 0q0 26 18 45t45 19v-1l1 1q26 0 45-19t19-45q0-26-19-45t-45-19q-26 0-45 19t-19 45zm1470 451l-324 441-312-563-309 559-333-441v832h1278V964zm129-387q26 0 45-18t20-46q0-26-19-45t-45-19q-26 0-45 19t-19 45q0 25 17 43t42 21l4-5v5z" })
      ]
    }
  );
}
var Crown_default = SvgCrown;

// src/components/Icon/icons/CursorHand.tsx
import { jsx as jsx300, jsxs as jsxs293 } from "react/jsx-runtime";
function SvgCursorHand({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs293(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx300("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx300("path", { d: "M1600 384q40 0 75 15t61 41 41 61 15 75v896q0 119-45 224t-124 183-183 123-224 46q-144 0-268-55t-226-156l-472-472q-28-28-43-65t-15-76q0-42 16-78t43-64 63-42 78-16q41 0 76 15t65 44l107 106V320q0-40 15-75t41-61 61-41 75-15q37 0 71 14 8-31 26-57t42-45 55-29 62-11q32 0 62 10t54 30 43 45 26 57q34-14 71-14 40 0 75 15t61 41 41 61 15 75v75q33-11 64-11zm64 192q0-26-19-45t-45-19q-26 0-45 19t-19 45v448q0 26-19 45t-45 19q-26 0-45-19t-19-45V320q0-26-19-45t-45-19q-26 0-45 19t-19 45v640q0 26-19 45t-45 19q-26 0-45-19t-19-45V192q0-26-19-45t-45-19q-26 0-45 19t-19 45v768q0 26-19 45t-45 19q-26 0-45-19t-19-45V320q0-26-19-45t-45-19q-26 0-45 19t-19 45v915q0 23-8 42t-23 35-35 23-42 9q-22 0-42-8t-37-24l-139-139q-21-21-50-21t-50 21-22 51q0 29 21 50l472 473q84 84 184 128t219 45q93 0 174-35t142-96 96-142 36-175V576z" })
      ]
    }
  );
}
var CursorHand_default = SvgCursorHand;

// src/components/Icon/icons/CursorHandClosed.tsx
import { jsx as jsx301, jsxs as jsxs294 } from "react/jsx-runtime";
function SvgCursorHandClosed({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs294(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx301("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx301("path", { d: "M1472 448q40 0 75 15t61 41 41 61 15 75v448q0 97-25 187t-71 168-110 143-142 110-169 71-187 25q-97 0-187-25t-168-71-143-110-110-142-71-169-25-187V832q0-57 19-109t53-93 81-71 103-41v-70q0-40 15-75t41-61 61-41 75-15q50 0 93 23t69 66q45-25 94-25 50 0 93 23t69 66q45-25 94-25 50 0 93 23t69 66q45-25 94-25zm64 192q0-26-19-45t-45-19q-34 0-47 19t-16 47-1 62 0 61-16 48-48 19q-37 0-50-23t-16-60 2-77 2-77-15-59-51-24q-34 0-47 19t-16 47-1 62 0 61-16 48-48 19q-37 0-50-23t-16-60 2-77 2-77-15-59-51-24q-34 0-47 19t-16 47-1 62 0 61-16 48-48 19q-37 0-50-23t-16-60 2-77 2-77-15-59-51-24q-26 0-45 19t-19 45v512q0 26-19 45t-45 19q-26 0-45-19t-19-45V651q-29 10-52 28t-41 42-26 52-9 59v256q0 119 45 224t124 183 183 123 224 46q119 0 224-45t183-124 123-183 46-224V640z" })
      ]
    }
  );
}
var CursorHandClosed_default = SvgCursorHandClosed;

// src/components/Icon/icons/CursorHandClosedHorizontal.tsx
import { jsx as jsx302, jsxs as jsxs295 } from "react/jsx-runtime";
function SvgCursorHandClosedHorizontal({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs295(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2176 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx302("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx302("path", { d: "M1600 448q40 0 75 15t61 41 41 61 15 75v448q0 96-26 185t-73 168-112 143-143 111-167 71-183 26q-96 0-185-26t-168-73-143-112-111-143-71-167-26-183V832q0-65 24-123t70-103q68-68 162-88v-70q0-40 15-75t41-61 61-41 75-15q51 0 93 24t69 65q44-25 94-25 51 0 93 24t69 65q44-25 94-25 51 0 93 24t69 65q44-25 94-25zm64 192q0-26-19-45t-45-19q-26 0-45 19t-19 45v128q0 26-19 45t-45 19q-26 0-45-19t-19-45V576q0-26-19-45t-45-19q-26 0-45 19t-19 45v128q0 26-19 45t-45 19q-26 0-45-19t-19-45V512q0-26-19-45t-45-19q-26 0-45 19t-19 45v128q0 26-19 45t-45 19q-26 0-45-19t-19-45V448q0-26-19-45t-45-19q-26 0-45 19t-19 45v512q0 26-19 45t-45 19q-26 0-45-19t-19-45V651q-57 20-92 69t-36 112v256q0 119 45 224t124 183 183 123 224 46q119 0 224-45t183-124 123-183 46-224V640zM256 1280L0 1024l256-256v512zm1664-512l256 256-256 256V768z" })
      ]
    }
  );
}
var CursorHandClosedHorizontal_default = SvgCursorHandClosedHorizontal;

// src/components/Icon/icons/Default.tsx
import { jsx as jsx303, jsxs as jsxs296 } from "react/jsx-runtime";
function SvgDefault({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs296(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx303("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx303("path", { d: "M1024 0q141 0 272 36t245 103 207 160 160 208 103 245 37 272q0 141-36 272t-103 245-160 207-208 160-245 103-272 37q-141 0-272-36t-245-103-207-160-160-208-103-244-37-273q0-141 36-272t103-245 160-207 208-160T751 37t273-37zm0 128q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 65 9 128h1774q9-63 9-128 0-123-32-237t-90-214-141-182-181-140-214-91-238-32zm0 1792q148 0 285-46t250-131 197-203 127-260H165q43 142 126 260t197 202 250 131 286 47z" })
      ]
    }
  );
}
var Default_default = SvgDefault;

// src/components/Icon/icons/DefaultUser.tsx
import { jsx as jsx304, jsxs as jsxs297 } from "react/jsx-runtime";
function SvgDefaultUser({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs297(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx304("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx304("path", { d: "M1920 557v878l-265 265q-20 20-36 35t-32 30-31 31-34 37q-8 9-14 17t-11 17-10 18-13 20l-96 143H670l-95-143q-14-20-22-36t-26-35q-18-19-33-34t-32-28-32-28-36-32l-266-244V557l78-117 135-45 155-259q18-31 48-52t65-29l25-5q20-4 47-11t57-13 56-13 43-9 20-4h334q1 0 19 3t43 10 56 12 58 13 47 11 25 6q35 8 65 29t48 52l155 259 135 45 78 117zM666 768H346l-90 91v251l429 188 116-146h446l116 146 429-188V859l-91-91h-320l-128-128H794L666 768zm486-389l-59-59H954l-58 59v133h256V379zM896 1723v197h256v-197l-59-59H954l-58 59zm896-473l-467 204-140-174H863l-140 174-467-204v162l123 113 246 225 75 113 38 57h30v-250l128-128v-64l69-70h117l70 69v65l128 128v250h30l37-56 75-113 247-246 123-123v-132zm0-572v-83l-32-47-139-47-179-299q-11-17-31-22-5-1-23-5t-45-10-54-12-53-12-41-9-18-4H871q-1 0-17 3t-41 9-53 12-55 13-44 10-24 5q-20 5-31 22L427 501l-139 47-32 47v83l37-38h320l128-128h27V326l133-134h245l134 134v186h26l128 128h320l38 38z" })
      ]
    }
  );
}
var DefaultUser_default = SvgDefaultUser;

// src/components/Icon/icons/Delay.tsx
import { jsx as jsx305, jsxs as jsxs298 } from "react/jsx-runtime";
function SvgDelay({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs298(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx305("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx305("path", { d: "M1024 0q141 0 272 36t245 103 207 160 160 208 103 245 37 272q0 141-36 272t-103 245-160 207-208 160-245 103-272 37q-141 0-272-36t-245-103-207-160-160-208-103-244-37-273q0-141 36-272t103-245 160-207 208-160T751 37t273-37zm0 128q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 133 37 256h1024l643-643q-56-117-140-211t-190-160-227-102-251-36zm0 1792q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-133-37-256l-640 640H215q56 117 140 211t190 162 227 103 252 36z" })
      ]
    }
  );
}
var Delay_default = SvgDelay;

// src/components/Icon/icons/Delete.tsx
import { jsx as jsx306, jsxs as jsxs299 } from "react/jsx-runtime";
function SvgDelete({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs299(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx306("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx306("path", { d: "M1792 384h-128v1472q0 40-15 75t-41 61-61 41-75 15H448q-40 0-75-15t-61-41-41-61-15-75V384H128V256h512V128q0-27 10-50t27-40 41-28 50-10h384q27 0 50 10t40 27 28 41 10 50v128h512v128zM768 256h384V128H768v128zm768 128H384v1472q0 26 19 45t45 19h1024q26 0 45-19t19-45V384zM768 1664H640V640h128v1024zm256 0H896V640h128v1024zm256 0h-128V640h128v1024z" })
      ]
    }
  );
}
var Delete_default = SvgDelete;

// src/components/Icon/icons/Descending.tsx
import { jsx as jsx307, jsxs as jsxs300 } from "react/jsx-runtime";
function SvgDescending({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs300(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx307("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx307("path", { d: "M1216 896l320-640h-320V128h512l-320 640h320v128h-512zm-541 579l90 90-317 318-317-318 90-90 163 163V128h128v1510l163-163zm946 189h-298l-43 128h-128l256-768h128l256 768h-128l-43-128zm-42-128l-107-320-107 320h214z" })
      ]
    }
  );
}
var Descending_default = SvgDescending;

// src/components/Icon/icons/Design.tsx
import { jsx as jsx308, jsxs as jsxs301 } from "react/jsx-runtime";
function SvgDesign({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs301(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx308("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx308("path", { d: "M1280 128h768v1920H0V37l1280 1280V128zM128 1920h1573L128 347v1573zm1627-128l128 128h37V256h-512v128h256v128h-256v128h256v128h-256v128h384v128h-384v128h256v128h-256v128h256v128h-165l128 128h165v128h-37zM384 1061l603 603H384v-603zm128 310v165h165l-165-165z" })
      ]
    }
  );
}
var Design_default = SvgDesign;

// src/components/Icon/icons/Desktop.tsx
import { jsx as jsx309, jsxs as jsxs302 } from "react/jsx-runtime";
function SvgDesktop({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs302(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 64 64",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx309("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx309("path", { d: "M23.88.067A.5.5 0 0124.3.03l.08.037 31.515 18.192.068.057.04.043.031.045a.5.5 0 01.074.22l.002.046v35.74a.5.5 0 01-.178.382l-.072.051-13.11 7.57-2.656 1.54-.052.02-.076.02-.104.007-.06-.006-.06-.013-.073-.027-.039-.02-15.75-9.091-15.74-9.09a.5.5 0 01-.242-.345l-.008-.088V9.59a.5.5 0 01.075-.265l.043-.06.045-.045.087-.063L23.88.067zM8.89 10.456v34.575l15.49 8.946 15 8.657V28.049l-16.538-9.545L8.89 10.456zm46.22 43.665V19.535l-14.73 8.513v34.583l1.87-1.084 12.86-7.426zm-2.03-6.194a.5.5 0 01.743.347l.007.086v4.37a.5.5 0 01-.178.382l-.072.051-9.309 5.37-1.86 1.08a.5.5 0 01-.744-.347l-.007-.086v-4.36a.5.5 0 01.178-.382l.072-.05 11.17-6.46zm-.251 1.299l-10.17 5.882v3.203l1.111-.644 9.059-5.226v-3.215zm.25-8.159a.5.5 0 01.744.347l.007.086v4.37a.5.5 0 01-.178.382l-.072.051-9.309 5.37-1.86 1.08a.5.5 0 01-.744-.347l-.007-.086v-4.36a.5.5 0 01.178-.382l.072-.05 11.17-6.46zm-.25 1.299l-10.17 5.882v3.203l1.111-.644 9.059-5.226v-3.215zm-5.941-5.026c.715-1.239 1.873-1.91 2.585-1.498.713.411.71 1.75-.004 2.988-.716 1.239-1.873 1.91-2.586 1.498-.712-.412-.71-1.75.005-2.988zm6.192-14.613a.5.5 0 01.743.347l.007.086v4.36a.5.5 0 01-.178.382l-.072.051-9.309 5.37-1.86 1.08a.5.5 0 01-.744-.347l-.007-.086v-4.36a.5.5 0 01.178-.382l.072-.051 11.17-6.45zm-.251 1.299l-10.17 5.872v3.203l1.111-.644 9.059-5.226v-3.205zm-28.7-22.949L9.39 9.589l14.99 8.648 15.5 8.945 14.73-8.512L24.129 1.077z" })
      ]
    }
  );
}
var Desktop_default = SvgDesktop;

// src/components/Icon/icons/Details.tsx
import { jsx as jsx310, jsxs as jsxs303 } from "react/jsx-runtime";
function SvgDetails({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs303(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx310("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx310("path", { d: "M0 1280v-128h128v128H0zm0-384V768h128v128H0zm384 0V768h1664v128H384zM0 512V384h128v128H0zm384-128h1664v128H384V384zm0 896v-128h1664v128H384zM0 1664v-128h128v128H0zm384 0v-128h1664v128H384z" })
      ]
    }
  );
}
var Details_default = SvgDetails;

// src/components/Icon/icons/DetailsMirrored.tsx
import { jsx as jsx311, jsxs as jsxs304 } from "react/jsx-runtime";
function SvgDetailsMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs304(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx311("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx311("path", { d: "M2048 1280v-128h-128v128h128zm0-384V768h-128v128h128zm-384 0V768H0v128h1664zm384-384V384h-128v128h128zm-384-128H0v128h1664V384zm0 896v-128H0v128h1664zm384 384v-128h-128v128h128zm-384 0v-128H0v128h1664z" })
      ]
    }
  );
}
var DetailsMirrored_default = SvgDetailsMirrored;

// src/components/Icon/icons/DevDeploy.tsx
import { jsx as jsx312, jsxs as jsxs305 } from "react/jsx-runtime";
function SvgDevDeploy({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs305(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx312("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx312("path", { d: "M1920 448h128v1152h-128V448zm-749 108l90-91 564 558-565 559-90-91 408-403H127V961h1453l-409-405z" })
      ]
    }
  );
}
var DevDeploy_default = SvgDevDeploy;

// src/components/Icon/icons/DevUpdate.tsx
import { jsx as jsx313, jsxs as jsxs306 } from "react/jsx-runtime";
function SvgDevUpdate({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs306(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx313("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx313("path", { d: "M1024 512v550l365 365-90 90-403-402V512h128zm512 128h297q-56-117-141-211t-190-161-227-103-251-37q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 123 32 237t90 214 141 182 181 140 214 91 238 32q150 0 289-48t253-136 197-207 124-266l123 34q-45 166-140 304t-226 237-289 155-331 55q-141 0-272-36t-245-103-207-160-160-208-103-244-37-273q0-141 36-272t103-245 160-207 208-160T751 37t273-37q140 0 272 37t248 105 212 167 164 221V256h128v512h-512V640z" })
      ]
    }
  );
}
var DevUpdate_default = SvgDevUpdate;

// src/components/Icon/icons/Diamond.tsx
import { jsx as jsx314, jsxs as jsxs307 } from "react/jsx-runtime";
function SvgDiamond({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs307(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx314("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx314("path", { d: "M1928 829l-904 1113L120 829l537-573h734l537 573zm-666-61l-144-384H930L786 768h476zM779 896l245 858 245-858H779zm-93-512L327 768h343l144-384H686zM314 896l542 667-191-667H314zm878 667l542-667h-351l-191 667zm529-795l-359-384h-128l144 384h343z" })
      ]
    }
  );
}
var Diamond_default = SvgDiamond;

// src/components/Icon/icons/DiamondSolid.tsx
import { jsx as jsx315, jsxs as jsxs308 } from "react/jsx-runtime";
function SvgDiamondSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs308(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx315("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx315("path", { d: "M1423 768H625l267-640h264l267 640zm571 0h-398l-267-640h123l542 640zM626 896h796l-398 946-398-946zm970 0h401l-847 1058 446-1058zM51 896h401l446 1058L51 896zm668-768L452 768H54l540-640h125z" })
      ]
    }
  );
}
var DiamondSolid_default = SvgDiamondSolid;

// src/components/Icon/icons/DisabledCamera.tsx
import { jsx as jsx316, jsxs as jsxs309 } from "react/jsx-runtime";
function SvgDisabledCamera({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs309(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx316("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx316("path", { d: "M1402 1085l4-30q2-15 2-31 0-79-30-149t-82-122-123-83-149-30q-15 0-30 2t-31 4L859 542q40-14 81-22t84-8q106 0 199 40t162 110 110 163 41 199q0 42-8 83t-22 82l-104-104zm646-829v1475l-128-128V384h-475l-128-128H731l-79 79-91-91 116-116h694l128 128h549zM320 640q-26 0-45-19t-19-45q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19zM109 19l1920 1920-90 90-238-237H0V256h165L19 109l90-90zm602 783q-35 48-53 105t-18 117q0 81 30 150t81 121 122 80 151 29q60 0 116-16t106-51L711 802zM293 384H128v1280h1445l-235-236q-68 53-148 80t-166 28q-106 0-199-40t-163-109-110-163-40-200q0-86 27-166t81-148L293 384z" })
      ]
    }
  );
}
var DisabledCamera_default = SvgDisabledCamera;

// src/components/Icon/icons/DisabledMicrophone.tsx
import { jsx as jsx317, jsxs as jsxs310 } from "react/jsx-runtime";
function SvgDisabledMicrophone({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs310(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx317("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx317("path", { d: "M704 128q-27 0-45 18t-19 46v132L512 196q0-40 14-76t40-62 61-42 77-16h512q40 0 75 15t61 41 41 61 15 75v900l-128-128V192q0-27-18-45t-46-19H704zm959 1219l-127-127v-196h128l-1 323zm276 682l-377-377q-59 67-139 103t-169 37h-230v128h256v128H640v-128h256v-128H666q-85 0-159-32t-130-88-88-130-33-160v-358h128v358q0 58 22 109t61 90 89 60 110 23h588q63 0 119-27t98-75l-102-103q-27 36-67 56t-86 21H704q-40 0-75-15t-61-41-41-61-15-75V603L19 109l90-90 1920 1920-90 90zm-723-621q20 0 36-11t24-30L640 731v613q0 27 18 45t46 19h512z" })
      ]
    }
  );
}
var DisabledMicrophone_default = SvgDisabledMicrophone;

// src/components/Icon/icons/DiscArtist.tsx
import { jsx as jsx318, jsxs as jsxs311 } from "react/jsx-runtime";
function SvgDiscArtist({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs311(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx318("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx318("path", { d: "M129 1024q0 123 32 237t90 214 140 181 181 140 213 90 238 32l1-1v127h-20q-57-2-111-8t-110-20q-124-30-235-89t-204-141-164-187-115-223q-11-31-22-67t-19-74-14-75-5-71q0-32-1-65t1-65q2-54 12-110t26-108q45-158 139-293t221-234T684 59t320-56h38q75 3 146 14t144 34q106 34 199 88t173 125 143 157 106 183 67 203 24 217q0 19-1 37t-3 37q-53-62-125-108-5-119-39-229t-94-206-140-174-178-134-209-86-232-31q-123 0-237 32t-214 90-181 140-140 181-90 213-32 238zm1147-20q-73 50-127 119t-87 152q-10 2-19 3t-20 1q-53 0-99-20t-81-55-55-81-20-99q0-53 20-99t54-81 81-55 100-20q49 0 93 18t79 50 55 75 26 92zm-253 147q26 0 49-10t40-27 28-40 10-50q0-26-10-49t-27-41-40-28-50-10q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 27 50 10zm784 495q57 28 102 70t75 94 47 111 17 123h-128q0-68-24-126t-67-101-101-67-126-25q-67 0-125 24t-102 68-67 101-25 126h-128q0-62 16-120t46-110 75-93 99-71q-54-46-83-109t-30-135q0-66 25-123t68-101 102-69 124-25q66 0 123 25t101 68 69 101 25 124q0 69-28 131t-80 109zm-210-431q-39 0-74 15t-61 41-42 61-15 74q0 40 15 75t41 61 61 41 75 15q39 0 74-15t61-41 41-62 15-74q0-39-15-74t-41-61-61-41-74-15z" })
      ]
    }
  );
}
var DiscArtist_default = SvgDiscArtist;

// src/components/Icon/icons/DiscBad.tsx
import { jsx as jsx319, jsxs as jsxs312 } from "react/jsx-runtime";
function SvgDiscBad({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs312(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx319("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx319("path", { d: "M1600 1152q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm-320 448q0 66 25 124t68 102 102 69 125 25q47 0 92-13t84-40l-443-443q-26 39-39 84t-14 92zm587 176q26-39 39-84t14-92q0-66-25-124t-69-101-102-69-124-26q-47 0-92 13t-84 40l443 443zM768 1024q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100q0 53-20 99t-55 82-81 55-100 20q-53 0-99-20t-82-55-55-81-20-100zm384 0q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10q27 0 50-10t40-27 28-41 10-50zm-51 892q40 64 97 116-43 8-86 12t-88 4q-141 0-272-36t-244-104-207-160-161-207-103-245-37-272q0-141 36-272t104-244 160-207 207-161T752 37t272-37q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 44-4 87t-12 87q-52-57-116-97 2-20 3-38t1-39q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 123 32 237t90 214 141 182 181 140 214 91 238 32q20 0 38-1t39-3z" })
      ]
    }
  );
}
var DiscBad_default = SvgDiscBad;

// src/components/Icon/icons/DiscCantPlay.tsx
import { jsx as jsx320, jsxs as jsxs313 } from "react/jsx-runtime";
function SvgDiscCantPlay({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs313(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx320("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx320("path", { d: "M1600 1152q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm-320 448q0 66 25 124t68 102 102 69 125 25q47 0 92-13t84-40l-443-443q-26 39-39 84t-14 92zm587 176q26-39 39-84t14-92q0-66-25-124t-69-101-102-69-124-26q-47 0-92 13t-84 40l443 443zM768 1024q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100q0 53-20 99t-55 82-81 55-100 20q-53 0-99-20t-82-55-55-81-20-100zm384 0q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10q27 0 50-10t40-27 28-41 10-50zm-51 892q40 64 97 116-43 8-86 12t-88 4q-141 0-272-36t-244-104-207-160-161-207-103-245-37-272q0-141 36-272t104-244 160-207 207-161T752 37t272-37q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 44-4 87t-12 87q-52-57-116-97 2-20 3-38t1-39q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 123 32 237t90 214 141 182 181 140 214 91 238 32q20 0 38-1t39-3z" })
      ]
    }
  );
}
var DiscCantPlay_default = SvgDiscCantPlay;

// src/components/Icon/icons/DiscGame.tsx
import { jsx as jsx321, jsxs as jsxs314 } from "react/jsx-runtime";
function SvgDiscGame({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs314(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx321("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx321("path", { d: "M1044 1q160 5 307 55t271 138 218 212 149 275q27 76 43 159t16 165q0 66-6 128t-21 127l-115-79q7-38 11-77t4-79q0-124-32-238t-90-214-141-182-181-140-214-91-239-32q-123 0-237 32t-214 90-182 141-140 182-91 214-32 238q0 147 46 283t129 248 200 197 257 128q-1 68 17 137-171-43-313-137t-246-226-160-293-58-337q0-114 24-222t70-206 111-186 147-159 179-124 206-86q65-19 133-30t135-11h39zm208 1101q-4 0-22 5t-42 14-53 19-53 19-43 17-22 10q-14 10-23 19t-15 18-11 21-13 26q-41-12-75-35t-59-56-38-72-14-82q0-53 20-99t54-82 81-55 100-20q53 0 100 20t81 54 55 82 20 100q0 21-4 41t-10 40q-3-1-7-2t-7-2zm-356-77q0 26 10 49t27 41 41 27 50 10q26 0 49-10t41-27 28-40 10-50q0-27-10-50t-27-40-41-28-50-10q-26 0-49 10t-41 27-28 41-10 50zm575 456q14 0 24 10t10 24q0 14-10 24t-24 10q-14 0-24-10t-10-24q0-14 10-24t24-10zm404-133q7 7 16 18t12 21l121 328q11 31 15 69t5 71q0 35-10 69t-29 62-50 45-69 17q-19 0-37-6t-32-19l-163-147q-11-10-29-14t-32-5h-238q-13 0-32 4t-28 14l-158 149q-13 12-31 18t-36 6q-39 0-70-16t-55-44-35-62-13-71q0-35 4-71t16-69l1-1 120-327q3-9 12-20t17-19v-41q28-15 53-26t50-18 53-12 61-4q30 0 51 10t48 24h175q1 0 11-5t24-12 31-11 34-6q33 0 60 4t52 11 51 19 54 26v41zm17 570q7-3 12-10t8-17 4-19 1-17q0-23-3-49t-11-49l-116-316q-8-8-19-13t-21-10v-30q-22-8-44-10t-45-3h-3v1q-26 13-48 23t-51 10h-170q-31 0-52-10t-48-24q-23 0-46 2t-45 11v30q-3 2-9 4t-12 6-12 7-7 6l-117 316q-8 20-10 48t-3 50q0 18 9 38t28 26l149-140q13-12 30-21t37-16 39-10 38-3h238q37 0 77 12t68 38l154 139z" })
      ]
    }
  );
}
var DiscGame_default = SvgDiscGame;

// src/components/Icon/icons/DiscMusic.tsx
import { jsx as jsx322, jsxs as jsxs315 } from "react/jsx-runtime";
function SvgDiscMusic({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs315(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx322("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx322("path", { d: "M2048 1086v706q0 31-15 54t-38 40-51 25-56 9q-27 0-55-8t-52-25-38-40-15-55q0-31 14-54t38-40 52-25 56-9h16q8 0 16 2v-416l-384 96v574q0 32-16 55t-40 40-55 25-57 8q-27 0-57-8t-54-24-41-40-16-56q0-32 16-56t40-40 55-24 57-8q20 0 40 3v-549l640-160zm-1280-62q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100q0 53-20 99t-55 82-81 55-100 20q-53 0-99-20t-82-55-55-81-20-100zm384 0q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50q0 26 10 49t27 41 41 28 50 10q26 0 49-10t41-27 28-41 10-50zm-80 893q0 67 37 126-21 2-42 3t-43 2q-141 0-271-36t-245-104-207-160-161-208-103-244-37-272q0-140 36-270t103-244 159-208 206-161T747 37t271-37q135 0 261 33t237 94 204 147 162 192 111 230 51 259l-126 31q-5-119-40-229t-94-206-141-173-178-133-209-86-232-31q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 123 32 237t90 214 141 182 181 140 214 91 238 32q12 0 24-1t24-2z" })
      ]
    }
  );
}
var DiscMusic_default = SvgDiscMusic;

// src/components/Icon/icons/Dislike.tsx
import { jsx as jsx323, jsxs as jsxs316 } from "react/jsx-runtime";
function SvgDislike({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs316(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx323("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx323("path", { d: "M2048 384v896h-417q-65 0-122 24t-104 70l-622 621q-25 25-50 39t-61 14q-33 0-62-12t-51-35-34-51-13-62q0-81 18-154t53-146q20-43 34-87t19-93H192q-39 0-74-15t-61-41-42-61-15-75q0-32 10-61l256-768q20-59 70-95t112-36h512q178 0 345 69 72 29 144 44t151 15h448zm-128 768V512h-320q-179 0-345-69-144-59-295-59H448q-20 0-37 12t-24 32q-5 14-18 54t-33 96-42 124-46 137-44 134-39 118-27 86-10 39q0 26 19 45t45 19h576v64q0 81-18 154t-53 146q-28 58-42 118t-15 126q0 14 9 23t23 9q6 0 10-4t9-9l623-624q32-32 68-56t78-41q80-34 171-34h289z" })
      ]
    }
  );
}
var Dislike_default = SvgDislike;

// src/components/Icon/icons/DislikeSolid.tsx
import { jsx as jsx324, jsxs as jsxs317 } from "react/jsx-runtime";
function SvgDislikeSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs317(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx324("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx324("path", { d: "M2048 384v896h-417q-65 0-122 24t-104 70l-622 621q-25 25-50 39t-61 14q-33 0-62-12t-51-35-34-51-13-62q0-81 18-154t53-146q20-43 34-87t19-93H192q-39 0-74-15t-61-41-42-61-15-75q0-32 10-61l256-768q20-59 70-95t112-36h512q178 0 345 69 72 29 144 44t151 15h448z" })
      ]
    }
  );
}
var DislikeSolid_default = SvgDislikeSolid;

// src/components/Icon/icons/Dlc.tsx
import { jsx as jsx325, jsxs as jsxs318 } from "react/jsx-runtime";
function SvgDlc({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs318(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx325("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx325("path", { d: "M1792 640h256v1408H640v-256H384v-256H128V128h1408v256h256v1408H768v128h1152V768h-128V640zM256 256v1152h1152V256H256zm256 1280v128h1152V512h-128v1024H512zM896 384v384h384v128H896v384H768V896H384V768h384V384h128z" })
      ]
    }
  );
}
var Dlc_default = SvgDlc;

// src/components/Icon/icons/DlcSolid.tsx
import { jsx as jsx326, jsxs as jsxs319 } from "react/jsx-runtime";
function SvgDlcSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs319(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx326("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx326("path", { d: "M1792 640h256v1408H640v-256H384v-256H128V128h1408v256h256v256zM384 768v128h384v384h128V896h384V768H896V384H768v384H384zm128 896h1152V512h-128v1024H512v128zm1408 256V768h-128v1024H768v128h1152z" })
      ]
    }
  );
}
var DlcSolid_default = SvgDlcSolid;

// src/components/Icon/icons/Dock.tsx
import { jsx as jsx327, jsxs as jsxs320 } from "react/jsx-runtime";
function SvgDock({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs320(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx327("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx327("path", { d: "M1139 947l562-563h-293V256h512v512h-128V475l-563 562-90-90zm781-51v896H128V256h1152v128H256v768h768v512h768V896h128zM896 1664v-384H256v384h640z" })
      ]
    }
  );
}
var Dock_default = SvgDock;

// src/components/Icon/icons/DockMirrored.tsx
import { jsx as jsx328, jsxs as jsxs321 } from "react/jsx-runtime";
function SvgDockMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs321(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx328("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx328("path", { d: "M909 947L347 384h293V256H128v512h128V475l563 562 90-90zm-781-51v896h1792V256H768v128h1024v768h-768v512H256V896H128zm1024 768v-384h640v384h-640z" })
      ]
    }
  );
}
var DockMirrored_default = SvgDockMirrored;

// src/components/Icon/icons/Download.tsx
import { jsx as jsx329, jsxs as jsxs322 } from "react/jsx-runtime";
function SvgDownload({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs322(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx329("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx329("path", { d: "M384 2048v-128h1152v128H384zm1197-851l-621 626-621-626 90-90 467 470V0h128v1577l467-470 90 90z" })
      ]
    }
  );
}
var Download_default = SvgDownload;

// src/components/Icon/icons/DownloadSeeAll.tsx
import { jsx as jsx330, jsxs as jsxs323 } from "react/jsx-runtime";
function SvgDownloadSeeAll({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs323(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx330("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx330("path", { d: "M385 1435L17 1068l91-90 212 212V512h128v679l213-213 90 91-366 366zM0 1536h768v128H0v-128zm1877-662l15 15q7 7 13 17 18 35 38 81t39 96 34 98 22 85q5 25 7 49t3 50q0 36-8 70t-28 65q-20 30-56 54t-74 25q-21 0-43-11t-44-28-45-38-43-38-37-32-31-18q-15-4-37-5t-45-2-45 1-40 1h-39q-23 0-47-1t-45 1-36 5q-21 6-50 32t-61 56-67 53-65 24q-18 0-37-6t-37-18-32-26-25-29q-20-30-27-64t-8-70q0-26 2-50t8-50q3-19 12-52t23-72 30-82 33-80 33-67 30-44q0-39 31-58 13-9 38-16t52-14 54-9 43-4q14 0 27 1t27 7h1q18 8 30 25t26 31h152q17-17 26-29t19-20 24-11 42-4q18 0 42 3t51 8 49 13 39 16q21 12 29 27t8 39zm8 573q11-5 18-14t10-21 5-24 2-23q0-37-8-77-3-16-10-42t-18-56-23-63-24-63-23-54-20-38q-4-7-10-11t-13-11-12-14-9-24q-22-8-44-11t-45-5l-18 22q-9 11-19 21t-22 16-29 6h-202q-28 0-51-21t-37-44q-23 2-45 5t-44 11q-3 14-8 21t-10 11-12 9-11 11q-8 11-19 35t-23 56-26 66-24 68-19 58-10 41q-4 20-6 39t-2 39q0 11 1 23t4 23 11 20 18 15q24-16 46-35t43-39q46-42 80-61t68-27 75-6 102 2q61 0 102-1t75 5 67 26 81 62l42 38q21 19 46 36zm-413-423q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45q0-26 19-45t45-19z" })
      ]
    }
  );
}
var DownloadSeeAll_default = SvgDownloadSeeAll;

// src/components/Icon/icons/Dpad.tsx
import { jsx as jsx331, jsxs as jsxs324 } from "react/jsx-runtime";
function SvgDpad({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs324(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx331("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx331("path", { d: "M1664 768v512h-384v384H768v-384H384V768h384V384h512v384h384zm-128 384V896h-384V512H896v384H512v256h384v384h256v-384h384z" })
      ]
    }
  );
}
var Dpad_default = SvgDpad;

// src/components/Icon/icons/DpadDlSet.tsx
import { jsx as jsx332, jsxs as jsxs325 } from "react/jsx-runtime";
function SvgDpadDlSet({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs325(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx332("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx332("path", { d: "M1792 640v640h-512v512H640v-512H128V640h512V128h640v512h512zm-128 128h-512V256H768v512H256v384h512v512h384v-512h512V768z" })
      ]
    }
  );
}
var DpadDlSet_default = SvgDpadDlSet;

// src/components/Icon/icons/DpadDown.tsx
import { jsx as jsx333, jsxs as jsxs326 } from "react/jsx-runtime";
function SvgDpadDown({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs326(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx333("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx333("path", { d: "M1664 768v512h-384v384H768v-384H384V768h384V384h512v384h384zm-128 384V896h-384V512H896v384H512v256h384v384h256v-384h384zm-768 640h512l-256 256-256-256z" })
      ]
    }
  );
}
var DpadDown_default = SvgDpadDown;

// src/components/Icon/icons/DpadLeft.tsx
import { jsx as jsx334, jsxs as jsxs327 } from "react/jsx-runtime";
function SvgDpadLeft({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs327(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx334("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx334("path", { d: "M1664 768v512h-384v384H768v-384H384V768h384V384h512v384h384zm-128 384V896h-384V512H896v384H512v256h384v384h256v-384h384zM0 1024l256-256v512L0 1024z" })
      ]
    }
  );
}
var DpadLeft_default = SvgDpadLeft;

// src/components/Icon/icons/DpadRight.tsx
import { jsx as jsx335, jsxs as jsxs328 } from "react/jsx-runtime";
function SvgDpadRight({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs328(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx335("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx335("path", { d: "M1664 768v512h-384v384H768v-384H384V768h384V384h512v384h384zm-128 384V896h-384V512H896v384H512v256h384v384h256v-384h384zm512-128l-256 256V768l256 256z" })
      ]
    }
  );
}
var DpadRight_default = SvgDpadRight;

// src/components/Icon/icons/DpadUp.tsx
import { jsx as jsx336, jsxs as jsxs329 } from "react/jsx-runtime";
function SvgDpadUp({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs329(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx336("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx336("path", { d: "M1664 768v512h-384v384H768v-384H384V768h384V384h512v384h384zm-128 384V896h-384V512H896v384H512v256h384v384h256v-384h384zm-256-896H768L1024 0l256 256z" })
      ]
    }
  );
}
var DpadUp_default = SvgDpadUp;

// src/components/Icon/icons/Dress.tsx
import { jsx as jsx337, jsxs as jsxs330 } from "react/jsx-runtime";
function SvgDress({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs330(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx337("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx337("path", { d: "M1408 953q0 2 11 47t29 118 41 166 48 191 49 195 45 175 33 133 18 70H238q4-15 17-69t34-134 44-175 49-194 48-191 42-166 29-118 11-47V514H409L230 157q8-2 45-14t88-30 110-37 107-36 81-27 33-11h138v128q0 26 10 49t27 41 41 28 50 10q26 0 49-10t41-27 28-41 10-50V2h139q23 6 41 12t36 12 36 14 41 14l309 103-178 357h-104v439zm110 969l-236-944h-2V386h153l77-155-294-97q-1 52-21 98t-55 80-81 54-99 20q-52 0-98-20t-81-54-55-80-22-98l-294 97 78 155h152v592h-2l-236 944h1116z" })
      ]
    }
  );
}
var Dress_default = SvgDress;

// src/components/Icon/icons/Dvr.tsx
import { jsx as jsx338, jsxs as jsxs331 } from "react/jsx-runtime";
function SvgDvr({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs331(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx338("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx338("path", { d: "M1920 256v903q-28-28-60-50t-68-40V384H128v896h1069q-29 61-38 128h-135v128h135q9 67 38 128H640v-128h256v-128H0V256h1920zm-320 896q66 0 124 25t102 68 69 102 25 125q0 66-25 124t-68 102-102 69-125 25q-66 0-124-25t-102-68-69-102-25-125q0-66 25-124t68-102 102-69 125-25z" })
      ]
    }
  );
}
var Dvr_default = SvgDvr;

// src/components/Icon/icons/EaaHorizontalLogo.tsx
import { jsx as jsx339, jsxs as jsxs332 } from "react/jsx-runtime";
function SvgEaaHorizontalLogo({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs332(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 6720 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx339("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx339("path", { d: "M1022 1951q128 0 247-33t222-93 188-145 145-188 94-221 34-248q0-128-33-246t-94-222-146-188-188-145-222-94-247-33q-128 0-246 33t-222 93-188 146-145 188-94 221-34 247q0 128 33 246t93 222 146 188 188 145 222 94 247 33zm3-1951q141 0 272 36t246 103 207 160 161 207 103 245 37 273q0 142-36 273t-104 244-160 207-208 160-245 103-273 37q-141 0-272-36t-245-103-207-160-161-208-103-244-37-273q0-141 36-272t104-245 160-207 208-160T752 37t273-37zm455 629v35h-8v-43h12l11 31 11-31h13v43h-8v-35l-12 35h-7l-12-35zm-38 35v-36h-15v-7h37v7h-14v36h-8zm-236-43l-89 143H527l90-143h589zm117 0l448 715h-169l-90-143h-261l89-143h83l-100-159-279 445H301l179-286H349l89-143h574l-89 143H649l-90 143h406l358-572zm2590 90l-63 73q-42-43-94-63t-112-20q-60 0-110 21t-86 58-57 89-20 110q0 60 20 111t56 88 86 59 111 21q60 0 112-20t94-63l63 73q-55 57-123 82t-146 25q-80 0-149-28t-119-79-80-120-29-149q0-79 29-148t80-119 119-79 149-29q78 0 146 25t123 82zm714 0l-63 73q-42-43-94-63t-112-20q-60 0-110 21t-86 58-57 89-20 110q0 60 20 111t56 88 86 59 111 21q60 0 112-20t94-63l63 73q-55 57-123 82t-146 25q-80 0-149-28t-119-79-80-120-29-149q0-79 29-148t80-119 119-79 149-29q78 0 146 25t123 82zm665 199q0-44-17-82t-47-67-68-44-83-16q-45 0-87 15t-76 42-56 66-25 86h459zm-570 72q0-80 24-149t70-120 112-80 149-29q75 0 135 28t103 76 65 113 23 136v22q0 11-1 23h-576q2 56 20 103t51 81 79 53 103 19q71 0 121-23t98-76l69 68q-57 64-130 94t-158 31q-84 0-150-27t-112-76-70-117-25-150zm1200-192q-24-46-62-71t-92-25q-25 0-51 5t-47 19-36 33-14 50q0 30 13 49t33 31 46 19 49 13l102 25q36 9 67 26t56 41 37 57 14 71q0 59-24 100t-63 68-90 38-101 13q-86 0-156-33t-118-106l87-59q32 51 79 78t108 28q27 0 57-6t54-20 41-36 16-56q0-26-12-45t-31-34-45-23-51-15-50-11-44-9q-36-8-69-23t-58-39-41-54-15-72q0-56 22-96t60-67 85-38 97-13q37 0 72 7t66 22 56 39 43 60l-90 59zm650 0q-24-46-62-71t-92-25q-25 0-51 5t-47 19-36 33-14 50q0 30 13 49t33 32 45 18 49 13l103 25q36 9 67 26t55 41 37 57 14 71q0 59-24 100t-63 68-89 38-101 13q-86 0-156-33t-119-106l87-59q32 51 80 78t108 28q27 0 56-6t54-20 41-36 16-56q0-27-12-46t-31-33-45-23-51-15-50-11-44-9q-36-8-69-23t-58-39-41-54-15-72q0-55 22-95t60-67 85-39 97-13q37 0 72 7t67 22 56 39 43 60l-90 59zM3033 979q0-58-19-108t-54-88-84-60-108-22q-59 0-106 22t-80 61-51 88-18 107q0 56 17 107t51 89 80 60 107 23q60 0 108-22t84-60 54-88 19-109zm168 282v90h-46q-117 0-132-117-45 66-111 93t-144 28q-80 0-146-30t-113-81-73-119-27-146q0-77 26-145t74-119 114-81 145-30q37 0 74 7t70 22 60 39 48 58V625h105v561q0 27 3 42t11 22 23 9 39 2z" })
      ]
    }
  );
}
var EaaHorizontalLogo_default = SvgEaaHorizontalLogo;

// src/components/Icon/icons/EaaVerticalLogo.tsx
import { jsx as jsx340, jsxs as jsxs333 } from "react/jsx-runtime";
function SvgEaaVerticalLogo({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs333(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx340("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx340("path", { d: "M1024 1336q-92 0-177-24t-160-67-135-105-104-135-68-159-24-178q0-92 24-177t67-160 105-135T687 92t159-68 178-24q92 0 177 24t160 67 135 105 104 135 68 159 24 178q0 92-24 177t-67 160-105 135-135 104-159 68-178 24zm-2-1274q-125 0-235 47T594 239 465 431t-48 236q0 125 47 235t130 193 192 130 236 48q125 0 235-47t193-130 130-193 48-236q0-125-47-235t-130-193-193-129-236-48zm291 348v23h-5v-28h8l7 20 7-20h9v28h-6v-23l-7 23h-5l-8-23zm-25 23v-23h-9v-5h24v5h-9v23h-6zm-153-28l-58 93H693l58-93h384zm-105 467H545l117-187h-86l59-93h374l-59 93H772l-58 93h264l233-373 292 467h-110l-59-94h-170l58-93h54l-65-104-181 291zm-433 866q-29 0-52 10t-41 28-27 42-10 52q0 29 9 53t27 41 41 28 53 10q58 0 97-39l30 34q-26 26-58 38t-69 13q-38 0-70-13t-57-38-38-56-14-71q0-38 14-70t38-57 56-37 71-14q37 0 69 12t58 39l-30 34q-39-39-97-39zm337 0q-28 0-51 10t-41 28-27 42-10 52q0 28 9 52t27 42 40 28 53 10q28 0 53-9t45-30l30 34q-26 26-58 38t-70 13q-38 0-70-13t-57-38-37-56-14-71q0-37 13-69t38-57 56-38 71-14q37 0 69 12t59 39l-30 34q-20-20-45-29t-53-10zm340-46q35 0 63 13t49 37 32 53 11 64v11q0 6-1 11h-272q2 53 33 87t86 34q34 0 57-11t47-36l32 32q-53 60-136 60-39 0-70-13t-54-36-33-56-12-71q0-37 12-69t33-57 53-39 70-14zm-115 145h217q0-21-8-39t-22-31-32-21-40-8q-21 0-41 7t-36 20-26 31-12 41zm570 106q0 28-11 47t-30 32-43 19-48 6q-41 0-74-16t-56-50l41-28q15 23 38 36t51 14q13 0 27-3t25-9 19-18 8-26q0-21-14-32t-37-18-47-12-47-16-36-27-15-49q0-26 10-45t28-31 40-19 46-6q35 0 65 13t48 47l-43 29q-22-46-72-46-12 0-24 2t-23 9-17 15-7 24q0 22 14 32t37 17 48 12 48 16 36 29 15 52zm307 0q0 28-11 47t-30 32-43 19-48 6q-40 0-73-15t-56-51l41-28q15 23 37 36t51 14q13 0 27-3t26-9 19-17 8-27q0-21-14-32t-37-18-47-12-48-16-36-27-15-49q0-27 10-46t28-31 40-18 47-6q35 0 65 13t47 47l-42 29q-11-22-29-34t-44-12q-12 0-24 2t-22 9-17 15-7 24q0 22 14 33t37 17 47 12 48 15 36 29 15 52zm-1649 61v42h-22q-56 0-63-55-20 32-52 44t-68 13q-38 0-69-14t-53-38-35-57-13-69q0-36 12-68t35-57 54-39 69-14q35 0 68 14t51 46v-50h50v266q0 13 1 20t5 10 11 5 19 1zm-80-134q0-27-9-51t-25-42-40-28-51-11q-28 0-50 10t-38 29-24 42-9 51q0 27 8 51t24 42 38 28 51 11q28 0 51-10t39-29 26-42 9-51z" })
      ]
    }
  );
}
var EaaVerticalLogo_default = SvgEaaVerticalLogo;

// src/components/Icon/icons/EaLogo.tsx
import { jsx as jsx341, jsxs as jsxs334 } from "react/jsx-runtime";
function SvgEaLogo({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs334(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx341("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx341("path", { d: "M1018 0q140 0 270 36t244 103 206 159 159 206 102 243 37 271q0 141-36 271t-103 243-159 207-206 159-243 102-271 37q-141 0-271-36t-243-103-206-160-159-206-102-243-37-271q0-140 36-270t103-244 159-206 206-159T747 37t271-37zm-3 1941q127 0 245-33t221-93 187-144 144-187 93-221 33-246q0-127-33-245t-93-220-144-187-187-145-221-93-245-33q-127 0-245 33t-220 93-187 144-145 187-93 221-33 245q0 128 33 246t93 220 144 187 187 145 221 93 245 33zm454-1315v35h-8v-44h13l11 31 10-31h13v44h-8v-35l-12 35h-7l-12-35zm-38 35v-36h-14v-8h37v8h-14v36h-9zm-233-44l-89 143H524l89-143h585zm116 0l444 712h-168l-88-142h-260l89-143h82l-99-158-277 443H299l177-285H346l89-142h570l-89 142H644l-89 143h403l356-570z" })
      ]
    }
  );
}
var EaLogo_default = SvgEaLogo;

// src/components/Icon/icons/EaPlayHorizontalLogo.tsx
import { jsx as jsx342, jsxs as jsxs335 } from "react/jsx-runtime";
function SvgEaPlayHorizontalLogo({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs335(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 6272 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx342("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx342("path", { d: "M928 1856q-128 0-246-33t-222-93-188-146-145-188-94-221T0 928q0-128 33-246t93-222 146-188 188-145 221-94T928 0q128 0 246 33t222 93 188 146 145 188 94 221 33 247q0 128-33 246t-93 222-145 188-188 145-222 94-247 33zm285-904l-81 130h237l80 129h153l-405-648-324 519H506l81-130h248l81-130H396l-81 130h119l-162 259h673l252-403 91 144h-75zM558 563l-81 130h534l81-130H558zm5022 1485h-270l280-568-419-871h278l284 588 278-588h261l-692 1439zm-1030-427q-104 0-191-43t-151-114-99-165-36-192q0-102 36-194t102-164 154-113 194-42q87 0 165 31t139 94V609h249v997h-249v-109q-63 60-144 92t-169 32zm43-800q-57 0-106 21t-87 59-58 87-22 107v27q0 57 21 106t59 86 86 58 107 21q53 0 101-20t86-55 60-82 25-101v-41q0-56-21-105t-59-87-86-59-106-22zm-649 785h-249V208l249-80v1478zm-1177 0h-271V208h318q158 0 319-1 92 0 171 35t138 95 92 140 34 172q0 99-37 181t-100 142-149 92-182 33h-333v509zm0-1152v407h165q82 0 164 1 43 0 80-16t64-44 44-65 16-80q0-42-16-79t-44-65-65-44-80-16h-164q-82 0-164 1z" })
      ]
    }
  );
}
var EaPlayHorizontalLogo_default = SvgEaPlayHorizontalLogo;

// src/components/Icon/icons/EaPlayLogo.tsx
import { jsx as jsx343, jsxs as jsxs336 } from "react/jsx-runtime";
function SvgEaPlayLogo({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs336(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx343("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx343("path", { d: "M2048 1024q0 142-36 272t-103 245-160 207-208 160-245 103-272 37q-141 0-272-36t-244-104-207-160-161-207-103-245-37-272q0-141 36-272t104-244 160-207 207-161T752 37t272-37q141 0 272 36t244 104 207 160 161 207 103 245 37 272zM616 621l-90 143h589l90-143H616zm983 715h169l-447-715-358 572H559l89-143h274l89-143H437l-89 143h131l-179 286h743l278-445 100 159h-83l-89 143h261l89 143z" })
      ]
    }
  );
}
var EaPlayLogo_default = SvgEaPlayLogo;

// src/components/Icon/icons/EaPlayVerticalLogo.tsx
import { jsx as jsx344, jsxs as jsxs337 } from "react/jsx-runtime";
function SvgEaPlayVerticalLogo({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs337(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx344("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx344("path", { d: "M1024 924q-96 0-180-36t-149-99-101-147-37-181q0-95 37-179t102-146 149-99 179-37q95 0 180 36t148 99 101 147 38 179q0 96-37 180t-100 148-149 99-181 36zM838 279l-41 65h269l40-65H838zm-62 194l-82 129h339l127-201 45 72h-38l-41 65h120l40 64h77l-203-323-163 259H812l41-65h125l40-65H757l-41 65h60zm1074 811h132l-351 711h-137l142-280-213-431h141l144 290 142-290zm-583 54v-54h126v493h-126v-55q-32 30-73 46t-86 16q-50 0-94-20t-77-55-52-79-19-94q0-52 18-99t51-83 78-57 100-21q90 0 154 62zm1 192v-5q0-29-11-54t-29-43-44-28-54-11q-30 0-55 11t-44 29-29 45-10 56q0 28 10 54t28 45 42 32 54 12q31 0 57-11t45-30 29-45 11-57zm-876-445q46 0 85 17t69 47 47 70 17 85q0 50-19 90t-51 70-76 45-91 16H203v252H66v-692h326zm82 222q0-21-8-39t-22-32-32-22-40-8h-84q-42 0-85 1v202h168q44 0 73-29t30-73zm201 470v-692l126-39v731H675z" })
      ]
    }
  );
}
var EaPlayVerticalLogo_default = SvgEaPlayVerticalLogo;

// src/components/Icon/icons/Ear.tsx
import { jsx as jsx345, jsxs as jsxs338 } from "react/jsx-runtime";
function SvgEar({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs338(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx345("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx345("path", { d: "M1280 768v-64q0-53-20-99t-55-82-81-55-100-20q-44 0-84 14t-73 39-56 61-35 78q78 2 146 33t120 82 80 121 30 148q0 80-30 149t-82 122-123 83-149 30v-128q53 0 99-20t82-55 55-81 20-100q0-52-19-98t-54-81-80-55-98-22q10 60 36 114t69 98l-92 88q-72-74-109-167t-37-197q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149v64h-128zm384-128q0 120-35 224t-107 200q-59 78-86 162t-28 182q0 106-40 199t-109 163-163 110-200 40q-106 0-199-40t-163-109-110-163-40-200h128q0 80 30 149t82 122 122 83 150 30q79 0 149-30t122-82 83-122 30-150q0-121 35-224t107-200q114-151 114-344 0-106-40-199t-110-162-163-110-199-41q-106 0-199 40T663 278 553 441t-41 199H384q0-133 50-249t137-204T774 50t250-50q133 0 249 50t204 137 137 203 50 250z" })
      ]
    }
  );
}
var Ear_default = SvgEar;

// src/components/Icon/icons/Earrings.tsx
import { jsx as jsx346, jsxs as jsxs339 } from "react/jsx-runtime";
function SvgEarrings({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs339(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx346("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx346("path", { d: "M1536 384q106 0 199 40t163 109 110 163 40 200q0 106-40 199t-109 163-163 110-200 40q-106 0-199-40t-163-109-110-163-40-200q0-106 40-199t109-163 163-110 200-40zm192 320q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75zm-192 576q79 0 149-30t122-82 83-122 30-150q0-57-16-111t-49-102q1 5 1 10t0 11q0 66-25 124t-69 102-102 69-124 25q-66 0-124-25t-102-68-69-102-25-125v-10q0-5 1-11-32 48-48 102t-17 111q0 80 30 149t82 122 122 83 150 30zm128-1024q0 27-10 50t-27 40-41 28-50 10q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10q27 0 50 10t40 27 28 41 10 50zM512 768q106 0 199 40t163 109 110 163 40 200q0 106-40 199t-109 163-163 110-200 40q-106 0-199-40t-163-109-110-163-40-200q0-106 40-199t109-163 163-110 200-40zm192 320q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75zm-192 576q79 0 149-30t122-82 83-122 30-150q0-57-16-111t-49-102q1 5 1 10t0 11q0 66-25 124t-69 102-102 69-124 25q-66 0-124-25t-102-68-69-102-25-125v-10q0-5 1-11-32 48-48 102t-17 111q0 80 30 149t82 122 122 83 150 30zM640 640q0 27-10 50t-27 40-41 28-50 10q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10q27 0 50 10t40 27 28 41 10 50z" })
      ]
    }
  );
}
var Earrings_default = SvgEarrings;

// src/components/Icon/icons/EaseOfAccess.tsx
import { jsx as jsx347, jsxs as jsxs340 } from "react/jsx-runtime";
function SvgEaseOfAccess({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs340(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx347("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx347("path", { d: "M3 1024q11-133 61-254t137-223l90 91q-69 82-109 181t-51 205H3zm288-567q101-86 222-136t255-62v128q-106 11-205 51T382 547l-91-90zm-90 1172q-86-101-136-222T3 1152h128q11 106 51 205t109 181l-90 91zm567 288q-133-11-254-61t-223-137l91-90q82 69 181 109t205 51v128zm893-765q-11 133-61 254t-137 223l-90-91q69-82 109-181t51-205h128zm-288 567q-101 86-222 136t-255 62v-128q106-11 205-51t181-109l91 90zM1024 128v768h192l-256 256-256-256h192V128h128zm768 1088v-192h-523l128-128h395V704l256 256-256 256z" })
      ]
    }
  );
}
var EaseOfAccess_default = SvgEaseOfAccess;

// src/components/Icon/icons/Edit.tsx
import { jsx as jsx348, jsxs as jsxs341 } from "react/jsx-runtime";
function SvgEdit({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs341(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx348("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx348("path", { d: "M2048 336q0 66-25 128t-73 109L633 1890 0 2048l158-633L1475 98q47-47 109-72t128-26q70 0 131 26t106 72 72 107 27 131zM326 1428q107 35 183 111t111 183L1701 640l-293-293L326 1428zm-150 444l329-82q-10-46-32-87t-55-73-73-54-87-33l-82 329zM1792 550q25-25 48-47t41-47 28-53 11-67q0-43-16-81t-45-66-66-44-81-17q-38 0-66 10t-53 29-47 41-48 48l294 294z" })
      ]
    }
  );
}
var Edit_default = SvgEdit;

// src/components/Icon/icons/EditSolid.tsx
import { jsx as jsx349, jsxs as jsxs342 } from "react/jsx-runtime";
function SvgEditSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs342(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx349("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx349("path", { d: "M348 1287l986-997 422 422L753 1713 0 2046l348-759zM2048 286q0 48-10 85t-28 69-44 61-58 61l-424-423q31-31 59-57t60-44 67-28 84-10q61 0 114 21t94 60 63 91 23 114z" })
      ]
    }
  );
}
var EditSolid_default = SvgEditSolid;

// src/components/Icon/icons/Eject.tsx
import { jsx as jsx350, jsxs as jsxs343 } from "react/jsx-runtime";
function SvgEject({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs343(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx350("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx350("path", { d: "M1024 256l768 1024H256l768-1024zm0 213l-512 683h1024l-512-683zM256 1536h1536v128H256v-128z" })
      ]
    }
  );
}
var Eject_default = SvgEject;

// src/components/Icon/icons/Emoji.tsx
import { jsx as jsx351, jsxs as jsxs344 } from "react/jsx-runtime";
function SvgEmoji({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs344(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx351("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx351("path", { d: "M1024 0q141 0 272 36t245 103 207 160 160 208 103 245 37 272q0 141-36 272t-103 245-160 207-208 160-245 103-272 37q-141 0-272-36t-245-103-207-160-160-208-103-244-37-273q0-141 36-272t103-245 160-207 208-160T751 37t273-37zm0 1920q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 123 32 237t90 214 141 182 181 140 214 91 238 32zM640 512q27 0 50 10t40 27 28 41 10 50H512q0-27 10-50t27-40 41-28 50-10zm768 0q27 0 50 10t40 27 28 41 10 50h-256q0-27 10-50t27-40 41-28 50-10zm64 256q40 0 75 15t61 41 41 61 15 75v64q0 133-50 249t-137 204-203 137-250 50q-133 0-249-50t-204-137-137-203-50-250v-64q0-40 15-75t41-61 61-41 75-15q142 0 260 75 44 28 90 40t98 13q51 0 97-12t91-41q118-75 260-75zm64 192q0-26-19-45t-45-19q-51 0-98 12t-90 41q-60 38-124 56t-136 19q-71 0-135-18t-125-57q-43-28-90-40t-98-13q-26 0-45 19t-19 45v64q0 106 40 199t110 162 163 110 199 41q106 0 199-40t162-110 110-163 41-199v-64z" })
      ]
    }
  );
}
var Emoji_default = SvgEmoji;

// src/components/Icon/icons/Entertainment.tsx
import { jsx as jsx352, jsxs as jsxs345 } from "react/jsx-runtime";
function SvgEntertainment({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs345(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx352("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx352("path", { d: "M1344 1673v-553l640-160v786h-1q1 5 1 14 0 10-3 21t-7 22q-19 53-64 85t-103 33h-7q-3 0-8-1h-7q-3 0-8 1-57 0-102-32t-65-86q-4-10-7-21t-3-22q0-10 3-21t7-22q19-53 64-85t103-33q42 0 79 10v-485l-384 96v590h-1q1 5 1 14 0 10-3 21t-7 22q-19 53-64 85t-103 33h-7q-3 0-8-1h-7q-3 0-8 1-57 0-102-32t-65-86q-4-10-7-21t-3-22q0-10 3-21t7-22q19-53 64-85t103-33q42 0 79 10zm-154-265v128H215q-32 0-60-11t-48-31-31-47-12-60V640h1408v290l-128 32V768H192v615q0 10 3 17t15 8h980zm602-704q-37-88-102-154t-154-102q88-37 153-102t103-154q37 88 102 154t154 102q-87 37-152 103t-104 153zM96 299l212 212-260 49L0 317l96-18zm359 184L244 272l246-47 211 211-246 47zm394-75L637 197l236-45 211 212-235 44zm383-72l-211-212 318-60 48 242-155 30z" })
      ]
    }
  );
}
var Entertainment_default = SvgEntertainment;

// src/components/Icon/icons/EntertainmentSolid.tsx
import { jsx as jsx353, jsxs as jsxs346 } from "react/jsx-runtime";
function SvgEntertainmentSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs346(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx353("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx353("path", { d: "M701 436l-246 47-211-211 246-47 211 211zm686-130l-155 30-211-212 318-60 48 242zm405 398q-37-88-102-153t-154-103q88-37 153-102t103-154q37 88 102 153t154 103q-86 36-152 103t-104 153zm-708-340l-235 44-212-211 236-45 211 212zm260 1309v-553l640-160v786h-1q1 5 1 14 0 10-3 21t-7 22q-19 53-64 85t-103 33h-7q-3 0-8-1h-7q-3 0-8 1-57 0-102-32t-65-86q-4-10-7-21t-3-22q0-10 3-21t7-22q19-53 64-85t103-33q42 0 79 10v-485l-384 96v590h-1q1 5 1 14 0 10-3 21t-7 22q-19 53-64 85t-103 33h-7q-3 0-8-1h-7q-3 0-8 1-57 0-102-32t-65-86q-4-10-7-21t-3-22q0-10 3-21t7-22q19-53 64-85t103-33q42 0 79 10zM96 299l212 212-260 49L0 317l96-18zm1094 701v536H215q-32 0-60-11t-48-31-31-47-12-60V640h1408v290l-282 70z" })
      ]
    }
  );
}
var EntertainmentSolid_default = SvgEntertainmentSolid;

// src/components/Icon/icons/Epg.tsx
import { jsx as jsx354, jsxs as jsxs347 } from "react/jsx-runtime";
function SvgEpg({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs347(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx354("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx354("path", { d: "M640 1536v-128h1408v128H640zm-640 0v-128h384v128H0zm0-512V896h2048v128H0zm1280-640v128H0V384h1280zm256 0h512v128h-512V384z" })
      ]
    }
  );
}
var Epg_default = SvgEpg;

// src/components/Icon/icons/Equalizer.tsx
import { jsx as jsx355, jsxs as jsxs348 } from "react/jsx-runtime";
function SvgEqualizer({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs348(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx355("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx355("path", { d: "M2048 256v128h-768v64q0 40-15 75t-41 61-61 41-75 15q-40 0-75-15t-61-41-41-61-15-75v-64H0V256h896v-64q0-40 15-75t41-61 61-41 75-15q40 0 75 15t61 41 41 61 15 75v64h768zm-896-64q0-26-19-45t-45-19q-26 0-45 19t-19 45v256q0 26 19 45t45 19q26 0 45-19t19-45V192zM448 640q40 0 75 15t61 41 41 61 15 75v64h1408v128H640v64q0 40-15 75t-41 61-61 41-75 15q-40 0-75-15t-61-41-41-61-15-75v-64H0V896h256v-64q0-40 15-75t41-61 61-41 75-15zm64 192q0-26-19-45t-45-19q-26 0-45 19t-19 45v256q0 26 19 45t45 19q26 0 45-19t19-45V832zm1088 448q40 0 75 15t61 41 41 61 15 75v64h256v128h-256v64q0 40-15 75t-41 61-61 41-75 15q-40 0-75-15t-61-41-41-61-15-75v-64H0v-128h1408v-64q0-40 15-75t41-61 61-41 75-15zm64 192q0-26-19-45t-45-19q-26 0-45 19t-19 45v256q0 26 19 45t45 19q26 0 45-19t19-45v-256z" })
      ]
    }
  );
}
var Equalizer_default = SvgEqualizer;

// src/components/Icon/icons/Event.tsx
import { jsx as jsx356, jsxs as jsxs349 } from "react/jsx-runtime";
function SvgEvent({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs349(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx356("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx356("path", { d: "M1664 128h384v1792H0V128h384V0h128v128h1024V0h128v128zM384 256H128v256h1792V256h-256v128h-128V256H512v128H384V256zM128 1792h1792V640H128v1152z" })
      ]
    }
  );
}
var Event_default = SvgEvent;

// src/components/Icon/icons/Explore.tsx
import { jsx as jsx357, jsxs as jsxs350 } from "react/jsx-runtime";
function SvgExplore({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs350(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx357("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx357("path", { d: "M1024 512q150 0 292 39t272 107 246 163 214 203q-98 110-213 203t-246 162-273 108-292 39q-150 0-292-39t-272-107-247-162T0 1024q97-109 213-203t246-162 273-108 292-39zm384 512q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149q0 80 30 149t82 122 122 83 150 30q79 0 149-30t122-82 83-122 30-150zm-1231 0q94 91 200 166t227 127q-45-64-68-139t-24-154q0-78 23-153t69-140q-120 51-226 126t-201 167zm1267 293q120-51 226-126t201-167q-94-91-200-166t-227-127q45 64 68 139t24 154q0 78-23 153t-69 140zm-420-165q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10z" })
      ]
    }
  );
}
var Explore_default = SvgExplore;

// src/components/Icon/icons/ExploreContent.tsx
import { jsx as jsx358, jsxs as jsxs351 } from "react/jsx-runtime";
function SvgExploreContent({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs351(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx358("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx358("path", { d: "M256 128h1664v1664h-128V256H256V128zM128 1920V384h1536v1536H128zM256 512v1280h1280V512H256zm703 256v320h321v128H959v320H831v-320H512v-128h319V768h128z" })
      ]
    }
  );
}
var ExploreContent_default = SvgExploreContent;

// src/components/Icon/icons/Export.tsx
import { jsx as jsx359, jsxs as jsxs352 } from "react/jsx-runtime";
function SvgExport({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs352(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx359("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx359("path", { d: "M0 1408V512h128v896H0zm1581-911l461 461-461 461-90-90 305-305H256V896h1543l-308-309 90-90z" })
      ]
    }
  );
}
var Export_default = SvgExport;

// src/components/Icon/icons/ExportMirrored.tsx
import { jsx as jsx360, jsxs as jsxs353 } from "react/jsx-runtime";
function SvgExportMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs353(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx360("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx360("path", { d: "M1920 512h128v896h-128V512zM557 587L249 896h1543v128H252l305 305-90 90L6 958l461-461 90 90z" })
      ]
    }
  );
}
var ExportMirrored_default = SvgExportMirrored;

// src/components/Icon/icons/Eye.tsx
import { jsx as jsx361, jsxs as jsxs354 } from "react/jsx-runtime";
function SvgEye({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs354(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx361("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx361("path", { d: "M1024 512q150 0 292 39t272 107 246 163 214 203q-98 110-213 203t-246 162-273 108-292 39q-150 0-292-39t-272-107-247-162T0 1024q97-109 213-203t246-162 273-108 292-39zm384 512q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149q0 80 30 149t82 122 122 83 150 30q79 0 149-30t122-82 83-122 30-150zm-1231 0q94 91 200 166t227 127q-45-64-68-139t-24-154q0-78 23-153t69-140q-120 51-226 126t-201 167zm1267 293q120-51 226-126t201-167q-94-91-200-166t-227-127q45 64 68 139t24 154q0 78-23 153t-69 140zm-420-165q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10z" })
      ]
    }
  );
}
var Eye_default = SvgEye;

// src/components/Icon/icons/Eyebrow.tsx
import { jsx as jsx362, jsxs as jsxs355 } from "react/jsx-runtime";
function SvgEyebrow({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs355(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx362("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx362("path", { d: "M1152 640q75 0 154 6t159 21 157 36 145 55q49 23 99 55t90 73 66 91 26 111q0 66-25 124t-68 102-102 69-125 25q-125 0-238-34t-216-107q-85-60-180-87t-198-28q-179 0-347 44t-326 129q-32 17-62 36t-62 37q-18 10-35 10-26 0-45-19t-19-45q0-20 12-37 47-71 105-139t123-131 136-117 144-99q146-88 303-134t329-47zm576 640q40 0 75-15t61-41 41-61 15-75q0-38-21-71t-52-60-67-48-66-35q-62-29-132-49t-143-33-146-18-141-6q-120 0-233 26t-218 75-200 117-181 152q138-56 282-85t294-29q125 0 238 34t216 107q84 60 179 87t199 28z" })
      ]
    }
  );
}
var Eyebrow_default = SvgEyebrow;

// src/components/Icon/icons/Eyelash.tsx
import { jsx as jsx363, jsxs as jsxs356 } from "react/jsx-runtime";
function SvgEyelash({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs356(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx363("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx363("path", { d: "M1860 1098q101 84 188 182h-177q-111-109-241-193t-278-135q27 45 41 96t15 104q0 80-30 149t-82 122-123 83-149 30q-80 0-149-30t-122-82-83-122-30-150q0-53 14-104t42-96q-148 50-278 134t-241 194H0q30-34 61-66t66-63h-1q62-63 110-137t81-157 50-169 17-176h128q0 109-22 215t-66 207q91-52 191-90 75-100 114-217t39-243h128q0 107-24 209t-74 198q14-3 28-5t29-5q23-6 47-17t45-23q48-28 86-66t64-85 41-98 14-108h128q0 110-43 210t-121 178q24 2 47 5t48 7q44-15 80-42t62-62 40-79 15-89h128q0 92-38 175t-110 141l60 22q30 11 59 25 36-15 65-39t49-55 32-66 11-75h128q0 93-39 170t-112 134q27 15 53 32t52 34q39-13 71-37t55-56 35-70 13-79h128q0 51-13 99t-37 90-60 78-78 63zm-580 54q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100zm-256 128q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10z" })
      ]
    }
  );
}
var Eyelash_default = SvgEyelash;

// src/components/Icon/icons/Eyeshadow.tsx
import { jsx as jsx364, jsxs as jsxs357 } from "react/jsx-runtime";
function SvgEyeshadow({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs357(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx364("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx364("path", { d: "M2048 896v1024H0V896h771q75-91 154-176t162-168q31-31 86-84t122-114 143-124 148-114 135-83 107-33q41 0 66 25t26 67q0 35-21 82t-56 103-82 116-98 122-104 119-101 108-88 90-65 64h743zm-280-744q-64 34-140 90t-158 126-163 148-159 156-142 149-113 129q25 11 45 31t32 46q57-47 128-113t149-142 156-158 148-164 126-157 91-141zm-976 905q-24 0-57 7t-69 18-74 27-72 33-62 36-45 37q-16 17-22 36t-7 42q0 44 21 87t56 78 78 56 88 22q23 0 42-6t36-23q18-17 36-44t36-62 33-72 27-74 19-69 7-58q0-41-15-56t-56-15zm1128-33h-752q-45 40-89 78t-92 77q-5 45-23 104t-45 118-59 111-65 85q-35 35-78 51t-92 16q-71 0-137-31t-118-83-83-118-31-138q0-54 17-94t48-72 69-56 83-48H128v768h1792v-768zm-768 384q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100q0 53-20 99t-55 82-81 55-100 20q-53 0-99-20t-82-55-55-81-20-100zm256-128q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10z" })
      ]
    }
  );
}
var Eyeshadow_default = SvgEyeshadow;

// src/components/Icon/icons/FacebookLogo.tsx
import { jsx as jsx365, jsxs as jsxs358 } from "react/jsx-runtime";
function SvgFacebookLogo({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs358(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx365("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx365("path", { d: "M1024 0q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 126-29 244t-84 225-132 196-174 161-208 118-237 68v-716h239l45-296h-284V832q0-55 18-87t48-48 68-21 79-5h42q21 0 41 1V420q-56-10-114-15t-115-5q-93 0-165 28t-121 80-75 125-26 165v226H604v296h260v716q-125-19-237-67t-208-118-173-161-132-197-84-224-30-245q0-141 36-272t104-244 160-207 207-161T752 37t272-37z" })
      ]
    }
  );
}
var FacebookLogo_default = SvgFacebookLogo;

// src/components/Icon/icons/FacialHair.tsx
import { jsx as jsx366, jsxs as jsxs359 } from "react/jsx-runtime";
function SvgFacialHair({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs359(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx366("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx366("path", { d: "M1920 640q21 0 38 14t32 38 25 51 18 57 11 54 4 42q0 106-40 199t-109 163-163 110-200 40q-134 0-262-30t-250-90q-121 59-249 89t-263 31q-106 0-199-40t-163-109-110-163T0 896q0-25 8-68t24-85 40-72 56-31q26 0 45 19t19 45q0 27 10 50t27 40 41 28 50 10q62 0 117-14t109-43q68-35 138-53t148-18q55 0 105 22t87 65q35-42 86-64t106-23q77 0 147 18t139 53q54 28 109 42t117 15q27 0 50-10t40-27 28-41 10-50q0-26 19-45t45-19zm-384 640q79 0 149-30t122-82 83-122 30-150v-11q0-6-1-11-36 42-86 64t-105 22q-77 0-147-18t-139-53q-55-28-109-42t-117-15q-24 0-48 10t-42 28-29 41-9 49H960q0-27-10-50t-27-40-41-28-50-10q-62 0-116 14t-110 43q-69 35-139 53t-147 18q-55 0-105-22t-86-64q-1 5-1 11t0 11q0 80 30 149t82 122 122 83 150 30q69 0 130-8t118-23 115-38 119-52q14-7 30-7t30 7q62 29 119 51t114 38 119 24 130 8z" })
      ]
    }
  );
}
var FacialHair_default = SvgFacialHair;

// src/components/Icon/icons/Family.tsx
import { jsx as jsx367, jsxs as jsxs360 } from "react/jsx-runtime";
function SvgFamily({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs360(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx367("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx367("path", { d: "M1790 1717q98 48 162 135t81 196h-110q-11-57-41-106t-73-84-97-56-112-20q-59 0-112 20t-97 55-73 85-41 106h-110q16-108 80-195t163-136q-57-45-88-109t-32-136q0-45 12-87t36-79 57-66 74-49q-27-39-62-69t-76-53-86-33-93-12q-80 0-153 31t-127 91q24 65 24 134 0 92-41 173t-115 136q65 33 117 81t90 108 57 128 20 142H896q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149H0q0-73 20-141t57-128 89-108 118-82q-74-55-115-136t-41-173q0-79 30-149t82-122 122-83 150-30q85 0 161 36t132 100q26-25 56-45t63-38q-74-55-115-136t-41-173q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 92-41 173t-115 136q70 37 126 90t95 123q64 0 120 24t99 67 66 98 24 121q0 72-31 136t-89 109zM512 1536q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100q0 53 20 99t55 82 81 55 100 20zm384-896q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100zm704 630q-42 0-78 16t-64 43-44 64-16 79q0 42 16 78t43 64 64 44 79 16q42 0 78-16t64-43 44-64 16-79q0-42-16-78t-43-64-64-44-79-16z" })
      ]
    }
  );
}
var Family_default = SvgFamily;

// src/components/Icon/icons/FamilySolid.tsx
import { jsx as jsx368, jsxs as jsxs361 } from "react/jsx-runtime";
function SvgFamilySolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs361(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx368("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx368("path", { d: "M1167 2048q16-108 80-195t163-136q-57-45-88-109t-32-136q0-45 12-87t36-79 57-66 74-49q-27-39-62-70t-76-52-86-33-93-12q-80 0-153 32t-127 90q11 32 17 65t7 69q0 92-41 173t-116 136q65 33 118 81t90 108 57 128 20 142H0q0-73 20-141t57-129 90-108 118-81q-74-54-115-135t-42-174q0-79 30-149t82-122 122-83 150-30q85 0 161 36t132 100q26-25 56-45t63-38q-74-55-115-136t-41-173q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 92-41 173t-115 136q70 35 126 89t95 124q64 0 120 24t99 67 66 98 24 121q0 72-31 136t-89 109q98 48 162 135t81 196h-866z" })
      ]
    }
  );
}
var FamilySolid_default = SvgFamilySolid;

// src/components/Icon/icons/FastForward.tsx
import { jsx as jsx369, jsxs as jsxs362 } from "react/jsx-runtime";
function SvgFastForward({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs362(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx369("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx369("path", { d: "M1152 379l806 645-806 650V379zm128 266v762l474-383-474-379zM256 1674V379l806 645-806 650zM384 645v762l474-383-474-379z" })
      ]
    }
  );
}
var FastForward_default = SvgFastForward;

// src/components/Icon/icons/Favorite.tsx
import { jsx as jsx370, jsxs as jsxs363 } from "react/jsx-runtime";
function SvgFavorite({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs363(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx370("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx370("path", { d: "M2048 768l-632 486 248 794-640-492-640 492 248-794L0 768h784L1024 0l240 768h784z" })
      ]
    }
  );
}
var Favorite_default = SvgFavorite;

// src/components/Icon/icons/FavoriteAdd.tsx
import { jsx as jsx371, jsxs as jsxs364 } from "react/jsx-runtime";
function SvgFavoriteAdd({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs364(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx371("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx371("path", { d: "M1504 1536h-134q-26-83-51-165t-52-164q103-77 203-155t202-156h-502q-36-118-72-233t-74-234q-37 118-73 233t-73 234H376q102 78 202 156t203 155q-40 124-78 246t-76 247q100-77 198-153t199-153l256 197v162l-256-197-640 492 248-794L0 768h784L1024 0l240 768h784l-632 486 88 282zm288 128h256v128h-256v256h-128v-256h-256v-128h256v-256h128v256z" })
      ]
    }
  );
}
var FavoriteAdd_default = SvgFavoriteAdd;

// src/components/Icon/icons/FavoriteHelp.tsx
import { jsx as jsx372, jsxs as jsxs365 } from "react/jsx-runtime";
function SvgFavoriteHelp({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs365(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx372("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx372("path", { d: "M1600 1920h128v128h-128v-128zm64-704q53 0 99 20t82 55 55 81 20 100q0 47-17 89t-49 76h-1l-95 96q-13 14-19 28t-9 29-2 32 0 34h-128v-48q0-46 14-81t35-63 47-50 46-45 36-45 14-52q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50h-128q0-53 20-99t55-82 81-55 100-20zm-640 178q112 87 224 172t224 173v161l-448-344-640 492 248-794L0 768h784L1024 0l240 768h784l-416 320h-210l250-192h-502q-36-118-72-233t-74-234q-37 118-73 233t-73 234H376q102 78 202 156t203 155q-40 124-78 246t-76 247q100-77 198-153t199-153z" })
      ]
    }
  );
}
var FavoriteHelp_default = SvgFavoriteHelp;

// src/components/Icon/icons/FavoriteHelpMirrored.tsx
import { jsx as jsx373, jsxs as jsxs366 } from "react/jsx-runtime";
function SvgFavoriteHelpMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs366(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx373("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx373("path", { d: "M1664 1920h128v128h-128v-128zm64-704q53 0 99 20t82 55 55 81 20 100h-128q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50q0 29 14 52t35 45 47 44 46 51 36 63 14 81v48h-128v-33q0-16-1-32t-9-30-20-28q-30-30-59-57t-52-58-37-65-14-81q0-53 20-99t55-82 81-55 100-20zm-704 178q112 87 224 172t224 173v161l-448-344-640 492 248-794L0 768h784L1024 0l240 768h784l-416 320h-210l250-192h-502q-36-118-72-233t-74-234q-37 118-73 233t-73 234H376q102 78 202 156t203 155q-40 124-78 246t-76 247q100-77 198-153t199-153z" })
      ]
    }
  );
}
var FavoriteHelpMirrored_default = SvgFavoriteHelpMirrored;

// src/components/Icon/icons/FavoriteRemove.tsx
import { jsx as jsx374, jsxs as jsxs367 } from "react/jsx-runtime";
function SvgFavoriteRemove({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs367(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx374("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx374("path", { d: "M376 896q102 78 202 156t203 155q-40 124-78 246t-76 247q100-77 198-153t199-153l26 20q-11 35-18 70t-10 73l-638 491 248-794L0 768h784L1024 0l240 768h784l-342 263q-27-5-54-8t-56-3q-49 0-97 9l173-133h-502q-36-118-72-233t-74-234q-37 118-73 233t-73 234H376zm1220 248q94 0 176 35t143 97 97 144 36 176q0 94-35 176t-97 143-144 97-176 36q-94 0-176-35t-143-97-97-144-36-176q0-94 35-176t97-143 144-97 176-36zm-324 452q0 67 25 126t70 103 103 69 126 26q48 0 93-14t86-40l-449-449q-26 40-40 85t-14 94zm594 179q26-40 40-85t14-94q0-67-25-126t-70-103-103-69-126-26q-48 0-93 14t-86 40l449 449z" })
      ]
    }
  );
}
var FavoriteRemove_default = SvgFavoriteRemove;

// src/components/Icon/icons/FavoriteRemove2.tsx
import { jsx as jsx375, jsxs as jsxs368 } from "react/jsx-runtime";
function SvgFavoriteRemove2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs368(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx375("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx375("path", { d: "M376 896q102 78 202 156t203 155q-40 124-78 246t-76 247q100-77 198-153t199-153l26 20q-11 35-18 70t-10 73l-638 491 248-794L0 768h784L1024 0l240 768h784l-342 263q-27-5-54-8t-56-3q-49 0-97 9l173-133h-502q-36-118-72-233t-74-234q-37 118-73 233t-73 234H376zm1220 248q94 0 176 35t143 97 97 144 36 176q0 94-35 176t-97 143-144 97-176 36q-94 0-176-35t-143-97-97-144-36-176q0-94 35-176t97-143 144-97 176-36zm-324 452q0 67 25 126t70 103 103 69 126 26q48 0 93-14t86-40l-449-449q-26 40-40 85t-14 94zm594 179q26-40 40-85t14-94q0-67-25-126t-70-103-103-69-126-26q-48 0-93 14t-86 40l449 449z" })
      ]
    }
  );
}
var FavoriteRemove2_default = SvgFavoriteRemove2;

// src/components/Icon/icons/Featured.tsx
import { jsx as jsx376, jsxs as jsxs369 } from "react/jsx-runtime";
function SvgFeatured({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs369(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx376("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx376("path", { d: "M1918 1408h-894v128h256v128H640v-128h256v-128H0V256h1918v1152zM128 384v896h1662V384H128zm512 640V896h1023v128H640zm1-256V640h1023v128H641zM256 896V640h256v256H256z" })
      ]
    }
  );
}
var Featured_default = SvgFeatured;

// src/components/Icon/icons/FeaturedMirrored.tsx
import { jsx as jsx377, jsxs as jsxs370 } from "react/jsx-runtime";
function SvgFeaturedMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs370(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx377("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx377("path", { d: "M0 1408h894v128H638v128h640v-128h-256v-128h896V256H0v1152zM1790 384v896H128V384h1662zm-512 640V896H255v128h1023zm-1-256V640H254v128h1023zm385 128V640h-256v256h256z" })
      ]
    }
  );
}
var FeaturedMirrored_default = SvgFeaturedMirrored;

// src/components/Icon/icons/FeatureRequest.tsx
import { jsx as jsx378, jsxs as jsxs371 } from "react/jsx-runtime";
function SvgFeatureRequest({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs371(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx378("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx378("path", { d: "M1767 660q2 8 9 38t19 75 25 98 27 109 27 107 24 92 16 66 6 27v776H128v-776q0-1 7-32t20-82 29-115 34-133 34-135 30-122 23-93 13-48h457L1280 5l571 571-84 84zM731 738l159 158h459l321-320-390-389-549 551zm-473 542h1532l-129-515-131 131h6l32 128H496l32-128h180L549 739l99-99H418l-160 640zm1534 640v-512H256v512h1536z" })
      ]
    }
  );
}
var FeatureRequest_default = SvgFeatureRequest;

// src/components/Icon/icons/Feedback.tsx
import { jsx as jsx379, jsxs as jsxs372 } from "react/jsx-runtime";
function SvgFeedback({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs372(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx379("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx379("path", { d: "M958 1328q101 40 184 106t142 153 91 187 33 210v64h-128v-64q0-119-45-224t-124-183-183-123-224-46q-119 0-224 45t-183 124-123 183-46 224v64H0v-64q0-109 32-210t92-187 142-152 184-107q-45-31-81-72t-61-88-38-100-14-108q0-93 35-174t96-142 142-96 175-36q93 0 174 35t142 96 96 142 36 175q0 55-13 107t-39 100-61 89-81 72zm-254-48q66 0 124-25t101-68 69-102 26-125q0-66-25-124t-69-101-102-69-124-26q-66 0-124 25t-102 69-69 102-25 124q0 66 25 124t68 102 102 69 125 25zM2048 0v1024h-256l-384 384v-384h-128V896h256v203l203-203h181V128H640v230q-32 4-64 10t-64 18V0h1536z" })
      ]
    }
  );
}
var Feedback_default = SvgFeedback;

// src/components/Icon/icons/FeedbackSolid.tsx
import { jsx as jsx380, jsxs as jsxs373 } from "react/jsx-runtime";
function SvgFeedbackSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs373(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx380("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx380("path", { d: "M960 1328q101 39 184 106t141 153 91 187 32 210v64H0v-64q0-109 32-210t90-187 142-153 184-106q-45-31-80-72t-61-88-38-100-13-108q0-93 35-174t96-143 142-96 175-35q93 0 174 35t143 96 96 142 35 175q0 55-13 107t-38 100-60 89-81 72zM512 0h1536v1024h-256l-384 384v-384h-102l4-32q2-16 2-32 0-126-48-236t-130-193-193-131-237-48q-49 0-97 9t-95 25V0z" })
      ]
    }
  );
}
var FeedbackSolid_default = SvgFeedbackSolid;

// src/components/Icon/icons/Filter.tsx
import { jsx as jsx381, jsxs as jsxs374 } from "react/jsx-runtime";
function SvgFilter({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs374(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx381("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx381("path", { d: "M2048 128v219l-768 768v805H768v-805L0 347V128h2048zm-128 128H128v37l768 768v731h256v-731l768-768v-37z" })
      ]
    }
  );
}
var Filter_default = SvgFilter;

// src/components/Icon/icons/FilterSolid.tsx
import { jsx as jsx382, jsxs as jsxs375 } from "react/jsx-runtime";
function SvgFilterSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs375(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx382("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx382("path", { d: "M2048 128v219l-768 768v805H768v-805L0 347V128h2048z" })
      ]
    }
  );
}
var FilterSolid_default = SvgFilterSolid;

// src/components/Icon/icons/Fingernail.tsx
import { jsx as jsx383, jsxs as jsxs376 } from "react/jsx-runtime";
function SvgFingernail({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs376(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx383("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx383("path", { d: "M1408 431q125 154 190 338t66 383v896h-128v-896q0-130-32-254t-96-238v492q0 80-30 149t-82 122-123 83-149 30q-80 0-149-30t-122-82-83-122-30-150V660q-63 113-95 237t-33 255v896H384v-896q0-198 65-382t191-339v-47q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149v47zm-128-47q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100v768q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100V384z" })
      ]
    }
  );
}
var Fingernail_default = SvgFingernail;

// src/components/Icon/icons/FirstAccessApp.tsx
import { jsx as jsx384, jsxs as jsxs377 } from "react/jsx-runtime";
function SvgFirstAccessApp({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs377(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx384("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx384("path", { d: "M1408 1531l-318-318q-60 32-125 47t-133 15q-100 0-191-33t-166-93-128-141-76-179q45-63 107-108t138-68q26 22 58 34t67 12q39 0 74-15t61-42 41-61 15-74q0-39-15-74t-41-62-61-41-74-16q-48 0-90 22t-69 62q-91 21-176 65 35-77 90-140t123-107 148-69 165-25q80 0 153 20t138 58 116 91 90 117 58 137 21 154q0 137-62 258l702 703v255h-256v-191h-190v-193h-194zm-767 65q69 0 134-18t122-52 105-82 82-108l94 93q-45 69-103 123t-128 93-146 58-160 21q-132 0-249-50t-204-138-137-204-51-249q0-81 19-157t56-143 87-125 113-100 136-72 154-38q14-17 33-27t43-11q20 0 37 8t31 21 20 31 8 37q0 40-28 68t-68 28q-19 0-36-7t-32-21q-96 12-177 57T255 745t-93 155-34 183q0 107 40 200t110 163 163 110 200 40z" })
      ]
    }
  );
}
var FirstAccessApp_default = SvgFirstAccessApp;

// src/components/Icon/icons/Fitness.tsx
import { jsx as jsx385, jsxs as jsxs378 } from "react/jsx-runtime";
function SvgFitness({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs378(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx385("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx385("path", { d: "M896 1526q0 52 7 102t23 100l-648-598q-36-33-64-76t-47-91-29-98-10-99q0-105 39-197t108-162 161-110 198-40q61 0 114 12t101 36 91 57 84 77q41-43 84-77t91-57 101-35 114-13q106 0 198 40t160 109 107 163 40 198q0 118-50 223-57-34-116-56 19-39 28-82t10-87q0-78-29-147t-80-121-120-82-148-30q-70 0-122 19t-97 52-85 76-86 89q-45-46-85-89t-85-75-97-52-123-20q-79 0-148 30t-120 82-80 121-30 149q0 36 7 73t22 73 34 68 48 57l529 488zm640-502q106 0 199 40t163 109 110 163 40 200q0 106-40 199t-109 163-163 110-200 40q-106 0-199-40t-163-109-110-163-40-200q0-106 40-199t109-163 163-110 200-40zm0 896q79 0 149-30t122-82 83-122 30-150q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149q0 80 30 149t82 122 122 83 150 30zm147-557l90 90-301 302-173-174 90-90 83 83 211-211z" })
      ]
    }
  );
}
var Fitness_default = SvgFitness;

// src/components/Icon/icons/Flag.tsx
import { jsx as jsx386, jsxs as jsxs379 } from "react/jsx-runtime";
function SvgFlag({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs379(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx386("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx386("path", { d: "M1152 256h768v1024h-896v-256H384v1024H256V0h896v256zM384 896h640V128H384v768zm1408 256V384h-640v768h640z" })
      ]
    }
  );
}
var Flag_default = SvgFlag;

// src/components/Icon/icons/FlagSolid.tsx
import { jsx as jsx387, jsxs as jsxs380 } from "react/jsx-runtime";
function SvgFlagSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs380(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx387("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx387("path", { d: "M1152 256h768v1024h-768V256zM256 2048V0h768v1024H384v1024H256z" })
      ]
    }
  );
}
var FlagSolid_default = SvgFlagSolid;

// src/components/Icon/icons/Folder.tsx
import { jsx as jsx388, jsxs as jsxs381 } from "react/jsx-runtime";
function SvgFolder({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs381(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx388("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx388("path", { d: "M922 384h1126v1408H0V256h794l128 128zm-181 0H128v128h613l64-64-64-64zm1179 1280V512H922L794 640H128v1024h1792z" })
      ]
    }
  );
}
var Folder_default = SvgFolder;

// src/components/Icon/icons/FolderAllItems.tsx
import { jsx as jsx389, jsxs as jsxs382 } from "react/jsx-runtime";
function SvgFolderAllItems({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs382(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx389("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx389("path", { d: "M1920 768q27 0 50 10t40 27 28 41 10 50v896H512v-512H0V256q0-27 10-50t27-40 41-28 50-10h352q45 0 77 9t58 24 45 31 41 31 44 23 55 10h608q27 0 50 10t40 27 28 41 10 50v384h384zM128 256v128h352q24 0 42-4t33-13 29-20 32-27q-17-15-31-26t-30-20-33-13-42-5H128zm384 896V768q0-27 10-50t27-40 41-28 50-10h352q45 0 77 9t58 24 46 31 40 31 44 23 55 10h96V384H800q-31 0-54 9t-44 24-41 31-45 31-58 23-78 10H128v640h384zm616-320q-17-15-31-26t-30-20-33-13-42-5H640v128h352q24 0 42-4t33-13 29-20 32-27zm792 64h-608q-31 0-54 9t-44 24-41 31-45 31-58 23-78 10H640v640h1280V896z" })
      ]
    }
  );
}
var FolderAllItems_default = SvgFolderAllItems;

// src/components/Icon/icons/FolderAvatarItems.tsx
import { jsx as jsx390, jsxs as jsxs383 } from "react/jsx-runtime";
function SvgFolderAvatarItems({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs383(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx390("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx390("path", { d: "M608 128q45 0 77 9t58 24 46 31 40 31 44 23 55 10h992q27 0 50 10t40 27 28 41 10 50v727l-128-42V384H928q-31 0-54 9t-44 24-41 31-45 31-58 23-78 10H128v1152h798l21 128H0V256q0-27 10-50t27-40 41-28 50-10h480zm0 256q24 0 42-4t33-13 29-20 32-27q-17-15-31-26t-30-20-33-13-42-5H128v128h480zm928 896q27 0 50-10t40-27 28-41 10-50l384 128-64 384h-128v384h-640v-384h-128l-64-384 384-128q0 27 10 50t27 40 41 28 50 10zm200 31q-36 46-88 71t-112 26q-59 0-111-25t-89-72l-168 56 28 169h148v384h384v-384h148l28-169-168-56z" })
      ]
    }
  );
}
var FolderAvatarItems_default = SvgFolderAvatarItems;

// src/components/Icon/icons/FolderDemos.tsx
import { jsx as jsx391, jsxs as jsxs384 } from "react/jsx-runtime";
function SvgFolderDemos({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs384(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx391("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx391("path", { d: "M1601 1155q93 0 174 35t143 95 96 143 35 175q0 93-35 174t-96 142-142 96-175 36q-92 0-173-35t-143-97-96-142-36-174q0-93 35-174t96-142 142-96 175-36zm-320 448q0 57 19 108t53 93 80 71 103 41v-205q-29-17-46-47t-18-64q0-34 17-64t47-47v-200q-55 12-102 41t-81 71-53 93-19 109zm383 313q56-11 103-40t81-70 54-94 19-109q0-57-19-109t-53-94-82-71-103-40v627zm-669-252q4 32 10 64t18 64H0V256q0-27 10-50t27-40 41-28 50-10h480q45 0 77 9t58 24 46 31 40 31 44 23 55 10h992q27 0 50 10t40 27 28 41 10 50v805q-28-31-60-57t-68-49V384H928q-31 0-54 9t-44 24-41 31-45 31-58 23-78 10H128v1152h867zM128 256v128h480q24 0 42-4t33-13 29-20 32-27q-17-15-31-26t-30-20-33-13-42-5H128z" })
      ]
    }
  );
}
var FolderDemos_default = SvgFolderDemos;

// src/components/Icon/icons/FolderFindContent.tsx
import { jsx as jsx392, jsxs as jsxs385 } from "react/jsx-runtime";
function SvgFolderFindContent({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs385(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx392("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx392("path", { d: "M608 128q45 0 77 9t58 24 46 31 40 31 44 23 55 10h992q27 0 50 10t40 27 28 41 10 50v603q-58-52-128-83V384H928q-31 0-54 9t-44 24-41 31-45 31-58 23-78 10H128v1152h963l-128 128H0V256q0-27 10-50t27-40 41-28 50-10h480zm0 256q24 0 42-4t33-13 29-20 32-27q-17-15-31-26t-30-20-33-13-42-5H128v128h480zm1120 640q66 0 124 25t101 69 69 102 26 124q0 66-25 124t-69 102-102 69-124 25q-47 0-92-13t-84-40l-419 418q-19 19-45 19t-45-19-19-45q0-26 19-45l418-419q-26-39-39-84t-14-92q0-66 25-124t68-101 102-69 125-26zm0 512q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15z" })
      ]
    }
  );
}
var FolderFindContent_default = SvgFolderFindContent;

// src/components/Icon/icons/FolderGamerPics.tsx
import { jsx as jsx393, jsxs as jsxs386 } from "react/jsx-runtime";
function SvgFolderGamerPics({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs386(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx393("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx393("path", { d: "M1024 896h1024v1024H1024V896zm128 896h768v-768h-768v768zm537-333q49 36 76 90t27 115h-128q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50h-128q0-61 27-115t76-90q-20-25-29-54t-10-61q0-40 15-75t41-61 61-41 75-15q40 0 75 15t61 41 41 61 15 75q0 31-9 60t-30 55zm-217-115q0 26 19 45t45 19q26 0 45-19t19-45q0-26-19-45t-45-19q-26 0-45 19t-19 45zM608 128q45 0 77 9t58 24 46 31 40 31 44 23 55 10h992q27 0 50 10t40 27 28 41 10 50v384h-128V384H928q-31 0-54 9t-44 24-41 31-45 31-58 23-78 10H128v1152h768v128H0V256q0-27 10-50t27-40 41-28 50-10h480zm0 256q24 0 42-4t33-13 29-20 32-27q-17-15-31-26t-30-20-33-13-42-5H128v128h480z" })
      ]
    }
  );
}
var FolderGamerPics_default = SvgFolderGamerPics;

// src/components/Icon/icons/FolderGames.tsx
import { jsx as jsx394, jsxs as jsxs387 } from "react/jsx-runtime";
function SvgFolderGames({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs387(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx394("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx394("path", { d: "M1888 1377q13 14 28 41t30 63 30 74 27 75 22 68 13 52q5 23 7 47t3 48q0 33-7 66t-27 61q-20 30-54 53t-72 23q-22 0-43-12t-43-32-40-43-37-45-34-36-31-20q-12-4-29-4t-31 0h-222q-18 0-30 4-15 4-31 19t-34 37-37 44-40 43-42 32-44 13q-18 0-36-6t-35-17-31-24-24-29q-19-29-26-62t-8-67q0-46 9-93 3-19 12-50t22-68 28-77 31-75 31-63 27-40q0-17 8-31t23-25q13-9 37-16t51-13 52-9 42-3q12 0 24 1t24 7h1q11 5 20 11t20 12h164q14-7 23-13t18-10 20-6 28-2q16 0 41 3t53 8 51 13 37 17q14 10 22 24t9 32zm7 537q17-12 21-31t4-38q0-18-2-36t-6-37q-2-11-9-35t-18-56-23-66-25-64-22-52-16-29q-6-7-12-11t-10-9-9-10-7-18q-21-6-42-10t-44-4h-1q-17 8-32 19t-35 12h-206q-19 0-34-11t-33-20q-23 0-44 4t-44 10q-2 12-6 18t-8 10-11 8-12 12q-6 7-16 29t-22 52-25 64-23 65-18 56-10 36q-3 17-5 35t-2 36q0 18 4 39t21 32q43-39 69-73t53-59 66-39 107-15h192q68 0 106 14t66 40 54 59 69 73zm-391-443q13 0 22 9t10 23q0 14-9 23t-23 9q-14 0-23-9t-9-23q0-13 9-22t23-10zm544-142q-2-4-4-7t-5-8q-10-22-18-40t-19-33-25-28-36-28l-21-12V384H928q-31 0-54 9t-44 24-41 31-45 31-58 23-78 10H128v1152h698q-8 32-14 63t-10 65H0V256q0-27 10-50t27-40 41-28 50-10h480q45 0 77 9t58 24 46 31 40 31 44 23 55 10h992q27 0 50 10t40 27 28 41 10 50v945zM608 384q24 0 42-4t33-13 29-20 32-27q-17-15-31-26t-30-20-33-13-42-5H128v128h480z" })
      ]
    }
  );
}
var FolderGames_default = SvgFolderGames;

// src/components/Icon/icons/FolderGenre.tsx
import { jsx as jsx395, jsxs as jsxs388 } from "react/jsx-runtime";
function SvgFolderGenre({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs388(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx395("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx395("path", { d: "M1601 1155q93 0 174 35t143 95 96 143 35 175q0 93-35 174t-96 142-142 96-175 36q-92 0-173-35t-143-97-96-142-36-174q0-93 35-174t96-142 142-96 175-36zm0 768q66 0 124-25t101-68 69-102 26-125q0-66-25-124t-68-102-102-69-125-25q-66 0-124 25t-102 69-69 102-25 124q0 66 25 124t68 102 102 69 125 25zm-1-387q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45q0-26 19-45t45-19zm-605 128q4 32 10 64t18 64H0V256q0-27 10-50t27-40 41-28 50-10h480q45 0 77 9t58 24 46 31 40 31 44 23 55 10h992q26 0 49 10t41 27 28 41 10 50v805q-28-31-60-57t-68-49V384H928q-31 0-54 9t-44 24-41 31-45 31-58 23-78 10H128v1152h867zM128 256v128h480q24 0 42-4t33-13 29-20 32-27q-17-15-31-26t-30-20-33-13-42-5H128z" })
      ]
    }
  );
}
var FolderGenre_default = SvgFolderGenre;

// src/components/Icon/icons/FolderMusic.tsx
import { jsx as jsx396, jsxs as jsxs389 } from "react/jsx-runtime";
function SvgFolderMusic({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs389(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx396("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx396("path", { d: "M2048 800l-128 32V384H928q-31 0-54 9t-44 24-41 31-45 31-58 23-78 10H128v1152h734q-41 58-55 128H0V256q0-27 10-50t27-40 41-28 50-10h480q45 0 77 9t58 24 46 31 40 31 44 23 55 10h992q27 0 50 10t40 27 28 41 10 50v416zM608 384q24 0 42-4t33-13 29-20 32-27q-17-15-31-26t-30-20-33-13-42-5H128v128h480zm672 716l768-154v782q0 44-19 79t-52 61-72 38-81 14q-41 0-81-13t-72-39-51-60-20-80q0-44 19-79t52-61 72-38 81-14q51 0 96 18v-452l-512 102v652q0 44-19 79t-52 61-72 38-81 14q-41 0-81-13t-72-39-51-60-20-80q0-44 19-79t52-61 72-38 81-14q51 0 96 18v-582zm544 692q13 0 29-4t32-12 25-20 10-28q0-16-10-28t-25-20-31-12-30-4q-13 0-29 4t-32 12-25 20-10 28q0 16 10 28t25 20 31 12 30 4zm-640 128q13 0 29-4t32-12 25-20 10-28q0-16-10-28t-25-20-31-12-30-4q-13 0-29 4t-32 12-25 20-10 28q0 16 10 28t25 20 31 12 30 4z" })
      ]
    }
  );
}
var FolderMusic_default = SvgFolderMusic;

// src/components/Icon/icons/FolderProfile.tsx
import { jsx as jsx397, jsxs as jsxs390 } from "react/jsx-runtime";
function SvgFolderProfile({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs390(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx397("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx397("path", { d: "M2048 1184l-128-128V384H928q-31 0-54 9t-44 24-41 31-45 31-58 23-78 10H128v1152h1024l-128 128H0V256q0-27 10-50t27-40 41-28 50-10h480q45 0 77 9t58 24 46 31 40 31 44 23 55 10h992q27 0 50 10t40 27 28 41 10 50v800zM608 384q24 0 42-4t33-13 29-20 32-27q-17-15-31-26t-30-20-33-13-42-5H128v128h480zm1200 1267q55 29 99 71t76 94 48 110 17 122h-128q0-66-25-124t-69-101-102-69-124-26q-66 0-124 25t-102 69-69 102-25 124h-128q0-63 16-122t48-110 76-94 100-71q-54-46-83-109t-29-134q0-66 25-124t68-101 102-69 125-26q66 0 124 25t101 69 69 102 26 124q0 70-29 133t-83 110zm-400-243q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75z" })
      ]
    }
  );
}
var FolderProfile_default = SvgFolderProfile;

// src/components/Icon/icons/FolderSystemItems.tsx
import { jsx as jsx398, jsxs as jsxs391 } from "react/jsx-runtime";
function SvgFolderSystemItems({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs391(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx398("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx398("path", { d: "M2048 1061q-58-63-128-106V384H928q-31 0-54 9t-44 24-41 31-45 31-58 23-78 10H128v1152h895q23 69 60 128H0V256q0-27 10-50t27-40 41-28 50-10h480q45 0 77 9t58 24 46 31 40 31 44 23 55 10h992q27 0 50 10t40 27 28 41 10 50v677zM608 384q24 0 42-4t33-13 29-20 32-27q-17-15-31-26t-30-20-33-13-42-5H128v128h480zm1430 976l-124 51q6 30 6 61t-6 61l124 51-49 119-124-52q-35 51-86 86l52 124-119 49-51-124q-30 6-61 6t-61-6l-51 124-119-49 52-124q-51-35-86-86l-124 52-49-119 124-51q-6-30-6-61t6-61l-124-51 49-119 124 52q35-51 86-86l-52-124 119-49 51 124q30-6 61-6t61 6l51-124 119 49-52 124q51 35 86 86l124-52 49 119zm-438 304q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15z" })
      ]
    }
  );
}
var FolderSystemItems_default = SvgFolderSystemItems;

// src/components/Icon/icons/FolderThemes.tsx
import { jsx as jsx399, jsxs as jsxs392 } from "react/jsx-runtime";
function SvgFolderThemes({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs392(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx399("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx399("path", { d: "M1707 827q28-28 65-43t76-15q41 0 77 15t64 43 42 63 16 78q0 39-15 76t-43 65l-710 711q-6 48-28 90t-56 72-78 48-93 18H384v-128h256q27 0 50-10t40-27 28-41 10-50q0-49 17-92t48-78 73-57 90-28l711-710zm-344 728q-42-60-102-102l-114 115q66 35 101 101l115-114zm-339 365q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50q0 70-34 128h162zm875-902q21-21 21-50 0-30-21-51t-51-21q-29 0-50 21l-445 445q57 44 101 101l445-445zM608 128q45 0 77 9t58 24 45 31 41 31 44 23 55 10h992q27 0 50 10t40 27 28 41 10 50v324q-29-22-61-36t-67-22V384H928q-31 0-54 9t-44 24-41 31-46 31-57 23-78 10H128v1152h534q-22 64-22 128H0V256q0-27 10-50t27-40 41-28 50-10h480zm0 256q24 0 42-4t33-13 29-20 32-27q-17-15-31-26t-30-20-33-13-42-5H128v128h480z" })
      ]
    }
  );
}
var FolderThemes_default = SvgFolderThemes;

// src/components/Icon/icons/FolderVideo.tsx
import { jsx as jsx400, jsxs as jsxs393 } from "react/jsx-runtime";
function SvgFolderVideo({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs393(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx400("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx400("path", { d: "M608 128q45 0 77 9t58 24 46 31 40 31 44 23 55 10h992q27 0 50 10t40 27 28 41 10 50v640h-128V384H928q-31 0-54 9t-44 24-41 31-45 31-58 23-78 10H128v1152h768v128H0V256q0-27 10-50t27-40 41-28 50-10h480zm0 256q24 0 42-4t33-13 29-20 32-27q-17-15-31-26t-30-20-33-13-42-5H128v128h480zm416 768h1024v896H1024v-896zm128 128v128h128v128h-128v128h128v128h-128v128h768v-640h-768zm768 128h-128v128h128v-128zm0 256h-128v128h128v-128z" })
      ]
    }
  );
}
var FolderVideo_default = SvgFolderVideo;

// src/components/Icon/icons/ForearmStrap.tsx
import { jsx as jsx401, jsxs as jsxs394 } from "react/jsx-runtime";
function SvgForearmStrap({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs394(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx401("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx401("path", { d: "M0 640h2048v768H0V640zm1280 128H768v512h512V768zm-1152 0v512h512V768H128zm1792 512V768h-512v512h512zm-768-128H896V896h256v256z" })
      ]
    }
  );
}
var ForearmStrap_default = SvgForearmStrap;

// src/components/Icon/icons/Forum.tsx
import { jsx as jsx402, jsxs as jsxs395 } from "react/jsx-runtime";
function SvgForum({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs395(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx402("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx402("path", { d: "M0 128h2048v1408H731l-475 475v-475H0V128zm1920 1280V256H128v1152h256v293l293-293h1243zM1792 384v896H256V384h1536zM512 1152V896H384v256h128zm0-384V512H384v256h128zm1152 384V896H640v256h1024zm0-384V512H640v256h1024z" })
      ]
    }
  );
}
var Forum_default = SvgForum;

// src/components/Icon/icons/ForumConfirm.tsx
import { jsx as jsx403, jsxs as jsxs396 } from "react/jsx-runtime";
function SvgForumConfirm({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs396(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx403("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx403("path", { d: "M0 128h2048v1024h-128V256H128v1152h256v293l293-293h219v128H731l-475 475v-475H0V128zm1792 988l-164 164H256V384h1536v732zM640 512v256h1024V512H640zm-128 640V896H384v256h128zm0-384V512H384v256h128zm128 384h1024V896H640v256zm691 651l530-531 91 91-621 621-366-365 91-91 275 275z" })
      ]
    }
  );
}
var ForumConfirm_default = SvgForumConfirm;

// src/components/Icon/icons/ForumFavorite.tsx
import { jsx as jsx404, jsxs as jsxs397 } from "react/jsx-runtime";
function SvgForumFavorite({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs397(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx404("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx404("path", { d: "M1703 1472h345l-276 216 116 360-288-225-288 225 116-360-276-216h345l103-320 103 320zM0 128h2048v1152h-128V256H128v1152h256v293l293-293h347v128H731l-475 475v-475H0V128zm1792 896h-128V896H640v256h768v128H256V384h1536v640zM512 1152V896H384v256h128zm0-384V512H384v256h128zm128 0h1024V512H640v256z" })
      ]
    }
  );
}
var ForumFavorite_default = SvgForumFavorite;

// src/components/Icon/icons/ForumLock.tsx
import { jsx as jsx405, jsxs as jsxs398 } from "react/jsx-runtime";
function SvgForumLock({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs398(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx405("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx405("path", { d: "M1792 896H640v256h640v128H256V384h1536v512zM640 512v256h1024V512H640zm-128 640V896H384v256h128zm0-384V512H384v256h128zM0 128h2048v896l-128-128V256H128v1152h256v293l293-293h475v128H731l-475 475v-475H0V128zm1920 1280h128v640h-768v-640h128v-128q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100v128zm-384-128v128h256v-128q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50zm384 640v-384h-512v384h512z" })
      ]
    }
  );
}
var ForumLock_default = SvgForumLock;

// src/components/Icon/icons/FullScreen.tsx
import { jsx as jsx406, jsxs as jsxs399 } from "react/jsx-runtime";
function SvgFullScreen({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs399(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx406("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx406("path", { d: "M1408 0h640v640h-128V219L218 1920h422v128H0v-640h128v422L1829 128h-421V0z" })
      ]
    }
  );
}
var FullScreen_default = SvgFullScreen;

// src/components/Icon/icons/Game.tsx
import { jsx as jsx407, jsxs as jsxs400 } from "react/jsx-runtime";
function SvgGame({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs400(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx407("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx407("path", { d: "M1024 640q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45q0-26 19-45t45-19zm704-164q20 14 36 35t25 45l224 607q20 55 27 121t8 124q0 55-17 111t-49 103-80 76-110 30q-22 0-48-8t-43-24l-304-304q-12-12-30-21t-40-15-42-9-37-3H800q-17 0-37 3t-42 9-39 15-31 21l-304 304q-16 16-42 24t-49 8q-62 0-109-29t-80-76-50-103-17-112q0-61 7-124t28-121l1-1 225-609v-2q9-22 24-41t35-34v-66q44-23 85-40t84-28 88-16 95-6q34 0 61 10t49 22 42 22 40 10h320q19 0 39-10t42-22 50-22 61-10q50 0 95 5t87 17 84 28 86 40v66zm64 1124q33 0 57-20t40-49 23-62 8-61q0-49-6-102t-22-101q-32-93-66-184t-70-184l-61-167q-7-17-12-35t-14-35q-5-10-12-17-11-11-27-17t-30-12v-66q-53-22-110-31t-114-9q-20 0-39 10t-42 22-50 22-61 10H864q-34 0-61-10t-49-22-43-22-39-10q-57 0-114 9t-110 31v66q-8 4-18 8t-21 9-18 12-12 17l-223 605q-16 44-22 100t-6 103q0 27 7 60t23 63 40 49 58 20q5 0 7-1l302-303q20-20 49-35t61-25 65-15 60-5h448q27 0 59 5t65 15 62 25 49 35l302 303q2 1 7 1z" })
      ]
    }
  );
}
var Game_default = SvgGame;

// src/components/Icon/icons/GameAdd.tsx
import { jsx as jsx408, jsxs as jsxs401 } from "react/jsx-runtime";
function SvgGameAdd({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs401(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx408("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx408("path", { d: "M2048 1472v128h-256v256h-128v-256h-256v-128h256v-256h128v256h256zM960 704q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45zm288 512q27 0 59 5t64 15 60 24 49 34q13 12 25 24t25 26H800q-17 0-38 3t-43 9-39 15-32 23l-299 299q-17 17-43 26t-50 9q-62 0-109-29t-80-76-50-104-17-111q0-57 7-124t28-121l225-609q8-23 24-43t36-35v-66q44-23 85-40t84-28 88-16 95-6q33 0 60 10t50 22 43 22 39 10h320q19 0 39-10t43-22 50-22 60-10q50 0 95 5t87 17 84 28 86 40v66q20 14 36 34t24 44l224 608q16 42 22 89t10 93h-128q-2-34-7-70t-17-69l-223-605q-3-10-11-17t-19-12-20-9-19-8v-66q-54-21-110-30t-114-10q-19 0-39 10t-43 22-50 22-60 10H864q-33 0-60-10t-51-22-42-22-39-10q-57 0-113 9t-111 31v66q-18 8-39 17t-30 30l-223 605q-16 44-22 99t-6 103q0 27 7 60t24 62 40 50 57 20l307-301q21-20 49-35t61-26 65-16 62-6h448z" })
      ]
    }
  );
}
var GameAdd_default = SvgGameAdd;

// src/components/Icon/icons/GameArt160.tsx
import { jsx as jsx409, jsxs as jsxs402 } from "react/jsx-runtime";
function SvgGameArt160({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs402(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx409("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx409("path", { d: "M1024 640q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45q0-26 19-45t45-19zm678-151q20 11 37 32t25 42l224 608q20 53 27 117t7 120q0 50-14 102t-44 95-72 70-100 28v-77q39 0 68-22t48-54 28-71 10-71q0-50-6-107t-24-104l-224-607q-8-22-27-33t-40-20v-65q-57-27-121-38t-128-12q-22 0-42 10t-43 22-49 22-58 10H864q-32 0-58-10t-48-22-43-22-43-10q-63 0-127 11t-123 39v65q-20 8-39 19t-27 34l-224 607q-17 47-23 104t-7 107q0 33 9 71t29 70 48 55 68 22q5 0 12-2t11-5l303-304q18-18 45-32t57-23 60-14 56-5h448q25 0 55 4t61 14 57 24 45 32l303 304q3 3 10 5t13 2v77q-17 0-39-6t-35-20l-304-304q-14-13-34-23t-44-18-46-10-42-4H800q-19 0-42 3t-46 11-44 17-34 24l-304 304q-13 13-35 19t-39 7q-57 0-100-27t-72-71-43-95-15-102q0-57 7-120t27-117l224-609 1-1q19-45 60-72v-64q79-42 158-61t169-19q31 0 56 10t49 22 44 23 43 10h320q22 0 43-10t44-22 48-23 57-10q87 0 168 19t158 61v64z" })
      ]
    }
  );
}
var GameArt160_default = SvgGameArt160;

// src/components/Icon/icons/GameArt224.tsx
import { jsx as jsx410, jsxs as jsxs403 } from "react/jsx-runtime";
function SvgGameArt224({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs403(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx410("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx410("path", { d: "M1024 640q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45q0-26 19-45t45-19zm954 535q19 52 26 115t7 118q0 47-14 97t-41 92-69 67-95 27v-54q42 0 73-22t51-57 31-74 10-76q0-51-6-109t-25-106l-223-607q-8-22-27-35t-39-21v-65q-60-29-127-41t-134-13q-24 0-46 10t-44 22-47 22-55 10H864q-21 0-39-4t-34-12-33-17-35-18h-1q-22-13-50-13-67 0-134 12t-127 42v65q-20 8-39 21t-27 35l-223 607q-18 48-24 106t-7 109q0 35 10 75t30 75 52 56 73 23q5 0 15-2t15-7l304-304q18-18 44-31t54-22 58-13 54-5h448q25 0 54 4t57 13 55 22 44 32l304 304q4 4 14 6t16 3v54q-17 0-34-5t-31-17h-1l-304-305q-14-14-35-24t-46-18-49-11-44-4H800q-19 0-43 3t-49 11-46 18-36 25l-304 305h-1q-14 12-31 17t-34 5q-54 0-95-26t-68-68-42-91-14-98q0-27 1-57t6-61 10-60 16-55l225-609v-1q19-45 62-70v-63q69-41 152-58t163-17q30 0 54 10t46 21 44 22 48 10h320q25 0 47-10t44-21 47-22 54-10q79 0 162 17t153 58v63q43 25 62 70l1 1 224 609z" })
      ]
    }
  );
}
var GameArt224_default = SvgGameArt224;

// src/components/Icon/icons/Gamebar.tsx
import { jsx as jsx411, jsxs as jsxs404 } from "react/jsx-runtime";
function SvgGamebar({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs404(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx411("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx411("path", { d: "M1536 787l384-115v832L640 1888v-315L0 1760V608l1536-448v627zm-128 172l-256 77v565l256-77V959zM125 1594l515-150v-388l771-231V326L125 701v893zm643-443v565l256-77v-565l-256 77zm1024 258V844l-256 77v565l256-77z" })
      ]
    }
  );
}
var Gamebar_default = SvgGamebar;

// src/components/Icon/icons/GameChat.tsx
import { jsx as jsx412, jsxs as jsxs405 } from "react/jsx-runtime";
function SvgGameChat({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs405(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx412("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx412("path", { d: "M896 1408v128H704l-448 448v-448H0V128h2048v1024h-128V256H128v1152h256v267l267-267h245zm1008 17q24 50 49 100t47 103 35 106 14 112q0 33-7 66t-27 61q-9 14-23 28t-32 24-35 17-37 7q-22 0-43-13t-43-32-42-43-38-45-34-36-28-18q-14-4-30-4t-30 0h-223q-10 0-17 2t-13 2q-23 8-49 38t-55 63-60 59-65 26q-18 0-36-6t-36-16-31-24-25-29q-20-31-28-66t-9-71q0-22 2-43t6-43q3-19 10-47t18-60 21-65 24-65 23-58 21-44q2-4 4-7t5-8q0-16 2-31t10-26 19-18 31-9q14-1 22-2t21-7q31-16 66-19t70-4q19 0 30 1t19 5 18 10 25 15h161q23-17 38-24t45-7q20 0 49 3t58 13 52 24 30 37q22 9 35 26t16 42zm-9 489q16-12 20-31t5-38q0-46-13-95t-34-97-45-95-45-86q-21-2-37-17t-19-37q-30-9-61-9-17 7-30 17t-33 13q-25 3-51 2t-51-1q-26 0-47 1t-41-1-39-8-41-23h-35q-18 0-36 5-12 3-24 9t-26 10q-4 11-9 19t-10 18q-15 27-34 76t-36 103-29 105-12 82q0 21 5 42t23 36q29-27 50-51t40-44 36-37 41-28 54-18 77-7h192q66 0 104 13t67 38 54 59 70 75zm-391-443q14 0 23 9t9 23q0 14-9 23t-23 9q-14 0-23-9t-9-23q0-14 9-23t23-9z" })
      ]
    }
  );
}
var GameChat_default = SvgGameChat;

// src/components/Icon/icons/GameChatTranscription.tsx
import { jsx as jsx413, jsxs as jsxs406 } from "react/jsx-runtime";
function SvgGameChatTranscription({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs406(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx413("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx413("path", { d: "M2048 128v680q-57-62-128-107V256H128v1152h256v293l293-293h347v128H731l-475 475v-475H0V128h2048zm-448 640q93 0 174 35t143 96 96 142 35 175v384q0 26-19 45t-45 19h-128q-26 0-45-19t-19-45v-256q0-22 8-34t22-19 30-9 34-2h34v-64q0-66-25-124t-69-101-102-69-124-26q-66 0-124 25t-102 69-69 102-25 124v64h34q17 0 33 2t30 8 22 19 9 35v256q0 22-8 34t-22 19-30 9-34 2h-34q0 70 35 130t97 94q11-42 45-69t79-27h128q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10h-128q-80 0-150-30t-122-82-82-122-30-150v-448q0-93 35-174t96-143 142-96 175-35z" })
      ]
    }
  );
}
var GameChatTranscription_default = SvgGameChatTranscription;

// src/components/Icon/icons/GameClip.tsx
import { jsx as jsx414, jsxs as jsxs407 } from "react/jsx-runtime";
function SvgGameClip({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs407(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx414("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx414("path", { d: "M384 768H256V640h128v128zm0 256H256V896h128v128zm-128 128h128v128H256v-128zm128 384h320v128H0V256h2048v944l-128-128V384h-128v128h-128V384H384v128H256V384H128v1152h128v-128h128v128zm1408-768h-128V640h128v128zm-128 128h128v128h-128V896zm-256 528q20 0 34 14t14 34q0 20-14 34t-34 14q-20 0-34-14t-14-34q0-20 14-34t34-14zm448-163q15 15 33 48t37 75 37 90 34 92 25 82 15 57q5 28 8 55t3 57q0 39-8 76t-31 70q-11 16-26 31t-33 28-38 19-40 7q-23 0-42-9t-36-26l-207-207q-14-14-35-14h-288q-21 0-35 14l-208 207q-17 16-35 25t-42 10q-20 0-40-7t-38-19-33-27-26-32q-22-33-30-70t-9-76q0-29 3-56t8-56q4-21 14-57t26-81 33-92 37-90 37-75 34-49v-43q55-32 117-49t126-17q23 0 42 6t38 15 36 21 38 22h102q20-10 38-21t36-21 37-16 43-6q64 0 126 17t117 49v43zm22 655q27-17 34-43t8-56q0-23-2-45t-7-44q-15-80-47-159t-65-154q-5-12-11-27t-14-27q-7-10-21-17t-25-12v-32q-57-20-115-20h-6q-7 4-25 14t-38 22-38 19-27 9h-142q-8 0-26-8t-39-20-38-21-25-15q-65 0-121 20v32q-11 5-25 11t-21 18q-8 11-14 26t-11 28q-33 74-65 153t-47 160q-4 22-6 44t-3 45q0 29 7 55t35 44l201-202q24-24 57-37t68-13h288q35 0 67 13t58 38l201 201z" })
      ]
    }
  );
}
var GameClip_default = SvgGameClip;

// src/components/Icon/icons/GameClip2.tsx
import { jsx as jsx415, jsxs as jsxs408 } from "react/jsx-runtime";
function SvgGameClip2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs408(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx415("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx415("path", { d: "M1024 0q141 0 272 36t245 103 207 160 160 208 103 245 37 272q0 141-36 272t-103 245-160 207-208 160-245 103-272 37q-172 0-330-55t-289-154-226-238-141-304l123-34q40 145 123 265t198 208 253 135 289 49q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-129 0-251 36T546 267 355 428 215 640h297v128H0V256h128v274q67-123 163-221t212-166T752 37t272-37zm320 1024q0 66-25 124t-68 102-102 69-125 25q-66 0-124-25t-102-68-69-102-25-125q0-66 25-124t68-102 102-69 125-25q66 0 124 25t102 68 69 102 25 125z" })
      ]
    }
  );
}
var GameClip2_default = SvgGameClip2;

// src/components/Icon/icons/GameClip2Off.tsx
import { jsx as jsx416, jsxs as jsxs409 } from "react/jsx-runtime";
function SvgGameClip2Off({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs409(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx416("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx416("path", { d: "M1024 128q-121 0-235 32t-218 95l-93-94Q601 83 739 42t285-42q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 146-41 285t-119 262l-93-93q62-103 93-218t32-236q0-123-32-237t-90-214-141-182-181-140-214-91-238-32zM19 109l90-90 1920 1920-90 90-239-238q-141 125-314 191t-362 66q-115 0-224-25t-208-71-187-114-159-150-124-182-84-209l123-34q40 145 123 265t198 208 253 135 289 49q163 0 313-56t273-164l-410-410q-80 54-176 54-66 0-124-25t-102-68-69-102-25-125q0-96 54-176L349 440q-79 92-131 200h166v128H0V384h128v147q27-50 59-95t71-87L19 109z" })
      ]
    }
  );
}
var GameClip2Off_default = SvgGameClip2Off;

// src/components/Icon/icons/GameClubs.tsx
import { jsx as jsx417, jsxs as jsxs410 } from "react/jsx-runtime";
function SvgGameClubs({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs410(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx417("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx417("path", { d: "M0 0h2048v128H0V0zm671 1408q-41 0-70-19t-49-50-28-68-9-73q0-20 2-38t5-38q3-17 10-47t18-66 23-76 24-74 23-63 19-41q0-33 12-56t48-26q23-2 40-9t39-13q20-5 40-8t42-3q16 0 27 2t22 6 21 10 23 15h142q13-8 23-14t20-11 22-6 28-2q21 0 41 3t41 8q21 5 38 12t41 10q35 3 47 26t13 56q8 13 19 40t23 63 24 75 22 75 18 67 11 47q3 19 5 37t2 39q0 35-9 72t-28 68-48 50-71 20q-22 0-43-13t-42-32-37-39-30-36q-18-21-29-33t-24-20-30-9-45-3H951q-29 0-45 2t-29 10-24 19-30 34q-13 15-30 35t-37 39-41 32-44 14zm91-615q-15 44-36 97t-39 108-32 109-14 99q0 17 4 36t19 32q42-41 67-70t43-49 34-31 43-17 66-7 107-2q66 0 106 1t67 8 42 17 35 31 43 49 67 70q15-12 19-31t4-37q0-45-13-98t-32-109-40-109-36-97q-19-5-27-9t-15-8-18-4-35-2h-12q-14 10-25 16t-21 10-23 5-30 2H968q-17 0-29-1t-23-5-22-10-25-17h-12q-24 0-35 1t-18 5-15 7-27 10zm1286-537v128h-256v1280l-768 384-768-384V384H0V256h2048zm-384 1329V384H384v1201l640 320 640-320z" })
      ]
    }
  );
}
var GameClubs_default = SvgGameClubs;

// src/components/Icon/icons/GameCompletion.tsx
import { jsx as jsx418, jsxs as jsxs411 } from "react/jsx-runtime";
function SvgGameCompletion({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs411(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx418("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx418("path", { d: "M1536 0v603l-343 342q78 34 141 89t108 124 69 149 25 165q0 119-45 224t-124 183-183 123-224 46q-119 0-224-45t-183-124-123-183-46-224q0-85 24-165t69-149 108-124 142-89L384 603V0h1152zm-128 1472q0-93-35-174t-96-142-142-96-175-36q-93 0-174 35t-142 96-96 142-36 175q0 93 35 174t96 142 142 96 175 36q93 0 174-35t142-96 96-142 36-175zm0-923V128H512v421l354 355q23-4 47-6t47-2q23 0 47 2t47 6l354-355zm-502 613h54q64 0 120 24t99 67 66 98 25 121v54h-108v-54q0-42-16-78t-43-64-64-44-79-16h-54v-108z" })
      ]
    }
  );
}
var GameCompletion_default = SvgGameCompletion;

// src/components/Icon/icons/GameCompletionDlc.tsx
import { jsx as jsx419, jsxs as jsxs412 } from "react/jsx-runtime";
function SvgGameCompletionDlc({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs412(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx419("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx419("path", { d: "M2048 128v731l-208 208q48 24 86 60t66 81 41 95 15 105q0 80-30 149t-82 122-123 83-149 30q-94 0-174-44-31 68-79 123t-110 95-131 60-146 22q-75 0-146-21t-131-61-109-94-80-124q-80 44-174 44-80 0-149-30t-122-82-83-122-30-150q0-54 14-104t42-95 65-81 87-61L0 859V128h512V0h1024v128h512zm-1408 0v552l306 350q39-6 78-6t78 6l306-350V128H640zm733 1033q48-57 116-94l-133-133-119 136q75 34 136 91zm-698 0q61-57 136-91L692 934l-133 133q68 37 116 94zM128 805l220 221q36-3 72 0l188-188-96-110V256H128v549zm256 878q37 0 72-9t67-30q-5-27-8-54t-3-54q0-78 23-152t68-139q-38-53-96-82t-123-30q-57 0-107 21t-87 59-59 88-22 107q0 57 21 107t59 87 88 59 107 22zm640 256q83 0 156-31t128-87 87-128 32-157q0-83-32-156t-86-128-128-87-157-32q-83 0-156 32t-129 86-86 128-32 157q0 83 31 156t87 129 128 86 157 32zm915-531q0-57-21-107t-59-87-88-59-107-22q-65 0-123 29t-96 83q45 64 68 138t23 153q0 27-3 54t-8 54q31 20 66 29t73 10q57 0 107-21t87-59 59-88 22-107zm-19-603V256h-384v472l-96 110 188 188q36-3 72 0l220-221zm-896 491q49 0 93 19t76 51 52 77 19 93h-96q0-30-11-56t-31-45-46-31-56-12v-96z" })
      ]
    }
  );
}
var GameCompletionDlc_default = SvgGameCompletionDlc;

// src/components/Icon/icons/GameDemos.tsx
import { jsx as jsx420, jsxs as jsxs413 } from "react/jsx-runtime";
function SvgGameDemos({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs413(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx420("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx420("path", { d: "M1728 476q20 14 36 35t25 45l224 607q20 55 27 121t8 124q0 55-17 111t-49 103-80 76-110 30q-22 0-48-8t-43-24l-304-304q-12-12-30-21t-40-15-42-9-37-3H800q-17 0-37 3t-42 9-39 15-31 21l-304 304q-16 16-42 24t-49 8q-62 0-109-29t-80-76-50-103-17-112q0-61 7-124t28-121l1-1 225-609v-2q9-22 24-41t35-34v-66q44-23 85-40t84-28 88-16 95-6q34 0 61 10t49 22 42 22 40 10h320q19 0 39-10t42-22 50-22 61-10q50 0 95 5t87 17 84 28 86 40v66zm64 1124q33 0 57-20t40-49 23-62 8-61q0-50-6-102t-22-101q-32-93-66-184t-70-184l-61-167q-7-17-12-35t-14-35q-5-10-12-17-11-11-27-17t-30-12v-66q-53-22-110-31t-114-9q-11 0-24 4t-26 11-25 13-22 12q-24 12-46 18t-49 6h-160v64q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10v384h224q66 0 122 19t110 59l1 1 2 1 302 303q2 1 7 1z" })
      ]
    }
  );
}
var GameDemos_default = SvgGameDemos;

// src/components/Icon/icons/GameEditions.tsx
import { jsx as jsx421, jsxs as jsxs414 } from "react/jsx-runtime";
function SvgGameEditions({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs414(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx421("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx421("path", { d: "M832 1152q-28 0-46-18t-18-46q0-26 19-45t45-19q26 0 45 19t19 45q0 28-18 46t-46 18zM384 0h1664v1664h-384v384H0V384h384V0zm1152 1920V512H128v1408h1408zm384-384V128H512v256h1152v1152h256zM288 1395q0-46 9-93 3-18 12-49t22-68 28-78 32-76 30-63 27-39q0-36 31-56 13-9 37-16t51-13 52-9 42-3q12 0 24 1t24 7h1q11 5 20 11t20 12h164q15-7 24-13t17-10 19-6 29-2q17 0 42 3t52 8 50 13 38 17q15 10 22 24t9 32q11 11 26 38t30 63 32 76 29 79 21 69 12 48q4 24 7 47t3 48q0 57-19 102t-69 77q-15 10-34 17t-38 7q-23 0-44-12t-41-32-40-43-37-44-34-37-32-20q-11-3-26-4t-28-1H820q-57 0-114 1-8 0-15 2t-15 2q-28 11-54 42t-54 63-56 58-64 25q-18 0-37-6t-34-16q-49-31-69-79t-20-104zm128 0q0 19 4 39t21 32q42-39 68-73t55-59 66-39 106-15h192q66 0 105 14t67 40 54 59 69 73q17-13 21-31t4-38q0-35-8-73-5-24-16-61t-25-76-29-75-26-59l-8-16q-4-8-9-15-7-8-12-12t-9-8-9-10-8-18q-22-6-43-10t-44-4q-17 8-32 19t-35 12H729q-20 0-35-11t-32-20q-23 0-44 4t-44 10q-3 11-6 17t-9 10-10 9-12 12q-5 6-8 14t-8 16q-15 32-33 77t-34 93-27 94-11 79z" })
      ]
    }
  );
}
var GameEditions_default = SvgGameEditions;

// src/components/Icon/icons/GameEditionSolid.tsx
import { jsx as jsx422, jsxs as jsxs415 } from "react/jsx-runtime";
function SvgGameEditionSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs415(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx422("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx422("path", { d: "M832 1024q26 0 45 19t19 45q0 28-18 46t-46 18q-28 0-46-18t-18-46q0-26 19-45t45-19zM384 0h1664v1664h-384v384H0V384h384V0zm992 1397q0-25-3-48t-7-47q-3-17-11-48t-22-69-29-78-31-76-31-63-26-39q-2-17-9-31t-22-25q-14-9-38-17t-50-13-51-8-43-3q-18 0-28 2t-19 6-18 10-24 13H750q-10-6-19-12t-21-11h-1q-11-5-23-6t-25-2q-17 0-42 3t-52 8-51 13-37 17q-31 20-31 56-12 12-26 39t-31 62-31 76-28 78-22 69-13 49q-9 47-9 93 0 56 20 104t69 79q15 10 34 16t37 6q34 0 63-25t57-57 53-64 55-42q8 0 15-2t15-2h114q57 0 114-1 12 0 27 1t27 4q15 5 31 20t35 37 37 44 39 42 42 32 44 13q19 0 38-7t34-17q49-32 68-77t20-102zm544 139V128H512v256h1152v1152h256z" })
      ]
    }
  );
}
var GameEditionSolid_default = SvgGameEditionSolid;

// src/components/Icon/icons/GameFavorite.tsx
import { jsx as jsx423, jsxs as jsxs416 } from "react/jsx-runtime";
function SvgGameFavorite({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs416(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx423("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx423("path", { d: "M960 704q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45zm928 1344l-288-225-288 225 116-360-276-216h345l103-320 103 320h345l-276 216 116 360zm-512-704H800q-17 0-38 3t-43 9-39 15-32 23l-299 299q-17 17-43 26t-50 9q-62 0-109-29t-80-76-50-104-17-111q0-28 1-60t6-64 11-63 17-58l225-609q8-23 24-43t36-35v-66q44-23 85-40t84-28 88-16 95-6q33 0 60 10t50 22 43 22 39 10h320q19 0 39-10t43-22 50-22 60-10q50 0 95 5t87 17 84 28 86 40v66q20 14 36 34t24 44l224 608q16 43 23 89t11 93h-129q-2-34-7-70t-18-69l-223-605q-3-10-11-17t-19-12-20-9-19-8v-66q-54-21-110-30t-114-10q-19 0-39 10t-43 22-50 22-60 10H864q-33 0-60-10t-51-22-42-22-39-10q-57 0-113 9t-111 31v66q-18 8-39 17t-30 30l-223 605q-16 44-22 99t-6 103q0 27 7 60t24 62 40 50 57 20l307-301q21-20 49-35t61-26 65-16 62-6h448q42 0 81 9t78 27l-31 92z" })
      ]
    }
  );
}
var GameFavorite_default = SvgGameFavorite;

// src/components/Icon/icons/GameFreeze.tsx
import { jsx as jsx424, jsxs as jsxs417 } from "react/jsx-runtime";
function SvgGameFreeze({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs417(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx424("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx424("path", { d: "M1024 640q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45q0-26 19-45t45-19zm-461 659q21-20 49-35t61-26 65-16 62-6h224v128H800q-17 0-38 3t-43 9-39 15-32 23l-299 299q-17 17-43 26t-50 9q-62 0-109-29t-80-76-50-104-17-111q0-28 1-60t6-64 11-63 17-58l225-609q8-23 24-43t36-35v-66q44-23 85-40t84-28 88-16 95-6q33 0 60 10t51 22 42 22 39 10h320q19 0 39-10t43-22 50-22 60-10q50 0 95 5t87 17 84 28 86 40v66q20 14 36 34t24 44l173 470h-136l-156-424q-3-10-11-17t-19-12-20-9-19-8v-66q-54-21-110-30t-114-10q-19 0-39 10t-43 22-50 22-60 10H864q-33 0-60-10t-51-22-42-22-39-10q-57 0-113 9t-111 31v66q-18 8-39 17t-30 30l-223 605q-17 44-22 99t-6 103q0 27 7 60t24 62 40 50 57 20l307-301zm1357 621l-86-516-138 644-142-664-82 408-93-466-99 594-128-768h896l-128 768z" })
      ]
    }
  );
}
var GameFreeze_default = SvgGameFreeze;

// src/components/Icon/icons/GameHub.tsx
import { jsx as jsx425, jsxs as jsxs418 } from "react/jsx-runtime";
function SvgGameHub({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs418(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx425("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx425("path", { d: "M128 128h1792v1024H128V128zm1664 896V256H256v768h1536zM128 1536v-128h1792v128H128zm0 384v-128h1792v128H128z" })
      ]
    }
  );
}
var GameHub_default = SvgGameHub;

// src/components/Icon/icons/GameJoin.tsx
import { jsx as jsx426, jsxs as jsxs419 } from "react/jsx-runtime";
function SvgGameJoin({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs419(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx426("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx426("path", { d: "M2048 1600q0 72-21 137t-61 121-95 97-122 66l-42-121q47-17 86-47t68-69 43-87 16-97q0-66-25-124t-69-101-102-69-124-26q-66 0-124 25t-102 69-69 102-25 124q0 75 34 142t94 112v-190h128v384h-384v-128h136q-66-63-101-146t-35-174q0-93 35-174t96-143 142-96 175-35q93 0 174 35t143 96 96 142 35 175zM960 704q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45zm-160 512h329q-49 59-80 128H800q-17 0-38 3t-43 9-39 15-32 23l-299 299q-17 17-43 26t-50 9q-62 0-109-29t-80-76-50-104-17-111q0-28 1-60t6-64 11-63 17-58l225-609q8-23 24-43t36-35v-66q44-23 85-40t84-28 88-16 95-6q33 0 60 10t50 22 43 22 39 10h320q19 0 39-10t43-22 50-22 60-10q50 0 95 5t87 17 84 28 86 40v66q20 14 36 34t24 44l219 595q-79-71-177-112l-161-437q-3-10-11-17t-19-12-20-9-19-8v-66q-54-21-110-30t-114-10q-19 0-39 10t-43 22-50 22-60 10H864q-33 0-60-10t-51-22-42-22-39-10q-57 0-113 9t-111 31v66q-18 8-39 17t-30 30l-223 605q-16 44-22 99t-6 103q0 27 7 60t24 62 40 50 57 20l307-301q21-20 49-35t61-26 65-16 62-6z" })
      ]
    }
  );
}
var GameJoin_default = SvgGameJoin;

// src/components/Icon/icons/GameLaunch.tsx
import { jsx as jsx427, jsxs as jsxs420 } from "react/jsx-runtime";
function SvgGameLaunch({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs420(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx427("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx427("path", { d: "M128 1664h728q-7 32-13 64t-9 64H0V256h384V128h128v128h768V128h128v128h384v843q-53-11-104-11h-12q-6 0-12 1V768H128v896zm0-1280v256h1536V384h-256v128h-128V384H512v128H384V384H128zm1786 1037q21 46 45 100t43 110 33 112 13 108q0 32-7 63t-25 60q-9 14-22 27t-30 24-33 17-36 6q-30 0-57-21t-51-49-48-58-46-44q-14-9-31-10t-34-1h-203q-9 0-18 2t-16 6-20 11q-8 11-18 21t-19 22q-13 15-30 35t-37 40-42 32-44 14q-35 0-69-22t-53-52q-19-29-27-62t-8-69q0-39 8-82 2-10 9-40t19-70 25-84 25-81 23-63 16-30q0-33 11-56t50-26q23-2 39-10t39-13q21-5 43-6t45-2q29 0 47 6t41 25h144q13-8 21-14t15-9 17-6 27-2q19 0 47 3t56 13 49 23 28 37q20 10 32 26t14 39zm-12 491q12-11 15-28t3-32q0-40-13-91t-32-104-40-102-40-87q-20-3-34-17t-18-35q-26-8-51-8-4 6-13 11t-19 10-20 7-18 3h-177q-9 0-19-5t-21-10-17-11-9-5h-31q-16 0-32 5-11 2-21 8t-22 9q-3 8-6 15t-9 15q-8 16-19 45t-23 65-23 77-21 78-14 69-6 50q0 7 1 17t3 20 7 19 11 13q40-38 64-70t51-55 62-37 99-14h178q61 0 97 13t62 36 51 55 64 71z" })
      ]
    }
  );
}
var GameLaunch_default = SvgGameLaunch;

// src/components/Icon/icons/GameLaunchSolid.tsx
import { jsx as jsx428, jsxs as jsxs421 } from "react/jsx-runtime";
function SvgGameLaunchSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs421(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx428("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx428("path", { d: "M898 1792H0V768h1792v395q-58-11-112-11-26 0-58 7t-54 24h-65q-29-18-61-24t-67-7q-18 0-42 1t-48 5-48 10-39 16q-49 3-91 27t-63 71q-9 20-12 36t-9 35q-8 23-17 46t-18 47q-27 85-53 171t-37 175zm1150 50q0 56-17 103t-67 80q-17 11-33 17t-36 6q-32 0-58-21t-50-49-47-58-47-44q-13-8-27-9t-29-2h-212q-17 0-28 5t-26 14q-8 11-18 21t-19 22q-12 15-30 36t-38 39-42 32-43 14q-19 0-36-6t-33-16q-48-32-68-79t-20-104q0-21 2-41t6-41q2-11 9-41t19-68 24-82 25-80 22-63 18-34q0-14 2-28t9-28q7-14 21-19t29-7q21-2 39-10t39-13q22-5 44-6t44-2q28 0 47 6t41 25h144q22-15 37-23t43-8q20 0 48 3t55 13 48 23 29 37q20 11 32 26t14 39q20 44 43 97t44 109 33 111 14 104zm-447-370q0-26-19-45t-45-19q-26 0-45 19t-19 45q0 26 19 45t45 19q26 0 45-19t19-45zm191-1216v384H0V256h384V128h128v128h768V128h128v128h384z" })
      ]
    }
  );
}
var GameLaunchSolid_default = SvgGameLaunchSolid;

// src/components/Icon/icons/GameMod.tsx
import { jsx as jsx429, jsxs as jsxs422 } from "react/jsx-runtime";
function SvgGameMod({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs422(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx429("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx429("path", { d: "M960 704q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45zm224-192H864q-33 0-60-10t-51-22-42-22-39-10q-57 0-114 9t-110 31v66q-18 8-39 17t-30 30l-223 605q-16 44-22 99t-6 103q0 27 7 60t24 62 40 50 57 20q5 0 7-1l305-305q6-6 15-12t19-12 20-11 18-8v151l-296 296q-14 14-41 22t-47 8q-62 0-109-29t-80-76-50-104-17-111q0-29 1-60t6-64 11-63 17-58l225-609q8-23 24-43t36-35v-66q44-23 85-40t84-28 88-16 95-6q33 0 60 10t51 22 42 22 39 10h320q19 0 39-10t42-22 50-22 61-10q50 0 95 5t87 17 84 28 86 40v66q20 14 36 34t24 44l126 342h-136l-109-296q-3-10-11-17t-19-12-20-9-19-8v-66q-53-22-110-31t-114-9q-20 0-39 10t-42 22-50 22-61 10zm480 512h384v1024H1024v-256q-53 0-99-20t-82-55-55-81-20-100q0-53 20-99t55-82 81-55 100-20v-256h384v128q0 27 10 50t27 40 41 28 50 10q27 0 50-10t40-27 28-41 10-50v-128zm256 896v-768h-128q0 53-20 99t-55 82-81 55-100 20q-53 0-99-20t-82-55-55-81-20-100h-128v256h-128q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10h128v256h768z" })
      ]
    }
  );
}
var GameMod_default = SvgGameMod;

// src/components/Icon/icons/GameMode.tsx
import { jsx as jsx430, jsxs as jsxs423 } from "react/jsx-runtime";
function SvgGameMode({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs423(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx430("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx430("path", { d: "M960 0q132 0 254 34t230 97 194 150 150 195 97 229 35 255q0 132-34 254t-97 230-150 194-195 150-229 97-255 35q-132 0-254-34t-230-97-194-150-150-195-97-229T0 960q0-132 34-254t97-230 150-194 195-150 229-97T960 0zm0 1792q115 0 221-30t198-84 169-130 130-168 84-199 30-221q0-115-30-221t-84-198-130-169-168-130-199-84-221-30q-115 0-221 30t-198 84-169 130-130 168-84 199-30 221q0 115 30 221t84 198 130 169 168 130 199 84 221 30zm172-916q20 40 20 84 0 40-15 75t-41 61-61 41-75 15q-40 0-75-15t-61-41-41-61-15-75q0-40 15-75t41-61 61-41 75-15q44 0 84 20l-1-1 368-368 90 90-368 368-1-1zm-172 148q26 0 45-19t19-45q0-26-19-45t-45-19q-26 0-45 19t-19 45q0 26 19 45t45 19zm640-352q31 68 46 140t16 148q0 140-52 269t-152 229l-91-91q81-81 125-185t44-219q0-124-52-239l116-52zm-404-236q-115-52-239-52-79 0-152 20t-137 59-116 90-89 117-58 137-21 153q0 115 44 220t125 187l-91 91q-100-100-153-228t-53-270q0-97 25-187t71-168 110-142 142-109 168-71 188-25q75 0 147 15t141 47l-52 116z" })
      ]
    }
  );
}
var GameMode_default = SvgGameMode;

// src/components/Icon/icons/GameModeOff.tsx
import { jsx as jsx431, jsxs as jsxs424 } from "react/jsx-runtime";
function SvgGameModeOff({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs424(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx431("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx431("path", { d: "M1939 2029l-348-347q-131 116-293 177t-338 61q-132 0-255-34t-229-97-194-150-150-194-97-229T0 960q0-176 61-338t177-293L19 109l90-90 1920 1920-90 90zm-979-237q149 0 288-52t252-149L510 601q-62 76-94 168t-32 191q0 115 44 220t125 187l-91 91q-100-100-152-228t-53-270q0-124 41-239t121-211l-90-90q-97 113-149 252t-52 288q0 114 30 220t84 199 130 169 168 130 199 84 221 30zm0-1664q-108 0-211 27t-197 81l-92-93Q572 71 699 36T960 0q132 0 255 34t229 97 194 150 150 194 97 230 35 255q0 133-35 260t-108 240l-93-92q54-93 81-196t27-212q0-114-30-220t-84-199-130-169-168-130-199-84-221-30zm203 719l-90-90 338-338 90 90-338 338zm331 331q41-103 41-215 0-62-13-122t-38-117l116-52q31 68 46 140t16 148q0 81-18 160t-56 152l-94-94zM648 332q73-37 152-55t160-19q75 0 147 15t141 47l-52 116q-57-25-117-38t-122-13q-112 0-215 41l-94-94z" })
      ]
    }
  );
}
var GameModeOff_default = SvgGameModeOff;

// src/components/Icon/icons/GameModSolid.tsx
import { jsx as jsx432, jsxs as jsxs425 } from "react/jsx-runtime";
function SvgGameModSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs425(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx432("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx432("path", { d: "M1792 1152h256v896h-896v-256h-64q-40 0-75-15t-61-41-41-62-15-75q0-28 8-55t24-50 37-42 48-29q25-10 51-12t53-3h35v-256h256v42q0 25 2 49t13 48q11 26 29 47t40 37 49 24 55 9q66 0 113-34t73-94q7-15 9-36t2-42v-26q0-12-1-24zM264 1796q-62 0-111-29t-83-75-52-103-18-114q0-62 7-124t29-122l1-1 233-610v-2q10-25 24-42t36-34v-66q47-23 90-40t86-28 89-16 99-6q34 0 61 10t51 22 45 22 41 10h330q20 0 41-10t45-22 51-22 61-10q52 0 98 5t89 17 87 29 90 39v66q20 14 37 36t26 45l152 400h-335v195q0 27-18 45t-46 19q-27 0-45-18t-19-46v-192h-512v256l-46 2q-54 2-95 17t-76 39-67 55-68 66l-314 305q-17 17-44 24t-50 8zM991 769q0 26 20 45t46 19q26 0 46-18t20-46q0-27-20-45t-46-19q-26 0-46 19t-20 45z" })
      ]
    }
  );
}
var GameModSolid_default = SvgGameModSolid;

// src/components/Icon/icons/GamePass.tsx
import { jsx as jsx433, jsxs as jsxs426 } from "react/jsx-runtime";
function SvgGamePass({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs426(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx433("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx433("path", { d: "M0 384h2048v1280H0V384zm684 160L536 974h146l20-78h120l19 78h146L848 544H684zM88 766q0 113 59 164t169 51q10 0 35-3t52-8 50-11 28-14V711H266v104h81v53q-8 1-14 1t-15 1q-50 0-72-31t-23-77q0-53 28-83t83-31q34 0 60 7t58 18V553h-3q-31-5-59-10t-60-6q-33 0-65 6t-60 18-53 33-41 51q-16 27-19 58t-4 63zm491 450q0-42-13-70t-37-44-56-22-70-7H226v430h135v-136h35q35 0 68-9t58-27 41-47 16-68zm320 288h147l-140-430H743l-148 430h146l20-77h119l19 77zm529-131q0-33-13-55t-32-39-42-26-42-19-32-18-13-21q0-16 15-20t28-5q26 0 57 8t52 24v-118h-3q-31-5-58-11t-60-6q-33 0-64 8t-56 24-40 43-15 64q0 35 12 57t31 38 41 25 40 18 31 17 13 23q0 16-14 20t-26 5q-33 0-65-14t-58-33v126q33 10 62 17t64 7q33 0 66-7t61-23 43-42 17-67zm5-696q-1 15-1 30t0 29v238h130V544h-191q-16 68-33 135t-29 136q-3-10-4-19t-3-20l-58-229-1-3h-197v430h119V771q0-23-1-46t-2-46q13 75 34 148t40 147h126l63-257 4-20 4-20zm395 698q0-33-13-55t-32-38-42-26-42-20-32-17-13-21q0-15 15-20t28-6q31 0 56 9t53 23v-117q-26-11-59-14t-62-3q-33 0-64 8t-56 24-40 43-15 64q0 34 12 57t31 38 41 24 40 18 31 18 13 22q0 16-13 21t-27 5q-35 0-64-14t-58-33v126q11 6 27 10t34 8 35 4 29 1q34 0 67-6t60-23 43-43 17-67zm106-401V867h-137v-55h127V705h-127v-54h135V544h-270v430h272zM820 1187q7 35 16 70t19 71h-71q9-35 20-70t16-71zm-23-389h-71l36-141q8 36 17 71t18 70zm-415 374q24 0 39 11t16 38q0 25-13 36t-38 12h-25v-97h21z" })
      ]
    }
  );
}
var GamePass_default = SvgGamePass;

// src/components/Icon/icons/GamePassBeta.tsx
import { jsx as jsx434, jsxs as jsxs427 } from "react/jsx-runtime";
function SvgGamePassBeta({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs427(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx434("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx434("path", { d: "M395 986h-49V869h42q14 0 28 2t26 8 19 16 8 28q0 32-22 47t-52 16zm93 146q0 36-25 51t-57 15h-60v-130h61q31 0 56 14t25 50zm1133-257q2 23 9 44l53 166h-127l54-167q8-21 9-43h2zm334-363q19 0 36 7t29 20 20 30 8 36v838q0 19-7 36t-20 29-30 20-36 8H93q-19 0-36-7t-29-20-20-30-8-36V605q0-19 7-36t20-29 30-20 36-8h1862zM605 1133q0-52-33-81t-82-37v-1q19-6 36-16t31-24 21-32 8-39q0-35-16-57t-41-36-55-18-59-5H235v493h190q35 0 67-8t58-26 40-46 15-67zm377 147v-90H797v-113h162v-90H797V878h174v-91H686v493h296zm291 0V878h141v-91h-392v91h139v402h112zm470 0h121l-175-493h-132l-179 493h120l35-110h175l35 110z" })
      ]
    }
  );
}
var GamePassBeta_default = SvgGamePassBeta;

// src/components/Icon/icons/GamePassBetaInline.tsx
import { jsx as jsx435, jsxs as jsxs428 } from "react/jsx-runtime";
function SvgGamePassBetaInline({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs428(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2946 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx435("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx435("path", { d: "M134 575h2678q28 0 52 10t43 29 28 42 11 53v1205q0 28-10 52t-29 43-42 28-53 11H134q-28 0-52-10t-43-29-28-42-11-53V709q0-28 10-52t29-43 42-28 53-11zm204 1105h273q50 0 97-12t83-37 58-66 22-97q0-36-13-65t-35-51-53-35-65-18v-2q28-7 53-22t44-35 30-47 11-56q0-51-23-83t-60-51-79-25-85-7H338v709zm160-592h60q20 0 41 3t37 11 27 24 11 41q0 47-31 68t-75 21h-70v-168zm0 287h88q22 0 43 5t37 15 27 28 10 43q0 26-10 44t-26 29-38 17-45 6h-86v-187zm915 305v-118l-266-12v-162h232v-130h-232v-157h249V971H987v709h426zm620-579V971h-563v130h201v579h160v-579h202zm648 579l-252-709h-189l-258 709h173l50-158h252l51 158h173zm-260-281h-182l77-240q10-28 13-62h3l4 32q2 16 8 32l77 238z" })
      ]
    }
  );
}
var GamePassBetaInline_default = SvgGamePassBetaInline;

// src/components/Icon/icons/GamePassConsoleGames.tsx
import { jsx as jsx436, jsxs as jsxs429 } from "react/jsx-runtime";
function SvgGamePassConsoleGames({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs429(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 5825 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx436("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx436("path", { d: "M0 640h5824v768H0V640zm533 619v-75q-27 17-58 25t-63 8q-40 0-71-13t-53-37-33-56-12-72q0-41 12-75t35-60 57-39 75-14q29 0 57 7t54 22v-81q-29-11-59-15t-60-5q-58 0-105 20t-81 55-52 83-19 106q0 54 16 99t47 77 75 51 99 18q36 0 71-6t68-23zm281 29q58 0 103-20t75-55 45-82 16-104q0-52-15-97t-46-79-73-53-97-19q-59 0-104 19t-76 54-47 82-16 105q0 54 16 99t46 79 73 52 100 19zm4-437q41 0 69 15t46 41 26 59 8 69q0 37-8 70t-28 58-48 39-69 15q-39 0-67-15t-46-42-27-58-9-68q0-35 9-68t28-58 48-41 68-16zm737 429V787h-79v351q0 16 3 33h-1q-59-98-121-192t-125-192h-96v493h80V957q0-33-3-68h2q6 16 15 29l235 362h90zm92-20q10 7 27 12t36 8 37 6 31 2q33 0 66-6t59-22 43-42 17-65q0-38-17-64t-42-46-56-33-55-28-43-30-17-40q0-19 10-31t25-20 33-11 33-3q29 0 57 6t51 24v-81q-24-11-55-14t-58-3q-31 0-63 7t-59 24-43 41-17 63q0 39 17 65t42 44 56 33 55 27 43 30 17 41q0 21-9 34t-25 21-33 9-35 3q-15 0-33-3t-35-9-32-14-28-19v84zm603 28q59 0 103-20t75-55 45-82 16-104q0-52-15-97t-45-79-73-53-98-19q-59 0-104 19t-76 54-47 82-16 105q0 54 16 99t46 79 73 52 100 19zm4-437q41 0 69 15t46 41 26 59 8 69q0 36-8 69t-27 58-48 40-69 15q-39 0-67-15t-46-42-28-58-9-68q0-35 9-68t28-58 48-41 68-16zm592 429v-69h-192V787h-81v493h273zm341 0v-69h-195v-146h170v-69h-170V857h184v-70h-265v493h276zm653-34v-234h-185v69h104v117q-20 11-42 15t-46 5q-41 0-71-14t-51-38-29-58-10-72q0-40 12-74t36-60 57-39 74-14q36 0 70 9t65 29v-84q-32-14-67-19t-71-5q-57 0-105 19t-83 53-54 83-20 106q0 56 17 101t50 78 77 51 101 18q45 0 88-10t83-32zm505 34l-183-493h-92l-185 493h89l43-126h194l44 126h90zm-156-192h-151l68-197q2-8 3-15t4-16h1q1 8 3 15t4 16l68 197zm747 192V787h-111l-132 327q-13 30-21 58h-2q-3-14-8-28t-11-29l-130-328h-115v493h76V914q0-24-3-49h1q3 12 5 25t8 24l148 366h56l147-369q5-11 8-22t6-24h1q-2 24-3 48t-2 48v319h82zm391 0v-69h-195v-146h170v-69h-170V857h184v-70h-265v493h276zm59-20q10 7 27 12t36 8 37 6 30 2q33 0 66-6t59-22 44-42 17-65q0-28-11-51t-30-41-40-33-46-26q-20-9-39-18t-38-22q-26-19-26-50 0-19 10-32t25-20 32-10 33-3q29 0 57 6t51 24v-81q-24-11-55-14t-58-3q-31 0-63 7t-58 24-43 42-17 62q0 39 17 65t42 44 56 33 55 27 43 30 17 41q0 21-10 34t-25 21-33 9-35 3q-14 0-31-3t-36-9-34-14-26-19v84z" })
      ]
    }
  );
}
var GamePassConsoleGames_default = SvgGamePassConsoleGames;

// src/components/Icon/icons/GamePassConsoleGamesInline.tsx
import { jsx as jsx437, jsxs as jsxs430 } from "react/jsx-runtime";
function SvgGamePassConsoleGamesInline({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs430(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 11166 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx437("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx437("path", { d: "M0 576h11166v1472H0V576zm1021 1187v-145q-52 34-111 48t-121 15q-77 0-137-25t-101-71-63-108-22-137q0-78 23-144t68-114 109-76 144-27q115 0 211 57V880q-54-23-112-30t-115-8q-112 0-202 38T437 985t-100 160-35 203q0 104 31 190t90 148 143 97 190 35q68 0 136-11t129-44zm540 55q112 0 197-38t144-105 87-158 29-199q0-101-29-188t-87-151-139-100-187-37q-113 0-199 37t-146 104-90 158-31 200q0 103 30 190t89 151 141 100 191 36zm7-839q79 0 133 29t89 79 49 113 15 133q0 71-16 134t-52 110-91 76-134 28q-74 0-128-30t-89-79-52-112-17-129q0-67 18-130t54-113 91-79 130-30zm1412 824V857h-151v609q0 32 1 64t6 64h-3q-7-15-16-30t-19-29l-436-678h-183v946h152v-685q0-33-6-65h4q6 14 13 28t15 27l452 695h171zm179-38q21 13 53 23t68 16 70 10 59 4q64 0 127-12t114-42 82-80 32-126q0-53-21-97t-57-79-78-63-87-49q-28-13-62-27t-65-35-50-46-21-65q0-37 19-61t48-38 62-20 64-6q55 0 108 13t99 45V875q-22-11-49-17t-57-10-57-5-53-1q-60 0-122 14t-112 45-83 80-32 120q0 74 32 124t82 85 106 62 107 53 81 58 33 77q0 41-18 66t-47 39-63 18-68 5q-29 0-62-5t-67-16-63-27-52-36v161zm1155 53q112 0 198-38t143-105 87-158 30-199q0-101-29-188t-87-151-139-100-188-37q-113 0-199 37t-146 104-89 158-31 200q0 103 30 190t89 151 141 100 190 36zm7-839q78 0 133 29t89 79 49 113 16 133q0 71-16 134t-52 110-91 76-134 28q-74 0-128-30t-89-79-52-112-17-129q0-67 17-130t54-113 91-79 130-30zm1135 824v-133h-366V857h-157v946h523zm655 0v-133h-374v-279h325v-133h-325V991h353V857h-510v946h531zm1252-65v-449h-355v132h199v225q-39 20-82 28t-87 9q-79 0-137-27t-96-74-56-111-19-137q0-77 24-142t68-113 108-75 143-27q69 0 135 17t125 55V888q-63-27-130-36t-135-10q-110 0-202 37t-160 103-104 158-37 203q0 106 33 193t94 150 148 97 194 35q88 0 170-19t159-61zm968 65l-352-946h-176l-354 946h171l82-241h372l85 241h172zm-299-369h-289l130-377q5-14 8-29t5-30h3q2 14 4 29t8 30l131 377zm1431 369V857h-213l-253 627q-11 27-20 55t-19 56h-3q-7-27-16-54t-21-54l-249-630h-221v946h145v-703q0-46-5-93h3q5 24 10 47t15 47l282 702h109l282-707q8-21 14-43t11-46h3q-4 46-6 92t-3 92v612h155zm751 0v-133h-374v-279h325v-133h-325V991h353V857h-509v946h530zm112-38q22 13 54 23t67 16 69 10 60 4q64 0 127-12t115-42 82-80 32-126q0-53-21-97t-57-79-78-63-87-49q-28-13-62-28t-65-34-50-46-21-65q0-37 19-61t48-38 62-20 64-6q55 0 108 13t99 45V875q-23-11-50-17t-56-10-57-5-54-1q-60 0-121 14t-112 45-83 80-32 120q0 55 19 97t50 74 70 56 81 45 81 40 71 40 50 47 19 60q0 41-18 66t-47 39-63 18-68 5q-30 0-63-5t-66-16-63-27-53-36v161z" })
      ]
    }
  );
}
var GamePassConsoleGamesInline_default = SvgGamePassConsoleGamesInline;

// src/components/Icon/icons/GamePassInline.tsx
import { jsx as jsx438, jsxs as jsxs431 } from "react/jsx-runtime";
function SvgGamePassInline({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs431(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 7363 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx438("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx438("path", { d: "M6600 1765q21 13 53 23t67 16 70 10 59 4q64 0 127-12t114-42 82-80 32-126q0-54-21-97t-56-79-78-63-87-49q-28-13-62-28t-65-34-50-46-21-65q0-37 19-61t48-38 62-20 64-6q55 0 108 13t99 45V875q-23-11-50-17t-55-10-57-5-54-1q-60 0-122 14t-112 45-83 80-32 120q0 56 19 97t50 74 70 56 81 44 81 40 71 40 50 48 19 60q0 41-18 66t-47 39-64 19-67 5q-28 0-62-6t-67-17-64-26-51-36v161zm-723 0q21 13 53 23t68 16 70 10 59 4q64 0 127-12t114-42 82-80 32-126q0-53-21-97t-56-79-78-63-87-49q-28-13-62-28t-65-34-51-46-21-65q0-37 19-61t48-38 63-20 63-6q55 0 108 12t99 46V875q-22-11-49-17t-57-10-57-5-53-1q-60 0-122 14t-112 45-83 80-32 120q0 74 32 124t82 85 106 62 107 53 81 57 33 78q0 41-18 66t-47 39-63 19-68 5q-28 0-62-6t-67-17-64-26-51-36v161zm-373-331h-289l130-377q5-14 8-29t5-30h3q2 14 4 29t8 30l131 377zm299 369l-351-945h-177l-354 945h171l82-241h372l85 241h172zM4499 987h114q42 0 78 8t61 28 40 52 15 78q0 48-16 82t-43 55-66 32-82 10h-101V987zm0 473h126q72 0 135-20t110-60 74-98 27-135q0-78-26-133t-73-89-109-51-133-16h-287v945h156v-343zm-671 343v-133h-373v-279h325v-133h-325V991h352V858h-509v945h530zm-751 0V858h-213l-253 626q-11 27-20 55t-19 56h-4q-6-28-16-55t-21-53l-248-629h-221v945h145v-704q0-46-5-92h3q5 24 10 47t15 47l282 702h108l283-707q8-21 14-43t11-46h3q-4 46-6 92t-3 92v612h155zm-1431-369h-289l130-377q5-14 7-29t6-30h2q3 14 5 29t8 30l131 377zm299 369l-352-945h-176l-354 945h171l82-241h372l85 241h172zm-968-65v-449H622v132h199v225q-39 20-82 28t-87 9q-78 0-136-27t-97-74-57-111-19-137q0-77 24-142t70-113 109-75 142-27q69 0 134 17t124 55V888q-63-27-130-36t-134-10q-110 0-202 36T320 981t-104 158-37 203q0 107 33 194t94 150 147 97 195 35q88 0 170-19t159-61zM0 575h7363v1473H0V575z" })
      ]
    }
  );
}
var GamePassInline_default = SvgGamePassInline;

// src/components/Icon/icons/GamePassInline2.tsx
import { jsx as jsx439, jsxs as jsxs432 } from "react/jsx-runtime";
function SvgGamePassInline2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs432(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 6848 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx439("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx439("path", { d: "M1396 1242q4 36 12 74t18 76 20 75 20 71h-148q17-64 33-127t32-127q2-11 4-21t4-21h5zM0 896h6848v1152H0V896zm932 899v-415H551v176h148v110q-14 3-29 3t-29 1q-47 0-81-15t-57-43-32-65-11-82q0-49 14-88t40-68 66-44 89-16q57 0 107 10t103 33v-203q-53-13-106-20t-109-8q-96 0-178 26t-144 78-95 129-35 179q0 99 31 171t87 121 135 71 171 23q32 0 72-4t80-12 79-20 65-28zm611 51h252l-250-772h-289l-266 772h251l37-142h231l34 142zm1280 0v-772h-343l-99 417q-7 29-11 58t-8 58h-3q-2-28-6-57t-12-57l-106-419h-348v772h204v-364q0-57-3-113t-5-113h7q5 32 11 65t14 66l119 459h219q36-148 73-294t67-296h6q-1 42-3 83t-2 84v423h229zm652 0v-182h-266v-114h233v-182h-233v-112h248v-182h-481v772h499zm1049-518q0-76-24-125t-66-77-99-40-125-12h-317v772h233v-248h71q63 0 121-16t105-49 73-84 28-121zm577 518h253l-250-772h-289l-266 772h251l37-142h231l33 142zm881-234q0-59-23-99t-59-69-77-46-77-35-59-34-24-41q0-16 8-26t22-17 28-8 28-3q51 0 99 14t93 39v-197q-54-13-105-21t-109-8q-58 0-114 13t-100 43-72 77-27 113q0 63 22 103t57 68 74 44 74 32 57 33 23 45q0 17-7 27t-20 17-26 8-27 2q-28 0-57-6t-57-17-54-25-49-31v211q53 22 109 31t113 10q60 0 120-12t108-40 78-76 30-119zm631 0q0-59-23-99t-59-69-77-46-76-35-59-34-24-41q0-16 8-26t22-17 28-8 28-3q51 0 98 14t93 39v-197q-54-13-105-21t-108-8q-58 0-114 13t-100 43-72 77-28 113q0 63 23 104t57 68 74 44 74 32 57 32 23 45q0 17-7 27t-20 17-26 8-27 2q-27 0-56-6t-58-17-55-25-48-31v211q53 22 109 31t113 10q60 0 120-11t107-40 78-76 30-120zm-1658-370q4 35 12 73t17 76 20 76 20 71h-147q8-31 19-69t21-78 20-78 13-71h5zm-785-1q48 0 78 21t30 74q0 50-26 72t-74 23h-52v-190h44z" })
      ]
    }
  );
}
var GamePassInline2_default = SvgGamePassInline2;

// src/components/Icon/icons/GamePassInline3.tsx
import { jsx as jsx440, jsxs as jsxs433 } from "react/jsx-runtime";
function SvgGamePassInline3({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs433(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 3328 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx440("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx440("path", { d: "M876 902q-22 12-51 21t-62 16-63 10-57 3q-154 0-238-72t-84-231q0-45 5-89t28-83q24-42 58-71t75-47 86-26 92-8q43 0 85 5t84 17v159q-43-19-80-26t-85-7q-78 0-121 46t-44 123q0 35 8 64t26 51 45 34 64 12h23q12 0 23-3v-87H577V575h299v327zm526 40l-27-112h-181l-28 112H968l209-607h227l196 607h-198zm-115-475h-4q-8 58-25 117t-32 116h115q-14-57-31-115t-23-118zm966 475V609q0-33 1-65t3-66h-5q-22 118-51 233t-59 231h-172q-30-117-60-231t-53-233h-5q2 45 4 89t2 89v286h-160V335h273l84 330q5 21 9 44t4 45h3q5-47 15-91l78-328h265v607h-176zm331 0V335h377v143h-195v88h184v143h-184v90h198v143h-380zm-1568 354q0 55-22 94t-58 66-82 38-95 13h-56v195H520v-607h249q52 0 97 9t79 32 52 62 19 98zm-194 6q0-42-23-58t-62-17h-34v149h41q38 0 58-17t20-57zm664 402l-27-112h-181l-29 112h-197l209-607h226l197 607h-198zm-115-475h-5q0 12-7 45t-18 70-19 71-13 47h116q-14-57-31-115t-23-118zm865 291q0 56-23 93t-61 60-85 32-95 10q-45 0-88-8t-86-25v-166q35 26 80 44t90 18q11 0 22-1t20-6 15-13 6-22q0-21-18-35t-44-26-58-25-58-35-45-53-18-81q0-52 21-89t56-60 79-34 90-11q84 0 168 23v155q-35-19-73-30t-78-12q-10 0-22 2t-22 7-16 13-7 21q0 19 18 32t47 26 60 28 60 37 46 53 19 78zm575 4q0 56-23 93t-61 60-85 32-94 9q-45 0-89-7t-86-25v-166q35 26 80 44t91 18q10 0 21-2t20-6 16-13 6-21q0-21-18-35t-45-26-58-25-58-35-45-53-18-82q0-52 21-88t57-60 79-34 89-11q44 0 85 6t83 17v155q-35-19-72-30t-78-12q-10 0-22 2t-22 6-17 13-7 22q0 19 18 32t47 25 60 28 60 37 46 54 19 78zm517 524H0V0h3328v2048zM128 1920h3072V128H128v1792z" })
      ]
    }
  );
}
var GamePassInline3_default = SvgGamePassInline3;

// src/components/Icon/icons/GamePassInline4.tsx
import { jsx as jsx441, jsxs as jsxs434 } from "react/jsx-runtime";
function SvgGamePassInline4({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs434(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 3328 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx441("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx441("path", { d: "M3143 959V784h-223v-88h207V522h-207v-87h220V260h-440v699h443zm-172 652q0-46-17-80t-44-61-64-46-74-35q-6-3-16-7t-20-8-20-10-14-10q-14-12-14-31 0-13 7-21t18-12 23-7 22-2q47 0 91 14t85 38v-190q-10-7-37-12t-58-8-59-6-42-2q-53 0-104 12t-91 40-64 70-25 103q0 56 20 93t50 62 66 40 66 29 51 28 20 37q0 13-6 21t-16 12-21 6-22 2q-56 0-105-22t-94-54v204q18 10 44 17t54 12 57 7 48 3q54 0 108-11t98-37 71-70 28-108zM2329 477q-1 25-1 49t-1 50v383h211V260h-311q-26 111-52 220t-49 221q0-15-3-32t-8-31l-94-373-1-5h-321v699h194V629q0-38-1-75t-4-75q3 17 6 33t8 34l107 413h204q29-121 60-240t56-242zm-9 1130q0-54-21-91t-52-62-68-43-68-31-53-27-21-34q0-13 7-21t18-12 23-7 22-2q21 0 45 3t48 11 45 16 39 22v-191q-19-3-37-8t-37-9q-59-10-122-10-53 0-104 12t-92 40-64 69-25 104q0 56 20 93t50 61 66 41 66 29 51 27 20 37q0 14-6 22t-16 12-21 6-22 2q-54 0-105-23t-94-54v205q97 39 204 39 54 0 108-11t98-37 71-70 27-108zm-859 214h238l-227-699h-265l-241 699h237l33-127h195l30 127zm-520-469q0-69-22-114t-60-71-90-36-114-11H368v699h219v-221h57q57 0 110-14t95-45 67-76 25-111zM143 621q0 92 24 157t72 109 116 63 158 20q24 0 62-4t77-11 75-19 55-25V531H432v170h131v86q-11 2-23 2t-23 1q-40 0-69-13t-48-38-28-56-9-69q0-85 46-135t134-50q28 0 52 2t46 7 45 12 49 20V275q-53-9-98-17t-100-9q-53 0-105 9t-98 30-86 54-67 82q-26 45-32 95t-6 102zm969-361L871 959h238l32-126h195l30 126h238l-226-699h-266zM0 2048V0h3328v2048H0zm1333-743q-15 57-29 114t-29 116h114l-30-114q-15-57-26-116zm-38-632h-115l30-114q15-57 28-116 11 59 26 116t31 114zm-675 608h-33v156h40q40 0 61-17t22-60q0-44-25-61t-65-18z" })
      ]
    }
  );
}
var GamePassInline4_default = SvgGamePassInline4;

// src/components/Icon/icons/GamePassPcGames.tsx
import { jsx as jsx442, jsxs as jsxs435 } from "react/jsx-runtime";
function SvgGamePassPcGames({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs435(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 3584 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx442("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx442("path", { d: "M0 640h3584v768H0V640zm270 461h66q37 0 70-10t58-31 39-51 14-71q0-40-14-69t-38-47-57-26-70-9H189v493h81v-179zm0-246h60q45 0 73 19t28 67q0 50-31 72t-77 22h-53V855zm668 404v-75q-27 17-58 25t-63 8q-40 0-71-13t-53-37-33-56-12-72q0-41 12-75t36-60 56-39 76-14q29 0 57 7t53 22v-81q-29-11-59-15t-60-5q-58 0-105 20t-81 55-52 83-18 106q0 54 16 99t46 77 75 51 99 18q35 0 71-6t68-23zm659-13v-234h-186v69h104v117q-20 11-42 15t-46 5q-41 0-71-14t-50-39-30-58-10-71q0-40 12-74t36-60 57-39 75-14q36 0 70 9t65 29v-84q-33-14-68-19t-71-5q-57 0-105 19t-83 54-54 83-20 105q0 56 17 101t50 78 77 51 101 18q92 0 172-42zm504 34l-183-493h-92l-185 493h90l42-125h194l45 125h89zm-155-192h-151l68-197q2-8 3-15t3-16h2q2 17 6 31l69 197zm746 192V787h-111q-39 97-79 192t-74 193h-1q-3-14-9-28t-11-29l-129-328h-115v493h75q0-61 1-122t1-122q0-43-1-85t-3-86h1q3 12 5 25t8 24l147 366h57l147-368q5-11 7-23t6-24h2q-2 24-3 48t-2 48v319h81zm392 0v-69h-195v-146h169v-69h-169V857h184v-70h-266v493h277zm58-20q9 7 26 12t35 8 37 6 32 2q34 0 67-6t59-22 43-42 17-66q0-38-17-64t-42-45-56-33-55-28-43-31-17-39q0-19 10-32t25-20 33-10 33-3q29 0 56 6t51 24v-81q-23-11-54-14t-58-3q-31 0-63 7t-59 24-43 41-17 63q0 39 17 65t42 44 56 33 55 27 43 30 17 40q0 22-9 35t-25 20-33 9-35 3q-33 0-68-11t-60-33v84z" })
      ]
    }
  );
}
var GamePassPcGames_default = SvgGamePassPcGames;

// src/components/Icon/icons/GamePassPcGamesInline.tsx
import { jsx as jsx443, jsxs as jsxs436 } from "react/jsx-runtime";
function SvgGamePassPcGamesInline({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs436(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 6872 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx443("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx443("path", { d: "M0 576h6872v1472H0V576zm518 884h126q72 0 135-20t110-60 74-98 28-135q0-78-27-133t-73-90-109-51-133-16H362v945h156v-342zm0-473h114q43 0 78 8t61 28 40 52 15 78q0 48-15 81t-44 56-65 32-82 10H518V987zm1280 776v-145q-53 33-111 48t-121 15q-77 0-137-25t-101-71-63-108-22-137q0-78 23-144t68-115 108-75 145-27q115 0 211 57V881q-54-23-112-31t-116-8q-112 0-202 38t-155 105-99 161-35 202q0 103 31 189t90 149 143 98 189 35q69 0 137-12t129-44zm1263-25v-449h-355v132h199v225q-39 20-82 28t-87 9q-79 0-137-27t-96-74-56-111-19-137q0-77 24-142t69-113 108-75 143-27q69 0 135 17t124 55V888q-63-27-130-36t-135-10q-110 0-202 37t-160 103-104 158-37 203q0 106 33 193t94 151 148 97 194 35q87 0 170-19t159-62zm968 64l-351-945h-177l-354 945h171l82-240h372l85 240h172zm-299-368h-289l130-377q5-14 8-29t5-30h3q2 14 4 29t8 30l131 377zm1432 368V857h-213l-254 627q-11 27-20 55t-19 56h-3q-7-28-16-55t-21-53l-249-630h-221v945h145v-656q0-35-1-69t-4-70h3q5 23 10 47t15 47l283 701h108l282-706q8-21 14-43t11-46h3q-4 46-6 92t-3 92v611h156zm750 0v-132h-373v-279h325v-133h-325V991h352V857h-509v945h530zm113-37q20 12 52 22t68 17 70 11 59 4q63 0 126-12t115-43 83-80 32-126q0-53-21-97t-57-79-78-63-87-49q-28-13-62-27t-65-35-50-46-21-65q0-37 19-61t48-38 62-20 64-6q55 0 108 13t99 45V875q-22-11-49-17t-57-10-57-5-53-1q-60 0-122 14t-112 45-83 80-32 120q0 74 32 124t82 85 106 62 107 53 81 57 33 78q0 41-18 66t-47 40-63 18-68 5q-27 0-61-6t-68-17-64-27-51-36v162z" })
      ]
    }
  );
}
var GamePassPcGamesInline_default = SvgGamePassPcGamesInline;

// src/components/Icon/icons/GamePassSuperscriptInline.tsx
import { jsx as jsx444, jsxs as jsxs437 } from "react/jsx-runtime";
function SvgGamePassSuperscriptInline({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs437(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 5696 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx444("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx444("path", { d: "M629 1229q-20 12-50 21t-62 16-64 10-56 4q-74 0-135-18t-105-56-68-95-25-135q0-79 27-140t75-101 112-62 140-21q43 0 85 6t84 17v159q-42-19-80-26t-84-7q-78 0-121 46t-44 123q0 34 8 63t26 51 44 34 64 13h23q12 0 23-3v-87H330V903h299v326zm564 40l-27-111H985l-29 111H759l209-606h227l196 606h-198zm-115-474h-4q-10 59-26 117t-31 116h116q-15-57-32-115t-23-118zm981 474V937q0-33 1-66t3-66h-5q-22 118-51 233t-59 231h-172q-30-117-61-231t-52-233h-6q2 45 4 89t2 89v286h-160V663h274l83 329q5 22 8 44t6 45h3q3-23 6-45t9-46l77-327h270v606h-180zm374 0V663h377v142h-195v89h184v143h-184v89h209v143h-391zm1362-406q0 63-32 111t-90 74q-41 19-82 22t-85 4h-24v195h-183V663h249q53 0 98 9t78 31 52 61 19 99zm-194 6q0-42-23-58t-62-17h-34v150h41q38 0 58-18t20-57zm691 402l-27-112h-181l-28 112h-198l209-607h227l196 607h-198zm-115-475h-4q-8 59-25 118t-32 116h116q-15-57-32-116t-23-118zm865 291q0 56-23 93t-60 60-85 32-95 10q-45 0-88-8t-86-25v-166q35 26 80 44t90 18q10 0 21-1t21-6 15-13 6-22q0-21-18-34t-45-26-58-26-58-35-45-53-18-81q0-52 21-89t56-60 79-34 90-11q44 0 85 6t83 17v155q-35-19-72-30t-78-12q-10 0-22 2t-22 6-17 13-7 22q0 19 18 32t47 26 60 27 60 37 46 54 19 78zm576 4q0 56-23 93t-61 60-85 32-95 9q-45 0-88-7t-86-25v-166q34 26 80 44t90 18q10 0 21-2t21-6 15-13 6-21q0-22-18-35t-45-26-58-25-58-35-45-54-18-81q0-52 21-88t57-60 80-34 89-11q44 0 85 6t83 17v155q-35-19-73-30t-78-12q-10 0-22 2t-22 6-17 13-7 22q0 19 18 32t47 26 60 28 61 37 46 53 19 78z" })
      ]
    }
  );
}
var GamePassSuperscriptInline_default = SvgGamePassSuperscriptInline;

// src/components/Icon/icons/GamePassUltimate.tsx
import { jsx as jsx445, jsxs as jsxs438 } from "react/jsx-runtime";
function SvgGamePassUltimate({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs438(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 3392 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx445("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx445("path", { d: "M0 640h3392v768H0V640zm568 441V787h-82v290q0 28-5 53t-17 44-33 31-53 12q-33 0-55-11t-35-32-18-46-5-56V787h-82v301q0 96 44 148t144 52q102 0 149-54t48-153zm382 199v-69H759V787h-81v493h272zm339-423v-70H924v70h142v423h81V857h142zm150 423V787h-85v493h85zm644 0V787h-111q-39 97-79 192t-74 193h-1q-3-14-8-28t-11-29l-130-328h-115v493h75q0-61 1-122t1-122q0-43-1-85t-3-86h1q3 12 5 25t8 24l148 366h56l147-368q5-11 7-23t6-24h2q-2 24-3 48t-2 48v319h81zm520 0l-183-493h-92l-185 493h89l43-125h194l44 125h90zm-156-192h-151l68-197q2-8 3-15t4-16h1q2 8 3 15t4 16l68 197zm484-231v-70h-365v70h141v423h82V857h142zm342 423v-69h-195v-146h170v-69h-170V857h184v-70h-265v493h276z" })
      ]
    }
  );
}
var GamePassUltimate_default = SvgGamePassUltimate;

// src/components/Icon/icons/GamePassUltimateInline.tsx
import { jsx as jsx446, jsxs as jsxs439 } from "react/jsx-runtime";
function SvgGamePassUltimateInline({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs439(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 6504 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx446("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx446("path", { d: "M0 575h6504v1473H0V575zm1089 845V857H932v556q0 54-9 102t-33 85-64 59-102 22q-64 0-105-22t-66-61-35-89-10-106V857H351v578q0 92 21 163t65 120 112 74 163 26q196 0 286-103t91-295zm733 383v-133h-366V857h-157v946h523zm650-813V857h-700v133h271v813h157V990h272zm287 813V857h-162v946h162zm1235 0V857h-213l-253 627q-11 27-20 55t-19 56h-4q-7-28-16-55t-21-53l-248-630h-221v946h145v-704q0-46-5-92h2q5 23 10 47t15 47l283 702h108l282-707q8-22 14-44t12-45h3q-5 46-7 92t-3 92v612h156zm997 0l-352-946h-176l-354 946h171l82-241h372l85 241h172zm-299-369h-289l130-377q5-14 8-29t5-30h2q3 14 5 29t8 30l131 377zm927-444V857h-699v133h271v813h157V990h271zm657 813v-133h-374v-279h325v-133h-325V990h353V857h-510v946h531z" })
      ]
    }
  );
}
var GamePassUltimateInline_default = SvgGamePassUltimateInline;

// src/components/Icon/icons/GamePassUltimateInline2.tsx
import { jsx as jsx447, jsxs as jsxs440 } from "react/jsx-runtime";
function SvgGamePassUltimateInline2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs440(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 6144 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx447("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx447("path", { d: "M4186 1237q8 75 29 149t40 147h-147l34-126q17-63 31-128 2-11 4-21t3-21h6zM0 896h6144v1152H0V896zm929 592v-419H694v438q0 27-4 53t-17 48-32 34-53 14q-33 0-53-14t-33-36-16-50-5-55v-432H247v424q0 84 19 151t60 113 104 72 152 25q92 0 157-24t108-70 62-115 20-157zm643 353v-182h-266v-590h-233v772h499zm708-590v-182h-669v182h217v590h233v-590h219zm326 590v-772h-233v772h233zm1089 0v-772h-343l-99 417q-7 28-11 57t-8 59h-3q-2-28-6-57t-11-57l-107-419h-348v772h204v-364q0-57-2-113t-6-113h7q28 150 67 296t77 294h219q36-148 73-294t67-296h6q-1 42-3 83t-2 84v423h229zm637 0h253l-251-772h-288l-266 772h251l37-142h230l34 142zm953-590v-182h-668v182h216v590h234v-590h218zm593 590v-182h-266v-114h233v-182h-233v-112h248v-182h-481v772h499z" })
      ]
    }
  );
}
var GamePassUltimateInline2_default = SvgGamePassUltimateInline2;

// src/components/Icon/icons/GamePassUltimateSuperscriptInline.tsx
import { jsx as jsx448, jsxs as jsxs441 } from "react/jsx-runtime";
function SvgGamePassUltimateSuperscriptInline({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs441(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 4672 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx448("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx448("path", { d: "M545 998q0 140-64 213t-208 74q-69 0-119-19t-82-56-48-90-15-119V668h184v340q0 21 3 42t13 39 26 29 42 11q25 0 41-10t26-27 13-38 4-42V668h184v330zm150 267V658h183v464h209v143H695zm761-464v464h-184V801h-169V658h525v143h-172zm309 464V658h182v607h-182zm937 0V926q0-32 1-62t3-63h-5q-24 118-52 232t-58 232h-172q-30-117-61-231t-53-233h-5q2 45 4 89t2 89v286h-160V658h274l83 330q5 22 8 44t6 45h3q2-23 5-46t9-45l78-328h270v607h-180zm730 0l-27-112h-181l-28 112h-198l209-607h227l196 607h-198zm-115-475h-4q-8 59-25 117t-32 116h116q-15-57-32-115t-23-118zm649 11v464h-183V801h-170V658h525v143h-172zm300 464V658h377v143h-195v89h184v143h-184v89h209v143h-391z" })
      ]
    }
  );
}
var GamePassUltimateSuperscriptInline_default = SvgGamePassUltimateSuperscriptInline;

// src/components/Icon/icons/GamePlay.tsx
import { jsx as jsx449, jsxs as jsxs442 } from "react/jsx-runtime";
function SvgGamePlay({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs442(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx449("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx449("path", { d: "M2048 1472l-640 448v-896l640 448zm-512 202l289-202-289-202v404zm64-1186q-53-22-110-31t-114-9q-19 0-39 10t-43 22-50 22-60 10H864q-33 0-60-10t-50-22-43-22-39-10q-57 0-114 9t-110 31v66q-18 8-39 17t-30 30l-223 605q-17 44-22 99t-6 103q0 27 7 60t24 62 40 50 57 20q5 0 7-1l305-305q19-19 48-34t61-24 64-15 59-5h157q78 0 158 2h82q40 0 83 1v127q-41-2-82-2t-82 1H958q-78 0-158-1-17 0-37 3t-42 9-39 15-31 21l-307 306q-14 14-41 22t-47 8q-62 0-109-29t-80-76-50-104-17-111q0-29 1-60t6-64 11-63 17-58l225-609q8-23 24-43t36-35v-66q44-23 85-40t84-28 88-16 95-6q33 0 60 10t50 22 43 22 39 10h320q19 0 39-10t43-22 50-22 60-10q50 0 95 5t87 17 84 28 86 40v66q20 14 36 34t24 44l224 608q11 31 17 64t11 65l-157-111-214-580q-3-10-11-17t-19-12-20-9-19-8v-66zM960 704q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45z" })
      ]
    }
  );
}
var GamePlay_default = SvgGamePlay;

// src/components/Icon/icons/GameRecommendations.tsx
import { jsx as jsx450, jsxs as jsxs443 } from "react/jsx-runtime";
function SvgGameRecommendations({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs443(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx450("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx450("path", { d: "M960 704q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45zm1069 557l-557 558-269-270 90-90 179 179 467-467 90 90zm-573 189l-30-30-31-31q-12-11-30-19t-39-14-41-9-37-3H800q-17 0-38 3t-43 9-39 15-32 23l-299 299q-17 17-43 26t-50 9q-62 0-109-29t-80-76-50-104-17-111q0-28 1-60t6-64 11-63 17-58l225-609q8-23 24-43t36-35v-66q44-23 85-40t84-28 88-16 95-6q33 0 60 10t51 22 42 22 39 10h320q19 0 39-10t43-22 50-22 60-10q50 0 95 5t87 17 84 28 86 40v66q20 14 36 34t24 44l152 412-100 100-171-466q-3-10-11-17t-19-12-20-9-19-8v-66q-54-21-110-30t-114-10q-19 0-39 10t-43 22-50 22-60 10H864q-33 0-60-10t-50-22-43-22-39-10q-57 0-113 9t-111 31v67q-9 4-19 7t-21 9-17 12-12 18l-223 605q-16 44-22 99t-6 103q0 27 7 60t24 62 40 50 57 20l307-301q21-21 50-36t61-26 64-16 62-5h448q27 0 59 5t64 14 60 25 49 34l66 66-90 90z" })
      ]
    }
  );
}
var GameRecommendations_default = SvgGameRecommendations;

// src/components/Icon/icons/GameRemove.tsx
import { jsx as jsx451, jsxs as jsxs444 } from "react/jsx-runtime";
function SvgGameRemove({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs444(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx451("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx451("path", { d: "M2048 1472v128h-640v-128h640zM960 704q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45zm288 512q27 0 59 5t64 15 60 24 49 34q13 12 25 24t25 26H800q-17 0-38 3t-43 9-39 15-32 23l-299 299q-17 17-43 26t-50 9q-62 0-109-29t-80-76-50-104-17-111q0-57 7-124t28-121l225-609q8-23 24-43t36-35v-66q44-23 85-40t84-28 88-16 95-6q33 0 60 10t50 22 43 22 39 10h320q19 0 39-10t43-22 50-22 60-10q50 0 95 5t87 17 84 28 86 40v66q20 14 36 34t24 44l224 608q16 42 22 89t10 93h-128q-2-34-7-70t-17-69l-223-605q-3-10-11-17t-19-12-20-9-19-8v-66q-54-21-110-30t-114-10q-19 0-39 10t-43 22-50 22-60 10H864q-33 0-60-10t-51-22-42-22-39-10q-57 0-113 9t-111 31v66q-18 8-39 17t-30 30l-223 605q-16 44-22 99t-6 103q0 27 7 60t24 62 40 50 57 20l307-301q21-20 49-35t61-26 65-16 62-6h448z" })
      ]
    }
  );
}
var GameRemove_default = SvgGameRemove;

// src/components/Icon/icons/GameRemove2.tsx
import { jsx as jsx452, jsxs as jsxs445 } from "react/jsx-runtime";
function SvgGameRemove2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs445(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx452("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx452("path", { d: "M960 704q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45zm640 384q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm-320 448q0 66 25 124t68 102 102 69 125 25q47 0 92-13t84-40l-443-443q-26 39-39 84t-14 92zm587 176q26-39 39-84t14-92q0-66-25-124t-69-101-102-69-124-26q-47 0-92 13t-84 40l443 443zM563 1299q21-21 50-36t61-26 64-16 62-5h303q-37 59-60 128H800q-17 0-38 3t-43 9-39 15-32 23l-299 299q-17 17-43 26t-50 9q-62 0-109-29t-80-76-50-104-17-111q0-28 1-60t6-64 11-63 17-58l225-609q8-22 24-43t36-35v-66q44-23 85-40t84-28 88-16 95-6q33 0 60 10t51 22 42 22 39 10h320q19 0 39-10t43-22 50-22 60-10q50 0 95 5t87 17 84 28 86 40v66q20 14 36 35t24 43l198 536q-39-33-83-60t-93-46l-141-384q-3-10-11-17t-19-12-20-9-19-8v-66q-53-22-110-31t-114-9q-19 0-39 10t-43 22-50 22-60 10H864q-33 0-60-10t-51-22-42-22-39-10q-57 0-114 9t-110 31v66q-18 8-39 17t-30 30l-223 605q-16 44-22 99t-6 103q0 27 7 60t24 62 40 50 57 20l307-301z" })
      ]
    }
  );
}
var GameRemove2_default = SvgGameRemove2;

// src/components/Icon/icons/GamerHistory.tsx
import { jsx as jsx453, jsxs as jsxs446 } from "react/jsx-runtime";
function SvgGamerHistory({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs446(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx453("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx453("path", { d: "M1792 640h256v1152H512v-256H256v-256H0V128h1536v256h256v256zM128 1152h1280V256H128v896zm256 256h1280V512h-128v768H384v128zm1536 256V768h-128v768H640v128h1280z" })
      ]
    }
  );
}
var GamerHistory_default = SvgGamerHistory;

// src/components/Icon/icons/GamerScore.tsx
import { jsx as jsx454, jsxs as jsxs447 } from "react/jsx-runtime";
function SvgGamerScore({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs447(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx454("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx454("path", { d: "M1024 0q141 0 272 36t245 103 207 160 160 208 103 245 37 272q0 141-36 272t-104 244-160 207-207 161-245 103-272 37q-141 0-272-36t-244-104-207-160-161-207-103-245-37-272q0-141 36-272t103-245 160-207 208-160T751 37t273-37zm367 956H984v173h192v187q-29 13-60 17t-63 4q-72 0-124-23t-87-64-52-97-17-125q0-69 20-127t60-101 95-67 127-24q71 0 140 14t132 50V572q-65-24-132-33t-137-9q-115 0-212 35T697 666 586 826t-40 213q0 115 35 204t101 150 156 93 205 32q91 0 180-17t168-64V956z" })
      ]
    }
  );
}
var GamerScore_default = SvgGamerScore;

// src/components/Icon/icons/GamerScoreInline.tsx
import { jsx as jsx455, jsxs as jsxs448 } from "react/jsx-runtime";
function SvgGamerScoreInline({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs448(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 1472 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx455("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx455("path", { d: "M736 576q102 0 196 26t175 74 149 115 115 149 74 176 27 196q0 102-26 195t-75 176-115 149-149 115-176 74-195 27q-102 0-195-26t-176-75-149-115-115-149-74-176-27-195q0-102 26-196t74-175 115-149 149-115 176-74 196-27zm264 1033v-346H708v124h137v135q-21 9-43 12t-45 3q-51 0-89-16t-63-46-37-70-13-90q0-49 15-91t43-72 69-48 91-18q51 0 100 10t95 36V987q-46-17-95-23t-98-7q-83 0-153 25t-121 73-80 114-29 153q0 83 25 147t73 108 113 67 147 23q65 0 129-12t121-46z" })
      ]
    }
  );
}
var GamerScoreInline_default = SvgGamerScoreInline;

// src/components/Icon/icons/GamerTagChange.tsx
import { jsx as jsx456, jsxs as jsxs449 } from "react/jsx-runtime";
function SvgGamerTagChange({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs449(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx456("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx456("path", { d: "M1024 1024q-53 0-99 20t-82 55-55 81-20 100h317q-19 30-33 62t-26 66H512v256h486q4 32 10 64t18 64H384V256h1280v742l-32-4q-16-2-32-2t-32 2-32 4V384H512v896h128q0-52 14-101t40-93 63-80 83-61q-34-35-53-81t-19-96q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100q0 50-19 96t-53 81q37 20 68 48t57 63q-57 28-107 68-37-47-89-73t-113-27zm0-384q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10zm890 899q6 30 6 61t-6 61l124 51-49 119-124-52q-35 51-86 86l52 124-119 49-51-124q-30 6-61 6t-61-6l-51 124-119-49 52-124q-51-35-86-86l-124 52-49-119 124-51q-6-30-6-61t6-61l-124-51 49-119 124 52q35-51 86-86l-52-124 119-49 51 124q30-6 61-6t61 6l51-124 119 49-52 124q51 35 86 86l124-52 49 119-124 51zm-314 253q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15z" })
      ]
    }
  );
}
var GamerTagChange_default = SvgGamerTagChange;

// src/components/Icon/icons/GamerTagSettings.tsx
import { jsx as jsx457, jsxs as jsxs450 } from "react/jsx-runtime";
function SvgGamerTagSettings({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs450(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx457("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx457("path", { d: "M1914 1539q6 30 6 61t-6 61l124 51-49 119-124-52q-35 51-86 86l52 124-119 49-51-124q-30 6-61 6t-61-6l-51 124-119-49 52-124q-51-35-86-86l-124 52-49-119 124-51q-6-30-6-61t6-61l-124-51 49-119 124 52q35-51 86-86l-52-124 119-49 51 124q30-6 61-6t61 6l51-124 119 49-52 124q51 35 86 86l124-52 49 119-124 51zm-314 253q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15zM512 1280h573q-19 30-33 62t-26 66H512v256h486q4 32 10 64t18 64H384V256h1280v768h-128V384H512v896z" })
      ]
    }
  );
}
var GamerTagSettings_default = SvgGamerTagSettings;

// src/components/Icon/icons/GamerTagTakePicture.tsx
import { jsx as jsx458, jsxs as jsxs451 } from "react/jsx-runtime";
function SvgGamerTagTakePicture({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs451(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx458("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx458("path", { d: "M1664 256v1536H384V256h1280zm-128 1152H512v256h1024v-256zm-512-384q-40 0-75 15t-61 41-41 61-15 75v64h384v-64q0-40-15-75t-41-61-61-41-75-15zM896 768q0 27 10 50t27 40 41 28 50 10q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50zm640-384H512v896h192v-64q0-80 37-150t104-115q-37-36-57-84t-20-99q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100q0 51-20 99t-57 84q66 45 103 115t38 150v64h192V384z" })
      ]
    }
  );
}
var GamerTagTakePicture_default = SvgGamerTagTakePicture;

// src/components/Icon/icons/GamesApp.tsx
import { jsx as jsx459, jsxs as jsxs452 } from "react/jsx-runtime";
function SvgGamesApp({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs452(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx459("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx459("path", { d: "M1928 829l-904 1113L120 829l537-573h734l537 573zm-666-61l-144-384H930L786 768h476zM779 896l245 858 245-858H779zm-93-512L327 768h343l144-384H686zM314 896l542 667-191-667H314zm878 667l542-667h-351l-191 667zm529-795l-359-384h-128l144 384h343z" })
      ]
    }
  );
}
var GamesApp_default = SvgGamesApp;

// src/components/Icon/icons/GameSolid.tsx
import { jsx as jsx460, jsxs as jsxs453 } from "react/jsx-runtime";
function SvgGameSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs453(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx460("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx460("path", { d: "M2048 1408q0 55-17 111t-50 103-80 76-109 30q-23 0-48-7t-43-25l-304-304q-12-12-30-21t-40-15-42-9-37-3H788q-15 0-34 3t-38 10-37 16-28 19l-304 304q-17 17-42 24t-49 8q-61 0-108-29t-81-76-50-103-17-112q0-63 7-124t28-121l1-1 225-609v-2q10-23 24-42t35-33v-66q45-23 86-40t84-28 86-16 96-6q33 0 59 10t50 22 44 22 39 10h320q19 0 39-10t44-22 50-22 59-10q50 0 94 5t87 17 84 28 87 40v66q20 16 36 36t25 44l224 607q21 58 28 121t7 124zm-960-704q0-26-19-45t-45-19q-26 0-45 19t-19 45q0 26 19 45t45 19q26 0 45-19t19-45z" })
      ]
    }
  );
}
var GameSolid_default = SvgGameSolid;

// src/components/Icon/icons/GameWait.tsx
import { jsx as jsx461, jsxs as jsxs454 } from "react/jsx-runtime";
function SvgGameWait({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs454(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx461("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx461("path", { d: "M960 704q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45zm640 384q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm0 768q66 0 124-25t101-68 69-102 26-125q0-66-25-124t-69-101-102-69-124-26q-66 0-124 25t-102 69-69 102-25 124q0 66 25 124t68 102 102 69 125 25zM563 1299q21-21 50-36t61-26 64-16 62-5h303q-37 59-60 128H800q-17 0-38 3t-43 9-39 15-32 23l-299 299q-17 17-43 26t-50 9q-62 0-109-29t-80-76-50-104-17-111q0-28 1-60t6-64 11-63 17-58l225-609q8-22 24-43t36-35v-66q44-23 85-40t84-28 88-16 95-6q33 0 60 10t51 22 42 22 39 10h320q19 0 39-10t43-22 50-22 60-10q50 0 95 5t87 17 84 28 86 40v66q20 14 36 35t24 43l198 536q-39-33-83-60t-93-46l-141-384q-3-10-11-17t-19-12-20-9-19-8v-66q-53-22-110-31t-114-9q-19 0-39 10t-43 22-50 22-60 10H864q-33 0-60-10t-51-22-42-22-39-10q-57 0-114 9t-110 31v66q-18 8-39 17t-30 30l-223 605q-16 44-22 99t-6 103q0 27 7 60t24 62 40 50 57 20l307-301zm1101 173h128v128h-256v-256h128v128z" })
      ]
    }
  );
}
var GameWait_default = SvgGameWait;

// src/components/Icon/icons/Gif.tsx
import { jsx as jsx462, jsxs as jsxs455 } from "react/jsx-runtime";
function SvgGif({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs455(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx462("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx462("path", { d: "M1856 128q40 0 75 15t61 41 41 61 15 75v1280q0 40-15 75t-41 61-61 41-75 15H192q-40 0-75-15t-61-41-41-61-15-75V320q0-40 15-75t41-61 61-41 75-15h1664zm64 1472V320q0-26-19-45t-45-19H192q-26 0-45 19t-19 45v1280q0 26 19 45t45 19h1664q26 0 45-19t19-45zm-626-326V646h338v89h-234v188h216v88h-216v263h-104zm-656-254v-87h236v298q-51 27-106 40t-112 13q-71 0-128-23t-99-64-63-100-22-129q0-73 25-134t69-105 106-68 134-25q45 0 89 6t87 24v108q-38-26-82-37t-90-12q-52 0-94 18t-72 50-46 75-16 95q0 48 12 90t38 74 63 50 91 18q29 0 57-5t55-20v-150H638zm396 260V653h108v627h-108z" })
      ]
    }
  );
}
var Gif_default = SvgGif;

// src/components/Icon/icons/GiftCard.tsx
import { jsx as jsx463, jsxs as jsxs456 } from "react/jsx-runtime";
function SvgGiftCard({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs456(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx463("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx463("path", { d: "M1936 256q23 0 43 9t36 24 24 35 9 44v1184q0 23-9 43t-24 36-35 24-44 9H112q-23 0-43-9t-36-24-24-35-9-44V368q0-23 9-43t24-36 35-24 44-9h1824zm-16 128H640v139q33-11 64-11 40 0 75 15t61 41 41 61 15 75q0 31-11 64h1035V384zM384 704q0 26 19 45t45 19h64v-64q0-26-19-45t-45-19q-26 0-45 19t-19 45zm320 64q26 0 45-19t19-45q0-26-19-45t-45-19q-26 0-45 19t-19 45v64h64zM128 384v384h139q-11-33-11-64 0-40 15-75t41-61 61-41 75-15q31 0 64 11V384H128zm0 1152h384V987l-147 146-90-90 146-147H128v640zm1792 0V896H731l146 147-90 90-147-146v549h1280z" })
      ]
    }
  );
}
var GiftCard_default = SvgGiftCard;

// src/components/Icon/icons/GiftCardSolid.tsx
import { jsx as jsx464, jsxs as jsxs457 } from "react/jsx-runtime";
function SvgGiftCardSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs457(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx464("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx464("path", { d: "M275 1043l90 90 147-146v677H112q-23 0-43-9t-36-24-24-35-9-44V896h421l-146 147zm237-339v64h-64q-26 0-45-19t-19-45q0-26 19-45t45-19q26 0 45 19t19 45zm192 64h-64v-64q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19zm1344-400v400H885q11-33 11-64 0-40-15-75t-41-61-61-41-75-15q-31 0-64 11V256h1296q23 0 43 9t36 24 24 35 9 44zM877 1043L731 896h1317v656q0 23-9 43t-24 36-35 24-44 9H640V987l147 146 90-90zM112 256h400v267q-33-11-64-11-40 0-75 15t-61 41-41 61-15 75q0 31 11 64H0V368q0-23 9-43t24-36 35-24 44-9z" })
      ]
    }
  );
}
var GiftCardSolid_default = SvgGiftCardSolid;

// src/components/Icon/icons/Glasses.tsx
import { jsx as jsx465, jsxs as jsxs458 } from "react/jsx-runtime";
function SvgGlasses({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs458(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx465("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx465("path", { d: "M1280 512q16 0 29 7l739 369v136q-26 0-45 19t-19 45v128q0 93-35 174t-96 142-142 96-175 36q-93 0-174-35t-142-96-96-142-36-175q0-26-19-45t-45-19q-26 0-45 19t-19 45q0 93-35 174t-96 142-142 96-175 36q-93 0-174-35t-142-96-96-142-36-175v-128q0-26-19-45t-45-19V888l739-369q13-7 29-7 26 0 45 19 10 10 24 22t28 27 22 29 9 31q0 26-19 45t-45 19q-25 0-42-16t-35-34L271 896h497q38 0 65 9t49 24 39 31 32 31 33 23 38 10q21 0 38-9t32-24 33-31 38-31 49-23 66-10h497l-484-242q-17 17-34 33t-43 17q-26 0-45-19t-19-45q0-16 9-31t22-29 27-26 25-23q19-19 45-19zm-448 640q0-26-10-49t-27-41-41-28-50-10H256q-26 0-45 19t-19 45v128q0 66 25 124t68 102 102 69 125 25q66 0 124-25t101-68 69-102 26-125v-64zm704 384q66 0 124-25t101-68 69-102 26-125q0-22-1-47t-1-50 2-49 11-46h-523q-26 0-49 10t-41 27-28 41-10 50v64q0 66 25 124t68 102 102 69 125 25z" })
      ]
    }
  );
}
var Glasses_default = SvgGlasses;

// src/components/Icon/icons/Gloves.tsx
import { jsx as jsx466, jsxs as jsxs459 } from "react/jsx-runtime";
function SvgGloves({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs459(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx466("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx466("path", { d: "M1600 256q40 0 75 15t61 41 41 61 15 75v1600H640v-390q-25-24-49-48t-49-49q-67-67-136-132t-132-137q-37-41-37-97 0-36 13-67t37-54 55-37 68-13q27 0 57 6t60 15 59 20 54 21V320q0-40 15-75t41-61 61-41 75-15q37 0 71 14 8-31 26-57t42-45 55-29 62-11q32 0 62 10t54 30 43 45 26 57q34-14 71-14 32 0 62 10t54 30 43 45 26 57q34-14 71-14zM366 1203q65 69 132 134t134 133q34 34 67 68t69 67v59h896V448q0-26-19-45t-45-19q-26 0-45 19t-19 45v448h-128V320q0-26-19-45t-45-19q-26 0-45 19t-19 45v576h-128V192q0-26-19-45t-45-19q-26 0-45 19t-19 45v704H896V320q0-26-19-45t-45-19q-26 0-45 19t-19 45v963q-19-8-47-21t-60-27-68-30-68-26-63-19-50-8q-20 0-33 11t-14 34q0 4 1 6zm1298 717v-128H768v128h896z" })
      ]
    }
  );
}
var Gloves_default = SvgGloves;

// src/components/Icon/icons/Gold.tsx
import { jsx as jsx467, jsxs as jsxs460 } from "react/jsx-runtime";
function SvgGold({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs460(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx467("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx467("path", { d: "M825 920q24 0 39 11t25 29 12 39 4 41q0 19-4 39t-14 37-25 28-39 11q-24 0-40-10t-26-28-14-38-4-41q0-21 4-42t14-38 26-27 42-11zm921 113q0 25-7 47t-20 40-34 27-47 10h-38V918h35q51 0 81 32t30 83zM0 690h2023v674H0V690zm546 544V990H323v103h86v65q-5 2-10 2t-11 0h-13q-56 0-81-34t-25-86q0-58 32-92t91-34q65 0 122 25V820q-31-8-62-12t-63-4q-56 0-104 15t-84 46-56 75-20 105q0 58 18 100t51 71 78 41 101 14q41 0 88-9t85-28zm504-198q0-51-15-93t-45-73-71-48-93-18q-53 0-95 18t-73 50-47 75-17 96q0 50 16 91t47 72 71 48 92 17q51 0 93-17t73-49 47-75 17-94zm356 227v-106h-156V811h-136v452h292zm484-231q0-117-63-169t-176-52h-187v452h191q53 0 96-16t74-46 48-73 17-96z" })
      ]
    }
  );
}
var Gold_default = SvgGold;

// src/components/Icon/icons/GoldGamePassInline2.tsx
import { jsx as jsx468, jsxs as jsxs461 } from "react/jsx-runtime";
function SvgGoldGamePassInline2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs461(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 6848 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx468("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx468("path", { d: "M4170 1280q49 0 78 22t30 74q0 50-26 72t-74 23h-52v-191h44zm785 1q8 73 30 150t39 147h-147l34-126q17-63 31-128 2-11 4-21t4-22h5zm-3559 0q8 73 30 149t40 148h-148q17-64 33-127t32-127q2-11 4-21t4-22h5zm1586-685q0 43-11 81t-34 67-57 46-81 17h-65V399h59q44 0 79 14t59 41 38 63 13 79zM1406 804q-41 0-69-18t-44-47-24-64-7-71q0-36 7-72t24-65 45-47 71-18q41 0 67 20t42 50 22 66 6 70q0 33-7 67t-23 63-44 47-66 19zM0 0h6848v2048H0V0zm1903 217v772h499V807h-266V217h-233zm-888 396q0 84 28 155t80 124 122 81 156 30q88 0 160-30t123-84 80-127 29-161q0-86-26-158t-76-126-120-83-159-30q-90 0-163 31t-125 85-80 130-29 163zm-83 1222v-416H551v176h148v110q-14 4-29 4t-29 1q-47 0-81-15t-57-44-32-65-11-82q0-49 14-88t41-68 65-44 89-16q55 0 107 10t103 34v-203q-53-13-106-21t-109-8q-96 0-178 26t-144 79-95 129-35 179q0 99 31 171t88 120 134 71 171 24q31 0 71-4t80-12 79-21 66-27zm0-896V523H551v176h148v110q-14 4-29 4t-29 1q-47 0-81-15t-57-44-32-65-11-82q0-99 54-157t155-58q57 0 107 9t103 34V233q-53-13-106-21t-109-8q-96 0-178 26t-144 79-95 129-35 179q0 99 31 171t88 120 134 71 171 24q31 0 71-4t80-12 79-21 66-27zm611 946h252l-250-772h-289l-266 772h251l37-142h231l34 142zm1280 0v-772h-343l-99 417q-7 29-11 58t-8 58h-3q-2-29-6-58t-12-56l-106-419h-348v772h204v-364q0-57-3-113t-5-113h7q5 32 11 65t14 66l119 459h219q36-148 73-294t67-296h6q-1 42-3 83t-2 84v423h229zm-322-896h327q90 0 164-27t126-79 82-125 29-165q0-100-28-171t-80-116-129-67-171-22h-320v772zm974 896v-182h-266v-113h233v-182h-233v-113h248v-182h-481v772h499zm1049-517q0-76-24-125t-66-78-99-40-125-12h-317v772h233v-248h71q62 0 121-16t104-49 74-83 28-121zm577 517h253l-250-772h-289l-266 772h251l37-142h231l33 142zm881-233q0-59-23-99t-59-69-77-47-77-35-59-33-24-42q0-16 9-26t22-17 28-8 27-3q51 0 99 14t93 39v-196q-54-14-105-22t-109-8q-58 0-114 13t-100 43-72 77-27 113q0 63 22 104t57 68 74 44 74 32 57 33 23 44q0 17-7 27t-19 17-26 8-28 2q-28 0-57-6t-57-17-54-25-49-31v212q54 21 109 31t113 10q60 0 120-12t108-40 78-76 30-119zm631 0q0-59-23-99t-59-69-77-47-76-35-59-33-24-42q0-16 8-26t22-17 28-8 28-3q51 0 98 14t93 39v-196q-54-14-105-22t-108-8q-58 0-114 13t-100 43-72 77-28 113q0 63 23 103t57 68 74 45 74 32 57 33 23 44q0 17-7 27t-19 17-26 8-28 2q-27 0-56-6t-58-17-55-25-48-31v212q53 21 109 31t113 10q60 0 120-12t107-40 78-76 30-119z" })
      ]
    }
  );
}
var GoldGamePassInline2_default = SvgGoldGamePassInline2;

// src/components/Icon/icons/GoldGamePassSuperscriptInline.tsx
import { jsx as jsx469, jsxs as jsxs462 } from "react/jsx-runtime";
function SvgGoldGamePassSuperscriptInline({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs462(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 5632 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx469("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx469("path", { d: "M626 1985q-22 12-51 21t-62 16-63 10-56 4q-74 0-135-18t-105-56-68-95-25-135q0-80 27-140t75-102 113-61 140-21q43 0 84 6t84 17v159q-42-18-80-26t-84-8q-78 0-121 46t-44 124q0 34 8 63t26 51 44 34 64 13h23q12 0 23-3v-87H327v-138h299v326zm564 40l-27-112H982l-29 112H756l209-607h227l196 607h-198zm-115-474h-4q-10 59-26 117t-31 116h115q-14-57-31-115t-23-118zm981 474v-332q0-33 1-65t3-66h-5q-23 118-52 232t-58 231h-172q-30-116-61-230t-53-233h-4q2 45 4 88t2 89v286h-161v-607h274l83 330q5 22 8 44t6 45h3l6-46q3-23 8-45l78-328h270v607h-180zm374 0v-607h377v144h-195v88h184v143h-184v89h209v143h-391zm1362-406q0 63-32 111t-90 74q-41 19-82 22t-85 4h-24v195h-183v-607h249q52 0 97 9t79 32 52 62 19 98zm-194 6q0-42-23-58t-62-17h-34v149h41q38 0 58-17t20-57zm691 402l-27-112h-181l-28 112h-198l209-607h227l197 607h-199zm-115-475h-4q-8 59-25 117t-32 116h116q-15-57-32-115t-23-118zm865 291q0 56-23 93t-61 60-85 32-94 10q-45 0-89-8t-86-25v-166q35 26 80 44t91 18q10 0 21-1t21-6 15-13 6-22q0-21-18-34t-45-26-58-26-58-35-45-53-18-81q0-52 21-89t56-60 79-34 90-11q84 0 168 23v155q-35-19-72-30t-78-12q-10 0-22 2t-22 7-17 13-7 21q0 19 18 32t47 26 60 27 60 37 46 54 19 78zm576 4q0 56-23 93t-62 60-85 32-94 9q-45 0-88-7t-86-25v-166q34 26 80 44t90 18q10 0 21-2t20-6 16-13 6-21q0-21-18-35t-45-26-58-25-58-35-45-53-18-82q0-52 21-88t57-60 80-34 89-11q44 0 85 6t83 17v155q-35-19-73-30t-78-12q-10 0-22 2t-22 6-17 13-7 22q0 18 18 31t47 26 60 28 61 37 46 54 19 78zM626 1201q-23 12-52 21t-61 15-63 10-56 4q-74 0-135-18t-105-56-68-95-25-135q0-80 27-140t75-102 113-61 140-21q43 0 84 6t84 17v159q-42-18-80-26t-84-8q-78 0-121 47t-44 123q0 34 8 63t26 51 44 34 64 13h23q12 0 23-3v-87H327V874h299v327zm766-266q0 68-22 126t-63 100-97 66-126 24q-67 0-122-23t-96-63-62-97-23-123q0-69 22-128t62-102 98-67 129-25q69 0 124 23t95 66 60 99 21 124zm-194 5q0-25-5-53t-17-53-33-39-52-16q-34 0-56 14t-35 37-19 51-6 57q0 27 5 55t19 50 34 37 55 15q31 0 52-14t34-38 18-50 6-53zm325 300V634h183v463h209v143h-392zm1091-311q0 72-22 129t-64 98-100 62-129 22h-257V634h252q75 0 134 16t101 53 63 92 22 134zm-194 2q0-69-39-111t-109-43h-47v320h51q37 0 64-13t45-36 26-53 9-64z" })
      ]
    }
  );
}
var GoldGamePassSuperscriptInline_default = SvgGoldGamePassSuperscriptInline;

// src/components/Icon/icons/GoldInline.tsx
import { jsx as jsx470, jsxs as jsxs463 } from "react/jsx-runtime";
function SvgGoldInline({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs463(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 3806 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx470("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx470("path", { d: "M2980 991h131q166 0 255 80t89 251q0 83-23 147t-69 109-110 68-148 24h-125V991zm-156 812h261q112 0 209-31t170-92 113-152 42-210q0-126-37-213t-106-143-165-79-215-25h-272v945zm-124 0v-133h-367V858h-157v945h524zM1565 979q79 0 133 29t89 79 49 113 15 133q0 71-16 134t-52 110-91 76-134 28q-74 0-128-30t-89-79-52-112-17-129q0-67 18-130t54-113 91-79 130-30zm-7 839q113 0 198-38t143-105 87-158 29-199q0-101-29-188t-86-151-139-100-188-37q-113 0-200 37t-146 103-89 158-30 201q0 103 30 190t89 151 141 100 190 36zm-581-80v-449H622v132h199v225q-39 20-82 28t-87 9q-78 0-136-27t-97-74-57-111-19-137q0-77 24-142t70-113 109-75 142-27q69 0 134 17t124 55V888q-63-27-130-36t-134-10q-110 0-202 36T320 981t-104 158-37 203q0 107 33 194t94 150 147 97 195 35q88 0 170-19t159-61zM0 575h3804v1473H0V575z" })
      ]
    }
  );
}
var GoldInline_default = SvgGoldInline;

// src/components/Icon/icons/GoldInline2.tsx
import { jsx as jsx471, jsxs as jsxs464 } from "react/jsx-runtime";
function SvgGoldInline2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs464(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 3456 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx471("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx471("path", { d: "M1409 1288q41 0 67 20t42 50 22 66 6 70q0 33-7 68t-23 63-43 47-67 18q-41 0-69-18t-44-47-24-64-7-71q0-36 7-72t24-65 45-47 71-18zm1573 194q0 43-11 81t-34 67-57 46-81 17h-65v-408h59q44 0 79 14t59 41 38 63 13 79zM0 896h3456v1152H0V896zm932 929v-416H551v176h148v111q-14 2-29 3t-29 1q-47 0-81-15t-56-44-33-65-11-81q0-99 54-157t155-59q30 0 56 2t52 7 50 14 52 20v-203q-53-13-106-21t-109-8q-96 0-178 26t-144 79-95 129-35 179q0 99 31 171t88 120 134 71 171 24q31 0 71-4t80-12 79-21 66-27zm861-338q0-85-26-158t-76-126-120-83-159-30q-90 0-163 31t-125 85-80 130-29 164q0 84 28 155t80 124 122 81 156 29q88 0 160-30t124-84 80-127 28-161zm609 388v-182h-266v-590h-233v772h499zm827-395q0-100-28-171t-80-117-128-67-172-22h-320v772h327q90 0 164-27t126-79 82-125 29-164z" })
      ]
    }
  );
}
var GoldInline2_default = SvgGoldInline2;

// src/components/Icon/icons/GoldSuperscriptInline.tsx
import { jsx as jsx472, jsxs as jsxs465 } from "react/jsx-runtime";
function SvgGoldSuperscriptInline({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs465(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2624 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx472("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx472("path", { d: "M585 1207q-22 12-51 21t-62 16-63 10-57 3q-73 0-134-18t-105-55-69-95-25-135q0-79 27-140t75-101 113-62 140-21q43 0 85 5t84 17v160q-42-20-80-27t-85-7q-79 0-121 46t-43 124q0 34 8 63t26 51 44 34 64 13h23q12 0 23-4v-86H285V880h300v327zm765-265q0 68-22 125t-62 100-97 66-126 24q-68 0-123-22t-96-63-63-97-22-124q0-70 22-128t63-102 98-67 129-24q70 0 125 23t94 65 59 99 21 125zm-193 5q0-25-5-53t-17-53-33-40-53-16q-33 0-55 14t-36 38-19 51-6 56q0 27 5 55t19 50 35 37 54 15q31 0 52-14t34-37 19-50 6-53zm325 300V640h182v464h210v143h-392zm1091-311q0 71-23 128t-64 98-99 63-129 22h-257V640h251q75 0 134 17t101 53 64 92 22 134zm-194 1q0-34-10-62t-29-48-47-32-62-12h-47v321h51q37 0 64-13t45-37 26-53 9-64z" })
      ]
    }
  );
}
var GoldSuperscriptInline_default = SvgGoldSuperscriptInline;

// src/components/Icon/icons/GotoLiveBroadcast.tsx
import { jsx as jsx473, jsxs as jsxs466 } from "react/jsx-runtime";
function SvgGotoLiveBroadcast({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs466(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx473("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx473("path", { d: "M557 339l621 621-621 621-90-90 466-467H0V896h933L467 429l90-90zm1107 237q79 0 149 30t122 82 83 123 30 149q0 80-30 149t-82 122-123 83-149 30q-80 0-149-30t-122-82-83-122-30-150q0-79 30-149t82-122 122-83 150-30zm0 640q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100q0 53 20 99t55 82 81 55 100 20z" })
      ]
    }
  );
}
var GotoLiveBroadcast_default = SvgGotoLiveBroadcast;

// src/components/Icon/icons/GpFlag.tsx
import { jsx as jsx474, jsxs as jsxs467 } from "react/jsx-runtime";
function SvgGpFlag({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs467(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx474("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx474("path", { d: "M1776 0q29 0 55 10t46 29 31 43 12 55v1911l-896-293-896 293V137q0-30 11-55t32-43 46-28 55-11h1504z" })
      ]
    }
  );
}
var GpFlag_default = SvgGpFlag;

// src/components/Icon/icons/GpFlagStar.tsx
import { jsx as jsx475, jsxs as jsxs468 } from "react/jsx-runtime";
function SvgGpFlagStar({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs468(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx475("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx475("path", { d: "M1536 766l-253 265 65 368-318-170-314 179 55-370-259-257 353-59 154-338 162 333 355 49z" })
      ]
    }
  );
}
var GpFlagStar_default = SvgGpFlagStar;

// src/components/Icon/icons/GridViewLarge.tsx
import { jsx as jsx476, jsxs as jsxs469 } from "react/jsx-runtime";
function SvgGridViewLarge({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs469(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx476("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx476("path", { d: "M128 128h1664v1664H128V128zm1536 1536V256H256v1408h1408z" })
      ]
    }
  );
}
var GridViewLarge_default = SvgGridViewLarge;

// src/components/Icon/icons/GridViewSmall.tsx
import { jsx as jsx477, jsxs as jsxs470 } from "react/jsx-runtime";
function SvgGridViewSmall({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs470(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx477("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx477("path", { d: "M128 128h1664v1664H128V128zm1536 768V256h-640v640h640zM896 256H256v640h640V256zm-640 768v640h640v-640H256zm768 640h640v-640h-640v640z" })
      ]
    }
  );
}
var GridViewSmall_default = SvgGridViewSmall;

// src/components/Icon/icons/GripperBarHorizontal.tsx
import { jsx as jsx478, jsxs as jsxs471 } from "react/jsx-runtime";
function SvgGripperBarHorizontal({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs471(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx478("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx478("path", { d: "M0 768h2048v128H0V768zm0 512v-128h2048v128H0z" })
      ]
    }
  );
}
var GripperBarHorizontal_default = SvgGripperBarHorizontal;

// src/components/Icon/icons/GripsDlSet.tsx
import { jsx as jsx479, jsxs as jsxs472 } from "react/jsx-runtime";
function SvgGripsDlSet({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs472(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx479("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx479("path", { d: "M2013 1163q20 57 27 121t8 124q0 55-17 111t-49 103-80 76-110 30q-22 0-48-8t-43-24l-304-304q-12-12-30-21t-40-15-41-9-38-3H800q-17 0-37 3t-42 9-39 15-31 21l-304 304q-16 16-42 24t-49 8q-62 0-109-29t-80-76-50-103-17-112q0-61 7-124t29-122l225-609q0-7 7-18t16-23 20-21 16-15v-66q44-23 85-40t84-28 88-16 95-6q34 0 61 10t49 22 42 22 40 10h320q19 0 39-10t42-22 50-22 61-10q50 0 95 5t87 17 84 28 86 40v66q10 7 22 19t22 26 18 30 8 30l215 582zM128 1408q0 27 7 60t23 63 40 49 58 20q0-5 9-37t26-82 36-112 43-128 44-130 40-118 31-92 18-52L345 692l-189 513q-16 44-22 100t-6 103zm1120-192q27 0 59 5t65 15 62 25 49 35l124 124-202-605 241-241-46-20v-66q-53-22-110-31t-114-9q-20 0-39 10t-42 22-50 22-61 10H864q-34 0-61-10t-49-22-43-22-39-10q-57 0-114 9t-110 31v66q-10 5-21 9t-20 9l242 243-199 596 115-115q20-20 49-35t61-25 65-15 60-5h448zm550 384q32-3 55-23t38-49 22-61 7-59q0-47-6-103t-22-100l-188-508-152 152q4 14 17 52t31 91 40 118 44 131 42 128 37 112 25 82 10 37z" })
      ]
    }
  );
}
var GripsDlSet_default = SvgGripsDlSet;

// src/components/Icon/icons/Grouped.tsx
import { jsx as jsx480, jsxs as jsxs473 } from "react/jsx-runtime";
function SvgGrouped({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs473(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx480("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx480("path", { d: "M451 835h1146v314H451V835zm58 58v198h198V893H509zm1030 198V893H765v198h774z" })
      ]
    }
  );
}
var Grouped_default = SvgGrouped;

// src/components/Icon/icons/GroupedList.tsx
import { jsx as jsx481, jsxs as jsxs474 } from "react/jsx-runtime";
function SvgGroupedList({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs474(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx481("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx481("path", { d: "M640 256h384v128H640V256zm1280 0v128h-768V256h768zM0 128h512v512H0V128zm128 384h256V256H128v256zm512 384h384v128H640V896zm512 0h768v128h-768V896zM0 768h512v512H0V768zm128 384h256V896H128v256zm512 384h384v128H640v-128zm512 0h768v128h-768v-128zM0 1408h512v512H0v-512zm128 384h256v-256H128v256z" })
      ]
    }
  );
}
var GroupedList_default = SvgGroupedList;

// src/components/Icon/icons/Guitar.tsx
import { jsx as jsx482, jsxs as jsxs475 } from "react/jsx-runtime";
function SvgGuitar({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs475(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx482("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx482("path", { d: "M1728 0q26 0 45 19l256 256q19 19 19 45t-19 45l-288 288q-19 19-45 19-29 0-48-22l-502 502h42q23 0 43 3t35 19 14 42v128q0 40-15 75t-41 61-61 41-75 15q-26 0-45 19t-19 45q0 93-35 174t-96 143-142 96-175 35q-119 0-224-45t-183-124-123-183-46-224q0-93 35-174t96-143 142-96 175-35q26 0 45-19t19-45q0-53 20-99t55-82 81-55 100-20q66 0 120 30t92 84l418-418q-22-19-22-48 0-26 19-45l288-288q19-19 45-19zm-576 1280H992q-26 0-45-19l-160-160q-19-19-19-45t19-45l99-99q-14-36-46-58t-72-22q-27 0-50 10t-40 27-28 41-10 50q0 40-15 75t-41 61-61 41-75 15q-66 0-124 25t-102 69-69 102-25 124q0 93 35 174t96 142 142 96 175 36q66 0 124-25t101-68 69-102 26-125q0-40 15-75t41-61 61-41 75-15q26 0 45-19t19-45v-64zm406-720l-70-70-566 566 70 70 566-566zm336-240l-166-166-198 198 166 166 198-198zM445 1379l224 224-90 90-224-224 90-90zm192-192l224 224-90 90-224-224 90-90z" })
      ]
    }
  );
}
var Guitar_default = SvgGuitar;

// src/components/Icon/icons/GuitarArt160.tsx
import { jsx as jsx483, jsxs as jsxs476 } from "react/jsx-runtime";
function SvgGuitarArt160({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs476(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx483("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx483("path", { d: "M1728 26q16 0 27 11l256 256q11 11 11 27t-11 27l-288 288q-11 11-27 11t-27-10-21-22l-563 564q35 0 65 12t54 35 36 53 14 66q0 37-13 66t-36 51-53 34-66 15q-36 2-62 27t-26 63q0 88-33 165t-90 134-134 90-165 33q-114 0-214-43t-175-118-118-175-43-214q0-85 31-161t91-136q63-64 135-92t161-33q38-2 65-26t29-63q2-48 19-90t48-74 71-50 92-18q65 0 121 35t85 95l460-459q-11-10-21-21t-11-27q0-16 11-27l288-288q11-11 27-11zm-550 1318q0-37-26-63t-64-27q-11 0-28 1t-36 1-35-2-24-11l-160-160q-11-11-11-27t11-27l110-110q-14-50-54-81t-93-32q-33 0-61 12t-48 33-32 49-13 61q-2 36-13 64t-38 53q-26 25-55 35t-64 13q-71 3-133 30t-109 73-73 108-27 135q0 98 37 184t102 150 151 102 184 38q72 0 135-27t110-74 74-110 27-135q0-36 12-65t34-51 52-35 65-15q38-2 65-25t28-65zm416-784l-106-106-602 602 106 106 602-602zm336-240l-202-202-234 234 202 202 234-234zM422 1408q17 0 28 11l179 179q11 11 11 28 0 16-11 27t-28 11q-16 0-27-11l-179-179q-11-11-11-27 0-17 11-28t27-11zm192-192q17 0 28 11l179 179q11 11 11 28 0 16-11 27t-27 11q-17 0-28-11l-179-179q-11-11-11-28 0-16 11-27t27-11z" })
      ]
    }
  );
}
var GuitarArt160_default = SvgGuitarArt160;

// src/components/Icon/icons/GuitarArt224.tsx
import { jsx as jsx484, jsxs as jsxs477 } from "react/jsx-runtime";
function SvgGuitarArt224({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs477(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx484("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx484("path", { d: "M1728 37q11 0 19 8l256 256q8 8 8 19t-8 19l-288 288q-8 8-19 8-13 0-26-13t-22-23l-590 590h30q32 0 60 12t50 33 33 49 12 61q0 34-12 62t-33 48-49 31-62 14q-42 2-71 30t-29 71q0 86-32 160t-88 131-131 88-160 32q-112 0-210-42t-171-116-115-171-43-210q0-87 32-162t89-130 132-87 162-32q39 0 67-28 15-15 22-33t8-39q1-46 17-86t46-70 69-47 87-17q68 0 122 37t81 100l478-478q-4-4-10-9t-12-12-10-14-4-13q0-11 8-19l288-288q8-8 19-8zm-539 1307q0-21-8-39t-22-32-32-22-39-8q-9 0-26 1t-35 1-33-2-21-8l-160-160q-8-8-8-19 0-8 16-27t37-41 41-39 28-27q-6-28-21-51t-36-40-47-26-55-10q-33 0-63 13t-54 36q-29 29-37 57t-11 57-10 57-35 57q-23 23-49 32t-58 11q-75 2-140 29t-114 75-77 112-29 141q0 100 38 188t104 155 154 104 189 38q74 0 139-28t113-76 77-114 28-139q0-64 45-109 24-25 49-34t59-12q43-3 73-29t30-72zm420-784l-121-121-617 617 121 121 617-617zm336-240l-217-217-249 249 217 217 249-249zM425 1422q12 0 20 8l178 178q7 7 7 20 0 11-7 19t-20 8q-11 0-19-8l-178-178q-8-8-8-20 0-11 8-19t19-8zm192-192q12 0 20 8l178 178q8 8 8 20 0 11-8 19t-20 8q-11 0-19-8l-178-178q-8-8-8-20 0-11 8-19t19-8z" })
      ]
    }
  );
}
var GuitarArt224_default = SvgGuitarArt224;

// src/components/Icon/icons/HairFemale.tsx
import { jsx as jsx485, jsxs as jsxs478 } from "react/jsx-runtime";
function SvgHairFemale({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs478(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx485("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx485("path", { d: "M1488 192q91 3 169 39t137 97 92 141 34 171v960q0 66-25 124t-68 102-102 69-125 25h-128q-66 0-124-25t-102-68-69-102-25-125q0-13 3-22t12-19q20-26 39-50t37-51q75-109 119-229t46-254q-50-97-81-201t-41-214q-177 100-374 150t-400 57v193q0 137 41 266t122 239q17 25 36 46t39 44q9 11 13 21t5 24q0 66-25 124t-68 102-102 69-125 25q-93 0-174-35t-143-96-96-142-35-175q0-120 15-237t53-232q34-103 47-211t13-216q0-117 43-221t126-186q82-82 186-125T704 0q207 0 403 49t381 143zm112 1600q40 0 75-15t61-41 41-61 15-75V640q0-66-25-124t-69-101-102-69-124-26q-14 0-30-7-35-17-68-33t-69-32q-144-60-295-90t-306-30q-93 0-174 35t-142 96-96 142-36 175q0 120-15 237t-53 232q-33 101-46 211t-14 216q0 66 25 124t68 102 102 69 125 25q36 0 68-12t59-35 42-54 22-67q-62-68-109-146t-80-162-49-174-17-182V704q0-26 19-45t45-19q186 0 369-38t350-123q37-19 71-40t70-44q17-11 37-11 6 0 15 1t14 6q16 11 25 24t9 33q0 132 32 248t89 234q7 14 7 30 0 93-18 181t-52 171-81 161-104 149q4 36 21 67t42 54 59 36 69 13h128z" })
      ]
    }
  );
}
var HairFemale_default = SvgHairFemale;

// src/components/Icon/icons/HairMale.tsx
import { jsx as jsx486, jsxs as jsxs479 } from "react/jsx-runtime";
function SvgHairMale({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs479(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx486("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx486("path", { d: "M1757 385q62 6 115 33t92 70 61 98 23 118q0 97-1 184t-7 172-21 170-39 180q-29 108-70 211t-92 202q-8 16-16 33t-18 31q-11 16-23 24t-33 9q-26 0-45-19t-19-45v-512q0-80-28-149t-82-127q-41-44-70-91t-49-104q-43 23-91 23H640q-53 0-99 20t-82 55-55 81-20 100v704q0 26-19 45t-45 19q-20 0-32-8t-24-25q-10-14-18-31t-16-33q-51-99-92-202t-70-211Q0 1158 0 896q0-124 32-238t90-214 140-182 181-140 214-90T896 0q124 0 242 26t228 76 208 121 183 162zm163 319q0-40-15-75t-41-61-61-41-75-15q-27 0-48-21l-63-63q-31-31-66-61-140-115-306-177t-349-62q-106 0-204 27t-183 78-156 120-120 155-77 184-28 204q0 174 32 343t96 332v-419q0-80 30-150t82-122 122-82 150-30h704q24 0 36-9t18-24 10-31 9-31 19-23 36-10q26 0 45 19t19 45q0 81 28 148t82 128q72 79 109 167t37 197v227q63-162 95-331t33-344V704z" })
      ]
    }
  );
}
var HairMale_default = SvgHairMale;

// src/components/Icon/icons/Hanger.tsx
import { jsx as jsx487, jsxs as jsxs480 } from "react/jsx-runtime";
function SvgHanger({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs480(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx487("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx487("path", { d: "M1797 1115q57 29 90 82t33 117q0 46-17 86t-48 71-70 47-87 18H222q-46 0-86-17t-71-48-47-70-18-87q0-64 33-117t90-82l640-320 57 115-640 319q-24 12-38 35t-14 50q0 20 7 37t20 29 30 20 37 8h1476q19 0 36-7t30-20 20-30 8-37q0-26-14-49t-38-36L931 825q-16-8-25-24t-10-33V576q0-24 9-36t24-18 31-10 31-9 23-19 10-36q0-26-19-45t-45-19q-26 0-45 19t-19 45H768q0-40 15-75t41-61 61-41 75-15q40 0 75 15t61 41 41 61 15 75q0 30-9 58t-26 53-40 42-53 28v99l773 387z" })
      ]
    }
  );
}
var Hanger_default = SvgHanger;

// src/components/Icon/icons/Harddrive.tsx
import { jsx as jsx488, jsxs as jsxs481 } from "react/jsx-runtime";
function SvgHarddrive({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs481(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx488("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx488("path", { d: "M1856 640q40 0 75 15t61 41 41 61 15 75v576H0V832q0-40 15-75t41-61 61-41 75-15h1664zm64 192q0-26-19-45t-45-19H192q-26 0-45 19t-19 45v448h1792V832zm-256 64h128v128h-128V896zm-256 0h128v128h-128V896z" })
      ]
    }
  );
}
var Harddrive_default = SvgHarddrive;

// src/components/Icon/icons/Hat.tsx
import { jsx as jsx489, jsxs as jsxs482 } from "react/jsx-runtime";
function SvgHat({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs482(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx489("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx489("path", { d: "M1792 1024q53 0 99 20t82 55 55 81 20 100q0 80-30 149t-82 122-123 83-149 30H384q-80 0-149-30t-122-82-83-122-30-150q0-53 20-99t55-82 81-55 100-20q55 0 98 23t79 64q4 4 7 8t8 7V832q0-38 9-66t24-49 31-38 31-32 23-33 10-38q0-40 15-75t41-61 61-41 75-15q38 0 66 9t49 24 38 31 33 31 32 23 38 10q31 0 54-20t48-44 61-44 93-20q40 0 75 15t61 41 41 61 15 75q0 21 9 38t24 32 31 33 31 38 23 49 10 66v294q5-3 8-7t7-8q35-41 78-64t99-23zM768 512q-26 0-45 19t-19 45q0 38-9 65t-24 49-31 39-31 32-23 33-10 38v384q0 26 19 45t45 19h768q26 0 45-19t19-45V832q0-21-9-38t-24-32-31-33-31-38-23-49-10-66q0-26-19-45t-45-19q-21 0-37 9t-33 24-32 31-38 31-50 23-66 10q-57 0-92-20t-61-44-49-44-54-20zm896 1024q53 0 99-20t82-55 55-81 20-100q0-27-10-50t-27-40-41-28-50-10q-27 0-47 15t-42 35-46 41-65 30q-10 30-28 55t-42 42-53 28-61 10H640q-32 0-61-10t-53-27-42-43-28-55q-39-10-64-30t-47-40-41-36-48-15q-27 0-50 10t-40 27-28 41-10 50q0 53 20 99t55 82 81 55 100 20h1280z" })
      ]
    }
  );
}
var Hat_default = SvgHat;

// src/components/Icon/icons/HdmiCable.tsx
import { jsx as jsx490, jsxs as jsxs483 } from "react/jsx-runtime";
function SvgHdmiCable({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs483(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx490("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx490("path", { d: "M1536 512h40q22 0 42 4t33 18 13 42v4q0 2-1 5l-128 896q-4 24-21 39t-42 16H704q-25 0-42-15t-21-40L513 585v-5q0-3-1-5 0-27 13-40t32-19 42-5 41 1V0h896v512zm-768 0h640V128H768v384zm758 128H650l109 768h657l110-768zm-501 896h126v512h-126v-512z" })
      ]
    }
  );
}
var HdmiCable_default = SvgHdmiCable;

// src/components/Icon/icons/HdQualityResolution.tsx
import { jsx as jsx491, jsxs as jsxs484 } from "react/jsx-runtime";
function SvgHdQualityResolution({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs484(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx491("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx491("path", { d: "M1920 384v1152H0V384h1920zm-128 128H128v896h1664V512zm-256 448q0 66-25 124t-69 102-102 69-124 25h-192V640h192q66 0 124 25t101 69 69 102 26 124zm-384 192h64q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15h-64v384zm-640 128H384V640h128v256h256V640h128v640H768v-256H512v256z" })
      ]
    }
  );
}
var HdQualityResolution_default = SvgHdQualityResolution;

// src/components/Icon/icons/HeadsetAdapter.tsx
import { jsx as jsx492, jsxs as jsxs485 } from "react/jsx-runtime";
function SvgHeadsetAdapter({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs485(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx492("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx492("path", { d: "M1883 768l165 165v182l-421 421H421L0 1115V933l165-165h347V512h128v256h128V512h512v256h128V512h128v256h347zM896 640v128h256V640H896zm1024 421v-74l-91-91H219l-91 91v74l347 347h1098l347-347z" })
      ]
    }
  );
}
var HeadsetAdapter_default = SvgHeadsetAdapter;

// src/components/Icon/icons/HeadsetChargeCritical.tsx
import { jsx as jsx493, jsxs as jsxs486 } from "react/jsx-runtime";
function SvgHeadsetChargeCritical({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs486(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx493("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx493("path", { d: "M768 128q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170v12q15-5 31-8t33-4h192v640H256v128q0 53 20 99t55 82 81 55 100 20q0-26 10-49t27-41 41-28 50-10h256q26 0 49 10t41 27 28 41 10 50v128q0 26-10 49t-27 41-41 28-50 10H640q-26 0-49-10t-41-27-28-41-10-50q-80 0-149-30t-122-82-83-122-30-150v-140q-29-10-52-28t-40-41-26-52-10-59V768q0-106 27-204t78-183 120-156 155-120 184-77T768 0q140 0 267 48t228 133 169 203 93 256h-130q-23-112-81-206t-141-162-187-106-218-38zM640 1920h256v-128H640v128zM192 896q-26 0-45 19t-19 45v256q0 26 19 45t45 19h64V896h-64z" })
      ]
    }
  );
}
var HeadsetChargeCritical_default = SvgHeadsetChargeCritical;

// src/components/Icon/icons/HeadsetChargeCriticalBattery.tsx
import { jsx as jsx494, jsxs as jsxs487 } from "react/jsx-runtime";
function SvgHeadsetChargeCriticalBattery({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs487(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx494("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx494("path", { d: "M2048 896v1152h-768V896h256V768h256v128h256zm-128 128h-512v896h512v-896z" })
      ]
    }
  );
}
var HeadsetChargeCriticalBattery_default = SvgHeadsetChargeCriticalBattery;

// src/components/Icon/icons/HeadsetChargeFull.tsx
import { jsx as jsx495, jsxs as jsxs488 } from "react/jsx-runtime";
function SvgHeadsetChargeFull({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs488(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx495("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx495("path", { d: "M1792 1792h-256v-640h256v640zM768 128q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170v12q15-5 31-8t33-4h192v640H256v128q0 53 20 99t55 82 81 55 100 20q0-26 10-49t27-41 41-28 50-10h256q26 0 49 10t41 27 28 41 10 50v128q0 26-10 49t-27 41-41 28-50 10H640q-26 0-49-10t-41-27-28-41-10-50q-80 0-149-30t-122-82-83-122-30-150v-140q-29-10-52-28t-40-41-26-52-10-59V768q0-106 27-204t78-183 120-156 155-120 184-77T768 0q140 0 267 48t228 133 169 203 93 256h-130q-23-112-81-206t-141-162-187-106-218-38zM640 1920h256v-128H640v128zM192 896q-26 0-45 19t-19 45v256q0 26 19 45t45 19h64V896h-64zm1856 0v1152h-768V896h256V768h256v128h256zm-128 128h-512v896h512v-896z" })
      ]
    }
  );
}
var HeadsetChargeFull_default = SvgHeadsetChargeFull;

// src/components/Icon/icons/HeadsetChargeLow.tsx
import { jsx as jsx496, jsxs as jsxs489 } from "react/jsx-runtime";
function SvgHeadsetChargeLow({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs489(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx496("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx496("path", { d: "M1792 1792h-256v-128h256v128zM768 128q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170v12q15-5 31-8t33-4h192v640H256v128q0 53 20 99t55 82 81 55 100 20q0-26 10-49t27-41 41-28 50-10h256q26 0 49 10t41 27 28 41 10 50v128q0 26-10 49t-27 41-41 28-50 10H640q-26 0-49-10t-41-27-28-41-10-50q-80 0-149-30t-122-82-83-122-30-150v-140q-29-10-52-28t-40-41-26-52-10-59V768q0-106 27-204t78-183 120-156 155-120 184-77T768 0q140 0 267 48t228 133 169 203 93 256h-130q-23-112-81-206t-141-162-187-106-218-38zM640 1920h256v-128H640v128zM192 896q-26 0-45 19t-19 45v256q0 26 19 45t45 19h64V896h-64zm1856 0v1152h-768V896h256V768h256v128h256zm-128 128h-512v896h512v-896z" })
      ]
    }
  );
}
var HeadsetChargeLow_default = SvgHeadsetChargeLow;

// src/components/Icon/icons/HeadsetChargeMed.tsx
import { jsx as jsx497, jsxs as jsxs490 } from "react/jsx-runtime";
function SvgHeadsetChargeMed({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs490(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx497("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx497("path", { d: "M1792 1792h-256v-384h256v384zM768 128q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170v12q15-5 31-8t33-4h192v640H256v128q0 53 20 99t55 82 81 55 100 20q0-26 10-49t27-41 41-28 50-10h256q26 0 49 10t41 27 28 41 10 50v128q0 26-10 49t-27 41-41 28-50 10H640q-26 0-49-10t-41-27-28-41-10-50q-80 0-149-30t-122-82-83-122-30-150v-140q-29-10-52-28t-40-41-26-52-10-59V768q0-106 27-204t78-183 120-156 155-120 184-77T768 0q140 0 267 48t228 133 169 203 93 256h-130q-23-112-81-206t-141-162-187-106-218-38zM640 1920h256v-128H640v128zM192 896q-26 0-45 19t-19 45v256q0 26 19 45t45 19h64V896h-64zm1856 0v1152h-768V896h256V768h256v128h256zm-128 128h-512v896h512v-896z" })
      ]
    }
  );
}
var HeadsetChargeMed_default = SvgHeadsetChargeMed;

// src/components/Icon/icons/HeadsetCharging.tsx
import { jsx as jsx498, jsxs as jsxs491 } from "react/jsx-runtime";
function SvgHeadsetCharging({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs491(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx498("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx498("path", { d: "M768 0q125 0 239 38t208 106 165 162 111 206h-137q-37-85-96-155t-136-122-166-79-188-28q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170v12q15-5 31-8t33-4h192v640H256v128q0 53 20 99t55 82 81 55 100 20q0-26 10-49t27-41 41-28 50-10h256q27 0 50 10t40 27 28 41 10 50v128q0 26-10 49t-27 41-41 28-50 10H640q-26 0-49-10t-41-27-28-41-10-50q-80 0-149-30t-122-82-83-122-30-150v-140q-56-20-92-68T0 1216V768q0-106 27-204t78-183 120-156 155-120 184-77T768 0zM640 1920h256v-128H640v128zM192 896q-26 0-45 19t-19 45v256q0 26 19 45t45 19h64V896h-64zm1856 0v320q0 58-19 110t-54 93-81 71-102 40v518h-128v-518q-55-11-101-40t-81-70-54-94-20-110V896h128V640h128v256h128V640h128v256h128zm-128 128h-384v192q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75v-192z" })
      ]
    }
  );
}
var HeadsetCharging_default = SvgHeadsetCharging;

// src/components/Icon/icons/HeadsetController.tsx
import { jsx as jsx499, jsxs as jsxs492 } from "react/jsx-runtime";
function SvgHeadsetController({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs492(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx499("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx499("path", { d: "M1280 272q20 0 34 14t14 34q0 20-14 34t-34 14q-20 0-34-14t-14-34q0-20 14-34t34-14zm448-163q15 15 33 48t37 75 37 90 34 92 25 81 15 58q5 28 8 55t3 57q0 39-8 76t-31 70q-11 16-26 31t-33 28-38 19-40 7q-23 0-42-9t-36-26l-207-208q-7-7-16-10t-19-3h-144q63 83 95 181t33 203v320q0 40-15 75t-41 61-61 41-75 15h-192v-512h192q31 0 64 11 0-114-41-213t-126-177q-6 3-22 18t-38 36-47 47-48 49-40 41-25 25q-16 16-35 25t-42 10q-20 0-40-7t-38-20-33-27-26-31q-22-33-30-71t-9-77q0-35 5-69t12-70q-87 20-161 66T369 703t-83 149-30 172v11q33-11 64-11h192v512H384v128q0 26 10 49t27 41 41 28 50 10q0-26 10-49t27-41 41-28 50-10h256q27 0 50 10t40 27 28 41 10 50v128q0 27-10 50t-27 40-41 28-50 10H640q-26 0-49-10t-41-27-28-41-10-50q-53 0-99-20t-82-55-55-81-20-100v-139q-29-10-52-28t-41-42-26-52-9-59v-320q0-123 43-233t121-195 182-140 227-69q9-23 24-63t33-82 37-79 37-54V66q54-32 117-49t126-17q24 0 43 6t37 16 35 21 39 21h102q20-10 38-21t36-21 37-16 43-6q62 0 126 16t117 50v43zM640 1920h256v-128H640v128zm-384-576q0 26 19 45t45 19h64v-256h-64q-26 0-45 19t-19 45v128zm960 64q26 0 45-19t19-45v-130q0-26-19-44t-45-18h-64v256h64zm534-645q13-7 21-18t13-24 6-28 2-28q0-23-2-45t-7-44q-6-34-22-84t-36-103-42-101-38-80q-5-9-20-16t-24-12l-1-33q-29-8-57-13t-58-6h-3q-4 0-21 10t-38 22-41 22-31 10h-68q-27 0-47 1t-34-4-31-10-37-19-53-32h-11q-28 0-56 5t-54 15v32q-11 5-25 12t-21 17q-8 11-13 26t-11 27q-33 75-65 154t-48 160q-4 22-6 44t-3 45q0 13 1 27t6 28 13 25 22 18l201-200q25-25 57-38t68-13h288q34 0 67 13t58 37l201 201z" })
      ]
    }
  );
}
var HeadsetController_default = SvgHeadsetController;

// src/components/Icon/icons/Heart.tsx
import { jsx as jsx500, jsxs as jsxs493 } from "react/jsx-runtime";
function SvgHeart({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs493(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx500("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx500("path", { d: "M1504 128q113 0 212 42t173 117 116 173 43 212q0 109-41 208t-118 177l-865 864-865-864Q82 980 41 881T0 672q0-113 42-212t117-173 173-116 212-43q109 0 208 41t177 118q24 24 47 48t48 48q24-24 47-48t48-48q77-77 176-118t209-41zm294 838q59-59 90-135t31-159q0-87-32-162t-88-131-132-87-163-32q-82 0-158 30t-136 88l-186 186-186-186q-60-60-134-91t-160-31q-86 0-162 32t-132 89-89 133-33 162q0 83 31 159t91 135l774 774 774-774z" })
      ]
    }
  );
}
var Heart_default = SvgHeart;

// src/components/Icon/icons/HeartAdd.tsx
import { jsx as jsx501, jsxs as jsxs494 } from "react/jsx-runtime";
function SvgHeartAdd({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs494(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx501("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx501("path", { d: "M1024 564q-35-35-69-71t-69-71-72-64-79-53-89-36-102-13q-87 0-162 32t-132 89-89 132-33 163q0 84 31 159t91 135l774 774v181l-865-864Q82 981 41 881T0 672q0-75 19-144t55-130 85-110 110-85 130-55 145-20q84 0 149 19t119 52 105 81 107 103q56-56 106-103t105-80 120-53 149-19q112 0 211 43t173 116 117 173 43 212q0 109-41 208t-118 177l-97 97V972q62-61 94-136t33-164q0-88-32-163t-88-130-132-87-163-32q-85 0-150 27t-121 71-105 98-104 108zm640 588v384h384v128h-384v384h-128v-384h-384v-128h384v-384h128z" })
      ]
    }
  );
}
var HeartAdd_default = SvgHeartAdd;

// src/components/Icon/icons/HeartAddSolid.tsx
import { jsx as jsx502, jsxs as jsxs495 } from "react/jsx-runtime";
function SvgHeartAddSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs495(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx502("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx502("path", { d: "M2048 672q0 98-25 171t-69 134-102 117-123 122h-321v256h-256v320l-128 128-865-863q-38-37-67-82t-50-94-31-103T0 672q0-75 19-144t55-130 85-110 110-85 130-55 145-20q84 0 149 19t119 52 105 81 107 103q51-53 101-99t106-81 120-55 143-20q114 0 215 41t176 115 119 172 44 216zm-384 672v256h256v128h-256v256h-128v-256h-256v-128h256v-256h128z" })
      ]
    }
  );
}
var HeartAddSolid_default = SvgHeartAddSolid;

// src/components/Icon/icons/HeartBroken.tsx
import { jsx as jsx503, jsxs as jsxs496 } from "react/jsx-runtime";
function SvgHeartBroken({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs496(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx503("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx503("path", { d: "M1504 127q113 0 212 42t173 116 116 173 43 213q0 109-41 208t-118 176l-865 865-865-865Q82 978 41 879T0 671q0-113 42-212t117-173 173-116 212-43q110 0 208 40t177 119l95 95 95-95q78-78 176-118t209-41zm294 838q59-59 90-135t31-159q0-87-32-162t-89-132-131-89-163-33q-81 0-159 31t-135 90q-64 66-127 131T955 639l384 384-302 301-90-90 211-211-384-384 163-164q-2-1-16-15t-32-31-32-33-19-20q-59-59-135-90t-159-31q-87 0-162 32t-132 89-89 132-33 163q0 83 31 159t91 135l774 774 774-774z" })
      ]
    }
  );
}
var HeartBroken_default = SvgHeartBroken;

// src/components/Icon/icons/HeartFull.tsx
import { jsx as jsx504, jsxs as jsxs497 } from "react/jsx-runtime";
function SvgHeartFull({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs497(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx504("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx504("path", { d: "M1504 128q113 0 212 42t173 117 116 173 43 212q0 109-41 208t-118 177l-865 864-865-864Q82 980 41 881T0 672q0-113 42-212t117-173 173-116 212-43q109 0 208 41t177 118q24 24 47 48t48 48q24-24 47-48t48-48q77-77 176-118t209-41z" })
      ]
    }
  );
}
var HeartFull_default = SvgHeartFull;

// src/components/Icon/icons/HeartRemove.tsx
import { jsx as jsx505, jsxs as jsxs498 } from "react/jsx-runtime";
function SvgHeartRemove({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs498(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx505("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx505("path", { d: "M1504 260q-85 0-150 27t-121 71-105 98-104 108q-35-35-69-71t-69-71-72-64-79-53-89-36-102-13q-87 0-162 32t-132 89-89 132-33 163q0 84 31 159t91 135l859 859-91 90-859-858Q82 981 41 881T0 672q0-75 19-144t55-130 85-110 110-85 130-55 145-20q84 0 149 19t119 52 105 81 107 103q56-56 106-103t105-80 120-53 149-19q112 0 211 43t173 116 117 173 43 212q0 109-41 208t-118 177l-98 98h-182l189-189q59-59 90-134t31-160q0-88-32-163t-88-130-132-87-163-32zm450 1023l91 91-291 290 291 291-91 91-290-291-291 291-91-91 291-291-291-290 91-91 291 291 290-291z" })
      ]
    }
  );
}
var HeartRemove_default = SvgHeartRemove;

// src/components/Icon/icons/HeartRemoveSolid.tsx
import { jsx as jsx506, jsxs as jsxs499 } from "react/jsx-runtime";
function SvgHeartRemoveSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs499(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx506("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx506("path", { d: "M1790 1338l91 90-181 181 181 181-91 91-181-181-181 181-90-91 181-181-181-181 90-90 181 181 181-181zm258-666q0 109-40 208t-119 177l-281 280-184-185-272 272 185 184-313 312-865-863q-38-37-67-82t-50-94-31-103T0 672q0-75 19-144t55-130 85-110 110-85 130-55 145-20q84 0 149 19t119 52 105 81 107 103q51-53 101-99t106-81 120-55 143-20q114 0 215 41t176 115 119 172 44 216z" })
      ]
    }
  );
}
var HeartRemoveSolid_default = SvgHeartRemoveSolid;

// src/components/Icon/icons/HeartWishlist.tsx
import { jsx as jsx507, jsxs as jsxs500 } from "react/jsx-runtime";
function SvgHeartWishlist({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs500(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx507("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx507("path", { d: "M1024 564q-53-53-103-107t-107-99-121-73-149-29q-87 0-162 32t-132 89-89 132-33 163q0 85 31 159t91 135l774 773v181l-865-863q-38-37-67-82t-50-94-31-103T0 672q0-75 19-144t55-130 85-110 110-85 130-55 145-20q84 0 149 19t119 52 105 81 107 103q51-53 101-99t106-81 120-55 143-20q114 0 215 41t176 115 119 172 44 216q0 109-40 208t-119 177l-224 223h-513v-128h459l187-186q59-58 90-134t31-160q0-87-32-162t-88-131-132-87-163-32q-83 0-148 27t-122 70-107 98-103 109zm128 1356v-128h768v128h-768zm0-320v-128h896v128h-896z" })
      ]
    }
  );
}
var HeartWishlist_default = SvgHeartWishlist;

// src/components/Icon/icons/HeartWishlistMirrored.tsx
import { jsx as jsx508, jsxs as jsxs501 } from "react/jsx-runtime";
function SvgHeartWishlistMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs501(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx508("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx508("path", { d: "M1280 1920v-128h768v128h-768zm513-768h255v128h-565l128-128 187-186q59-58 90-134t31-160q0-87-32-162t-88-131-132-87-163-32q-83 0-148 27t-122 70-107 98-103 109q-53-53-103-107t-107-99-121-73-149-29q-87 0-162 32t-132 89-89 132-33 163q0 85 31 159t91 135l774 773v181l-865-863q-38-37-67-82t-50-94-31-103T0 672q0-75 19-144t55-130 85-110 110-85 130-55 145-20q84 0 149 19t119 52 105 81 107 103q51-53 101-99t106-81 120-55 143-20q114 0 215 41t176 115 119 172 44 216q0 109-40 208t-119 177l-96 95zm-641 448v-128h896v128h-896z" })
      ]
    }
  );
}
var HeartWishlistMirrored_default = SvgHeartWishlistMirrored;

// src/components/Icon/icons/HeartWishlistMirroredSolid.tsx
import { jsx as jsx509, jsxs as jsxs502 } from "react/jsx-runtime";
function SvgHeartWishlistMirroredSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs502(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx509("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx509("path", { d: "M1729 1216h-705v704l-865-863q-38-37-67-82t-50-94-31-103T0 672q0-75 19-144t55-130 85-110 110-85 130-55 145-20q84 0 149 19t119 52 105 81 107 103q51-53 101-99t106-81 120-55 143-20q114 0 215 41t176 115 119 172 44 216q0 98-25 171t-69 134-102 117-123 122zm-449 640v-128h768v128h-768zm-128-320v-128h896v128h-896z" })
      ]
    }
  );
}
var HeartWishlistMirroredSolid_default = SvgHeartWishlistMirroredSolid;

// src/components/Icon/icons/HeartWishlistSolid.tsx
import { jsx as jsx510, jsxs as jsxs503 } from "react/jsx-runtime";
function SvgHeartWishlistSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs503(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx510("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx510("path", { d: "M1729 1216h-705v704l-865-863q-38-37-67-82t-50-94-31-103T0 672q0-75 19-144t55-130 85-110 110-85 130-55 145-20q84 0 149 19t119 52 105 81 107 103q51-53 101-99t106-81 120-55 143-20q114 0 215 41t176 115 119 172 44 216q0 98-25 171t-69 134-102 117-123 122zm-577 320v-128h896v128h-896zm0 320v-128h768v128h-768z" })
      ]
    }
  );
}
var HeartWishlistSolid_default = SvgHeartWishlistSolid;

// src/components/Icon/icons/HeightBottomRange.tsx
import { jsx as jsx511, jsxs as jsxs504 } from "react/jsx-runtime";
function SvgHeightBottomRange({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs504(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx511("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx511("path", { d: "M1024 1196q0 30-9 61t-25 58-41 49-53 32v652H256v-652q-58-22-93-69t-35-111V768q0-44 16-83t43-72 63-56 77-36q-34-43-52-94t-19-107q0-66 25-124t68-101 102-69T576 0q66 0 124 25t101 69 69 102 26 124q0 55-18 106t-53 95q41 13 77 36t64 56 42 71 16 84v428zM576 128q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15zm320 640q0-23-12-46t-30-41-42-29-47-12H384q-22 0-45 11t-41 30-30 42-12 45v448q0 27 13 40t32 19 42 6 41-1v640h128v-512h128v512h128v-640h64q15 0 27-8t20-20 12-28 5-28V768zm1024 1152v128h-896v-128h896zm-448-137l-320-320 86-87 170 170v-522h128v522l170-170 86 87-320 320z" })
      ]
    }
  );
}
var HeightBottomRange_default = SvgHeightBottomRange;

// src/components/Icon/icons/HeightTopRange.tsx
import { jsx as jsx512, jsxs as jsxs505 } from "react/jsx-runtime";
function SvgHeightTopRange({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs505(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx512("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx512("path", { d: "M825 521q41 13 77 36t64 56 42 71 16 84v428q0 30-9 61t-25 58-41 49-53 32v652H256v-652q-58-22-93-69t-35-111V768q0-44 16-83t43-72 63-56 77-36q-34-43-52-94t-19-107q0-66 25-124t68-101 102-69T576 0q66 0 124 25t101 69 69 102 26 124q0 55-18 106t-53 95zM576 128q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15zm320 640q0-23-12-46t-30-41-42-29-47-12H384q-22 0-45 11t-41 30-30 42-12 45v448q0 27 13 40t32 19 42 6 41-1v640h128v-512h128v512h128v-640h64q15 0 27-8t20-20 12-28 5-28V768zM1792 0v128h-640V0h640zm-320 265l320 320-86 87-170-170v522h-128V502l-170 170-86-87 320-320z" })
      ]
    }
  );
}
var HeightTopRange_default = SvgHeightTopRange;

// src/components/Icon/icons/Helmet.tsx
import { jsx as jsx513, jsxs as jsxs506 } from "react/jsx-runtime";
function SvgHelmet({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs506(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx513("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx513("path", { d: "M1416 1024q11 42 35 77t57 61 72 40 84 14h40l216 433v143q0 27-10 50t-27 40-41 28-50 10h-640v-64q0-66-25-124t-69-101-102-69-124-26H731l-258 257-45-45q-146-146-223-331t-77-393q0-141 36-272t104-244 160-207 207-161T880 37t272-37q207 0 392 77t332 223l45 45-269 270 140 196v213h-376zm-760 405q-71-87-107-190t-37-215q0-133 50-249t137-204 203-137 250-50q112 0 215 36t190 108l182-181q-123-106-273-162t-314-57q-124 0-238 32t-214 90-181 140-140 181-91 213-32 239q0 163 56 314t163 274l181-182zm1136 250l-169-337q-74-7-136-40t-109-85-72-117-26-140v-64h384v-43l-104-146h-1l-45-45q-74-72-166-111t-196-39q-106 0-199 40T790 661 680 824t-40 200q0 118 45 210t127 174h20q84 0 159 29t135 80 98 121 51 154h517v-113z" })
      ]
    }
  );
}
var Helmet_default = SvgHelmet;

// src/components/Icon/icons/HeroStats.tsx
import { jsx as jsx514, jsxs as jsxs507 } from "react/jsx-runtime";
function SvgHeroStats({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs507(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx514("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx514("path", { d: "M384 1664h291l-128 128H256V577q-40 0-74-15t-61-41-41-62-15-74q0-40 15-75t41-61 61-41 75-15q40 0 75 15t61 41 41 61 15 75q0 56-29 103t-81 71l362 479 261-472q-29-10-52-28t-41-42-26-52-10-59q0-40 15-75t41-61 61-41 75-15q40 0 75 15t61 41 41 61 15 75q0 30-9 58t-25 51-40 42-52 29l263 474 355-481q-50-24-79-71t-29-102q0-40 15-75t41-61 61-41 75-15q40 0 75 15t61 41 41 61 15 75q0 40-15 75t-42 61-61 41-75 15v447h-128V835l-325 440-312-562-309 559-334-441v833zM1729 385q0 25 17 43t43 21l3-4v4h1q26 0 45-19t19-45q0-26-19-45t-45-19q-26 0-45 19t-19 45zm-704-64q-26 0-45 19t-19 45q0 26 19 45t45 19q26 0 45-19t19-45q0-26-19-45t-45-19zm-832 64q0 26 19 45t45 19q26 0 45-19t19-45q0-26-19-45t-45-19q-26 0-45 19t-19 45zm1855 767v512h-128v-293l-448 447-256-256-467 467-90-90 557-557 256 256 357-358h-293v-128h512z" })
      ]
    }
  );
}
var HeroStats_default = SvgHeroStats;

// src/components/Icon/icons/HighContrast.tsx
import { jsx as jsx515, jsxs as jsxs508 } from "react/jsx-runtime";
function SvgHighContrast({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs508(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx515("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx515("path", { d: "M0 0h2048v2048H0V0zm128 1920L1920 128H128v1792z" })
      ]
    }
  );
}
var HighContrast_default = SvgHighContrast;

// src/components/Icon/icons/HoloLens.tsx
import { jsx as jsx516, jsxs as jsxs509 } from "react/jsx-runtime";
function SvgHoloLens({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs509(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx516("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx516("path", { d: "M960 768q-26 0-45-19t-19-45q0-26 19-45t45-19h128q26 0 45 19t19 45q0 26-19 45t-45 19H960zm1034-219q26 26 40 61t14 72v257q0 124-47 232t-128 190-189 128-233 47h-81q-37 0-68-14t-60-34-55-45-53-44-53-35-57-14q-30 0-57 14t-53 34-52 45-55 44-60 35-69 14h-81q-124 0-232-47t-190-128-128-189T0 939V682q0-37 14-72t40-61h1q36-36 80-55 54-24 124-41t150-30 164-20 164-12 154-5 133-2q58 0 132 1t154 6 165 12 163 20 150 29 125 42q44 19 80 55h1zM128 851q150 52 306 78t314 27q296 0 575-89t521-262q-84-31-189-49t-217-28-218-13-196-3q-54 0-123 1t-145 5-157 11-155 18-143 27-118 39q-22 10-38 26t-17 43v169zm1792-143q-128 92-268 162t-288 119-304 73-312 25q-158 0-312-25t-305-73q9 89 49 166t103 133 143 88 171 32h81q19 0 40-14t46-34 51-45 60-44 69-35 80-14q43 0 80 14t69 34 59 45 52 44 45 35 41 14h81q97 0 182-37t149-100 101-149 37-183V708z" })
      ]
    }
  );
}
var HoloLens_default = SvgHoloLens;

// src/components/Icon/icons/Home.tsx
import { jsx as jsx517, jsxs as jsxs510 } from "react/jsx-runtime";
function SvgHome({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs510(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx517("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx517("path", { d: "M1024 166l941 941-90 90-83-82v805h-640v-640H896v640H256v-805l-83 82-90-90 941-941zm640 1626V987l-640-640-640 640v805h384v-640h512v640h384z" })
      ]
    }
  );
}
var Home_default = SvgHome;

// src/components/Icon/icons/HomeFill.tsx
import { jsx as jsx518, jsxs as jsxs511 } from "react/jsx-runtime";
function SvgHomeFill({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs511(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx518("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx518("path", { d: "M1024 165l941 942-90 90-83-82v805h-512v-640H768v640H256v-805l-83 82-90-90 941-942z" })
      ]
    }
  );
}
var HomeFill_default = SvgHomeFill;

// src/components/Icon/icons/Icon4K.tsx
import { jsx as jsx519, jsxs as jsxs512 } from "react/jsx-runtime";
function SvgIcon4K({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs512(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx519("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx519("path", { d: "M0 384h1920v1152H0V384zm1792 1024V512H128v896h1664zM640 1280v-128H384v-123l248-389h136v384h128v128H768v128H640zm-101-256h101V866l-101 158zm613-21v277h-128V640h128v275l206-275h132l-237 317 283 309v14h-130l-254-277z" })
      ]
    }
  );
}
var Icon4K_default = SvgIcon4K;

// src/components/Icon/icons/Import.tsx
import { jsx as jsx520, jsxs as jsxs513 } from "react/jsx-runtime";
function SvgImport({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs513(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx520("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx520("path", { d: "M249 898h1543v128H252l305 305-90 90L6 960l461-461 90 90-308 309zm1799-386v896h-128V512h128z" })
      ]
    }
  );
}
var Import_default = SvgImport;

// src/components/Icon/icons/ImportAll.tsx
import { jsx as jsx521, jsxs as jsxs514 } from "react/jsx-runtime";
function SvgImportAll({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs514(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx521("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx521("path", { d: "M1024 1024l-772 1 289 290-90 90L6 960l445-445 90 90-292 292 775-1v128zm1024-512v896h-896V512h896zm-128 128h-256v256h256V640zm-640 0v256h256V640h-256zm0 640h256v-256h-256v256zm640 0v-256h-256v256h256z" })
      ]
    }
  );
}
var ImportAll_default = SvgImportAll;

// src/components/Icon/icons/ImportAllMirrored.tsx
import { jsx as jsx522, jsxs as jsxs515 } from "react/jsx-runtime";
function SvgImportAllMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs515(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx522("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx522("path", { d: "M1030 1024l772 1-289 290 90 90 445-445-445-445-90 90 292 292-775-1v128zM6 512v896h896V512H6zm128 128h256v256H134V640zm640 0v256H518V640h256zm0 640H518v-256h256v256zm-640 0v-256h256v256H134z" })
      ]
    }
  );
}
var ImportAllMirrored_default = SvgImportAllMirrored;

// src/components/Icon/icons/ImportMirrored.tsx
import { jsx as jsx523, jsxs as jsxs516 } from "react/jsx-runtime";
function SvgImportMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs516(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx523("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx523("path", { d: "M1805 898H262v128h1540l-305 305 90 90 461-461-461-461-90 90 308 309zM6 512v896h128V512H6z" })
      ]
    }
  );
}
var ImportMirrored_default = SvgImportMirrored;

// src/components/Icon/icons/IncidentTriangle.tsx
import { jsx as jsx524, jsxs as jsxs517 } from "react/jsx-runtime";
function SvgIncidentTriangle({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs517(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx524("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx524("path", { d: "M1920 2048H0L960 128l960 1920zm-896-384H896v128h128v-128zm0-128V896H896v640h128z" })
      ]
    }
  );
}
var IncidentTriangle_default = SvgIncidentTriangle;

// src/components/Icon/icons/Info.tsx
import { jsx as jsx525, jsxs as jsxs518 } from "react/jsx-runtime";
function SvgInfo({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs518(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx525("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx525("path", { d: "M1022 443q-33 0-61-11t-50-30-34-47-13-62q0-33 12-61t34-48 50-32 62-11q33 0 62 11t52 31 35 48 13 62q0 33-13 61t-36 47-52 31-61 11zM896 640h256v1280H896V640z" })
      ]
    }
  );
}
var Info_default = SvgInfo;

// src/components/Icon/icons/Info16.tsx
import { jsx as jsx526, jsxs as jsxs519 } from "react/jsx-runtime";
function SvgInfo16({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs519(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx526("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx526("path", { d: "M960 0q133 0 255 34t230 96 194 150 150 195 97 229 34 256q0 133-34 255t-96 230-150 194-195 150-229 97-256 34q-133 0-255-34t-230-96-194-150-150-195-97-229T0 960q0-133 34-255t96-230 150-194 195-150 229-97T960 0zm0 1792q115 0 221-30t198-84 169-130 130-168 84-199 30-221q0-115-30-221t-84-198-130-169-168-130-199-84-221-30q-115 0-221 30t-198 84-169 130-130 168-84 199-30 221q0 115 30 221t84 198 130 169 168 130 199 84 221 30zM896 768h128v640H896V768zm0-256h128v128H896V512z" })
      ]
    }
  );
}
var Info16_default = SvgInfo16;

// src/components/Icon/icons/Infrastructure.tsx
import { jsx as jsx527, jsxs as jsxs520 } from "react/jsx-runtime";
function SvgInfrastructure({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs520(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx527("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx527("path", { d: "M1280 640q0 88-23 170t-64 153-100 129-130 100-153 65-170 23q-133 0-249-50t-204-137T50 890 0 640q0-88 23-170t64-153 100-129T317 88t153-65T640 0q88 0 170 23t153 64 129 100 100 130 65 153 23 170zm-1152 0q0 106 40 199t110 162 163 110 199 41q106 0 199-40t162-110 110-163 41-199q0-106-40-199t-110-162-163-110-199-41q-106 0-199 40T279 278 169 441t-41 199zm1600 768q66 0 124 25t101 69 69 102 26 124q0 66-25 124t-69 102-102 69-124 25q-66 0-124-25t-102-68-69-102-25-125q0-66 25-124t68-101 102-69 125-26zm0 512q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15zm-64-1344q0 150-39 289t-110 260-170 220-221 170-260 110-289 39v-128q132 0 255-34t229-96 195-150 150-195 97-229 35-256h128z" })
      ]
    }
  );
}
var Infrastructure_default = SvgInfrastructure;

// src/components/Icon/icons/InstagramLogo.tsx
import { jsx as jsx528, jsxs as jsxs521 } from "react/jsx-runtime";
function SvgInstagramLogo({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs521(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx528("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx528("path", { d: "M2048 1024v94q0 83-1 164t-5 164q-3 62-12 120t-29 112-49 103-76 95q-45 45-94 75t-104 50-112 28-120 13q-82 5-163 5t-165 1H766q-81 0-164-6-62-3-120-12t-112-29-103-49-95-76q-45-45-75-94t-50-104-28-112-13-120q-5-82-5-163t-1-165V766q0-81 6-164 3-62 12-120t29-112 49-103 76-95q45-45 94-75t104-50 112-28T602 6q82-5 163-5t165-1h188q83 0 164 1t164 5q62 3 120 12t112 29 103 49 95 76q45 45 75 94t50 104 28 112 13 120q5 82 5 163t1 165v94zm-185 0v-89q0-50 1-107 0-55-1-113t-6-112-13-101-22-82q-14-36-31-63t-45-55q-28-28-55-45t-63-31q-35-13-82-21t-101-13-112-6-113-2h-107q-50 0-89 1h-89q-50 0-108-1-55 0-112 1t-112 6-101 13-82 22q-36 14-63 31t-55 45q-28 28-45 55t-31 63q-14 35-22 82t-13 101-6 112-2 113q0 57 1 107t1 89q0 39-1 89t-1 108q0 55 1 112t6 112 13 101 23 82q14 36 31 63t45 55q28 28 55 45t63 31q35 14 82 22t101 13 111 6 113 2q57 0 107-1t90-1q39 0 89 1t107 1q55 0 113-1t112-6 101-13 82-23q36-14 63-31t55-45q28-28 45-55t31-63q13-35 21-82t13-101 6-111 2-113v-107q0-50-1-90zm-839-526q109 0 204 41t167 113 113 167 42 205q0 109-41 204t-113 167-167 113-205 42q-109 0-204-41t-167-113-113-167-42-205q0-109 41-204t113-167 167-113 205-42zm0 867q70 0 132-27t109-73 73-108 27-133q0-70-27-132t-73-109-108-73-133-27q-71 0-133 27t-108 73-73 108-27 133q0 71 27 133t73 108 108 73 133 27zm547-1010q25 0 47 9t39 26 26 39 10 48q0 25-9 47t-26 39-39 27-48 10q-26 0-48-9t-39-27-26-39-10-48q0-25 10-47t26-39 39-26 48-10z" })
      ]
    }
  );
}
var InstagramLogo_default = SvgInstagramLogo;

// src/components/Icon/icons/Instant.tsx
import { jsx as jsx529, jsxs as jsxs522 } from "react/jsx-runtime";
function SvgInstant({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs522(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx529("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx529("path", { d: "M1024 0q141 0 272 36t245 103 207 160 160 208 103 245 37 272q0 141-36 272t-103 245-160 207-208 160-245 103-272 37q-141 0-272-36t-245-103-207-160-160-208-103-244-37-273q0-141 36-272t103-245 160-207 208-160T751 37t273-37zm0 128q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 133 37 256l640-640h1028q-56-117-140-211t-190-162-227-103-252-36zm0 1792q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-133-37-256H859l-643 643q56 117 140 211t190 160 227 102 251 36z" })
      ]
    }
  );
}
var Instant_default = SvgInstant;

// src/components/Icon/icons/InstructionManual.tsx
import { jsx as jsx530, jsxs as jsxs523 } from "react/jsx-runtime";
function SvgInstructionManual({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs523(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx530("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx530("path", { d: "M1664 384q27 0 50 10t40 27 28 41 10 50v1408q0 27-10 50t-27 40-41 28-50 10H256V384L1408 0q2-1 13 0t13 3q45 9 73 44t29 81v256h128zm-1024 0h768V128L640 384zm1024 128H384v1408h1280V512z" })
      ]
    }
  );
}
var InstructionManual_default = SvgInstructionManual;

// src/components/Icon/icons/Internet.tsx
import { jsx as jsx531, jsxs as jsxs524 } from "react/jsx-runtime";
function SvgInternet({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs524(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx531("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx531("path", { d: "M1024 0q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 141-36 272t-103 245-160 207-208 160-245 103-272 37q-141 0-272-36t-245-103-207-160-160-208-103-244-37-273q0-141 36-272t103-245 160-207 208-160T751 37t273-37zm809 640q-39-81-92-152t-120-131-142-105-162-75q73 103 116 221t67 242h333zm87 384q0-133-37-256h-363q8 64 12 127t4 129q0 65-4 128t-12 128h363q37-123 37-256zm-896 896q49 0 91-27t79-71 64-99 51-113 37-110 23-92H678q8 39 23 92t38 110 50 112 65 100 78 71 92 27zm367-640q8-64 12-127t5-129q0-65-4-128t-13-128H656q-8 64-12 127t-4 129q0 65 4 128t12 128h735zM128 1024q0 133 37 256h363q-8-64-12-127t-4-129q0-65 4-128t12-128H165q-37 123-37 256zm896-896q-49 0-91 27t-79 71-64 99-51 113-37 110-24 92h691q-8-39-23-92t-37-110-50-112-65-100-78-71-92-27zm-293 49q-85 29-162 75T426 357 307 487t-93 153h334q11-59 27-120t39-121 52-116 65-106zM214 1408q78 163 212 283t305 180q-36-49-65-105t-51-116-39-121-28-121H214zm1103 463q85-29 161-74t143-105 120-131 92-153h-333q-24 124-67 242t-116 221z" })
      ]
    }
  );
}
var Internet_default = SvgInternet;

// src/components/Icon/icons/InternetWithController.tsx
import { jsx as jsx532, jsxs as jsxs525 } from "react/jsx-runtime";
function SvgInternetWithController({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs525(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx532("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx532("path", { d: "M1888 1377q13 14 28 42t30 63 31 75 27 77 22 67 12 49q5 23 7 47t3 48q0 34-7 66t-27 61q-20 29-54 52t-72 24q-22 0-43-12t-42-32-39-42-38-44-34-37-32-21q-4-1-12-2t-18-1-17-1-13 0h-222q-10 0-17 2t-13 2q-15 6-32 22t-35 36-37 44-39 42-42 31-43 13q-18 0-36-6t-35-16-31-24-24-29q-19-29-26-62t-8-68q0-46 9-93 3-17 12-47t22-68 28-78 31-76 31-64 27-40q0-17 8-32t23-24q14-9 38-16t50-13 52-9 42-3q12 0 24 1t24 7h1q11 5 20 11t20 12h164q15-7 24-13t17-10 19-6 29-2q16 0 41 3t52 8 51 13 38 17q14 9 22 24t9 32zm7 537q17-12 21-30t4-39q0-18-2-36t-6-37q-2-12-9-36t-18-55-23-64-24-64-22-52-17-31q-6-7-11-11t-10-8-9-10-8-19q-21-6-42-10t-44-4h-1q-16 7-32 19t-35 12h-206q-19 0-35-12t-32-19q-23 0-44 4t-44 10q-3 12-7 18t-8 11-10 8-12 11q-6 8-16 30t-23 52-24 64-23 64-18 56-10 36q-3 17-5 35t-2 36q0 17 4 38t21 33q44-40 70-74t53-59 66-39 106-14h192q68 0 106 14t65 39 54 59 70 74zm-391-443q13 0 22 9t10 23q0 14-9 23t-23 9q-14 0-23-9t-9-23q0-13 9-22t23-10zm-521-191q-10 31-18 64t-22 63l-1 1H694q12 39 27 78t34 78 42 73 51 66q-5 35-10 68t-6 68q0 15 1 29t3 30q-103-22-195-66t-171-107-142-139-107-168-69-189-24-205q0-123 32-237t90-214 141-182 181-140 214-91 238-32q123 0 237 32t214 90 182 141 140 181 91 214 32 238q0 42-4 83t-12 84q-6-2-22-8t-35-13-33-12-22-6l-11 1q5-32 8-64t3-65q0-132-44-256h-232q11 64 15 127t5 129q0 32-1 64t-4 64h-129q6-64 6-128 0-65-5-129t-18-127H663q-12 63-17 127t-6 129q0 65 5 129t18 127h320zm705-641q-59-101-144-179t-192-129q48 70 81 148t55 160h200zm-664-383q-44 0-83 18t-72 49-61 71-49 82-38 85-27 78h660q-11-36-27-78t-38-84-49-83-61-70-72-49-83-19zm-328 75q-106 50-191 128T360 639h200q22-82 55-160t81-148zm-440 693q0 133 45 256h232q-11-63-16-127t-5-129q0-65 4-128t16-128H300q-23 62-33 126t-11 130zm440 694q-48-71-81-149t-55-161H360q59 101 144 180t192 130z" })
      ]
    }
  );
}
var InternetWithController_default = SvgInternetWithController;

// src/components/Icon/icons/JoinClub.tsx
import { jsx as jsx533, jsxs as jsxs526 } from "react/jsx-runtime";
function SvgJoinClub({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs526(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx533("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx533("path", { d: "M1600 1152q93 0 174 35t143 96 96 142 35 175q0 72-21 137t-61 121-95 97-122 66l-42-121q47-17 86-47t68-69 43-87 16-97q0-66-25-124t-69-101-102-69-124-26q-66 0-124 25t-102 69-69 102-25 124q0 75 34 142t94 112v-190h128v384h-384v-128h136q-66-63-101-146t-35-174q0-93 35-174t96-143 142-96 175-35zM0 0h2048v128H0V0zm0 384V256h2048v128h-256v512q0 62-6 125-64-20-126-26 2-25 3-49t1-50V384H384v512q0 163 45 315t128 284 201 237 266 176v140q-174-73-316-191t-242-268-155-327-55-366V384H0zm640 896q0-52 14-101t39-94 62-80 83-61q-33-35-51-81t-19-95q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100q0 49-18 95t-52 81q73 41 124 109-29 14-56 31t-53 38q-36-47-88-72t-113-26q-53 0-99 20t-82 55-55 81-20 100H640zm256-512q0 27 10 50t27 40 41 28 50 10q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50z" })
      ]
    }
  );
}
var JoinClub_default = SvgJoinClub;

// src/components/Icon/icons/JoinGameClubs.tsx
import { jsx as jsx534, jsxs as jsxs527 } from "react/jsx-runtime";
function SvgJoinGameClubs({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs527(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx534("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx534("path", { d: "M0 0h2048v128H0V0zm1600 1152q93 0 174 35t143 96 96 142 35 175q0 72-21 137t-61 121-95 97-122 66l-42-121q47-17 86-47t68-69 43-87 16-97q0-66-25-124t-69-101-102-69-124-26q-66 0-124 25t-102 69-69 102-25 124q0 75 34 142t94 112v-190h128v384h-384v-128h136q-66-63-101-146t-35-174q0-93 35-174t96-143 142-96 175-35zm448-896v128h-256v639q-31-11-63-17t-65-11V384H384v1201l640 320v143l-768-384V384H0V256h2048zm-819 862q-29 23-56 49t-50 56H951q-29 0-45 2t-29 10-24 19-30 34q-13 15-30 35t-37 39-41 32-44 14q-41 0-70-19t-49-50-28-68-9-73q0-20 2-38t5-38q3-17 10-47t18-67 23-75 24-74 23-62 19-42q0-32 12-55t48-27q23-2 40-9t39-13q20-5 40-8t42-3q16 0 28 2t22 6 20 10 23 15h142q25-16 43-24t50-9q21 0 41 3t41 8q21 5 38 12t41 10q35 3 47 26t13 56q13 21 25 53t23 66 21 69 17 58q-61 10-121 35-20-62-43-122t-45-121q-19-5-27-9t-15-8-18-4-35-2h-12q-14 9-25 15t-21 11-23 5-30 2H968q-17 0-29-1t-23-6-22-10-25-16h-12q-24 0-35 1t-18 5-15 7-27 10q-15 44-36 97t-39 108-32 109-14 99q0 17 4 37t19 31q42-41 67-70t43-49 34-31 43-17 66-7 107-2h82q23 0 46 3t43 6 34 11z" })
      ]
    }
  );
}
var JoinGameClubs_default = SvgJoinGameClubs;

// src/components/Icon/icons/Key.tsx
import { jsx as jsx535, jsxs as jsxs528 } from "react/jsx-runtime";
function SvgKey({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs528(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx535("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx535("path", { d: "M2048 1574v474h-512v-256h-256v-256h-256v-207q-74 39-155 59t-165 20q-97 0-187-25t-168-71-143-110-110-142-71-169T0 704q0-97 25-187t71-168 110-143T348 96t169-71T704 0q97 0 187 25t168 71 143 110 110 142 71 169 25 187q0 51-8 101t-23 98l671 671zm-128 53l-690-690q22-57 36-114t14-119q0-119-45-224t-124-183-183-123-224-46q-119 0-224 45T297 297 174 480t-46 224q0 119 45 224t124 183 183 123 224 46q97 0 190-33t169-95h89v256h256v256h256v256h256v-293zM512 384q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10z" })
      ]
    }
  );
}
var Key_default = SvgKey;

// src/components/Icon/icons/Keyboard.tsx
import { jsx as jsx536, jsxs as jsxs529 } from "react/jsx-runtime";
function SvgKeyboard({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs529(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx536("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx536("path", { d: "M448 832H320V704h128v128zM320 960h256v128H320V960zm1152 0h256v128h-256V960zm0 256h256v128h-256v-128zm-1152 0h256v128H320v-128zm384 0h640v128H704v-128zm0-384H576V704h128v128zm0 128h128v128H704V960zm256 0h128v128H960V960zm256 0h128v128h-128V960zM960 832H832V704h128v128zm256 0h-128V704h128v128zm256 0h-128V704h128v128zm128-128h128v128h-128V704zm256-256q27 0 50 10t40 27 28 41 10 50v896q0 27-10 50t-27 40-41 28-50 10H192q-27 0-50-10t-40-27-28-41-10-50V576q0-27 10-50t27-40 41-28 50-10h1664zm0 128H192v896h1664V576z" })
      ]
    }
  );
}
var Keyboard_default = SvgKeyboard;

// src/components/Icon/icons/Kinect.tsx
import { jsx as jsx537, jsxs as jsxs530 } from "react/jsx-runtime";
function SvgKinect({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs530(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx537("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx537("path", { d: "M0 1409h2048v127H0v-127zm2048-769v640H0V640h2048zm-128 128H128v384h1792V768zM320 1024q-26 0-45-19t-19-45q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19z" })
      ]
    }
  );
}
var Kinect_default = SvgKinect;

// src/components/Icon/icons/KinectBroadcasting.tsx
import { jsx as jsx538, jsxs as jsxs531 } from "react/jsx-runtime";
function SvgKinectBroadcasting({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs531(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx538("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx538("path", { d: "M1408 1664q-18 0-33-4l-153 152q68 53 148 80t166 28v128q-133 0-249-50t-204-137-137-203-50-250h128q0 86 27 166t81 148l152-153q-4-15-4-33 0-27 10-50t27-40 41-28 50-10q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10zm0-768q88 0 170 23t153 64 129 100 100 130 65 153 23 170h-128q0-106-40-199t-110-162-163-110-199-41V896zm0 256q79 0 149 30t122 83 82 122 31 149h-128q0-53-20-99t-55-82-81-55-100-20v-128zM0 1280h768v128H0v-128zm2048-768v531q-27-41-59-77t-69-70V640H128v384h1152v128H0V512h2048zM326 768q10 0 20 5t19 13 14 19 5 21v13q0 10-5 20t-14 18-18 14-21 5h-13q-10 0-20-5t-18-13-14-19-5-20v-13q0-10 5-20t13-19 19-13 20-6h13z" })
      ]
    }
  );
}
var KinectBroadcasting_default = SvgKinectBroadcasting;

// src/components/Icon/icons/KinectDisconnected.tsx
import { jsx as jsx539, jsxs as jsxs532 } from "react/jsx-runtime";
function SvgKinectDisconnected({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs532(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx539("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx539("path", { d: "M1600 896q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm-320 448q0 66 25 124t68 102 102 69 125 25q47 0 92-13t84-40l-443-443q-26 39-39 84t-14 92zm587 176q26-39 39-84t14-92q0-66-25-124t-69-101-102-69-124-26q-47 0-92 13t-84 40l443 443zM256 960q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45zm758 448q7 65 29 128H0v-128h1014zm1034-768v321q-28-33-59-62t-69-52v-79H128v384h915q-22 63-29 128H0V640h2048z" })
      ]
    }
  );
}
var KinectDisconnected_default = SvgKinectDisconnected;

// src/components/Icon/icons/KinectIr.tsx
import { jsx as jsx540, jsxs as jsxs533 } from "react/jsx-runtime";
function SvgKinectIr({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs533(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx540("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx540("path", { d: "M0 1280h896v128H0v-128zm2048-768v512q-1-10-18-24t-39-30-42-26-29-16V640H128v384h896q-31 22-59 58t-46 70H0V512h2048zM326 768q10 0 20 5t19 13 14 19 5 21v13q0 10-5 20t-14 18-18 14-21 5h-13q-10 0-20-5t-18-13-14-19-5-20v-13q0-10 5-20t13-19 19-13 20-6h13zm1201 768q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 41-40 27-51 10q-27 0-50-10t-40-27-28-41-10-50q0-26 10-49t27-41 41-28 50-10zm-271-143q54-54 124-83t147-29q77 0 147 29t125 83l-91 90q-36-36-83-55t-98-20q-51 0-98 19t-83 56l-90-90zm-181-181q91-91 207-139t245-49q128 0 245 48t208 140l-91 90q-72-72-165-111t-197-39q-103 0-196 39t-166 111l-90-90z" })
      ]
    }
  );
}
var KinectIr_default = SvgKinectIr;

// src/components/Icon/icons/KinectSettings.tsx
import { jsx as jsx541, jsxs as jsxs534 } from "react/jsx-runtime";
function SvgKinectSettings({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs534(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx541("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx541("path", { d: "M256 960q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45zm1782 400l-124 51q6 30 6 61t-6 61l124 51-49 119-124-52q-35 51-86 86l52 124-119 49-51-124q-30 6-61 6t-61-6l-51 124-119-49 52-124q-51-35-86-86l-124 52-49-119 124-51q-6-30-6-61t6-61l-124-51 49-119 124 52q35-51 86-86l-52-124 119-49 51 124q30-6 61-6t61 6l51-124 119 49-52 124q51 35 86 86l124-52 49 119zm-438 304q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15zM0 1408h1024v128H0v-128zm2048-768v424q-57-62-128-107V768H128v384h957q-19 30-33 62t-26 66H0V640h2048z" })
      ]
    }
  );
}
var KinectSettings_default = SvgKinectSettings;

// src/components/Icon/icons/Label.tsx
import { jsx as jsx542, jsxs as jsxs535 } from "react/jsx-runtime";
function SvgLabel({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs535(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx542("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx542("path", { d: "M1720 128q41 0 77 16t63 43 43 63 16 78q0 37-10 65t-29 53-41 46-47 46v1254H256V256h1254q24-24 46-47t47-41 52-29 65-11zm0 128q-29 0-50 21l-948 948-34 135 135-34 948-948q21-21 21-50 0-30-21-51t-51-21zm-56 410l-775 776-377 94 94-377 776-775H384v1280h1280V666z" })
      ]
    }
  );
}
var Label_default = SvgLabel;

// src/components/Icon/icons/LaserCutter.tsx
import { jsx as jsx543, jsxs as jsxs536 } from "react/jsx-runtime";
function SvgLaserCutter({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs536(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx543("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx543("path", { d: "M1920 1920v128h-896v-128h224l-20-37 138-119-171-64 30-180-172 60-93-156-93 156-172-60 30 180-171 64 138 119-20 37h224v128H0v-128h525l4-8q-55-49-110-96t-111-95q69-26 137-51t136-53q-11-72-23-144t-24-144l138 48 138 48q22-36 43-72t43-72V0h128v1281l42 72q21 36 44 72 69-23 138-47t138-49l-24 144q-12 72-23 144 68 27 136 52t137 52q-56 48-111 95t-110 96l4 8h525z" })
      ]
    }
  );
}
var LaserCutter_default = SvgLaserCutter;

// src/components/Icon/icons/LauncherApp.tsx
import { jsx as jsx544, jsxs as jsxs537 } from "react/jsx-runtime";
function SvgLauncherApp({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs537(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx544("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx544("path", { d: "M192 480q-23-54-64-95t-96-65q54-23 95-64t65-96q23 54 64 95t96 65q-54 23-95 64t-65 96zm1664 64q23 54 64 95t96 65q-54 23-95 64t-65 96q-23-54-64-95t-96-65q54-23 95-64t65-96zm-384 96q-47-109-129-191t-191-129q109-47 191-129T1472 0q47 109 129 191t191 129q-109 47-191 129t-129 191zm0-451q-57 74-131 131 74 57 131 131 57-74 131-131-74-57-131-131zm27 707l402 403-90 90-147-146v677q0 27-10 50t-27 40-41 28-50 10H384q-27 0-50-10t-40-27-28-41-10-50v-677l-147 146-90-90 402-403h427q-35 41-77 72t-91 56H475l-128 128h362q74-34 137-80t110-106 73-132 27-158q0-53-15-106t-44-97-75-70-105-27q-35 0-68 13t-59 37-42 54-16 68q0 23 9 45t24 40 37 29 46 11q23 0 37-7t23-20 14-25 13-25 17-19 29-8q23 0 40 17t17 40q0 5-2 13-8 32-26 59t-42 46-55 31-65 11q-47 0-88-19t-73-53-49-76-18-90q0-59 24-110t66-90 95-61 112-23q83 0 148 35t111 94 68 132 24 150q0 145-64 267t-179 210h648l-128-128h-240q17-31 31-63t25-65h238z" })
      ]
    }
  );
}
var LauncherApp_default = SvgLauncherApp;

// src/components/Icon/icons/LeftArmReplacement.tsx
import { jsx as jsx545, jsxs as jsxs538 } from "react/jsx-runtime";
function SvgLeftArmReplacement({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs538(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx545("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx545("path", { d: "M1280 512v1408q0 27-10 50t-27 40-41 28-50 10H768q-27 0-50-10t-40-27-28-41-10-50v-651q-29-10-52-28t-41-42-26-52-9-59V704q0-40 15-75t41-61 61-41 75-15h576zm-128 128H704q-26 0-45 19t-19 45v384q0 28 13 41t32 19 42 5 41-1v768h128v-640h128v640h128V640zm64-384q0 53-20 99t-55 82-81 55-100 20q-53 0-99-20t-82-55-55-81-20-100q0-53 20-99t55-82 81-55T960 0q53 0 99 20t82 55 55 81 20 100zM960 384q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10zm589 128q57 0 104 31t71 83l183 408q6 14 9 27t4 28q0 38-19 68t-52 47l-123 62q-28 14-57 14-36 0-67-19t-48-52l-171-349 114-56 172 348 123-62 36 53q-9-13-20-27t-17-29l-184-409q-8-17-23-27t-35-11h-141V512h141z" })
      ]
    }
  );
}
var LeftArmReplacement_default = SvgLeftArmReplacement;

// src/components/Icon/icons/LeftDoubleQuote.tsx
import { jsx as jsx546, jsxs as jsxs539 } from "react/jsx-runtime";
function SvgLeftDoubleQuote({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs539(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx546("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx546("path", { d: "M153 523h176v343H0V523q0-52 7-106t22-105 40-95 61-78 85-52 112-20v156q-55 0-89 31t-53 76-25 98-7 95zm546 0h176v343H543V523q0-52 7-106t23-104 41-95 62-78 85-53 110-20v156q-56 0-90 31t-52 76-24 98-6 95z" })
      ]
    }
  );
}
var LeftDoubleQuote_default = SvgLeftDoubleQuote;

// src/components/Icon/icons/LeftLegReplacement.tsx
import { jsx as jsx547, jsxs as jsxs540 } from "react/jsx-runtime";
function SvgLeftLegReplacement({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs540(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx547("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx547("path", { d: "M1280 1269q0 29-8 54t-25 44-41 30-54 11h-128v512q0 27-10 50t-27 40-41 28-50 10H768q-27 0-50-10t-40-27-28-41-10-50v-651q-29-10-52-28t-41-42-26-52-9-59V704q0-40 15-75t41-61 61-41 75-15h512q40 0 75 15t61 41 41 61 15 75v384q0 30-9 58t-26 53-40 42-53 28zm-128-117h40q22 0 42-4t33-18 13-42V704q0-26-19-45t-45-19H704q-26 0-45 19t-19 45v384q0 28 13 41t32 19 42 5 41-1v768h128v-640h256v-128zm627 650q6 14 9 27t4 28q0 38-19 68t-52 47l-123 62q-14 7-27 10t-30 4q-36 0-67-19t-48-52l-227-455 114-57 228 455 123-62 36 53q-9-13-20-27t-17-29l-207-464 117-52 206 463zM1216 256q0 53-20 99t-55 82-81 55-100 20q-53 0-99-20t-82-55-55-81-20-100q0-53 20-99t55-82 81-55T960 0q53 0 99 20t82 55 55 81 20 100zM960 384q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10z" })
      ]
    }
  );
}
var LeftLegReplacement_default = SvgLeftLegReplacement;

// src/components/Icon/icons/LeftStick.tsx
import { jsx as jsx548, jsxs as jsxs541 } from "react/jsx-runtime";
function SvgLeftStick({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs541(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx548("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx548("path", { d: "M1024 1536h256v128H896v-640h128v512zm896-896q24 0 47 11t41 29 29 41 11 47v256q0 24-11 47t-29 41-41 29-47 11h-385v640h-126v-384h-1v-384h507l5-5V773l-5-5H133l-5 5v246l5 5h507v768H512v-640H128q-24 0-47-11t-41-29-29-41-11-47V768q0-24 11-47t29-41 41-29 47-11h1792z" })
      ]
    }
  );
}
var LeftStick_default = SvgLeftStick;

// src/components/Icon/icons/LeftStickClick.tsx
import { jsx as jsx549, jsxs as jsxs542 } from "react/jsx-runtime";
function SvgLeftStickClick({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs542(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx549("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx549("path", { d: "M1024 1536h256v128H896v-640h128v512zm0-1024L768 256h512l-256 256zm896 128q24 0 47 11t41 29 29 41 11 47v256q0 24-11 47t-29 41-41 29-47 11h-385v640h-126v-384h-1v-384h507l5-5V773l-5-5H133l-5 5v246l5 5h507v768H512v-640H128q-24 0-47-11t-41-29-29-41-11-47V768q0-24 11-47t29-41 41-29 47-11h1792z" })
      ]
    }
  );
}
var LeftStickClick_default = SvgLeftStickClick;

// src/components/Icon/icons/LeftThumbDown.tsx
import { jsx as jsx550, jsxs as jsxs543 } from "react/jsx-runtime";
function SvgLeftThumbDown({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs543(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx550("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx550("path", { d: "M768 1792h512l-256 256-256-256zm255-1407q132 0 249 50t204 136 137 203 51 249q0 88-23 170t-64 153-100 130-129 101-153 65-170 23q-88 0-170-23t-153-64-129-99-101-130-65-152-23-171q0-133 50-249t136-204 203-137 250-51zm1 1151q70 0 135-18t123-52 104-81 80-104 51-122 19-136q0-106-40-199t-110-162-163-110-199-40q-106 0-199 40T662 662 552 825t-40 200q0 106 40 199t110 162 163 110 199 40zm-64-320h256v128H832V704h128v512z" })
      ]
    }
  );
}
var LeftThumbDown_default = SvgLeftThumbDown;

// src/components/Icon/icons/LeftThumbHorizontal.tsx
import { jsx as jsx551, jsxs as jsxs544 } from "react/jsx-runtime";
function SvgLeftThumbHorizontal({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs544(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx551("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx551("path", { d: "M256 1280L0 1024l256-256v512zm1536-512l256 256-256 256V768zm-128 255q0 133-50 249t-137 204-203 137-250 51q-88 0-170-23t-153-64-129-100-100-129-65-153-23-170q0-133 50-249t137-204 203-137 250-51q88 0 170 23t153 64 129 100 100 129 65 153 23 170zm-639 513q106 0 199-40t162-111 110-163 40-199q0-106-40-199t-111-162-163-110-199-40q-106 0-199 40T662 663 552 826t-40 199q0 106 40 199t110 162 163 110 200 40zm-65-832v512h256v128H832V704h128z" })
      ]
    }
  );
}
var LeftThumbHorizontal_default = SvgLeftThumbHorizontal;

// src/components/Icon/icons/LeftThumbLeft.tsx
import { jsx as jsx552, jsxs as jsxs545 } from "react/jsx-runtime";
function SvgLeftThumbLeft({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs545(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx552("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx552("path", { d: "M0 1024l256-256v512L0 1024zm1023-639q132 0 249 50t204 136 137 203 51 249q0 88-23 170t-64 153-100 130-129 101-153 65-170 23q-88 0-170-23t-153-64-129-99-101-130-65-152-23-171q0-133 50-249t136-204 203-137 250-51zm1 1151q70 0 135-18t123-52 104-81 80-104 51-122 19-136q0-106-40-199t-110-162-163-110-199-40q-106 0-199 40T662 662 552 825t-40 200q0 106 40 199t110 162 163 110 199 40zm-64-320h256v128H832V704h128v512z" })
      ]
    }
  );
}
var LeftThumbLeft_default = SvgLeftThumbLeft;

// src/components/Icon/icons/LeftThumbRight.tsx
import { jsx as jsx553, jsxs as jsxs546 } from "react/jsx-runtime";
function SvgLeftThumbRight({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs546(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx553("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx553("path", { d: "M2048 1024l-256 256V768l256 256zM1023 385q132 0 249 50t204 136 137 203 51 249q0 88-23 170t-64 153-100 130-129 101-153 65-170 23q-88 0-170-23t-153-64-129-99-101-130-65-152-23-171q0-133 50-249t136-204 203-137 250-51zm1 1151q70 0 135-18t123-52 104-81 80-104 51-122 19-136q0-106-40-199t-110-162-163-110-199-40q-106 0-199 40T662 662 552 825t-40 200q0 106 40 199t110 162 163 110 199 40zm-64-320h256v128H832V704h128v512z" })
      ]
    }
  );
}
var LeftThumbRight_default = SvgLeftThumbRight;

// src/components/Icon/icons/LeftThumbUp.tsx
import { jsx as jsx554, jsxs as jsxs547 } from "react/jsx-runtime";
function SvgLeftThumbUp({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs547(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx554("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx554("path", { d: "M1280 256H768L1024 0l256 256zm-257 129q132 0 249 50t204 136 137 203 51 249q0 88-23 170t-64 153-100 130-129 101-153 65-170 23q-88 0-170-23t-153-64-129-99-101-130-65-152-23-171q0-133 50-249t136-204 203-137 250-51zm1 1151q70 0 135-18t123-52 104-81 80-104 51-122 19-136q0-106-40-199t-110-162-163-110-199-40q-106 0-199 40T662 662 552 825t-40 200q0 106 40 199t110 162 163 110 199 40zm-64-320h256v128H832V704h128v512z" })
      ]
    }
  );
}
var LeftThumbUp_default = SvgLeftThumbUp;

// src/components/Icon/icons/Leggings.tsx
import { jsx as jsx555, jsxs as jsxs548 } from "react/jsx-runtime";
function SvgLeggings({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs548(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx555("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx555("path", { d: "M704 0q26 0 45 19l1280 1280q19 19 19 45t-19 45l-128 128q-19 19-45 19-7 0-45-11t-93-29-116-39-120-41-100-34-58-20q-20-7-32-24t-12-37v-173q-129-65-256-128T768 871v1113q0 26-19 45t-45 19H544q-17 0-33-9t-24-26l-224-448q-7-13-7-29 0-26 19-45l109-109q0-28 1-62t1-71-4-71-14-65L210 640H0V512h512q26 0 45 19l104 104q40 40 86 73t97 59l231 115 179-178-577-576H0V0h704zm-64 1920v-640H512q0 47 1 76t0 47-7 31-18 26-34 35-56 54l185 371h57zm0-1133q-42-33-79-71t-75-76H345l144 433q13 37 19 79h132V787zm1254 557l-550-550-148 148 177 89q16 8 25 24t10 33v167l431 144 55-55z" })
      ]
    }
  );
}
var Leggings_default = SvgLeggings;

// src/components/Icon/icons/Library.tsx
import { jsx as jsx556, jsxs as jsxs549 } from "react/jsx-runtime";
function SvgLibrary({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs549(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx556("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx556("path", { d: "M640 1792V256h384v1536H640zM768 384v1280h128V384H768zM128 1792V256h384v1536H128zM256 384v1280h128V384H256zm1235-151l484 1450-346 116-484-1450 346-116zm-204 186l412 1238 134-44-413-1238-133 44z" })
      ]
    }
  );
}
var Library_default = SvgLibrary;

// src/components/Icon/icons/LibraryAddTo.tsx
import { jsx as jsx557, jsxs as jsxs550 } from "react/jsx-runtime";
function SvgLibraryAddTo({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs550(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx557("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx557("path", { d: "M639 1792V256h385v1536H639zM768 385v1280h129V385H768zM127 1792V256h385v1536H127zM256 385v1280h129V385H256zm1536 1278h256v129h-256v256h-129v-256h-254v-129h254v-254h129v254zm-218-383h-118l-311-931 346-116 349 1047h-118l-302-905-133 44 287 861z" })
      ]
    }
  );
}
var LibraryAddTo_default = SvgLibraryAddTo;

// src/components/Icon/icons/LibraryRemoveFrom.tsx
import { jsx as jsx558, jsxs as jsxs551 } from "react/jsx-runtime";
function SvgLibraryRemoveFrom({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs551(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx558("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx558("path", { d: "M639 1792V256h385v1536H639zM768 385v1280h129V385H768zM127 1792V256h385v1536H127zM256 385v1280h129V385H256zm1792 1114l-230 229 230 229-91 91-229-230-229 230-91-91 230-229-230-229 91-91 229 230 229-230 91 91zm-474-219h-118l-311-931 346-116 349 1047h-118l-302-905-133 44 287 861z" })
      ]
    }
  );
}
var LibraryRemoveFrom_default = SvgLibraryRemoveFrom;

// src/components/Icon/icons/LibrarySolid.tsx
import { jsx as jsx559, jsxs as jsxs552 } from "react/jsx-runtime";
function SvgLibrarySolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs552(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx559("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx559("path", { d: "M640 1792V256h384v1536H640zm-512 0V256h384v1536H128zM1491 233l484 1450-346 116-484-1450 346-116z" })
      ]
    }
  );
}
var LibrarySolid_default = SvgLibrarySolid;

// src/components/Icon/icons/LicenseStore.tsx
import { jsx as jsx560, jsxs as jsxs553 } from "react/jsx-runtime";
function SvgLicenseStore({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs553(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx560("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx560("path", { d: "M1914 1539q6 30 6 61t-6 61l124 51-49 119-124-52q-35 51-86 86l52 124-119 49-51-124q-30 6-61 6t-61-6l-51 124-119-49 52-124q-51-35-86-86l-124 52-49-119 124-51q-6-30-6-61t6-61l-124-51 49-119 124 52q35-51 86-86l-52-124 119-49 51 124q30-6 61-6t61 6l51-124 119 49-52 124q51 35 86 86l124-52 49 119-124 51zm-314 253q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15zm-515 128q45 71 107 128H256V0h987l549 549v477q-31-11-63-17t-65-11V640h-512V128H384v1792h701zm195-1408h293l-293-293v293z" })
      ]
    }
  );
}
var LicenseStore_default = SvgLicenseStore;

// src/components/Icon/icons/Lightbulb.tsx
import { jsx as jsx561, jsxs as jsxs554 } from "react/jsx-runtime";
function SvgLightbulb({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs554(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx561("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx561("path", { d: "M960 0q97 0 187 25t168 71 143 110 110 142 71 169 25 187q0 145-55 269t-157 225q-83 82-127 183t-45 219v256q0 40-15 75t-41 61-61 41-75 15H832q-40 0-75-15t-61-41-41-61-15-75v-256q0-118-44-219t-128-183q-102-101-157-225t-55-269q0-97 25-187t71-168 110-143T604 96t169-71T960 0zm128 1920q26 0 45-19t19-45v-192H768v192q0 26 19 45t45 19h256zm67-384q13-129 66-234t143-196q83-84 127-183t45-219q0-119-45-224t-124-183-183-123-224-46q-119 0-224 45T553 297 430 480t-46 224q0 119 44 218t128 184q90 91 143 196t66 234h390z" })
      ]
    }
  );
}
var Lightbulb_default = SvgLightbulb;

// src/components/Icon/icons/LightningBolt.tsx
import { jsx as jsx562, jsxs as jsxs555 } from "react/jsx-runtime";
function SvgLightningBolt({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs555(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx562("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx562("path", { d: "M1883 768L603 2048H313l384-768H248L888 0h719l-384 768h660zm-310 128h-557l384-768H967L455 1152h449l-384 768h29L1573 896z" })
      ]
    }
  );
}
var LightningBolt_default = SvgLightningBolt;

// src/components/Icon/icons/Like.tsx
import { jsx as jsx563, jsxs as jsxs556 } from "react/jsx-runtime";
function SvgLike({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs556(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx563("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx563("path", { d: "M2048 832q0 32-10 61l-256 768q-10 29-28 53t-42 42-52 26-60 10h-512q-179 0-345-69-72-29-144-44t-151-15H0V768h417q65 0 122-24t104-70l622-621q25-25 50-39t61-14q33 0 62 12t51 35 34 51 13 62q0 81-18 154t-53 146q-20 43-34 87t-19 93h444q39 0 74 15t61 41 42 61 15 75zm-128 0q0-26-19-45t-45-19h-576v-64q0-81 18-154t53-146q28-58 42-118t15-126q0-14-9-23t-23-9q-6 0-10 4t-9 9L734 765q-32 32-68 56t-78 41q-80 34-171 34H128v640h320q178 0 345 69 144 59 295 59h512q20 0 37-12t24-32q5-14 18-54t33-96 42-124 46-137 44-134 39-118 27-86 10-39z" })
      ]
    }
  );
}
var Like_default = SvgLike;

// src/components/Icon/icons/LikeDislike.tsx
import { jsx as jsx564, jsxs as jsxs557 } from "react/jsx-runtime";
function SvgLikeDislike({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs557(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx564("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx564("path", { d: "M2048 1407q0 11-2 21t-5 21l-170 512q-13 39-47 63t-75 24H768v-768h267q26 0 45-19l328-328q18-18 44-27t52-10q33 0 62 12t51 35 34 51 13 62v8l-54 216h310q27 0 50 10t40 27 28 41 10 49zm-299 513l171-512h-474l89-358q-2-11-11-18t-20-8q-1 0-3 1t-4 1l-326 326q-27 27-62 41t-74 15H896v512h853zM544 1152q-33 0-62-12t-51-35-34-51-13-62v-8l54-216H128q-27 0-50-10t-40-27-28-40-10-50q0-11 2-21t5-21L177 87q13-39 47-63t75-24h981v768h-267q-26 0-45 19l-328 328q-18 18-44 27t-52 10zm7-130l326-326q27-27 62-41t74-15h139V128H299L128 640h474l-89 358q2 11 11 18t20 8q1 0 3-1t4-1z" })
      ]
    }
  );
}
var LikeDislike_default = SvgLikeDislike;

// src/components/Icon/icons/LikeDislikeSolid.tsx
import { jsx as jsx565, jsxs as jsxs558 } from "react/jsx-runtime";
function SvgLikeDislikeSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs558(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx565("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx565("path", { d: "M2048 1407q0 11-2 21t-5 21l-170 512q-13 39-46 63t-76 24H768v-768h267q26 0 45-19l328-328q19-19 44-28t52-9q33 0 62 12t51 35 34 51 13 62q0 17-7 46t-16 63-18 64-13 51h310q26 0 49 10t41 27 28 41 10 49zM544 1152q-33 0-62-12t-51-35-34-51-13-62q0-13 7-43t16-66 18-67 13-48H128q-27 0-50-10t-40-27-28-40-10-50q0-11 2-21t5-21L177 87q13-39 46-63t76-24h981v768h-267q-26 0-45 19l-328 328q-19 19-44 28t-52 9z" })
      ]
    }
  );
}
var LikeDislikeSolid_default = SvgLikeDislikeSolid;

// src/components/Icon/icons/LikeSolid.tsx
import { jsx as jsx566, jsxs as jsxs559 } from "react/jsx-runtime";
function SvgLikeSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs559(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx566("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx566("path", { d: "M2048 832q0 32-10 61l-256 768q-10 29-28 53t-42 42-52 26-60 10h-512q-179 0-345-69-72-29-144-44t-151-15H0V768h417q65 0 122-24t104-70l622-621q25-25 50-39t61-14q33 0 62 12t51 35 34 51 13 62q0 81-18 154t-53 146q-20 43-34 87t-19 93h444q39 0 74 15t61 41 42 61 15 75z" })
      ]
    }
  );
}
var LikeSolid_default = SvgLikeSolid;

// src/components/Icon/icons/Link.tsx
import { jsx as jsx567, jsxs as jsxs560 } from "react/jsx-runtime";
function SvgLink({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs560(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx567("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx567("path", { d: "M1536 768v128q76 0 145 17t123 56 84 99 32 148q0 66-25 124t-69 101-102 69-124 26h-512q-66 0-124-25t-101-69-69-102-26-124q0-87 31-147t85-99 122-56 146-18V768h-64q-93 0-174 35t-142 96-96 142-36 175q0 93 35 174t96 142 142 96 175 36h512q93 0 174-35t142-96 96-142 36-175q0-93-35-174t-96-142-142-96-175-36h-64zm-640 512v-128q76 0 145-17t123-56 84-99 32-148q0-66-25-124t-69-101-102-69-124-26H448q-66 0-124 25t-101 69-69 102-26 124q0 87 31 147t85 99 122 56 146 18v128h-64q-93 0-174-35t-142-96-96-142T0 832q0-93 35-174t96-142 142-96 175-36h512q93 0 174 35t142 96 96 142 36 175q0 93-35 174t-96 142-142 96-175 36h-64z" })
      ]
    }
  );
}
var Link_default = SvgLink;

// src/components/Icon/icons/List.tsx
import { jsx as jsx568, jsxs as jsxs561 } from "react/jsx-runtime";
function SvgList({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs561(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx568("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx568("path", { d: "M0 1536v-128h1280v128H0zm0-640h2048v128H0V896zm1664-512v128H0V384h1664z" })
      ]
    }
  );
}
var List_default = SvgList;

// src/components/Icon/icons/ListBulleted.tsx
import { jsx as jsx569, jsxs as jsxs562 } from "react/jsx-runtime";
function SvgListBulleted({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs562(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx569("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx569("path", { d: "M0 1280v-128h128v128H0zm0-384V768h128v128H0zm384 0V768h1664v128H384zM0 512V384h128v128H0zm384-128h1664v128H384V384zm0 896v-128h1664v128H384zM0 1664v-128h128v128H0zm384 0v-128h1664v128H384z" })
      ]
    }
  );
}
var ListBulleted_default = SvgListBulleted;

// src/components/Icon/icons/ListBulletedMirrored.tsx
import { jsx as jsx570, jsxs as jsxs563 } from "react/jsx-runtime";
function SvgListBulletedMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs563(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx570("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx570("path", { d: "M2048 1280v-128h-128v128h128zm0-384V768h-128v128h128zm-384 0V768H0v128h1664zm384-384V384h-128v128h128zm-384-128H0v128h1664V384zm0 896v-128H0v128h1664zm384 384v-128h-128v128h128zm-384 0v-128H0v128h1664z" })
      ]
    }
  );
}
var ListBulletedMirrored_default = SvgListBulletedMirrored;

// src/components/Icon/icons/ListJustified.tsx
import { jsx as jsx571, jsxs as jsxs564 } from "react/jsx-runtime";
function SvgListJustified({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs564(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx571("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx571("path", { d: "M0 384h2048v128H0V384zm0 1152v-128h2048v128H0zm0-512V897h2048v127H0z" })
      ]
    }
  );
}
var ListJustified_default = SvgListJustified;

// src/components/Icon/icons/ListMirrored.tsx
import { jsx as jsx572, jsxs as jsxs565 } from "react/jsx-runtime";
function SvgListMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs565(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx572("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx572("path", { d: "M2048 1536v-128H768v128h1280zm0-640H0v128h2048V896zM384 384v128h1664V384H384z" })
      ]
    }
  );
}
var ListMirrored_default = SvgListMirrored;

// src/components/Icon/icons/ListView.tsx
import { jsx as jsx573, jsxs as jsxs566 } from "react/jsx-runtime";
function SvgListView({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs566(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx573("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx573("path", { d: "M0 1280v-128h128v128H0zm0-384V768h128v128H0zm384 0V768h1664v128H384zM0 512V384h128v128H0zm384-128h1664v128H384V384zm0 896v-128h1664v128H384zM0 1664v-128h128v128H0zm384 0v-128h1664v128H384z" })
      ]
    }
  );
}
var ListView_default = SvgListView;

// src/components/Icon/icons/ListViewMirrored.tsx
import { jsx as jsx574, jsxs as jsxs567 } from "react/jsx-runtime";
function SvgListViewMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs567(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx574("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx574("path", { d: "M2048 1280v-128h-128v128h128zm0-384V768h-128v128h128zm-384 0V768H0v128h1664zm384-384V384h-128v128h128zm-384-128H0v128h1664V384zm0 896v-128H0v128h1664zm384 384v-128h-128v128h128zm-384 0v-128H0v128h1664z" })
      ]
    }
  );
}
var ListViewMirrored_default = SvgListViewMirrored;

// src/components/Icon/icons/LiveIndicator.tsx
import { jsx as jsx575, jsxs as jsxs568 } from "react/jsx-runtime";
function SvgLiveIndicator({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs568(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx575("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx575("path", { d: "M2048 1024q0 141-36 272t-104 244-160 207-207 161-245 103-272 37q-141 0-272-36t-244-104-207-160-161-207-103-245-37-272q0-141 36-272t104-244 160-207 207-161T752 37t272-37q141 0 272 36t244 104 207 160 161 207 103 245 37 272z" })
      ]
    }
  );
}
var LiveIndicator_default = SvgLiveIndicator;

// src/components/Icon/icons/LiveText.tsx
import { jsx as jsx576, jsxs as jsxs569 } from "react/jsx-runtime";
function SvgLiveText({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs569(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 4224 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx576("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx576("path", { d: "M0 0h4224v2048H0V0zm1093 1664v-179H596V384H384v1280h709zm448 0V384h-219v1280h219zm904 0l460-1280h-225q-63 188-107 322t-75 226-50 152-31 99-21 66-16 55-20 64-29 95q-33-117-76-255t-89-282-93-282-85-260h-232l452 1280h237zm1394 0v-179h-506v-379h440V927h-440V564h477V384h-690v1280h719z" })
      ]
    }
  );
}
var LiveText_default = SvgLiveText;

// src/components/Icon/icons/LiveTextInline.tsx
import { jsx as jsx577, jsxs as jsxs570 } from "react/jsx-runtime";
function SvgLiveTextInline({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs570(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 3037 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx577("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx577("path", { d: "M3037 575v1473H0V575h3037zM786 1643H429V852H276v920h510v-129zm322-791H951v920h157V852zm981 0h-162l-232 696q-8 22-12 41t-9 39q-3-23-7-42t-10-36l-227-698h-167l325 920h170l331-920zm671 791h-364v-272h317v-129h-317V981h344V852h-496v920h516v-129z" })
      ]
    }
  );
}
var LiveTextInline_default = SvgLiveTextInline;

// src/components/Icon/icons/Lock.tsx
import { jsx as jsx578, jsxs as jsxs571 } from "react/jsx-runtime";
function SvgLock({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs571(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx578("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx578("path", { d: "M1792 896v1152H256V896h256V522q0-108 39-203t108-166T821 41t203-41q109 0 202 41t163 112 108 166 39 203v374h256zm-1152 0h768V522q0-81-29-152t-80-126-122-85-153-31q-82 0-152 31t-122 85-81 125-29 153v374zm1024 128H384v896h1280v-896z" })
      ]
    }
  );
}
var Lock_default = SvgLock;

// src/components/Icon/icons/LockSolid.tsx
import { jsx as jsx579, jsxs as jsxs572 } from "react/jsx-runtime";
function SvgLockSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs572(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx579("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx579("path", { d: "M1536 896h256v1152H256V896h256V522q0-108 39-203t108-166T821 41t203-41q109 0 202 41t163 112 108 166 39 203v374zm-896 0h768V522q0-81-29-152t-80-126-122-85-153-31q-82 0-152 31t-122 85-81 125-29 153v374z" })
      ]
    }
  );
}
var LockSolid_default = SvgLockSolid;

// src/components/Icon/icons/LowerBrightness.tsx
import { jsx as jsx580, jsxs as jsxs573 } from "react/jsx-runtime";
function SvgLowerBrightness({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs573(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx580("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx580("path", { d: "M1408 960q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35q93 0 174 35t143 96 96 142 35 175zm-448 320q66 0 124-25t101-68 69-102 26-125q0-66-25-124t-69-101-102-69-124-26q-66 0-124 25t-102 69-69 102-25 124q0 66 25 124t68 102 102 69 125 25zm64-1088v192H896V192h128zM598 507l-91 91-135-136 90-90 136 135zM384 896v128H192V896h192zm-12 562l135-136 91 91-136 135-90-90zm524 270v-192h128v192H896zm426-315l91-91 135 136-90 90-136-135zm214-517h192v128h-192V896zm12-434l-135 136-91-91 136-135 90 90z" })
      ]
    }
  );
}
var LowerBrightness_default = SvgLowerBrightness;

// src/components/Icon/icons/LowHardDrive.tsx
import { jsx as jsx581, jsxs as jsxs574 } from "react/jsx-runtime";
function SvgLowHardDrive({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs574(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx581("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx581("path", { d: "M1856 384q40 0 75 15t61 41 41 61 15 75v576H0V576q0-40 15-75t41-61 61-41 75-15h1664zm64 192q0-26-19-45t-45-19H192q-26 0-45 19t-19 45v448h1792V576zm-256 64h128v128h-128V640zm-256 0h128v128h-128V640zM0 1280h2048v384H0v-384zm1920 128h-512l-128 128h640v-128z" })
      ]
    }
  );
}
var LowHardDrive_default = SvgLowHardDrive;

// src/components/Icon/icons/MailSearch.tsx
import { jsx as jsx582, jsxs as jsxs575 } from "react/jsx-runtime";
function SvgMailSearch({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs575(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx582("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx582("path", { d: "M2048 256v639q-28-28-60-50t-68-42V520l-896 447-896-447v888h1009q16 67 50 128H0V256h2048zM1024 825l881-441H143l881 441zm640 71q79 0 149 30t122 82 83 123 30 149q0 80-30 149t-82 122-123 83-149 30q-60 0-117-18t-105-53l-437 436q-19 19-45 19t-45-19-19-45q0-26 19-45l436-437q-35-48-53-105t-18-117q0-79 30-149t82-122 122-83 150-30zm0 640q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100q0 53 20 99t55 82 81 55 100 20z" })
      ]
    }
  );
}
var MailSearch_default = SvgMailSearch;

// src/components/Icon/icons/Mask.tsx
import { jsx as jsx583, jsxs as jsxs576 } from "react/jsx-runtime";
function SvgMask({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs576(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx583("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx583("path", { d: "M1472 384q40 0 75 15t61 41 41 61 15 75q0 40-15 75t-41 61-61 41-75 15h-64q-53 0-100-20t-81-54-55-82-20-100q28-17 70-39t87-42 88-33 75-14zm0 256q26 0 45-19t19-45q0-26-19-45t-45-19q-13 0-37 8t-51 18-51 22-35 18q20 29 47 45t63 17h64zM384 576q0-40 15-75t41-61 61-41 75-15q31 0 74 13t89 34 87 42 70 39q0 53-20 100t-54 81-82 55-100 20h-64q-40 0-75-15t-61-41-41-61-15-75zm366 2q-13-6-36-17t-50-22-50-19-38-8q-26 0-45 19t-19 45q0 26 19 45t45 19h64q36 0 63-16t47-46zM1984 0q26 0 45 19t19 45q0 252-68 482t-197 447l-2 4q-1 2-2 3-35 35-68 63t-69 48-77 30-93 11q-66 0-118-19t-92-47-73-62-60-61-53-48-52-19q-27 0-52 19t-53 47-60 62-73 61-92 48-118 19q-76 0-142-28t-121-81l-31-31q-14-14-26-34v1070H128V719Q65 562 33 398T0 64q0-26 19-45T64 0q24 0 36 9t18 24 10 31 9 31 19 23 36 10h327q69 0 133 16t125 45q31 15 60 27t59 22 60 13 68 5q36 0 67-4t61-14 58-21 61-28q61-29 125-45t133-16h327q24 0 36-9t18-24 10-31 9-31 19-23 36-10zm-512 1024q63 0 114-28t91-76q14-16 25-39t21-43q74-138 121-286t65-304q-27 8-53 8h-327q-106 0-200 47-38 19-74 34t-73 25-76 16-82 6q-70 0-138-16t-131-47q-60-30-114-47t-122-18H192q-26 0-53-8 17 149 61 292t114 277q11 23 26 53t31 50q39 48 90 76t115 28q54 0 94-19t74-47 62-61 60-62 69-47 89-19q50 0 88 19t70 47 61 61 62 62 73 47 94 19z" })
      ]
    }
  );
}
var Mask_default = SvgMask;

// src/components/Icon/icons/MediaDisc.tsx
import { jsx as jsx584, jsxs as jsxs577 } from "react/jsx-runtime";
function SvgMediaDisc({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs577(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx584("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx584("path", { d: "M1023 1q142 0 273 36t245 103 207 160 159 207 103 245 37 273q0 141-36 272t-103 245-160 207-208 160-245 103-272 37q-141 0-271-36t-245-104-207-160-161-208-103-244-37-272q0-141 36-272t103-245 160-207 208-160T750 38t273-37zm0 1920q123 0 237-32t215-90 182-141 140-181 91-214 32-238q0-124-32-238t-90-214-141-182-181-140-214-91-239-32q-123 0-237 32t-214 90-182 141-140 182-91 214-32 238q0 123 32 237t90 214 141 182 181 140 214 91 238 32zm0-1152q53 0 100 20t81 54 55 82 20 100q0 53-20 99t-55 81-81 55-100 20q-53 0-99-20t-81-54-55-81-20-100q0-53 20-99t54-82 81-55 100-20zm0 383q26 0 49-10t41-27 28-40 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-27 41-10 50q0 26 10 49t27 41 40 27 50 10z" })
      ]
    }
  );
}
var MediaDisc_default = SvgMediaDisc;

// src/components/Icon/icons/MediaDvd.tsx
import { jsx as jsx585, jsxs as jsxs578 } from "react/jsx-runtime";
function SvgMediaDvd({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs578(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx585("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx585("path", { d: "M1023 1q142 0 273 36t245 103 207 160 159 207 103 245 37 273q0 141-36 272t-103 245-160 207-208 160-245 103-272 37q-141 0-271-36t-245-104-207-160-161-208-103-244-37-272q0-141 36-272t103-245 160-207 208-160T750 38t273-37zm0 1920q123 0 237-32t215-90 182-141 140-181 91-214 32-238q0-124-32-238t-90-214-141-182-181-140-214-91-239-32q-123 0-237 32t-214 90-182 141-140 182-91 214-32 238q0 123 32 237t90 214 141 182 181 140 214 91 238 32zm0-1152q53 0 100 20t81 54 55 82 20 100q0 53-20 99t-55 81-81 55-100 20q-53 0-99-20t-81-54-55-81-20-100q0-53 20-99t54-82 81-55 100-20zm0 383q26 0 49-10t41-27 28-40 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-27 41-10 50q0 26 10 49t27 41 40 27 50 10z" })
      ]
    }
  );
}
var MediaDvd_default = SvgMediaDvd;

// src/components/Icon/icons/MediaHdDvd.tsx
import { jsx as jsx586, jsxs as jsxs579 } from "react/jsx-runtime";
function SvgMediaHdDvd({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs579(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx586("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx586("path", { d: "M768 1152h1280v896H768v-896zm128 768h1024v-640H896v640zm704-512q43 0 78 14t61 39 39 60 14 79q0 88-52 140t-140 52h-128v-384h128zm0 256q35 0 49-15t15-49q0-33-15-48t-49-16v128zm-320-256h128v384h-128v-128h-128v128h-128v-384h128v128h128v-128zm-256-512q-27 0-50 10t-40 27-28 41-10 50H768q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100h-128q0-27-10-50t-27-40-41-28-50-10zM1005 0h38q91 4 176 19t171 48q143 55 264 150t208 219 137 269 49 300v19h-127q0-124-32-238t-90-214-141-182-181-140-214-91-239-32q-124 0-238 32t-214 90-182 141-140 181-91 214-32 239q0 130 36 252t103 227 162 189 212 141v141q-140-57-257-152t-202-218-133-266-48-295v-38q4-91 19-176t48-171q55-143 150-264t219-208T705 49t300-49z" })
      ]
    }
  );
}
var MediaHdDvd_default = SvgMediaHdDvd;

// src/components/Icon/icons/MediaMusic.tsx
import { jsx as jsx587, jsxs as jsxs580 } from "react/jsx-runtime";
function SvgMediaMusic({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs580(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx587("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx587("path", { d: "M1792 1408q0 62-29 109t-76 80-104 50-111 17q-54 0-111-17t-103-49-76-80-30-110q0-61 29-109t76-80 104-50 111-17q51 0 99 12t93 39V226L768 450v1214q0 62-29 109t-76 80-104 50-111 17q-54 0-111-17t-103-49-76-80-30-110q0-61 29-109t76-80 104-50 111-17q51 0 99 12t93 39V350L1792 62v1346zM448 1792q27 0 60-8t62-23 50-40 20-57q0-33-20-57t-49-39-63-24-60-8q-27 0-60 8t-62 23-50 40-20 57q0 33 20 57t49 39 63 24 60 8zm1024-256q27 0 60-8t62-23 50-40 20-57q0-33-20-57t-49-39-63-24-60-8q-27 0-60 8t-62 23-50 40-20 57q0 33 20 57t49 39 63 24 60 8z" })
      ]
    }
  );
}
var MediaMusic_default = SvgMediaMusic;

// src/components/Icon/icons/MediaRemote.tsx
import { jsx as jsx588, jsxs as jsxs581 } from "react/jsx-runtime";
function SvgMediaRemote({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs581(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx588("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx588("path", { d: "M1280 0q40 0 75 15t61 41 41 61 15 75v1664q0 40-15 75t-41 61-61 41-75 15H768q-40 0-75-15t-61-41-41-61-15-75V192q0-40 15-75t41-61 61-41 75-15h512zm64 192q0-26-19-45t-45-19H768q-26 0-45 19t-19 45v1664q0 26 19 45t45 19h512q26 0 45-19t19-45V192zm-320 64q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45q0-26 19-45t45-19z" })
      ]
    }
  );
}
var MediaRemote_default = SvgMediaRemote;

// src/components/Icon/icons/Megaphone.tsx
import { jsx as jsx589, jsxs as jsxs582 } from "react/jsx-runtime";
function SvgMegaphone({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs582(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx589("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx589("path", { d: "M0 768h27q17 0 35 1t35 1 25-2l1798-320q9-1 26-1t36-1 37 1 29 1v1152h-30q-19 0-41 1t-40 0-28-2l-763-136q-10 57-38 106t-71 84-94 55-111 20q-66 0-124-25t-102-68-69-102-25-125q0-28 6-57l-264-47q-19-4-35-7t-31-6-31-5-35-6q-12-1-27-1t-33-1-33 1-29 1V768zm832 832q35 0 67-12t57-33 42-51 23-64l-378-67q-3 18-3 35 0 40 15 75t41 61 61 41 75 15zM1920 577L128 896v256q7 0 11 1l1781 318V577z" })
      ]
    }
  );
}
var Megaphone_default = SvgMegaphone;

// src/components/Icon/icons/MemoryUnitExternal.tsx
import { jsx as jsx590, jsxs as jsxs583 } from "react/jsx-runtime";
function SvgMemoryUnitExternal({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs583(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx590("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx590("path", { d: "M1344 640q40 0 75 15t61 41 41 61 15 75v640q0 17 2 47t7 61 14 60 22 42q10 11 15 21t6 25q0 29-19 46t-47 18H384q-28 0-47-18t-19-46q0-14 5-24t15-21q13-14 22-42t14-59 8-62 2-48V832q0-40 15-75t41-61 61-41 75-15h64V128h640v512h64zm-576 0h384V256h-128v256H896V256H768v384zm665 1024q-14-47-19-95t-6-97V832q0-26-19-45t-45-19H576q-26 0-45 19t-19 45v640q0 49-5 97t-20 95h946zM639 895h641v129H639V895z" })
      ]
    }
  );
}
var MemoryUnitExternal_default = SvgMemoryUnitExternal;

// src/components/Icon/icons/MemoryUnitInternal.tsx
import { jsx as jsx591, jsxs as jsxs584 } from "react/jsx-runtime";
function SvgMemoryUnitInternal({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs584(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx591("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx591("path", { d: "M1600 192q58 0 93 35t35 93v1410q0 26-10 49t-28 40-41 27-50 10H448q-26 0-49-10t-40-29-28-41-11-49V575q0-25 10-48t28-40 41-28 48-11h281l102-202q13-25 35-39t51-14l684-1zM872 448h728V320l-665 1-63 127zm728 1280V576H450l-2 3v1147l2 2h1150z" })
      ]
    }
  );
}
var MemoryUnitInternal_default = SvgMemoryUnitInternal;

// src/components/Icon/icons/Menu.tsx
import { jsx as jsx592, jsxs as jsxs585 } from "react/jsx-runtime";

// src/components/Icon/icons/Message.tsx
import { jsx as jsx593, jsxs as jsxs586 } from "react/jsx-runtime";
function SvgMessage({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs586(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx593("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx593("path", { d: "M0 384h2048v1280H0V384zm1905 128H143l881 440 881-440zM128 1536h1792V648l-896 448-896-448v888z" })
      ]
    }
  );
}
var Message_default = SvgMessage;

// src/components/Icon/icons/MessageFriendRequest.tsx
import { jsx as jsx594, jsxs as jsxs587 } from "react/jsx-runtime";
function SvgMessageFriendRequest({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs587(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx594("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx594("path", { d: "M2048 384v768q-12-23-26-49t-31-51-35-50-36-42V640l-896 448-896-448v896h960l64 128H0V384h2048zm-143 128H143l881 440 881-440zm-97 1075q55 29 99 71t76 94 48 110 17 122v64h-128v-64q0-66-25-124t-69-101-102-69-124-26q-66 0-124 25t-102 69-69 102-25 124v64h-128v-64q0-63 16-121t48-110 76-94 100-72q-54-46-83-109t-29-134q0-66 25-124t68-101 102-69 125-26q66 0 124 25t101 69 69 102 26 124q0 70-29 133t-83 110zm-400-243q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75z" })
      ]
    }
  );
}
var MessageFriendRequest_default = SvgMessageFriendRequest;

// src/components/Icon/icons/MessageJoinParty.tsx
import { jsx as jsx595, jsxs as jsxs588 } from "react/jsx-runtime";
function SvgMessageJoinParty({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs588(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx595("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx595("path", { d: "M1907 1335q66 45 103 115t38 150h-128q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 52-20 99t-57 84q66 45 103 115t38 150h-128q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75H960q0-80 37-150t104-115q-37-36-57-83t-20-100q0-53 20-99t55-82 81-55 100-20q52 0 99 20t84 57q35-51 86-86-37-36-57-83t-20-100q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100q0 52-20 99t-57 84zm-627 393q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10zm320-576q0 27 10 50t27 40 41 28 50 10q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50zm448-768v556q-50-74-128-120V648l-896 448-896-448v888h768v128H0V384h2048zm-143 128H143l881 440 881-440z" })
      ]
    }
  );
}
var MessageJoinParty_default = SvgMessageJoinParty;

// src/components/Icon/icons/MessageReply.tsx
import { jsx as jsx596, jsxs as jsxs589 } from "react/jsx-runtime";
function SvgMessageReply({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs589(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx596("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx596("path", { d: "M1262 129q149 49 270 135t208 203 133 257 47 300q0 134-33 262t-96 242-150 209-196 165-234 107-264 39q-107 0-209-22t-196-65-179-105-155-142l96-84q61 69 134 123t156 91 172 56 181 20q120 0 229-34t203-95 170-145 130-183 83-211 30-228q0-138-41-260t-116-223-182-175-237-117v263h-129V0h512v129h-337z" })
      ]
    }
  );
}
var MessageReply_default = SvgMessageReply;

// src/components/Icon/icons/MessageSend.tsx
import { jsx as jsx597, jsxs as jsxs590 } from "react/jsx-runtime";
function SvgMessageSend({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs590(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx597("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx597("path", { d: "M640 512h1408v896H640V512zm1233 128H815l529 264 529-264zM768 1280h1152V760l-576 288-576-288v520zM0 768V640h512v128H0zm128 256V896h384v128H128zm128 256v-128h256v128H256z" })
      ]
    }
  );
}
var MessageSend_default = SvgMessageSend;

// src/components/Icon/icons/MessageSendMirrored.tsx
import { jsx as jsx598, jsxs as jsxs591 } from "react/jsx-runtime";
function SvgMessageSendMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs591(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx598("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx598("path", { d: "M1408 512H0v896h1408V512zM175 640h1058L704 904 175 640zm1105 640H128V760l576 288 576-288v520zm768-512V640h-512v128h512zm-128 256V896h-384v128h384zm-128 256v-128h-256v128h256z" })
      ]
    }
  );
}
var MessageSendMirrored_default = SvgMessageSendMirrored;

// src/components/Icon/icons/MessageVideo.tsx
import { jsx as jsx599, jsxs as jsxs592 } from "react/jsx-runtime";
function SvgMessageVideo({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs592(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx599("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx599("path", { d: "M2048 384v384h-128V584l-369 184h-286l512-256H271l753 376v144L128 584v952h896v128H0V384h2048zm-896 512h896v1152h-896V896zm128 1024h640v-896h-640v896zm320-768q53 0 99 20t82 55 55 81 20 100q0 53-20 99t-55 82-81 55-100 20q-53 0-99-20t-82-55-55-81-20-100q0-53 20-99t55-82 81-55 100-20zm0 384q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10z" })
      ]
    }
  );
}
var MessageVideo_default = SvgMessageVideo;

// src/components/Icon/icons/MessageVoice.tsx
import { jsx as jsx600, jsxs as jsxs593 } from "react/jsx-runtime";
function SvgMessageVoice({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs593(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx600("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx600("path", { d: "M1792 1664q27 0 50-10t40-27 28-41 10-50v-384h128v384q0 53-20 99t-55 82-81 55-100 20h-128v128h128v128h-384v-128h128v-128h-128q-53 0-99-20t-82-55-55-81-20-100v-384h128v384q0 27 10 50t27 40 41 28 50 10h384zm-288-128q-40 0-68-28t-28-68V992q0-40 28-68t68-28h192q40 0 68 28t28 68v448q0 40-28 68t-68 28h-192zm32-128h128v-384h-128v384zm512-1024v640h-128V648l-241 120h-286l512-256H143l881 440 256-128v144l-256 128-896-448v888h896v128H0V384h2048z" })
      ]
    }
  );
}
var MessageVoice_default = SvgMessageVoice;

// src/components/Icon/icons/MicOff.tsx
import { jsx as jsx601, jsxs as jsxs594 } from "react/jsx-runtime";
function SvgMicOff({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs594(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx601("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx601("path", { d: "M704 128q-27 0-45 18t-19 46v132L512 196q0-40 14-76t40-62 61-42 77-16h512q40 0 75 15t61 41 41 61 15 75v900l-128-128V192q0-27-18-45t-46-19H704zm959 1219l-127-127v-196h128l-1 323zm276 682l-377-377q-59 67-139 103t-169 37h-230v128h256v128H640v-128h256v-128H666q-85 0-159-32t-130-88-88-130-33-160v-358h128v358q0 58 22 109t61 90 89 60 110 23h588q63 0 119-27t98-75l-102-103q-27 36-67 56t-86 21H704q-40 0-75-15t-61-41-41-61-15-75V603L19 109l90-90 1920 1920-90 90zm-723-621q20 0 36-11t24-30L640 731v613q0 27 18 45t46 19h512z" })
      ]
    }
  );
}
var MicOff_default = SvgMicOff;

// src/components/Icon/icons/MicOff2.tsx
import { jsx as jsx602, jsxs as jsxs595 } from "react/jsx-runtime";
function SvgMicOff2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs595(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx602("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx602("path", { d: "M704 128q-27 0-45 18t-19 46v132L512 196q0-40 14-76t40-62 61-42 77-16h512q40 0 75 15t61 41 41 61 15 75v900l-128-128V192q0-27-18-45t-46-19H704zm959 1219l-127-127v-196h128l-1 323zm276 682l-377-377q-59 67-139 103t-169 37h-230v128h256v128H640v-128h256v-128H666q-85 0-159-32t-130-88-88-130-33-160v-358h128v358q0 58 22 109t61 90 89 60 110 23h588q63 0 119-27t98-75l-102-103q-27 36-67 56t-86 21H704q-40 0-75-15t-61-41-41-61-15-75V603L19 109l90-90 1920 1920-90 90zm-723-621q20 0 36-11t24-30L640 731v613q0 27 18 45t46 19h512z" })
      ]
    }
  );
}
var MicOff2_default = SvgMicOff2;

// src/components/Icon/icons/MicOn.tsx
import { jsx as jsx603, jsxs as jsxs596 } from "react/jsx-runtime";
function SvgMicOn({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs596(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx603("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx603("path", { d: "M704 1536q-40 0-75-15t-61-41-41-61-15-75V192q0-40 15-75t41-61 61-41 75-15h512q40 0 75 15t61 41 41 61 15 75v1152q0 40-15 75t-41 61-61 41-75 15H704zm-64-192q0 26 19 45t45 19h512q26 0 45-19t19-45V192q0-26-19-45t-45-19H704q-26 0-45 19t-19 45v1152zm1024-320v362q0 84-32 158t-87 129-129 87-158 32h-234v128h256v128H640v-128h256v-128H662q-84 0-158-32t-129-87-87-129-32-158v-362h128v362q0 57 22 108t59 88 89 60 108 22h596q57 0 108-22t88-59 60-89 22-108v-362h128z" })
      ]
    }
  );
}
var MicOn_default = SvgMicOn;

// src/components/Icon/icons/MicrosoftPoints.tsx
import { jsx as jsx604, jsxs as jsxs597 } from "react/jsx-runtime";
function SvgMicrosoftPoints({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs597(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx604("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx604("path", { d: "M960 1024q0 49 24 85t61 60 83 35 88 12h791l-26 83q-33 103-86 199t-125 179-157 151-184 117-203 76-216 27q-165 0-314-48t-272-137-216-215-141-285l-26-83h87q63 0 121-13t102-44 71-79 26-120q0-68-27-116t-73-80-102-45-118-15H41l26-83q49-157 141-284t215-216T696 48t314-48q110 0 216 27t203 75 183 117 158 152 124 179 87 199l26 83h-791q-42 0-87 11t-83 36-62 60-24 85zm50 896q133 0 258-45t233-123 192-183 135-225h-612q-70 0-138-21t-123-61-89-101-34-137q0-77 34-137t88-100 123-62 139-21h612q-51-120-135-225t-191-183-233-123-259-45q-131 0-253 35T532 265 347 428 216 647q76 11 142 41t114 77 76 113 28 146q0 83-26 148t-74 113-113 77-146 40q50 122 131 218t184 163 225 102 253 35z" })
      ]
    }
  );
}
var MicrosoftPoints_default = SvgMicrosoftPoints;

// src/components/Icon/icons/MiniGuide.tsx
import { jsx as jsx605, jsxs as jsxs598 } from "react/jsx-runtime";
function SvgMiniGuide({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs598(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx605("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx605("path", { d: "M0 384h2048v1152h-960v128h256v128H704v-128h256v-128H0V384zm1920 1024V512H128v896h1792zm-128-255v127H639v-127h1153zM512 1280H256v-127h256v127z" })
      ]
    }
  );
}
var MiniGuide_default = SvgMiniGuide;

// src/components/Icon/icons/MiniGuideMirrored.tsx
import { jsx as jsx606, jsxs as jsxs599 } from "react/jsx-runtime";
function SvgMiniGuideMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs599(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx606("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx606("path", { d: "M2048 384H0v1152h960v128H704v128h640v-128h-256v-128h960V384zM128 1408V512h1792v896H128zm128-255v127h1153v-127H256zm1280 127h256v-127h-256v127z" })
      ]
    }
  );
}
var MiniGuideMirrored_default = SvgMiniGuideMirrored;

// src/components/Icon/icons/MixerCoStreamingSolid.tsx
import { jsx as jsx607, jsxs as jsxs600 } from "react/jsx-runtime";
function SvgMixerCoStreamingSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs600(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx607("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx607("path", { d: "M1024 1024q53 0 99 20t82 55 55 81 20 100v256H0v-256q0-53 20-99t55-82 81-55 100-20h768zM640 896q-53 0-99-20t-82-55-55-81-20-100q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100q0 53-20 99t-55 82-81 55-100 20zm768 0q-53 0-99-20t-82-55-55-81-20-100q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100q0 53-20 99t-55 82-81 55-100 20zm384 128q53 0 99 20t82 55 55 81 20 100v256h-608v-256q0-70-23-135t-66-121h441z" })
      ]
    }
  );
}
var MixerCoStreamingSolid_default = SvgMixerCoStreamingSolid;

// src/components/Icon/icons/MixerEmbers.tsx
import { jsx as jsx608, jsxs as jsxs601 } from "react/jsx-runtime";
function SvgMixerEmbers({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs601(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx608("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx608("path", { d: "M1024 7l896 499v1036l-896 499-896-499V506L1024 7zm512 648l190-110-638-356v207l448 259zm-512 886l448-259V766l-448-259-448 259v516l448 259zM960 396V189L322 545l190 110 448-259zM448 766L256 655v738l192-111V766zm64 627l-190 110 638 356v-207l-448-259zm576 259v207l638-356-190-110-448 259zm512-370l192 111V655l-192 111v516z" })
      ]
    }
  );
}
var MixerEmbers_default = SvgMixerEmbers;

// src/components/Icon/icons/MixerEmbersSolid.tsx
import { jsx as jsx609, jsxs as jsxs602 } from "react/jsx-runtime";
function SvgMixerEmbersSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs602(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx609("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx609("path", { d: "M576 766l448-259 448 259v516l-448 259-448-259V766zM1024 7l896 499v1036l-896 499-896-499V506L1024 7zm576 1349V692l-576-333-576 333v664l576 333 576-333z" })
      ]
    }
  );
}
var MixerEmbersSolid_default = SvgMixerEmbersSolid;

// src/components/Icon/icons/MixerInteractiveSolid.tsx
import { jsx as jsx610, jsxs as jsxs603 } from "react/jsx-runtime";
function SvgMixerInteractiveSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs603(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx610("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx610("path", { d: "M2048 384v1152H0V384h2048zM896 896H640V640H512v256H256v128h256v256h128v-256h256V896zm384 48q36 0 68-14t56-38 38-56 14-68q0-36-14-68t-38-56-56-38-68-14q-36 0-68 14t-56 38-38 56-14 68q0 36 14 68t38 56 56 38 68 14zm384 384q36 0 68-14t56-38 38-56 14-68q0-36-14-68t-38-56-56-38-68-14q-36 0-68 14t-56 38-38 56-14 68q0 36 14 68t38 56 56 38 68 14z" })
      ]
    }
  );
}
var MixerInteractiveSolid_default = SvgMixerInteractiveSolid;

// src/components/Icon/icons/MixerLogo.tsx
import { jsx as jsx611, jsxs as jsxs604 } from "react/jsx-runtime";
function SvgMixerLogo({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs604(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx611("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx611("path", { d: "M234 256q53 0 100 24t80 67l456 612q20 28 20 64 0 35-20 63l-458 615q-32 44-79 67t-102 24q-47 0-88-17t-72-48-48-72-18-89q0-38 12-74t36-67l299-403L55 623q-23-31-35-68T8 479q0-46 18-87t48-71 72-47 88-18zm1633 1169q23 31 35 67t13 74q0 47-17 88t-48 72-72 48-89 18q-54 0-101-23t-80-68l-458-615q-20-28-20-63 0-36 20-64l456-612q32-42 79-66t101-25q46 0 87 17t72 48 49 71 18 87q0 39-12 76t-35 69l-297 398 299 403zm-180 239q21 0 39-7t31-20 21-31 8-39q0-36-22-66l-356-479 354-475q22-30 22-65 0-43-28-70t-71-28q-23 0-42 11t-34 29l-446 599 448 601q14 18 33 29t43 11z" })
      ]
    }
  );
}
var MixerLogo_default = SvgMixerLogo;

// src/components/Icon/icons/MixerLogotypeInline.tsx
import { jsx as jsx612, jsxs as jsxs605 } from "react/jsx-runtime";
function SvgMixerLogotypeInline({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs605(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 5120 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx612("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx612("path", { d: "M1787 1002q25 0 47 9t38 26 26 39 10 47v862q0 14-9 22t-23 9h-177q-14 0-23-8t-9-23v-862q0-25 9-47t26-38 39-26 46-10zm-641 1q90 0 152 29t102 82 56 127 18 167v577q0 14-9 22t-23 9h-178q-13 0-22-8t-9-23v-526q0-58-7-105t-27-80-55-52-93-19q-46 0-82 23t-61 59-38 83-13 94v522q0 14-9 23t-22 9H648q-13 0-22-9t-9-23v-544q0-121-44-179t-136-58q-49 0-85 22t-61 58-36 83-12 96v523q0 14-9 22t-22 9H34q-13 0-22-8t-9-23v-980h30q37 0 70 12t61 34 46 51 27 65q35-55 85-91t107-55 116-19 112 21 96 59 68 99q57-88 135-133t190-45zm1510 498q13 19 0 37l-339 455q-15 21-37 33t-47 14-48-4-45-26q-18-16-27-36t-11-43 4-44 21-42l243-326-241-323q-14-19-20-41t-6-44 11-43 27-37q20-18 44-25t49-6 47 15 38 33l337 453zm406-453q15-21 37-33t46-14 49 4 45 26q17 16 26 36t11 43-4 45-21 41l-241 323 243 326q14 19 20 41t5 45-11 42-27 37q-20 18-44 25t-48 6-47-15-38-33l-338-456q-13-18 0-37l337-452zm645 210q-59 61-77 153h420q-3-103-51-159-53-57-145-57-82 0-147 63zm467 676q9 11 6 26t-17 21q-61 28-142 45t-168 15-171-28-151-86-107-156-41-240q0-138 43-238t113-166 157-96 176-30 168 34 136 94q34 37 56 79t35 88 18 94 5 99q0 22-8 41t-23 34-34 23-42 9h-554q5 73 31 121t64 76 84 41 93 12 90-7 74-19q8-2 17 0t14 10l78 104zm841-916q10 3 16 11t6 20v168q0 16-13 25t-29 4q-71-26-126-16t-93 48-59 98-20 134v475q0 14-9 22t-23 9h-177q-14 0-23-8t-9-23v-980h31q40 0 75 14t63 38 46 58 23 71q29-66 76-109t111-63q8-2 24-3t35-1 39 2 36 6zM1659 704q0-27 10-50t27-41 41-28 50-10q27 0 50 10t42 27 28 41 10 51q0 26-10 49t-27 41-41 28-51 10q-27 0-50-10t-41-27-28-41-10-50z" })
      ]
    }
  );
}
var MixerLogotypeInline_default = SvgMixerLogotypeInline;

// src/components/Icon/icons/MixerPoll.tsx
import { jsx as jsx613, jsxs as jsxs606 } from "react/jsx-runtime";
function SvgMixerPoll({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs606(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx613("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx613("path", { d: "M384 768h256v896H384V768zm1024 384h256v512h-256v-512zM896 384h256v1280H896V384zM1856 0q40 0 75 15t61 41 41 61 15 75v1664q0 40-15 75t-41 61-61 41-75 15H192q-40 0-75-15t-61-41-41-61-15-75V192q0-40 15-75t41-61 61-41 75-15h1664zm64 192q0-26-19-45t-45-19H192q-26 0-45 19t-19 45v1664q0 26 19 45t45 19h1664q26 0 45-19t19-45V192z" })
      ]
    }
  );
}
var MixerPoll_default = SvgMixerPoll;

// src/components/Icon/icons/MixerPollSolid.tsx
import { jsx as jsx614, jsxs as jsxs607 } from "react/jsx-runtime";
function SvgMixerPollSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs607(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx614("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx614("path", { d: "M1728 128q40 0 75 15t61 41 41 61 15 75v1408q0 40-15 75t-41 61-61 41-75 15H320q-40 0-75-15t-61-41-41-61-15-75V320q0-40 15-75t41-61 61-41 75-15h1408zM640 768H384v896h256V768zm512-384H896v1280h256V384zm512 768h-256v512h256v-512z" })
      ]
    }
  );
}
var MixerPollSolid_default = SvgMixerPollSolid;

// src/components/Icon/icons/MixerSkillsStar.tsx
import { jsx as jsx615, jsxs as jsxs608 } from "react/jsx-runtime";
function SvgMixerSkillsStar({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs608(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx615("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx615("path", { d: "M793 1792q26 0 49 10t40 29 28 41 11 49q0 26-10 49t-28 40-41 27-49 11q-26 0-48-10t-39-27-26-39-10-49q0-27 9-50t25-42 39-28 50-11zM2008 635q0 58-11 118t-33 118-54 110-73 94l-141 141-480 480q-15 15-29 30t-30 26-34 19-42 8q-26 0-49-10t-40-28-27-40-11-49q0-30 12-54t32-44 42-40 41-39 32-45 13-54q0-26-10-49t-28-40-41-28-49-11q-24 0-43 8t-35 21-32 29-31 32l-563 563q-18 18-41 28t-49 10q-26 0-49-10t-40-28-27-40-11-49q0-26 10-49t28-41l199-199 364-365q15-15 31-30t29-31 21-36 9-43q0-26-10-49t-28-40-41-28-49-11q-25 0-44 8t-35 21-31 28-31 32l-243 237q-18 18-41 28t-49 10q-26 0-49-10t-40-28-27-40-11-49q0-26 10-49t28-41q61-60 122-118t121-119q123-121 243-242t243-244l128-128q44-44 96-78t109-57 119-36 124-12q131 0 245 49t199 136 133 201 49 246zm-179 38q0-99-37-185t-102-150-151-101-185-37q-99 0-185 37t-151 102-102 151-38 185q0 98 37 185t102 151 152 102 185 38q99 0 185-37t151-103 102-152 37-186zm-184-116q0-10 6-17t16-7q11 0 19 19t13 43 7 48 3 33q0 72-27 135t-75 110-111 75-134 28q-9 0-33-2t-50-8-44-13-20-20q0-14 8-17t19-4h11q5 0 11 1 80 0 150-29t121-81 81-120 30-150v-12q0-6-1-12z" })
      ]
    }
  );
}
var MixerSkillsStar_default = SvgMixerSkillsStar;

// src/components/Icon/icons/MixerSparksSolid.tsx
import { jsx as jsx616, jsxs as jsxs609 } from "react/jsx-runtime";
function SvgMixerSparksSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs609(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx616("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx616("path", { d: "M676 2048l220-768H384L1265 0l-241 768h544L676 2048z" })
      ]
    }
  );
}
var MixerSparksSolid_default = SvgMixerSparksSolid;

// src/components/Icon/icons/MixerTrending.tsx
import { jsx as jsx617, jsxs as jsxs610 } from "react/jsx-runtime";
function SvgMixerTrending({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs610(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx617("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx617("path", { d: "M1237 0q15 215 100 392t234 331q121 126 185 270t65 322q0 153-57 286t-157 233-233 157-287 57q-102 0-196-26t-175-74-148-115-114-149-74-176-26-196q0-99 26-194t79-179q21 42 45 83t55 73 72 53 93 20q45 0 85-17t70-47 48-70 18-85q0-40-12-71t-34-64q-48-74-76-146t-28-163q0-95 34-181t93-154 140-113 175-57zm-150 1920q84 0 162-21t145-61 122-94 95-122 60-145 22-162q0-147-54-272t-158-231q-135-135-225-296t-126-350q-47 25-85 61t-66 81-42 95-15 104q0 49 11 88t28 72 36 64 37 63 28 70 11 85q0 72-27 135t-75 110-111 75-136 27q-132 0-232-89-9 53-9 106 0 126 47 236t129 193 192 130 236 48z" })
      ]
    }
  );
}
var MixerTrending_default = SvgMixerTrending;

// src/components/Icon/icons/MixerTrendingSolid.tsx
import { jsx as jsx618, jsxs as jsxs611 } from "react/jsx-runtime";
function SvgMixerTrendingSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs611(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx618("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx618("path", { d: "M1237 0q15 215 100 392t234 331q121 126 185 270t65 322q0 153-57 286t-157 233-233 157-287 57q-102 0-196-26t-175-74-148-115-114-149-74-176-26-196q0-99 26-194t79-179q21 42 45 83t55 73 72 53 93 20q45 0 85-17t70-47 48-70 18-85q0-40-12-71t-34-64q-48-74-76-146t-28-163q0-95 34-181t93-154 140-113 175-57z" })
      ]
    }
  );
}
var MixerTrendingSolid_default = SvgMixerTrendingSolid;

// src/components/Icon/icons/MixerVideoFeedback.tsx
import { jsx as jsx619, jsxs as jsxs612 } from "react/jsx-runtime";
function SvgMixerVideoFeedback({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs612(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx619("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx619("path", { d: "M1664 512h128v128h-128V512zM256 1152v-128h128v128H256zm128-640v128H256V512h128zm0 256v128H256V768h128zm1024 768v-384h128v384h-128zm0 256v-128h128v128h-128zM0 128h2048v888q-55-70-128-126V256h-128v128h-128V256H384v128H256V256H128v1152h128v-128h128v128h384v128H0V128zm1472 768q79 0 153 20t137 58 116 90 90 117 58 137 21 154q0 80-20 153t-58 138-90 116-116 90-138 58-153 21q-119 0-224-45t-183-124-123-183-46-224q0-119 45-224t124-183 183-123 224-46zm447 576q0-93-35-174t-95-142-142-96-175-36q-93 0-174 35t-142 96-96 142-36 175q0 93 35 174t96 142 142 96 175 36q93 0 174-35t142-96 96-142 35-175z" })
      ]
    }
  );
}
var MixerVideoFeedback_default = SvgMixerVideoFeedback;

// src/components/Icon/icons/MixerVideoFeedbackSolid.tsx
import { jsx as jsx620, jsxs as jsxs613 } from "react/jsx-runtime";
function SvgMixerVideoFeedbackSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs613(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx620("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx620("path", { d: "M1472 896q79 0 153 20t137 58 116 90 90 117 58 137 21 154q0 80-20 153t-58 138-90 116-116 90-138 58-153 21q-119 0-224-45t-183-124-123-183-46-224q0-119 45-224t124-183 183-123 224-46zm64 896v-128h-128v128h128zm0-256v-384h-128v384h128zM0 128h2048v888q-53-66-117-118t-138-88-155-55-166-19q-101 0-195 26t-176 75-149 115-115 149-74 176-27 195q0 16 1 32t3 32H0V128zm384 1280v-128H256v128h128zm0-256v-128H256v128h128zm0-256V768H256v128h128zm0-256V512H256v128h128zm0-256V256H256v128h128zm1408 256V512h-128v128h128zm0-256V256h-128v128h128z" })
      ]
    }
  );
}
var MixerVideoFeedbackSolid_default = SvgMixerVideoFeedbackSolid;

// src/components/Icon/icons/MixerViewers.tsx
import { jsx as jsx621, jsxs as jsxs614 } from "react/jsx-runtime";
function SvgMixerViewers({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs614(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx621("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx621("path", { d: "M1024 384q162 0 315 44t286 127 240 200 180 263v3q0 2 1 3 0 4-1 6-76 146-182 263t-238 200-283 127-318 44q-162 0-315-44t-286-127-240-200T3 1030q0-1-1-3t-1-3q0-2 2-6 76-146 182-263t238-200 283-127 318-44zm512 640q0-106-40-199t-110-162-163-110-199-41q-106 0-199 40T663 662 553 825t-41 199q0 106 40 199t110 162 163 110 199 41q106 0 199-40t162-110 110-163 41-199zm-1391 0q30 53 68 105t84 99 97 89 104 71q-56-81-85-173t-29-191q0-98 29-190t85-174q-53 30-104 71t-96 88-84 100-69 105zm1405 364q53-30 104-71t96-88 84-100 69-105q-30-53-68-105t-84-99-97-89-104-71q56 81 85 173t29 191q0 98-29 190t-85 174zm-782-364q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100q0 53-20 99t-55 82-81 55-100 20q-53 0-99-20t-82-55-55-81-20-100z" })
      ]
    }
  );
}
var MixerViewers_default = SvgMixerViewers;

// src/components/Icon/icons/MixerViewersSolid.tsx
import { jsx as jsx622, jsxs as jsxs615 } from "react/jsx-runtime";
function SvgMixerViewersSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs615(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx622("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx622("path", { d: "M1024 384q163 0 317 45t287 128 241 201 179 266q-71 147-178 265t-241 202-288 128-317 45q-164 0-317-45t-287-128-241-201T0 1024q71-147 178-265t241-202 287-128 318-45zm0 1152q106 0 199-40t163-109 110-163 40-200q0-106-40-199t-109-163-163-110-200-40q-106 0-199 40T662 661 552 824t-40 200q0 106 40 199t109 163 163 110 200 40zm0-768q53 0 99 20t82 55 55 81 20 100q0 53-20 99t-55 82-81 55-100 20q-53 0-99-20t-82-55-55-81-20-100q0-53 20-99t55-82 81-55 100-20z" })
      ]
    }
  );
}
var MixerViewersSolid_default = SvgMixerViewersSolid;

// src/components/Icon/icons/ModeSelector.tsx
import { jsx as jsx623, jsxs as jsxs616 } from "react/jsx-runtime";
function SvgModeSelector({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs616(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx623("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx623("path", { d: "M0 512h2048v1024H0V512zm512 896V640H128v768h384zm896 0V640H640v768h768zm512 0V640h-384v768h384z" })
      ]
    }
  );
}
var ModeSelector_default = SvgModeSelector;

// src/components/Icon/icons/MoreActions.tsx
import { jsx as jsx624, jsxs as jsxs617 } from "react/jsx-runtime";
function SvgMoreActions({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs617(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx624("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx624("path", { d: "M256 896q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10zm768 0q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10zm768 0q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10z" })
      ]
    }
  );
}
var MoreActions_default = SvgMoreActions;

// src/components/Icon/icons/MoreVertical.tsx
import { jsx as jsx625, jsxs as jsxs618 } from "react/jsx-runtime";
function SvgMoreVertical({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs618(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx625("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx625("path", { d: "M1024 1664q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10zm0-768q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10zm0-512q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10z" })
      ]
    }
  );
}
var MoreVertical_default = SvgMoreVertical;

// src/components/Icon/icons/MostPopular.tsx
import { jsx as jsx626, jsxs as jsxs619 } from "react/jsx-runtime";
function SvgMostPopular({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs619(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx626("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx626("path", { d: "M1444 1344h-427l364 320-37 128-320-256-640 512 248-794L0 768h784L1024 0l240 768h784l-632 486 28 90zm310 96h294l-237 182 93 298-240-185-240 185 93-298-237-182h294l90-288 90 288z" })
      ]
    }
  );
}
var MostPopular_default = SvgMostPopular;

// src/components/Icon/icons/Mounts.tsx
import { jsx as jsx627, jsxs as jsxs620 } from "react/jsx-runtime";
function SvgMounts({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs620(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx627("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx627("path", { d: "M1733 571q5 11 15 28t19 37 17 38 8 30v96q0 17-9 33t-26 24q-20 11-44 25t-49 14q-14 0-28 1t-29 0-28-5-24-15l-110-109h-37v274l340 113q20 7 32 24t12 37v256q0 15-7 30t-21 23l-97 64q-9 6-16 8t-19 3q-26 0-45-19t-19-46q0-16 7-29t21-23l68-45v-176l-256-85q0 30-2 46t-7 30-16 30-25 48q10 11 14 24 5 14 20 55t34 94 40 112 39 110 29 87 12 43q0 27-19 45t-45 19q-20 0-37-11t-24-31l-126-359-450-225-191 191 171 342q7 16 7 29 0 26-19 45t-45 19q-18 0-33-9t-24-26l-125-250q-9-18-16-33t-13-31-15-29-19-32l-15-15q-13-13-32-33t-41-41-42-43-35-34-20-20l-74 148 177 355q7 16 7 29 0 26-19 45t-45 19q-18 0-33-9t-24-26l-207-413 136-271v-113q0-76 33-143t95-113v-58q0-29-10-56-15-36-47-57t-71-21q-27 0-50 10t-40 27-28 41-10 50q0 32 14 62t33 64 32 70 15 82q0 78-42 141t-114 94l-50-118q35-14 56-46t22-71q0-33-14-63t-33-63-32-69-15-83q0-53 20-100t54-81 82-55 100-20q55 0 102 20t81 56 53 84 20 102q31-6 64-6h321q6-108 51-201t118-163 170-108 204-40h160q26 0 45 19t19 45v64l384-128-315 315zm-69 148l-16-32q-11-22-26-49t-30-58-27-56-21-47-8-30v-63h-96q-86 0-161 33t-132 89-90 132-33 162q0 17-1 34t-8 31-20 22-35 9H576q-40 0-75 15t-61 41-41 61-15 75v101l192 193 192-193v-101q0-26 19-45t45-19q30 0 44 16t18 41 4 50-2 45l317 159 67-134V704q0-26 19-45t45-19h128q26 0 45 19l110 109h22l15-8v-41z" })
      ]
    }
  );
}
var Mounts_default = SvgMounts;

// src/components/Icon/icons/Mouse.tsx
import { jsx as jsx628, jsxs as jsxs621 } from "react/jsx-runtime";
function SvgMouse({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs621(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx628("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx628("path", { d: "M1184 0q100 0 187 37t153 103 102 152 38 188v864q0 97-25 187t-71 168-110 143-142 110-169 71-187 25q-97 0-187-25t-168-71-143-110-110-142-71-169-25-187V480q0-100 37-187t103-153T548 38 736 0h448zm352 480q0-73-27-137t-76-112-112-75-137-28h-160v640H896V128H736q-73 0-137 27t-112 76-75 112-28 137v864q0 119 45 224t124 183 183 123 224 46q119 0 224-45t183-124 123-183 46-224V480z" })
      ]
    }
  );
}
var Mouse_default = SvgMouse;

// src/components/Icon/icons/Mouth.tsx
import { jsx as jsx629, jsxs as jsxs622 } from "react/jsx-runtime";
function SvgMouth({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs622(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx629("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx629("path", { d: "M1152 640q13 0 29 7l832 416q35 18 35 58 0 14-6 25t-16 22q-98 91-217 160t-249 115-267 69-269 24q-132 0-268-23t-267-70-250-115-217-160q-10-10-16-21t-6-26q0-40 35-58l832-416q16-7 29-7 24 0 36 9t19 24 9 31 10 31 18 23 36 10q24 0 36-9t18-24 9-31 10-31 18-23 37-10zm-128 256q-53 0-98-27t-71-73l-456 228h1250l-456-228q-26 46-71 73t-98 27zm0 512q220 0 429-63t389-193H206q180 129 389 192t429 64z" })
      ]
    }
  );
}
var Mouth_default = SvgMouth;

// src/components/Icon/icons/Move.tsx
import { jsx as jsx630, jsxs as jsxs623 } from "react/jsx-runtime";
function SvgMove({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs623(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx630("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx630("path", { d: "M640 1024H245l206 205-91 91L0 960l360-360 91 91-206 205h395v128zm920-424l360 360-356 355-90-90 201-201h-395V896h395l-206-205 91-91zM896 245L695 446l-90-90L960 0l360 360-91 91-205-206v395H896V245zm128 1430l205-206 91 91-360 360-360-360 91-91 205 206v-395h128v395z" })
      ]
    }
  );
}
var Move_default = SvgMove;

// src/components/Icon/icons/MoveToBack.tsx
import { jsx as jsx631, jsxs as jsxs624 } from "react/jsx-runtime";
function SvgMoveToBack({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs624(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx631("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx631("path", { d: "M1919 0v1665H283l210 210-90 90-366-365 366-365 90 90-211 211h1510V129H127v1023L0 1280V0h1919z" })
      ]
    }
  );
}
var MoveToBack_default = SvgMoveToBack;

// src/components/Icon/icons/MoveToFront.tsx
import { jsx as jsx632, jsxs as jsxs625 } from "react/jsx-runtime";
function SvgMoveToFront({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs625(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx632("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx632("path", { d: "M1792 1920V896l128-128v1280H0V384h1701l-210-211 90-90 365 365-365 365-90-90 210-211H128v1408h1664z" })
      ]
    }
  );
}
var MoveToFront_default = SvgMoveToFront;

// src/components/Icon/icons/Movies.tsx
import { jsx as jsx633, jsxs as jsxs626 } from "react/jsx-runtime";
function SvgMovies({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs626(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx633("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx633("path", { d: "M0 256h2048v1408H0V256zm1920 1280V384h-128v128h-128V384H384v128H256V384H128v1152h128v-128h128v128h1280v-128h128v128h128zM256 768V640h128v128H256zm0 256V896h128v128H256zm0 256v-128h128v128H256zm1408-512V640h128v128h-128zm0 256V896h128v128h-128zm0 256v-128h128v128h-128z" })
      ]
    }
  );
}
var Movies_default = SvgMovies;

// src/components/Icon/icons/MoviesTvApp.tsx
import { jsx as jsx634, jsxs as jsxs627 } from "react/jsx-runtime";
function SvgMoviesTvApp({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs627(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx634("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx634("path", { d: "M1865 368l-200 38-273-273 410-78 63 313zm-391 74l-304 58-274-273 305-58 273 273zM471 632l-336 63-62-313 124-23 274 273zm508-96l-318 60-273-273 318-60 273 273zM128 832h1792v960q0 42-14 77t-40 60-61 40-77 15H320q-42 0-77-14t-60-40-40-61-15-77V832z" })
      ]
    }
  );
}
var MoviesTvApp_default = SvgMoviesTvApp;

// src/components/Icon/icons/MultiItemJoinable.tsx
import { jsx as jsx635, jsxs as jsxs628 } from "react/jsx-runtime";
function SvgMultiItemJoinable({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs628(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx635("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx635("path", { d: "M933 1088H0V960h933L723 749l90-90 365 365-365 365-90-90 210-211zm449-64l-275-275 90-90 365 365-365 365-90-90 275-275zm-358-896q124 0 238 32t214 90 181 140 140 181 91 214 32 239q0 124-32 238t-90 214-140 181-181 140-214 91-239 32q-152 0-290-48t-252-135-197-207-124-267l123-34q34 124 106 227t169 178 217 116 248 42q106 0 204-27t183-78 156-120 120-155 77-184 28-204q0-106-27-204t-78-183-120-156-155-120-184-77-204-28q-129 0-248 41T560 413 390 591 284 819l-123-34q41-145 124-266t197-208 252-135 290-48z" })
      ]
    }
  );
}
var MultiItemJoinable_default = SvgMultiItemJoinable;

// src/components/Icon/icons/MultiPlayer.tsx
import { jsx as jsx636, jsxs as jsxs629 } from "react/jsx-runtime";
function SvgMultiPlayer({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs629(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx636("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx636("path", { d: "M1636 693q65 33 117 81t90 108 57 128 20 142h-128q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149q0 92-41 173t-115 136q65 33 117 81t90 108 57 128 20 142h-128q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149H128q0-73 20-141t57-128 89-108 118-82q-74-55-115-136t-41-173q0-79 30-149t82-122 122-83 150-30q92 0 173 41t136 115q37-75 97-134t134-97q-74-55-115-136t-41-173q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 92-41 173t-115 136zm-996 715q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100q0 53 20 99t55 82 81 55 100 20zm512-1024q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100z" })
      ]
    }
  );
}
var MultiPlayer_default = SvgMultiPlayer;

// src/components/Icon/icons/MultiPlayerGold.tsx
import { jsx as jsx637, jsxs as jsxs630 } from "react/jsx-runtime";
function SvgMultiPlayerGold({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs630(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx637("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx637("path", { d: "M738 1461q65 33 118 81t90 108 58 128 20 142H896q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149H0q0-73 20-141t57-129 91-108 118-81q-75-54-116-135t-42-174q0-79 30-149t82-122 122-83 150-30q92 0 173 41t136 117q38-76 97-135t136-98q-75-54-116-135t-42-174q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 92-41 173t-116 136q100 50 170 136t98 195h-133q-20-57-56-104t-84-81-104-52-118-19q-80 0-149 30t-122 82-83 123-30 149q0 92-41 173t-117 136zm286-1077q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100zM512 1408q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100q0 53 20 99t55 82 81 55 100 20zm1376 640l-288-225-288 225 116-360-276-216h345l103-320 103 320h345l-276 216 116 360z" })
      ]
    }
  );
}
var MultiPlayerGold_default = SvgMultiPlayerGold;

// src/components/Icon/icons/MultiPlayerJoinChallenge.tsx
import { jsx as jsx638, jsxs as jsxs631 } from "react/jsx-runtime";
function SvgMultiPlayerJoinChallenge({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs631(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx638("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx638("path", { d: "M1282 766q-80 0-148 29t-119 81-81 120-34 147v8q0 92-41 173t-115 136q43 22 81 51t70 66v278q-10-70-44-129t-84-101-115-66-134-24q-80 0-149 30t-121 83-82 122-30 149H8q0-73 20-141t57-128 89-108 118-82q-74-54-115-135t-41-174q0-79 30-149t81-122 121-82 150-31q92 0 173 41t135 115q37-75 96-134t134-97q-74-55-115-136t-41-174q0-79 30-149t81-122 121-82 150-31q79 0 149 30t121 83 82 122 30 149q0 92-41 173t-115 137q65 33 117 81t89 108 57 128 20 142h-127q0-79-30-149t-82-122-121-83-149-31zm-255-384q0 53 20 99t54 82 81 55 100 20q53 0 99-20t81-55 54-81 20-100q0-52-20-99t-54-81-81-55-99-21q-53 0-99 20t-81 55-55 81-20 100zM518 1407q53 0 99-20t80-55 55-81 20-100q0-52-20-99t-54-82-81-55-99-21q-53 0-99 20t-81 56-55 81-20 100q0 53 20 99t54 81 81 55 100 21zm1341-51q24 11 32 26t15 39q5 20 17 44t21 44q25 61 49 124t37 129q4 23 6 45t3 45q0 32-7 63t-25 60q-9 14-22 27t-30 24-33 17-36 6q-31 0-61-26t-59-58-51-61-41-34q-12-4-26-4t-27 0h-204q-16 0-27 4-12 4-27 18t-31 35-35 42-38 41-40 31-42 12q-17 0-35-6t-34-16-31-24-23-28q-19-29-26-63t-8-69q0-44 12-105t31-124 41-122 40-99q0-32 12-55t49-27q10-1 19-1t18-6q29-15 62-19t66-4q18 0 28 1t19 6 17 9 24 14h143q12-7 20-13t16-9 18-6 25-2q19 0 47 3t55 12 49 23 28 37zm34 557q12-11 15-28t3-33q0-41-13-92t-31-103-40-102-40-87q-20-3-34-17t-18-35q-11-4-24-5t-26-3q-3 4-11 9t-17 10-19 8-14 4h-188q-5 0-14-3t-20-9-18-10-11-9q-22 0-34 1t-22 5-21 7-29 10q-3 10-7 18t-10 16q-7 13-16 37t-19 55-19 64-18 65-15 57-10 41l-4 30q-2 15-2 30 0 7 1 17t3 20 7 20 11 13q39-39 64-71t51-55 63-37 97-13h177q61 0 96 13t62 36 51 56 63 70zm-396-375q14 0 23 9t9 23q0 13-9 22t-23 10q-13 0-22-9t-10-23q0-13 9-22t23-10z" })
      ]
    }
  );
}
var MultiPlayerJoinChallenge_default = SvgMultiPlayerJoinChallenge;

// src/components/Icon/icons/MultiPlayerLeaveParty.tsx
import { jsx as jsx639, jsxs as jsxs632 } from "react/jsx-runtime";
function SvgMultiPlayerLeaveParty({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs632(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx639("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx639("path", { d: "M1565 643l446 445-446 445-90-90 291-291H768v-128h998l-291-291 90-90zm-413 1149v-384h128v512H128V256h1152v512h-128V384H256v1408h896z" })
      ]
    }
  );
}
var MultiPlayerLeaveParty_default = SvgMultiPlayerLeaveParty;

// src/components/Icon/icons/MultiPlayerPartyJoinable.tsx
import { jsx as jsx640, jsxs as jsxs633 } from "react/jsx-runtime";
function SvgMultiPlayerPartyJoinable({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs633(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx640("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx640("path", { d: "M738 1461q65 33 118 81t90 108 58 128 20 142H896q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149H0q0-73 20-141t57-129 91-108 118-81q-75-54-116-135t-42-174q0-79 30-149t82-122 122-83 150-30q92 0 173 41t136 117q38-76 97-135t136-98q-75-54-116-135t-42-174q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 92-41 173t-116 136q96 48 165 130t99 185h-135q-22-54-58-98t-83-76-101-49-114-17q-80 0-149 30t-122 82-83 123-30 149q0 92-41 173t-117 136zm286-1077q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100zM512 1408q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100q0 53 20 99t55 82 81 55 100 20zm1237-229q67 24 122 66t94 97 61 120 22 138q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-91 35-174t101-146h-136v-128h384v384h-128v-190q-60 45-94 112t-34 142q0 66 25 124t68 102 102 69 125 25q66 0 124-25t101-68 69-102 26-125q0-50-15-97t-44-86-67-70-87-47l42-121z" })
      ]
    }
  );
}
var MultiPlayerPartyJoinable_default = SvgMultiPlayerPartyJoinable;

// src/components/Icon/icons/MultiPlayerShare.tsx
import { jsx as jsx641, jsxs as jsxs634 } from "react/jsx-runtime";
function SvgMultiPlayerShare({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs634(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx641("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx641("path", { d: "M741 1461q66 32 118 80t90 108 56 129 20 142H897q0-79-30-149t-82-122-123-83-149-30q-79 0-149 30t-122 83-82 122-31 149H1q0-73 20-141t56-129 89-108 119-81q-73-54-114-136t-42-173q0-79 30-149t83-122 122-82 149-31q92 0 173 41t136 115q38-75 97-134t134-97q-73-54-114-136t-42-173q0-79 30-149t83-122 122-82 149-31q79 0 149 30t122 82 83 123 30 149q0 92-41 173t-115 136q66 32 118 80t90 108 56 129 20 142h-128q0-79-30-149t-82-122-123-83-149-30q-79 0-149 30t-122 83-82 122-31 149q0 92-41 173t-115 136zm284-1077q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100zm-768 768q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100zm1763 448l-441 369-82-98 247-207h-463v-128h463l-247-207 82-98 441 369z" })
      ]
    }
  );
}
var MultiPlayerShare_default = SvgMultiPlayerShare;

// src/components/Icon/icons/MultiPlayerSolid.tsx
import { jsx as jsx642, jsxs as jsxs635 } from "react/jsx-runtime";
function SvgMultiPlayerSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs635(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx642("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx642("path", { d: "M868 1461q65 33 117 81t90 108 57 128 20 142H128q0-73 20-141t57-128 89-108 118-82q-74-55-115-136t-41-173q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 92-41 173t-115 136zm768-768q65 33 117 81t90 108 57 128 20 142h-736q0-101-36-193t-104-167q59-59 136-99-74-55-115-136t-41-173q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 92-41 173t-115 136z" })
      ]
    }
  );
}
var MultiPlayerSolid_default = SvgMultiPlayerSolid;

// src/components/Icon/icons/MultiPlayerTimer.tsx
import { jsx as jsx643, jsxs as jsxs636 } from "react/jsx-runtime";
function SvgMultiPlayerTimer({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs636(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx643("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx643("path", { d: "M739 1461q65 33 118 81t90 108 57 128 20 142H896q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149H0q0-73 20-141t57-129 90-108 118-81q-74-54-115-135t-42-174q0-79 30-149t82-122 122-83 150-30q92 0 173 41t136 116q38-75 97-134t135-98q-74-54-115-135t-42-174q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 92-41 173t-116 136q100 50 170 136t98 195h-133q-20-57-56-104t-84-81-104-52-118-19q-80 0-149 30t-122 82-83 123-30 149q0 92-41 173t-116 136zm285-1077q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100zm-768 768q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100zm1344 0q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm0 768q66 0 124-25t101-68 69-102 26-125q0-66-25-124t-69-101-102-69-124-26q-66 0-124 25t-102 69-69 102-25 124q0 66 25 124t68 102 102 69 125 25zm64-384h128v128h-256v-256h128v128z" })
      ]
    }
  );
}
var MultiPlayerTimer_default = SvgMultiPlayerTimer;

// src/components/Icon/icons/MultiPlayerWimax.tsx
import { jsx as jsx644, jsxs as jsxs637 } from "react/jsx-runtime";
function SvgMultiPlayerWimax({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs637(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx644("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx644("path", { d: "M1764 1461q66 32 118 80t90 108 56 129 20 142h-128q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149h-128q0-73 19-142t57-128 89-108 119-81q-74-54-115-135t-41-174q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149H256q0-73 19-142t57-128 89-108 119-81q-74-54-115-135t-41-174q0-79 30-149t82-122 122-83T768 0q79 0 149 30t122 82 83 123 30 149q0 92-41 173T996 693q75 36 135 96t96 135q54-74 135-115t174-41q79 0 149 30t122 82 83 123 30 149q0 92-41 173t-115 136zM512 384q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100zm768 768q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100zm-967 384h463v128H313l247 207-82 98-441-369 441-369 82 98-247 207z" })
      ]
    }
  );
}
var MultiPlayerWimax_default = SvgMultiPlayerWimax;

// src/components/Icon/icons/MultiSelect.tsx
import { jsx as jsx645, jsxs as jsxs638 } from "react/jsx-runtime";

// src/components/Icon/icons/MultiSelectMirrored.tsx
import { jsx as jsx646, jsxs as jsxs639 } from "react/jsx-runtime";
function SvgMultiSelectMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs639(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx646("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx646("path", { d: "M1294 384v128H14V384h1280zm0 512H14V768h1280v128zm0 384H14v-128h1280v128zm0 384H14v-128h1280v128zm400-388l286-286 68 68-354 354-178-178 68-68 110 110zm0-768l286-286 68 68-354 354-178-178 68-68 110 110z" })
      ]
    }
  );
}
var MultiSelectMirrored_default = SvgMultiSelectMirrored;

// src/components/Icon/icons/Music.tsx
import { jsx as jsx647, jsxs as jsxs640 } from "react/jsx-runtime";
function SvgMusic({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs640(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx647("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx647("path", { d: "M1024 128q106 0 204 27t183 78 156 120 120 155 77 184 28 204v704q0 40-15 75t-41 61-61 41-75 15h-192v-768h192q33 0 64 11V896q0-88-23-170t-64-153-100-129-130-100-153-65-170-23q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170v139q31-11 64-11h192v768H448q-40 0-75-15t-61-41-41-61-15-75V896q0-106 27-204t78-183 120-156 155-120 183-77 205-28zM448 1152q-26 0-45 19t-19 45v384q0 26 19 45t45 19h64v-512h-64zm1152 512q26 0 45-19t19-45v-384q0-26-19-45t-45-19h-64v512h64z" })
      ]
    }
  );
}
var Music_default = SvgMusic;

// src/components/Icon/icons/MusicTracks.tsx
import { jsx as jsx648, jsxs as jsxs641 } from "react/jsx-runtime";
function SvgMusicTracks({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs641(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx648("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx648("path", { d: "M2048 384v128H0V384h2048zM0 768h2048v128H0V768zm1280 896H0v-128h1280v128zm128-418l640-160v706q0 31-14 54t-38 40-52 25-56 9q-27 0-55-8t-52-25-38-40-15-55q0-31 14-54t38-40 52-25 56-9q15 0 32 3v-417l-384 96v574q0 32-16 56t-40 40-55 24-57 8q-27 0-57-8t-54-24-41-40-16-56q0-32 16-56t40-40 55-24 57-8q10 0 20 1t20 3v-550zm-128 34H0v-128h1280v128z" })
      ]
    }
  );
}
var MusicTracks_default = SvgMusicTracks;

// src/components/Icon/icons/MusicTracksMirrored.tsx
import { jsx as jsx649, jsxs as jsxs642 } from "react/jsx-runtime";
function SvgMusicTracksMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs642(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx649("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx649("path", { d: "M2048 384v128H0V384h2048zM0 768h2048v128H0V768zm1024 768h1024v128H1024v-128zm-768-290l640-160v706q0 31-14 54t-38 40-52 25-56 9q-27 0-55-8t-52-25-38-40-15-55q0-31 14-54t38-40 52-25 56-9q15 0 32 3v-417l-384 96v574q0 32-16 56t-40 40-55 24-57 8q-27 0-57-8t-54-24-41-40-16-56q0-32 16-56t40-40 55-24 57-8q10 0 20 1t20 3v-550zm768-94h1024v128H1024v-128z" })
      ]
    }
  );
}
var MusicTracksMirrored_default = SvgMusicTracksMirrored;

// src/components/Icon/icons/Mute.tsx
import { jsx as jsx650, jsxs as jsxs643 } from "react/jsx-runtime";
function SvgMute({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs643(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx650("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx650("path", { d: "M293 640l384-384h91v1536h-91l-384-384H0V640h293zm347 933V475L347 768H128v512h219l293 293zm1133-824l-274 275 274 275-90 90-275-274-275 274-90-90 274-275-274-275 90-90 275 274 275-274 90 90z" })
      ]
    }
  );
}
var Mute_default = SvgMute;

// src/components/Icon/icons/MyMoviesTv.tsx
import { jsx as jsx651, jsxs as jsxs644 } from "react/jsx-runtime";
function SvgMyMoviesTv({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs644(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx651("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx651("path", { d: "M1920 896v832q0 40-15 75t-41 61-61 41-75 15H320q-40 0-75-15t-61-41-41-61-15-75v-507q0-37 1-67t2-59 1-60-4-67q-2-21-6-38t-8-34-10-32-11-38L22 541l1738-434 124 497L713 896h1207zM681 508l-321 80 352 176 321-80-352-176zm543 129l322-81-352-175-322 80 352 176zm-1046 4l61 241 282-70-343-171zm1489-379l-282 71 342 171-60-242zm125 762H256v704q0 26 19 45t45 19h1408q26 0 45-19t19-45v-704z" })
      ]
    }
  );
}
var MyMoviesTv_default = SvgMyMoviesTv;

// src/components/Icon/icons/Narrator.tsx
import { jsx as jsx652, jsxs as jsxs645 } from "react/jsx-runtime";
function SvgNarrator({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs645(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx652("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx652("path", { d: "M640 0h1408v1024h-677l-411 410v-410H640V0zm1280 896V128H768v768h320v230l229-230h603zm-128 768v-512h128v640h-896v128h256v128H640v-128h256v-128H0V640h512v128H128v896h1664z" })
      ]
    }
  );
}
var Narrator_default = SvgNarrator;

// src/components/Icon/icons/Navigation.tsx
import { jsx as jsx653, jsxs as jsxs646 } from "react/jsx-runtime";
function SvgNavigation({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs646(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx653("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx653("path", { d: "M960 0q132 0 255 34t229 97 194 150 150 194 97 230 35 255q0 133-34 255t-96 230-150 194-195 150-229 97-256 34q-133 0-255-34t-230-96-194-150-150-195-97-229T0 960q0-133 34-255t96-230 150-194 195-150 229-97T960 0zm64 1790q102-8 196-39t176-83 152-120 120-151 82-177 40-196h-126V896h126q-8-102-39-196t-83-176-120-152-151-120-177-82-196-40v126H896V130q-102 8-196 39t-176 83-152 120-120 151-82 177-40 196h126v128H130q8 102 39 196t83 176 120 152 151 120 177 82 196 40v-126h128v126zm85-979l299 597-597-299-299-597 597 299zm63 361l-141-283-283-141 141 283 283 141z" })
      ]
    }
  );
}
var Navigation_default = SvgNavigation;

// src/components/Icon/icons/Network.tsx
import { jsx as jsx654, jsxs as jsxs647 } from "react/jsx-runtime";
function SvgNetwork({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs647(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx654("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx654("path", { d: "M417 289Q308 398 251 538t-58 294q0 154 57 294t167 249l-91 91q-126-128-194-291T64 832q0-180 68-343t194-291l91 91zm1177-91q126 128 194 291t68 343q0 180-68 343t-194 291l-91-91q109-109 166-249t58-294q0-154-57-294t-167-249l91-91zM643 515q-63 63-97 145t-34 172q0 90 34 172t97 145l-90 90q-81-81-125-186t-44-221q0-115 44-220t125-187l90 90zm724-90q81 81 125 186t44 221q0 115-44 220t-125 187l-90-90q63-63 96-145t34-172q0-90-33-172t-97-145l90-90zM960 576q53 0 99 20t82 55 55 81 20 100q0 44-14 83t-40 73-61 57-77 35v712H896v-712q-42-11-77-35t-61-57-40-72-14-84q0-53 20-99t55-82 81-55 100-20zm0 384q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10z" })
      ]
    }
  );
}
var Network_default = SvgNetwork;

// src/components/Icon/icons/NetworkConnected.tsx
import { jsx as jsx655, jsxs as jsxs648 } from "react/jsx-runtime";
function SvgNetworkConnected({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs648(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx655("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx655("path", { d: "M1546 512l-146 1024h-376v512H896v-512H520L374 512h138V0h896v512h138zM640 128v384h128V256h128v256h128V256h128v256h128V128H640zm648 1280l110-768H522l110 768h656z" })
      ]
    }
  );
}
var NetworkConnected_default = SvgNetworkConnected;

// src/components/Icon/icons/NetworkDisconnected.tsx
import { jsx as jsx656, jsxs as jsxs649 } from "react/jsx-runtime";
function SvgNetworkDisconnected({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs649(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx656("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx656("path", { d: "M1600 1152q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm-320 448q0 66 25 124t68 102 102 69 125 25q47 0 92-13t84-40l-443-443q-26 39-39 84t-14 92zm587 176q26-39 39-84t14-92q0-66-25-124t-69-101-102-69-124-26q-47 0-92 13t-84 40l443 443zm-841-368q-4 31-3 64t1 64v512H896v-512H521L374 512h138V0h896v512h138l-71 493q-35 8-69 20t-67 28l59-413H522l109 768h395zM640 512h128V256h128v256h128V256h128v256h128V128H640v384z" })
      ]
    }
  );
}
var NetworkDisconnected_default = SvgNetworkDisconnected;

// src/components/Icon/icons/NetworkDisconnected2.tsx
import { jsx as jsx657, jsxs as jsxs650 } from "react/jsx-runtime";
function SvgNetworkDisconnected2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs650(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx657("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx657("path", { d: "M1600 1152q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm-320 448q0 66 25 124t68 102 102 69 125 25q47 0 92-13t84-40l-443-443q-26 39-39 84t-14 92zm587 176q26-39 39-84t14-92q0-66-25-124t-69-101-102-69-124-26q-47 0-92 13t-84 40l443 443zm-841-368q-4 31-3 64t1 64v512H896v-512H521L374 512h138V0h896v512h138l-71 493q-35 8-69 20t-67 28l59-413H522l109 768h395zM640 512h128V256h128v256h128V256h128v256h128V128H640v384z" })
      ]
    }
  );
}
var NetworkDisconnected2_default = SvgNetworkDisconnected2;

// src/components/Icon/icons/Networks.tsx
import { jsx as jsx658, jsxs as jsxs651 } from "react/jsx-runtime";
function SvgNetworks({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs651(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx658("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx658("path", { d: "M1188 794q45-43 69-99t25-119q0-63-24-119t-70-99l89-92q64 62 98 141t35 169q0 89-34 168t-99 142l-89-92zm267-712q101 97 156 225t55 269q0 70-14 138t-41 131-66 120-90 105l-89-92q83-80 127-183t45-219q0-115-44-218t-128-184l89-92zM643 886q-64-62-98-141t-35-169q0-89 34-168t99-142l89 92q-45 43-69 99t-25 119q0 63 24 119t70 99l-89 92zm-178 184q-50-48-89-105t-67-120-41-131-14-138q0-140 55-268T465 82l89 92q-83 80-127 183t-45 219q0 115 44 218t128 184l-89 92zm687-494q0 45-19 84t-55 67l397 1193h-135l-85-256H665l-86 256H444L842 727q-35-27-54-66t-20-85q0-40 15-75t41-61 61-41 75-15q40 0 75 15t61 41 41 61 15 75zm-192-64q-26 0-45 19t-19 45q0 26 19 45t45 19q26 0 45-19t19-45q0-26-19-45t-45-19zm0 266l-125 374h249L960 778zm-8-10h-1 1zm260 768l-85-256H793l-86 256h505zM968 768h1-1z" })
      ]
    }
  );
}
var Networks_default = SvgNetworks;

// src/components/Icon/icons/NetworkSettings.tsx
import { jsx as jsx659, jsxs as jsxs652 } from "react/jsx-runtime";
function SvgNetworkSettings({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs652(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx659("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx659("path", { d: "M831 384q66 0 124 25t102 69 69 102 26 124q0 56-19 108t-54 94-81 71-102 40v647H768v-647q-56-11-103-40t-81-71-53-93-19-109q0-66 25-124t68-101 102-69 124-26zm0 512q39 0 74-15t62-41 41-62 16-74q0-39-15-74t-42-61-61-42-75-15q-39 0-73 15t-61 42-42 61-15 74q0 39 15 74t41 61 61 41 74 16zm1083 643q12 61 0 122l124 51-49 119-124-52q-35 51-86 86l52 124-119 49-51-124q-61 12-122 0l-51 124-119-49 52-124q-51-35-86-86l-124 52-49-119 124-51q-12-61 0-122l-124-51 49-119 124 52q35-51 86-86l-52-124 119-49 51 124q61-12 122 0l51-124 119 49-52 124q51 35 86 86l124-52 49 119-124 51zm-314 253q39 0 74-15t61-42 41-61 16-74q0-39-15-74t-42-61-61-41-74-16q-39 0-74 15t-61 42-41 61-16 74q0 39 15 74t42 61 61 41 74 16zm-137-783q35-72 52-150t18-158q0-140-53-268t-151-227l91-90q58 58 103 126t77 144 47 155 16 162q0 148-52 290-14-2-33-1t-41 4-40 6-34 7zm-55-305q0 115-44 220t-125 187l-91-90q63-63 97-145t35-172q0-90-34-172t-98-145l91-90q81 81 125 186t44 221zM334 206q-49 49-87 107t-65 121-40 132-14 138q0 70 14 138t40 131 64 122 88 107l-91 90q-58-58-103-126t-77-144-47-155T0 704q0-82 16-162t47-156 76-143 104-127l91 90zm181 181q-63 63-97 145t-34 172q0 90 34 172t97 145l-91 90q-81-81-124-186t-44-221q0-115 43-220t125-187l91 90z" })
      ]
    }
  );
}
var NetworkSettings_default = SvgNetworkSettings;

// src/components/Icon/icons/NetworkTower.tsx
import { jsx as jsx660, jsxs as jsxs653 } from "react/jsx-runtime";
function SvgNetworkTower({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs653(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx660("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx660("path", { d: "M1188 794q45-43 69-99t25-119q0-63-24-119t-70-99l89-92q64 62 98 141t35 169q0 89-34 168t-99 142l-89-92zm267-712q50 48 89 105t67 120 41 131 14 138q0 70-14 138t-41 131-66 120-90 105l-89-92q83-80 127-183t45-219q0-115-44-218t-128-184l89-92zM643 886q-64-62-98-141t-35-169q0-89 34-168t99-142l89 92q-45 43-69 99t-25 119q0 63 24 119t70 99l-89 92zm-178 184q-50-48-89-105t-67-120-41-131-14-138q0-70 14-138t41-131 66-120 90-105l89 92q-83 80-127 183t-45 219q0 115 44 218t128 184l-89 92zm687-494q0 45-19 84t-55 67l397 1193h-134l-86-256H665l-86 256H445L842 727q-35-27-54-66t-20-85q0-40 15-75t41-61 61-41 75-15q40 0 75 15t61 41 41 61 15 75zm-192-64q-26 0-45 19t-19 45q0 26 19 45t45 19q26 0 45-19t19-45q0-26-19-45t-45-19zm0 266l-125 374h250L960 778zm253 758l-86-256H793l-86 256h506z" })
      ]
    }
  );
}
var NetworkTower_default = SvgNetworkTower;

// src/components/Icon/icons/NetworkTransfer.tsx
import { jsx as jsx661, jsxs as jsxs654 } from "react/jsx-runtime";
function SvgNetworkTransfer({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs654(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx661("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx661("path", { d: "M2029 1741l-301 301-301-301 90-90 147 147v-390h128v390l147-147 90 90zM417 161Q308 270 251 410t-58 294q0 154 57 294t167 249l-91 91q-126-128-194-291T64 704q0-180 68-343T326 70l91 91zm1086 1086q109-109 166-249t58-294q0-154-57-294t-167-249l91-91q126 128 194 291t68 343q0 180-68 343t-194 291l-91-91zM643 387q-63 63-97 145t-34 172q0 90 34 172t97 145l-90 90q-81-81-125-186t-44-221q0-115 44-220t125-187l90 90zm724-90q81 81 125 186t44 221q0 115-44 220t-125 187l-90-90q63-63 96-145t34-172q0-90-33-172t-97-145l90-90zM960 448q53 0 99 20t82 55 55 81 20 100q0 44-14 83t-40 73-61 57-77 35v712H896V952q-42-11-77-35t-61-57-40-72-14-84q0-53 20-99t55-82 81-55 100-20zm0 384q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10z" })
      ]
    }
  );
}
var NetworkTransfer_default = SvgNetworkTransfer;

// src/components/Icon/icons/NewReleases.tsx
import { jsx as jsx662, jsxs as jsxs655 } from "react/jsx-runtime";
function SvgNewReleases({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs655(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx662("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx662("path", { d: "M768 896V768h128v128H768zm384 768v-128h128v128h-128zm384-768V768h128v128h-128zm-384 0V768h128v128h-128zm-384 256v-128h128v128H768zm-384 0v-128h128v128H384zm1152 0v-128h128v128h-128zm-384 0v-128h128v128h-128zm-384 256v-128h128v128H768zm-384 0v-128h128v128H384zm1152 0v-128h128v128h-128zm-384 0v-128h128v128h-128zm-384 256v-128h128v128H768zm-384 0v-128h128v128H384zM1664 128h384v1792H0V128h384V0h128v128h1024V0h128v128zM384 256H128v256h1792V256h-256v128h-128V256H512v128H384V256zM128 1792h1792V640H128v1152z" })
      ]
    }
  );
}
var NewReleases_default = SvgNewReleases;

// src/components/Icon/icons/NewSparkles.tsx
import { jsx as jsx663, jsxs as jsxs656 } from "react/jsx-runtime";
function SvgNewSparkles({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs656(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx663("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx663("path", { d: "M448 768q-46-109-129-190T128 448q109-46 190-129t130-191q45 109 128 190t192 130q-109 46-190 129T448 768zm1600 256q-104 44-200 107t-178 144-150 175-112 197q-46-104-112-198t-149-174-178-143-201-108q108-45 205-109t178-147 147-179 110-205q45 108 110 204t147 178 178 147 205 111zm-638 396q63-127 161-228t223-168q-118-72-216-169t-170-215q-74 117-171 214t-214 170q128 64 227 165t160 231zm-962-268q64 152 180 268t268 180q-152 64-268 180t-180 268q-64-152-180-268T0 1600q152-64 268-180t180-268z" })
      ]
    }
  );
}
var NewSparkles_default = SvgNewSparkles;

// src/components/Icon/icons/Next.tsx
import { jsx as jsx664, jsxs as jsxs657 } from "react/jsx-runtime";
function SvgNext({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs657(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx664("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx664("path", { d: "M1664 256h128v1536h-128V256zM256 1792V256l1088 768-1088 768zM384 503v1042l738-521-738-521z" })
      ]
    }
  );
}
var Next_default = SvgNext;

// src/components/Icon/icons/NoContent.tsx
import { jsx as jsx665, jsxs as jsxs658 } from "react/jsx-runtime";
function SvgNoContent({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs658(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx665("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx665("path", { d: "M2045 861l-290 291 290 291-90 90-291-290-291 290-90-90 290-291-290-291 90-90 291 290 291-290 90 90zm-381 803v-224l128 128v224H128V128h1664v608l-128 128V256H256v1408h1408z" })
      ]
    }
  );
}
var NoContent_default = SvgNoContent;

// src/components/Icon/icons/Nose.tsx
import { jsx as jsx666, jsxs as jsxs659 } from "react/jsx-runtime";
function SvgNose({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs659(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx666("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx666("path", { d: "M1472 1280q66 0 124 25t101 69 69 102 26 124q0 66-25 124t-69 102-102 69-124 25q-60 0-114-14t-108-41q-39-20-78-30t-84-11q-45 0-84 10t-78 31q-54 26-108 40t-114 15q-93 0-174-35t-143-96-96-142-35-175q0-45 9-96t30-93L935 3l114 58-639 1278q-7 13-12 30t-8 35-4 35-2 33q0 66 25 124t68 102 102 69 125 25q45 0 84-10t78-31q54-26 108-40t114-15q60 0 114 14t108 41q39 20 78 30t84 11q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15v-128z" })
      ]
    }
  );
}
var Nose_default = SvgNose;

// src/components/Icon/icons/NoseRing.tsx
import { jsx as jsx667, jsxs as jsxs660 } from "react/jsx-runtime";
function SvgNoseRing({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs660(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx667("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx667("path", { d: "M1472 1152q66 0 124 25t101 69 69 102 26 124q0 66-25 124t-69 102-102 69-124 25q-20 0-40-1t-40-6q-15 52-42 99t-67 84-88 58-107 22q-57 0-106-21t-89-58-66-84-43-100q-20 4-40 5t-40 2q-93 0-174-35t-143-96-96-142-35-175q0-45 9-96t30-93L871 3l114 58-575 1150q-7 13-12 30t-8 35-4 35-2 33q0 66 25 124t68 102 102 69 125 25q45 0 84-10t78-31q53-26 107-40t115-15q98 0 187 39-6-39-20-68t-36-61q-7-10-10-19t-4-21q0-27 19-45t45-19q16 0 27 6t23 18q22 25 38 56t28 66 17 70 6 68q31 6 64 6 40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15v-128zm-384 768q36 0 65-15t53-40 40-56 24-63q-24-10-45-19t-42-16-45-11-50-4q-27 0-50 4t-44 10-43 16-45 20q8 32 24 63t39 55 53 40 66 16z" })
      ]
    }
  );
}
var NoseRing_default = SvgNoseRing;

// src/components/Icon/icons/Notebook.tsx
import { jsx as jsx668, jsxs as jsxs661 } from "react/jsx-runtime";
function SvgNotebook({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs661(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx668("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx668("path", { d: "M1920 0v2048H320q-40 0-75-15t-61-41-41-61-15-75V256q0-49 21-95t58-82 82-57 95-22h1536zm-128 1792H320q-26 0-45 19t-19 45q0 26 19 45t45 19h1472v-128zm0-1664H384q-23 0-46 11t-41 30-29 41-12 46v1419q33-11 64-11h1472V128zm-768 896q-80 0-149-30t-122-82-83-122-30-150q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 80-30 149t-82 122-123 83-149 30zm0-640q-53 0-99 20t-82 55-55 81-20 100q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20z" })
      ]
    }
  );
}
var Notebook_default = SvgNotebook;

// src/components/Icon/icons/NoThumbnail.tsx
import { jsx as jsx669, jsxs as jsxs662 } from "react/jsx-runtime";
function SvgNoThumbnail({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs662(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx669("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx669("path", { d: "M1664 256v1536H384V256h1280zm-128 1152H512v256h1024v-256zm0-1024H512v896h1024V384z" })
      ]
    }
  );
}
var NoThumbnail_default = SvgNoThumbnail;

// src/components/Icon/icons/NotOnline.tsx
import { jsx as jsx670, jsxs as jsxs663 } from "react/jsx-runtime";
function SvgNotOnline({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs663(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx670("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx670("path", { d: "M1600 1152q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm-320 448q0 66 25 124t68 102 102 69 125 25q47 0 92-13t84-40l-443-443q-26 39-39 84t-14 92zm587 176q26-39 39-84t14-92q0-66-25-124t-69-101-102-69-124-26q-47 0-92 13t-84 40l443 443zm-774 125q22 36 48 69t57 62q-43 8-86 12t-88 4q-141 0-272-36t-244-104-207-160-161-207-103-245-37-272q0-141 36-272t104-244 160-207 207-161T752 37t272-37q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 44-4 87t-12 87q-54-59-118-98l4-38q2-19 2-38 0-130-38-256h-362q8 62 11 123t5 124q-33 3-65 10t-64 18q2-69-2-137t-14-138H657q-9 64-13 127t-4 129q0 65 4 128t13 128h446q-37 59-60 128H679q8 37 23 89t37 109 51 113 64 101 78 72 92 28q18 0 35-5t34-14zm739-1261q-38-81-91-152t-120-131-143-104-162-75q36 49 64 105t51 115 40 121 29 121h332zm-808-512q-49 0-91 27t-78 73-65 101-51 113-37 109-23 89h690q-8-37-23-89t-37-109-51-113-64-101-78-72-92-28zm-292 50q-85 29-162 74T427 357 308 487t-92 153h332q12-59 28-120t39-121 52-116 65-105zm-604 846q0 130 38 256h362q-8-64-12-127t-4-129q0-65 4-128t12-128H166q-38 126-38 256zm88 384q38 81 91 152t120 131 143 104 162 75q-36-49-65-105t-51-115-39-121-29-121H216z" })
      ]
    }
  );
}
var NotOnline_default = SvgNotOnline;

// src/components/Icon/icons/NoVideoCamera.tsx
import { jsx as jsx671, jsxs as jsxs664 } from "react/jsx-runtime";
function SvgNoVideoCamera({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs664(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx671("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx671("path", { d: "M960 1664H320V256h1408v784q-31-11-63-18t-65-10V384H448v1152h512v128zm576-512q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm-320 448q0 66 25 124t68 102 102 69 125 25q47 0 92-13t84-40l-443-443q-26 39-39 84t-14 92zm587 176q26-39 39-84t14-92q0-66-25-124t-69-101-102-69-124-26q-47 0-92 13t-84 40l443 443zm-827 16q24 67 62 128H704v-128h272zM704 960q0 66 25 124t68 102 102 69 125 25q5 0 15-2-38 61-62 128-85-9-158-47t-128-99-84-137-31-163q0-93 35-174t96-142 142-96 175-36q93 0 174 35t142 96 96 142 36 175q0 27-3 52-35 4-69 12t-69 21q6-20 9-41t4-44q0-66-25-124t-69-101-102-69-124-26q-66 0-124 25t-102 69-69 102-25 124z" })
      ]
    }
  );
}
var NoVideoCamera_default = SvgNoVideoCamera;

// src/components/Icon/icons/NoVideoCamera2.tsx
import { jsx as jsx672, jsxs as jsxs665 } from "react/jsx-runtime";
function SvgNoVideoCamera2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs665(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx672("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx672("path", { d: "M960 1664H320V256h1408v784q-31-11-63-18t-65-10V384H448v1152h512v128zm576-512q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm-320 448q0 66 25 124t68 102 102 69 125 25q47 0 92-13t84-40l-443-443q-26 39-39 84t-14 92zm587 176q26-39 39-84t14-92q0-66-25-124t-69-101-102-69-124-26q-47 0-92 13t-84 40l443 443zm-827 16q24 67 62 128H704v-128h272zM704 960q0 66 25 124t68 102 102 69 125 25q5 0 15-2-38 61-62 128-85-9-158-47t-128-99-84-137-31-163q0-93 35-174t96-142 142-96 175-36q93 0 174 35t142 96 96 142 36 175q0 27-3 52-35 4-69 12t-69 21q6-20 9-41t4-44q0-66-25-124t-69-101-102-69-124-26q-66 0-124 25t-102 69-69 102-25 124z" })
      ]
    }
  );
}
var NoVideoCamera2_default = SvgNoVideoCamera2;

// src/components/Icon/icons/NowPlaying.tsx
import { jsx as jsx673, jsxs as jsxs666 } from "react/jsx-runtime";
function SvgNowPlaying({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs666(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx673("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx673("path", { d: "M1280 1792V641h127v1151h-127zm-1153 0v-383h129v383H127zm385 0v-768h127v768H512zm383 0V129h129v1663H895zm768-768h129v768h-129v-768z" })
      ]
    }
  );
}
var NowPlaying_default = SvgNowPlaying;

// src/components/Icon/icons/Ocr1.tsx
import { jsx as jsx674, jsxs as jsxs667 } from "react/jsx-runtime";
function SvgOcr1({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs667(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 1286 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx674("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx674("path", { d: "M1157 1789q27 0 50 9t41 27 28 40 10 50q0 27-10 51t-27 42-41 29-51 11H130q-28 0-51-10t-41-29-28-42-10-52q0-27 10-50t28-40 41-26 51-10h398V259H136q-27 0-50-10t-42-27-28-41-10-51q0-27 10-50t28-42 41-28 51-10h651v1789h370z" })
      ]
    }
  );
}
var Ocr1_default = SvgOcr1;

// src/components/Icon/icons/Ocr2.tsx
import { jsx as jsx675, jsxs as jsxs668 } from "react/jsx-runtime";
function SvgOcr2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs668(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 1318 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx675("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx675("path", { d: "M1318 890q0 54-20 102t-56 84-83 56-103 21H268v636h920q27 0 50 10t41 27 28 41 11 51q0 27-10 50t-28 42-41 28-51 10H9v-895q0-53 20-101t56-84 82-57 101-21h788V259H130q-27 0-51-9t-41-27-28-41-10-52q0-28 10-51t27-41 41-28 52-10h926q54 0 101 20t84 55 56 82 21 102v631z" })
      ]
    }
  );
}
var Ocr2_default = SvgOcr2;

// src/components/Icon/icons/Ocrp1.tsx
import { jsx as jsx676, jsxs as jsxs669 } from "react/jsx-runtime";
function SvgOcrp1({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs669(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 3181 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx676("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx676("path", { d: "M3052 1786q27 0 50 9t41 27 28 40 10 50q0 27-10 51t-27 43-40 28-52 11H2026q-27 0-51-10t-41-29-27-43-10-51q0-27 10-50t28-40 41-26 50-10h398V259h-391q-27 0-50-10t-42-28-28-41-10-51q0-27 10-50t28-41 41-28 51-10h650v1786h369zM919 0q80 0 150 31t124 85 83 124 31 151v486q0 81-30 151t-83 123-123 83-152 31H262v654q0 27-10 50t-27 41-41 28-51 10q-27 0-51-9t-42-27-29-41-11-52V0h919zm129 391q0-26-10-49t-28-41-41-28-50-11H262v744h657q26 0 49-10t41-28 28-41 11-50V391z" })
      ]
    }
  );
}
var Ocrp1_default = SvgOcrp1;

// src/components/Icon/icons/Ocrp2.tsx
import { jsx as jsx677, jsxs as jsxs670 } from "react/jsx-runtime";
function SvgOcrp2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs670(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 3210 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx677("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx677("path", { d: "M0 1919V0h919q80 0 150 31t124 85 83 124 31 151v486q0 81-30 151t-83 123-123 83-152 31H262v654q0 27-10 50t-27 41-41 28-51 10q-27 0-51-9t-42-27-29-41-11-52zm262-913h657q26 0 49-10t41-28 28-41 11-50V391q0-26-10-49t-28-41-41-28-50-11H262v744zm2818 1039H1903v-894q0-54 20-101t55-83 83-57 101-21h786V259h-925q-27 0-51-10t-41-27-27-42-10-51q0-27 10-51t27-41 41-27 51-10h925q54 0 101 20t84 55 56 82 21 102v630q0 55-20 102t-56 83-83 56-103 21h-786v635h918q27 0 50 10t41 27 28 41 11 51q0 27-10 50t-28 41-41 28-51 11z" })
      ]
    }
  );
}
var Ocrp2_default = SvgOcrp2;

// src/components/Icon/icons/Ocrp3.tsx
import { jsx as jsx678, jsxs as jsxs671 } from "react/jsx-runtime";
function SvgOcrp3({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs671(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 3213 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx678("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx678("path", { d: "M919 0q80 0 150 31t124 85 83 124 31 151v486q0 81-30 151t-83 123-123 83-152 31H262v654q0 27-10 50t-27 41-41 28-51 10q-27 0-51-9t-42-27-29-41-11-52V0h919zm129 391q0-26-10-49t-28-41-41-28-50-11H262v744h657q26 0 49-10t41-28 28-41 11-50V391zm2057 628q51 56 79 121t29 141v505q0 54-20 101t-57 83-83 55-102 20h-915q-27 0-50-10t-42-28-28-41-10-51q0-27 10-50t28-41 41-28 51-10h912v-505q0-27-10-51t-27-42-42-29-51-11h-520q-27 0-51-10t-41-27-28-41-10-51q0-27 10-50t28-42 41-28 51-10h524q26 0 49-10t41-28 28-41 11-50V259h-925q-27 0-50-10t-41-28-28-41-10-51q0-27 10-50t27-41 41-28 51-10h925q54 0 101 20t82 55 56 83 20 101v485q0 78-24 148t-81 127z" })
      ]
    }
  );
}
var Ocrp3_default = SvgOcrp3;

// src/components/Icon/icons/Ocrp4.tsx
import { jsx as jsx679, jsxs as jsxs672 } from "react/jsx-runtime";
function SvgOcrp4({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs672(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 3141 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx679("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx679("path", { d: "M919 0q80 0 150 31t124 85 83 124 31 151v486q0 81-30 151t-83 123-123 83-152 31H262v654q0 27-10 50t-27 41-41 28-51 10q-27 0-51-9t-42-27-29-41-11-52V0h919zm129 391q0-26-10-49t-28-41-41-28-50-11H262v744h657q26 0 49-10t41-28 28-41 11-50V391zm1963 726q27 0 50 10t42 28 28 41 10 51q0 27-10 50t-28 41-41 28-51 10v543q0 27-10 50t-27 41-41 28-51 10q-27 0-50-10t-42-27-28-41-10-51v-540h-780V133q0-27 10-51t29-42 43-29 51-11q27 0 51 10t41 29 27 43 10 51v984h518V359q0-27 10-51t27-42 42-28 51-11q27 0 50 10t41 29 28 42 10 51v758z" })
      ]
    }
  );
}
var Ocrp4_default = SvgOcrp4;

// src/components/Icon/icons/Offline.tsx
import { jsx as jsx680, jsxs as jsxs673 } from "react/jsx-runtime";
function SvgOffline({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs673(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx680("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx680("path", { d: "M1728 1408q66 0 124 25t101 69 69 102 26 124q0 66-25 124t-69 102-102 69-124 25q-66 0-124-25t-102-68-69-102-25-125q0-66 25-124t68-101 102-69 125-26zm0 512q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15zm-688-974q134 49 240 145t171 223l-114 58q-41-81-101-145t-134-110-159-69-175-24q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170H0q0-117 35-229t101-207 157-169 203-113q-56-36-100-83t-76-103-47-118-17-130q0-106 40-199t109-163T568 40 768 0q106 0 199 40t163 109 110 163 40 200q0 137-63 248t-177 186zM384 512q0 80 30 149t82 122 122 83 150 30q79 0 149-30t122-82 83-122 30-150q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149z" })
      ]
    }
  );
}
var Offline_default = SvgOffline;

// src/components/Icon/icons/Online.tsx
import { jsx as jsx681, jsxs as jsxs674 } from "react/jsx-runtime";
function SvgOnline({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs674(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx681("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx681("path", { d: "M1728 1408q66 0 124 25t101 69 69 102 26 124q0 66-25 124t-69 102-102 69-124 25q-66 0-124-25t-102-68-69-102-25-125q0-66 25-124t68-101 102-69 125-26zm-688-462q134 49 240 145t171 223l-114 58q-41-81-101-145t-134-110-159-69-175-24q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170H0q0-117 35-229t101-207 157-169 203-113q-56-36-100-83t-76-103-47-118-17-130q0-106 40-199t109-163T568 40 768 0q106 0 199 40t163 109 110 163 40 200q0 137-63 248t-177 186zM384 512q0 80 30 149t82 122 122 83 150 30q79 0 149-30t122-82 83-122 30-150q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149z" })
      ]
    }
  );
}
var Online_default = SvgOnline;

// src/components/Icon/icons/Open.tsx
import { jsx as jsx682, jsxs as jsxs675 } from "react/jsx-runtime";
function SvgOpen({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs675(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx682("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx682("path", { d: "M1536 256h384v384h-128V475l-456 456-91-91 456-456h-165V256zm0 1280v-512l128-128v768H0V512h1280l-128 128H128v896h1408z" })
      ]
    }
  );
}
var Open_default = SvgOpen;

// src/components/Icon/icons/OpenMirrored.tsx
import { jsx as jsx683, jsxs as jsxs676 } from "react/jsx-runtime";
function SvgOpenMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs676(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx683("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx683("path", { d: "M384 256H0v384h128V475l456 456 91-91-456-456h165V256zm0 1280v-512L256 896v768h1664V512H640l128 128h1024v896H384z" })
      ]
    }
  );
}
var OpenMirrored_default = SvgOpenMirrored;

// src/components/Icon/icons/OpenNewTab.tsx
import { jsx as jsx684, jsxs as jsxs677 } from "react/jsx-runtime";
function SvgOpenNewTab({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs677(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx684("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx684("path", { d: "M1536 1536V896h128v768H0V512h1152v128H128v896h1408zm384-1152v128h-256v256h-128V512h-256V384h256V128h128v256h256z" })
      ]
    }
  );
}
var OpenNewTab_default = SvgOpenNewTab;

// src/components/Icon/icons/OpenNewTabMirrored.tsx
import { jsx as jsx685, jsxs as jsxs678 } from "react/jsx-runtime";
function SvgOpenNewTabMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs678(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx685("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx685("path", { d: "M384 1536V896H256v768h1664V512H768v128h1024v896H384zM0 384v128h256v256h128V512h256V384H384V128H256v256H0z" })
      ]
    }
  );
}
var OpenNewTabMirrored_default = SvgOpenNewTabMirrored;

// src/components/Icon/icons/OptionalMediaUpdate.tsx
import { jsx as jsx686, jsxs as jsxs679 } from "react/jsx-runtime";
function SvgOptionalMediaUpdate({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs679(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx686("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx686("path", { d: "M512 256h1024v1409H512V256zm895 1280V897H641v639h766zM641 768h766V385H641v383zm255 256l256 192-256 192v-384z" })
      ]
    }
  );
}
var OptionalMediaUpdate_default = SvgOptionalMediaUpdate;

// src/components/Icon/icons/OutlineHalfStarLeft.tsx
import { jsx as jsx687, jsxs as jsxs680 } from "react/jsx-runtime";
function SvgOutlineHalfStarLeft({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs680(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx687("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx687("path", { d: "M2048 768l-632 486 248 794-640-492-640 492 248-794L0 768h784L1024 0l240 768h784zm-627 932l-157-493 408-311h-502l-146-467v965l397 306z" })
      ]
    }
  );
}
var OutlineHalfStarLeft_default = SvgOutlineHalfStarLeft;

// src/components/Icon/icons/OutlineQuarterStarLeft.tsx
import { jsx as jsx688, jsxs as jsxs681 } from "react/jsx-runtime";
function SvgOutlineQuarterStarLeft({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs681(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx688("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx688("path", { d: "M2048 768l-632 486 248 794-640-492-640 492 248-794L0 768h784L1024 0l240 768h784zm-627 932l-157-493 408-311h-502l-146-467-146 467h-46v646l192-148 397 306z" })
      ]
    }
  );
}
var OutlineQuarterStarLeft_default = SvgOutlineQuarterStarLeft;

// src/components/Icon/icons/OutlineThreeQuarterStarLeft.tsx
import { jsx as jsx689, jsxs as jsxs682 } from "react/jsx-runtime";
function SvgOutlineThreeQuarterStarLeft({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs682(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx689("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx689("path", { d: "M2048 768l-632 486 248 794-640-492-640 492 248-794L0 768h784L1024 0l240 768h784zm-627 932l-157-493 408-311h-456v646l205 158z" })
      ]
    }
  );
}
var OutlineThreeQuarterStarLeft_default = SvgOutlineThreeQuarterStarLeft;

// src/components/Icon/icons/PaddleP1.tsx
import { jsx as jsx690, jsxs as jsxs683 } from "react/jsx-runtime";
function SvgPaddleP1({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs683(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx690("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx690("path", { d: "M448 512q71 0 142 17 49 12 89 23t77 28 71 41 72 60q93 90 218 106l931 117v504H448q-93 0-174-35t-143-96-96-142T0 960q0-93 35-174t96-143 142-96 175-35zm1472 504l-819-102q-86-11-158-47t-134-96q-38-37-80-61t-94-37l-77-19q-56-14-110-14-66 0-124 25t-102 69-69 102-25 124q0 66 25 124t68 102 102 69 125 25h1472v-264z" })
      ]
    }
  );
}
var PaddleP1_default = SvgPaddleP1;

// src/components/Icon/icons/PaddleP2.tsx
import { jsx as jsx691, jsxs as jsxs684 } from "react/jsx-runtime";
function SvgPaddleP2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs684(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx691("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx691("path", { d: "M1600 512q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35H0V904l931-117q125-16 218-106 37-36 71-60t71-40 77-28 90-24q71-17 142-17zm0 768q66 0 124-25t101-68 69-102 26-125q0-66-25-124t-69-101-102-69-124-26q-54 0-110 14l-72 18q-32 8-62 21t-58 30-59 48q-62 60-134 96t-158 47l-819 102v264h1472z" })
      ]
    }
  );
}
var PaddleP2_default = SvgPaddleP2;

// src/components/Icon/icons/PaddleP3.tsx
import { jsx as jsx692, jsxs as jsxs685 } from "react/jsx-runtime";
function SvgPaddleP3({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs685(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx692("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx692("path", { d: "M2048 256v443l-700 58q-38 3-68 26t-43 61q-18 53-33 100t-32 92-41 88-56 87l-345 453-3 3q-62 60-138 92t-163 33q-87 0-163-32t-134-89-91-132-33-163q0-92 34-176t100-150l588-588q99-99 228-152t270-54h823zm-128 128h-695q-115 0-220 44T818 553l-588 588q-46 46-71 106t-26 126q0 61 23 114t62 92 93 62 115 23q49 0 95-15t86-46q1-1 5-4t8-7 9-7 5-5l339-446q28-37 48-77t36-81 29-85 29-87q25-73 85-120t137-54l583-49V384z" })
      ]
    }
  );
}
var PaddleP3_default = SvgPaddleP3;

// src/components/Icon/icons/PaddleP4.tsx
import { jsx as jsx693, jsxs as jsxs686 } from "react/jsx-runtime";
function SvgPaddleP4({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs686(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx693("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx693("path", { d: "M823 256q140 0 269 53t229 153l588 588q65 65 99 149t35 177q0 83-32 158t-88 133-130 91-160 34q-93 0-169-30t-143-95l-3-3-345-453q-33-44-56-87t-40-88-33-92-33-100q-13-37-43-60t-68-27L0 699V256h823zm799 1408q61 0 114-22t93-62 63-93 23-114q0-66-25-126t-72-106l-588-588q-81-81-186-125t-221-44H128v197l583 49q77 7 137 54t85 120q15 44 28 87t29 84 36 82 49 77l339 446 4 4q3 3 7 6t7 6 5 4q40 32 87 48t98 16z" })
      ]
    }
  );
}
var PaddleP4_default = SvgPaddleP4;

// src/components/Icon/icons/Page.tsx
import { jsx as jsx694, jsxs as jsxs687 } from "react/jsx-runtime";
function SvgPage({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs687(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx694("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx694("path", { d: "M1115 0l677 677v1371H256V0h859zm37 219v421h421l-421-421zM384 1920h1280V768h-640V128H384v1792z" })
      ]
    }
  );
}
var Page_default = SvgPage;

// src/components/Icon/icons/PageEdit.tsx
import { jsx as jsx695, jsxs as jsxs688 } from "react/jsx-runtime";
function SvgPageEdit({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs688(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx695("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx695("path", { d: "M2048 1094q0 39-15 76t-43 65l-717 719-377 94 94-377 717-718q28-28 65-42t76-15q42 0 78 15t64 42 42 63 16 78zm-128 0q0-31-20-50t-52-20q-14 0-27 4t-23 15l-692 694-34 135 135-34 692-693q21-21 21-51zM256 128v1792h507l-32 128H128V0h1115l549 549v194q-67 10-128 44V640h-512V128H256zm1024 91v293h293l-293-293z" })
      ]
    }
  );
}
var PageEdit_default = SvgPageEdit;

// src/components/Icon/icons/PanMode.tsx
import { jsx as jsx696, jsxs as jsxs689 } from "react/jsx-runtime";
function SvgPanMode({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs689(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx696("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx696("path", { d: "M1152 1024q0 27-10 50t-27 40-41 28-50 10q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10q27 0 50 10t40 27 28 41 10 50zM1024 0q26 0 45 19l320 320q19 19 19 45t-19 45-45 19q-26 0-45-19l-275-275-275 275q-19 19-45 19t-45-19-19-45q0-26 19-45L979 19q19-19 45-19zm275 1619q19-19 45-19t45 19 19 45q0 26-19 45l-320 320q-19 19-45 19t-45-19l-320-320q-19-19-19-45t19-45 45-19q26 0 45 19l275 275 275-275zM384 640q26 0 45 19t19 45q0 26-19 45l-275 275 275 275q19 19 19 45t-19 45-45 19q-26 0-45-19L19 1069q-19-19-19-45t19-45l320-320q19-19 45-19zm1280 0q26 0 45 19l320 320q19 19 19 45t-19 45l-320 320q-19 19-45 19t-45-19-19-45q0-26 19-45l275-275-275-275q-19-19-19-45t19-45 45-19z" })
      ]
    }
  );
}
var PanMode_default = SvgPanMode;

// src/components/Icon/icons/Pants.tsx
import { jsx as jsx697, jsxs as jsxs690 } from "react/jsx-runtime";
function SvgPants({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs690(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx697("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx697("path", { d: "M1536 0v2048H384V0h1152zm-256 128v128q0 27 10 50t27 40 41 28 50 10V128h-128zM512 384q27 0 50-10t40-27 28-41 10-50V128H512v256zm256-128q0 53-20 99t-55 82-81 55-100 20v1152h384V640h128v1024h384V512q-53 0-99-20t-82-55-55-81-20-100V128h-128v128H896V128H768v128zm128 1664v-128H512v128h384zm512 0v-128h-384v128h384z" })
      ]
    }
  );
}
var Pants_default = SvgPants;

// src/components/Icon/icons/ParentalLock.tsx
import { jsx as jsx698, jsxs as jsxs691 } from "react/jsx-runtime";
function SvgParentalLock({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs691(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx698("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx698("path", { d: "M867 1461q65 33 118 81t90 108 57 128 20 142h-128q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149H128q0-73 20-141t57-129 90-108 118-81q-74-54-115-135t-42-174q0-79 30-149t82-122 122-83 150-30q92 0 173 41t136 116q38-75 97-134t135-97q-74-55-115-136t-42-174q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 94-43 177t-120 137q47 25 90 60t79 77 63 90 42 99h-134q-22-52-59-98t-85-82-103-55-114-20q-80 0-149 30t-122 82-83 122-30 149q0 92-41 173t-116 136zm541-1333q-53 0-99 20t-82 55-55 81-20 100q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20zM384 1152q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100zm1664 384v512h-640v-512h64v-128q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100v128h64zm-448 0h256v-128q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50v128zm320 128h-384v256h384v-256z" })
      ]
    }
  );
}
var ParentalLock_default = SvgParentalLock;

// src/components/Icon/icons/PartyLeader.tsx
import { jsx as jsx699, jsxs as jsxs692 } from "react/jsx-runtime";
function SvgPartyLeader({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs692(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx699("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx699("path", { d: "M1168 946q38 15 74 33t70 41q-22 24-40 50t-33 56q-77-50-164-76t-179-26q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170H128q0-120 35-231t101-205 156-167 204-115q-113-74-176-186t-64-248q0-106 40-199t109-163T696 40 896 0q106 0 199 40t163 109 110 163 40 200q0 66-16 129t-48 119-75 103-101 83zM512 512q0 80 30 149t82 122 122 83 150 30q79 0 149-30t122-82 83-122 30-150q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149zm1472 832q0 52-16 101t-48 91v512l-256-128-256 128v-512q-31-42-47-91t-17-101q0-66 25-124t68-101 102-69 125-26q66 0 124 25t101 69 69 102 26 124zm-320-192q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15zm128 689v-204q-60 27-128 27t-128-27v204q32-16 64-31t64-33q32 17 64 32t64 32z" })
      ]
    }
  );
}
var PartyLeader_default = SvgPartyLeader;

// src/components/Icon/icons/Pause.tsx
import { jsx as jsx700, jsxs as jsxs693 } from "react/jsx-runtime";
function SvgPause({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs693(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx700("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx700("path", { d: "M640 1792V256h128v1536H640zm640-1536h128v1536h-128V256z" })
      ]
    }
  );
}
var Pause_default = SvgPause;

// src/components/Icon/icons/Pc1.tsx
import { jsx as jsx701, jsxs as jsxs694 } from "react/jsx-runtime";
function SvgPc1({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs694(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx701("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx701("path", { d: "M2048 1536h-640v128h256v128h-640v-128h256v-128H896v256H0V128h896v512h1152v896zm-128-128V768H768v640h1152zM768 1664v-128H256v-128h384v-128H256v-128h384V640h128V256H128v1408h640zM640 384v128H256V384h384z" })
      ]
    }
  );
}
var Pc1_default = SvgPc1;

// src/components/Icon/icons/PerformanceMonitoring.tsx
import { jsx as jsx702, jsxs as jsxs695 } from "react/jsx-runtime";
function SvgPerformanceMonitoring({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs695(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx702("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx702("path", { d: "M1920 1408h-896v128h256v128H640v-128h256v-128H0V256h1920v1152zM1792 384H128v384h219l165-288 236 406 187-267 165 277h692V384zM128 896v384h1664v-256h-764L926 854l-189 269-224-387-92 160H128z" })
      ]
    }
  );
}
var PerformanceMonitoring_default = SvgPerformanceMonitoring;

// src/components/Icon/icons/PhoneCall.tsx
import { jsx as jsx703, jsxs as jsxs696 } from "react/jsx-runtime";
function SvgPhoneCall({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs696(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx703("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx703("path", { d: "M1607 1213q44 0 84 16t72 48l220 220q31 31 47 71t17 85q0 45-16 84t-48 72l-110 110q-70 69-161 99t-188 30q-125 0-257-39t-262-108-256-164-237-207-206-238-162-256T38 775 0 523q0-97 29-187t100-161L239 65q32-31 71-48t85-17q91 0 156 65l220 220q31 31 47 71t17 85q0 44-15 78t-37 63-48 51-49 45-37 44-15 49q0 38 27 65l551 551q27 27 65 27 26 0 48-15t45-37 45-48 51-49 62-37 79-15zm-83 707q72 0 120-13t88-39 76-64 85-86q27-27 27-65t-27-65l-220-220q-27-27-66-27-26 0-48 15t-44 37-45 48-52 49-62 37-79 15q-44 0-84-16t-72-48L570 927q-31-31-47-71t-17-85q0-44 15-78t37-63 48-51 49-46 37-44 15-48q0-39-27-66L460 155q-27-27-65-27t-65 27l-85 85q-37 37-64 76t-40 87-14 120q0 112 36 231t101 238 153 234 192 219 219 190 234 150 236 99 226 36z" })
      ]
    }
  );
}
var PhoneCall_default = SvgPhoneCall;

// src/components/Icon/icons/PhoneHangUp.tsx
import { jsx as jsx704, jsxs as jsxs697 } from "react/jsx-runtime";
function SvgPhoneHangUp({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs697(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx704("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx704("path", { d: "M960 256q73 0 154 7t163 25 162 43 154 64 135 87 109 113q39 54 61 112t22 125v128q0 40-15 75t-41 61-61 41-75 15h-256q-40 0-75-15t-61-41-41-61-15-75V832q0-26-19-45t-45-19H704q-26 0-45 19t-19 45v128q0 40-15 75t-41 61-61 41-75 15H192q-40 0-75-15t-61-41-41-61-15-75V832q0-66 22-124t61-113q46-63 108-112t136-87 153-64 163-44 163-24 154-8zm832 576q0-52-20-97t-53-84-74-69-83-56q-66-38-140-65t-151-44-156-25-155-8q-76 0-154 8t-156 25-152 44-140 65q-42 24-83 55t-73 70-53 83-21 98v128q0 26 19 45t45 19h256q26 0 45-19t19-45V832q0-40 15-75t41-61 61-41 75-15h512q40 0 75 15t61 41 41 61 15 75v128q0 26 19 45t45 19h256q26 0 45-19t19-45V832zm-557 659l90 90-365 366-365-366 90-90 211 211v-678h128v678l211-211z" })
      ]
    }
  );
}
var PhoneHangUp_default = SvgPhoneHangUp;

// src/components/Icon/icons/Photo.tsx
import { jsx as jsx705, jsxs as jsxs698 } from "react/jsx-runtime";
function SvgPhoto({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs698(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx705("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx705("path", { d: "M2048 256v1536H0V256h2048zM128 384v677l448-447 640 640 256-256 448 447V384H128zm0 1280h1317L576 794l-448 449v421zm1792 0v-37l-448-449-166 166 321 320h293zm-320-896q-26 0-45-19t-19-45q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19z" })
      ]
    }
  );
}
var Photo_default = SvgPhoto;

// src/components/Icon/icons/PhotoCollection.tsx
import { jsx as jsx706, jsxs as jsxs699 } from "react/jsx-runtime";
function SvgPhotoCollection({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs699(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx706("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx706("path", { d: "M1472 640q-26 0-45-19t-19-45q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19zm320-128h256v1280H256v-256H0V256h1792v256zm-549 896h330l-357-358-166 166 193 192zm421-1024H128v549l320-319 512 512 256-256 448 447V384zM128 1408h933L448 794l-320 321v293zm1792 256V640h-128v896H384v128h1536z" })
      ]
    }
  );
}
var PhotoCollection_default = SvgPhotoCollection;

// src/components/Icon/icons/Pin.tsx
import { jsx as jsx707, jsxs as jsxs700 } from "react/jsx-runtime";
function SvgPin({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs700(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx707("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx707("path", { d: "M1990 748q-33 33-64 60t-65 47-73 29-90 11q-34 0-65-6l-379 379q13 38 19 78t6 80q0 65-13 118t-37 100-60 90-80 86l-385-385-568 568-136 45 45-136 568-568-385-385q43-45 86-80t90-59 101-38 118-13q82 0 157 25l379-379q-6-31-6-65 0-49 10-88t30-74 46-65 61-65l690 690zm-292 19q55 0 104-26l-495-495q-26 49-26 104 0 28 6 52t15 51L810 944q-25-10-47-19t-44-15-45-9-51-4q-57 0-110 17t-100 49l673 672q32-46 49-99t17-110q0-27-3-50t-10-46-16-45-19-47l491-492q26 8 50 14t53 7z" })
      ]
    }
  );
}
var Pin_default = SvgPin;

// src/components/Icon/icons/PinSolid.tsx
import { jsx as jsx708, jsxs as jsxs701 } from "react/jsx-runtime";
function SvgPinSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs701(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx708("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx708("path", { d: "M1990 748q-33 33-64 60t-65 47-74 29-89 11q-34 0-65-6l-379 379q26 78 26 158 0 100-37 189t-108 160l-45 45-386-386-568 569-136 45 45-136 569-568-386-386 45-45q70-69 159-107t190-38q80 0 158 26l379-379q-6-31-6-65 0-49 10-88t30-74 46-66 61-64l690 690z" })
      ]
    }
  );
}
var PinSolid_default = SvgPinSolid;

// src/components/Icon/icons/Pip.tsx
import { jsx as jsx709, jsxs as jsxs702 } from "react/jsx-runtime";
function SvgPip({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs702(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx709("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx709("path", { d: "M2048 384v1280H0V384h2048zm-128 128H128v1024h1792V512zm-128 896H768V768h1024v640zm-587-128l-117-117-117 117h234zm459-384H896v309l192-192 267 267h309V896zm-192 256q-26 0-45-19t-19-45q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19z" })
      ]
    }
  );
}
var Pip_default = SvgPip;

// src/components/Icon/icons/Play.tsx
import { jsx as jsx710, jsxs as jsxs703 } from "react/jsx-runtime";
function SvgPlay({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs703(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx710("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx710("path", { d: "M384 128l1280 896-1280 896V128zm128 246v1300l929-650-929-650z" })
      ]
    }
  );
}
var Play_default = SvgPlay;

// src/components/Icon/icons/PlayButtonSolid.tsx
import { jsx as jsx711, jsxs as jsxs704 } from "react/jsx-runtime";
function SvgPlayButtonSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs704(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx711("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx711("path", { d: "M1024 0q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 141-36 272t-104 244-160 207-207 161-245 103-272 37q-141 0-272-36t-244-104-207-160-161-207-103-245-37-272q0-141 36-272t104-244 160-207 207-161T752 37t272-37zm512 1021L768 512v1024l768-515z" })
      ]
    }
  );
}
var PlayButtonSolid_default = SvgPlayButtonSolid;

// src/components/Icon/icons/Player.tsx
import { jsx as jsx712, jsxs as jsxs705 } from "react/jsx-runtime";
function SvgPlayer({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs705(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx712("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx712("path", { d: "M1329 1203q136 47 245 131t187 195 118 243 41 276h-128q0-164-58-304t-162-244-243-161-305-59q-108 0-206 27t-184 76-155 119-119 155-77 184-27 207H128q0-143 42-274t119-242 186-195 245-133q-78-42-140-102T475 968t-67-156-24-172q0-88 23-170t64-153 100-129T701 88t153-65 170-23q88 0 170 23t153 64 129 100 100 130 65 153 23 170q0 87-23 170t-67 157-106 134-139 102zM512 640q0 106 40 199t110 162 163 110 199 41q106 0 199-40t162-110 110-163 41-199q0-106-40-199t-110-162-163-110-199-41q-106 0-199 40T663 278 553 441t-41 199z" })
      ]
    }
  );
}
var Player_default = SvgPlayer;

// src/components/Icon/icons/PlayerAchievement.tsx
import { jsx as jsx713, jsxs as jsxs706 } from "react/jsx-runtime";
function SvgPlayerAchievement({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs706(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx713("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx713("path", { d: "M2048 1216v256q0 49-17 85t-48 60-70 35-84 12q-31 71-92 120t-137 66v70h128v128h-384v-128h128v-70q-76-16-137-65t-92-121q-44 0-84-11t-70-36-47-60-18-85v-256h192v-128h640v128h192zm-896 256q0 26 19 45t45 19v-192h-64v128zm576-256h-384v320q0 39 15 74t41 61 62 42 74 15q39 0 74-15t61-41 42-62 15-74v-320zm192 128h-64v192q26 0 45-19t19-45v-128zm-832-234q-73-42-154-64t-166-22q-88 0-170 23t-153 64-129 101-100 130-65 152-23 170H0q0-115 35-227t101-209 157-170 203-112q-56-35-100-82t-75-104-48-119-17-129q0-106 40-199t110-162T569 41 768 0q106 0 199 40t162 110 110 163 41 199q0 66-16 129t-48 119-76 103-100 83q57 22 112 54l-64 110zM384 512q0 79 30 149t83 122 122 82 149 31q79 0 149-30t122-83 82-122 31-149q0-79-30-149t-83-122-122-82-149-31q-79 0-149 30t-122 83-82 122-31 149z" })
      ]
    }
  );
}
var PlayerAchievement_default = SvgPlayerAchievement;

// src/components/Icon/icons/PlayerAdd.tsx
import { jsx as jsx714, jsxs as jsxs707 } from "react/jsx-runtime";
function SvgPlayerAdd({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs707(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx714("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx714("path", { d: "M1536 1536h-13q-23-112-81-206t-141-162-187-106-218-38q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170H128q0-120 35-231t101-205 156-167 204-115q-113-74-176-186t-64-248q0-106 40-199t109-163T696 40 896 0q106 0 199 40t163 109 110 163 40 200q0 66-16 129t-48 119-75 103-101 83q112 43 206 118t162 176v296zM512 512q0 80 30 149t82 122 122 83 150 30q79 0 149-30t122-82 83-122 30-150q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149zm1280 1152h256v128h-256v256h-128v-256h-256v-128h256v-256h128v256z" })
      ]
    }
  );
}
var PlayerAdd_default = SvgPlayerAdd;

// src/components/Icon/icons/PlayerDownloadProfile.tsx
import { jsx as jsx715, jsxs as jsxs708 } from "react/jsx-runtime";
function SvgPlayerDownloadProfile({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs708(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx715("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx715("path", { d: "M1600 1818l-365-365 90-90 211 210V960h128v613l211-210 90 90-365 365zm-320 102h640v128h-640v-128zm-240-974q82 31 155 81t133 113l-94 88q-91-97-211-150t-255-54q-88 0-170 23t-153 64-129 101-100 130-65 152-23 170H0q0-115 35-227t101-209 157-170 203-112q-56-35-100-82t-75-104-48-119-17-129q0-106 40-199t110-162T569 41 768 0q106 0 199 40t162 110 110 163 41 199q0 66-16 129t-48 119-76 103-100 83zM384 512q0 79 30 149t83 122 122 82 149 31q79 0 149-30t122-83 82-122 31-149q0-79-30-149t-83-122-122-82-149-31q-79 0-149 30t-122 83-82 122-31 149z" })
      ]
    }
  );
}
var PlayerDownloadProfile_default = SvgPlayerDownloadProfile;

// src/components/Icon/icons/PlayerGold.tsx
import { jsx as jsx716, jsxs as jsxs709 } from "react/jsx-runtime";
function SvgPlayerGold({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs709(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx716("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx716("path", { d: "M1888 2048l-288-225-288 225 116-360-276-216h345l103-320 103 320h345l-276 216 116 360zm-584-733q-45-68-103-122t-128-91-146-58-159-20q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170H0q0-117 35-229t101-207 157-169 203-113q-56-36-100-83t-76-103-47-119-17-129q0-106 40-199t109-163T568 40 768 0q106 0 199 40t163 109 110 163 40 200q0 67-16 129t-48 119-75 103-101 83q115 44 210 120t161 179l-107 70zM384 512q0 80 30 149t82 122 122 83 150 30q79 0 149-30t122-82 83-122 30-150q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149z" })
      ]
    }
  );
}
var PlayerGold_default = SvgPlayerGold;

// src/components/Icon/icons/PlayerKinect.tsx
import { jsx as jsx717, jsxs as jsxs710 } from "react/jsx-runtime";
function SvgPlayerKinect({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs710(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx717("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx717("path", { d: "M2048 1280v384h-128v128h-640v-128h-128v-384h896zm-128 128h-640v128h640v-128zm-1182 53q65 32 117 80t90 109 58 129 21 141H896q0-79-30-149t-83-122-122-82-149-31q-79 0-149 30t-122 83-82 122-31 149H0q0-72 20-141t58-129 90-108 118-81q-37-27-66-61t-50-75-31-84-11-89q0-79 30-149t83-122 122-82 149-31q45 0 89 11t84 31 74 49 62 67q38-76 97-135t136-98q-37-27-66-61t-50-75-31-84-11-89q0-79 30-149t83-122 122-82 149-31q79 0 149 30t122 83 82 122 31 149q0 17-6 46t-17 64-26 70-33 64-38 47-40 19q65 32 118 80t91 108 58 128 21 142h-128q0-79-30-149t-83-122-122-82-149-31q-79 0-149 30t-122 83-82 122-31 149q0 45-11 89t-31 84-49 74-67 62zm286-1077q0 53 20 99t55 81 81 55 100 21q52 0 99-20t81-55 55-81 21-100q0-52-20-99t-55-81-82-55-99-21q-53 0-99 20t-81 55-55 82-21 99zM512 1408q52 0 99-20t81-55 55-81 21-100q0-52-20-99t-55-81-82-55-99-21q-53 0-99 20t-81 55-55 82-21 99q0 53 20 99t55 81 81 55 100 21z" })
      ]
    }
  );
}
var PlayerKinect_default = SvgPlayerKinect;

// src/components/Icon/icons/PlayerPerks.tsx
import { jsx as jsx718, jsxs as jsxs711 } from "react/jsx-runtime";
function SvgPlayerPerks({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs711(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx718("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx718("path", { d: "M1792 1408l-256 85v363l-576 192-576-192v-363l-256-85 256-384 576-192 576 192 256 384zm-174-60l-128-191-355 119 127 191 356-119zM960 950l-399 133 399 133 399-133-399-133zm-530 207l-128 191 356 119 127-191-355-119zm66 374v244l400 134v-597l-192 288-208-69zm928 244v-244l-208 69-192-288v597l400-134zm-80-879q-65-152-180-267T896 448q152-65 267-180T1344 0q65 152 180 267t268 181q-152 65-267 180t-181 268zm0-669q-92 129-221 221 129 92 221 221 92-129 221-221-129-92-221-221zM448 896q-47-109-129-191T128 576q109-47 191-129t129-191q47 109 129 191t191 129q-109 47-191 129T448 896zm0-425q-47 59-105 105 58 47 105 105 46-58 105-105-59-46-105-105z" })
      ]
    }
  );
}
var PlayerPerks_default = SvgPlayerPerks;

// src/components/Icon/icons/PlayerRecoverProfile.tsx
import { jsx as jsx719, jsxs as jsxs712 } from "react/jsx-runtime";
function SvgPlayerRecoverProfile({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs712(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx719("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx719("path", { d: "M1965 1645l-365 366-365-366 90-90 211 211v-614h128v614l211-211 90 90zm-661-330q-45-68-103-122t-128-91-146-58-159-20q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170H0q0-117 35-229t101-207 157-169 203-113q-56-36-100-83t-76-103-47-119-17-129q0-106 40-199t109-163T568 40 768 0q106 0 199 40t163 109 110 163 40 200q0 67-16 129t-48 119-75 103-101 83q115 44 210 120t161 179l-107 70zM384 512q0 80 30 149t82 122 122 83 150 30q79 0 149-30t122-82 83-122 30-150q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149z" })
      ]
    }
  );
}
var PlayerRecoverProfile_default = SvgPlayerRecoverProfile;

// src/components/Icon/icons/PlayerRemove.tsx
import { jsx as jsx720, jsxs as jsxs713 } from "react/jsx-runtime";
function SvgPlayerRemove({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs713(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx720("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx720("path", { d: "M1408 1664h640v128h-640v-128zm245-128h-130q-23-112-81-206t-141-162-187-106-218-38q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170H128q0-120 35-231t101-205 156-167 204-115q-113-74-176-186t-64-248q0-106 40-199t109-163T696 40 896 0q106 0 199 40t163 109 110 163 40 200q0 66-16 129t-48 119-75 103-101 83q95 36 176 95t145 135 105 168 59 192zM512 512q0 80 30 149t82 122 122 83 150 30q79 0 149-30t122-82 83-122 30-150q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149z" })
      ]
    }
  );
}
var PlayerRemove_default = SvgPlayerRemove;

// src/components/Icon/icons/PlayerRespond.tsx
import { jsx as jsx721, jsxs as jsxs714 } from "react/jsx-runtime";
function SvgPlayerRespond({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs714(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx721("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx721("path", { d: "M1600 1152q93 0 174 35t143 96 96 142 35 175q0 72-21 137t-61 121-95 97-122 66l-42-121q47-17 86-47t68-69 43-87 16-97q0-66-25-124t-69-101-102-69-124-26q-66 0-124 25t-102 69-69 102-25 124q0 75 34 142t94 112v-190h128v384h-384v-128h136q-66-63-101-146t-35-174q0-93 35-174t96-143 142-96 175-35zm-408 34q-88-78-197-120t-227-42q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170H0q0-117 35-229t101-207 157-169 203-113q-56-36-100-83t-76-103-47-118-17-130q0-106 40-199t109-163T568 40 768 0q106 0 199 40t163 109 110 163 40 200q0 66-16 129t-48 119-75 103-101 83q66 25 125 61t112 83l-85 96zM384 512q0 80 30 149t82 122 122 83 150 30q79 0 149-30t122-82 83-122 30-150q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149z" })
      ]
    }
  );
}
var PlayerRespond_default = SvgPlayerRespond;

// src/components/Icon/icons/PlayerSettings.tsx
import { jsx as jsx722, jsxs as jsxs715 } from "react/jsx-runtime";
function SvgPlayerSettings({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs715(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx722("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx722("path", { d: "M1192 1186q-88-78-197-120t-227-42q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170H0q0-117 35-229t101-207 157-169 203-113q-56-36-100-83t-76-103-47-118-17-130q0-106 40-199t109-163T568 40 768 0q106 0 199 40t163 109 110 163 40 200q0 66-16 129t-48 119-75 103-101 83q66 25 125 61t112 83l-85 96zM384 512q0 80 30 149t82 122 122 83 150 30q79 0 149-30t122-82 83-122 30-150q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149zm1530 1027q6 30 6 61t-6 61l124 51-49 119-124-52q-35 51-86 86l52 124-119 49-51-124q-30 6-61 6t-61-6l-51 124-119-49 52-124q-51-35-86-86l-124 52-49-119 124-51q-6-30-6-61t6-61l-124-51 49-119 124 52q35-51 86-86l-52-124 119-49 51 124q30-6 61-6t61 6l51-124 119 49-52 124q51 35 86 86l124-52 49 119-124 51zm-314 253q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15z" })
      ]
    }
  );
}
var PlayerSettings_default = SvgPlayerSettings;

// src/components/Icon/icons/PlayerSignIn.tsx
import { jsx as jsx723, jsxs as jsxs716 } from "react/jsx-runtime";
function SvgPlayerSignIn({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs716(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx723("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx723("path", { d: "M2042 1600l-365 365-90-90 211-211h-646v-128h646l-211-211 90-90 365 365zm-691-198q-38-86-98-155t-137-119-165-77-183-27q-88 0-170 23t-153 64-129 101-100 130-65 152-23 170H0q0-115 35-227t101-209 157-170 203-112q-56-35-100-82t-75-104-48-119-17-129q0-106 40-199t110-162T569 41 768 0q106 0 199 40t162 110 110 163 41 199q0 67-16 129t-48 118-75 103-101 84q71 27 135 67t119 92 99 114 75 131l-117 52zM384 512q0 79 30 149t83 122 122 82 149 31q79 0 149-30t122-83 82-122 31-149q0-79-30-149t-83-122-122-82-149-31q-79 0-149 30t-122 83-82 122-31 149z" })
      ]
    }
  );
}
var PlayerSignIn_default = SvgPlayerSignIn;

// src/components/Icon/icons/PlayerSignOut.tsx
import { jsx as jsx724, jsxs as jsxs717 } from "react/jsx-runtime";
function SvgPlayerSignOut({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs717(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx724("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx724("path", { d: "M2048 1664h-614l211 211-90 90-366-365 366-365 90 90-211 211h614v128zm-787-407q-46-55-102-98t-119-74-131-45-141-16q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170H0q0-117 35-229t101-207 157-169 203-113q-56-36-100-83t-76-103-47-118-17-130q0-106 40-199t109-163T568 40 768 0q106 0 199 40t163 109 110 163 40 200q0 66-16 129t-48 119-75 103-101 83q94 35 174 93t145 136l-98 82zM384 512q0 80 30 149t82 122 122 83 150 30q79 0 149-30t122-82 83-122 30-150q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149z" })
      ]
    }
  );
}
var PlayerSignOut_default = SvgPlayerSignOut;

// src/components/Icon/icons/PlayerSkipSignIn.tsx
import { jsx as jsx725, jsxs as jsxs718 } from "react/jsx-runtime";
function SvgPlayerSkipSignIn({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs718(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx725("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx725("path", { d: "M493 1235l366 365-366 365-90-90 211-211H0v-128h614l-211-211 90-90zm1059-289q111 39 202 112t157 169 101 208 36 229h-128q0-88-23-170t-64-153-100-129-130-100-153-65-170-23q-72 0-140 15t-132 46-119 73-102 99l-98-82q64-77 144-135t175-94q-56-35-100-82t-76-104-47-119-17-129q0-106 40-199t109-163 163-110 200-40q106 0 199 40t163 109 110 163 40 200q0 67-16 129t-48 119-75 103-101 83zM896 512q0 80 30 149t82 122 122 83 150 30q79 0 149-30t122-82 83-122 30-150q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149z" })
      ]
    }
  );
}
var PlayerSkipSignIn_default = SvgPlayerSkipSignIn;

// src/components/Icon/icons/PlayerSwitchProfile.tsx
import { jsx as jsx726, jsxs as jsxs719 } from "react/jsx-runtime";
function SvgPlayerSwitchProfile({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs719(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx726("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx726("path", { d: "M738 1461q65 33 118 81t90 108 58 128 20 142H896q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149H0q0-73 20-141t57-129 91-108 118-81q-75-54-116-135t-42-174q0-79 30-149t82-122 122-83 150-30q92 0 173 41t136 117q38-76 97-135t136-98q-75-54-116-135t-42-174q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 94-41 173t-116 136q-1 1-3 1 66 33 119 81t90 107 58 128 21 142h-128q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149q0 92-41 173t-117 136zm286-1077q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100zM512 1408q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100q0 53 20 99t55 82 81 55 100 20zm896 128q53 0 99-20t82-55 55-81 20-100h128q0 80-30 150t-82 122-122 82-150 30h-37l82 83-90 90-237-237 237-237 90 90-82 83h37z" })
      ]
    }
  );
}
var PlayerSwitchProfile_default = SvgPlayerSwitchProfile;

// src/components/Icon/icons/PlayerWait.tsx
import { jsx as jsx727, jsxs as jsxs720 } from "react/jsx-runtime";
function SvgPlayerWait({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs720(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx727("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx727("path", { d: "M1192 1186q-88-78-197-120t-227-42q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170H0q0-117 35-229t101-207 157-169 203-113q-56-36-100-83t-76-103-47-118-17-130q0-106 40-199t109-163T568 40 768 0q106 0 199 40t163 109 110 163 40 200q0 66-16 129t-48 119-75 103-101 83q66 25 125 61t112 83l-85 96zM384 512q0 80 30 149t82 122 122 83 150 30q79 0 149-30t122-82 83-122 30-150q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149zm1216 640q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm0 768q66 0 124-25t101-68 69-102 26-125q0-66-25-124t-69-101-102-69-124-26q-66 0-124 25t-102 69-69 102-25 124q0 66 25 124t68 102 102 69 125 25zm64-384h128v128h-256v-256h128v128z" })
      ]
    }
  );
}
var PlayerWait_default = SvgPlayerWait;

// src/components/Icon/icons/Playground.tsx
import { jsx as jsx728, jsxs as jsxs721 } from "react/jsx-runtime";
function SvgPlayground({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs721(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx728("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx728("path", { d: "M1920 1953L1664 682v982h-128V255h-256v1027h128v128H640v-128h128V255H512v1409H384V682L128 1953 3 1927 365 127q165 1 329 1t330 0h329q163 0 330-1l362 1800-125 26zM1152 256H896v1026h256V256z" })
      ]
    }
  );
}
var Playground_default = SvgPlayground;

// src/components/Icon/icons/Playlist.tsx
import { jsx as jsx729, jsxs as jsxs722 } from "react/jsx-runtime";
function SvgPlaylist({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs722(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx729("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx729("path", { d: "M0 1280v-128h2048v128H0zm0 384v-128h2048v128H0zM0 256l538 384L0 1024V256zm106 205v358l250-179-250-179zm342-77h1600v128H640L448 384zm0 512l192-128h1408v128H448z" })
      ]
    }
  );
}
var Playlist_default = SvgPlaylist;

// src/components/Icon/icons/PlaylistAdd.tsx
import { jsx as jsx730, jsxs as jsxs723 } from "react/jsx-runtime";
function SvgPlaylistAdd({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs723(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx730("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx730("path", { d: "M0 896V768h2048v128H0zm0-512h2048v128H0V384zm0 896v-128h2048v128H0zm0 384v-128h1280v128H0zm1792-256v256h256v128h-256v256h-128v-256h-256v-128h256v-256h128z" })
      ]
    }
  );
}
var PlaylistAdd_default = SvgPlaylistAdd;

// src/components/Icon/icons/PlaylistAddMirrored.tsx
import { jsx as jsx731, jsxs as jsxs724 } from "react/jsx-runtime";
function SvgPlaylistAddMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs724(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx731("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx731("path", { d: "M2048 896V768H0v128h2048zm0-512H0v128h2048V384zm0 896v-128H0v128h2048zm0 384v-128H768v128h1280zM256 1408v256H0v128h256v256h128v-256h256v-128H384v-256H256z" })
      ]
    }
  );
}
var PlaylistAddMirrored_default = SvgPlaylistAddMirrored;

// src/components/Icon/icons/PlaylistGenre.tsx
import { jsx as jsx732, jsxs as jsxs725 } from "react/jsx-runtime";
function SvgPlaylistGenre({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs725(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx732("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx732("path", { d: "M0 1280v-128h128v128H0zm0-384V768h128v128H0zm384 0V768h1664v128H384zM0 512V384h128v128H0zm384-128h1664v128H384V384zm0 896v-128h1664v128H384zM0 1664v-128h128v128H0zm384 0v-128h1664v128H384z" })
      ]
    }
  );
}
var PlaylistGenre_default = SvgPlaylistGenre;

// src/components/Icon/icons/PlaylistGenreMirrored.tsx
import { jsx as jsx733, jsxs as jsxs726 } from "react/jsx-runtime";
function SvgPlaylistGenreMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs726(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx733("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx733("path", { d: "M2048 1280v-128h-128v128h128zm0-384V768h-128v128h128zm-384 0V768H0v128h1664zm384-384V384h-128v128h128zm-384-128H0v128h1664V384zm0 896v-128H0v128h1664zm384 384v-128h-128v128h128zm-384 0v-128H0v128h1664z" })
      ]
    }
  );
}
var PlaylistGenreMirrored_default = SvgPlaylistGenreMirrored;

// src/components/Icon/icons/PlaylistMusic.tsx
import { jsx as jsx734, jsxs as jsxs727 } from "react/jsx-runtime";
function SvgPlaylistMusic({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs727(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx734("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx734("path", { d: "M2048 384v128H384V384h1664zM384 768h1664v128H384V768zm896 896H384v-128h896v128zm128-418l640-160v706q0 31-14 54t-38 40-52 25-56 9q-27 0-55-8t-52-25-38-40-15-55q0-31 14-54t38-40 52-25 56-9q15 0 32 3v-417l-384 96v574q0 32-16 56t-40 40-55 24-57 8q-27 0-57-8t-54-24-41-40-16-56q0-32 16-56t40-40 55-24 57-8q10 0 20 1t20 3v-550zm-128 34H384v-128h896v128zM0 1536h128v128H0v-128zm0-384h128v128H0v-128zm0-384h128v128H0V768zm0-384h128v128H0V384z" })
      ]
    }
  );
}
var PlaylistMusic_default = SvgPlaylistMusic;

// src/components/Icon/icons/PlaylistMusicMirrored.tsx
import { jsx as jsx735, jsxs as jsxs728 } from "react/jsx-runtime";
function SvgPlaylistMusicMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs728(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx735("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx735("path", { d: "M1664 512H0V384h1664v128zm0 384H0V768h1664v128zm-640 640h640v128h-640v-128zm-768-290l640-160v706q0 27-12 50t-35 40-51 28-62 10q-33 0-62-10t-51-27-34-41-13-50q0-27 12-50t35-40 51-28 62-10q17 0 32 3v-417l-384 96v574q0 27-13 50t-36 40-53 28-66 10q-35 0-65-10t-54-27-36-41-13-50q0-27 13-50t36-40 53-28 66-10q23 0 40 4v-550zm768-94h640v128h-640v-128zm896 384h128v128h-128v-128zm0-384h128v128h-128v-128zm0-384h128v128h-128V768zm128-384v128h-128V384h128z" })
      ]
    }
  );
}
var PlaylistMusicMirrored_default = SvgPlaylistMusicMirrored;

// src/components/Icon/icons/PlaylistRemove.tsx
import { jsx as jsx736, jsxs as jsxs729 } from "react/jsx-runtime";
function SvgPlaylistRemove({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs729(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx736("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx736("path", { d: "M0 896V768h2048v128H0zm0-512h2048v128H0V384zm0 896v-128h2048v128H0zm0 384v-128h1280v128H0zm1408 128v-128h640v128h-640z" })
      ]
    }
  );
}
var PlaylistRemove_default = SvgPlaylistRemove;

// src/components/Icon/icons/PlaylistRemoveMirrored.tsx
import { jsx as jsx737, jsxs as jsxs730 } from "react/jsx-runtime";
function SvgPlaylistRemoveMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs730(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx737("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx737("path", { d: "M2048 896V768H0v128h2048zm0-512H0v128h2048V384zm0 896v-128H0v128h2048zm0 384v-128H768v128h1280zM640 1792v-128H0v128h640z" })
      ]
    }
  );
}
var PlaylistRemoveMirrored_default = SvgPlaylistRemoveMirrored;

// src/components/Icon/icons/PlayPause.tsx
import { jsx as jsx738, jsxs as jsxs731 } from "react/jsx-runtime";
function SvgPlayPause({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs731(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx738("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx738("path", { d: "M0 1792V256l1024 768L0 1792zM128 512v1024l683-512-683-512zm1024 1280V256h128v1536h-128zm768-1536h128v1536h-128V256z" })
      ]
    }
  );
}
var PlayPause_default = SvgPlayPause;

// src/components/Icon/icons/PolicyInsights.tsx
import { jsx as jsx739, jsxs as jsxs732 } from "react/jsx-runtime";
function SvgPolicyInsights({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs732(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx739("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx739("path", { d: "M384 1920h512l128 128H256V293L549 0h1243v1024h-128V128H603L384 347v1573zm1344-768q66 0 124 25t101 69 69 102 26 124q0 66-25 124t-69 102-102 69-124 25q-47 0-92-13t-84-40l-304 303-90-90 303-304q-26-39-39-84t-14-92q0-66 25-124t68-101 102-69 125-26zm0 512q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15z" })
      ]
    }
  );
}
var PolicyInsights_default = SvgPolicyInsights;

// src/components/Icon/icons/PopIn.tsx
import { jsx as jsx740, jsxs as jsxs733 } from "react/jsx-runtime";
function SvgPopIn({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs733(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx740("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx740("path", { d: "M512 512v933L1875 83l90 90L603 1536h933v128H384V512h128zm1152 1408V768l128-128v1408H0V256h1408l-128 128H128v1536h1536z" })
      ]
    }
  );
}
var PopIn_default = SvgPopIn;

// src/components/Icon/icons/Pose.tsx
import { jsx as jsx741, jsxs as jsxs734 } from "react/jsx-runtime";
function SvgPose({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs734(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx741("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx741("path", { d: "M1216 512q26 0 45 19l384 384q19 19 19 45t-19 45l-363 366v472q0 65-2 109t-3 50v46H640v-677l-365-366q-19-19-19-45t19-45l390-390h1q3-3 7-5 1 0 2-1t2-1h1q1 0 2-1t2-1l2-1h1l2-1h3l2-1h4l2-1h6q-31-42-47-91t-17-101q0-66 25-124t68-101 102-69T960 0q66 0 124 25t101 69 69 102 26 124q0 52-16 101t-48 91zM768 320q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75zm386 1024q0-26 19-45l337-339-321-320H731L410 960l339 339q19 19 19 45v576h128v-512h128v512h128l2-576zM608 960l160-160v320L608 960zm544-160l160 160-160 160V800z" })
      ]
    }
  );
}
var Pose_default = SvgPose;

// src/components/Icon/icons/Power.tsx
import { jsx as jsx742, jsxs as jsxs735 } from "react/jsx-runtime";
function SvgPower({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs735(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx742("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx742("path", { d: "M1088 1024H960V0h128v1024zm212-724q138 44 252 128t196 197 127 248 45 279q0 124-32 238t-90 214-140 181-181 140-214 91-239 32q-124 0-238-32t-214-90-181-140-140-181-91-214-32-239q0-145 45-280t126-247 196-197 253-128l40 121q-119 39-217 111T403 700 295 911t-39 241q0 106 27 204t78 183 120 156 155 120 184 77 204 28q159 0 298-60t244-165 165-244 61-299q0-125-38-240t-109-212-168-168-217-111l40-121z" })
      ]
    }
  );
}
var Power_default = SvgPower;

// src/components/Icon/icons/PowerCord.tsx
import { jsx as jsx743, jsxs as jsxs736 } from "react/jsx-runtime";
function SvgPowerCord({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs736(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx743("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx743("path", { d: "M640 256h128v320q0 57-19 109t-53 93-81 71-103 41v1158H384V890q-56-12-103-41t-81-70-53-94-19-109V256h128V0h128v256h128V0h128v256zm0 128H256v192q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75V384zm1024 0h41q22 0 42 4t32 19 13 42q0 8-1 12l-128 640q-5 22-22 36t-41 15h-192v896h-128v-896h-192q-23 0-40-14t-23-37L897 461q-1-3-1-6t0-7q0-28 13-41t32-19 42-5 41 1V0h640v384zm-512 0h384V128h-384v256zm498 128h-612l102 512h407l103-512z" })
      ]
    }
  );
}
var PowerCord_default = SvgPowerCord;

// src/components/Icon/icons/PowerSettings.tsx
import { jsx as jsx744, jsxs as jsxs737 } from "react/jsx-runtime";
function SvgPowerSettings({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs737(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx744("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx744("path", { d: "M768 704H640V0h128v704zm1280 192v546q0 113-43 212t-117 173-173 118-212 43q-92 0-179-30t-159-88l-159 160-91-91 160-159q-57-72-87-158t-31-180q0-113 43-212t117-174 173-117 213-43h545zm-128 128h-417q-86 0-162 33t-133 90-90 133-33 162q0 66 20 129t61 118l467-467 91 90-468 467q54 39 117 60t130 21q87 0 163-33t132-90 89-133 33-162v-418zm-654-280q-17-75-51-143t-84-124-113-99-137-68l40-121q90 30 166 81t137 119 103 150 63 175q-32 5-63 12t-61 18zm-562 722q16 0 31-1t31-3q1 32 4 63t10 64q-19 2-38 3t-38 2q-99 0-189-26t-169-74-142-113-109-147-70-171T0 874q0-115 34-223t99-198 153-159 201-105l40 121q-91 30-164 86T237 527t-80 163-29 184q0 80 20 154t57 141 89 120 117 94 138 61 155 22z" })
      ]
    }
  );
}
var PowerSettings_default = SvgPowerSettings;

// src/components/Icon/icons/PowerSupply.tsx
import { jsx as jsx745, jsxs as jsxs738 } from "react/jsx-runtime";
function SvgPowerSupply({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs738(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx745("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx745("path", { d: "M1600 128q26 0 45 19t19 45q0 26-19 45t-45 19h-192v128H896V256q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10q53 0 99 20t82 55 55 81 20 100h384v1280H640V768h384q0-27-10-50t-27-40-41-28-50-10q-53 0-99-20t-82-55-55-81-20-100q0-53 20-99t55-82 81-55 100-20V0h512v128h192zM768 896v1024h640V896H768zm512-768h-256v128h256V128z" })
      ]
    }
  );
}
var PowerSupply_default = SvgPowerSupply;

// src/components/Icon/icons/PreviewContent.tsx
import { jsx as jsx746, jsxs as jsxs739 } from "react/jsx-runtime";
function SvgPreviewContent({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs739(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx746("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx746("path", { d: "M192 480q-23-54-64-95t-96-65q54-23 95-64t65-96q23 54 64 95t96 65q-54 23-95 64t-65 96zm1664 64q23 54 64 95t96 65q-54 23-95 64t-65 96q-23-54-64-95t-96-65q54-23 95-64t65-96zm-384 96q-47-109-129-191t-191-129q109-47 191-129T1472 0q47 109 129 191t191 129q-109 47-191 129t-129 191zm0-446q-56 71-126 126 70 56 126 126 55-70 126-126-71-55-126-126zM747 785q-47 0-88-19t-73-53-48-76-18-89q0-59 24-110t66-90 94-61 112-23q84 0 149 35t111 94 68 132 24 151q0 105-34 196t-93 167-141 132-174 97q-9 4-23 4-23 0-39-16t-16-40q0-36 34-52 76-36 140-77t113-95 79-122 40-158q1-10 1-19t1-20q0-52-15-105t-45-96-75-69-105-27q-34 0-67 13t-59 37-42 54-16 68q0 23 9 45t24 40 37 29 46 11q24 0 38-7t23-20 14-25 12-25 17-19 29-8q23 0 40 17t17 40q0 5-2 13-8 32-26 59t-44 46-55 30-64 11zm880 111l274 275-90 90-147-146v933H256v-933l-147 146-90-90 274-275h555q-35 41-77 72t-91 56H384v896h1152v-896h-331q17-31 31-63t25-65h366z" })
      ]
    }
  );
}
var PreviewContent_default = SvgPreviewContent;

// src/components/Icon/icons/Previous.tsx
import { jsx as jsx747, jsxs as jsxs740 } from "react/jsx-runtime";
function SvgPrevious({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs740(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx747("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx747("path", { d: "M256 1792V256h128v1536H256zm448-768l1088-768v1536L704 1024zm960 521V503l-738 521 738 521z" })
      ]
    }
  );
}
var Previous_default = SvgPrevious;

// src/components/Icon/icons/Profile.tsx
import { jsx as jsx748, jsxs as jsxs741 } from "react/jsx-runtime";
function SvgProfile({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs741(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx748("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx748("path", { d: "M1148 1152q-83-62-180-95t-200-33q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170H0q0-120 35-231t101-205 156-167 204-115q-113-74-176-186t-64-248q0-106 40-199t109-163T568 40 768 0q106 0 199 40t163 109 110 163 40 200q0 66-16 129t-48 119-76 104-101 82q86 33 161 85t137 121h-189zM384 512q0 80 30 149t82 122 122 83 150 30q79 0 149-30t122-82 83-122 30-150q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149zm1664 768v768H896v-256H768v-512h1280zm-128 128H896v256h640v128h-512v128h896v-512zm-192 256q-26 0-45-19t-19-45q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19z" })
      ]
    }
  );
}
var Profile_default = SvgProfile;

// src/components/Icon/icons/ProfileSearch.tsx
import { jsx as jsx749, jsxs as jsxs742 } from "react/jsx-runtime";
function SvgProfileSearch({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs742(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx749("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx749("path", { d: "M1466 1140q-50 41-90 95-83-42-173-62t-183-20q-108 0-206 27t-183 76-154 119-119 155-76 183-27 206H128q0-146 43-280t124-247 193-195 253-129q-54-36-96-83t-72-102-46-116-16-126q0-105 40-198t110-162 163-110 198-41q105 0 198 40t162 110 110 163 41 198q0 65-16 126t-45 117-73 102-97 83q85 27 164 71zM639 641q0 79 30 149t82 122 121 82 150 31q79 0 149-30t122-82 82-122 30-150q0-79-30-149t-82-122-122-82-149-30q-79 0-149 30t-122 82-82 122-30 149zm1088 510q66 0 124 25t102 69 69 102 26 125q0 66-25 124t-69 102-102 69-125 25q-48 0-93-13t-84-40l-291 291q-19 19-45 19t-45-19-19-45q0-26 19-45l291-291q-26-39-39-84t-14-93q0-66 25-124t68-102 102-69 125-26zm0 514q40 0 75-15t61-41 41-62 16-75q0-40-15-75t-41-61-62-42-75-15q-40 0-75 15t-61 42-42 61-15 75q0 40 15 75t41 61 62 42 75 15z" })
      ]
    }
  );
}
var ProfileSearch_default = SvgProfileSearch;

// src/components/Icon/icons/QrCode.tsx
import { jsx as jsx750, jsxs as jsxs743 } from "react/jsx-runtime";
function SvgQrCode({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs743(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx750("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx750("path", { d: "M384 640V384h256v256H384zM128 896V128h768v768H128zm128-640v512h512V256H256zm128 1408v-256h256v256H384zm-256 256v-768h768v768H128zm128-640v512h512v-512H256zm1408-896v256h-256V384h256zm-512-256h768v768h-768V128zm640 640V256h-512v512h512zm-640 768h128v128h-128v-128zm256-256h-128v128h-128v-256h256v128zm256-128v128h-128v-128h128zm-128 128v256h-256v-128h128v-128h128zm-256 384h256v128h-128v128h-256v-128h128v-128zm256 256v-128h256v128h-256zm384-128h-128v-256h128v256zm-128-512v-128h128v256h-128v128h-128v-256h128zm-256 384v-128h128v128h-128z" })
      ]
    }
  );
}
var QrCode_default = SvgQrCode;

// src/components/Icon/icons/Quest.tsx
import { jsx as jsx751, jsxs as jsxs744 } from "react/jsx-runtime";
function SvgQuest({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs744(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx751("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx751("path", { d: "M1792 0q53 0 99 20t82 55 55 81 20 100q0 53-20 99t-55 82-81 55-100 20h-128v1280q0 53-20 99t-55 82-81 55-100 20H256q-53 0-99-20t-82-55-55-81-20-100q0-53 20-99t55-82 81-55 100-20V256q0-53 20-99t55-82 81-55T512 0h1280zM128 1792q0 27 10 50t27 40 41 28 50 10h930q-34-60-34-128t34-128H256q-27 0-50 10t-40 27-28 41-10 50zm1280 128q27 0 50-10t40-27 28-41 10-50V256q0-68 34-128H512q-27 0-50 10t-40 27-28 41-10 50v1280h1024q26 0 45 19t19 45q0 26-19 45t-45 19q-25 0-49 9t-42 28q-18 18-27 42t-10 49q0 27 10 50t27 40 41 28 50 10zm384-1536q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50v128h128zm-467-83l-147 147 147 147-90 90-147-147-147 147-90-90 147-147-147-147 90-90 147 147 147-147 90 90zm-685 851H512v-128h128v128zm64-410l90 90-90 90-90-90 90-90zm0 512l90 90-90 90-90-90 90-90z" })
      ]
    }
  );
}
var Quest_default = SvgQuest;

// src/components/Icon/icons/Question.tsx
import { jsx as jsx752, jsxs as jsxs745 } from "react/jsx-runtime";
function SvgQuestion({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs745(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx752("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx752("path", { d: "M896 1920h128v128H896v-128zM960 0q119 0 224 45t183 124 123 183 46 224q0 103-37 197t-109 168h-1l-127 127q-63 63-128 129-54 54-82 126t-28 149v192H896v-192q0-101 37-197t110-168l127-127q63-63 128-129 54-54 82-126t28-149q0-93-35-174t-96-142-142-96-175-36q-93 0-174 35t-142 96-96 142-36 175H384q0-119 45-224t124-183T736 46 960 0z" })
      ]
    }
  );
}
var Question_default = SvgQuestion;

// src/components/Icon/icons/QuestionMirrored.tsx
import { jsx as jsx753, jsxs as jsxs746 } from "react/jsx-runtime";
function SvgQuestionMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs746(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx753("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx753("path", { d: "M1024 1920H896v128h128v-128zM960 0Q841 0 736 45T553 169 430 352t-46 224q0 103 37 197t109 168h1l127 127q63 63 128 129 54 54 82 126t28 149v192h128v-192q0-101-37-197t-110-168L750 980q-63-63-128-129-54-54-82-126t-28-149q0-93 35-174t96-142 142-96 175-36q93 0 174 35t142 96 96 142 36 175h128q0-119-45-224t-124-183-183-123T960 0z" })
      ]
    }
  );
}
var QuestionMirrored_default = SvgQuestionMirrored;

// src/components/Icon/icons/Questionnaire.tsx
import { jsx as jsx754, jsxs as jsxs747 } from "react/jsx-runtime";
function SvgQuestionnaire({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs747(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx754("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx754("path", { d: "M1115 0l677 677v1371H256V0h859zm37 219v421h421l-421-421zM384 1920h1280V768h-640V128H384v1792zm128-640V896h384v384H512zm128-256v128h128v-128H640zM512 768V384h384v384H512zm128-256v128h128V512H640zm384 640v-128h512v128h-512zm-512 640v-384h384v384H512zm128-256v128h128v-128H640zm384 128v-128h512v128h-512z" })
      ]
    }
  );
}
var Questionnaire_default = SvgQuestionnaire;

// src/components/Icon/icons/QuestionnaireMirrored.tsx
import { jsx as jsx755, jsxs as jsxs748 } from "react/jsx-runtime";
function SvgQuestionnaireMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs748(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx755("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx755("path", { d: "M1115 0l677 677v1371H256V0h859zm37 219v421h421l-421-421zM384 1920h1280V768h-640V128H384v1792zm768-640V896h384v384h-384zm128-256v128h128v-128h-128zm-768 128v-128h512v128H512zm384-640v128H512V512h384zm256 1280v-384h384v384h-384zm128-256v128h128v-128h-128zm-768 128v-128h512v128H512z" })
      ]
    }
  );
}
var QuestionnaireMirrored_default = SvgQuestionnaireMirrored;

// src/components/Icon/icons/RadioBtnOff.tsx
import { jsx as jsx756, jsxs as jsxs749 } from "react/jsx-runtime";
function SvgRadioBtnOff({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs749(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx756("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx756("path", { d: "M1024 0q141 0 272 36t245 103 207 160 160 208 103 245 37 272q0 141-36 272t-103 245-160 207-208 160-245 103-272 37q-141 0-272-36t-245-103-207-160-160-208-103-244-37-273q0-141 36-272t103-245 160-207 208-160T751 37t273-37zm0 1920q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 123 32 237t90 214 141 182 181 140 214 91 238 32z" })
      ]
    }
  );
}
var RadioBtnOff_default = SvgRadioBtnOff;

// src/components/Icon/icons/RadioBtnOn.tsx
import { jsx as jsx757, jsxs as jsxs750 } from "react/jsx-runtime";
function SvgRadioBtnOn({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs750(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx757("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx757("path", { d: "M1024 0q141 0 272 36t245 103 207 160 160 208 103 245 37 272q0 141-36 272t-103 245-160 207-208 160-245 103-272 37q-141 0-272-36t-245-103-207-160-160-208-103-244-37-273q0-141 36-272t103-245 160-207 208-160T751 37t273-37zm0 1920q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 123 32 237t90 214 141 182 181 140 214 91 238 32zm0-1568q93 0 178 24t161 68 136 105 105 136 68 160 24 179q0 93-24 178t-68 161-105 136-136 105-160 68-179 24q-93 0-178-24t-161-68-136-105-105-136-68-160-24-179q0-93 24-178t68-161 105-136 136-105 160-68 179-24z" })
      ]
    }
  );
}
var RadioBtnOn_default = SvgRadioBtnOn;

// src/components/Icon/icons/Ratings.tsx
import { jsx as jsx758, jsxs as jsxs751 } from "react/jsx-runtime";
function SvgRatings({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs751(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx758("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx758("path", { d: "M1416 1254l248 794-640-492-640 492 248-794L0 768h784L1024 0l240 768h784l-632 486zm5 446q-38-124-76-246t-78-247q103-77 203-155t202-156h-502q-36-118-72-233t-74-234q-37 118-73 233t-73 234H376q102 78 202 156t203 155q-40 124-78 246t-76 247q100-77 198-153t199-153q100 77 198 153t199 153z" })
      ]
    }
  );
}
var Ratings_default = SvgRatings;

// src/components/Icon/icons/Reading.tsx
import { jsx as jsx759, jsxs as jsxs752 } from "react/jsx-runtime";
function SvgReading({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs752(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx759("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx759("path", { d: "M1664 256v1536H384V256h1280zm-128 1152H512v256h1024v-256zm0-1024H512v896h1024V384zM704 896q-26 0-45-19t-19-45q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19zm320 0q-26 0-45-19t-19-45q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19zm320 0q-26 0-45-19t-19-45q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19z" })
      ]
    }
  );
}
var Reading_default = SvgReading;

// src/components/Icon/icons/Recent.tsx
import { jsx as jsx760, jsxs as jsxs753 } from "react/jsx-runtime";
function SvgRecent({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs753(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx760("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx760("path", { d: "M1024 2048q-142 0-272-36t-245-103-207-160-160-208-103-245-37-272q0-141 36-272t103-245 160-207 208-160T752 37t272-37q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 142-36 272t-103 245-160 207-208 160-245 103-272 37zm0-1920q-124 0-238 32t-213 90-182 141-140 181-91 214-32 238q0 124 32 238t90 213 141 182 181 140 214 91 238 32q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32zm0 896V384H896v768h512v-128h-384z" })
      ]
    }
  );
}
var Recent_default = SvgRecent;

// src/components/Icon/icons/RecentInstalled.tsx
import { jsx as jsx761, jsxs as jsxs754 } from "react/jsx-runtime";
function SvgRecentInstalled({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs754(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx761("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx761("path", { d: "M2048 1024q0 32-1 64t-7 64h-129q5-32 7-64t2-64q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-121 0-234 31t-213 90-182 139-142 179-92 211-33 235q0 125 31 241t89 216 139 184 180 142 215 91 242 33q65 0 128-9v128q-32 4-64 6t-64 3q-142 0-272-36t-245-103-207-160-160-207-103-245-37-273q0-141 36-272t103-245 160-207 208-160T752 37t272-37q141 0 271 36t245 104 207 160 161 207 103 245 37 272zM896 384h128v640h384v128H896V384zm768 896v256h256v128h-256v256h-128v-256h-256v-128h256v-256h128z" })
      ]
    }
  );
}
var RecentInstalled_default = SvgRecentInstalled;

// src/components/Icon/icons/RecentPlayed.tsx
import { jsx as jsx762, jsxs as jsxs755 } from "react/jsx-runtime";
function SvgRecentPlayed({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs755(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx762("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx762("path", { d: "M896 384h128v640h384v128H896V384zm1152 640q0 32-1 64t-7 64h-129q5-32 7-64t2-64q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-121 0-234 31t-213 90-182 139-142 179-92 211-33 235q0 125 31 241t89 216 139 184 180 142 215 91 242 33q65 0 128-9v128q-32 4-64 6t-64 3q-142 0-272-36t-245-103-207-160-160-207-103-245-37-273q0-141 36-272t103-245 160-207 208-160T752 37t272-37q141 0 271 36t245 104 207 160 161 207 103 245 37 272zm-640 896v-640l512 320-512 320z" })
      ]
    }
  );
}
var RecentPlayed_default = SvgRecentPlayed;

// src/components/Icon/icons/RecentSolid.tsx
import { jsx as jsx763, jsxs as jsxs756 } from "react/jsx-runtime";
function SvgRecentSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs756(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx763("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx763("path", { d: "M2048 1024q0 141-36 272t-104 244-160 207-207 161-245 103-272 37q-141 0-272-36t-244-104-207-160-161-207-103-245-37-272q0-141 36-272t104-244 160-207 207-161T752 37t272-37q141 0 272 36t244 104 207 160 161 207 103 245 37 272zm-512 128v-128h-512V384H896v768h640z" })
      ]
    }
  );
}
var RecentSolid_default = SvgRecentSolid;

// src/components/Icon/icons/RecordArrow.tsx
import { jsx as jsx764, jsxs as jsxs757 } from "react/jsx-runtime";
function SvgRecordArrow({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs757(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx764("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx764("path", { d: "M1024 0q141 0 272 36t245 103 207 160 160 208 103 245 37 272q0 141-36 272t-103 245-160 207-208 160-245 103-272 37q-172 0-330-55t-289-154-226-238-141-304l123-34q40 145 123 265t198 208 253 135 289 49q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-129 0-251 36T546 267 355 428 215 640h297v128H0V256h128v274q67-123 163-221t212-166T752 37t272-37z" })
      ]
    }
  );
}
var RecordArrow_default = SvgRecordArrow;

// src/components/Icon/icons/RecordDot.tsx
import { jsx as jsx765, jsxs as jsxs758 } from "react/jsx-runtime";
function SvgRecordDot({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs758(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx765("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx765("path", { d: "M1344 1024q0 66-25 124t-68 102-102 69-125 25q-66 0-124-25t-102-68-69-102-25-125q0-66 25-124t68-102 102-69 125-25q66 0 124 25t102 68 69 102 25 125z" })
      ]
    }
  );
}
var RecordDot_default = SvgRecordDot;

// src/components/Icon/icons/RecordInnerCircle.tsx
import { jsx as jsx766, jsxs as jsxs759 } from "react/jsx-runtime";
function SvgRecordInnerCircle({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs759(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx766("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx766("path", { d: "M1024 0q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 141-36 272t-104 244-160 207-207 161-245 103-272 37q-141 0-272-36t-244-104-207-160-161-207-103-245-37-272q0-141 36-272t104-244 160-207 207-161T752 37t272-37zm0 1920q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 123 32 237t90 214 141 182 181 140 214 91 238 32z" })
      ]
    }
  );
}
var RecordInnerCircle_default = SvgRecordInnerCircle;

// src/components/Icon/icons/RecordOuterCircle.tsx
import { jsx as jsx767, jsxs as jsxs760 } from "react/jsx-runtime";
function SvgRecordOuterCircle({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs760(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx767("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx767("path", { d: "M1024 256q106 0 204 27t183 78 156 120 120 155 77 184 28 204q0 106-27 204t-78 183-120 156-155 120-184 77-204 28q-106 0-204-27t-183-78-156-120-120-155-77-184-28-204q0-106 27-204t78-183 120-156 155-120 184-77 204-28z" })
      ]
    }
  );
}
var RecordOuterCircle_default = SvgRecordOuterCircle;

// src/components/Icon/icons/RecordSeries.tsx
import { jsx as jsx768, jsxs as jsxs761 } from "react/jsx-runtime";
function SvgRecordSeries({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs761(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx768("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx768("path", { d: "M1408 640q79 0 149 30t122 82 83 123 30 149q0 80-30 149t-82 122-123 83-149 30q-33 0-65-6t-63-18q57-20 104-56t81-83 52-104 19-117q0-61-18-117t-52-103-81-84-105-56q31-11 63-17t65-7zm-384 0q79 0 149 30t122 82 83 123 30 149q0 80-30 149t-82 122-123 83-149 30q-33 0-65-6t-63-18q57-20 104-56t81-83 52-104 19-117q0-61-18-117t-52-103-81-84-105-56q31-11 63-17t65-7zm0 384q0 80-30 149t-82 122-123 83-149 30q-80 0-149-30t-122-82-83-122-30-150q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149z" })
      ]
    }
  );
}
var RecordSeries_default = SvgRecordSeries;

// src/components/Icon/icons/Refresh.tsx
import { jsx as jsx769, jsxs as jsxs762 } from "react/jsx-runtime";
function SvgRefresh({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs762(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx769("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx769("path", { d: "M2048 1024q0 142-36 272t-103 245-160 207-208 160-245 103-272 37q-142 0-272-36t-245-103-207-160-160-208-103-245-37-272q0-140 37-272t105-248 167-212 221-164H256V0h512v512H640V215q-117 56-211 140T267 545 164 773t-36 251q0 124 32 238t90 213 141 182 181 140 214 91 238 32q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-150-48-289t-136-253-207-197-266-124l34-123q166 45 304 140t237 226 155 289 55 331z" })
      ]
    }
  );
}
var Refresh_default = SvgRefresh;

// src/components/Icon/icons/Related.tsx
import { jsx as jsx770, jsxs as jsxs763 } from "react/jsx-runtime";
function SvgRelated({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs763(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx770("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx770("path", { d: "M384 640V384h256v256H384zm512 0V384h256v256H896zm512-256h256v256h-256V384zM384 1152V896h256v256H384zm512 0V896h256v256H896zm512 0V896h256v256h-256zM384 1664v-256h256v256H384zm512 0v-256h256v256H896zm512 0v-256h256v256h-256z" })
      ]
    }
  );
}
var Related_default = SvgRelated;

// src/components/Icon/icons/Reminder.tsx
import { jsx as jsx771, jsxs as jsxs764 } from "react/jsx-runtime";
function SvgReminder({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs764(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx771("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx771("path", { d: "M1792 1536v128h-512q0 53-20 99t-55 82-81 55-100 20q-53 0-99-20t-82-55-55-81-20-100H256v-128h128V768q0-88 23-170t64-153 100-129 130-100 153-65 170-23q88 0 170 23t153 64 129 100 100 130 65 153 23 170v768h128zm-256 0V768q0-106-40-199t-110-162-163-110-199-41q-106 0-199 40T663 406 553 569t-41 199v768h1024zm-512 256q27 0 50-10t40-27 28-41 10-50H896q0 27 10 50t27 40 41 28 50 10z" })
      ]
    }
  );
}
var Reminder_default = SvgReminder;

// src/components/Icon/icons/Remove.tsx
import { jsx as jsx772, jsxs as jsxs765 } from "react/jsx-runtime";
function SvgRemove({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs765(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx772("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx772("path", { d: "M256 896h1408v128H256V896z" })
      ]
    }
  );
}
var Remove_default = SvgRemove;

// src/components/Icon/icons/RemoveContent.tsx
import { jsx as jsx773, jsxs as jsxs766 } from "react/jsx-runtime";
function SvgRemoveContent({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs766(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx773("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx773("path", { d: "M2045 1245l-355 355 355 355-90 90-355-355-355 355-90-90 355-355-355-355 90-90 355 355 355-355 90 90zM256 1792h864l-128 128H128V128h1792v864l-128 128V256H256v1536z" })
      ]
    }
  );
}
var RemoveContent_default = SvgRemoveContent;

// src/components/Icon/icons/RemoveEvent.tsx
import { jsx as jsx774, jsxs as jsxs767 } from "react/jsx-runtime";
function SvgRemoveEvent({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs767(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx774("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx774("path", { d: "M1664 128h384v1792H0V128h384V0h128v128h1024V0h128v128zM384 256H128v256h1792V256h-256v128h-128V256H512v128H384V256zM128 1792h1792V640H128v1152zm1171-941l90 90-274 275 274 275-90 90-275-275-275 275-90-90 274-275-274-275 90-90 275 275 275-275z" })
      ]
    }
  );
}
var RemoveEvent_default = SvgRemoveEvent;

// src/components/Icon/icons/Repairs.tsx
import { jsx as jsx775, jsxs as jsxs768 } from "react/jsx-runtime";
function SvgRepairs({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs768(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx775("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx775("path", { d: "M1664 1152h-128v704q0 40-15 75t-41 61-61 41-75 15q-40 0-75-15t-61-41-41-61-15-75v-704h-128v-128h256V475l-128-128V0h384v347l-128 128v549h256v128zm-384-858l64 64 64-64V128h-128v166zm128 858h-128v704q0 26 19 45t45 19q26 0 45-19t19-45v-704zM704 0q66 0 124 25t101 69 69 102 26 124q0 75-34 142t-94 113v1281q0 40-15 75t-41 61-61 41-75 15q-40 0-75-15t-61-41-41-61-15-75V575q-60-45-94-112t-34-143q0-66 25-124t68-101 102-69T704 0zm64 504q28-16 51-34t41-39 26-49 10-62q0-30-9-58t-26-52-41-42-52-28v180l-64 64-64-64V140q-29 10-52 28t-40 42-26 52-10 58q0 35 9 62t27 48 40 40 52 34v1352q0 26 19 45t45 19q26 0 45-19t19-45V504z" })
      ]
    }
  );
}
var Repairs_default = SvgRepairs;

// src/components/Icon/icons/Repeat.tsx
import { jsx as jsx776, jsxs as jsxs769 } from "react/jsx-runtime";
function SvgRepeat({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs769(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx776("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx776("path", { d: "M128 1024q0 69 15 136t44 130 70 118 95 100l-91 91q-62-55-110-120t-82-139-51-153-18-163q0-106 27-204t78-183 120-156 155-120 184-77 204-28h646L1251 93l90-90 317 317-317 317-90-90 163-163H768q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170zm1659-574q62 54 110 119t82 139 51 154 18 162q0 106-27 204t-78 183-120 156-155 120-184 77-204 28H634l163 163-90 90-317-317 317-317 90 90-163 163h646q88 0 170-23t153-64 129-100 100-130 65-153 23-170q0-70-15-137t-43-130-70-117-95-101l90-89z" })
      ]
    }
  );
}
var Repeat_default = SvgRepeat;

// src/components/Icon/icons/RepeatBlock.tsx
import { jsx as jsx777, jsxs as jsxs770 } from "react/jsx-runtime";
function SvgRepeatBlock({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs770(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx777("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx777("path", { d: "M128 1024q0 69 15 136t44 130 70 118 95 100l-91 91q-62-55-110-120t-82-139-51-153-18-163q0-106 27-204t78-183 120-156 155-120 184-77 204-28h646L1251 93l90-90 317 317-317 317-90-90 163-163H768q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170zm1792 0q0-70-15-137t-43-130-70-117-95-101l90-89q62 54 110 119t82 139 51 154 18 162q0 77-15 150-26-27-56-49t-63-43q2-14 4-29t2-29zM797 1501l-163 163h390v128H634l163 163-90 90-317-317 317-317 90 90zm803-349q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm-320 448q0 66 25 124t68 102 102 69 125 25q47 0 92-13t84-40l-443-443q-26 39-39 84t-14 92zm587 176q26-39 39-84t14-92q0-66-25-124t-69-101-102-69-124-26q-47 0-92 13t-84 40l443 443z" })
      ]
    }
  );
}
var RepeatBlock_default = SvgRepeatBlock;

// src/components/Icon/icons/RepeatOnce.tsx
import { jsx as jsx778, jsxs as jsxs771 } from "react/jsx-runtime";
function SvgRepeatOnce({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs771(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx778("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx778("path", { d: "M128 1024q0 69 15 136t44 130 70 118 95 100l-91 91q-62-55-110-120t-82-139-51-153-18-163q0-106 27-204t78-183 120-156 155-120 184-77 204-28h646L1251 93l90-90 317 317-317 317-90-90 163-163H768q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170zm1659-574q62 54 110 119t82 139 51 154 18 162q0 106-27 204t-78 183-120 156-155 120-184 77-204 28H634l163 163-90 90-317-317 317-317 90 90-163 163h646q88 0 170-23t153-64 129-100 100-130 65-153 23-170q0-70-15-137t-43-130-70-117-95-101l90-89zm-635 958h-128V820q-29 21-61 34t-67 23V746q56-19 106-45t99-61h51v768z" })
      ]
    }
  );
}
var RepeatOnce_default = SvgRepeatOnce;

// src/components/Icon/icons/RepeatRefresh.tsx
import { jsx as jsx779, jsxs as jsxs772 } from "react/jsx-runtime";
function SvgRepeatRefresh({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs772(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx779("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx779("path", { d: "M1024 1920q154 0 295-47t258-134 203-208 132-270l122 38q-50 167-149 304t-232 237-294 153-335 55q-137 0-267-34t-245-98-214-157-170-210v243H0v-512h512v128H196q59 117 146 211t196 161 231 103 255 37zM2048 256v512h-512V640h316q-59-117-146-211t-196-161-231-103-255-37q-154 0-295 47T471 309 268 517 136 787L14 749q50-166 149-304t232-237T689 55t335-55q138 0 267 34t245 99 213 157 171 209V256h128z" })
      ]
    }
  );
}
var RepeatRefresh_default = SvgRepeatRefresh;

// src/components/Icon/icons/Replay.tsx
import { jsx as jsx780, jsxs as jsxs773 } from "react/jsx-runtime";
function SvgReplay({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs773(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx780("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx780("path", { d: "M1024 0q141 0 272 36t245 103 207 160 160 208 103 245 37 272q0 141-36 272t-103 245-160 207-208 160-245 103-272 37q-172 0-330-55t-289-154-226-238-141-304l123-34q40 145 123 265t198 208 253 135 289 49q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-129 0-251 36T546 267 355 428 215 640h297v128H0V256h128v274q67-123 163-221t212-166T752 37t272-37z" })
      ]
    }
  );
}
var Replay_default = SvgReplay;

// src/components/Icon/icons/Report.tsx
import { jsx as jsx781, jsxs as jsxs774 } from "react/jsx-runtime";
function SvgReport({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs774(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx781("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx781("path", { d: "M2048 1280v512h-512v-128h-256v384h-128v-896h512v128h384zm-512 256v-256h-256v256h256zm384-128h-256v256h256v-256zm-880-462q57 22 112 54l-64 110q-73-42-154-64t-166-22q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170H0q0-117 35-229t101-207 157-169 203-113q-56-36-100-83t-76-103-47-118-17-130q0-106 40-199t109-163T568 40 768 0q106 0 199 40t163 109 110 163 40 200q0 66-16 129t-48 119-75 103-101 83zM384 512q0 80 30 149t82 122 122 83 150 30q79 0 149-30t122-82 83-122 30-150q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149z" })
      ]
    }
  );
}
var Report_default = SvgReport;

// src/components/Icon/icons/Resolution4K.tsx
import { jsx as jsx782, jsxs as jsxs775 } from "react/jsx-runtime";
function SvgResolution4K({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs775(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx782("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx782("path", { d: "M797 933v260h80v185h-80v158H604v-158H192v-177l315-688h217l-306 680h186V933h193zm713 2l346 600h-228l-244-425-146 204v221h-192V512h192v507l333-507h242l-303 423z" })
      ]
    }
  );
}
var Resolution4K_default = SvgResolution4K;

// src/components/Icon/icons/ResolutionHd.tsx
import { jsx as jsx783, jsxs as jsxs776 } from "react/jsx-runtime";
function SvgResolutionHd({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs776(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx783("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx783("path", { d: "M734 935V512h187v1024H734v-415H378v415H192V512h186v423h356zm1122-56v290q0 92-28 160t-80 115-124 69-159 23h-327V512h328q88 0 160 23t123 68 79 115 28 161zm-193 296V873q0-45-14-78t-40-54-61-32-78-11h-145v652h145q42 0 77-10t61-32 40-55 15-78z" })
      ]
    }
  );
}
var ResolutionHd_default = SvgResolutionHd;

// src/components/Icon/icons/ResolutionSd.tsx
import { jsx as jsx784, jsxs as jsxs777 } from "react/jsx-runtime";
function SvgResolutionSd({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs777(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx784("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx784("path", { d: "M960 1232q0 85-32 143t-87 94-123 51-144 16q-106 0-201-30t-181-94l89-156q61 50 138 74t155 25q29 0 63-4t64-18 49-36 20-62q0-40-23-62t-60-36-84-20-98-16-97-25-85-48-60-81-23-127q0-84 30-142t82-96 119-53 143-17q89 0 170 28t156 77l-81 160q-53-36-116-60t-129-24q-26 0-58 4t-60 15-47 33-19 57q0 41 23 65t60 38 84 23 98 20 97 28 85 49 60 81 23 126zm896-350v284q0 92-30 160t-84 112-127 66-159 22h-335V522h335q88 0 161 21t127 65 82 113 30 161zm-198 290V876q0-46-15-78t-42-53-63-30-78-10h-148v638h148q42 0 78-9t63-30 42-53 15-79z" })
      ]
    }
  );
}
var ResolutionSd_default = SvgResolutionSd;

// src/components/Icon/icons/Reward.tsx
import { jsx as jsx785, jsxs as jsxs778 } from "react/jsx-runtime";
function SvgReward({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs778(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx785("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx785("path", { d: "M1024 1024q-80 0-149-30t-122-82-83-122-30-150q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 80-30 149t-82 122-123 83-149 30zm0-640q-53 0-99 20t-82 55-55 81-20 100q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20zm640 256q0 104-32 202t-96 182v1024l-512-256-512 256V1024q-63-83-95-181t-33-203q0-88 23-170t64-153 100-129T701 88t153-65 170-23q88 0 170 23t153 64 129 100 100 130 65 153 23 170zm-640-512q-106 0-199 40T663 278 553 441t-41 199q0 106 40 199t110 162 163 110 199 41q106 0 199-40t162-110 110-163 41-199q0-106-40-199t-110-162-163-110-199-41zm384 1728v-704q-83 63-181 95t-203 33q-104 0-202-32t-182-96v704l384-192 384 192z" })
      ]
    }
  );
}
var Reward_default = SvgReward;

// src/components/Icon/icons/Rewind.tsx
import { jsx as jsx786, jsxs as jsxs779 } from "react/jsx-runtime";
function SvgRewind({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs779(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx786("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx786("path", { d: "M896 1674L90 1024l806-645v1295zm-128-267V645l-474 379 474 383zm218-383l806-645v1295l-806-650zm678 383V645l-474 379 474 383z" })
      ]
    }
  );
}
var Rewind_default = SvgRewind;

// src/components/Icon/icons/Ribbon.tsx
import { jsx as jsx787, jsxs as jsxs780 } from "react/jsx-runtime";
function SvgRibbon({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs780(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx787("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx787("path", { d: "M1024 1024q-80 0-149-30t-122-82-83-122-30-150q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 80-30 149t-82 122-123 83-149 30zm0-640q-53 0-99 20t-82 55-55 81-20 100q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20zm640 256q0 104-32 202t-96 182v1024l-512-256-512 256V1024q-63-83-95-181t-33-203q0-133 50-249t137-204T774 50t250-50q133 0 249 50t204 137 137 203 50 250zm-640-512q-106 0-199 40T663 278 553 441t-41 199q0 106 40 199t110 162 163 110 199 41q106 0 199-40t162-110 110-163 41-199q0-106-40-199t-110-162-163-110-199-41zm384 1728v-704q-83 63-181 95t-203 33q-104 0-202-32t-182-96v704l384-192 384 192z" })
      ]
    }
  );
}
var Ribbon_default = SvgRibbon;

// src/components/Icon/icons/RightArmReplacement.tsx
import { jsx as jsx788, jsxs as jsxs781 } from "react/jsx-runtime";
function SvgRightArmReplacement({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs781(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx788("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx788("path", { d: "M1472 512q40 0 75 15t61 41 41 61 15 75v384q0 30-9 58t-26 53-40 42-53 28v651q0 27-10 50t-27 40-41 28-50 10h-384q-27 0-50-10t-40-27-28-41-10-50V512h576zm64 192q0-26-19-45t-45-19h-448v1280h128v-640h128v640h128v-768h40q22 0 42-4t33-18 13-42V704zm-64-448q0 53-20 99t-55 82-81 55-100 20q-53 0-99-20t-82-55-55-81-20-100q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100zm-256 128q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10zM679 804l114 56-171 349q-16 32-47 51t-68 20q-29 0-57-14l-123-62q-33-17-52-47t-19-68q0-15 3-28t10-27l183-408q23-52 70-83t105-31h141v128H627q-19 0-34 10t-24 28l-184 411-1 1 123 62 172-348z" })
      ]
    }
  );
}
var RightArmReplacement_default = SvgRightArmReplacement;

// src/components/Icon/icons/RightDoubleQuote.tsx
import { jsx as jsx789, jsxs as jsxs782 } from "react/jsx-runtime";
function SvgRightDoubleQuote({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs782(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx789("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx789("path", { d: "M0 409V66h332v343q0 51-7 105t-23 104-41 96-62 78-84 53T5 865V708q37 0 64-14t47-38 30-55 18-64 9-66 3-62H0zM546 66h329v343q0 78-16 159t-54 147-100 108-157 42V708q55 0 89-30t53-76 25-98 7-95H546V66z" })
      ]
    }
  );
}
var RightDoubleQuote_default = SvgRightDoubleQuote;

// src/components/Icon/icons/RightLegReplacement.tsx
import { jsx as jsx790, jsxs as jsxs783 } from "react/jsx-runtime";
function SvgRightLegReplacement({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs783(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx790("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx790("path", { d: "M1344 512q40 0 75 15t61 41 41 61 15 75v384q0 30-9 58t-26 53-40 42-53 28v651q0 27-10 50t-27 40-41 28-50 10h-128q-27 0-50-10t-40-27-28-41-10-50v-512H896q-30 0-54-11t-40-30-25-44-9-54q-29-10-52-28t-41-42-26-52-9-59V704q0-40 15-75t41-61 61-41 75-15h512zm64 192q0-26-19-45t-45-19H832q-26 0-45 19t-19 45v384q0 28 13 41t32 19 42 5 41-1v128h256v640h128v-768h40q22 0 42-4t33-18 13-42V704zm-673 761l114 57-227 455q-16 32-47 51t-68 20q-29 0-57-14l-123-62q-33-17-52-47t-19-68q0-15 3-28t10-27l206-463 117 52-207 466-1 1 123 62 228-455zm609-1209q0 53-20 99t-55 82-81 55-100 20q-53 0-99-20t-82-55-55-81-20-100q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100zm-256 128q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10z" })
      ]
    }
  );
}
var RightLegReplacement_default = SvgRightLegReplacement;

// src/components/Icon/icons/RightStick.tsx
import { jsx as jsx791, jsxs as jsxs784 } from "react/jsx-runtime";
function SvgRightStick({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs784(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx791("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx791("path", { d: "M1920 640q24 0 47 11t41 29 29 41 11 47v256q0 24-11 47t-29 41-41 29-47 11h-385v640h-126v-384h-1v-384h507l5-5V773l-5-5H133l-5 5v246l5 5h507v768H512v-640H128q-24 0-47-11t-41-29-29-41-11-47V768q0-24 11-47t29-41 41-29 47-11h1792zm-640 608q0 55-25 101t-71 76l96 239h-128l-78-196q-43 8-88 6t-90-2v192H768v-640h256q49 0 95 15t82 44 57 70 22 95zm-256 96q21 0 44-5t41-18 31-30 12-43q0-25-12-43t-30-30-42-17-44-6H896v192h128z" })
      ]
    }
  );
}
var RightStick_default = SvgRightStick;

// src/components/Icon/icons/RightStickClick.tsx
import { jsx as jsx792, jsxs as jsxs785 } from "react/jsx-runtime";
function SvgRightStickClick({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs785(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx792("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx792("path", { d: "M1024 512L768 256h512l-256 256zm896 128q24 0 47 11t41 29 29 41 11 47v256q0 24-11 47t-29 41-41 29-47 11h-385v640h-126v-384h-1v-384h507l5-5V773l-5-5H133l-5 5v246l5 5h507v768H512v-640H128q-24 0-47-11t-41-29-29-41-11-47V768q0-24 11-47t29-41 41-29 47-11h1792zm-640 608q0 55-25 101t-71 76l96 239h-128l-78-196q-43 8-88 6t-90-2v192H768v-640h256q49 0 95 15t82 44 57 70 22 95zm-256 96q21 0 44-5t41-18 31-30 12-43q0-25-12-43t-30-30-42-17-44-6H896v192h128z" })
      ]
    }
  );
}
var RightStickClick_default = SvgRightStickClick;

// src/components/Icon/icons/RightThumbDown.tsx
import { jsx as jsx793, jsxs as jsxs786 } from "react/jsx-runtime";
function SvgRightThumbDown({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs786(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx793("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx793("path", { d: "M768 1792h512l-256 256-256-256zm255-1407q132 0 249 50t204 136 137 203 51 249q0 88-23 170t-64 153-100 130-129 101-153 65-170 23q-88 0-170-23t-153-64-129-99-101-130-65-152-23-171q0-133 50-249t136-204 203-137 250-51zm1 1151q70 0 135-18t123-52 104-81 80-104 51-122 19-136q0-106-40-199t-110-162-163-110-199-40q-106 0-199 40T662 662 552 825t-40 200q0 106 40 199t110 162 163 110 199 40zm256-608q0 55-25 101t-71 76l96 239h-128l-78-196q-43 8-88 6t-90-2v192H768V704h256q49 0 95 15t82 44 57 70 22 95zm-256 96q21 0 44-5t41-18 31-30 12-43q0-25-12-43t-30-30-42-17-44-6H896v192h128z" })
      ]
    }
  );
}
var RightThumbDown_default = SvgRightThumbDown;

// src/components/Icon/icons/RightThumbDownSolid.tsx
import { jsx as jsx794, jsxs as jsxs787 } from "react/jsx-runtime";
function SvgRightThumbDownSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs787(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx794("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx794("path", { d: "M1152 928q0 25-12 43t-30 30-42 17-44 6H896V832h128q21 0 44 5t41 18 31 30 12 43zm-128 1120l-256-256h512l-256 256zm640-1025q0 88-23 170t-64 153-100 130-129 101-153 65-170 23q-88 0-170-23t-153-64-129-100-101-129-65-153-23-170q0-88 23-170t64-153 100-129 129-101 153-65 170-23q88 0 169 22t153 64 130 100 101 130 65 152 23 170zm-384 321l-96-239q45-30 70-76t26-101q0-53-21-94t-58-71-82-44-95-15H768v640h128v-192q27 0 54 1t53 1q36 0 71-6l78 196h128z" })
      ]
    }
  );
}
var RightThumbDownSolid_default = SvgRightThumbDownSolid;

// src/components/Icon/icons/RightThumbHorizontal.tsx
import { jsx as jsx795, jsxs as jsxs788 } from "react/jsx-runtime";
function SvgRightThumbHorizontal({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs788(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx795("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx795("path", { d: "M256 1280L0 1024l256-256v512zm1536-512l256 256-256 256V768zm-768-384q88 0 170 23t153 64 129 100 100 129 65 153 23 170q0 133-50 249t-137 204-203 137-250 51q-88 0-170-23t-153-64-129-100-100-129-65-153-23-170q0-133 50-249t137-204 203-137 250-51zm1 1152q106 0 199-40t162-111 110-163 40-199q0-106-40-199t-111-162-163-110-199-40q-106 0-199 40T662 663 552 826t-40 199q0 106 40 199t110 162 163 110 200 40zm255-608q0 55-25 101t-71 76l96 239h-128l-78-196q-43 8-88 6t-90-2v192H768V704h256q49 0 95 15t82 44 57 70 22 95zm-384 96h128q21 0 44-5t41-18 31-30 12-43q0-25-12-43t-30-30-42-17-44-6H896v192z" })
      ]
    }
  );
}
var RightThumbHorizontal_default = SvgRightThumbHorizontal;

// src/components/Icon/icons/RightThumbLeft.tsx
import { jsx as jsx796, jsxs as jsxs789 } from "react/jsx-runtime";
function SvgRightThumbLeft({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs789(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx796("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx796("path", { d: "M0 1024l256-256v512L0 1024zm1023-639q132 0 249 50t204 136 137 203 51 249q0 88-23 170t-64 153-100 130-129 101-153 65-170 23q-88 0-170-23t-153-64-129-99-101-130-65-152-23-171q0-133 50-249t136-204 203-137 250-51zm1 1151q70 0 135-18t123-52 104-81 80-104 51-122 19-136q0-106-40-199t-110-162-163-110-199-40q-106 0-199 40T662 662 552 825t-40 200q0 106 40 199t110 162 163 110 199 40zm256-608q0 55-25 101t-71 76l96 239h-128l-78-196q-43 8-88 6t-90-2v192H768V704h256q49 0 95 15t82 44 57 70 22 95zm-256 96q21 0 44-5t41-18 31-30 12-43q0-25-12-43t-30-30-42-17-44-6H896v192h128z" })
      ]
    }
  );
}
var RightThumbLeft_default = SvgRightThumbLeft;

// src/components/Icon/icons/RightThumbLeftSolid.tsx
import { jsx as jsx797, jsxs as jsxs790 } from "react/jsx-runtime";
function SvgRightThumbLeftSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs790(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx797("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx797("path", { d: "M256 1280L0 1024l256-256v512zm896-352q0 25-12 43t-30 30-42 17-44 6H896V832h128q21 0 44 5t41 18 31 30 12 43zm512 95q0 88-23 170t-64 153-100 130-129 101-153 65-170 23q-88 0-170-23t-153-64-129-100-101-129-65-153-23-170q0-88 23-170t64-153 100-129 129-101 153-65 170-23q88 0 169 22t153 64 130 100 101 130 65 152 23 170zm-384 321l-96-239q45-30 70-76t26-101q0-53-21-94t-58-71-82-44-95-15H768v640h128v-192q27 0 54 1t53 1q36 0 71-6l78 196h128z" })
      ]
    }
  );
}
var RightThumbLeftSolid_default = SvgRightThumbLeftSolid;

// src/components/Icon/icons/RightThumbRight.tsx
import { jsx as jsx798, jsxs as jsxs791 } from "react/jsx-runtime";
function SvgRightThumbRight({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs791(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx798("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx798("path", { d: "M2048 1024l-256 256V768l256 256zM1023 385q132 0 249 50t204 136 137 203 51 249q0 88-23 170t-64 153-100 130-129 101-153 65-170 23q-88 0-170-23t-153-64-129-99-101-130-65-152-23-171q0-133 50-249t136-204 203-137 250-51zm1 1151q70 0 135-18t123-52 104-81 80-104 51-122 19-136q0-106-40-199t-110-162-163-110-199-40q-106 0-199 40T662 662 552 825t-40 200q0 106 40 199t110 162 163 110 199 40zm256-608q0 55-25 101t-71 76l96 239h-128l-78-196q-43 8-88 6t-90-2v192H768V704h256q49 0 95 15t82 44 57 70 22 95zm-256 96q21 0 44-5t41-18 31-30 12-43q0-25-12-43t-30-30-42-17-44-6H896v192h128z" })
      ]
    }
  );
}
var RightThumbRight_default = SvgRightThumbRight;

// src/components/Icon/icons/RightThumbRightSolid.tsx
import { jsx as jsx799, jsxs as jsxs792 } from "react/jsx-runtime";
function SvgRightThumbRightSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs792(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx799("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx799("path", { d: "M1152 928q0 25-12 43t-30 30-42 17-44 6H896V832h128q21 0 44 5t41 18 31 30 12 43zm640-160l256 256-256 256V768zm-128 255q0 88-23 170t-64 153-100 130-129 101-153 65-170 23q-88 0-170-23t-153-64-129-100-101-129-65-153-23-170q0-88 23-170t64-153 100-129 129-101 153-65 170-23q88 0 169 22t153 64 130 100 101 130 65 152 23 170zm-384 321l-96-239q45-30 70-76t26-101q0-53-21-94t-58-71-82-44-95-15H768v640h128v-192q27 0 54 1t53 1q36 0 71-6l78 196h128z" })
      ]
    }
  );
}
var RightThumbRightSolid_default = SvgRightThumbRightSolid;

// src/components/Icon/icons/RightThumbUp.tsx
import { jsx as jsx800, jsxs as jsxs793 } from "react/jsx-runtime";
function SvgRightThumbUp({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs793(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx800("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx800("path", { d: "M1280 256H768L1024 0l256 256zm-257 129q132 0 249 50t204 136 137 203 51 249q0 88-23 170t-64 153-100 130-129 101-153 65-170 23q-88 0-170-23t-153-64-129-99-101-130-65-152-23-171q0-133 50-249t136-204 203-137 250-51zm1 1151q70 0 135-18t123-52 104-81 80-104 51-122 19-136q0-106-40-199t-110-162-163-110-199-40q-106 0-199 40T662 662 552 825t-40 200q0 106 40 199t110 162 163 110 199 40zm256-608q0 55-25 101t-71 76l96 239h-128l-78-196q-43 8-88 6t-90-2v192H768V704h256q49 0 95 15t82 44 57 70 22 95zm-256 96q21 0 44-5t41-18 31-30 12-43q0-25-12-43t-30-30-42-17-44-6H896v192h128z" })
      ]
    }
  );
}
var RightThumbUp_default = SvgRightThumbUp;

// src/components/Icon/icons/RightThumbUpSolid.tsx
import { jsx as jsx801, jsxs as jsxs794 } from "react/jsx-runtime";
function SvgRightThumbUpSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs794(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx801("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx801("path", { d: "M1664 1023q0 88-23 170t-64 153-100 130-129 101-153 65-170 23q-88 0-170-23t-153-64-129-100-101-129-65-153-23-170q0-88 23-170t64-153 100-129 129-101 153-65 170-23q88 0 169 22t153 64 130 100 101 130 65 152 23 170zm-384 321l-96-239q45-30 70-76t26-101q0-53-21-94t-58-71-82-44-95-15H768v640h128v-192q27 0 54 1t53 1q36 0 71-6l78 196h128zM1024 0l256 256H768L1024 0zm128 928q0 25-12 43t-30 30-42 17-44 6H896V832h128q21 0 44 5t41 18 31 30 12 43z" })
      ]
    }
  );
}
var RightThumbUpSolid_default = SvgRightThumbUpSolid;

// src/components/Icon/icons/RightThumbVertical.tsx
import { jsx as jsx802, jsxs as jsxs795 } from "react/jsx-runtime";
function SvgRightThumbVertical({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs795(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx802("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx802("path", { d: "M1024 2048l-256-256h512l-256 256zm0-2048l256 256H768L1024 0zm640 1023q0 133-50 249t-137 204-203 137-250 51q-88 0-170-23t-153-64-129-100-100-129-65-153-23-170q0-133 50-249t137-204 203-137 250-51q88 0 170 23t153 64 129 100 100 129 65 153 23 170zm-639 513q106 0 199-40t162-111 110-163 40-199q0-106-40-199t-111-162-163-110-199-40q-106 0-199 40T662 663 552 826t-40 199q0 106 40 199t110 162 163 110 200 40zm255-608q0 55-25 101t-71 76l96 239h-128l-78-196q-20 4-40 5t-41 1q-24 0-48-1t-49-1v192H768V704h256q49 0 95 15t82 44 57 70 22 95zm-384 96h128q21 0 44-5t41-18 31-30 12-43q0-25-12-43t-30-30-42-17-44-6H896v192z" })
      ]
    }
  );
}
var RightThumbVertical_default = SvgRightThumbVertical;

// src/components/Icon/icons/RightThumbVerticalSolid.tsx
import { jsx as jsx803, jsxs as jsxs796 } from "react/jsx-runtime";
function SvgRightThumbVerticalSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs796(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx803("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx803("path", { d: "M1024 0l256 256H768L1024 0zm128 928q0 25-12 43t-30 30-42 17-44 6H896V832h128q21 0 44 5t41 18 31 30 12 43zm512 95q0 88-23 170t-64 153-100 130-129 101-153 65-170 23q-88 0-170-23t-153-64-129-100-101-129-65-153-23-170q0-88 23-170t64-153 100-129 129-101 153-65 170-23q88 0 169 22t153 64 130 100 101 130 65 152 23 170zm-384 321l-96-239q45-30 70-76t26-101q0-53-21-94t-58-71-82-44-95-15H768v640h128v-192q27 0 54 1t53 1q36 0 71-6l78 196h128zm-256 704l-256-256h512l-256 256z" })
      ]
    }
  );
}
var RightThumbVerticalSolid_default = SvgRightThumbVerticalSolid;

// src/components/Icon/icons/Ring.tsx
import { jsx as jsx804, jsxs as jsxs797 } from "react/jsx-runtime";
function SvgRing({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs797(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx804("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx804("path", { d: "M1051 646q131 17 243 78t195 155 128 213 47 252q0 97-25 187t-71 168-110 143-142 110-169 71-187 25q-97 0-187-25t-168-71-143-110-110-142-71-169-25-187q0-133 46-252t129-213 195-155 245-78L530 302q-9-9-13-21t-5-24q0-18 9-33t26-24L922 12q11-5 18-8t20-4q14 0 21 3t19 9l375 188q17 8 26 24t9 34q0 25-19 44l-340 344zm187-371l-214-107v323l214-216zm-554 0l212 214V169L684 275zm276 1645q119 0 224-45t183-124 123-183 46-224q0-119-45-224t-124-183-183-123-224-46q-119 0-224 45T553 937t-123 183-46 224q0 119 45 224t124 183 183 123 224 46zm0-1023q93 0 174 35t142 96 96 142 35 174q0 93-35 174t-96 142-142 96-174 35q-93 0-174-35t-142-96-96-142-35-174q0-93 35-174t96-142 142-96 174-35zm0 766q66 0 124-25t101-68 69-102 25-124q0-66-25-124t-68-101-102-69-124-25q-66 0-124 25t-101 68-69 102-25 124q0 66 25 124t68 101 102 69 124 25z" })
      ]
    }
  );
}
var Ring_default = SvgRing;

// src/components/Icon/icons/Ringer.tsx
import { jsx as jsx805, jsxs as jsxs798 } from "react/jsx-runtime";
function SvgRinger({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs798(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx805("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx805("path", { d: "M1792 1536v128h-512q0 53-20 99t-55 82-81 55-100 20q-53 0-99-20t-82-55-55-81-20-100H256v-128h128V768q0-88 23-170t64-153 100-129 130-100 153-65 170-23q88 0 170 23t153 64 129 100 100 130 65 153 23 170v768h128zm-256 0V768q0-106-40-199t-110-162-163-110-199-41q-106 0-199 40T663 406 553 569t-41 199v768h1024zm-512 256q27 0 50-10t40-27 28-41 10-50H896q0 27 10 50t27 40 41 28 50 10z" })
      ]
    }
  );
}
var Ringer_default = SvgRinger;

// src/components/Icon/icons/RingerAccounts.tsx
import { jsx as jsx806, jsxs as jsxs799 } from "react/jsx-runtime";
function SvgRingerAccounts({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs799(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx806("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx806("path", { d: "M1536 1041q102 0 192 39t158 106 107 157 39 193q0 40-7 88t-24 86q-21 44-60 73t-91 30q-48 0-87-25t-60-70q-35 31-77 48t-90 17q-51 0-96-19t-78-53-53-79-20-96q0-51 19-96t53-78 79-53 96-20q42 0 80 13t71 40v-30h96v339q0 28 19 47t48 19q29 0 46-21t26-50 11-59 3-51q0-82-31-155t-86-127-128-86-155-32q-83 0-155 31t-127 86-86 128-32 155q0 83 31 155t86 127 127 86 156 32q69 0 135-23l32 90q-82 29-167 29-103 0-193-39t-157-106-106-158-39-193q0-102 39-192t106-158 157-106 193-39zm0 646q31 0 59-12t48-32 32-47 12-60q0-31-12-58t-32-48-48-33-59-12q-31 0-58 12t-48 32-33 48-12 59q0 31 12 58t32 48 48 33 59 12zm-640 105q24 0 49-10 13 29 28 57t33 55q-26 12-53 19t-57 7q-53 0-99-20t-82-55-55-81-20-100H128v-128h128q1-193 2-384t1-384q0-132 50-248t136-204 202-137 249-51q88 0 170 23t153 64 129 100 100 130 65 153 23 170v128q-32 0-64 3t-64 10V768q0-106-40-199t-110-162-163-110-199-41q-106 0-199 40T535 406 425 569t-41 199v768h512q0 32 3 64t10 64H768q0 27 10 50t27 40 41 28 50 10z" })
      ]
    }
  );
}
var RingerAccounts_default = SvgRingerAccounts;

// src/components/Icon/icons/RingerOff.tsx
import { jsx as jsx807, jsxs as jsxs800 } from "react/jsx-runtime";
function SvgRingerOff({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs800(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx807("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx807("path", { d: "M896 1664q0 26 10 49t27 41 40 28 50 10q23 65 57 121-14 3-28 5t-28 2q-53 0-99-20t-82-55-55-81-20-100H256v-128h128V768q0-88 23-170t64-153 100-129 130-100 153-65 170-23q88 0 170 23t153 64 129 100 100 130 65 153 23 170v228q-16-2-32-3t-32-1q-16 0-32 1t-32 3V768q0-106-40-199t-110-162-163-110-199-41q-106 0-199 40T663 406 553 569t-41 199v768h484q-2 16-3 32t-1 32q0 16 1 32t3 32H896zm1152-64q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35q93 0 174 35t143 96 96 142 35 175zm-768 0q0 66 25 124t68 102 102 69 125 25q47 0 92-13t84-40l-443-443q-26 39-39 84t-14 92zm587 176q26-39 39-84t14-92q0-66-25-124t-69-101-102-69-124-26q-47 0-92 13t-84 40l443 443z" })
      ]
    }
  );
}
var RingerOff_default = SvgRingerOff;

// src/components/Icon/icons/RingerSolid.tsx
import { jsx as jsx808, jsxs as jsxs801 } from "react/jsx-runtime";
function SvgRingerSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs801(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx808("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx808("path", { d: "M1792 1536v128h-512q0 53-20 99t-55 82-81 55-100 20q-53 0-99-20t-82-55-55-81-20-100H256v-128h128V768q0-88 23-170t64-153 100-129 130-100 153-65 170-23q88 0 170 23t153 64 129 100 100 130 65 153 23 170v768h128z" })
      ]
    }
  );
}
var RingerSolid_default = SvgRingerSolid;

// src/components/Icon/icons/RingOfLight.tsx
import { jsx as jsx809, jsxs as jsxs802 } from "react/jsx-runtime";
function SvgRingOfLight({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs802(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx809("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx809("path", { d: "M128 1153q20 148 86 279t169 233 233 168 279 87v128q-113-15-219-56t-200-102-175-142-142-175-103-201-56-219h128zM0 897q15-113 56-219t102-201 142-175 174-143T675 57 895 0v128q-149 20-279 87T383 384 215 617t-87 280H0zm1151 1023q148-20 279-86t234-169 169-232 87-280h128q-15 114-56 220t-103 200-142 175-175 141-201 103-220 56v-128zm769-1023q-20-149-87-280t-169-233-233-169-280-87V0q171 23 323 102t273 199 199 272 102 324h-128z" })
      ]
    }
  );
}
var RingOfLight_default = SvgRingOfLight;

// src/components/Icon/icons/Rocket.tsx
import { jsx as jsx810, jsxs as jsxs803 } from "react/jsx-runtime";
function SvgRocket({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs803(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx810("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx810("path", { d: "M2048 0v64q0 182-32 340t-99 299-166 268-235 249h1l-191 572h-302v-227q-138 81-279 156l-418-418q75-141 156-279H256V722l572-191v1q121-135 248-235t269-166 299-98 340-33h64zM384 896h174q29-46 58-91t62-89l-294 98v82zm385 666q51-29 102-57t102-58l-372-372q-29 51-57 102t-58 102v1l282 282h1zm465 102l98-294q-44 32-89 61t-91 59v174h82zm281-621q99-99 172-201t124-214 76-235 32-264q-140 5-263 31t-235 77-214 123-202 173v1q-100 96-182 203T668 962l418 418q118-72 225-154t203-183h1zm-235-19q-53 0-99-20t-82-55-55-81-20-100q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100q0 53-20 99t-55 82-81 55-100 20zm0-384q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10zM256 1536q53 0 99 20t82 55 55 81 20 100q0 53-20 99t-55 82-81 55-100 20H0v-256q0-53 20-99t55-82 81-55 100-20zm0 384q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50v128h128z" })
      ]
    }
  );
}
var Rocket_default = SvgRocket;

// src/components/Icon/icons/RotateClockwise.tsx
import { jsx as jsx811, jsxs as jsxs804 } from "react/jsx-runtime";
function SvgRotateClockwise({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs804(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx811("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx811("path", { d: "M1024 768q53 0 99 20t82 55 55 81 20 100q0 53-20 99t-55 82-81 55-100 20q-53 0-99-20t-82-55-55-81-20-100q0-53 20-99t55-82 81-55 100-20zm0 384q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10zm1024-128q0 140-37 272t-105 248-167 213-221 163h274v128h-512v-512h128v297q117-55 211-140t162-190 103-228 36-251q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 150 48 289t136 253 207 197 266 124l-34 123q-166-45-304-140t-237-226-155-289-55-331q0-141 36-272t103-245 160-207 208-160T751 37t273-37q141 0 272 36t244 104 207 160 161 207 103 245 37 272z" })
      ]
    }
  );
}
var RotateClockwise_default = SvgRotateClockwise;

// src/components/Icon/icons/RotateCounterClockwise.tsx
import { jsx as jsx812, jsxs as jsxs805 } from "react/jsx-runtime";
function SvgRotateCounterClockwise({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs805(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx812("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx812("path", { d: "M1024 768q53 0 99 20t82 55 55 81 20 100q0 53-20 99t-55 82-81 55-100 20q-53 0-99-20t-82-55-55-81-20-100q0-53 20-99t55-82 81-55 100-20zm0 384q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10zm0-1152q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 172-55 330t-154 289-238 226-304 141l-34-123q145-40 265-123t208-198 135-253 49-289q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 129 36 251t103 227 161 191 212 140v-297h128v512H256v-128h274q-123-67-221-163t-167-212-105-248-37-273q0-141 36-272t103-245 160-207 208-160T751 37t273-37z" })
      ]
    }
  );
}
var RotateCounterClockwise_default = SvgRotateCounterClockwise;

// src/components/Icon/icons/Sad.tsx
import { jsx as jsx813, jsxs as jsxs806 } from "react/jsx-runtime";
function SvgSad({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs806(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx813("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx813("path", { d: "M640 896q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10zm768-256q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10zM1024 0q141 0 272 36t245 103 207 160 160 208 103 245 37 272q0 141-36 272t-103 245-160 207-208 160-245 103-272 37q-141 0-272-36t-245-103-207-160-160-208-103-244-37-273q0-141 36-272t103-245 160-207 208-160T751 37t273-37zm0 1920q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 123 32 237t90 214 141 182 181 140 214 91 238 32zm0-640q138 0 261 56t216 160l-96 85q-74-83-171-128t-210-45q-112 0-209 45t-172 128l-96-85q92-103 215-159t262-57z" })
      ]
    }
  );
}
var Sad_default = SvgSad;

// src/components/Icon/icons/Sad2.tsx
import { jsx as jsx814, jsxs as jsxs807 } from "react/jsx-runtime";
function SvgSad2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs807(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx814("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx814("path", { d: "M640 896q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10zm768-256q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10zM1024 0q141 0 272 36t245 103 207 160 160 208 103 245 37 272q0 141-36 272t-103 245-160 207-208 160-245 103-272 37q-141 0-272-36t-245-103-207-160-160-208-103-244-37-273q0-141 36-272t103-245 160-207 208-160T751 37t273-37zm0 1920q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 123 32 237t90 214 141 182 181 140 214 91 238 32zm0-640q138 0 261 56t216 160l-96 85q-74-83-171-128t-210-45q-112 0-209 45t-172 128l-96-85q92-103 215-159t262-57z" })
      ]
    }
  );
}
var Sad2_default = SvgSad2;

// src/components/Icon/icons/Save.tsx
import { jsx as jsx815, jsxs as jsxs808 } from "react/jsx-runtime";
function SvgSave({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs808(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx815("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx815("path", { d: "M1792 128q27 0 50 10t40 27 28 41 10 50v1664H357l-229-230V256q0-27 10-50t27-40 41-28 50-10h1536zM512 896h1024V256H512v640zm768 512H640v384h128v-256h128v256h384v-384zm512-1152h-128v768H384V256H256v1381l154 155h102v-512h896v512h384V256z" })
      ]
    }
  );
}
var Save_default = SvgSave;

// src/components/Icon/icons/SaveSolid.tsx
import { jsx as jsx816, jsxs as jsxs809 } from "react/jsx-runtime";
function SvgSaveSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs809(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx816("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx816("path", { d: "M1920 251v1669H357l-229-230V256q0-25 9-48t27-41 39-28 48-11h1541q25 0 48 9t41 27 28 39 11 48zm-512 1541v-512H512v512h256v-256h128v256h512zm256-768V256H384v768h1280z" })
      ]
    }
  );
}
var SaveSolid_default = SvgSaveSolid;

// src/components/Icon/icons/ScreenTime.tsx
import { jsx as jsx817, jsxs as jsxs810 } from "react/jsx-runtime";
function SvgScreenTime({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs810(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx817("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx817("path", { d: "M1920 1024q63 83 95 181t33 203q0 133-50 249t-137 204-203 137-250 50q-133 0-249-50t-204-137-137-203-50-250H128q-27 0-50-10t-40-27-28-41-10-50V256q0-27 10-50t27-40 41-28 50-10h1664q27 0 50 10t40 27 28 41 10 50v768zM781 1280q22-112 80-206t142-162 187-106 218-38q104 0 202 32t182 96V256H128v1024h653zm627 640q106 0 199-40t162-110 110-163 41-199q0-106-40-199t-110-162-163-110-199-41q-106 0-199 40t-162 110-110 163-41 199q0 106 40 199t110 162 163 110 199 41zm0-512h256v128h-384v-512h128v384z" })
      ]
    }
  );
}
var ScreenTime_default = SvgScreenTime;

// src/components/Icon/icons/SdQualityResolution.tsx
import { jsx as jsx818, jsxs as jsxs811 } from "react/jsx-runtime";
function SvgSdQualityResolution({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs811(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx818("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx818("path", { d: "M1920 512v1152H0V512h1920zm-128 128H128v896h1664V640zm-256 448q0 66-25 124t-69 102-102 69-124 25h-192V768h192q66 0 124 25t101 69 69 102 26 124zm-384 192h64q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15h-64v384zm-448 0q26 0 45-19t19-45q0-26-19-45t-45-19q-40 0-75-15t-61-41-41-61-15-75q0-40 15-75t41-61 61-41 75-15q40 0 75 15t61 41 41 61 15 75H768q0-26-19-45t-45-19q-26 0-45 19t-19 45q0 26 19 45t45 19q40 0 75 15t61 41 41 61 15 75q0 40-15 75t-41 61-61 41-75 15q-40 0-75-15t-61-41-41-61-15-75h128q0 26 19 45t45 19z" })
      ]
    }
  );
}
var SdQualityResolution_default = SvgSdQualityResolution;

// src/components/Icon/icons/Search.tsx
import { jsx as jsx819, jsxs as jsxs812 } from "react/jsx-runtime";
function SvgSearch({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs812(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx819("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx819("path", { d: "M1344 0q97 0 187 25t168 71 143 110 110 142 71 169 25 187q0 97-25 187t-71 168-110 143-142 110-169 71-187 25q-127 0-240-41t-211-122l-784 784q-19 19-45 19t-45-19-19-45q0-26 19-45l784-784q-80-98-121-211t-42-240q0-97 25-187t71-168 110-143T988 96t169-71 187-25zm0 1280q119 0 224-45t183-124 123-183 46-224q0-119-45-224t-124-183-183-123-224-46q-119 0-224 45T937 297 814 480t-46 224q0 119 45 224t124 183 183 123 224 46z" })
      ]
    }
  );
}
var Search_default = SvgSearch;

// src/components/Icon/icons/SearchMedium.tsx
import { jsx as jsx820, jsxs as jsxs813 } from "react/jsx-runtime";
function SvgSearchMedium({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs813(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx820("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx820("path", { d: "M2048 683q0 94-24 181t-69 163-107 138-138 107-163 68-182 25q-114 0-221-36t-197-107l-801 801q-25 25-61 25-35 0-60-25t-25-60q0-17 6-33t19-28l801-801q-70-90-106-197t-37-221q0-94 24-181t69-164 106-138 138-106 163-69 182-25q94 0 181 24t164 69 138 107 106 138 69 163 25 182zm-683 512q106 0 199-40t162-110 110-163 41-199q0-106-40-199t-109-163-163-110-200-40q-106 0-199 40t-162 110-110 163-41 199q0 106 40 199t110 162 163 110 199 41z" })
      ]
    }
  );
}
var SearchMedium_default = SvgSearchMedium;

// src/components/Icon/icons/SelectionWheel.tsx
import { jsx as jsx821, jsxs as jsxs814 } from "react/jsx-runtime";
function SvgSelectionWheel({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs814(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx821("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx821("path", { d: "M1864 440q91 129 137 277t47 307q0 141-36 272t-104 244-160 207-207 161-245 103-272 37q-141 0-272-36t-244-104-207-160-161-207-103-245-37-272q0-141 36-272t104-244 160-207 207-161T752 37t272-37q158 0 306 46t278 138L1792 0l256 256-184 184zm-72-304l-252 252q-25 25-25 60t25 60 60 25q35 0 60-25l252-252-120-120zm128 888q0-132-38-257t-110-235q-18 20-36 37t-39 31-44 21-53 8q-25 0-49-7t-46-19q78 88 118 196t41 225q0 133-50 249t-137 204-203 137-250 50q-133 0-249-50t-204-137-137-203-50-250q0-133 50-249t137-204 203-137 250-50q117 0 225 40t196 118q-26-43-26-93 0-29 7-53t21-44 31-39 38-37q-110-72-235-110t-257-38q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 123 32 237t90 214 141 182 181 140 214 91 238 32q123 0 237-32t214-90 182-141 140-181 91-214 32-238zm-384 0q0-106-40-199t-110-162-163-110-199-41q-106 0-199 40T663 662 553 825t-41 199q0 106 40 199t110 162 163 110 199 41q106 0 199-40t162-110 110-163 41-199z" })
      ]
    }
  );
}
var SelectionWheel_default = SvgSelectionWheel;

// src/components/Icon/icons/SelectScene.tsx
import { jsx as jsx822, jsxs as jsxs815 } from "react/jsx-runtime";
function SvgSelectScene({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs815(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx822("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx822("path", { d: "M832 768h1088v512H832v1H128V767h704v1zM256 895v258h448V895H256zm1024 257V896H832v256h448zm512 0V896h-384v256h384z" })
      ]
    }
  );
}
var SelectScene_default = SvgSelectScene;

// src/components/Icon/icons/SemanticZoom.tsx
import { jsx as jsx823, jsxs as jsxs816 } from "react/jsx-runtime";
function SvgSemanticZoom({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs816(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx823("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx823("path", { d: "M128 128h1664v1664H128V128zm1536 1536V256H256v1408h1408zm-256-768v128H512V896h896z" })
      ]
    }
  );
}
var SemanticZoom_default = SvgSemanticZoom;

// src/components/Icon/icons/Send.tsx
import { jsx as jsx824, jsxs as jsxs817 } from "react/jsx-runtime";
function SvgSend({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs817(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx824("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx824("path", { d: "M1997 960L18 1843l220-883L18 77l1979 883zM206 301l149 598h1190L206 301zm147 726l-147 592 1327-592H353z" })
      ]
    }
  );
}
var Send_default = SvgSend;

// src/components/Icon/icons/SendMirrored.tsx
import { jsx as jsx825, jsxs as jsxs818 } from "react/jsx-runtime";
function SvgSendMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs818(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx825("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx825("path", { d: "M56 960l1979 883-220-883 220-883L56 960zm1791-659l-149 598H508l1339-598zm-147 726l147 592-1327-592h1180z" })
      ]
    }
  );
}
var SendMirrored_default = SvgSendMirrored;

// src/components/Icon/icons/Sensor.tsx
import { jsx as jsx826, jsxs as jsxs819 } from "react/jsx-runtime";
function SvgSensor({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs819(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx826("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx826("path", { d: "M2048 640v640H0V640h2048zm-128 128H128v384h1792V768zm-192 256q-26 0-45-19t-19-45q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19z" })
      ]
    }
  );
}
var Sensor_default = SvgSensor;

// src/components/Icon/icons/SensorWithStand.tsx
import { jsx as jsx827, jsxs as jsxs820 } from "react/jsx-runtime";
function SvgSensorWithStand({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs820(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx827("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx827("path", { d: "M1536 1280v127h512v129H0v-129h512v-127H0V640h2048v640h-512zm384-128V768H128v384h1792zm-512 128H640v127h768v-127zm320-256q-26 0-45-19t-19-45q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19z" })
      ]
    }
  );
}
var SensorWithStand_default = SvgSensorWithStand;

// src/components/Icon/icons/ServerProcesses.tsx
import { jsx as jsx828, jsxs as jsxs821 } from "react/jsx-runtime";
function SvgServerProcesses({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs821(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx828("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx828("path", { d: "M2038 1488l-124 51q6 30 6 61t-6 61l124 51-49 119-124-52q-17 26-38 47t-48 39l52 124-119 49-51-124q-30 6-61 6t-61-6l-51 124-119-49 52-124q-51-35-86-86l-124 52-49-119 124-51q-6-30-6-61t6-61l-124-51 49-119 124 52q35-51 86-86l-52-124 119-49 51 124q30-6 61-6t61 6l51-124 119 49-52 124q26 17 47 38t39 48l124-52 49 119zm-438 304q39 0 74-15t61-41 42-62 15-74q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15zm448-1664v896h-128V640H128v1024h896v128H0V128h2048zm-128 384V256H128v256h1792zM896 1408v-140q-31-11-60-34l-121 69-64-110 120-70q-3-18-3-35t3-35l-120-70 64-110 121 69q29-23 60-34V768h128v140q17 6 31 14t29 20l121-69 64 110-120 70q3 18 3 35t-3 35l120 70-64 110-121-69q-14 11-28 19t-32 15v140H896zm-32-320q0 40 28 68t68 28q40 0 68-28t28-68q0-40-28-68t-68-28q-40 0-68 28t-28 68z" })
      ]
    }
  );
}
var ServerProcesses_default = SvgServerProcesses;

// src/components/Icon/icons/Settings.tsx
import { jsx as jsx829, jsxs as jsxs822 } from "react/jsx-runtime";
function SvgSettings({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs822(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx829("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx829("path", { d: "M1783 988v18q0 9 1 18v18q0 9-1 18l259 161-159 383-297-68q-24 26-50 50l68 297-383 159-161-259h-18q-9 0-18 1h-18q-9 0-18-1l-161 259-383-159 68-297q-26-24-50-50l-297 68L6 1221l259-161v-18q0-9-1-18v-18q0-9 1-18L6 827l159-383 297 68q24-26 50-50l-68-297L827 6l161 259h18q9 0 18-1h18q9 0 18 1L1221 6l383 159-68 297q26 24 50 50l297-68 159 383-259 161zm-117 130q2-24 4-47t2-48q0-23-2-47t-4-47l236-147-86-208-271 63q-31-38-63-70t-71-64l63-271-208-86-148 236q-23-2-47-4t-47-2q-24 0-47 2t-48 4L782 146l-208 86 63 271q-38 31-70 63t-64 71l-271-63-86 208 236 148q-2 24-4 47t-2 48q0 23 2 47t4 47l-236 147 86 208 271-63q31 38 63 70t71 64l-63 271 208 86 148-236q23 2 47 4t47 2q24 0 47-2t48-4l147 236 208-86-63-271q38-31 70-63t64-71l271 63 86-208-236-148zm-642-470q78 0 146 29t120 81 80 119 30 147q0 78-29 146t-81 120-119 80-147 30q-78 0-146-29t-120-81-80-119-30-147q0-78 29-146t81-120 119-80 147-30zm0 640q55 0 103-20t84-57 56-84 21-103q0-55-20-103t-57-84-84-56-103-21q-55 0-103 20t-84 57-56 84-21 103q0 55 20 103t57 84 84 56 103 21z" })
      ]
    }
  );
}
var Settings_default = SvgSettings;

// src/components/Icon/icons/SettingsDisplaySound.tsx
import { jsx as jsx830, jsxs as jsxs823 } from "react/jsx-runtime";
function SvgSettingsDisplaySound({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs823(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx830("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx830("path", { d: "M1680 945q54 54 83 124t29 147q0 76-29 146t-83 125l-91-90q36-36 55-83t20-98q0-51-19-98t-56-83l91-90zm181-182q91 91 139 208t48 245q0 128-48 245t-139 208l-91-91q72-72 111-165t39-197q0-103-39-196t-111-166l91-91zm-965 645H0V256h1920v384h-128V384H128v896h768v128zm240 128l128 128H640v-128h496zm309-768h91v896h-91l-256-256h-165v-384h165l256-256zm-37 219l-165 165h-91v128h91l165 165V987z" })
      ]
    }
  );
}
var SettingsDisplaySound_default = SvgSettingsDisplaySound;

// src/components/Icon/icons/SettingsSolid.tsx
import { jsx as jsx831, jsxs as jsxs824 } from "react/jsx-runtime";
function SvgSettingsSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs824(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx831("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx831("path", { d: "M1790 992v64l258 168-155 386-296-64-51 51 90 296-387 155-167-258h-77l-168 258-386-155 64-296-51-51-309 64L0 1224l258-142v-77L0 837l168-386 296 64 51-51-64-309L837 0l142 258h77L1224 0l386 168-64 296 51 51 296-77 155 386-258 168zm-760 412q77 0 145-29t119-81 80-119 30-145q0-77-29-145t-81-118-119-80-145-30q-77 0-145 29t-118 80-80 119-30 145q0 77 29 145t80 119 119 80 145 30z" })
      ]
    }
  );
}
var SettingsSolid_default = SvgSettingsSolid;

// src/components/Icon/icons/SgControllerDown.tsx
import { jsx as jsx832, jsxs as jsxs825 } from "react/jsx-runtime";
function SvgSgControllerDown({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs825(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx832("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx832("path", { d: "M1024 379q132 0 248 50t204 138 137 203 51 249q0 133-50 249t-137 204-203 137-250 50q-133 0-249-50t-204-137-137-203-50-250q0-88 23-170t64-153 100-129 130-100 153-65 170-23zm0 1152q106 0 199-40t162-110 110-163 41-199q0-106-40-199t-110-162-163-110-199-41q-106 0-199 40T663 657 553 820t-41 199q0 106 40 199t110 162 163 110 199 41zM719 891h610l-305 509-305-509z" })
      ]
    }
  );
}
var SgControllerDown_default = SvgSgControllerDown;

// src/components/Icon/icons/SgControllerLeft.tsx
import { jsx as jsx833, jsxs as jsxs826 } from "react/jsx-runtime";
function SvgSgControllerLeft({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs826(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx833("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx833("path", { d: "M644 1024l508-305v610l-508-305zm378-638q132 0 248 50t204 138 137 203 51 249q0 88-23 170t-64 153-100 129-130 100-153 65-170 23q-133 0-249-50t-204-137-137-203-50-250q0-88 23-170t64-153 100-129 130-100 153-65 170-23zm0 1152q106 0 199-40t162-110 110-163 41-199q0-106-40-199t-110-162-163-110-199-41q-106 0-199 40T661 664 551 827t-41 199q0 106 40 199t109 163 163 110 200 40z" })
      ]
    }
  );
}
var SgControllerLeft_default = SvgSgControllerLeft;

// src/components/Icon/icons/SgControllerRight.tsx
import { jsx as jsx834, jsxs as jsxs827 } from "react/jsx-runtime";
function SvgSgControllerRight({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs827(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx834("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx834("path", { d: "M1022 384q88 0 170 23t153 64 129 100 100 130 65 153 23 170q0 88-23 170t-64 153-100 129-130 100-153 65-170 23q-133 0-249-50t-204-137-137-203-50-250q0-133 50-249t137-204 203-137 250-50zm0 1152q106 0 199-40t162-110 110-163 41-199q0-106-40-199t-110-162-163-110-199-41q-106 0-199 40T661 662 551 825t-41 199q0 106 40 199t110 162 163 110 199 41zm378-512l-509 305V719l509 305z" })
      ]
    }
  );
}
var SgControllerRight_default = SvgSgControllerRight;

// src/components/Icon/icons/SgControllerUp.tsx
import { jsx as jsx835, jsxs as jsxs828 } from "react/jsx-runtime";
function SvgSgControllerUp({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs828(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx835("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx835("path", { d: "M1024 384q88 0 170 23t153 64 129 100 100 130 65 153 23 170q0 88-23 170t-64 153-100 129-130 100-153 65-170 23q-133 0-249-50t-204-137-137-203-50-250q0-88 23-170t64-153 100-129 130-100 153-65 170-23zm0 1152q106 0 199-40t162-110 110-163 41-199q0-106-40-199t-110-162-163-110-199-41q-106 0-199 40T663 662 553 825t-41 199q0 106 40 199t110 162 163 110 199 41zm0-892l305 508H719l305-508z" })
      ]
    }
  );
}
var SgControllerUp_default = SvgSgControllerUp;

// src/components/Icon/icons/SgFavorite.tsx
import { jsx as jsx836, jsxs as jsxs829 } from "react/jsx-runtime";
function SvgSgFavorite({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs829(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx836("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx836("path", { d: "M1216 896h448l-389 256 197 512-448-320-448 320 197-512-389-256h448l192-512 192 512zM1024 0q141 0 272 36t245 103 207 160 160 208 103 245 37 272q0 141-36 272t-103 245-160 207-208 160-245 103-272 37q-141 0-272-36t-245-103-207-160-160-208-103-244-37-273q0-141 36-272t103-245 160-207 208-160T751 37t273-37zm0 1920q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 123 32 237t90 214 141 182 181 140 214 91 238 32z" })
      ]
    }
  );
}
var SgFavorite_default = SvgSgFavorite;

// src/components/Icon/icons/Share.tsx
import { jsx as jsx837, jsxs as jsxs830 } from "react/jsx-runtime";
function SvgShare({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs830(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx837("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx837("path", { d: "M1408 1536l128-128v384H0V512h128v1152h1280v-128zm-128-512q-128 0-250 25t-237 75-217 121-192 163v-128q0-124 32-238t90-214 140-181 181-140 214-91 239-32V0l704 704-704 704v-384zm128-512h-114q-53 0-103 6t-102 17-108 37q-87 36-161 92T687 791t-99 155-60 176q168-112 359-169t393-57h128v203l395-395-395-395v203z" })
      ]
    }
  );
}
var Share_default = SvgShare;

// src/components/Icon/icons/Shirt.tsx
import { jsx as jsx838, jsxs as jsxs831 } from "react/jsx-runtime";
function SvgShirt({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs831(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx838("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx838("path", { d: "M1792 402v1326h-256v192h-475l-37-37-37 37H512v-192H256V402l453-151 123-123h384l123 123 453 151zm-768-7l122-123 6-16H896l6 16 122 123zM384 1600h128v-128H384v128zm256 192h293l27-26V512L803 355 384 494v850h128V704h128v1088zm768 0V704h128v640h128V494l-419-139-157 157v1254l27 26h293zm128-192h128v-128h-128v128z" })
      ]
    }
  );
}
var Shirt_default = SvgShirt;

// src/components/Icon/icons/Shoes.tsx
import { jsx as jsx839, jsxs as jsxs832 } from "react/jsx-runtime";
function SvgShoes({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs832(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx839("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx839("path", { d: "M512 1536q27 0 50-6t48-19q38-19 76-29t82-10q43 0 81 10t77 29q27 14 54 19t56 7 58 0 58-1q74 0 160-6t174-21 169-39 147-62H128v64q0 26 19 45t45 19h320zm1408-288q0-16-14-32t-33-29-40-24-32-15q-78-30-155-57t-155-59l-102 101q-10 9-20 14t-25 5q-26 0-45-19t-19-45q0-26 19-45l65-66q-35-16-69-32t-68-34l-94 94q-19 19-45 19t-45-19-19-45q0-26 19-45l66-67q-32-18-63-37t-63-39L877 877q-10 9-20 14t-25 5q-26 0-45-19t-19-45q0-26 19-45l89-89q-24-19-49-38t-59-20q-28 0-53 12t-44 32h-1q-41 41-77 79t-77 68-87 47-109 18q-62 0-105-34t-77-82q-6-8-10-11v511h1792v-32zM128 640q42 0 67 20t44 44 36 44 45 20q49 0 85-19t68-47 61-62 63-61 75-48 96-19q36 0 70 11t63 32l1 2 9 7q9 7 21 15t22 17 13 10q13-12 25-21t32-9q26 0 45 19t19 46q0 20-13 38 32 20 64 38t64 37q17-17 34-33t43-17q26 0 45 19t19 45q0 17-6 25t-15 23q34 17 68 33t70 31q16-16 33-32t42-16q26 0 45 19t19 45q0 21-12 37 63 26 127 48t129 46q34 13 70 33t66 49 49 63 19 76v32q0 56-27 101t-70 80-92 62-96 43q-71 27-147 45t-154 31-156 17-154 5h-128q-43 0-81-10t-76-29q-23-11-48-18t-51-7q-27 0-50 6t-48 19q-37 19-76 29t-82 10H192q-40 0-75-15t-61-41-41-61-15-75V768q0-27 10-50t27-40 41-28 50-10z" })
      ]
    }
  );
}
var Shoes_default = SvgShoes;

// src/components/Icon/icons/ShopBrand.tsx
import { jsx as jsx840, jsxs as jsxs833 } from "react/jsx-runtime";
function SvgShopBrand({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs833(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx840("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx840("path", { d: "M2048 512v1344q0 40-15 75t-41 61-61 41-75 15H192q-40 0-75-15t-61-41-41-61-15-75V512h512q0-106 40-199t109-163T824 40t200-40q106 0 199 40t163 109 110 163 40 200h512zM1024 128q-80 0-149 30t-122 82-83 123-30 149h768q0-79-30-149t-82-122-123-83-149-30zm896 512H128v1216q0 26 19 45t45 19h1664q26 0 45-19t19-45V640z" })
      ]
    }
  );
}
var ShopBrand_default = SvgShopBrand;

// src/components/Icon/icons/ShoppingCartSolid.tsx
import { jsx as jsx841, jsxs as jsxs834 } from "react/jsx-runtime";
function SvgShoppingCartSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs834(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx841("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx841("path", { d: "M1792 1728q0 40-15 75t-41 61-61 41-75 15q-40 0-75-15t-61-41-41-61-15-75q0-31 11-64H885q11 33 11 64 0 40-15 75t-41 61-61 41-75 15q-40 0-75-15t-61-41-41-61-15-75q0-55 29-102t80-71L189 256H0V128h281l85 256h1682l-298 896H665l85 256h850q40 0 75 15t61 41 41 61 15 75zm-1024 0q0-26-19-45t-45-19q-26 0-45 19t-19 45q0 26 19 45t45 19q26 0 45-19t19-45zm832 64q26 0 45-19t19-45q0-26-19-45t-45-19q-26 0-45 19t-19 45q0 26 19 45t45 19z" })
      ]
    }
  );
}
var ShoppingCartSolid_default = SvgShoppingCartSolid;

// src/components/Icon/icons/ShuffleOff.tsx
import { jsx as jsx842, jsxs as jsxs835 } from "react/jsx-runtime";
function SvgShuffleOff({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs835(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx842("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx842("path", { d: "M1619 787l146-147H0V512h1765l-146-147 90-90 301 301-301 301-90-90zm0 474l90-90 301 301-301 301-90-90 146-147H0v-128h1765l-146-147z" })
      ]
    }
  );
}
var ShuffleOff_default = SvgShuffleOff;

// src/components/Icon/icons/ShuffleOn.tsx
import { jsx as jsx843, jsxs as jsxs836 } from "react/jsx-runtime";
function SvgShuffleOn({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs836(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx843("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx843("path", { d: "M1765 640q-127 4-240 35t-215 87-193 133-172 170q-34 39-68 76t-72 72q-168 153-372 238T0 1536v-128q131 0 248-30t223-86 198-134 178-175q35-41 70-79t76-74q81-72 170-130t187-99 202-63 214-26l-147-147 90-90 301 301-301 301-90-90 146-147zM805 836q-22 24-42 48t-44 49Q569 796 387 718T0 640V512q229 0 433 85t372 239zm904 335l301 301-301 301-90-90 147-147q-110-3-215-26t-204-64-188-101-172-133q42-47 85-97 144 132 320 210t373 83l-146-147 90-90z" })
      ]
    }
  );
}
var ShuffleOn_default = SvgShuffleOn;

// src/components/Icon/icons/SignalFull.tsx
import { jsx as jsx844, jsxs as jsxs837 } from "react/jsx-runtime";
function SvgSignalFull({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs837(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx844("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx844("path", { d: "M1536 256h384v1536h-384V256zm-512 1536V640h384v1152h-384zm-512 0v-768h384v768H512zm-512 0v-384h384v384H0z" })
      ]
    }
  );
}
var SignalFull_default = SvgSignalFull;

// src/components/Icon/icons/SignalHalf.tsx
import { jsx as jsx845, jsxs as jsxs838 } from "react/jsx-runtime";
function SvgSignalHalf({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs838(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx845("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx845("path", { d: "M1536 256h384v1536h-384V256zm256 1408V384h-128v1280h128zm-768 128V640h384v1152h-384zm128-1024v896h128V768h-128zM512 1792v-768h384v768H512zm-512 0v-384h384v384H0z" })
      ]
    }
  );
}
var SignalHalf_default = SvgSignalHalf;

// src/components/Icon/icons/SignalLow.tsx
import { jsx as jsx846, jsxs as jsxs839 } from "react/jsx-runtime";
function SvgSignalLow({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs839(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx846("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx846("path", { d: "M0 1792v-384h384v384H0zm512 0v-768h384v768H512zm128-640v512h128v-512H640zm384 640V640h384v1152h-384zm128-1024v896h128V768h-128zm384-512h384v1536h-384V256zm256 1408V384h-128v1280h128z" })
      ]
    }
  );
}
var SignalLow_default = SvgSignalLow;

// src/components/Icon/icons/SignalNone.tsx
import { jsx as jsx847, jsxs as jsxs840 } from "react/jsx-runtime";
function SvgSignalNone({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs840(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx847("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx847("path", { d: "M1536 256h384v1536h-384V256zm256 1408V384h-128v1280h128zm-768 128V640h384v1152h-384zm128-1024v896h128V768h-128zM512 1792v-768h384v768H512zm128-640v512h128v-512H640zM0 1792v-384h384v384H0zm128-256v128h128v-128H128z" })
      ]
    }
  );
}
var SignalNone_default = SvgSignalNone;

// src/components/Icon/icons/SignalThreeQuarter.tsx
import { jsx as jsx848, jsxs as jsxs841 } from "react/jsx-runtime";
function SvgSignalThreeQuarter({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs841(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx848("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx848("path", { d: "M1536 256h384v1536h-384V256zm256 1408V384h-128v1280h128zm-768 128V640h384v1152h-384zm-512 0v-768h384v768H512zm-512 0v-384h384v384H0z" })
      ]
    }
  );
}
var SignalThreeQuarter_default = SvgSignalThreeQuarter;

// src/components/Icon/icons/Signin.tsx
import { jsx as jsx849, jsxs as jsxs842 } from "react/jsx-runtime";
function SvgSignin({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs842(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx849("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx849("path", { d: "M1728 1152q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45q0-26 19-45t45-19zm-603-19q-79-54-170-81t-187-28q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170H0q0-117 35-229t101-207 157-169 203-113q-56-36-100-83t-76-103-47-118-17-130q0-106 40-199t109-163T568 40 768 0q106 0 199 40t163 109 110 163 40 200q0 67-16 129t-48 119-75 103-101 83q81 29 156 80l-71 107zM384 512q0 80 30 149t82 122 122 83 150 30q79 0 149-30t122-82 83-122 30-150q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149zm1280 384q79 0 149 30t122 82 83 123 30 149q0 80-30 149t-82 122-123 83-149 30q-65 0-128-23v151h-128v128h-128v128H896v-282l395-396q-11-46-11-90 0-79 30-149t82-122 122-83 150-30zm0 640q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100q0 35 9 64t21 61l-414 413v102h128v-128h128v-128h128v-91l93-92q40 23 77 39t86 16z" })
      ]
    }
  );
}
var Signin_default = SvgSignin;

// src/components/Icon/icons/SignOut.tsx
import { jsx as jsx850, jsxs as jsxs843 } from "react/jsx-runtime";
function SvgSignOut({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs843(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx850("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx850("path", { d: "M256 128v1664h896v128H128V0h1024v128H256zm1192 344l487 488-487 488-80-80 345-344H640V896h1073l-345-344 80-80z" })
      ]
    }
  );
}
var SignOut_default = SvgSignOut;

// src/components/Icon/icons/SingleBookmark.tsx
import { jsx as jsx851, jsxs as jsxs844 } from "react/jsx-runtime";
function SvgSingleBookmark({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs844(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx851("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx851("path", { d: "M1664 0v2048l-640-323-640 323V0h1280zm-128 128H512v1712q129-65 256-130t256-129q129 64 256 129t256 130V128z" })
      ]
    }
  );
}
var SingleBookmark_default = SvgSingleBookmark;

// src/components/Icon/icons/SingleBookmarkSolid.tsx
import { jsx as jsx852, jsxs as jsxs845 } from "react/jsx-runtime";
function SvgSingleBookmarkSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs845(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx852("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx852("path", { d: "M1664 0v2048l-640-323-640 323V0h1280z" })
      ]
    }
  );
}
var SingleBookmarkSolid_default = SvgSingleBookmarkSolid;

// src/components/Icon/icons/SizeBottomRange.tsx
import { jsx as jsx853, jsxs as jsxs846 } from "react/jsx-runtime";
function SvgSizeBottomRange({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs846(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx853("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx853("path", { d: "M1209 521q41 13 77 36t64 56 42 71 16 84v428q0 30-9 61t-25 58-41 49-53 32v652H640v-652q-58-22-93-69t-35-111V768q0-44 16-83t43-72 63-56 77-36q-34-43-52-94t-19-107q0-66 25-124t68-101 102-69T960 0q66 0 124 25t101 69 69 102 26 124q0 55-18 106t-53 95zM960 128q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15zm320 640q0-23-12-46t-30-41-42-29-47-12H768q-22 0-45 11t-41 30-30 42-12 45v448q0 27 13 40t32 19 42 6 41-1v640h128v-512h128v512h128v-640h64q15 0 27-8t20-20 12-28 5-28V768zM93 739l285 285-285 285-90-90 194-195L3 829l90-90zm1630 285l194 195-90 90-285-285 285-285 90 90-194 195z" })
      ]
    }
  );
}
var SizeBottomRange_default = SvgSizeBottomRange;

// src/components/Icon/icons/SizeTopRange.tsx
import { jsx as jsx854, jsxs as jsxs847 } from "react/jsx-runtime";
function SvgSizeTopRange({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs847(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx854("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx854("path", { d: "M1209 521q41 13 77 36t64 56 42 71 16 84v428q0 30-9 61t-25 58-41 49-53 32v652H640v-652q-58-22-93-69t-35-111V768q0-44 16-83t43-72 63-56 77-36q-34-43-52-94t-19-107q0-66 25-124t68-101 102-69T960 0q66 0 124 25t101 69 69 102 26 124q0 55-18 106t-53 95zM960 128q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15zm320 640q0-23-12-46t-30-41-42-29-47-12H768q-22 0-45 11t-41 30-30 42-12 45v448q0 27 13 40t32 19 42 6 41-1v640h128v-512h128v512h128v-640h64q15 0 27-8t20-20 12-28 5-28V768zm-899 61l-194 195 194 195-90 90L6 1024l285-285 90 90zm1533 195l-285 285-90-90 194-195-194-195 90-90 285 285z" })
      ]
    }
  );
}
var SizeTopRange_default = SvgSizeTopRange;

// src/components/Icon/icons/SkipBack.tsx
import { jsx as jsx855, jsxs as jsxs848 } from "react/jsx-runtime";
function SvgSkipBack({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs848(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx855("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx855("path", { d: "M1152 1674l-806-650 806-645v1295zm-128-267V645l-474 379 474 383zm218-383l806-645v1295l-806-650zm678 383V645l-474 379 474 383zM0 1664V384h128v1280H0z" })
      ]
    }
  );
}
var SkipBack_default = SvgSkipBack;

// src/components/Icon/icons/SkipBack10.tsx
import { jsx as jsx856, jsxs as jsxs849 } from "react/jsx-runtime";
function SvgSkipBack10({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs849(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx856("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx856("path", { d: "M462 1148q34-9 70-24t73-35 69-41 60-44h39v916H670v-774q-15 15-41 32t-57 31-59 26-51 17v-104zm904-139q62 0 106 20t76 56 51 81 30 98 14 103 4 101q0 49-5 102t-18 106-34 99-55 83-80 57-108 21q-59 0-102-20t-75-55-52-79-33-94-16-101-5-97q0-50 4-105t17-109 33-101 55-86 81-58 112-22zm-9 839q43 0 74-19t51-49 33-70 18-81 8-80 2-71q0-30-1-70t-8-82-17-84-32-73-51-53-73-20q-45 0-76 20t-53 52-34 74-19 85-8 85-2 73q0 31 2 70t8 80 18 78 33 69 52 48 75 18zM1038 128q173 0 334 54t294 154 233 237 149 304l-122 38q-45-148-131-269t-203-208-258-134-296-48q-130 0-254 36T552 395 356 556 210 768h316v128H14V384h128v243q72-116 169-208t214-157 246-99 267-35z" })
      ]
    }
  );
}
var SkipBack10_default = SvgSkipBack10;

// src/components/Icon/icons/SkipForward.tsx
import { jsx as jsx857, jsxs as jsxs850 } from "react/jsx-runtime";
function SvgSkipForward({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs850(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx857("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx857("path", { d: "M896 1674V379l806 645-806 650zm128-1029v762l474-383-474-379zM0 1674V379l806 645L0 1674zM128 645v762l474-383-474-379zm1792-261h128v1280h-128V384z" })
      ]
    }
  );
}
var SkipForward_default = SvgSkipForward;

// src/components/Icon/icons/SkipForward10.tsx
import { jsx as jsx858, jsxs as jsxs851 } from "react/jsx-runtime";
function SvgSkipForward10({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs851(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx858("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx858("path", { d: "M1920 384h128v512h-512V768h316q-59-117-146-211t-196-161-232-103-254-37q-155 0-296 47T471 437 268 645 136 915L14 877q33-111 88-209t130-182 163-150 191-112 211-71 227-25q136 0 266 34t247 99 213 157 170 209V384zM734 1004h39v916H670v-774q-15 15-41 32t-57 31-59 26-51 17v-104q34-9 70-24t73-35 69-41 60-44zm632 5q62 0 106 20t76 56 51 81 30 98 14 103 4 101q0 49-5 102t-18 106-34 99-55 83-80 57-108 21q-59 0-102-20t-75-55-52-79-33-94-16-101-5-97q0-50 4-105t17-109 33-101 55-86 81-58 112-22zm-9 839q43 0 74-19t51-49 33-70 18-81 8-80 2-71q0-30-1-70t-8-82-17-84-32-73-51-53-73-20q-45 0-76 20t-53 52-34 74-19 85-8 85-2 73q0 32 2 71t8 79 18 78 33 69 52 48 75 18z" })
      ]
    }
  );
}
var SkipForward10_default = SvgSkipForward10;

// src/components/Icon/icons/SkipForward30.tsx
import { jsx as jsx859, jsxs as jsxs852 } from "react/jsx-runtime";
function SvgSkipForward30({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs852(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx859("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx859("path", { d: "M704 1480q44 4 82 20t68 45 45 65 17 84q0 67-26 117t-70 84-101 51-118 17q-53 0-106-10t-98-39v-110q90 72 207 72 40 0 77-10t66-32 46-53 18-78q0-46-15-76t-40-51-58-30-69-14-73-4-70-1v-86q47 0 98-2t95-17 71-49 28-98q0-82-46-117t-123-35q-50 0-94 17t-84 47v-100q46-28 98-39t106-12q49 0 93 13t79 41 55 67 21 93q0 92-45 147t-134 80v3zm662-444q62 0 106 20t76 56 51 81 30 98 14 103 4 101q0 49-5 102t-17 106-35 99-55 83-79 57-109 21q-59 0-103-20t-75-55-52-79-32-94-16-101-5-97q0-50 4-105t17-109 33-101 55-86 81-58 112-22zm-9 840q43 0 74-19t51-50 33-70 18-81 8-80 2-71q0-30-1-70t-8-82-17-84-32-73-51-53-73-20q-45 0-76 20t-53 52-34 74-19 85-8 85-2 73q0 31 2 70t8 80 18 79 33 69 52 48 75 18zm691-1492v512h-512V768h316q-59-117-146-211t-196-161-232-103-254-37q-155 0-296 47T471 437 268 645 136 915L14 877q33-111 88-209t130-182 163-150 191-112 211-71 227-25q136 0 266 34t247 99 213 157 170 209V384h128z" })
      ]
    }
  );
}
var SkipForward30_default = SvgSkipForward30;

// src/components/Icon/icons/SkipTab.tsx
import { jsx as jsx860, jsxs as jsxs853 } from "react/jsx-runtime";
function SvgSkipTab({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs853(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx860("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx860("path", { d: "M512 1664v-640h896v640H512zm128-512v384h640v-384H640zm1280-640h128v512h-512V896h310q-81-87-174-158t-197-121-217-77-234-28q-139 0-267 36T514 648 299 802 115 999L13 921q93-119 205-218t239-170 270-110 297-39q129 0 252 28t236 81 216 128 192 167V512z" })
      ]
    }
  );
}
var SkipTab_default = SvgSkipTab;

// src/components/Icon/icons/SliderThumb.tsx
import { jsx as jsx861, jsxs as jsxs854 } from "react/jsx-runtime";
function SvgSliderThumb({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs854(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx861("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx861("path", { d: "M1365 341v1366q0 70-27 132t-73 108-109 74-132 27q-70 0-132-27t-108-73-74-109-27-132V341q0-70 27-132t73-108 109-74 132-27q70 0 132 27t108 73 74 109 27 132z" })
      ]
    }
  );
}
var SliderThumb_default = SvgSliderThumb;

// src/components/Icon/icons/SlotOne.tsx
import { jsx as jsx862, jsxs as jsxs855 } from "react/jsx-runtime";
function SvgSlotOne({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs855(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx862("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx862("path", { d: "M1579 597q97 0 182 37t149 101 101 149 37 183q0 98-36 183t-101 149-149 100-183 37H469q-98 0-183-36t-149-101-100-149-37-183q0-97 37-182t100-150 149-101 183-37h1110zm0 811q70 0 132-27t109-73 73-108 27-133q0-70-26-132t-73-109-109-74-133-27H469q-71 0-133 27t-108 73-73 109-27 133q0 71 27 133t73 108 108 73 133 27h1110zM981 853q44 0 83 17t68 46 46 68 17 83q0 44-17 83t-46 68-68 45-83 17H471q-44 0-83-16t-68-46-46-68-17-83q0-44 17-83t46-68 68-46 83-17h510z" })
      ]
    }
  );
}
var SlotOne_default = SvgSlotOne;

// src/components/Icon/icons/SlotTwo.tsx
import { jsx as jsx863, jsxs as jsxs856 } from "react/jsx-runtime";
function SvgSlotTwo({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs856(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx863("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx863("path", { d: "M1579 597q97 0 182 37t149 101 101 149 37 183q0 98-36 183t-101 149-149 100-183 37H469q-98 0-183-36t-149-101-100-149-37-183q0-97 37-182t100-150 149-101 183-37h1110zm0 811q70 0 132-27t109-73 73-108 27-133q0-70-26-132t-73-109-109-74-133-27H469q-71 0-133 27t-108 73-73 109-27 133q0 71 27 133t73 108 108 73 133 27h1110zm-2-555q44 0 83 17t68 46 46 68 17 83q0 44-17 83t-46 68-68 45-83 17h-510q-44 0-83-16t-68-46-46-68-17-83q0-44 17-83t46-68 68-46 83-17h510z" })
      ]
    }
  );
}
var SlotTwo_default = SvgSlotTwo;

// src/components/Icon/icons/SmartDj.tsx
import { jsx as jsx864, jsxs as jsxs857 } from "react/jsx-runtime";
function SvgSmartDj({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs857(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx864("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx864("path", { d: "M768 818l309 206-309 206V818zm896 206q0 155-58 294t-167 249l-91-90q91-91 139-208t49-245q0-128-48-244t-140-208l91-91q109 109 167 248t58 295zm-44-724q72 72 128 156t94 176 58 191 20 201q0 102-19 200t-58 191-95 177-128 156l-90-90q127-128 194-291t68-343q0-180-67-343t-195-291l90-90zm-362 362q73 73 111 166t39 196q0 103-38 196t-112 166l-91-90q54-54 83-124t29-148q0-76-29-146t-83-125l91-91zM896 1664q75 0 147-17t139-51l57 114q-80 41-166 61t-177 21q-106 0-204-27t-184-78-155-120-120-155-77-183-28-205q0-106 27-204t78-184 120-155 155-120 183-77 205-28q90 0 176 21t167 61l-57 114q-67-33-139-50t-147-18q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170q0 88 23 170t64 153 100 129 130 100 153 65 170 23z" })
      ]
    }
  );
}
var SmartDj_default = SvgSmartDj;

// src/components/Icon/icons/SmartGlass.tsx
import { jsx as jsx865, jsxs as jsxs858 } from "react/jsx-runtime";
function SvgSmartGlass({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs858(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx865("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx865("path", { d: "M1793 512v1152H128V512h282l123 128H256v896h1409V640h-277l123-128h282zM779 715q36-36 83-55t98-20q51 0 98 19t83 56l-91 91q-37-37-90-37-26 0-49 9t-42 28l-90-91zm452-90q-54-54-124-83t-147-29q-77 0-147 29t-125 83l-90-91q73-73 166-111t196-39q103 0 196 38t166 112l-91 91zM960 256q-128 0-245 48T507 444l-90-91q109-109 248-167t295-58q155 0 294 58t249 167l-91 91q-91-91-207-139t-245-49z" })
      ]
    }
  );
}
var SmartGlass_default = SvgSmartGlass;

// src/components/Icon/icons/SmartGlassConnected.tsx
import { jsx as jsx866, jsxs as jsxs859 } from "react/jsx-runtime";
function SvgSmartGlassConnected({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs859(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx866("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx866("path", { d: "M2048 1024v896H256v-256H0v-640h2048zm-128 640H384v128h1536v-128zm0-128v-384H128v384h1792zm-320-256q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45q0-26 19-45t45-19zM828 721q39-39 90-60t106-21q55 0 106 21t90 60l-91 90q-21-21-48-32t-57-11q-29 0-56 11t-49 32l-91-90zm552-125q-72-72-163-110t-193-38q-101 0-192 38T668 596l-91-91q90-89 205-137t242-48q127 0 242 48t205 137l-91 91zm251-217q-60-60-130-107t-148-78-161-48-168-17q-86 0-168 16t-160 48-148 79-131 107l-91-90Q466 149 646 75t378-75q198 0 378 74t320 215l-91 90z" })
      ]
    }
  );
}
var SmartGlassConnected_default = SvgSmartGlassConnected;

// src/components/Icon/icons/SmartGlassConnectingConsole.tsx
import { jsx as jsx867, jsxs as jsxs860 } from "react/jsx-runtime";
function SvgSmartGlassConnectingConsole({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs860(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx867("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx867("path", { d: "M2048 512v896H256v-256H0V512h2048zm-128 640H384v128h1536v-128zm0-128V640H128v384h1792zm-320-256q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45q0-26 19-45t45-19z" })
      ]
    }
  );
}
var SmartGlassConnectingConsole_default = SvgSmartGlassConnectingConsole;

// src/components/Icon/icons/SmartGlassConnectingRingsFull.tsx
import { jsx as jsx868, jsxs as jsxs861 } from "react/jsx-runtime";
function SvgSmartGlassConnectingRingsFull({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs861(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx868("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx868("path", { d: "M752 753q55-55 124-84t148-29q77 0 147 29t124 84l-90 90q-36-36-83-55t-98-20q-51 0-98 19t-83 56l-91-90zM571 571q91-91 208-139t245-48q128 0 244 48t208 139l-90 91q-72-72-165-111t-197-39q-103 0-196 39T662 662l-91-91zm453-443q180 0 343 68t291 194l-91 91q-109-109-249-166t-294-58q-154 0-294 57T481 481l-91-91q128-126 291-194t343-68z" })
      ]
    }
  );
}
var SmartGlassConnectingRingsFull_default = SvgSmartGlassConnectingRingsFull;

// src/components/Icon/icons/SmartGlassConnectingRingsInner.tsx
import { jsx as jsx869, jsxs as jsxs862 } from "react/jsx-runtime";
function SvgSmartGlassConnectingRingsInner({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs862(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx869("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx869("path", { d: "M1024 640q77 0 147 29t124 84l-90 90q-36-36-83-55t-98-20q-51 0-98 19t-83 56l-91-90q55-55 124-84t148-29z" })
      ]
    }
  );
}
var SmartGlassConnectingRingsInner_default = SvgSmartGlassConnectingRingsInner;

// src/components/Icon/icons/SmartGlassConnectingRingsMid.tsx
import { jsx as jsx870, jsxs as jsxs863 } from "react/jsx-runtime";
function SvgSmartGlassConnectingRingsMid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs863(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx870("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx870("path", { d: "M1024 384q128 0 244 48t208 139l-90 91q-72-72-165-111t-197-39q-103 0-196 39T662 662l-91-91q91-91 208-139t245-48z" })
      ]
    }
  );
}
var SmartGlassConnectingRingsMid_default = SvgSmartGlassConnectingRingsMid;

// src/components/Icon/icons/SmartGlassConnectingRingsOuter.tsx
import { jsx as jsx871, jsxs as jsxs864 } from "react/jsx-runtime";
function SvgSmartGlassConnectingRingsOuter({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs864(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx871("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx871("path", { d: "M1024 128q180 0 343 68t291 194l-91 91q-109-109-249-166t-294-58q-154 0-294 57T481 481l-91-91q128-126 291-194t343-68z" })
      ]
    }
  );
}
var SmartGlassConnectingRingsOuter_default = SvgSmartGlassConnectingRingsOuter;

// src/components/Icon/icons/SmartGlassGamerScore.tsx
import { jsx as jsx872, jsxs as jsxs865 } from "react/jsx-runtime";
function SvgSmartGlassGamerScore({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs865(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx872("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx872("path", { d: "M1024 0q141 0 272 36t245 103 207 160 160 208 103 245 37 272q0 141-36 272t-104 244-160 207-207 161-245 103-272 37q-141 0-272-36t-244-104-207-160-161-207-103-245-37-272q0-141 36-272t103-245 160-207 208-160T751 37t273-37zm367 956H984v173h192v187q-29 13-60 17t-63 4q-72 0-124-23t-87-64-52-97-17-125q0-69 20-127t60-101 95-67 127-24q71 0 140 14t132 50V572q-65-24-132-33t-137-9q-115 0-212 35T697 666 586 826t-40 213q0 115 35 204t101 150 156 93 205 32q91 0 180-17t168-64V956z" })
      ]
    }
  );
}
var SmartGlassGamerScore_default = SvgSmartGlassGamerScore;

// src/components/Icon/icons/SmartGlassPhone.tsx
import { jsx as jsx873, jsxs as jsxs866 } from "react/jsx-runtime";
function SvgSmartGlassPhone({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs866(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx873("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx873("path", { d: "M1793 512v1152H128V512h282l123 128H256v896h1409V640h-277l123-128h282zM779 715q36-36 83-55t98-20q51 0 98 19t83 56l-91 91q-37-37-90-37-26 0-49 9t-42 28l-90-91zm452-90q-54-54-124-83t-147-29q-77 0-147 29t-125 83l-90-91q73-73 166-111t196-39q103 0 196 38t166 112l-91 91zM960 256q-128 0-245 48T507 444l-90-91q109-109 248-167t295-58q155 0 294 58t249 167l-91 91q-91-91-207-139t-245-49z" })
      ]
    }
  );
}
var SmartGlassPhone_default = SvgSmartGlassPhone;

// src/components/Icon/icons/SmartGlassRemote.tsx
import { jsx as jsx874, jsxs as jsxs867 } from "react/jsx-runtime";
function SvgSmartGlassRemote({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs867(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx874("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx874("path", { d: "M768 1280H640v-128h128v128zm384 128h128v128h-128v-128zm-256-256h128v128H896v-128zm256 0h128v128h-128v-128zm-384 384H640v-128h128v128zm128-128h128v128H896v-128zm-128 384H640v-128h128v128zm384-128h128v128h-128v-128zm-256 0h128v128H896v-128zm64-768q-66 0-124-25t-102-68-69-102-25-125q0-66 25-124t68-101 102-69 125-26q66 0 124 25t101 69 69 102 26 124q0 66-25 124t-69 102-102 69-124 25zm0-512q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15zM1536 0v2048H384V0h1152zm-128 128H512v1792h896V128z" })
      ]
    }
  );
}
var SmartGlassRemote_default = SvgSmartGlassRemote;

// src/components/Icon/icons/SmartGlassTablet.tsx
import { jsx as jsx875, jsxs as jsxs868 } from "react/jsx-runtime";
function SvgSmartGlassTablet({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs868(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx875("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx875("path", { d: "M1793 512v1152H128V512h282l123 128H256v896h1409V640h-277l123-128h282zM779 715q36-36 83-55t98-20q51 0 98 19t83 56l-91 91q-37-37-90-37-26 0-49 9t-42 28l-90-91zm452-90q-54-54-124-83t-147-29q-77 0-147 29t-125 83l-90-91q73-73 166-111t196-39q103 0 196 38t166 112l-91 91zM960 256q-128 0-245 48T507 444l-90-91q109-109 248-167t295-58q155 0 294 58t249 167l-91 91q-91-91-207-139t-245-49z" })
      ]
    }
  );
}
var SmartGlassTablet_default = SvgSmartGlassTablet;

// src/components/Icon/icons/SmartVj.tsx
import { jsx as jsx876, jsxs as jsxs869 } from "react/jsx-runtime";
function SvgSmartVj({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs869(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx876("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx876("path", { d: "M127 520l853 568-853 569V520zm129 896l491-328-491-327v655zm1280-328q0 155-58 294t-167 249l-91-90q91-91 139-208t49-245q0-128-48-244t-140-208l91-91q109 109 167 248t58 295zm-44-724q72 72 128 156t94 176 58 191 20 201q0 102-19 200t-58 191-95 177-128 156l-90-90q127-128 194-291t68-343q0-180-67-343t-195-291l90-90zm-362 362q73 73 111 166t39 196q0 103-38 196t-112 166l-91-90q54-54 83-124t29-148q0-76-29-146t-83-125l91-91z" })
      ]
    }
  );
}
var SmartVj_default = SvgSmartVj;

// src/components/Icon/icons/Smiley.tsx
import { jsx as jsx877, jsxs as jsxs870 } from "react/jsx-runtime";
function SvgSmiley({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs870(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx877("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx877("path", { d: "M1408 896q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10zm-768 0q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10zM1024 0q141 0 272 36t244 104 207 160 161 207 103 245 37 272q0 141-36 272t-103 245-160 207-208 160-245 103-272 37q-141 0-272-36t-245-103-207-160-160-208-103-244-37-273q0-141 36-272t103-245 160-207 208-160T751 37t273-37zm0 1920q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-123-32-237t-90-214-141-182-181-140-214-91-238-32q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 123 32 237t90 214 141 182 181 140 214 91 238 32zm0-384q73 0 141-20t128-57 106-90 81-118l115 58q-41 81-101 147t-134 112-159 71-177 25q-92 0-177-25t-159-71-134-112-101-147l115-58q32 66 80 118t107 90 127 57 142 20z" })
      ]
    }
  );
}
var Smiley_default = SvgSmiley;

// src/components/Icon/icons/Smooth.tsx
import { jsx as jsx878, jsxs as jsxs871 } from "react/jsx-runtime";
function SvgSmooth({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs871(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx878("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx878("path", { d: "M1024 0q141 0 272 36t245 103 207 160 160 208 103 245 37 272q0 141-36 272t-103 245-160 207-208 160-245 103-272 37q-141 0-272-36t-245-103-207-160-160-208-103-244-37-273q0-141 36-272t103-245 160-207 208-160T751 37t273-37zm0 128q-123 0-237 32t-214 90-182 141-140 181-91 214-32 238q0 100 22 197t65 188q55-89 130-160t164-122 189-76 205-27q31 0 62 1t62 1q127 0 242-42t207-119 154-181 83-232q-64-77-142-137t-166-101-184-64-197-22zm0 1792q123 0 237-32t214-90 182-141 140-181 91-214 32-238q0-113-28-222t-82-208q-43 128-121 231t-181 177-227 112-258 40q-31 0-61-1t-62-1q-97 0-188 27t-171 78-144 122-107 158q63 90 144 161t176 120 199 76 215 26z" })
      ]
    }
  );
}
var Smooth_default = SvgSmooth;

// src/components/Icon/icons/Speakers.tsx
import { jsx as jsx879, jsxs as jsxs872 } from "react/jsx-runtime";
function SvgSpeakers({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs872(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx879("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx879("path", { d: "M1664 128v1920H384V128h1280zm-128 128H512v1664h1024V256zm-512 896q-80 0-149-30t-122-82-83-122-30-150q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 80-30 149t-82 122-123 83-149 30zm0-640q-53 0-99 20t-82 55-55 81-20 100q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20zm0 768q53 0 99 20t82 55 55 81 20 100q0 53-20 99t-55 82-81 55-100 20q-53 0-99-20t-82-55-55-81-20-100q0-53 20-99t55-82 81-55 100-20zm0 384q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10zm0-800q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68q0 40-28 68t-68 28z" })
      ]
    }
  );
}
var Speakers_default = SvgSpeakers;

// src/components/Icon/icons/Sports.tsx
import { jsx as jsx880, jsxs as jsxs873 } from "react/jsx-runtime";
function SvgSports({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs873(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx880("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx880("path", { d: "M1219 0q114 0 220 29t198 84 168 130 130 168 83 198 30 220q0 155-54 294t-149 250-227 183-285 94q5 36 7 72t3 72q0 53-20 99t-55 80-81 55-99 20q-150 0-289-39t-260-110-220-170-170-220-110-260T0 960q0-51 19-97t55-82v-1q0-1 2-1 36-35 82-54t97-20q36 0 72 2t71 8q21-154 94-285t183-226T924 54t295-54zm677 646q-19-72-53-138t-83-125l-225 224q48 33 103 50t114 17q76 0 144-28zm-500-495q-27 66-27 140 0 61 19 119t55 108l226-226q-59-50-128-87t-145-54zm-177-23q-125 0-239 41T771 290l450 450 131-131q-54-69-82-149t-28-169q0-42 6-82t20-79q-12-1-24-1t-25-1zM680 381q-64 76-104 167t-52 191q128 32 242 93t214 149l150-150-450-450zm408 1539q26 0 49-10t40-27 28-40 10-49q0-35-2-68t-8-68h-1q-9-45-17-83t-19-74-25-73-37-79q-60-118-151-213T752 974 513 870t-258-37q-26 0-49 10t-41 27v1q-17 18-27 41t-10 48q0 132 34 254t97 230 150 194 195 150 229 97 255 35zm221-396q99-13 190-52t168-104l-446-447-151 151q85 96 146 211t93 241zm449-247q80-95 121-209t41-239v-27q0-13-2-27-81 27-167 27-83 0-162-26t-145-77l-133 132 447 446zm-1177-81l271 271-90 91-272-272 91-90z" })
      ]
    }
  );
}
var Sports_default = SvgSports;

// src/components/Icon/icons/StartBack.tsx
import { jsx as jsx881, jsxs as jsxs874 } from "react/jsx-runtime";
function SvgStartBack({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs874(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx881("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx881("path", { d: "M1024 384q88 0 170 23t153 64 129 100 100 130 65 153 23 170q0 133-50 249t-137 204-203 137-250 50q-133 0-249-50t-204-137-137-203-50-250q0-88 23-170t64-153 100-129 130-100 153-65 170-23zm0 1152q106 0 199-40t162-110 110-163 41-199q0-106-40-199t-110-162-163-110-199-41q-106 0-199 40T663 662 553 825t-41 199q0 106 40 199t110 162 163 110 199 41zm-376-512l509-305v610l-509-305zm381-79l-132 79 132 79V945z" })
      ]
    }
  );
}
var StartBack_default = SvgStartBack;

// src/components/Icon/icons/StartParty.tsx
import { jsx as jsx882, jsxs as jsxs875 } from "react/jsx-runtime";
function SvgStartParty({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs875(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx882("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx882("path", { d: "M1280 896q-80 0-149 30t-122 82-83 123-30 149q0 92-41 173t-115 136q65 33 117 81t90 108 57 128 20 142H896q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149H0q0-73 20-141t57-128 89-108 118-82q-74-55-115-136t-41-173q0-79 30-149t82-122 122-83 150-30q92 0 173 41t136 115q37-75 97-134t134-97q-74-55-115-136t-41-173q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 92-41 173t-115 136q65 33 117 81t90 108 57 128 20 142h-128q0-79-30-149t-82-122-123-83-149-30zm-256-384q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100zM512 1536q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100q0 53 20 99t55 82 81 55 100 20zm1536 256h-256v256h-128v-256h-256v-128h256v-256h128v256h256v128z" })
      ]
    }
  );
}
var StartParty_default = SvgStartParty;

// src/components/Icon/icons/StatusCircleBlock.tsx
import { jsx as jsx883, jsxs as jsxs876 } from "react/jsx-runtime";
function SvgStatusCircleBlock({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs876(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx883("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx883("path", { d: "M1792 1088q0 115-29 221t-84 199-130 168-168 130-199 84-222 30q-115 0-221-29t-199-84-168-130-130-168-84-199-30-222q0-115 29-221t84-199 130-168 168-130 199-84 222-30q115 0 221 29t199 84 168 130 130 168 84 199 30 222zm-832 704q124 0 239-41t211-122L419 638q-80 95-121 210t-42 240q0 97 25 187t71 168 110 142 143 111 168 71 187 25zm541-254q80-95 121-210t42-240q0-97-25-187t-71-168-110-142-143-111-168-71-187-25q-124 0-239 41T510 547l991 991z" })
      ]
    }
  );
}
var StatusCircleBlock_default = SvgStatusCircleBlock;

// src/components/Icon/icons/StatusCircleErrorX.tsx
import { jsx as jsx884, jsxs as jsxs877 } from "react/jsx-runtime";
function SvgStatusCircleErrorX({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs877(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx884("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx884("path", { d: "M1421 717l-371 371 371 371-90 90-371-371-371 371-90-90 371-371-371-371 90-90 371 371 371-371 90 90z" })
      ]
    }
  );
}
var StatusCircleErrorX_default = SvgStatusCircleErrorX;

// src/components/Icon/icons/StatusCircleExclamation.tsx
import { jsx as jsx885, jsxs as jsxs878 } from "react/jsx-runtime";
function SvgStatusCircleExclamation({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs878(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx885("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx885("path", { d: "M1024 1792H896v-128h128v128zm0-256H896V896h128v640z" })
      ]
    }
  );
}
var StatusCircleExclamation_default = SvgStatusCircleExclamation;

// src/components/Icon/icons/StatusCircleInner.tsx
import { jsx as jsx886, jsxs as jsxs879 } from "react/jsx-runtime";
function SvgStatusCircleInner({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs879(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx886("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx886("path", { d: "M960 256q115 0 221 30t198 84 169 130 130 168 84 199 30 221q0 115-30 221t-84 198-130 169-168 130-199 84-221 30q-115 0-221-30t-198-84-169-130-130-168-84-199-30-221q0-115 30-221t84-198 130-169 168-130 199-84 221-30z" })
      ]
    }
  );
}
var StatusCircleInner_default = SvgStatusCircleInner;

// src/components/Icon/icons/StatusCircleOuter.tsx
import { jsx as jsx887, jsxs as jsxs880 } from "react/jsx-runtime";
function SvgStatusCircleOuter({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs880(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx887("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx887("path", { d: "M960 128q132 0 254 34t230 97 194 150 150 195 97 229 35 255q0 132-34 254t-97 230-150 194-195 150-229 97-255 35q-132 0-254-34t-230-97-194-150-150-195-97-229-35-255q0-132 34-254t97-230 150-194 195-150 229-97 255-35z" })
      ]
    }
  );
}
var StatusCircleOuter_default = SvgStatusCircleOuter;

// src/components/Icon/icons/StatusTriangleInner.tsx
import { jsx as jsx888, jsxs as jsxs881 } from "react/jsx-runtime";
function SvgStatusTriangleInner({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs881(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx888("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx888("path", { d: "M960 512l704 1408H256L960 512z" })
      ]
    }
  );
}
var StatusTriangleInner_default = SvgStatusTriangleInner;

// src/components/Icon/icons/StatusTriangleOuter.tsx
import { jsx as jsx889, jsxs as jsxs882 } from "react/jsx-runtime";
function SvgStatusTriangleOuter({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs882(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx889("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx889("path", { d: "M960 128l960 1920H0L960 128z" })
      ]
    }
  );
}
var StatusTriangleOuter_default = SvgStatusTriangleOuter;

// src/components/Icon/icons/StepBack.tsx
import { jsx as jsx890, jsxs as jsxs883 } from "react/jsx-runtime";
function SvgStepBack({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs883(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx890("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx890("path", { d: "M1280 1792L256 1024l1024-768v1536zm-128-256V512l-683 512 683 512zm386-1280h125v1536h-125V256z" })
      ]
    }
  );
}
var StepBack_default = SvgStepBack;

// src/components/Icon/icons/StepForward.tsx
import { jsx as jsx891, jsxs as jsxs884 } from "react/jsx-runtime";
function SvgStepForward({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs884(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx891("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx891("path", { d: "M768 256l1024 768-1024 768V256zm128 256v1024l683-512-683-512zM385 1792V256h125v1536H385z" })
      ]
    }
  );
}
var StepForward_default = SvgStepForward;

// src/components/Icon/icons/Stop.tsx
import { jsx as jsx892, jsxs as jsxs885 } from "react/jsx-runtime";
function SvgStop({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs885(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx892("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx892("path", { d: "M128 128h1792v1792H128V128zm1664 1664V256H256v1536h1536z" })
      ]
    }
  );
}
var Stop_default = SvgStop;

// src/components/Icon/icons/StopSolid.tsx
import { jsx as jsx893, jsxs as jsxs886 } from "react/jsx-runtime";
function SvgStopSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs886(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx893("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx893("path", { d: "M1920 128v1792H128V128h1792z" })
      ]
    }
  );
}
var StopSolid_default = SvgStopSolid;

// src/components/Icon/icons/StopWatch.tsx
import { jsx as jsx894, jsxs as jsxs887 } from "react/jsx-runtime";
function SvgStopWatch({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs887(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx894("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx894("path", { d: "M1024 1152h384v128H896V640h128v512zm896 0q0 124-32 238t-90 214-140 181-181 140-214 91-239 32q-124 0-238-32t-214-90-181-140-140-181-91-214-32-239q0-111 26-216t75-198 118-172 154-141 185-103 210-57V128H640V0h640v128h-256v128q139 0 270 41t245 122l208-208 90 90-198 199q135 137 208 297t73 355zm-896 768q106 0 204-27t183-78 156-120 120-155 77-184 28-204q0-106-27-204t-78-183-120-156-155-120-184-77-204-28q-106 0-204 27t-183 78-156 120-120 155-77 184-28 204q0 106 27 204t78 183 120 156 155 120 184 77 204 28z" })
      ]
    }
  );
}
var StopWatch_default = SvgStopWatch;

// src/components/Icon/icons/StorageInternalExternal.tsx
import { jsx as jsx895, jsxs as jsxs888 } from "react/jsx-runtime";
function SvgStorageInternalExternal({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs888(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx895("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx895("path", { d: "M0 1152h2048v896H256v-256H0v-640zm1920 640H384v128h1536v-128zM128 1664h1792v-384H128v384zm1472-128q-26 0-45-19t-19-45q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19zM256 576h128v64H256v-64zm128-192v64H256v-64h128zM1920 0q27 0 50 10t40 27 28 41 10 50v768q0 27-10 50t-27 40-41 28-50 10H640q-27 0-50-10t-40-27-28-41-10-50H0V128h512q0-27 10-50t27-40 41-28 50-10h1280zM512 768V256H128v512h384zm1408-640H640v768h1280V128z" })
      ]
    }
  );
}
var StorageInternalExternal_default = SvgStorageInternalExternal;

// src/components/Icon/icons/Store.tsx
import { jsx as jsx896, jsxs as jsxs889 } from "react/jsx-runtime";
function SvgStore({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs889(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx896("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx896("path", { d: "M1792 512v1280q0 53-20 99t-55 82-81 55-100 20H384q-53 0-99-20t-82-55-55-81-20-100V512h256V384q0-79 30-149t82-122 122-83T768 0q104 0 193 52 89-52 191-52 79 0 149 30t122 82 83 123 30 149v128h256zm-384-128q0-53-20-99t-55-82-81-55-100-20q-45 0-85 15 36 45 54 88t24 87 7 91 0 103h256V384zM512 512h512V384q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100v128zm802 1408q-34-60-34-128V640H256v1152q0 27 10 50t27 40 41 28 50 10h930zm350-1280h-256v1152q0 27 10 50t27 40 41 28 50 10q27 0 50-10t40-27 28-41 10-50V640z" })
      ]
    }
  );
}
var Store_default = SvgStore;

// src/components/Icon/icons/StoreLogo16.tsx
import { jsx as jsx897, jsxs as jsxs890 } from "react/jsx-runtime";
function SvgStoreLogo16({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs890(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx897("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx897("path", { d: "M1536 512h384v1453q0 35-23 59t-59 24H82q-34 0-58-24t-24-59V512h384V256L640 0h640l256 256v256zM640 256v256h640V256H640zm256 1536v-384H512v384h384zm0-512V896H512v384h384zm512 512v-384h-384v384h384zm0-512V896h-384v384h384z" })
      ]
    }
  );
}
var StoreLogo16_default = SvgStoreLogo16;

// src/components/Icon/icons/StoreLogoMed20.tsx
import { jsx as jsx898, jsxs as jsxs891 } from "react/jsx-runtime";
function SvgStoreLogoMed20({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs891(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx898("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx898("path", { d: "M1536 512h410v1452q0 35-24 59t-59 25H83q-35 0-59-24t-24-60V512h410V205L614 0h717l205 205v307zM922 1638v-307H614v307h308zm0-409V922H614v307h308zm409 409v-307h-307v307h307zm0-409V922h-307v307h307zm0-717V205H614v307h717z" })
      ]
    }
  );
}
var StoreLogoMed20_default = SvgStoreLogoMed20;

// src/components/Icon/icons/StoreSolid.tsx
import { jsx as jsx899, jsxs as jsxs892 } from "react/jsx-runtime";
function SvgStoreSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs892(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx899("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx899("path", { d: "M1536 512h256v1280q0 53-20 99t-55 81-82 55-99 21H384q-53 0-99-20t-81-55-55-81-21-100V512h256V384q0-79 30-148t83-122 122-83T768 0q51 0 100 13t93 39q89-52 191-52 58 0 112 17t99 47 82 74 60 97q20 48 26 94t6 94v44q0 22-1 45zm-512 0V384q0-52-20-99t-55-81-82-55-99-21q-53 0-99 20t-81 55-55 82-21 99v128h512zm128 0h256V384q0-52-20-99t-55-81-82-55-99-21q-45 0-85 15 29 37 46 72t25 72 11 74 3 79v72zm512 1280V640h-256v1152q0 27 10 50t27 40 41 28 50 10q27 0 50-10t40-27 28-41 10-50z" })
      ]
    }
  );
}
var StoreSolid_default = SvgStoreSolid;

// src/components/Icon/icons/Streaming.tsx
import { jsx as jsx900, jsxs as jsxs893 } from "react/jsx-runtime";
function SvgStreaming({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs893(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx900("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx900("path", { d: "M481 481Q372 590 314 730t-58 294q0 154 58 294t167 249l-91 91q-126-128-194-291t-68-343q0-180 68-343t194-291l91 91zm1177-91q126 128 194 291t68 343q0 180-68 343t-194 291l-91-91q109-109 166-249t58-294q0-154-57-294t-167-249l91-91zM707 707q-63 63-97 145t-34 172q0 90 34 172t97 145l-90 90q-81-81-125-186t-44-221q0-115 44-220t125-187l90 90zm724-90q81 81 125 186t44 221q0 115-44 220t-125 187l-90-90q63-63 96-145t34-172q0-90-33-172t-97-145l90-90zm-407 151q53 0 99 20t82 55 55 81 20 100q0 53-20 99t-55 82-81 55-100 20q-53 0-99-20t-82-55-55-81-20-100q0-53 20-99t55-82 81-55 100-20zm0 384q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10z" })
      ]
    }
  );
}
var Streaming_default = SvgStreaming;

// src/components/Icon/icons/Subscribe.tsx
import { jsx as jsx901, jsxs as jsxs894 } from "react/jsx-runtime";
function SvgSubscribe({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs894(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx901("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx901("path", { d: "M1920 960q0 133-34 255t-96 230-150 194-195 150-229 97-256 34q-133 0-255-34t-230-96-194-150-150-195-97-229T0 960q0-133 34-255t96-230 150-194 195-150 229-97T960 0q133 0 255 34t230 96 194 150 150 195 97 229 34 256zm-960 832q115 0 221-30t198-84 169-130 130-168 84-199 30-221q0-115-30-221t-84-198-130-169-168-130-199-84-221-30q-115 0-221 30t-198 84-169 130-130 168-84 199-30 221q0 115 30 221t84 198 130 169 168 130 199 84 221 30zm47-907q48 16 97 37t88 53 63 75 25 103q0 61-22 105t-60 73-87 46-104 22v137h-97v-133q-133 0-252-58v-174q22 17 53 31t67 25 70 19 62 8v-229q-50-17-98-39t-87-54-61-76-24-105q0-57 23-101t60-76 86-49 101-24V384h97v115q50 2 107 10t103 32v170q-48-27-101-43t-109-22v239zm-97-37V649q-39 6-66 27t-27 64q0 20 8 36t22 30 29 24 34 18zm97 404q40-5 68-25t28-65q0-20-9-36t-23-28-31-21-33-16v191z" })
      ]
    }
  );
}
var Subscribe_default = SvgSubscribe;

// src/components/Icon/icons/SubscriptionAdd.tsx
import { jsx as jsx902, jsxs as jsxs895 } from "react/jsx-runtime";
function SvgSubscriptionAdd({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs895(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx902("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx902("path", { d: "M512 1152v-128h640v128H512zm896-384v128H512V768h896zM384 384v1152h896v128H256V256h1536v896h-128V384H384zm1664 1152v128h-256v256h-128v-256h-256v-128h256v-256h128v256h256zM512 512h768v128H512V512z" })
      ]
    }
  );
}
var SubscriptionAdd_default = SvgSubscriptionAdd;

// src/components/Icon/icons/SubscriptionAddMirrored.tsx
import { jsx as jsx903, jsxs as jsxs896 } from "react/jsx-runtime";
function SvgSubscriptionAddMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs896(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx903("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx903("path", { d: "M1536 1152H896v-128h640v128zm0-384v128H640V768h896zM384 384v1152h896v128H256V256h1536v896h-128V384H384zm1664 1152v128h-256v256h-128v-256h-256v-128h256v-256h128v256h256zM1536 512v128H768V512h768z" })
      ]
    }
  );
}
var SubscriptionAddMirrored_default = SvgSubscriptionAddMirrored;

// src/components/Icon/icons/SubscriptionAddMirroredSolid.tsx
import { jsx as jsx904, jsxs as jsxs897 } from "react/jsx-runtime";
function SvgSubscriptionAddMirroredSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs897(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx904("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx904("path", { d: "M1408 1152v256h-256v256H128V256h1536v896h-256v-128H768v128h640zM640 512v128h768V512H640zM512 768v128h896V768H512zm1152 768h256v128h-256v256h-128v-256h-256v-128h256v-256h128v256z" })
      ]
    }
  );
}
var SubscriptionAddMirroredSolid_default = SvgSubscriptionAddMirroredSolid;

// src/components/Icon/icons/SubscriptionAddSolid.tsx
import { jsx as jsx905, jsxs as jsxs898 } from "react/jsx-runtime";
function SvgSubscriptionAddSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs898(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx905("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx905("path", { d: "M1408 1152v256h-256v256H128V256h1536v896h-256zM256 512v128h768V512H256zm640 640v-128H256v128h640zm256-256V768H256v128h896zm512 640h256v128h-256v256h-128v-256h-256v-128h256v-256h128v256z" })
      ]
    }
  );
}
var SubscriptionAddSolid_default = SvgSubscriptionAddSolid;

// src/components/Icon/icons/Subscriptions.tsx
import { jsx as jsx906, jsxs as jsxs899 } from "react/jsx-runtime";
function SvgSubscriptions({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs899(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx906("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx906("path", { d: "M512 1152v-128h640v128H512zm989 130l317 318-317 318-91-91 163-163H256V256h1536v1136l-128-128V384H384v1152h1189l-163-163 91-91zm-93-514v128H512V768h896zM512 512h768v128H512V512z" })
      ]
    }
  );
}
var Subscriptions_default = SvgSubscriptions;

// src/components/Icon/icons/Subscriptions2.tsx
import { jsx as jsx907, jsxs as jsxs900 } from "react/jsx-runtime";
function SvgSubscriptions2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs900(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx907("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx907("path", { d: "M512 1152v-128h640v128H512zm989 130l317 318-317 318-91-91 163-163H256V256h1536v1136l-128-128V384H384v1152h1189l-163-163 91-91zm-93-514v128H512V768h896zM512 512h768v128H512V512z" })
      ]
    }
  );
}
var Subscriptions2_default = SvgSubscriptions2;

// src/components/Icon/icons/Subscriptions2Mirrored.tsx
import { jsx as jsx908, jsxs as jsxs901 } from "react/jsx-runtime";
function SvgSubscriptions2Mirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs901(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx908("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx908("path", { d: "M896 1152v-128h640v128H896zm922 448l-317 318-91-91 163-163H256V256h1536v1136l-128-128V384H384v1152h1189l-163-163 91-91 317 318zm-282-704H640V768h896v128zm0-256H768V512h768v128z" })
      ]
    }
  );
}
var Subscriptions2Mirrored_default = SvgSubscriptions2Mirrored;

// src/components/Icon/icons/SubscriptionsMirrored.tsx
import { jsx as jsx909, jsxs as jsxs902 } from "react/jsx-runtime";
function SvgSubscriptionsMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs902(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx909("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx909("path", { d: "M896 1152v-128h640v128H896zm922 448l-317 318-91-91 163-163H256V256h1536v1136l-128-128V384H384v1152h1189l-163-163 91-91 317 318zm-282-704H640V768h896v128zm0-256H768V512h768v128z" })
      ]
    }
  );
}
var SubscriptionsMirrored_default = SvgSubscriptionsMirrored;

// src/components/Icon/icons/SubtitlesAudio.tsx
import { jsx as jsx910, jsxs as jsxs903 } from "react/jsx-runtime";
function SvgSubtitlesAudio({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs903(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx910("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx910("path", { d: "M0 128h2048v256h-128V256H128v1152h256v293l293-293h475v128H731l-475 475v-475H0V128zm1573 768l384-384h91v1408h-90l-385-384h-293V896h293zm347 805V731l-293 293h-219v384h219l293 293zM256 1280v-128h896v128H256zm896-384v128H256V896h896z" })
      ]
    }
  );
}
var SubtitlesAudio_default = SvgSubtitlesAudio;

// src/components/Icon/icons/SurfaceHub.tsx
import { jsx as jsx911, jsxs as jsxs904 } from "react/jsx-runtime";
function SvgSurfaceHub({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs904(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx911("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx911("path", { d: "M0 384h2048v1280H0V384zm256 1152V512H128v1024h128zm1408 0V512H384v1024h1280zm256 0V512h-128v1024h128z" })
      ]
    }
  );
}
var SurfaceHub_default = SvgSurfaceHub;

// src/components/Icon/icons/Swap.tsx
import { jsx as jsx912, jsxs as jsxs905 } from "react/jsx-runtime";
function SvgSwap({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs905(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx912("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx912("path", { d: "M1491 1197l90-90 365 365-365 365-90-90 210-211H0v-128h1701l-210-211zM346 512h1702v128H346l211 211-90 90-366-365 366-365 90 90-211 211z" })
      ]
    }
  );
}
var Swap_default = SvgSwap;

// src/components/Icon/icons/Sweepstakes.tsx
import { jsx as jsx913, jsxs as jsxs906 } from "react/jsx-runtime";
function SvgSweepstakes({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs906(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx913("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx913("path", { d: "M2048 768q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10v512h-454q30 24 50 56t20 72q0 54-32 93t-84 68-116 47-128 29-121 15-95 4q-37 0-94-4t-122-14-128-29-115-47-84-68-33-94q0-30 12-57-36-13-70-30t-64-41H0v-512q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10V256h2048v512zM448 1408q0 13 10 25t28 24 37 22 41 19 36 15 26 8q66 18 134 24t136 7q43 0 104-6t125-21 118-37 88-58q4-4 8-10t5-12q0-6-4-12t-9-10q-60 11-121 16t-122 6q-54 0-115-5t-123-16-118-30-106-46q-11 3-40 12t-60 23-54 30-24 32zm192-256q0 6 4 12t9 10q33 34 88 57t118 38 124 20 105 7q67 0 136-6t134-25q9-2 25-8t37-14 40-19 38-22 27-24 11-26q0-11-10-21t-19-17q-38-30-91-50t-110-33-114-18-104-5q-47 0-104 5t-114 17-110 33-91 51q-8 6-18 16t-11 22zm448 656q47 0 104-5t114-17 110-33 91-51q8-6 18-16t11-22q0-16-23-32t-54-29-60-23-41-13q-48 27-105 46t-119 30-122 16-116 5q-61 0-122-5t-121-17q-4 4-8 10t-5 12q0 11 10 21t19 17q38 30 91 50t110 33 114 18 104 5zm-768-400q0-40 19-72t50-56 66-42 69-29q-12-27-12-57 0-53 32-93t84-68 116-47 128-29 121-15 95-4q37 0 94 4t122 14 128 29 115 47 84 69 33 93q0 40-19 72t-50 56-66 42-69 29q12 27 12 57h448v-290q-60-35-94-94t-34-128q0-69 34-128t94-94V384H128v290q60 35 94 94t34 128q0 69-34 128t-94 94v290h192z" })
      ]
    }
  );
}
var Sweepstakes_default = SvgSweepstakes;

// src/components/Icon/icons/SwitcherMultitask.tsx
import { jsx as jsx914, jsxs as jsxs907 } from "react/jsx-runtime";
function SvgSwitcherMultitask({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs907(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx914("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx914("path", { d: "M128 384v640h512v128H0V256h1280v512h-128V384H128zm640 512h1280v896H768V896zm1152 768v-640H896v640h1024z" })
      ]
    }
  );
}
var SwitcherMultitask_default = SvgSwitcherMultitask;

// src/components/Icon/icons/SwitchFocus.tsx
import { jsx as jsx915, jsxs as jsxs908 } from "react/jsx-runtime";
function SvgSwitchFocus({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs908(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx915("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx915("path", { d: "M0 384h2048v1152h-960v128h320v128H640v-128h320v-128H0V384zm128 128v896h1280V512H128zm1792 896V512h-384v896h384z" })
      ]
    }
  );
}
var SwitchFocus_default = SvgSwitchFocus;

// src/components/Icon/icons/SwitchFocusMirrored.tsx
import { jsx as jsx916, jsxs as jsxs909 } from "react/jsx-runtime";
function SvgSwitchFocusMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs909(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx916("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx916("path", { d: "M2048 384H0v1152h960v128H640v128h768v-128h-320v-128h960V384zm-128 128v896H640V512h1280zM128 1408V512h384v896H128z" })
      ]
    }
  );
}
var SwitchFocusMirrored_default = SvgSwitchFocusMirrored;

// src/components/Icon/icons/Tag.tsx
import { jsx as jsx917, jsxs as jsxs910 } from "react/jsx-runtime";
function SvgTag({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs910(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx917("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx917("path", { d: "M1472 576q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10zM1024 0h896v896L896 1920 0 1024 1024 0zm768 843V128h-715l-896 896 715 715 896-896z" })
      ]
    }
  );
}
var Tag_default = SvgTag;

// src/components/Icon/icons/TagCommunications.tsx
import { jsx as jsx918, jsxs as jsxs911 } from "react/jsx-runtime";
function SvgTagCommunications({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs911(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx918("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx918("path", { d: "M256 384h1536v1024H896l-384 384v-384H256V384z" })
      ]
    }
  );
}
var TagCommunications_default = SvgTagCommunications;

// src/components/Icon/icons/TagLanguage.tsx
import { jsx as jsx919, jsxs as jsxs912 } from "react/jsx-runtime";
function SvgTagLanguage({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs912(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx919("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx919("path", { d: "M512 1024q0 107 10 212t34 210q-146 23-288 60-69-109-104-231t-36-251q0-96 20-189t60-181q81 23 161 41t164 32q-11 74-16 148t-5 149zm148-278q91 11 181 16t183 6q92 0 182-5t182-17q11 69 15 138t5 140q0 103-10 203t-33 201q-85-9-170-14t-171-5q-86 0-171 5t-170 14q-23-100-33-200t-10-204q0-70 4-139t16-139zm1180-92q40 88 60 181t20 189q0 128-35 250t-105 232q-143-37-288-60 23-104 33-209t11-213q0-75-5-149t-16-148q83-14 163-32t162-41zm-476-35q-85 10-169 15t-171 5q-86 0-170-5t-170-15q8-36 23-86t38-105 50-108 64-96 76-69 89-27q48 0 89 26t76 69 63 96 51 108 37 105 24 87zm-646 934q77-8 153-12t153-4q77 0 153 4t153 12q-10 30-25 69t-37 80-47 80-57 69-66 50-74 19q-39 0-74-19t-65-49-57-70-48-80-36-80-26-69zm-366 64q59-14 118-26t119-21q25 80 59 157t85 145q-110-38-206-102t-175-153zm963 255q50-68 84-145t60-157q60 9 119 21t118 26q-78 88-174 152t-207 103zM733 176q-68 92-110 203t-67 222q-144-24-285-63 82-127 200-220t262-142zm1044 362q-141 39-285 63-25-111-67-222t-110-203q143 49 261 142t201 220z" })
      ]
    }
  );
}
var TagLanguage_default = SvgTagLanguage;

// src/components/Icon/icons/TagPeople.tsx
import { jsx as jsx920, jsxs as jsxs913 } from "react/jsx-runtime";
function SvgTagPeople({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs913(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx920("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx920("path", { d: "M1408 1024q-53 0-99-20t-82-55-55-81-20-100V640q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100v128q0 53-20 99t-55 82-81 55-100 20zm-704 0q-66 0-124-25t-102-68-69-102-25-125V576q0-66 25-124t68-102 102-69 125-25q66 0 124 25t102 68 69 102 25 125v128q0 66-25 124t-68 102-102 69-125 25zm960 128q53 0 99 20t82 55 55 81 20 100v256h-512v-256q0-71-25-137t-73-119h354zm-640 0q53 0 99 20t82 55 55 81 20 100v256H128v-256q0-53 20-99t55-82 81-55 100-20h640z" })
      ]
    }
  );
}
var TagPeople_default = SvgTagPeople;

// src/components/Icon/icons/TagPlayStyle.tsx
import { jsx as jsx921, jsxs as jsxs914 } from "react/jsx-runtime";
function SvgTagPlayStyle({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs914(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx921("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx921("path", { d: "M896 501q-29-10-52-28t-41-42-26-52-9-59q0-40 15-75t41-61 61-41 75-15q40 0 75 15t61 41 41 61 15 75q0 30-9 58t-26 53-40 42-53 28v587q0 9-7 15t-18 10-21 5-18 2q-7 0-17-1t-21-5-18-10-8-16V501zm64 1003l-832-416 640-320v193q-20 8-42 19t-41 27-32 36-13 45q0 31 17 55t46 41 63 30 71 20 68 11 55 3q22 0 54-3t68-10 71-20 64-30 45-42 18-55q0-24-12-44t-32-36-42-27-42-20V768l640 320-832 416zm0 143l832-416v273l-832 416-832-416v-273l832 416z" })
      ]
    }
  );
}
var TagPlayStyle_default = SvgTagPlayStyle;

// src/components/Icon/icons/TagSolid.tsx
import { jsx as jsx922, jsxs as jsxs915 } from "react/jsx-runtime";
function SvgTagSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs915(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx922("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx922("path", { d: "M1024 0h896v896L896 1920 0 1024 1024 0zm448 624q36 0 68-14t56-38 38-56 14-68q0-36-14-68t-38-56-56-38-68-14q-36 0-68 14t-56 38-38 56-14 68q0 36 14 68t38 56 56 38 68 14z" })
      ]
    }
  );
}
var TagSolid_default = SvgTagSolid;

// src/components/Icon/icons/Tattoo.tsx
import { jsx as jsx923, jsxs as jsxs916 } from "react/jsx-runtime";
function SvgTattoo({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs916(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx923("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx923("path", { d: "M1536 1189l237 238-90 90-84-83q-5 129-57 241t-138 195-201 130-243 48q-129 0-243-47t-200-131-139-195-57-241l-84 83-90-90 237-238 237 238-90 90-82-82q5 92 41 174t95 147 139 107 172 53V896H640v128H301L13 832l288-192h211V512h384V373q-29-10-52-28t-41-42-26-52-9-59q0-40 15-75t41-61 61-41 75-15q40 0 75 15t61 41 41 61 15 75q0 30-9 58t-26 53-40 42-53 28v139h384v128h211l288 192-288 192h-339V896h-256v1020q92-11 171-53t139-106 96-147 41-175l-82 82-90-90 237-238zM960 112q-33 0-56 23t-24 57q0 33 23 56t57 24q33 0 56-23t24-57q0-33-23-56t-57-24zm448 656v128h173l96-64-96-64h-173zM512 896V768H339l-96 64 96 64h173zm128-128h640V640H640v128z" })
      ]
    }
  );
}
var Tattoo_default = SvgTattoo;

// src/components/Icon/icons/Teamwork.tsx
import { jsx as jsx924, jsxs as jsxs917 } from "react/jsx-runtime";
function SvgTeamwork({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs917(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx924("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx924("path", { d: "M1664 1088q66 0 124 25t102 68 69 102 25 125q0 52-16 101t-48 91v424l-256-128-256 128v-424q-31-42-47-91t-17-101q0-66 25-124t68-102 102-69 125-25zm0 128q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15zm0 536l128 64v-115q-60 27-128 27t-128-27v115l128-64zm-413-674q19 9 36 20t35 23l-75 104q-49-35-106-54t-117-19q-80 0-149 30t-122 82-83 123-30 149H512q0-73 20-141t57-128 89-108 118-82q-74-55-115-136t-41-173q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100H0q0-52 14-101t39-93 62-80 83-62q-33-35-51-81t-19-95q0-53 20-99t55-82 81-55T384 0q53 0 99 20t82 55 55 81 20 100q0 49-18 95t-52 81q82 45 134 124 27-40 62-72t76-54 87-34 95-12q48 0 94 12t87 34 77 54 62 72q52-79 134-124-33-35-51-81t-19-95q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100q0 49-18 95t-52 81q46 26 82 62t62 79 40 93 14 102h-128q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100q0 92-41 173t-116 137zm285-822q0 27 10 50t27 40 41 28 50 10q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50zm-1280 0q0 27 10 50t27 40 41 28 50 10q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50zm512 512q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100z" })
      ]
    }
  );
}
var Teamwork_default = SvgTeamwork;

// src/components/Icon/icons/Teeth.tsx
import { jsx as jsx925, jsxs as jsxs918 } from "react/jsx-runtime";
function SvgTeeth({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs918(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx925("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx925("path", { d: "M1025 512q70 0 136-18t129-50q60-32 119-46t128-14v128q-52 0-96 11t-91 34q-78 40-157 61t-168 22q-92 0-172-22t-162-65q-42-22-86-31t-92-10V384q63 0 122 13t116 43q66 35 132 53t142 19zM1539 0q109 0 201 43t160 116 107 168 41 201q1 24 1 48t0 48q0 168-28 346t-81 354-127 340-165 306q-24 37-61 57t-81 21q-56 0-99-31t-61-84l-178-532q-36 4-71 5t-72 2q-36 0-72-1t-72-6l-177 532q-17 53-61 84t-100 31q-43 0-81-21t-61-57q-97-150-172-319t-126-348-77-362T0 579v-25q0-12 1-26 2-105 41-200t107-168T309 44 510 0q66 0 124 13t117 43q66 34 132 53t142 19q75 0 141-19t133-53q59-30 116-43t124-13zm-33 1920q21 0 34-19 35-51 65-107t58-113q117-238 182-492t76-520V528q0-79-30-151t-83-128-123-88-152-33q-45 0-89 10t-85 30q-81 42-161 65t-173 23q-93 0-173-23t-162-65q-35-18-77-29t-83-11q-85 0-158 30t-126 85-85 127-32 158v26q0 12-1 27v44q0 22 1 44 11 275 81 540t196 510q24 46 49 92t55 90q7 10 14 14t20 5q28 0 38-28l186-556q10-29 34-47t56-19l11 1q78 9 156 9 77 0 155-9l11-1q32 0 56 18t34 48l186 556q10 28 39 28z" })
      ]
    }
  );
}
var Teeth_default = SvgTeeth;

// src/components/Icon/icons/Telemarketer.tsx
import { jsx as jsx926, jsxs as jsxs919 } from "react/jsx-runtime";
function SvgTelemarketer({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs919(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx926("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx926("path", { d: "M1920 2048h-128q0-106-27-204t-78-183-120-156-155-120-184-77-204-28q-106 0-204 27t-183 78-156 120-120 155-77 184-28 204H128q0-145 42-276t121-240 187-193 244-135q-124-67-210-180h-64q-40 0-75-15t-61-41-41-61-15-75V576q0-38 14-72t38-60 58-42 71-18q39-88 99-159t137-121 166-77 185-27q96 0 185 27t165 77 137 121 100 159q38 2 71 18t57 42 39 60 14 72v256q0 40-15 75t-41 61-61 41-75 15q-30 0-57-9-43 59-97 107t-120 82q134 51 243 134t188 193 120 241 43 276zM1664 576q0-26-19-45t-45-19q-26 0-45 19t-19 45v256q0 26 19 45t45 19q26 0 45-19t19-45V576zM384 832q0 26 19 45t45 19h64V576q0-26-19-45t-45-19q-26 0-45 19t-19 45v256zm301 192q70 62 157 95t182 33q62 0 121-14t112-42 100-67 83-91q-16-23-24-50t-8-56V576q0-46 20-87t59-68q-32-67-80-121t-109-92-130-59-144-21q-74 0-144 20t-130 59-108 93-81 121q38 27 58 68t21 87v320h128q0-27 10-50t27-40 41-28 50-10q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10H685z" })
      ]
    }
  );
}
var Telemarketer_default = SvgTelemarketer;

// src/components/Icon/icons/TestBeaker.tsx
import { jsx as jsx927, jsxs as jsxs920 } from "react/jsx-runtime";
function SvgTestBeaker({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs920(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx927("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx927("path", { d: "M1887 1856q0 40-15 75t-41 61-61 41-75 15H354q-40 0-75-15t-61-41-41-61-15-75q0-27 6-51t21-47l569-991v-1q10-14 10-34V128H640V0h768v128h-128v604q0 20 10 34v1l569 991q14 23 21 47t7 51zM538 1408h972l-331-577q-27-46-27-99V128H896v604q0 53-27 99l-331 577zm1220 448q0-10-2-17t-8-16l-164-287H464l-165 287q-9 15-9 33 0 26 18 45t46 19h1341q26 0 44-19t19-45z" })
      ]
    }
  );
}
var TestBeaker_default = SvgTestBeaker;

// src/components/Icon/icons/TestBeakerSolid.tsx
import { jsx as jsx928, jsxs as jsxs921 } from "react/jsx-runtime";
function SvgTestBeakerSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs921(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx928("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx928("path", { d: "M1887 1856q0 40-15 75t-41 61-61 41-75 15H354q-40 0-75-15t-61-41-41-61-15-75q0-27 6-51t21-47l569-991v-1q10-14 10-34V128H640V0h768v128h-128v604q0 20 10 34v1l569 991q14 23 21 47t7 51zM538 1408h972l-331-577q-27-46-27-99V128H896v604q0 53-27 99l-331 577z" })
      ]
    }
  );
}
var TestBeakerSolid_default = SvgTestBeakerSolid;

// src/components/Icon/icons/TextField.tsx
import { jsx as jsx929, jsxs as jsxs922 } from "react/jsx-runtime";
function SvgTextField({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs922(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx929("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx929("path", { d: "M0 256h2048v1408H0V256zm1920 1280V384H128v1152h1792zM451 1118l-54 160H283l235-628h117l234 628H754l-56-160H451zm27-85h193l-88-250q-3-9-4-19t-4-21h-2q-2 10-3 20t-5 20l-87 250zm555 180v65H931V614h102v294h1q26-43 63-66t89-23q48 0 82 18t57 50 32 71 10 83q0 48-11 92t-36 79-62 55-92 21q-86 0-132-75h-1zm-1-178v55q0 24 8 45t22 38 34 25 46 10q35 0 58-15t37-39 20-54 6-59q0-26-6-51t-19-46-34-32-52-12q-29 0-51 11t-38 29-23 43-8 52zm632 253q-50 0-91-16t-70-46-45-71-16-91q0-55 17-100t48-77 76-50 101-18q28 0 55 5t53 16v95q-22-16-47-25t-53-10q-35 0-62 12t-45 34-29 50-10 62q0 66 37 108t105 42q29 0 55-10t49-29v88q-29 17-62 24t-66 7z" })
      ]
    }
  );
}
var TextField_default = SvgTextField;

// src/components/Icon/icons/ThisPc.tsx
import { jsx as jsx930, jsxs as jsxs923 } from "react/jsx-runtime";
function SvgThisPc({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs923(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx930("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx930("path", { d: "M0 0h1920v1152h-896v128h256v128H640v-128h256v-128H0V0zm1792 1024V128H128v896h1664zM228 1536h1464l228 334v50H0v-50l228-334zm-20 256h1504l-88-128H296l-88 128z" })
      ]
    }
  );
}
var ThisPc_default = SvgThisPc;

// src/components/Icon/icons/ThisPcSolid.tsx
import { jsx as jsx931, jsxs as jsxs924 } from "react/jsx-runtime";
function SvgThisPcSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs924(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx931("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx931("path", { d: "M64 64h1920v1152h-896v128h256v128H704v-128h256v-128H64V64zm228 1536h1464l228 334v50H64v-50l228-334z" })
      ]
    }
  );
}
var ThisPcSolid_default = SvgThisPcSolid;

// src/components/Icon/icons/ThumbstickDlSet.tsx
import { jsx as jsx932, jsxs as jsxs925 } from "react/jsx-runtime";
function SvgThumbstickDlSet({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs925(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx932("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx932("path", { d: "M1829 384q33 0 63 11t54 30 43 46 27 58q17 58 24 118t8 121q0 60-7 120t-25 119q-9 32-27 58t-42 46-55 30-63 11h-293v512h-128v-640h421q23 0 40-14t24-36q15-48 21-101t6-105q0-51-6-104t-21-102q-7-22-24-36t-40-14H219q-23 0-40 14t-24 36q-15 48-21 101t-6 105q0 51 6 104t21 102q7 22 24 36t40 14h421v640H512v-512H219q-33 0-63-11t-54-30-43-45-27-59Q15 949 8 889T0 768q0-60 7-120t25-119q9-31 27-58t42-46 55-30 63-11h1610z" })
      ]
    }
  );
}
var ThumbstickDlSet_default = SvgThumbstickDlSet;

// src/components/Icon/icons/ThumbstickXAxisInverted.tsx
import { jsx as jsx933, jsxs as jsxs926 } from "react/jsx-runtime";
function SvgThumbstickXAxisInverted({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs926(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx933("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx933("path", { d: "M1152 1280q27 0 50 10t40 27 28 41 10 50v128q0 27-10 50t-27 40-41 28-50 10v128h-128v-256h128v-128H768v128h128v256H768v-128q-27 0-50-10t-40-27-28-41-10-50v-128q0-27 10-50t27-40 41-28 50-10h384zm640-384h128v128h-128V896zm-256 128V896h128v128h-128zm-256 0V896h128v128h-128zm-128-128v128h-128V896h128zm-384 0h128v128H768V896zm-128 0v128H512V896h128zm-384 128V896h128v128H256zm-256 0V896h128v128H0zm1581-403l-90-90 147-147H282l147 147-90 90L37 320 339 19l90 90-147 147h1356l-147-147 90-90 302 301-302 301z" })
      ]
    }
  );
}
var ThumbstickXAxisInverted_default = SvgThumbstickXAxisInverted;

// src/components/Icon/icons/ThumbstickXAxisSwap.tsx
import { jsx as jsx934, jsxs as jsxs927 } from "react/jsx-runtime";
function SvgThumbstickXAxisSwap({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs927(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx934("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx934("path", { d: "M512 1280q27 0 50 10t40 27 28 41 10 50v128q0 27-10 50t-27 40-41 28-50 10v128H384v-256h128v-128H128v128h128v256H128v-128q-27 0-50-10t-40-27-28-41-10-50v-128q0-27 10-50t27-40 41-28 50-10h384zm1280 0q27 0 50 10t40 27 28 41 10 50v128q0 27-10 50t-27 40-41 28-50 10v128h-128v-256h128v-128h-384v128h128v256h-128v-128q-27 0-50-10t-40-27-28-41-10-50v-128q0-27 10-50t27-40 41-28 50-10h384zM448 0h192v128H448q-26 0-45 19t-19 45v229l147-146 90 90-301 301L19 365l90-90 147 146V192q0-40 15-75t41-61 61-41 75-15zm1088 192q0-26-19-45t-45-19h-192V0h192q40 0 75 15t61 41 41 61 15 75v229l147-146 90 90-301 301-301-301 90-90 147 146V192zm256 704h128v128h-128V896zm-256 128V896h128v128h-128zm-128-128v128h-128V896h128zm-384 128V896h128v128h-128zm-256 0V896h128v128H768zm-256 0V896h128v128H512zM256 896h128v128H256V896zm-128 0v128H0V896h128z" })
      ]
    }
  );
}
var ThumbstickXAxisSwap_default = SvgThumbstickXAxisSwap;

// src/components/Icon/icons/ThumbstickYAxisInverted.tsx
import { jsx as jsx935, jsxs as jsxs928 } from "react/jsx-runtime";
function SvgThumbstickYAxisInverted({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs928(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx935("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx935("path", { d: "M512 768q27 0 50 10t40 27 28 41 10 50v128q0 27-10 50t-27 40-41 28-50 10v128H384v-256h128V896H128v128h128v256H128v-128q-27 0-50-10t-40-27-28-41-10-50V896q0-27 10-50t27-40 41-28 50-10h384zm384-640V0h128v128H896zm0 256V256h128v128H896zm0 256V512h128v128H896zm0 256V768h128v128H896zm0 256v-128h128v128H896zm0 256v-128h128v128H896zm0 256v-128h128v128H896zm0 256v-128h128v128H896zm768-282l147-147 90 90-301 302-301-302 90-90 147 147V282l-147 147-90-90 301-302 301 302-90 90-147-147v1356z" })
      ]
    }
  );
}
var ThumbstickYAxisInverted_default = SvgThumbstickYAxisInverted;

// src/components/Icon/icons/ThumbstickYAxisSwap.tsx
import { jsx as jsx936, jsxs as jsxs929 } from "react/jsx-runtime";
function SvgThumbstickYAxisSwap({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs929(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx936("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx936("path", { d: "M512 128q27 0 50 10t40 27 28 41 10 50v128q0 27-10 50t-27 40-41 28-50 10v128H384V384h128V256H128v128h128v256H128V512q-27 0-50-10t-40-27-28-41-10-50V256q0-27 10-50t27-40 41-28 50-10h384zm0 1280q27 0 50 10t40 27 28 41 10 50v128q0 27-10 50t-27 40-41 28-50 10v128H384v-256h128v-128H128v128h128v256H128v-128q-27 0-50-10t-40-27-28-41-10-50v-128q0-27 10-50t27-40 41-28 50-10h384zM896 128V0h128v128H896zm0 256V256h128v128H896zm0 256V512h128v128H896zm0 256V768h128v128H896zm0 256v-128h128v128H896zm0 256v-128h128v128H896zm0 256v-128h128v128H896zm0 256v-128h128v128H896zM1920 448v192h-128V448q0-26-19-45t-45-19h-229l146 147-90 90-301-301 301-301 90 90-146 147h229q40 0 75 15t61 41 41 61 15 75zm-128 832h128v192q0 40-15 75t-41 61-61 41-75 15h-229l146 147-90 90-301-301 301-301 90 90-146 147h229q26 0 45-19t19-45v-192z" })
      ]
    }
  );
}
var ThumbstickYAxisSwap_default = SvgThumbstickYAxisSwap;

// src/components/Icon/icons/TileGroups.tsx
import { jsx as jsx937, jsxs as jsxs930 } from "react/jsx-runtime";
function SvgTileGroups({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs930(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx937("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx937("path", { d: "M384 1536h451l-128 128H256v-256H0V0h1664v256h256v529l-128-128V384H384v1152zm-128-256V256h1280V128H128v1152h128zm1298-634l488 488q-33 33-64 60t-64 46-73 29-88 11q-35 0-66-7l-50 49q27 72 27 150 0 59-12 108t-36 92-55 83-74 79l-271-272-347 348-136 45 45-136 348-347-272-271q40-41 79-73t82-56 93-35 108-13q78 0 150 27l49-50q-7-31-7-66 0-49 10-88t30-72 46-65 60-64zm199 506q54 0 102-25l-294-294q-25 48-25 102 0 27 8 52t16 51l-166 166q-46-23-86-37t-92-15q-47 0-92 13t-84 40l443 443q26-39 39-84t14-92q0-52-14-92t-38-86l166-166 50 16q25 8 53 8z" })
      ]
    }
  );
}
var TileGroups_default = SvgTileGroups;

// src/components/Icon/icons/Tiles2.tsx
import { jsx as jsx938, jsxs as jsxs931 } from "react/jsx-runtime";
function SvgTiles2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs931(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx938("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx938("path", { d: "M256 768h640v1280H256V768zm128 1152h384V896H384v1024zM256 0h640v640H256V0zm128 512h384V128H384v384zM1664 0v1280h-640V0h640zm-128 128h-384v1024h384V128zm-512 1280h640v640h-640v-640zm128 512h384v-384h-384v384z" })
      ]
    }
  );
}
var Tiles2_default = SvgTiles2;

// src/components/Icon/icons/TimeLanguage.tsx
import { jsx as jsx939, jsxs as jsxs932 } from "react/jsx-runtime";
function SvgTimeLanguage({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs932(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx939("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx939("path", { d: "M601 1152l298 896H765l-86-256H345l-86 256H125l298-896h178zm36 512l-125-374-125 374h250zm3-1408v384h256v128H512V256h128zm-383 893q-60-45-108-102T68 925 18 788 0 640q0-88 23-170t64-153 100-129T317 88t153-65T640 0q88 0 170 23t153 64 129 100 100 130 65 153 23 170q0 32-3 64t-10 64h-133q8-32 13-64t5-64q0-106-40-199t-110-162-163-110-199-41q-106 0-199 40T279 278 169 441t-41 199q0 110 45 208t127 172l-43 129zm1773 293q2 8 2 13v96q0 4-2 12-8 2-13 2-40-1-79-2t-79-1h-321q-1 60 0 120t4 121q1 25-8 50t-30 40q-14 10-39 15t-55 8-56 3-44 1h-19q-13 0-18-6-3-3-7-16t-6-18q-7-26-16-48t-24-46q34 4 68 5t68 2q24 0 36-7t13-34v-190h-319q-40 0-80 1t-80 2q-8 0-12-3-2-6-2-11v-103q0-4 3-7 6-2 11-2l80 2q40 1 80 1h319q-2-26-2-52t-6-53q22 2 43 4t43 4q35-25 67-53t64-57h-308q-42 0-83 1t-84 2q-8 0-12-3-2-6-2-11v-95q0-4 2-12 8-2 12-2 42 1 83 2t84 1h373q16 0 30-4t25-5q8 0 23 12t30 28 26 32 12 25q0 10-6 15t-15 10q-14 7-27 18t-25 21q-52 43-104 83t-110 78v11h321q40 0 79-1t79-2q7 0 13 3zm-639-542v-66q0-34-9-66 69 0 137 6 6 1 12 3t7 10q0 5-3 12t-5 12q-2 6-3 16t-2 21-1 22 0 17v13h296q42 0 83-1t84-2q7 0 13 3 3 5 3 10-1 17-2 35t-1 36v58q0 36 1 72t2 73v7q0 4-3 6-8 2-13 2h-23q-18 0-38 1t-36 0-20-4q-2-11-2-35t-1-52 1-53 1-40h-802v20q0 15 1 34t0 42 0 40-1 31-3 15q-8 2-13 2H949q-11 0-13-3t-2-13q1-69 1-137t-1-137q0-5 2-11 8-2 13-2 42 1 83 2t84 1h275z" })
      ]
    }
  );
}
var TimeLanguage_default = SvgTimeLanguage;

// src/components/Icon/icons/Timer.tsx
import { jsx as jsx940, jsxs as jsxs933 } from "react/jsx-runtime";
function SvgTimer({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs933(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx940("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx940("path", { d: "M1920 1152q0 124-32 238t-90 214-140 181-181 140-214 91-239 32q-124 0-238-32t-214-90-181-140-140-181-91-214-32-239q0-111 26-216t75-198 118-172 154-141 185-103 210-57V128H640V0h640v128h-256v128q139 0 270 41t245 122l208-208 90 90-198 199q135 137 208 297t73 355zm-896 768q106 0 204-27t183-78 156-120 120-155 77-184 28-204q0-106-27-204t-78-183-120-156-155-120-184-77-204-28q-106 0-204 27t-183 78-156 120-120 155-77 184-28 204q0 106 27 204t78 183 120 156 155 120 184 77 204 28zm128-896h512v128q0 133-50 249t-137 204-203 137-250 50q-133 0-249-50t-204-136-137-203-50-250q0-88 23-170t64-153 100-130 130-100 153-65 170-23h128v512zm384 128h-512V640q-107 0-200 40T661 790 552 954t-40 200q0 106 40 199t110 162 163 109 199 40q106 0 199-40t163-109 110-163 40-200z" })
      ]
    }
  );
}
var Timer_default = SvgTimer;

// src/components/Icon/icons/TitleMenu.tsx
import { jsx as jsx941, jsxs as jsxs934 } from "react/jsx-runtime";
function SvgTitleMenu({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs934(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx941("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx941("path", { d: "M896 0h1024v1920H0V896h896V0zm0 1792v-768H128v768h768zm896 0v-768h-768v768h768zm-768-896h768V128h-768v768z" })
      ]
    }
  );
}
var TitleMenu_default = SvgTitleMenu;

// src/components/Icon/icons/Toenail.tsx
import { jsx as jsx942, jsxs as jsxs935 } from "react/jsx-runtime";
function SvgToenail({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs935(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx942("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx942("path", { d: "M1518 214q64 40 114 93t86 117 55 134 19 146v576q0 152-21 300t-63 294l-123-36q39-137 59-276t20-282V704q0-88-33-169t-95-144v377q0 106-40 199t-109 163-163 110-200 40q-106 0-199-40t-163-109-110-163-40-200V391q-62 63-95 144t-33 169v576q0 142 20 281t59 277l-123 36q-42-146-63-294t-21-300V704q0-75 19-146t54-134 86-116 115-94q17-48 47-87t70-68 87-43 98-16h384q51 0 98 15t87 44 70 67 47 88zm-110 106q0-40-15-75t-41-61-61-41-75-15H832q-40 0-75 15t-61 41-41 61-15 75v448q0 80 30 149t82 122 122 83 150 30q79 0 149-30t122-82 83-122 30-150V320zM752 881q55-55 124-84t148-29q78 0 147 29t125 84l-91 90q-36-36-83-55t-98-20q-51 0-98 19t-83 56l-91-90z" })
      ]
    }
  );
}
var Toenail_default = SvgToenail;

// src/components/Icon/icons/ToeRing.tsx
import { jsx as jsx943, jsxs as jsxs936 } from "react/jsx-runtime";
function SvgToeRing({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs936(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx943("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx943("path", { d: "M1856 640q40 0 75 15t61 41 41 61 15 75v1152q0 26-19 45t-45 19q-26 0-45-19t-19-45V832q0-26-19-45t-45-19q-26 0-45 19t-19 45v256q0 26-19 45t-45 19q-26 0-45-19t-19-45V768q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50v320q0 26-19 45t-45 19q-26 0-45-19t-19-45V640q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50v12q28 10 52 28t40 42 26 52 10 58q0 30-9 58t-26 52-41 42-52 28q0 19 1 43t-3 46-19 36-43 15q-28 0-41-13t-19-32-5-42 1-41H640v40q0 22-4 42t-18 33-42 13q-29 0-43-14t-18-36-4-46 1-44q-29-10-52-28t-40-42-26-52-10-58q0-30 9-58t26-52 40-42 53-28V448q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75v1536q0 26-19 45t-45 19q-26 0-45-19t-19-45V448q0-66 25-124t68-101 102-69 125-26q46 0 90 13t81 37 68 58 50 76q34-27 74-41t85-15q40 0 78 12t69 35 56 54 38 70q64-43 143-43 40 0 78 12t69 35 56 54 38 70q64-43 143-43 37 0 72 11t66 30 55 47 40 62q42-22 87-22zm-1216 0h256V512q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50v128zm320 256q26 0 45-19t19-45q0-26-19-45t-45-19H576q-26 0-45 19t-19 45q0 26 19 45t45 19h384z" })
      ]
    }
  );
}
var ToeRing_default = SvgToeRing;

// src/components/Icon/icons/ToggleBorder.tsx
import { jsx as jsx944, jsxs as jsxs937 } from "react/jsx-runtime";
function SvgToggleBorder({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs937(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx944("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx944("path", { d: "M1582 558q96 0 181 37t148 100 100 148 37 181q0 96-37 181t-100 148-148 100-181 37H466q-96 0-181-37t-148-100-100-148-37-181q0-96 37-181t100-148 148-100 181-37h1116zm0 838q77 0 145-29t118-80 80-118 30-145q0-77-29-144t-80-118-119-80-145-30H466q-77 0-145 29t-118 80-80 118-30 145q0 77 29 144t80 118 119 80 145 30h1116z" })
      ]
    }
  );
}
var ToggleBorder_default = SvgToggleBorder;

// src/components/Icon/icons/ToggleFilled.tsx
import { jsx as jsx945, jsxs as jsxs938 } from "react/jsx-runtime";
function SvgToggleFilled({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs938(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx945("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx945("path", { d: "M1582 1490H466q-96 0-181-37t-148-100-100-148-37-181q0-96 37-181t100-148 148-100 181-37h1116q96 0 181 37t148 100 100 148 37 181q0 96-37 181t-100 148-148 100-181 37z" })
      ]
    }
  );
}
var ToggleFilled_default = SvgToggleFilled;

// src/components/Icon/icons/ToggleThumb.tsx
import { jsx as jsx946, jsxs as jsxs939 } from "react/jsx-runtime";
function SvgToggleThumb({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs939(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx946("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx946("path", { d: "M1031 0q143 0 274 36t244 103 205 161 157 208 101 245 36 273q0 140-36 270t-103 243-159 208-206 160-243 104-270 37q-140 0-271-36t-245-104-209-160-163-207-105-244-38-271q0-143 37-274t104-246 161-207 208-159T756 37t275-37z" })
      ]
    }
  );
}
var ToggleThumb_default = SvgToggleThumb;

// src/components/Icon/icons/Touch.tsx
import { jsx as jsx947, jsxs as jsxs940 } from "react/jsx-runtime";
function SvgTouch({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs940(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx947("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx947("path", { d: "M1600 896q40 0 75 15t61 41 41 61 15 75v384q0 119-45 224t-124 183-183 123-224 46q-144 0-268-55t-226-156l-472-472q-28-28-43-65t-15-76q0-42 16-78t43-64 63-42 78-16q82 0 141 59l107 106V853q-59-28-106-70t-80-95-52-114-18-126q0-93 35-174t96-143 142-96T832 0q93 0 174 35t143 96 96 142 35 175q0 93-37 178t-105 149q35 9 63 30t49 52q45-25 94-25 50 0 93 23t69 66q45-25 94-25zM512 448q0 75 34 143t94 113V448q0-40 15-75t41-61 61-41 75-15q40 0 75 15t61 41 41 61 15 75v256q60-45 94-113t34-143q0-66-25-124t-69-101-102-69-124-26q-66 0-124 25t-102 69-69 102-25 124zm1152 1024v-384q0-26-19-45t-45-19q-21 0-34 7t-20 21-9 31-2 37q0 16 1 32t1 32q0 20-2 37t-9 30-20 21-34 8q-21 0-34-8t-20-21-9-33-3-40q0-28 2-58t2-58q0-43-12-72t-54-30q-21 0-34 7t-20 21-9 31-2 37q0 16 1 32t1 32q0 20-2 37t-9 30-20 21-34 8q-21 0-34-8t-20-21-9-33-3-40q0-28 2-58t2-58q0-43-12-72t-54-30q-21 0-34 7t-20 21-9 31-2 37q0 16 1 32t1 32q0 20-2 37t-9 30-20 21-34 8q-26 0-45-19t-19-45V448q0-26-19-45t-45-19q-26 0-45 19t-19 45v787q0 23-8 42t-23 35-35 23-42 9q-22 0-42-8t-37-24l-139-139q-21-21-50-21t-50 21-22 51q0 29 21 50l472 473q84 84 184 128t219 45q93 0 174-35t142-96 96-142 36-175z" })
      ]
    }
  );
}
var Touch_default = SvgTouch;

// src/components/Icon/icons/Tournament.tsx
import { jsx as jsx948, jsxs as jsxs941 } from "react/jsx-runtime";
function SvgTournament({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs941(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx948("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx948("path", { d: "M2016 1376q0 26-19 45l-242 243 274 275-90 90-275-274-243 242q-19 19-45 19t-45-19-19-45q0-19 9-33t23-25q-2-102-22-206t-59-203-93-189-128-164q-5-5-9-8t-9-9q-5 5-9 8t-9 9q-72 74-127 164t-94 189-58 203-23 206q13 11 22 25t10 33q0 26-19 45t-45 19q-26 0-45-19l-243-242-275 274-90-90 274-275-242-243q-19-19-19-45t19-45 45-19q19 0 33 9t25 23q102-2 206-22t203-59 189-93 164-128q5-5 8-9t9-9L45 136 0 0l136 45 10 10q7 7 33 34t81 81 152 152 247 247 365 364l888-888 136-45-45 136-10 10q-7 7-34 33t-81 81-152 152-247 247-364 365q5 5 8 9t9 9q74 72 164 127t189 94 203 58 206 23q11-13 25-22t33-10q26 0 45 19t19 45zM584 1773q13-115 44-223t83-213q-104 51-212 82t-224 45l309 309zm753-436q51 104 82 212t45 224l309-309q-115-13-223-44t-213-83z" })
      ]
    }
  );
}
var Tournament_default = SvgTournament;

// src/components/Icon/icons/TransferCable.tsx
import { jsx as jsx949, jsxs as jsxs942 } from "react/jsx-runtime";
function SvgTransferCable({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs942(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx949("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx949("path", { d: "M1664 384q27 0 50 10t40 27 28 41 10 50v512q0 27-10 50t-27 40-41 28-50 10h-192q-26 0-45 19t-19 45v704q0 27-10 50t-27 40-41 28-50 10H384q-27 0-50-10t-40-27-28-41-10-50V512q0-27 10-50t27-40 41-28 50-10h384q0-53 20-99t55-82 81-55 100-20h256q27 0 50-10t40-27 28-41 10-50h128q0 53-20 99t-55 82-81 55-100 20h-256q-27 0-50 10t-40 27-28 41-10 50h768zm0 128H384v1408h896v-704q0-40 15-75t41-61 61-41 75-15h192V512z" })
      ]
    }
  );
}
var TransferCable_default = SvgTransferCable;

// src/components/Icon/icons/Translate.tsx
import { jsx as jsx950, jsxs as jsxs943 } from "react/jsx-runtime";
function SvgTranslate({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs943(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx950("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx950("path", { d: "M651 896l341 1024H853l-85-256H384l-85 256H160L501 896h150zm577 257q24 0 36-7t13-34V922H958q-40 0-80 1t-80 2q-8 0-12-3-2-6-2-11V808q0-4 3-7 6-2 11-2l80 2q40 1 80 1h319q-2-26-2-52t-6-53q20 2 39 3t40 4h3q1 0 4 1 35-25 67-53t64-57h-308q-42 0-83 1t-84 2q-8 0-12-3-2-6-2-11v-95q0-4 2-12 8-2 12-2 42 1 83 2t84 1h373q16 0 30-4t25-5q8 0 23 12t30 28 26 32 12 25q0 10-6 15t-15 10q-14 7-27 18t-25 21q-52 43-104 83t-110 78v11h321q40 0 79-1t79-2q7 0 13 3 2 8 2 13v96q0 4-2 12-8 2-13 2-40-1-79-2t-79-1h-321v33q0 52 1 104t3 104v4q0 24-9 48t-29 38q-14 10-39 15t-55 8-56 3-44 1h-19q-13 0-18-6-3-3-7-16t-6-18q-7-26-16-48t-24-46q34 4 68 5t68 2zm647 300l-83-82v165q0 53-20 99t-55 82-81 55-100 20h-165l82 83-90 90-237-237 237-237 90 90-82 83h165q27 0 50-10t40-27 28-41 10-50v-165l-83 82-90-90 237-237 237 237-90 90zM806 544q1-40 1-79t0-79v-58q0-29-1-58 0-5 2-11 8-2 13-2 42 1 83 2t84 1h275v-11q0-30-1-61t-8-60q69 0 137 6 6 1 12 3t7 10q0 6-3 12t-5 12q-2 5-3 15t-2 22-1 22 0 17v13h296q42 0 83-1t84-2q7 0 13 3 3 5 3 10-1 17-2 35t-1 36v58q0 36 1 72t2 73v7q0 4-3 6-8 2-13 2h-25q-20 0-41 1-19 0-34-1t-17-3q-2-8-2-24t-1-36q0-33 1-68t1-52H939v39q0 15 1 31t0 34q0 29-1 52t-3 26q-8 2-13 2H821q-11 0-13-3t-2-13zm-81 992l-149-448-149 448h298z" })
      ]
    }
  );
}
var Translate_default = SvgTranslate;

// src/components/Icon/icons/Trending.tsx
import { jsx as jsx951, jsxs as jsxs944 } from "react/jsx-runtime";
function SvgTrending({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs944(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx951("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx951("path", { d: "M1280 384h768v768h-128V603l-896 896-384-384-547 546-90-90 637-638 384 384 805-805h-549V384z" })
      ]
    }
  );
}
var Trending_default = SvgTrending;

// src/components/Icon/icons/TrendingMirrored.tsx
import { jsx as jsx952, jsxs as jsxs945 } from "react/jsx-runtime";
function SvgTrendingMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs945(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx952("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx952("path", { d: "M771 384H3v768h128V603l896 896 384-384 547 546 90-90-637-638-384 384-805-805h549V384z" })
      ]
    }
  );
}
var TrendingMirrored_default = SvgTrendingMirrored;

// src/components/Icon/icons/TriggerLeft.tsx
import { jsx as jsx953, jsxs as jsxs946 } from "react/jsx-runtime";
function SvgTriggerLeft({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs946(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx953("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx953("path", { d: "M1664 0q47 0 97 8t94 29 78 55 49 85q14 48 20 100t14 103q16 129 24 257t8 259q0 184-40 340t-116 285-184 226-243 165-295 101-338 35H384q-39 0-83-13t-83-38-64-60-26-81q0-20 6-43t16-46 19-45 20-40q46-98 82-191t62-189 38-195 13-211q0-62-5-119t-15-112-25-110-34-113-34-113-16-118v-11q0-6 1-12 5-44 30-79t62-59 80-37 84-13h1152zM832 1920q160 0 302-30t264-88 217-146 165-201 104-254 36-305q0-146-10-291t-33-291q-4-26-7-54t-12-52q-8-25-31-40t-53-25-59-12-51-3H512q-14 0-34 5t-40 14-35 21-19 28q-1 2-1 8t0 9q0 49 14 96t29 93q21 63 37 123t27 120 16 123 6 128q0 118-13 225t-40 209-65 202-89 205l-12 24q-8 16-16 35t-15 36-6 24q0 13 16 24t37 21 43 14 32 5h448zm64-768h256v128H768V640h128v512zm256-512h512v128h-192v512h-128V768h-192V640z" })
      ]
    }
  );
}
var TriggerLeft_default = SvgTriggerLeft;

// src/components/Icon/icons/TriggerLeftDlSet.tsx
import { jsx as jsx954, jsxs as jsxs947 } from "react/jsx-runtime";
function SvgTriggerLeftDlSet({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs947(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx954("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx954("path", { d: "M1538 128q53 0 99 21t80 58 55 83 20 100v458q0 132-34 253t-96 227-149 193-192 149-228 96-253 34H472q-39 0-74-15t-61-41-41-62-15-74q0-21 4-40t12-38q24-60 51-118t56-118l8-16q42-88 66-180t25-189q0-67-10-138t-32-135q-14-38-27-75t-25-76-19-77-7-80q0-39 15-75t40-64 61-44 75-17h964zm126 262q0-25-10-49t-27-43-40-30-49-12H574q-13 0-24 6t-20 17-14 23-5 25q0 35 6 68t17 66 23 65 24 65q26 73 38 158t12 163q0 112-28 216t-76 205q-2 2-3 5t-3 8q-11 22-29 61t-37 81-32 76-14 44q0 26 18 45t45 19h368q113 0 218-29t197-83 167-129 129-167 83-197 30-219V390z" })
      ]
    }
  );
}
var TriggerLeftDlSet_default = SvgTriggerLeftDlSet;

// src/components/Icon/icons/TriggerLeftSolid.tsx
import { jsx as jsx955, jsxs as jsxs948 } from "react/jsx-runtime";
function SvgTriggerLeftSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs948(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx955("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx955("path", { d: "M2048 896q0 184-40 341t-117 285-184 226-243 165-294 101-338 34H384q-39 0-83-13t-83-38-64-60-26-81q0-19 6-42t16-47 19-45 20-40q23-47 43-95t40-96q56-143 84-292t28-303q0-173-45-341-12-45-26-88t-28-88-21-88-9-92q0-45 25-82t63-63 84-40 85-14h1152q36 0 72 4t72 15 67 29 58 44q18 18 29 39t20 46q15 50 21 101t13 102q17 128 24 257t8 259zm-896 384v-128H896V640H768v640h384zm512-512V640h-512v128h192v512h128V768h192z" })
      ]
    }
  );
}
var TriggerLeftSolid_default = SvgTriggerLeftSolid;

// src/components/Icon/icons/TriggerRight.tsx
import { jsx as jsx956, jsxs as jsxs949 } from "react/jsx-runtime";
function SvgTriggerRight({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs949(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx956("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx956("path", { d: "M1664 896q0 111 13 210t38 195 61 189 83 192q9 18 19 40t20 45 15 46 7 43q0 45-25 80t-64 60-83 38-84 14h-448q-178 0-337-34t-295-101-244-165-183-227-116-284T0 896q0-130 8-258t24-258q7-50 13-102t21-101q15-51 49-85t78-54 94-29 97-9h1152q41 0 84 13t79 37 62 59 31 79q1 5 1 11t0 12q0 61-15 117t-35 114q-19 58-34 113t-25 110-15 112-5 119zm0 1024q10 0 31-5t43-14 38-20 16-25q0-7-6-24t-15-35-16-35-12-25q-50-105-88-205t-65-202-40-209-14-225q0-67 5-129t17-122 27-120 37-123q15-46 29-93t14-96v-8q0-6-1-9-4-15-19-27t-34-22-40-14-35-5H384q-21 0-51 3t-59 12-52 24-32 41q-8 24-11 52t-8 54q-22 145-32 290t-11 292q0 165 36 305t104 254 164 201 218 145 263 89 303 30h448zM896 864q0 55-25 101t-71 76l96 239H768l-78-196q-43 8-88 6t-90-2v192H384V640h256q49 0 95 15t82 44 57 70 22 95zm-256 96q21 0 44-5t41-18 31-30 12-43q0-25-12-43t-30-30-42-17-44-6H512v192h128zm256-320h512v128h-192v512h-128V768H896V640z" })
      ]
    }
  );
}
var TriggerRight_default = SvgTriggerRight;

// src/components/Icon/icons/TriggerRightDlSet.tsx
import { jsx as jsx957, jsxs as jsxs950 } from "react/jsx-runtime";
function SvgTriggerRightDlSet({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs950(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx957("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx957("path", { d: "M1545 909q0 97 24 189t67 180l8 16q29 59 56 117t51 119q8 19 12 38t4 40q0 39-15 74t-41 61-61 42-74 15h-368q-131 0-253-34t-227-96-193-149-149-192-96-227-34-254V390q0-52 20-99t54-84 81-57 99-22h964q40 0 74 16t61 44 41 64 15 75q0 42-7 81t-18 77-26 75-27 76q-22 63-32 134t-10 139zm31 763q26 0 44-19t19-44q0-7-7-28t-19-48-26-59-27-59-24-51-15-31q-48-100-76-204t-28-217q0-77 12-162t38-159l24-64q12-32 22-64t17-66 7-69q0-13-5-25t-13-23-20-17-25-7H510q-26 0-49 11t-40 30-27 43-10 50v458q0 114 29 219t83 196 129 167 167 129 197 83 219 30h368z" })
      ]
    }
  );
}
var TriggerRightDlSet_default = SvgTriggerRightDlSet;

// src/components/Icon/icons/TriggerRightSolid.tsx
import { jsx as jsx958, jsxs as jsxs951 } from "react/jsx-runtime";
function SvgTriggerRightSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs951(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx958("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx958("path", { d: "M768 864q0 25-12 43t-30 30-42 17-44 6H512V768h128q21 0 44 5t41 18 31 30 12 43zm1152 992q0 45-25 80t-64 60-83 38-84 14h-487q-74 0-150-9t-148-25q-213-46-377-145t-275-244-169-328T0 896q0-130 7-259t25-257q7-51 13-102t21-101q14-50 49-85 26-26 58-44t67-28 71-15 73-5h1152q44 0 90 14t83 42 60 67 24 88q0 44-9 87t-22 87-27 85-26 85q-45 168-45 341 0 156 28 302t84 293q19 49 39 96t44 95q9 18 19 40t20 45 15 46 7 43zM896 1280l-96-239q45-30 70-76t26-101q0-53-21-94t-58-71-82-44-95-15H384v640h128v-192q27 0 54 1t53 1q36 0 71-6l78 196h128zm512-512V640H896v128h192v512h128V768h192z" })
      ]
    }
  );
}
var TriggerRightSolid_default = SvgTriggerRightSolid;

// src/components/Icon/icons/Trim.tsx
import { jsx as jsx959, jsxs as jsxs952 } from "react/jsx-runtime";
function SvgTrim({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs952(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx959("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx959("path", { d: "M640 384H512V256h128v128zm896 0h-128V256h128v128zM640 640H512V512h128v128zm896 0h-128V512h128v128zM640 1792H512v-128h128v128zm896 0h-128v-128h128v128zm-896-256H512v-128h128v128zm896 0h-128v-128h128v128zM128 1280H0V768h128v512zm256 0H256V768h128v512zm1408 0h-128V768h128v512zm256 0h-128V768h128v512zm-640-384v256H640V896h768zm128-128H512v512h1024V768z" })
      ]
    }
  );
}
var Trim_default = SvgTrim;

// src/components/Icon/icons/TShirt.tsx
import { jsx as jsx960, jsxs as jsxs953 } from "react/jsx-runtime";
function SvgTShirt({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs953(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx960("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx960("path", { d: "M2048 384l-128 512h-256v1024H384V896H128L0 384l768-256q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100l768 256zm-153 84l-524-175q-24 50-60 90t-82 69-97 44-108 16q-56 0-108-15t-97-44-81-69-61-91L153 468l75 300h284v1024h1024V768h284l75-300z" })
      ]
    }
  );
}
var TShirt_default = SvgTShirt;

// src/components/Icon/icons/TvBluRaySettings.tsx
import { jsx as jsx961, jsxs as jsxs954 } from "react/jsx-runtime";
function SvgTvBluRaySettings({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs954(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx961("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx961("path", { d: "M128 1280h786q-10 28-14 61t-5 66 0 67 1 62v128H512v-128h256v-128H0V256h1920v716q-30-18-62-30t-66-23V384H128v896zm1408-256q106 0 199 40t163 109 110 163 40 200q0 106-40 199t-109 163-163 110-200 40q-106 0-199-40t-163-109-110-163-40-200q0-106 40-199t109-163 163-110 200-40zm0 896q79 0 149-30t122-82 83-122 30-150q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149q0 80 30 149t82 122 122 83 150 30zm0-459q31 0 53 22t22 53q0 31-22 53t-53 22q-31 0-53-22t-22-53q0-31 22-53t53-22z" })
      ]
    }
  );
}
var TvBluRaySettings_default = SvgTvBluRaySettings;

// src/components/Icon/icons/TvCableSettings.tsx
import { jsx as jsx962, jsxs as jsxs955 } from "react/jsx-runtime";
function SvgTvCableSettings({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs955(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx962("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx962("path", { d: "M1920 256v638l-128 1V384H128v896h1280v128h-384v128h256v128H640v-128h256v-128H0V256h1920zm-128 1025h40q22 0 42 4t33 18 13 42v511q0 28-13 41t-32 19-42 5-41-1v128h-128v-128h-40q-22 0-42-4t-33-18-13-42v-511q0-28 13-41t32-19 42-5 41 1v-257h128v257zm0 128h-128v383h128v-383z" })
      ]
    }
  );
}
var TvCableSettings_default = SvgTvCableSettings;

// src/components/Icon/icons/TvMonitor.tsx
import { jsx as jsx963, jsxs as jsxs956 } from "react/jsx-runtime";
function SvgTvMonitor({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs956(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx963("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx963("path", { d: "M1920 1408h-896v128h256v128H640v-128h256v-128H0V256h1920v1152zM128 384v896h1664V384H128z" })
      ]
    }
  );
}
var TvMonitor_default = SvgTvMonitor;

// src/components/Icon/icons/TvRecommendationsTv.tsx
import { jsx as jsx964, jsxs as jsxs957 } from "react/jsx-runtime";
function SvgTvRecommendationsTv({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs957(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx964("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx964("path", { d: "M1536 1408h-512v256H640v-128h256v-128H0V256h1920v768l-128 128V384H128v896h1536l-128 128zm403-109l90 90-557 558-301-302 90-90 211 211 467-467z" })
      ]
    }
  );
}
var TvRecommendationsTv_default = SvgTvRecommendationsTv;

// src/components/Icon/icons/TvSettings.tsx
import { jsx as jsx965, jsxs as jsxs958 } from "react/jsx-runtime";
function SvgTvSettings({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs958(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx965("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx965("path", { d: "M1914 1539q6 30 6 61t-6 61l124 51-49 119-124-52q-35 51-86 86l52 124-119 49-51-124q-30 6-61 6t-61-6l-51 124-119-49 52-124q-51-35-86-86l-124 52-49-119 124-51q-6-30-6-61t6-61l-124-51 49-119 124 52q35-51 86-86l-52-124 119-49 51 124q30-6 61-6t61 6l51-124 119 49-52 124q51 35 86 86l124-52 49 119-124 51zm-314 253q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15zm-517-512q-5 8-14 26t-20 38-17 39-8 25q-2 64-1 128t1 128H640v-128h256v-128H0V256h1920v829q-30-19-62-33t-66-26V384H128v896h955z" })
      ]
    }
  );
}
var TvSettings_default = SvgTvSettings;

// src/components/Icon/icons/TvShows.tsx
import { jsx as jsx966, jsxs as jsxs959 } from "react/jsx-runtime";
function SvgTvShows({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs959(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx966("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx966("path", { d: "M0 1536V512h1664v1024H896v128h256v128H512v-128h256v-128H0zm128-896v768h1408V640H128zm128-384h1664v1024h-128V384H256V256z" })
      ]
    }
  );
}
var TvShows_default = SvgTvShows;

// src/components/Icon/icons/TwitterLogo.tsx
import { jsx as jsx967, jsxs as jsxs960 } from "react/jsx-runtime";
function SvgTwitterLogo({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs960(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx967("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx967("path", { d: "M2048 389q-42 63-95 117t-115 100q1 14 1 27t1 28q0 126-27 249t-78 238q-74 167-185 298t-251 223-307 139-348 48q-172 0-335-47T0 1667q49 6 100 6 143 0 276-46t246-134q-67-1-129-22t-113-60-90-92-60-117q20 3 39 5t40 2q56 0 110-15-75-15-137-53t-106-94-69-125-25-145q88 50 191 53-44-30-78-68t-59-84-37-95-13-103q0-56 14-109t43-102q80 99 178 177t208 135 232 88 248 39q-6-23-8-47t-3-49q0-87 33-163t90-134 133-90 164-33q88 0 167 34t140 99q71-14 137-39t129-63q-23 73-70 133t-114 99q126-15 241-66z" })
      ]
    }
  );
}
var TwitterLogo_default = SvgTwitterLogo;

// src/components/Icon/icons/Uncompare.tsx
import { jsx as jsx968, jsxs as jsxs961 } from "react/jsx-runtime";
function SvgUncompare({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs961(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx968("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx968("path", { d: "M2029 109l-914 915 914 915-90 90-915-914-915 914-90-90 914-915L19 109l90-90 915 914 915-914 90 90z" })
      ]
    }
  );
}
var Uncompare_default = SvgUncompare;

// src/components/Icon/icons/Undo.tsx
import { jsx as jsx969, jsxs as jsxs962 } from "react/jsx-runtime";
function SvgUndo({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs962(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx969("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx969("path", { d: "M1088 4q96 0 185 25t167 71 142 110 110 142 71 167 25 185q0 139-52 265t-150 224l-837 836-90-90 836-837q80-80 122-182t43-216q0-117-45-221t-124-182-182-123-221-46q-113 0-215 42T690 297L475 512h421v128H256V0h128v421q55-56 105-108t101-99 103-85 112-66 129-43 154-16z" })
      ]
    }
  );
}
var Undo_default = SvgUndo;

// src/components/Icon/icons/Undock.tsx
import { jsx as jsx970, jsxs as jsxs963 } from "react/jsx-runtime";
function SvgUndock({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs963(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx970("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx970("path", { d: "M1280 512v293l467-466 90 90-466 467h293v128h-512V512h128zm512 192l128-128v1216H128V256h1472l-128 128H256v768h768v512h768V704zm-896 960v-384H256v384h640z" })
      ]
    }
  );
}
var Undock_default = SvgUndock;

// src/components/Icon/icons/UndockMirrored.tsx
import { jsx as jsx971, jsxs as jsxs964 } from "react/jsx-runtime";
function SvgUndockMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs964(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx971("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx971("path", { d: "M768 512v293L301 339l-90 90 466 467H384v128h512V512H768zM256 704L128 576v1216h1792V256H448l128 128h1216v768h-768v512H256V704zm896 960v-384h640v384h-640z" })
      ]
    }
  );
}
var UndockMirrored_default = SvgUndockMirrored;

// src/components/Icon/icons/Ungrouped.tsx
import { jsx as jsx972, jsxs as jsxs965 } from "react/jsx-runtime";
function SvgUngrouped({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs965(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx972("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx972("path", { d: "M451 1149V835h1146v314H451zm1088-58V893H765v198h774zM509 893v198h198V893H509zm-58 704v-314h1146v314H451zm1088-58v-198H765v198h774zM509 1341v198h198v-198H509zm-58-954h1146v314H451V387zm58 58v198h198V445H509zm1030 198V445H765v198h774z" })
      ]
    }
  );
}
var Ungrouped_default = SvgUngrouped;

// src/components/Icon/icons/Uninstall.tsx
import { jsx as jsx973, jsxs as jsxs966 } from "react/jsx-runtime";
function SvgUninstall({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs966(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx973("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx973("path", { d: "M2045 1373l-290 291 290 291-90 90-291-290-291 290-90-90 290-291-290-291 90-90 291 290 291-290 90 90zM1920 256v896h-768v768H256V256h1664zM384 384v640h640V384H384zm640 1408v-640H384v640h640zm768-768V384h-640v640h640z" })
      ]
    }
  );
}
var Uninstall_default = SvgUninstall;

// src/components/Icon/icons/Unknown.tsx
import { jsx as jsx974, jsxs as jsxs967 } from "react/jsx-runtime";
function SvgUnknown({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs967(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx974("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx974("path", { d: "M960 4q132 0 254 34t228 96 194 150 149 193 97 229 34 254q0 132-34 254t-96 228-150 194-193 149-229 97-254 34q-132 0-254-34t-228-96-194-150-149-193-97-229T4 960q0-132 34-254t96-228 150-194 193-149 229-97T960 4zm0 1792q115 0 222-30t200-84 169-131 130-169 85-200 30-222q0-115-30-222t-84-200-131-169-169-130-200-85-222-30q-115 0-222 30t-200 84-169 131-130 169-85 200-30 222q0 115 30 222t84 200 131 169 169 130 200 85 222 30zm-64-388h128v128H896v-128zm64-960q66 0 124 25t101 69 69 102 26 124q0 60-19 104t-47 81-62 65-61 59-48 63-19 76v64H896v-64q0-60 19-104t47-81 62-65 61-59 48-63 19-76q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75H640q0-66 25-124t68-101 102-69 125-26z" })
      ]
    }
  );
}
var Unknown_default = SvgUnknown;

// src/components/Icon/icons/Unknown3D.tsx
import { jsx as jsx975, jsxs as jsxs968 } from "react/jsx-runtime";
function SvgUnknown3D({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs968(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 64 64",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx975("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx975("path", { d: "M0 29.74a.5.5 0 01.075-.265l.043-.06.045-.045.052-.04.035-.023 36.73-21.21a.5.5 0 01.42-.037l.08.037 26.305 15.182.069.057.039.043.031.045a.5.5 0 01.074.22l.002.046v9.96a.5.5 0 01-.178.382l-.072.051-36.745 21.208-.072.032-.105.024-.095.002-.078-.012-.069-.022-.066-.032L.25 40.123a.5.5 0 01-.242-.345L0 39.69v-9.95zm62.999 3.621v-8.805L27.27 45.188v8.795l35.729-20.622zm-62-2.756V39.4l25.27 14.583v-8.795L.999 30.605zm36.23-21.498L1.5 29.739l25.27 14.583L62.499 23.69 37.229 9.107z" })
      ]
    }
  );
}
var Unknown3D_default = SvgUnknown3D;

// src/components/Icon/icons/UnknownMirrored.tsx
import { jsx as jsx976, jsxs as jsxs969 } from "react/jsx-runtime";
function SvgUnknownMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs969(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx976("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx976("path", { d: "M960 4Q828 4 706 38t-228 96-194 150-149 193-97 229T4 960q0 132 34 254t96 228 150 194 193 149 229 97 254 34q132 0 254-34t228-96 194-150 149-193 97-229 34-254q0-132-34-254t-96-228-150-194-193-149-229-97T960 4zm0 1792q-115 0-222-30t-200-84-169-131-130-169-85-200-30-222q0-115 30-222t84-200 131-169 169-130 200-85 222-30q115 0 222 30t200 84 169 131 130 169 85 200 30 222q0 115-30 222t-84 200-131 169-169 130-200 85-222 30zm64-388H896v128h128v-128zm-64-960q-66 0-124 25t-101 69-69 102-26 124q0 60 19 104t47 81 62 65 61 59 48 63 19 76v64h128v-64q0-60-19-104t-47-81-62-65-61-59-48-63-19-76q0-40 15-75t41-61 61-41 75-15q40 0 75 15t61 41 41 61 15 75h128q0-66-25-124t-68-101-102-69-125-26z" })
      ]
    }
  );
}
var UnknownMirrored_default = SvgUnknownMirrored;

// src/components/Icon/icons/UnknownMirroredSolid.tsx
import { jsx as jsx977, jsxs as jsxs970 } from "react/jsx-runtime";
function SvgUnknownMirroredSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs970(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx977("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx977("path", { d: "M0 960q0-132 34-255t97-229 150-194 194-150 230-97T960 0q132 0 255 34t229 97 194 150 150 194 97 230 35 255q0 133-34 255t-97 229-150 194-194 150-230 97-255 35q-133 0-255-34t-229-97-194-150-150-194-97-230T0 960zm896 448v128h128v-128H896zM632 768q0 59 18 105t49 85 69 74 77 75q29 29 36 63t7 73v37h144v-64q0-61-19-106t-47-82-62-66-61-59-48-62-19-73q0-38 14-71t40-59 58-39 72-15q38 0 71 14t59 40 39 58 15 72h144q0-68-26-127t-70-104-104-71-128-26q-68 0-127 26t-104 70-71 104-26 128z" })
      ]
    }
  );
}
var UnknownMirroredSolid_default = SvgUnknownMirroredSolid;

// src/components/Icon/icons/UnknownSolid.tsx
import { jsx as jsx978, jsxs as jsxs971 } from "react/jsx-runtime";
function SvgUnknownSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs971(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx978("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx978("path", { d: "M960 0q132 0 255 34t229 97 194 150 150 194 97 230 35 255q0 133-34 255t-97 229-150 194-194 150-230 97-255 35q-133 0-255-34t-229-97-194-150-150-194-97-230T0 960q0-132 34-255t97-229 150-194 194-150 230-97T960 0zm64 1536v-128H896v128h128zm264-768q0-68-26-127t-70-104-104-71-128-26q-68 0-127 26t-104 70-71 104-26 128h144q0-38 14-71t40-59 58-39 72-15q38 0 71 14t59 40 39 58 15 72q0 41-19 73t-47 61-62 60-61 66-48 81-19 107v64h144v-64q0-41 19-73t47-61 62-60 61-66 48-81 19-107z" })
      ]
    }
  );
}
var UnknownSolid_default = SvgUnknownSolid;

// src/components/Icon/icons/Unlock.tsx
import { jsx as jsx979, jsxs as jsxs972 } from "react/jsx-runtime";
function SvgUnlock({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs972(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx979("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx979("path", { d: "M1792 896v1152H256V896h1152V512q0-82-29-152t-80-122-122-81-153-29q-82 0-152 29t-122 80-81 122-29 153H512q0-109 39-202t108-163T821 39t203-39q109 0 202 39t163 108 108 162 39 203v384h256zm-128 128H384v896h1280v-896z" })
      ]
    }
  );
}
var Unlock_default = SvgUnlock;

// src/components/Icon/icons/UnlockedAchievement.tsx
import { jsx as jsx980, jsxs as jsxs973 } from "react/jsx-runtime";
function SvgUnlockedAchievement({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs973(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx980("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx980("path", { d: "M1276 1017q-9 74-42 140t-83 117-115 85-140 44v133h256v128H512v128h640v128H256v-128h128v-256h384v-133q-74-10-139-44t-116-85-83-117-42-140q-56-11-104-40t-82-70-54-94-20-110V256h256V128h896v128h256v447q0 57-19 109t-54 94-83 71-104 40zm4-133q28-10 52-28t40-43 26-52 10-58V384h-128v500zM384 384H256v319q0 30 9 58t26 53 40 42 53 28V384zm448 896q66 0 124-25t101-68 69-102 26-125V256H512v704q0 66 25 124t68 102 102 69 125 25zm1216 128v640h-768v-640h512v-128q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50h-128q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100v128h128zm-128 128h-512v384h512v-384z" })
      ]
    }
  );
}
var UnlockedAchievement_default = SvgUnlockedAchievement;

// src/components/Icon/icons/Unpin.tsx
import { jsx as jsx981, jsxs as jsxs974 } from "react/jsx-runtime";
function SvgUnpin({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs974(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx981("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx981("path", { d: "M1472 1152q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm-320 448q0 66 25 124t68 102 102 69 125 25q47 0 92-13t84-40l-443-443q-26 39-39 84t-14 92zm587 176q26-39 39-84t14-92q0-66-25-124t-69-101-102-69-124-26q-47 0-92 13t-84 40l443 443zm251-1028q-33 33-64 60t-65 47-73 29-90 11q-34 0-65-6l-135 135h-181l278-278q26 8 51 14t52 7q55 0 104-26l-495-495q-26 49-26 104 0 27 6 52t15 51L810 944q-24-10-46-19t-44-15-45-9-51-4q-57 0-111 16t-100 49l483 484v181l-192-192-568 568-136 45 45-136 568-568-385-385 45-46q69-70 162-107t191-37q39 0 77 6t77 19l379-379q-6-31-6-65 0-49 10-88t30-74 46-65 61-65l690 690z" })
      ]
    }
  );
}
var Unpin_default = SvgUnpin;

// src/components/Icon/icons/Unpin2.tsx
import { jsx as jsx982, jsxs as jsxs975 } from "react/jsx-runtime";
function SvgUnpin2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs975(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx982("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx982("path", { d: "M1472 1152q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm-320 448q0 66 25 124t68 102 102 69 125 25q47 0 92-13t84-40l-443-443q-26 39-39 84t-14 92zm587 176q26-39 39-84t14-92q0-66-25-124t-69-101-102-69-124-26q-47 0-92 13t-84 40l443 443zm251-1028q-33 33-64 60t-65 47-73 29-90 11q-34 0-65-6l-135 135h-181l278-278q26 8 51 14t52 7q55 0 104-26l-495-495q-26 49-26 104 0 27 6 52t15 51L810 944q-24-10-46-19t-44-15-45-9-51-4q-57 0-111 16t-100 49l483 484v181l-192-192-568 568-136 45 45-136 568-568-385-385 45-46q69-70 162-107t191-37q39 0 77 6t77 19l379-379q-6-31-6-65 0-49 10-88t30-74 46-65 61-65l690 690z" })
      ]
    }
  );
}
var Unpin2_default = SvgUnpin2;

// src/components/Icon/icons/UnrecognizedFormat.tsx
import { jsx as jsx983, jsxs as jsxs976 } from "react/jsx-runtime";
function SvgUnrecognizedFormat({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs976(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx983("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx983("path", { d: "M384 256h1280v1536H384V256zm1152 1408v-256H512v256h1024zm0-384V384H512v896h1024zm-691-192l-77-77 179-179-179-179 77-77 179 179 179-179 77 77-179 179 179 179-77 77-179-179-179 179z" })
      ]
    }
  );
}
var UnrecognizedFormat_default = SvgUnrecognizedFormat;

// src/components/Icon/icons/UnSnap.tsx
import { jsx as jsx984, jsxs as jsxs977 } from "react/jsx-runtime";
function SvgUnSnap({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs977(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx984("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx984("path", { d: "M1038 692l268 268-268 269-90-90 114-115H640V896h421L948 782l90-90zm882 716V512h-384v896h384zM128 512v896h1280V512H128zM0 384h2048v1152h-960v128h320v128H640v-128h320v-128H0V384z" })
      ]
    }
  );
}
var UnSnap_default = SvgUnSnap;

// src/components/Icon/icons/UnSnapMirrored.tsx
import { jsx as jsx985, jsxs as jsxs978 } from "react/jsx-runtime";
function SvgUnSnapMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs978(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx985("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx985("path", { d: "M1010 692L742 960l268 269 90-90-114-115h422V896H987l113-114-90-90zm-882 716V512h384v896H128zm1792-896v896H640V512h1280zm128-128H0v1152h960v128H640v128h768v-128h-320v-128h960V384z" })
      ]
    }
  );
}
var UnSnapMirrored_default = SvgUnSnapMirrored;

// src/components/Icon/icons/Upload.tsx
import { jsx as jsx986, jsxs as jsxs979 } from "react/jsx-runtime";
function SvgUpload({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs979(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx986("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx986("path", { d: "M1536 128H384V0h1152v128zm-45 941l-467-470v1449H896V599l-467 470-90-90 621-626 621 626-90 90z" })
      ]
    }
  );
}
var Upload_default = SvgUpload;

// src/components/Icon/icons/Usb.tsx
import { jsx as jsx987, jsxs as jsxs980 } from "react/jsx-runtime";
function SvgUsb({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs980(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx987("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx987("path", { d: "M1536 896h-128v64q0 66-25 124t-68 102-102 69-125 25h-66v394q29 10 53 28t41 42 26 52 10 60q0 40-15 75t-41 61-61 41-75 15q-40 0-75-15t-61-41-41-61-15-75q0-31 9-59t27-52 40-42 53-28v-267h-65q-66 0-124-25t-102-68-69-102-25-125v-75q-29-10-52-28t-41-42-26-52-9-59q0-40 15-75t41-61 61-41 75-15q40 0 75 15t61 41 41 61 15 75q0 30-9 58t-26 52-41 42-52 29v75q0 40 15 75t41 61 61 41 75 15h65V250L749 397l-90-90L960 6l301 301-90 90-149-148v903h66q40 0 75-15t61-41 41-61 15-75v-64h-128V512h384v384zM576 768q-26 0-45 19t-19 45q0 26 19 45t45 19q26 0 45-19t19-45q0-26-19-45t-45-19zm384 1152q26 0 45-19t19-45q0-26-19-45t-45-19q-26 0-45 19t-19 45q0 26 19 45t45 19zm448-1280h-128v128h128V640z" })
      ]
    }
  );
}
var Usb_default = SvgUsb;

// src/components/Icon/icons/UsbDevice.tsx
import { jsx as jsx988, jsxs as jsxs981 } from "react/jsx-runtime";
function SvgUsbDevice({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs981(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx988("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx988("path", { d: "M768 256h128v128H768V256zm384 0v128h-128V256h128zm256 256q27 0 50 10t40 27 28 41 10 50v1280q0 27-10 50t-27 40-41 28-50 10H512q-27 0-50-10t-40-27-28-41-10-50V640q0-27 10-50t27-40 41-28 50-10V0h896v512zm-768 0h640V128H640v384zm768 128H512v1280h896V640z" })
      ]
    }
  );
}
var UsbDevice_default = SvgUsbDevice;

// src/components/Icon/icons/UserTypeAdult.tsx
import { jsx as jsx989, jsxs as jsxs982 } from "react/jsx-runtime";
function SvgUserTypeAdult({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs982(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx989("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx989("path", { d: "M1850 1200q46 26 82 62t62 79 40 93 14 102h-128q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100h-128q0-57 16-110t48-102q-27-40-62-72t-76-54-88-34-94-12q-80 0-149 30t-122 82-83 123-30 149H512q0-100 38-193-35-30-77-46t-89-17q-53 0-99 20t-82 55-55 81-20 100H0q0-50 12-97t37-90 58-78 76-62q-57-46-88-111T64 960q0-66 25-124t68-101 102-69 125-26q66 0 124 25t101 69 69 102 26 124q0 73-31 138t-89 112l30 20q35-51 87-92t110-68q-51-45-79-107t-28-131q0-66 25-124t68-101 102-69 125-26q66 0 124 25t101 69 69 102 26 124q0 69-28 131t-79 107q118 55 196 159l45-29q-33-35-51-81t-19-95q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100q0 49-18 95t-52 81zM192 960q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75zm640-128q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75zm704 192q0 27 10 50t27 40 41 28 50 10q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50zM512 1664h768v128H512v-128z" })
      ]
    }
  );
}
var UserTypeAdult_default = SvgUserTypeAdult;

// src/components/Icon/icons/UserTypeChild.tsx
import { jsx as jsx990, jsxs as jsxs983 } from "react/jsx-runtime";
function SvgUserTypeChild({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs983(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx990("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx990("path", { d: "M1344 1324q-27-40-62-72t-76-54-88-34-94-12q-80 0-149 30t-122 82-83 123-30 149H512q0-100 38-193-35-30-77-46t-89-17q-53 0-99 20t-82 55-55 81-20 100H0q0-50 12-97t37-90 58-78 76-62q-57-46-88-111T64 960q0-66 25-124t68-101 102-69 125-26q66 0 124 25t101 69 69 102 26 124q0 73-31 138t-89 112l30 20q35-51 87-92t110-68q-51-45-79-107t-28-131q0-66 25-124t68-101 102-69 125-26q66 0 124 25t101 69 69 102 26 124q0 69-28 131t-79 107q118 55 196 159l45-29q-33-35-51-81t-19-95q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100q0 49-18 95t-52 81q46 26 82 62t62 79 40 93 14 102h-128q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100h-128q0-57 16-110t48-102zm192-300q0 27 10 50t27 40 41 28 50 10q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50zM192 960q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75zm640-128q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75zm448 831h768v129h-768v-129z" })
      ]
    }
  );
}
var UserTypeChild_default = SvgUserTypeChild;

// src/components/Icon/icons/UserTypeTeen.tsx
import { jsx as jsx991, jsxs as jsxs984 } from "react/jsx-runtime";
function SvgUserTypeTeen({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs984(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx991("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx991("path", { d: "M1850 1200q46 26 82 62t62 79 40 93 14 102h-128q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100h-128q0-57 16-110t48-102q-27-40-62-72t-76-54-88-34-94-12q-80 0-149 30t-122 82-83 123-30 149H512q0-100 38-193-35-30-77-46t-89-17q-53 0-99 20t-82 55-55 81-20 100H0q0-50 12-97t37-90 58-78 76-62q-57-46-88-111T64 960q0-66 25-124t68-101 102-69 125-26q66 0 124 25t101 69 69 102 26 124q0 73-31 138t-89 112l30 20q35-51 87-92t110-68q-51-45-79-107t-28-131q0-66 25-124t68-101 102-69 125-26q66 0 124 25t101 69 69 102 26 124q0 69-28 131t-79 107q118 55 196 159l45-29q-33-35-51-81t-19-95q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100q0 49-18 95t-52 81zM192 960q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75zm640-128q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75zm704 192q0 27 10 50t27 40 41 28 50 10q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50zM0 1664h640v128H0v-128z" })
      ]
    }
  );
}
var UserTypeTeen_default = SvgUserTypeTeen;

// src/components/Icon/icons/VerifiedGameClub.tsx
import { jsx as jsx992, jsxs as jsxs985 } from "react/jsx-runtime";
function SvgVerifiedGameClub({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs985(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx992("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx992("path", { d: "M1408 769q0 25-8 48t-25 42l-457 511q-16 17-37 27t-45 11q-23 0-45-11t-37-28l-208-231q-17-19-25-43t-9-49q0-24 8-47t24-41 37-30 47-11q26 0 45 10t37 29l126 140 375-419q15-17 37-27t45-10q26 0 47 11t36 29 23 42 9 47z" })
      ]
    }
  );
}
var VerifiedGameClub_default = SvgVerifiedGameClub;

// src/components/Icon/icons/VerifiedGameClubBackplate.tsx
import { jsx as jsx993, jsxs as jsxs986 } from "react/jsx-runtime";
function SvgVerifiedGameClubBackplate({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs986(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx993("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx993("path", { d: "M1920 708l-94 316 94 316-260 200-107 312-326 7-267 189-267-189H367l-107-318L0 1340l94-316L0 708l260-200 107-312 325-7L960 0l267 189h326l107 318 260 201z" })
      ]
    }
  );
}
var VerifiedGameClubBackplate_default = SvgVerifiedGameClubBackplate;

// src/components/Icon/icons/VerifiedGameClubBackplateInline.tsx
import { jsx as jsx994, jsxs as jsxs987 } from "react/jsx-runtime";
function SvgVerifiedGameClubBackplateInline({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs987(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx994("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx994("path", { d: "M1536 1001l-76 247 76 247-208 156-85 244H982l-214 153-214-148H293l-85-249L0 1495l76-247-76-247 208-156 85-244h261l214-153 214 148h261l85 249 208 156z" })
      ]
    }
  );
}
var VerifiedGameClubBackplateInline_default = SvgVerifiedGameClubBackplateInline;

// src/components/Icon/icons/VerifiedGameClubInline.tsx
import { jsx as jsx995, jsxs as jsxs988 } from "react/jsx-runtime";
function SvgVerifiedGameClubInline({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs988(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx995("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx995("path", { d: "M1126 1048q0 21-6 38t-20 33l-366 399q-14 15-29 22t-36 8q-19 0-36-8t-30-22l-166-181q-27-30-27-72 0-18 6-35t19-32 28-24 35-9q23 0 38 6t32 23l101 110 300-327q27-29 65-29 21 0 38 8t29 22 18 32 7 38z" })
      ]
    }
  );
}
var VerifiedGameClubInline_default = SvgVerifiedGameClubInline;

// src/components/Icon/icons/VerifiedGameClubSolid.tsx
import { jsx as jsx996, jsxs as jsxs989 } from "react/jsx-runtime";
function SvgVerifiedGameClubSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs989(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx996("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx996("path", { d: "M1920 708l-94 316 94 316-260 200-107 312-325 7-268 189-267-189H367l-107-319L0 1340l94-316L0 708l260-200 107-312 325-7L960 0l267 189h326l107 318 260 201zm-512 61q0-24-8-47t-23-42-36-29-48-11q-23 0-45 10t-37 27l-375 419-126-140q-18-20-36-29t-46-9q-26 0-47 10t-37 29-23 41-9 48q0 25 8 49t26 43l208 232q15 17 37 27t45 11q24 0 45-10t37-28l457-511q17-18 25-42t8-48z" })
      ]
    }
  );
}
var VerifiedGameClubSolid_default = SvgVerifiedGameClubSolid;

// src/components/Icon/icons/VerifiedGameClubSolidInline.tsx
import { jsx as jsx997, jsxs as jsxs990 } from "react/jsx-runtime";
function SvgVerifiedGameClubSolidInline({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs990(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx997("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx997("path", { d: "M1536 1001l-75 247 75 247-208 156-86 244H982l-214 153-214-148H293l-85-249L0 1495l75-247-75-247 208-156 85-244h261l214-153 214 148h260l86 248 208 157zm-409 48q0-19-7-37t-19-33-29-22-37-9q-39 0-66 29l-300 327-101-109q-14-16-29-23t-37-7q-21 0-38 8t-29 22-18 32-7 38q0 42 27 72l166 181q13 14 30 22t36 8q19 0 36-8t30-22l365-399q27-30 27-70z" })
      ]
    }
  );
}
var VerifiedGameClubSolidInline_default = SvgVerifiedGameClubSolidInline;

// src/components/Icon/icons/VibrateController.tsx
import { jsx as jsx998, jsxs as jsxs991 } from "react/jsx-runtime";
function SvgVibrateController({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs991(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx998("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx998("path", { d: "M960 704q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45zm-832 704q0 27 7 60t24 62 40 50 57 20l307-301q18-18 43-32t53-24 56-16 53-8v130q-14 2-30 5t-33 9-32 13-25 18l-299 299q-17 17-43 26t-50 9q-62 0-109-29t-80-76-50-104-17-111q0-28 1-60t6-64 11-63 17-58l225-609q8-23 24-43t36-35v-66q44-23 85-40t84-28 88-16 95-6q33 0 60 10t51 22 42 22 39 10h320q19 0 39-10t43-22 50-22 60-10q50 0 95 5t87 17 84 28 86 40v66q21 15 34 34t24 40 18 45 16 45h-137q-9-25-14-37t-12-20-20-13-37-16v-66q-54-21-110-30t-114-10q-19 0-39 10t-43 22-50 22-60 10H864q-33 0-60-10t-51-22-42-22-39-10q-57 0-113 9t-111 31v66q-18 8-39 17t-30 30l-223 605q-17 44-22 99t-6 103zm1811-239l90 91q-22 22-31 45t-14 48-8 51-10 54-24 58-48 61q-32 32-61 48t-57 23-54 10-51 7-48 15-46 33q-22 22-32 45t-14 47-7 51-11 54-24 57-48 62l-91-90q22-22 32-45t14-48 8-51 10-54 24-58 48-61q32-32 61-48t58-24 54-11 51-7 48-14 45-32q22-22 31-45t14-47 8-51 10-55 24-57 49-62zm-724 634l-91-90q22-23 32-46t14-48 7-51 11-53 24-57 48-62q32-32 62-48t58-25 54-10 50-7 48-14 45-32q21-21 31-44t14-48 7-51 11-54 24-58 49-62l90 91q-22 22-31 44t-15 47-7 51-11 55-24 57-48 62q-32 32-62 48t-58 25-54 10-51 7-48 14-44 32q-22 22-31 45t-14 47-7 51-11 54-24 58-48 62zm-227-226l-90-91q22-22 31-45t14-47 8-51 10-55 24-57 49-62q31-31 61-47t58-24 54-11 51-7 48-14 44-32q22-22 32-45t14-49 8-51 10-54 24-57 48-61l91 90q-22 22-31 45t-14 47-8 51-10 55-24 57-49 62q-32 32-62 48t-57 24-54 11-51 7-48 14-45 32q-22 22-31 45t-14 47-8 51-10 55-24 57-49 62z" })
      ]
    }
  );
}
var VibrateController_default = SvgVibrateController;

// src/components/Icon/icons/Video.tsx
import { jsx as jsx999, jsxs as jsxs992 } from "react/jsx-runtime";
function SvgVideo({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs992(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx999("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx999("path", { d: "M1953 256q45 0 70 31t25 74v1326q0 43-25 74t-70 31H100q-45 0-72-30t-28-75V361q0-44 27-74t73-31h1853zm-46 169H140v1198h1767V425zm-883 939q-70 0-132-26t-108-73-73-108-27-132q0-70 27-132t73-108 108-72 132-27q70 0 132 26t108 73 73 108 27 132q0 70-27 132t-73 108-108 72-132 27zm-92-150l256-196-256-176v372z" })
      ]
    }
  );
}
var Video_default = SvgVideo;

// src/components/Icon/icons/Video1.tsx
import { jsx as jsx1000, jsxs as jsxs993 } from "react/jsx-runtime";
function SvgVideo1({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs993(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1000("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1000("path", { d: "M896 736l384 288-384 288V736zM0 384h2048v1280H0V384zm1920 1152V512H128v1024h1792z" })
      ]
    }
  );
}
var Video1_default = SvgVideo1;

// src/components/Icon/icons/Video11.tsx
import { jsx as jsx1001, jsxs as jsxs994 } from "react/jsx-runtime";
function SvgVideo11({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs994(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1001("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1001("path", { d: "M2048 504v1040l-512-256v248H0V512h1536v248l512-256zm-640 904V640H128v768h1280zm512-71V711l-384 193v240l384 193z" })
      ]
    }
  );
}
var Video11_default = SvgVideo11;

// src/components/Icon/icons/VideoBanned.tsx
import { jsx as jsx1002, jsxs as jsxs995 } from "react/jsx-runtime";
function SvgVideoBanned({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs995(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1002("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1002("path", { d: "M1600 1152q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm-320 448q0 66 25 124t68 102 102 69 125 25q47 0 92-13t84-40l-443-443q-26 39-39 84t-14 92zm587 176q26-39 39-84t14-92q0-66-25-124t-69-101-102-69-124-26q-47 0-92 13t-84 40l443 443zM384 768H256V640h128v128zm0 256H256V896h128v128zm-128 128h128v128H256v-128zm1536-384h-128V640h128v128zm-128 128h128v128h-128V896zm384-640v961q-28-33-59-62t-69-52V384h-128v128h-128V384H384v128H256V384H128v1152h128v-128h128v128h640v128H0V256h2048z" })
      ]
    }
  );
}
var VideoBanned_default = SvgVideoBanned;

// src/components/Icon/icons/VideoCamera.tsx
import { jsx as jsx1003, jsxs as jsxs996 } from "react/jsx-runtime";
function SvgVideoCamera({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs996(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1003("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1003("path", { d: "M1024 1664v128h256v128H640v-128h256v-128H256V256h1408v1408h-640zm-640-128h1152V384H384v1152zM960 512q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm0 768q66 0 124-25t101-68 69-102 26-125q0-66-25-124t-69-101-102-69-124-26q-66 0-124 25t-102 69-69 102-25 124q0 66 25 124t68 102 102 69 125 25z" })
      ]
    }
  );
}
var VideoCamera_default = SvgVideoCamera;

// src/components/Icon/icons/VideoCameraDisconnected.tsx
import { jsx as jsx1004, jsxs as jsxs997 } from "react/jsx-runtime";
function SvgVideoCameraDisconnected({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs997(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1004("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1004("path", { d: "M1536 896V384H384v1152h1152v128h-512v128h256v128H640v-128h256v-128H256V256h1408v640h-128zM512 960q0-93 35-174t96-143 142-96 175-35q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175zm768 0q0-66-25-124t-69-101-102-69-124-26q-66 0-124 25t-102 69-69 102-25 124q0 66 25 124t68 102 102 69 125 25q66 0 124-25t101-68 69-102 26-125zm512 64v640h-128v-640h128zm-128 768h128v128h-128v-128z" })
      ]
    }
  );
}
var VideoCameraDisconnected_default = SvgVideoCameraDisconnected;

// src/components/Icon/icons/VideoGames.tsx
import { jsx as jsx1005, jsxs as jsxs998 } from "react/jsx-runtime";
function SvgVideoGames({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs998(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1005("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1005("path", { d: "M384 768H256V640h128v128zm0 256H256V896h128v128zm-128 128h128v128H256v-128zm128 384h320v128H0V256h2048v944l-128-128V384h-128v128h-128V384H384v128H256V384H128v1152h128v-128h128v128zm1408-768h-128V640h128v128zm-128 128h128v128h-128V896zm-256 528q20 0 34 14t14 34q0 20-14 34t-34 14q-20 0-34-14t-14-34q0-20 14-34t34-14zm448-163q15 15 33 48t37 75 37 90 34 92 25 82 15 57q5 28 8 55t3 57q0 39-8 76t-31 70q-11 16-26 31t-33 28-38 19-40 7q-23 0-42-9t-36-26l-207-207q-14-14-35-14h-288q-21 0-35 14l-208 207q-17 16-35 25t-42 10q-20 0-40-7t-38-19-33-27-26-32q-22-33-30-70t-9-76q0-29 3-56t8-56q4-21 14-57t26-81 33-92 37-90 37-75 34-49v-43q55-32 117-49t126-17q23 0 42 6t38 15 36 21 38 22h102q20-10 38-21t36-21 37-16 43-6q64 0 126 17t117 49v43zm22 655q27-17 34-43t8-56q0-23-2-45t-7-44q-15-80-47-159t-65-154q-5-12-11-27t-14-27q-7-10-21-17t-25-12v-32q-57-20-115-20h-6q-7 4-25 14t-38 22-38 19-27 9h-142q-8 0-26-8t-39-20-38-21-25-15q-65 0-121 20v32q-11 5-25 11t-21 18q-8 11-14 26t-11 28q-33 74-65 153t-47 160q-4 22-6 44t-3 45q0 29 7 55t35 44l201-202q24-24 57-37t68-13h288q35 0 67 13t58 38l201 201z" })
      ]
    }
  );
}
var VideoGames_default = SvgVideoGames;

// src/components/Icon/icons/VideoNewRelease.tsx
import { jsx as jsx1006, jsxs as jsxs999 } from "react/jsx-runtime";
function SvgVideoNewRelease({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs999(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1006("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1006("path", { d: "M384 768H256V640h128v128zm0 256H256V896h128v128zm-128 128h128v128H256v-128zm1408-512h128v128h-128V640zm0 256h128v128h-128V896zm-128 256h128v256h-128v-256zm-207 86l181 181-91 91-181-181 91-91zm79 426h-256v-128h256v128zm11 26l91 91-181 181-91-91 181-181zm117 102h128v256h-128v-256zm245-102l181 181-91 91-181-181 91-91zm11-154h256v128h-256v-128zm-102-117l181-181 91 91-181 181-91-91zm358-1163v958q-57-66-128-112V384h-128v128h-128V384H384v128H256V384H128v1152h128v-128h128v128h640v128H0V256h2048z" })
      ]
    }
  );
}
var VideoNewRelease_default = SvgVideoNewRelease;

// src/components/Icon/icons/VideoPopular.tsx
import { jsx as jsx1007, jsxs as jsxs1000 } from "react/jsx-runtime";
function SvgVideoPopular({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1000(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1007("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1007("path", { d: "M384 640v128H256V640h128zm0 256v128H256V896h128zm-128 384v-128h128v128H256zm1536-640v128h-128V640h128zm-128 384V896h128v128h-128zM0 256h2048v1088h-128V384h-128v128h-128V384H384v128H256V384H128v1152h128v-128h128v128h642l164 128H0V256zm1703 1216h345l-276 216 116 360-288-225-288 225 116-360-276-216h345l103-320 103 320z" })
      ]
    }
  );
}
var VideoPopular_default = SvgVideoPopular;

// src/components/Icon/icons/VideoProvider.tsx
import { jsx as jsx1008, jsxs as jsxs1001 } from "react/jsx-runtime";
function SvgVideoProvider({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1001(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1008("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1008("path", { d: "M1317 761q0-72-27-136t-75-111-112-75-136-28V283q99 0 186 37t152 103 102 152 38 186h-128zm276 0q0-86-22-166t-63-149-98-127-127-98-150-63-166-23V7q104 0 200 27t180 76 153 118 118 152 76 180 27 201h-128zm-693 715q-89 0-173-22t-157-64-135-100-105-131-68-155-24-174q0-134 50-248t145-208l44-44 421 409 94-93q0-39 26-66t66-28q19 0 36 7t29 19 20 30 7 36q0 20-7 36t-20 29-30 20-36 7l-93 93 425 412-48 46q-97 93-215 141t-252 48zM480 511q-55 68-84 149t-30 170q0 110 43 204t116 164 170 110 205 40q89 0 173-27t155-82L480 511zm1504 1281q26 0 45 19t19 45q0 26-19 45t-45 19h-320v128h-576q-30 0-58-9t-53-26-42-40-28-53H0v-128h907q10-29 28-52t42-41 52-26 59-9h576v128h320zm-448 0h-448q-26 0-45 19t-19 45q0 26 19 45t45 19h448v-128z" })
      ]
    }
  );
}
var VideoProvider_default = SvgVideoProvider;

// src/components/Icon/icons/VideoRecommendations.tsx
import { jsx as jsx1009, jsxs as jsxs1002 } from "react/jsx-runtime";
function SvgVideoRecommendations({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1002(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1009("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1009("path", { d: "M0 256h2048v960l-128-128V384h-128v128h-128V384H384v128H256V384H128v1152h128v-128h128v128h704l-128 128H0V256zm384 384v128H256V640h128zm0 256v128H256V896h128zm-128 384v-128h128v128H256zm1536-640v128h-128V640h128zm-128 384V896h128v128h-128zm0 256v-128h128v128h-128zm-192 486l467-467 90 90-557 558-301-302 90-90 211 211z" })
      ]
    }
  );
}
var VideoRecommendations_default = SvgVideoRecommendations;

// src/components/Icon/icons/ViewMenuDlSet.tsx
import { jsx as jsx1010, jsxs as jsxs1003 } from "react/jsx-runtime";
function SvgViewMenuDlSet({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1003(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1010("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1010("path", { d: "M1600 640q66 0 124 25t101 69 69 102 26 124q0 66-25 124t-69 102-102 69-124 25q-66 0-124-25t-102-68-69-102-25-125q0-66 25-124t68-101 102-69 125-26zm0 512q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15zM320 640q66 0 124 25t101 69 69 102 26 124q0 66-25 124t-69 102-102 69-124 25q-66 0-124-25t-102-68-69-102T0 960q0-66 25-124t68-101 102-69 125-26zm0 512q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15z" })
      ]
    }
  );
}
var ViewMenuDlSet_default = SvgViewMenuDlSet;

// src/components/Icon/icons/ViewProfileDetails.tsx
import { jsx as jsx1011, jsxs as jsxs1004 } from "react/jsx-runtime";
function SvgViewProfileDetails({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1004(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1011("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1011("path", { d: "M740 1077q65 33 117 81t90 108 57 128 20 142H896q0-79-30-149t-82-122-123-83-149-30q-80 0-149 30t-122 82-83 123-30 149H0q0-73 20-141t57-128 89-108 118-82q-74-55-115-136t-41-173q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149q0 92-41 173t-115 136zM256 768q0 53 20 99t55 82 81 55 100 20q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100zm1792-384v128h-896V384h896zm-896 512h896v128h-896V896zm0 512h896v128h-896v-128z" })
      ]
    }
  );
}
var ViewProfileDetails_default = SvgViewProfileDetails;

// src/components/Icon/icons/ViewProfileDetailsMirrored.tsx
import { jsx as jsx1012, jsxs as jsxs1005 } from "react/jsx-runtime";
function SvgViewProfileDetailsMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1005(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1012("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1012("path", { d: "M1308 1077q-65 33-117 81t-90 108-57 128-20 142h128q0-79 30-149t82-122 123-83 149-30q80 0 149 30t122 82 83 123 30 149h128q0-73-20-141t-57-128-89-108-118-82q74-55 115-136t41-173q0-79-30-149t-82-122-122-83-150-30q-79 0-149 30t-122 82-83 123-30 149q0 92 41 173t115 136zm484-309q0 53-20 99t-55 82-81 55-100 20q-53 0-99-20t-82-55-55-81-20-100q0-53 20-99t55-82 81-55 100-20q53 0 99 20t82 55 55 81 20 100zM0 384v128h896V384H0zm896 512H0v128h896V896zm0 512H0v128h896v-128z" })
      ]
    }
  );
}
var ViewProfileDetailsMirrored_default = SvgViewProfileDetailsMirrored;

// src/components/Icon/icons/VirtualKeyboardClose.tsx
import { jsx as jsx1013, jsxs as jsxs1006 } from "react/jsx-runtime";
function SvgVirtualKeyboardClose({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1006(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1013("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1013("path", { d: "M1783 384q30 0 55 11t43 32 28 46 11 55v864q0 29-10 55t-29 46-43 31-55 12H137q-30 0-55-11t-43-32-28-46-11-55V528q0-29 10-55t29-46 43-31 55-12h1646zm9 144q0-3-2-9t-7-7H137q-5 0-7 6t-2 10v864q0 3 2 9t7 7h1646q5 0 7-6t2-10V528zm-605 1107l90 90-317 318-317-318 90-90 227 227 227-227z" })
      ]
    }
  );
}
var VirtualKeyboardClose_default = SvgVirtualKeyboardClose;

// src/components/Icon/icons/Volume.tsx
import { jsx as jsx1014, jsxs as jsxs1007 } from "react/jsx-runtime";
function SvgVolume({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1007(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1014("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1014("path", { d: "M1673 119q90 90 160 195t117 220 72 239 25 251q0 128-24 251t-72 238-118 221-160 195l-90-90q81-81 144-175t105-199 65-215 23-226q0-115-22-226t-65-215-106-198-144-176l90-90zm-271 271q127 128 194 291t68 343q0 180-67 343t-195 291l-91-91q109-109 166-249t58-294q0-154-57-294t-167-249l91-91zm-272 272q73 73 111 166t39 196q0 103-38 196t-112 166l-91-90q55-55 84-124t29-148q0-77-29-147t-84-124l91-91zM677 256h91v1536h-91l-384-384H0V640h293l384-384zm-37 219L346 768H128v512h218l294 294V475z" })
      ]
    }
  );
}
var Volume_default = SvgVolume;

// src/components/Icon/icons/Volume0.tsx
import { jsx as jsx1015, jsxs as jsxs1008 } from "react/jsx-runtime";
function SvgVolume0({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1008(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1015("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1015("path", { d: "M293 640l384-384h91v1536h-90l-385-384H0V640h293zm347 933V475L347 768H128v512h219l293 293z" })
      ]
    }
  );
}
var Volume0_default = SvgVolume0;

// src/components/Icon/icons/Volume1.tsx
import { jsx as jsx1016, jsxs as jsxs1009 } from "react/jsx-runtime";
function SvgVolume1({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1009(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1016("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1016("path", { d: "M1040 752l90-90q73 73 111 166t39 196q0 103-38 196t-112 166l-90-90q54-54 83-124t29-148q0-77-29-147t-83-125zM293 640l384-384h91v1536h-90l-385-384H0V640h293zm347 933V475L347 768H128v512h219l293 293z" })
      ]
    }
  );
}
var Volume1_default = SvgVolume1;

// src/components/Icon/icons/Volume2.tsx
import { jsx as jsx1017, jsxs as jsxs1010 } from "react/jsx-runtime";
function SvgVolume2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1010(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1017("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1017("path", { d: "M1664 1024q0 180-68 343t-194 291l-91-91q109-109 167-249t58-294q0-154-58-294t-167-249l91-91q126 128 194 291t68 343zm-624-272l90-90q73 73 111 166t39 196q0 103-38 196t-112 166l-90-90q54-54 83-124t29-148q0-77-29-147t-83-125zM293 640l384-384h91v1536h-90l-385-384H0V640h293zm347 933V475L347 768H128v512h219l293 293z" })
      ]
    }
  );
}
var Volume2_default = SvgVolume2;

// src/components/Icon/icons/Volume3.tsx
import { jsx as jsx1018, jsxs as jsxs1011 } from "react/jsx-runtime";
function SvgVolume3({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1011(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1018("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1018("path", { d: "M2048 1024q0 128-25 251t-72 239-118 220-160 195l-91-91q81-81 144-175t106-198 65-215 22-226q0-115-22-226t-65-214-106-198-144-176l91-91q90 90 160 195t117 220 73 239 25 251zm-384 0q0 180-68 343t-194 291l-91-91q109-109 167-249t58-294q0-154-58-294t-167-249l91-91q126 128 194 291t68 343zm-624-272l90-90q73 73 111 166t39 196q0 103-38 196t-112 166l-90-90q54-54 83-124t29-148q0-77-29-147t-83-125zM293 640l384-384h91v1536h-90l-385-384H0V640h293zm347 933V475L347 768H128v512h219l293 293z" })
      ]
    }
  );
}
var Volume3_default = SvgVolume3;

// src/components/Icon/icons/VolumeDisabled.tsx
import { jsx as jsx1019, jsxs as jsxs1012 } from "react/jsx-runtime";
function SvgVolumeDisabled({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1012(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1019("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1019("path", { d: "M1344 1152q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm-320 448q0 66 25 124t68 102 102 69 125 25q47 0 92-13t84-40l-443-443q-26 39-39 84t-14 92zm587 176q26-39 39-84t14-92q0-66-25-124t-69-101-102-69-124-26q-47 0-92 13t-84 40l443 443zM640 768v512h188q-19 30-33 62t-26 66H512V640h293l384-384h91v743q-33 3-65 10t-63 19V475L858 768H640z" })
      ]
    }
  );
}
var VolumeDisabled_default = SvgVolumeDisabled;

// src/components/Icon/icons/VolumeDisabled2.tsx
import { jsx as jsx1020, jsxs as jsxs1013 } from "react/jsx-runtime";
function SvgVolumeDisabled2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1013(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1020("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1020("path", { d: "M1344 1152q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm-320 448q0 66 25 124t68 102 102 69 125 25q47 0 92-13t84-40l-443-443q-26 39-39 84t-14 92zm587 176q26-39 39-84t14-92q0-66-25-124t-69-101-102-69-124-26q-47 0-92 13t-84 40l443 443zM640 768v512h188q-19 30-33 62t-26 66H512V640h293l384-384h91v743q-33 3-65 10t-63 19V475L858 768H640z" })
      ]
    }
  );
}
var VolumeDisabled2_default = SvgVolumeDisabled2;

// src/components/Icon/icons/VolumeMute.tsx
import { jsx as jsx1021, jsxs as jsxs1014 } from "react/jsx-runtime";
function SvgVolumeMute({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1014(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1021("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1021("path", { d: "M1189 256h91v1536h-90l-385-384H512V640h293l384-384zm-37 1318V475L858 768H640v512h218l294 294z" })
      ]
    }
  );
}
var VolumeMute_default = SvgVolumeMute;

// src/components/Icon/icons/Warning.tsx
import { jsx as jsx1022, jsxs as jsxs1015 } from "react/jsx-runtime";
function SvgWarning({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1015(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1022("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1022("path", { d: "M1920 1920H0L960 0l960 1920zM207 1792h1506L960 286 207 1792zm817-1024v640H896V768h128zm-128 768h128v128H896v-128z" })
      ]
    }
  );
}
var Warning_default = SvgWarning;

// src/components/Icon/icons/WelcomeApp.tsx
import { jsx as jsx1023, jsxs as jsxs1016 } from "react/jsx-runtime";
function SvgWelcomeApp({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1016(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1023("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1023("path", { d: "M1792 512H0l384-256h1024l384 256zm0 601q13 6 25 7t24 4 20 10 16 24l150 426q12 35 16 77t5 80q0 27-7 58t-24 59-40 44-57 18q-7 0-17-3t-15-8l-203-221q-10-11-26-19t-34-14-36-9-32-3h-298q-14 0-32 3t-37 8-33 14-26 20l-203 221q-5 5-15 8t-17 3q-33 0-57-17t-40-45-23-58-8-59q0-37 4-79t17-78l150-426q6-17 15-24t20-10 24-4 26-7v-44q21-12 37-21t33-14 35-7 44-3q23 0 43 10t38 23 29 22 18 11h214q6 0 18-10t29-23 37-22 44-11q25 0 43 2t35 8 33 14 38 21v44zm-384 231q26 0 45-19t19-45q0-26-19-45t-45-19q-26 0-45 19t-19 45q0 26 19 45t45 19zm-544-326q-27 15-47 42t-31 56l-58 164H0v-256h768V896H0V640h1792v256h-651q-45 0-79 7t-66 20-63 31-69 40v24z" })
      ]
    }
  );
}
var WelcomeApp_default = SvgWelcomeApp;

// src/components/Icon/icons/WheelArt160.tsx
import { jsx as jsx1024, jsxs as jsxs1017 } from "react/jsx-runtime";
function SvgWheelArt160({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1017(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1024("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1024("path", { d: "M1024 90q129 0 248 33t223 95 189 146 147 189 94 223 34 248q0 129-33 248t-95 223-146 189-190 147-223 94-248 34q-129 0-248-33t-223-95-189-146-146-190-94-223-34-248q0-129 33-248t95-223 146-189 189-146 223-94 248-34zm0 77q-114 0-221 29t-200 82-171 127-135 166-91 196-39 219h1714q-5-114-39-219t-91-196-134-165-171-128-201-82-221-29zm-857 896q5 110 37 212t86 192 128 163 163 128 192 86 213 37v-665q0-32-12-60t-33-48-49-33-60-12H167zm896 818q110-5 212-37t192-86 163-128 128-163 86-191 37-213h-665q-32 0-60 12t-48 32-33 49-12 60v665z" })
      ]
    }
  );
}
var WheelArt160_default = SvgWheelArt160;

// src/components/Icon/icons/WheelArt224.tsx
import { jsx as jsx1025, jsxs as jsxs1018 } from "react/jsx-runtime";
function SvgWheelArt224({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1018(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1025("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1025("path", { d: "M1024 101q127 0 245 33t220 93 187 144 145 187 93 221 33 245q0 127-33 245t-93 220-144 187-187 145-221 93-245 33q-127 0-245-33t-220-93-187-144-145-187-93-221-33-245q0-127 33-245t93-220 144-187 187-145 221-93 245-33zm0 54q-117 0-226 30t-204 84-175 131-136 170-90 202-37 225h1736q-4-117-37-225t-90-201-136-170-174-131-205-85-226-30zm-868 896q3 114 35 220t87 198 132 169 168 131 198 88 221 35v-676q0-34-13-64t-35-52-53-36-64-13H156zm895 841q114-3 220-35t198-87 169-132 131-168 87-198 36-221h-676q-34 0-64 13t-52 35-36 53-13 64v676z" })
      ]
    }
  );
}
var WheelArt224_default = SvgWheelArt224;

// src/components/Icon/icons/Wifi.tsx
import { jsx as jsx1026, jsxs as jsxs1019 } from "react/jsx-runtime";
function SvgWifi({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1019(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1026("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1026("path", { d: "M1024 2048q0-106 27-204t78-184 120-155 155-120 183-77 205-28v128q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170h-128zm-384 0q0-159 41-306t116-276 180-233 233-180 275-116 307-41v128q-141 0-272 36t-244 104-207 160-161 207-103 245-37 272H640zm-384 0q0-212 55-408t155-367 240-311 311-240 367-155 408-55v128q-194 0-373 50t-336 142-286 221-220 285-142 336-51 374H256zm1344-384q40 0 75 15t61 41 41 61 15 75q0 40-15 75t-41 61-61 41-75 15q-40 0-75-15t-61-41-41-61-15-75q0-40 15-75t41-61 61-41 75-15z" })
      ]
    }
  );
}
var Wifi_default = SvgWifi;

// src/components/Icon/icons/Wifi1.tsx
import { jsx as jsx1027, jsxs as jsxs1020 } from "react/jsx-runtime";
function SvgWifi1({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1020(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1027("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1027("path", { d: "M1792 1856q0 40-15 75t-41 61-61 41-75 15q-40 0-75-15t-61-41-41-61-15-75q0-40 15-75t41-61 61-41 75-15q40 0 75 15t61 41 41 61 15 75z" })
      ]
    }
  );
}
var Wifi1_default = SvgWifi1;

// src/components/Icon/icons/Wifi2.tsx
import { jsx as jsx1028, jsxs as jsxs1021 } from "react/jsx-runtime";
function SvgWifi2({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1021(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1028("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1028("path", { d: "M1024 2048q0-106 27-204t78-184 120-155 155-120 183-77 205-28v128q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170h-128zm576-384q40 0 75 15t61 41 41 61 15 75q0 40-15 75t-41 61-61 41-75 15q-40 0-75-15t-61-41-41-61-15-75q0-40 15-75t41-61 61-41 75-15z" })
      ]
    }
  );
}
var Wifi2_default = SvgWifi2;

// src/components/Icon/icons/Wifi3.tsx
import { jsx as jsx1029, jsxs as jsxs1022 } from "react/jsx-runtime";
function SvgWifi3({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1022(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1029("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1029("path", { d: "M1152 2048h-128q0-106 27-204t78-184 120-155 155-120 183-77 205-28v128q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170zm-384 0H640q0-159 41-306t116-276 180-233 233-180 275-116 307-41v128q-141 0-272 36t-244 104-207 160-161 207-103 245-37 272zm1024-192q0 40-15 75t-41 61-61 41-75 15q-40 0-75-15t-61-41-41-61-15-75q0-40 15-75t41-61 61-41 75-15q40 0 75 15t61 41 41 61 15 75z" })
      ]
    }
  );
}
var Wifi3_default = SvgWifi3;

// src/components/Icon/icons/WifiWarning4.tsx
import { jsx as jsx1030, jsxs as jsxs1023 } from "react/jsx-runtime";
function SvgWifiWarning4({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1023(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1030("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1030("path", { d: "M576 896l576 1152H0L576 896zm395 1040l-395-790-395 790h790zm-459-528h128v320H512v-320zm0 384h128v128H512v-128zm1216-256q40 0 75 15t61 41 41 61 15 75q0 40-15 75t-41 61-61 41-75 15q-40 0-75-15t-61-41-41-61-15-75q0-40 15-75t41-61 61-41 75-15zM763 913q109-126 241-224t280-166 308-103 328-36v128q-160 0-313 35t-294 103-263 164-225 222l-62-123zm191 381q80-123 186-220t230-166 264-104 286-36v128q-141 0-273 37t-249 106-212 168-164 222l-68-135zm221 442q32-128 102-235t170-185 220-121 253-43v128q-88 0-170 23t-153 64-129 100-100 130-65 153-23 170h-13l-92-184z" })
      ]
    }
  );
}
var WifiWarning4_default = SvgWifiWarning4;

// src/components/Icon/icons/WindowsLogo.tsx
import { jsx as jsx1031, jsxs as jsxs1024 } from "react/jsx-runtime";
function SvgWindowsLogo({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1024(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1031("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1031("path", { d: "M0 896V268l768-107v735H0zm896-753L1920 0v896H896V143zm0 1634v-753h1024v896L896 1777zM0 1652v-628h768v735L0 1652z" })
      ]
    }
  );
}
var WindowsLogo_default = SvgWindowsLogo;

// src/components/Icon/icons/WirelessDevice.tsx
import { jsx as jsx1032, jsxs as jsxs1025 } from "react/jsx-runtime";
function SvgWirelessDevice({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1025(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1032("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1032("path", { d: "M1611 1044q13 7 27 15t22 22q13 22 21 50t17 51q41 122 80 253t63 258q6 35 10 69t5 70q0 37-8 73t-29 69q-8 12-20 25t-28 24-31 18-31 7q-6 0-27-16t-49-40-61-54-63-57-56-49-37-29q-28-18-49-27t-42-15-45-6-60-1H828q-36 0-60 1t-45 5-42 15-49 28q-12 8-37 29t-55 48-64 57-62 54-49 41-27 16q-14 0-30-7t-31-19-27-24-20-24q-22-32-30-71t-8-78q0-33 4-66t10-67q23-122 60-247t77-243q9-29 19-62t25-59q8-14 21-22t28-15q1-3 2-10t2-15 4-15 4-9q4-6 23-15t41-19 42-17 29-10q54-12 112-12h18q10 0 17 3 8 3 21 10t29 16 28 14 20 6h392q7 0 20-6t27-14 28-15 22-11q7-2 16-2t16-1q59 0 115 12 8 2 28 9t42 17 41 19 24 16q2 3 4 9t3 14 3 15 2 11zm-587 270q41 0 69-28t29-70q0-41-28-69t-70-29q-41 0-69 28t-29 70q0 41 28 69t70 29zm0-802q49 0 99 9t98 28 91 46 77 63q19 19 19 46t-19 45-45 19q-24 0-45-18-62-54-127-82t-148-28q-83 0-148 28t-127 82q-20 18-45 18-26 0-45-19t-19-45q0-27 19-46 34-36 77-63t91-45 98-28 99-10zm496 64q-13 0-23-4t-21-13q-20-15-38-31t-38-30q-84-57-180-85t-196-29q-100 0-196 28t-180 86q-20 14-38 29t-38 32q-11 8-20 12t-24 5q-26 0-45-18t-19-46q0-14 5-25t15-22q16-17 35-32t39-29q102-73 221-110t245-38q126 0 245 37t221 111q19 14 38 29t36 32q10 11 15 22t5 25q0 27-18 45t-46 19zM352 416q-26 0-45-19t-19-45q0-14 4-23t14-21q31-36 71-69t84-64 91-55 90-43Q825 0 1024 0t382 77q43 18 89 43t91 55 85 63 71 70q9 11 13 20t5 24q0 26-19 45t-45 19q-14 0-24-5t-22-15q-26-23-50-46t-53-46q-114-86-247-131t-276-45q-143 0-276 45T501 304q-28 22-52 45t-51 47q-11 10-21 15t-25 5z" })
      ]
    }
  );
}
var WirelessDevice_default = SvgWirelessDevice;

// src/components/Icon/icons/Wristwear.tsx
import { jsx as jsx1033, jsxs as jsxs1026 } from "react/jsx-runtime";
function SvgWristwear({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1026(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1033("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1033("path", { d: "M1664 960q0 103-35 199t-102 174q-11 182-35 359t-59 356H743q-35-179-59-356t-35-359q-34-40-60-85t-44-96H384V768h161q19-55 49-104t70-93l-4-1q14-145 34-286T743 0h690q28 143 48 284t35 286l-4 1q74 80 113 180t39 209zM849 128q-15 83-27 166t-22 167q66-38 139-57t149-20q76 0 149 19t139 58q-10-84-22-167t-27-166H849zm239 384q-93 0-174 35t-142 96-96 142-36 175q0 93 35 174t96 142 142 96 175 36q93 0 174-35t142-96 96-142 36-175q0-93-35-174t-96-142-142-96-175-36zm239 1408q42-232 63-469-69 42-145 63t-157 22q-80 0-156-21t-146-64q21 237 63 469h478zm-47-896h-256V640h128v256h128v128z" })
      ]
    }
  );
}
var Wristwear_default = SvgWristwear;

// src/components/Icon/icons/Xbox360.tsx
import { jsx as jsx1034, jsxs as jsxs1027 } from "react/jsx-runtime";
function SvgXbox360({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1027(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1034("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1034("path", { d: "M1216 0q40 0 75 15t61 41 41 61 15 75v1664q0 40-15 75t-41 61-61 41-75 15H832q-40 0-75-15t-61-41-41-61-15-75V192q0-40 15-75t41-61 61-41 75-15h384zm64 192q0-26-19-45t-45-19H832q-26 0-45 19t-19 45v1664q0 26 19 45t45 19h384q26 0 45-19t19-45V192zm-256 1216q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10z" })
      ]
    }
  );
}
var Xbox360_default = SvgXbox360;

// src/components/Icon/icons/Xbox3603D.tsx
import { jsx as jsx1035, jsxs as jsxs1028 } from "react/jsx-runtime";
function SvgXbox3603D({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1028(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 64 64",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1035("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1035("path", { d: "M25.067.246l.183.09 14.98 8.63.273.142c.53.279.726.664.903 1.484l.143.69.059.222c.093.319.213.56.385.758l.015.014 6.182 3.571 1.685.977a1.8 1.8 0 011.043 1.423l-.007-.046c.032.066.05.144.05.232-.006.76-.037 1.375-.099 1.992l-.033.31-.022.18-.142 1.038-.182 1.408-.082.745-.085.95-.06.777-.07 1.126-.062 1.24-.041 1.01-.057 1.846-.036 1.635-.026 1.786-.02 2.46-.004 2.653.013 2.909.018 1.75.035 1.987.047 1.774.046 1.274.053 1.152.077 1.276.051.684.075.82.06.551.08.621.062.395.074.41.167.86.042.252.036.258.022.21.023.313.008.17.008.38v.214c-.076.772-.539 1.447-1.177 1.778l-.14.066-6.277 3.624a5.38 5.38 0 01-4.84.198.5.5 0 01-.119-.076l-.973-.566L13.897 49.37a1.814 1.814 0 01-.677-1.39c0-.426.035-.86.113-1.418l.042-.29.093-.567.368-2.112.108-.666.118-.779.123-.908.112-.932.1-.96c.032-.325.062-.655.09-.99l.04-.51.07-1.044.03-.538.052-1.109c.046-1.131.073-2.334.08-3.624l.001-.653-.006-1.78-.01-1.12-.015-1.072-.02-1.025-.039-1.456-.032-.918-.058-1.307-.044-.827-.05-.795-.054-.765-.059-.737-.097-1.06-.071-.678-.076-.66-.08-.643-.071-.538-.33-2.277-.09-.68a27.563 27.563 0 01-.226-3.283v.095a1.18 1.18 0 01-.125-.372l-.017-.142.002-2.435.009-.069c.056-.396.286-.744.598-.935l.12-.064 1.002-.58 2.918-1.68L22.581.331a2.779 2.779 0 012.3-.162l.186.077zM49.881 20.17l-.094.054-.147.069-2.72 1.57-3.547 2.054a5.38 5.38 0 01-3.573.593l-.258-.053-.039-.01.039.241.022.12.082.534.051.399.05.43.071.708.067.778.081 1.142.074 1.258.05 1.015.073 1.822.06 1.976.047 2.118.028 1.79.023 2.347.009 2.235c0 5.655-.235 11.311-.596 16.293l-.074.987v.149a5.5 5.5 0 01-.285 1.992l.227.068a4.378 4.378 0 002.794-.183l.238-.107.216-.112 6.323-3.647c.386-.165.663-.507.746-.876l.021-.124-.006-.411-.018-.358-.026-.29-.039-.287-.037-.22-.121-.623-.087-.46-.084-.513-.078-.576-.083-.736-.058-.615-.07-.91-.078-1.291-.054-1.163-.047-1.284-.047-1.787-.03-1.582-.024-2.178-.013-2.925.005-2.664.02-2.47.034-2.222.049-1.99.05-1.436.058-1.31.05-.905.074-1.11.06-.767.067-.713.072-.673.097-.771.238-1.765.021-.178.046-.447zm-35.524-9.996l.007.159c.025.525.066 1.03.123 1.553l.062.53.062.468.311 2.15.2 1.525.077.668.071.686.067.709.091 1.108.055.772.05.803.045.834.04.87.035.907.03.946.036 1.498.025 1.602.01 1.128.006 1.79-.002.631-.012 1.223-.01.592-.014.58-.037 1.124-.023.546-.054 1.06-.065 1.022-.037.498-.083.97-.094.941-.104.914-.056.449-.12.881-.117.77-.169 1.027-.356 2.044-.092.61-.06.514a7.359 7.359 0 00-.035.696c.003.2.08.391.178.511l.06.063 22.791 13.08 1.197.69a4.78 4.78 0 00.185-1.197v-.517l.036-.48.106-1.562.068-1.134.097-1.81.06-1.265.083-1.957.05-1.327.045-1.334.055-1.987.041-1.94.018-1.247.01-1.199-.004-1.548-.006-.79-.02-1.873-.012-.786-.058-2.742-.054-1.874-.05-1.419-.1-2.28-.08-1.452-.103-1.518-.09-1.06-.047-.443-.072-.509-.05-.292-.05-.254-.053-.214a2.519 2.519 0 00-.053-.174l-.036-.09-24.005-13.868zM48.824 55.82a2.707 2.707 0 01-1.092 2.027l-.154.108-4.673 2.7c-.83.473-1.62.022-1.62-.955.044-.803.441-1.541 1.08-2.02l.151-.105 4.687-2.71c.837-.483 1.622-.026 1.621.955zm-1.166-.348l-.08.043-4.66 2.693-.132.095a1.959 1.959 0 00-.704 1.092l-.03.161-.017.164c0 .347.14.456.418.327l.08-.042 4.653-2.69c.525-.34.856-.91.889-1.515 0-.318-.11-.437-.337-.36l-.08.032zM46.27 47.29v.01c.78 0 1.32.62 1.32 1.7a5.24 5.24 0 01-2.38 4.1 2.14 2.14 0 01-1.06.32c-.77 0-1.31-.62-1.31-1.69a5.24 5.24 0 012.37-4.11 2.22 2.22 0 01.873-.313l.187-.017zm-.72 2.06a.69.69 0 00-.34.1 1.67 1.67 0 00-.75 1.3c0 .34.17.54.42.54a.77.77 0 00.33-.1 1.67 1.67 0 00.76-1.3c0-.34-.17-.54-.42-.54zm1.82-23.716l.005.126-.001.92.001.01v12.834a2.708 2.708 0 01-1.295 2.14c-.792.464-1.553.066-1.62-.806l-.005-.128V26.977c.051-.82.469-1.569 1.131-2.042l.147-.098c.8-.528 1.572-.103 1.637.797zm-.744 2.795c-.16.17-.345.32-.55.447-.31.176-.612.224-.87.165l-.001 11.689c0 .315.114.436.335.363l.077-.032.077-.04c.494-.303.827-.806.913-1.355l.018-.166.001-11.07zm-.403-3.012l-.076.046-.154.104c-.416.309-.693.77-.77 1.266l-.018.167v.91l.003.09c.02.252.132.344.33.282l.078-.031.077-.04c.493-.304.825-.808.914-1.375l.017-.163.001-.913c0-.341-.112-.466-.333-.376l-.07.033zm-2.887-11.222a1.876 1.876 0 01-.147.341c-.34.624-1.213 1.373-2.757 2.341l-.557.341-.565.333-.932.532-.598.328-.701.37-.6.297-.067.032c-.907.435-1.672.732-2.332.909l-.243.06-.167.036 5.247 3.04a4.38 4.38 0 003.72-.048l.217-.112 3.536-1.998 2.77-1.595a1.31 1.31 0 00.75-.906l.016-.099-.002-.045a.782.782 0 00-.306-.52l-.093-.064-.105-.055-6.084-3.518zm-2.788-2.804c-.085.09-.177.178-.278.269l-.157.137-.163.136c-.339.267-.684.524-1.036.771l-.594.404c-.538.356-1.089.688-1.65.995l-.326.187-.317.179-.609.334-.714.374-.137.07-.528.257c-1.52.719-2.648 1.048-3.553 1.066l.046.185.037.176.107.56.063.27c.103.392.237.661.431.855l.087.078.066.045.367.214.04.01.072.029c.47.233 1.055.291 1.895.092l.216-.055.33-.1.175-.058.369-.136.395-.16.208-.09.554-.255.56-.277.652-.342.707-.388.607-.346.562-.33.638-.389.567-.363.207-.138.382-.263.34-.248c.582-.44.95-.799 1.127-1.083.03-.047.053-.087.069-.123.029-.106-.02-.181-.197-.308l-.185-.123-.274-.173a2.363 2.363 0 01-.287-.23c-.381-.357-.613-.78-.772-1.323l-.056-.21-.043-.182zm-26.36-3.687v1.087l.052.063.055.08.058.065.012.009.046.012.08.037 1.035.598.535.303 13.575 7.876-.165-.811-.058-.232c-.055-.195-.108-.31-.17-.38l-.038-.036-.097-.067-.448-.245-12.751-7.36-1.098-.64-.623-.359zm9.027-6.571l-.144.07-4.73 2.74-2.92 1.68-1.102.636a.415.415 0 00-.13.147c.007.09.054.171.149.235l.973.557 1.1.639 12.744 7.352.252.135c.068 0 .14.016.217.05.483.215 1.113.239 2.028-.016l.234-.07.361-.121.191-.07.403-.16.432-.188.227-.105.479-.23.252-.126.26-.133.546-.29.583-.32 1.158-.658c.348-.203.69-.416 1.026-.637l.49-.335.48-.347.48-.367.133-.116.227-.21c.336-.324.466-.527.466-.645 0-.082-.078-.194-.229-.314l-.113-.08L24.76 1.209a1.78 1.78 0 00-1.546-.076zm.666 3.149l.201.08.168.085 6.913 4.01c.496.172.829.638.829 1.163s-.333.991-.767 1.136a3.153 3.153 0 01-2.667.08l-.198-.093-7.027-4.067-.09-.06c-.893-.595-.825-1.691.14-2.182a3.15 3.15 0 012.292-.219l.206.067zm-2.045 1.044c-.256.13-.29.26-.107.408l.131.093 6.975 4.037c.61.308 1.33.308 2.002-.027a.23.23 0 00.155-.217c0-.082-.044-.156-.162-.22l-.08-.037-6.974-4.036-.104-.052-.174-.068a2.15 2.15 0 00-1.662.119z" })
      ]
    }
  );
}
var Xbox3603D_default = SvgXbox3603D;

// src/components/Icon/icons/XboxAmbassadorBaseLogo16.tsx
import { jsx as jsx1036, jsxs as jsxs1029 } from "react/jsx-runtime";
function SvgXboxAmbassadorBaseLogo16({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1029(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1036("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1036("path", { d: "M723 1652q17-2 32-3t32-1q66 0 121 18t94 50q-34 52-99 90t-151 51q-17 2-32 3t-32 2q-66 0-121-18t-94-51q33-52 98-90t152-51zm-317-221q85 17 147 59t93 97q-35 27-84 41t-108 15q-44 0-90-9-85-18-148-60t-93-96q35-27 84-41t107-15q45 0 92 9zm8-92q-17 3-35 3-56 0-117-24t-119-72q-66-56-101-123T5 995q18-3 36-3 56 0 117 24t118 72q66 55 101 122t37 129zm-92-310q-58-20-111-74t-85-135q-17-42-25-82t-8-78q0-71 28-127 59 20 112 74t85 135q17 41 24 80t8 77q0 74-28 130zm72-313q-51-34-89-99t-49-152q-2-15-3-30t-1-30q0-68 19-124t52-95q51 35 89 100t49 152q2 16 3 31t1 31q0 66-19 122t-52 94zm937 936q85 13 150 51t99 90q-38 32-93 50t-122 19q-16 0-31-1t-33-4q-85-13-150-51t-100-90q38-32 93-50t122-18q16 0 32 1t33 3zm316-221q46-9 92-9 57 0 106 14t85 42q-30 54-93 96t-148 60q-47 9-90 9-58 0-107-14t-85-42q30-54 92-96t148-60zm130-343q56-48 117-72t117-24q19 0 37 3-1 61-36 128t-102 123q-57 48-118 72t-118 24q-19 0-35-3 1-62 36-129t102-122zm-46-59q-28-56-28-130 0-37 7-76t25-81q32-80 85-134t112-75q27 54 27 127 0 38-7 78t-25 82q-32 80-85 134t-111 75zm66-564q-11 86-49 151t-89 100q-33-38-52-94t-19-124q0-14 1-29t3-31q11-86 49-151t89-101q33 38 52 94t19 125q0 14-1 29t-3 31zM627 1302q-21 0-39-10t-31-29-21-43-8-53q0-71 17-119l115-321q4-10 14-20 4-5 9-8t10-6v-34q29-15 67-24t82-9q20 0 33 8l33 17q7 4 15 14t18 11h166q10 0 18-10t15-15l33-17q13-8 33-8 44 0 82 9t67 24v34l10 6q5 3 9 8 10 10 14 20l115 321q17 48 17 119 0 28-7 52t-21 43-32 29-39 11q-15 0-25-8l-157-167q-19-16-44-25t-55-9H908q-29 0-54 9t-45 25l-157 167q-10 8-25 8zm397-557q-26 0-44 18t-18 45q0 26 18 43t44 18q26 0 44-17t18-44q0-26-18-44t-44-19z" })
      ]
    }
  );
}
var XboxAmbassadorBaseLogo16_default = SvgXboxAmbassadorBaseLogo16;

// src/components/Icon/icons/XboxAmbassadorBaseLogo32.tsx
import { jsx as jsx1037, jsxs as jsxs1030 } from "react/jsx-runtime";
function SvgXboxAmbassadorBaseLogo32({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1030(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1037("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1037("path", { d: "M713 1669q16-2 32-3t32-2h13q62 2 114 20t88 49q-33 51-98 89t-152 52q-17 2-32 3t-32 2q-66 0-121-18t-94-52q33-51 98-89t152-51zm-313-234q85 17 147 59t93 97q-35 26-84 41t-107 15q-22 0-45-2t-47-8q-85-17-147-59t-93-97q35-26 84-41t106-15q47 0 93 10zm16-94q-18 3-37 3-56 0-117-24t-117-72q-66-55-101-122T7 997q8-2 17-2t18 0q56 0 117 23t119 72q66 56 101 123t37 128zm-92-317q-58-20-111-74t-85-135q-17-41-24-80t-8-78q0-75 27-128 59 20 112 74t85 134q17 41 24 80t8 78q0 73-28 129zm63-320q-51-34-88-100t-50-151q-2-15-3-30t-1-29q0-68 19-125t52-95q52 34 89 100t49 151q2 16 3 31t1 31q0 67-19 123t-52 94zm944 965q85 12 150 50t99 90q-38 33-93 51t-122 19q-16 0-31-1t-33-4q-85-13-150-51t-100-90q35-30 86-48t111-21h14q17 0 34 1t35 4zm316-234q23-5 46-7t46-3q57 0 106 15t85 41q-30 54-93 96t-148 60q-46 10-92 10-57 0-106-15t-84-41q30-54 92-96t148-60zm130-345q57-48 118-71t118-24h18q9 0 17 2-1 62-36 129t-102 122q-57 48-118 72t-117 24q-18 0-36-3 1-61 36-128t102-123zm-46-66q-28-56-28-129 0-38 7-77t25-81q32-80 85-134t112-74q27 53 27 127 0 38-7 78t-25 81q-32 80-85 134t-111 75zm68-571q-12 85-49 151t-89 100q-33-38-52-94t-20-123q0-15 1-30t4-32q11-85 48-151t90-100q32 38 51 95t20 125q0 14-1 29t-3 30zM614 1303q-21 0-39-11t-33-30-22-44-8-55q0-36 4-67t13-55l120-332q5-13 13-21 5-5 10-8t11-6v-35q29-16 68-25t85-9q21 0 34 8l35 18q6 4 14 14t20 11h170q11 0 19-10t15-15l35-18q13-8 34-8 45 0 84 9t69 25v35q6 3 11 6t10 8q8 8 13 21l120 332q8 23 12 54t5 68q0 29-8 54t-22 45-32 30-40 11q-8 0-14-2t-12-7l-162-172q-20-17-46-26t-57-9H905q-62 0-103 35l-162 172q-5 4-11 6t-15 3zm410-567q-26 0-45 19t-19 45q0 26 19 45t45 19q26 0 45-19t19-45q0-26-19-45t-45-19z" })
      ]
    }
  );
}
var XboxAmbassadorBaseLogo32_default = SvgXboxAmbassadorBaseLogo32;

// src/components/Icon/icons/XboxAssistApp.tsx
import { jsx as jsx1038, jsxs as jsxs1031 } from "react/jsx-runtime";
function SvgXboxAssistApp({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1031(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1038("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1038("path", { d: "M768 2048q-25 0-48-10t-41-29-28-41-11-48h640q0 25-10 48t-29 41-41 28-48 11H768zm-128-384h640v128H640v-128zM960 0q149 0 277 54t223 148 148 224 54 278q0 79-25 148t-65 133-85 126-88 127-73 139-40 159H635q-5-58-17-108t-33-96-50-88-68-87q-45-51-83-101t-67-105-45-115-16-132q0-149 54-277t149-224T682 54 960 0zm64 1280H896v128h128v-128zm0-128v-55q0-31 5-64t15-62 28-47q43-43 80-79t66-74 45-84 17-111q0-67-24-125t-68-102-102-68-126-25q-68 0-126 24t-101 68-68 102-25 126v64h128v-64q0-41 14-76t41-61 61-40 76-15q41 0 76 14t61 41 40 61 15 76q0 15-2 32t-8 35-12 33-19 27L980 835q-20 21-36 52t-26 65-16 70-6 63v67h128z" })
      ]
    }
  );
}
var XboxAssistApp_default = SvgXboxAssistApp;

// src/components/Icon/icons/XboxAssistAppMirrored.tsx
import { jsx as jsx1039, jsxs as jsxs1032 } from "react/jsx-runtime";
function SvgXboxAssistAppMirrored({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1032(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1039("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1039("path", { d: "M1150 2048q25 0 48-10t41-29 28-41 11-48H638q0 25 10 48t29 41 41 28 48 11h384zm128-384H638v128h640v-128zM958 0Q809 0 681 54T458 202 310 426t-54 278q0 79 25 148t65 133 85 126 88 127 73 139 40 159h651q5-58 17-108t33-96 50-88 68-87q45-51 83-101t67-105 45-115 16-132q0-149-54-277t-149-224-223-149T958 0zm-64 1280h128v128H894v-128zm0-128v-55q0-31-5-64t-15-62-28-47q-43-43-80-79t-66-74-45-84-17-111q0-67 24-125t68-102 102-68 126-25q68 0 126 24t101 68 68 102 25 126v64h-128v-64q0-41-14-76t-41-61-61-40-76-15q-41 0-76 14t-61 41-40 61-15 76q0 15 2 32t8 35 12 33 19 27l131 132q20 21 36 52t26 65 16 70 6 63v67H894z" })
      ]
    }
  );
}
var XboxAssistAppMirrored_default = SvgXboxAssistAppMirrored;

// src/components/Icon/icons/XboxChat.tsx
import { jsx as jsx1040, jsxs as jsxs1033 } from "react/jsx-runtime";
function SvgXboxChat({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1033(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1040("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1040("path", { d: "M1472 1151h18l110 93v227q0 40-15 75t-41 61-61 42-75 15H512l-384 321V960q0-40 15-75t41-61 61-41 75-15v128q-26 0-45 19t-19 45v751l210-175h942q27 0 45-19t19-46v-320zm256-1023q40 0 75 15t61 41 41 61 15 75v1025l-384-321H640q-40 0-75-15t-61-41-41-62-15-75V320q0-40 15-75t41-61 61-41 75-15h1088zm64 943V320q0-26-19-45t-45-19H640q-26 0-45 19t-19 45v511q0 26 18 45t46 20h942l210 175z" })
      ]
    }
  );
}
var XboxChat_default = SvgXboxChat;

// src/components/Icon/icons/XboxClassic.tsx
import { jsx as jsx1041, jsxs as jsxs1034 } from "react/jsx-runtime";
function SvgXboxClassic({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1034(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1041("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1041("path", { d: "M2048 192v1664H0V192h2048zM858 320l166 166 165-166H858zM128 1382l357-358-357-357v715zm1061 346l-165-165-166 165h331zm731-1061l-358 357 358 358V667zm0-347h-550l-346 347-347-347H128v166l538 538-538 539v165h549l347-346 346 346h550v-165l-539-539 539-538V320zm-896 448q53 0 99 20t82 55 55 81 20 100q0 53-20 99t-55 82-81 55-100 20q-53 0-99-20t-82-55-55-81-20-100q0-53 20-99t55-82 81-55 100-20zm0 384q27 0 50-10t40-27 28-41 10-50q0-27-10-50t-27-40-41-28-50-10q-27 0-50 10t-40 27-28 41-10 50q0 27 10 50t27 40 41 28 50 10z" })
      ]
    }
  );
}
var XboxClassic_default = SvgXboxClassic;

// src/components/Icon/icons/XboxDynamicLighting.tsx
import { jsx as jsx1042, jsxs as jsxs1035 } from "react/jsx-runtime";
function SvgXboxDynamicLighting({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1035(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1042("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1042("path", { d: "M871 207q-63 12-123 33L697 51l124-33 50 189zM483 393q-48 42-90 90L255 345l90-90 138 138zm868-342l-51 204q-30-22-60-32t-63-16l50-189 124 33zm214 342l138-138 90 90-138 138q-42-48-90-90zm465 428l-189 50q-12-63-33-123l189-51 33 124zM393 1565q42 48 90 90l-138 138-90-90 138-138zm784 276q63-12 123-33l51 189-124 33-50-189zM18 821l33-124 189 51q-21 60-33 123L18 821zm1790 479q21-60 33-123l189 50-33 124-189-51zm-243 355q48-42 90-90l138 138-90 90-138-138zM18 1227l189-50q12 63 33 123l-189 51-33-124zm679 770l51-189q60 21 123 33l-50 189-124-33zm570-1633l-50 187q-30-12-61-19t-63-13l50-188q65 11 124 33zM831 551l-50-187q59-22 124-33l50 188q-32 5-63 12t-61 20zM621 712L483 574q42-49 91-91l138 138q-51 40-91 91zm1063 69q22 59 33 124l-188 50q-5-32-12-63t-20-61l187-50zm-257-69q-40-51-91-91l138-138q49 42 91 91l-138 138zM331 1143l188-50q5 32 12 63t20 61l-187 50q-22-59-33-124zm33-362l187 50q-12 30-19 61t-13 63l-188-50q11-65 33-124zm1063 555l138 138q-42 49-91 91l-138-138q51-40 91-91zm70-119q12-30 19-61t13-63l188 50q-11 65-33 124l-187-50zm-280 280l50 187q-59 22-124 33l-50-188q32-5 63-12t61-20zm-436 187l50-187q30 12 61 19t63 13l-50 188q-65-11-124-33zm-160-348q40 51 91 91l-138 138q-49-42-91-91l138-138zm403-440q27 0 50 10t40 27 28 41 10 50q0 27-10 50t-27 40-41 28-50 10q-27 0-50-10t-40-27-28-41-10-50q0-27 10-50t27-40 41-28 50-10zm384 128q0 80-30 149t-82 122-123 83-149 30q-80 0-149-30t-122-82-83-122-30-150q0-79 30-149t82-122 122-83 150-30q79 0 149 30t122 82 83 123 30 149zm-384 256q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20q-53 0-99 20t-82 55-55 81-20 100q0 53 20 99t55 82 81 55 100 20z" })
      ]
    }
  );
}
var XboxDynamicLighting_default = SvgXboxDynamicLighting;

// src/components/Icon/icons/XboxGamePass.tsx
import { jsx as jsx1043, jsxs as jsxs1036 } from "react/jsx-runtime";
function SvgXboxGamePass({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1036(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 3841 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1043("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1043("path", { d: "M3442 1260q10 7 27 12t36 8 37 6 30 2q33 0 66-6t60-22 43-42 17-66q0-38-17-64t-42-45-56-33-55-28-43-30-17-40q0-19 10-31t25-20 32-11 33-3q29 0 57 6t51 24v-81q-23-11-54-14t-58-3q-31 0-63 7t-59 24-43 41-17 63q0 39 17 65t42 44 56 33 55 27 43 30 17 40q0 21-10 34t-25 21-33 9-35 3q-32 0-67-11t-60-33v84zm-377 0q10 7 27 12t36 8 37 6 30 2q33 0 66-6t60-21 43-42 17-67q0-38-17-64t-42-45-56-33-55-28-43-30-17-40q0-19 10-31t25-20 32-11 33-3q29 0 57 6t51 24v-81q-23-11-54-14t-58-3q-31 0-63 7t-59 24-43 42-17 62q0 39 17 65t42 44 56 33 55 27 43 30 17 40q0 22-9 35t-25 20-33 9-35 3q-32 0-67-11t-61-33v84zm-194-172h-151l68-197q2-8 3-15t4-16h1q2 17 6 31l69 197zm156 192l-184-493h-92l-184 493h89l43-126h194l44 126h90zm-681-425h60q45 0 73 19t28 67q0 51-30 72t-78 21h-53V855zm0 246h66q37 0 70-10t58-31 39-51 14-71q0-40-14-69t-38-47-57-26-70-9h-149v493h81v-179zm-349 179v-69h-195v-146h169v-69h-169V857h184v-70h-266v493h277zm-392 0V787h-111q-39 97-79 192t-74 193h-2q-2-14-8-28t-11-29l-129-328h-115v493h75V914q0-24-3-49h2q2 12 5 25t8 24l147 366h57l147-369q5-11 7-22t6-24h2q-2 24-3 48t-2 48v319h81zm-746-192H708l67-197q2-8 3-15t4-16h1q2 8 3 15t4 16l69 197zm155 192L831 787h-92l-185 493h90l42-126h194l44 126h90zm-505-34v-234H324v69h104v117q-20 11-42 15t-46 5q-41 0-71-14t-51-39-29-58-10-72q0-40 13-74t36-59 57-39 74-14q36 0 70 9t65 29v-84q-32-14-67-19t-71-5q-57 0-105 19t-84 53-54 83-20 106q0 56 17 101t50 78 77 51 101 18q45 0 88-10t83-32zM0 640h3840v768H0V640z" })
      ]
    }
  );
}
var XboxGamePass_default = SvgXboxGamePass;

// src/components/Icon/icons/XboxGamePassBadge.tsx
import { jsx as jsx1044, jsxs as jsxs1037 } from "react/jsx-runtime";
function SvgXboxGamePassBadge({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1037(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1044("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1044("path", { d: "M1792 0v2048H384v-177q42-4 71-22t57-48v119h1152V128H512v547q-34 8-65 16t-63 23V0h1408zM680 1489q-23 0-54 7t-48 25l-206 207q-11 11-29 16t-33 6q-42 0-74-20t-55-51-33-70-12-77q0-42 4-84t20-82v-1l153-414v-1q6-15 16-28t24-23v-45q57-32 116-46t124-15q22 0 40 6t34 15 29 15 27 7h218q13 0 26-6t30-15 34-15 40-7q65 0 124 14t116 47v45q13 9 24 24t17 30l152 413q14 40 19 82t5 84q0 38-11 76t-34 70-54 52-75 20q-14 0-32-5t-30-17l-206-207q-17-17-48-24t-54-8H680zm-180-46q16-16 38-28t46-21 48-12 48-4h304q23 0 47 4t49 12 45 20 39 29l196 196q15-3 25-15t18-28 10-34 4-30q0-32-3-65t-14-63l-151-411q-1-2-8-7t-15-11-16-11-11-8l1-31q-62-22-129-22-3 0-4 1-18 6-32 13t-28 14-29 11-37 5H723q-20 0-36-4t-30-10-29-14-32-16q-35 0-67 5t-65 17v31l-47 33-153 414q-11 29-14 63t-3 66q0 12 3 29t11 34 17 29 26 15l196-196zm332-307q-23 0-38-16t-15-38q0-22 15-37t38-16q22 0 37 15t16 38q0 22-15 38t-38 16zm192-752q-26 0-45-19t-19-45q0-26 19-45t45-19h256q26 0 45 19t19 45q0 26-19 45t-45 19h-256z" })
      ]
    }
  );
}
var XboxGamePassBadge_default = SvgXboxGamePassBadge;

// src/components/Icon/icons/XboxLfg.tsx
import { jsx as jsx1045, jsxs as jsxs1038 } from "react/jsx-runtime";
function SvgXboxLfg({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1038(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1045("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1045("path", { d: "M2048 1216q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175v-128H896v128q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-72 22-141t67-128l404-537q32-43 78-66t101-24q46 0 87 17t71 48 48 72 18 87v96h256v-96q0-46 17-87t48-71 72-48 87-18q54 0 100 23t79 67l404 537q44 58 66 127t23 142zm-672-768q-40 0-68 28t-28 68v359l3-4q30-31 67-55t78-42 85-25 87-9q17 0 34 1t34 4l-215-287q-14-18-34-28t-43-10zM380 773q17-2 34-3t34-2q43 0 86 8t85 26 79 41 67 56l3 4V544q0-40-28-68t-68-28q-23 0-43 10t-34 28L380 773zm68 763q66 0 124-25t101-68 69-102 26-125q0-66-25-124t-69-101-102-69-124-26q-66 0-124 25t-102 68-69 102-25 125q0 66 25 124t68 102 102 69 125 25zm448-576h256V768H896v192zm704 576q66 0 124-25t101-68 69-102 26-125q0-66-25-124t-68-102-102-69-125-25q-66 0-124 25t-102 69-69 102-25 124q0 66 25 124t68 102 102 69 125 25z" })
      ]
    }
  );
}
var XboxLfg_default = SvgXboxLfg;

// src/components/Icon/icons/XboxLogoOutline.tsx
import { jsx as jsx1046, jsxs as jsxs1039 } from "react/jsx-runtime";
function SvgXboxLogoOutline({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1039(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1046("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1046("path", { d: "M1024 5q141 0 271 36t243 103 207 159 159 206 102 244 37 271q0 141-36 271t-103 243-159 207-206 159-244 102-271 37q-141 0-271-36t-243-103-207-159-159-206-102-244-37-271q0-141 36-271t103-243 159-207 206-159T753 42t271-37zM549 255l4 2q34-8 65-8 47 0 101 12t107 32 104 44 92 48h4q39-25 90-49t107-43 109-31 100-12q32 0 62 6l4-2-1-5q-112-66-227-99t-246-33q-130 0-246 33T550 250l-1 5zM308 1570q-9-30-9-62 0-61 24-137t64-160 91-168 104-163 103-145 90-114l1-3-1-3q-17-17-43-42t-57-52-65-53-69-48-67-35-60-13q-4 0-13 1t-14 5q-65 63-115 138t-84 158-53 171-18 179q0 150 47 290t138 260l5 1 1-5zm716 361q137 0 266-39t242-117q22-14 46-31t43-37q14-14 20-33t6-39q0-56-34-127t-88-147-123-155-138-147-131-124-106-89l-3-2-3 2q-43 33-105 88t-132 125-137 147-123 154-89 148-34 127q0 20 6 39t20 33q19 19 43 36t46 32q112 77 241 116t267 40zm722-357q91-119 138-259t47-291q0-90-18-178t-52-172-85-158-115-138q-4-4-13-5t-13-1q-27 0-59 13t-67 34-69 48-66 54-57 52-43 42l-1 1-1 2 1 2q39 50 90 117t104 144 103 161 90 166 64 159 25 141q0 32-9 62l1 5 5-1z" })
      ]
    }
  );
}
var XboxLogoOutline_default = SvgXboxLogoOutline;

// src/components/Icon/icons/XboxMsgFulfillmentLogo.tsx
import { jsx as jsx1047, jsxs as jsxs1040 } from "react/jsx-runtime";
function SvgXboxMsgFulfillmentLogo({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1040(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1047("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1047("path", { d: "M1792 128q53 0 99 20t82 55 55 81 20 100v768q0 53-20 99t-55 82-81 55-100 20V768q0-79-30-149t-82-122-123-83-149-30H256q0-53 20-99t55-82 81-55 100-20h1280zm-384 384q53 0 99 20t82 55 55 81 20 100v640q0 53-20 99t-55 82-81 55-100 20H832l-512 256 128-256H256q-53 0-99-20t-82-55-55-81-20-100V768q0-53 20-99t55-82 81-55 100-20h1152zm-448 896q26 0 45-19t19-45q0-26-19-45t-45-19H320q-26 0-45 19t-19 45q0 26 19 45t45 19h640zm384-256q26 0 45-19t19-45q0-26-19-45t-45-19H320q-26 0-45 19t-19 45q0 26 19 45t45 19h1024zm0-256q26 0 45-19t19-45q0-26-19-45t-45-19H320q-26 0-45 19t-19 45q0 26 19 45t45 19h1024z" })
      ]
    }
  );
}
var XboxMsgFulfillmentLogo_default = SvgXboxMsgFulfillmentLogo;

// src/components/Icon/icons/XboxOne3D.tsx
import { jsx as jsx1048, jsxs as jsxs1041 } from "react/jsx-runtime";
function SvgXboxOne3D({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1041(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 64 64",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1048("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1048("path", { d: "M36.98 8.067a.5.5 0 01.42-.037l.08.037 26.305 15.182.069.057.039.043.031.045a.5.5 0 01.074.22l.002.046v9.15a.5.5 0 01-.178.382l-.072.051-18.252 10.539-.058.041-18.42 10.63-2.57 1.48a.5.5 0 01-.42.037l-.08-.037-23.7-13.68a.5.5 0 01-.242-.345L0 41.82V29.7c0-.092.025-.185.075-.265l.044-.06.037-.039.058-.046.036-.023 36.73-21.2zM1 30.566v10.965l23.2 13.391 2.07-1.192v-3.72l-2.31-1.34v-1.73l2.31 1.337v-3.119L1 30.566zm43.668 9.396L27.27 50.009v3.144l17.418-10.058-.02-3.133zm-.032-4.83L27.27 45.158v3.118l17.386-10.04-.02-3.104zM18.87 19.677L1.5 29.7l25.269 14.592 17.36-10.024L18.87 19.677zm44.129 4.849L45.631 34.557l.053 7.963 17.315-9.999v-7.995zM37.23 9.077L19.867 19.099l25.261 14.592L62.499 23.66 37.23 9.077zm22.33 20.601c.388-.674 1.022-1.037 1.414-.81.392.226.395.956.005 1.63-.389.675-1.023 1.038-1.415.811-.392-.226-.394-.956-.005-1.63z" })
      ]
    }
  );
}
var XboxOne3D_default = SvgXboxOne3D;

// src/components/Icon/icons/XboxOneConsole.tsx
import { jsx as jsx1049, jsxs as jsxs1042 } from "react/jsx-runtime";
function SvgXboxOneConsole({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1042(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1049("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1049("path", { d: "M2048 512v896H0V512h2048zm-128 128H128v256h768v128H128v256h1792V640zm-320 384q-26 0-45-19t-19-45q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19z" })
      ]
    }
  );
}
var XboxOneConsole_default = SvgXboxOneConsole;

// src/components/Icon/icons/XboxOneDown.tsx
import { jsx as jsx1050, jsxs as jsxs1043 } from "react/jsx-runtime";
function SvgXboxOneDown({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1043(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1050("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1050("path", { d: "M2048 256v896H256V896H0V256h2048zm-128 640H384v128h1536V896zm0-128V384H128v384h1792zm-320-256q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45q0-26 19-45t45-19zm-301 851l90 90-365 365-365-365 90-90 275 275 275-275z" })
      ]
    }
  );
}
var XboxOneDown_default = SvgXboxOneDown;

// src/components/Icon/icons/XboxOneHardwareSolid.tsx
import { jsx as jsx1051, jsxs as jsxs1044 } from "react/jsx-runtime";
function SvgXboxOneHardwareSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1044(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1051("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1051("path", { d: "M0 512h2048v768q-30-35-63-65t-65-63H384v128h600q-14 32-30 64t-32 64H256v-256H0V512zm1696 320q0-19-7-36t-21-31-31-21-37-8q-20 0-37 7t-30 21-21 31-8 37q0 20 7 37t21 30 31 21 37 8q19 0 36-7t31-21 21-31 8-37zm352 1011q0 58-19 102t-69 79q-16 11-34 17t-38 7q-26 0-48-14t-44-36-41-46-40-47-41-35-44-15h-252q-23 0-44 14t-41 36-40 46-41 47-43 35-49 15q-20 0-37-6t-34-18q-50-32-69-76t-20-103q0-24 2-48t8-47q3-18 12-49t22-69 28-77 30-76 31-62 27-40q0-18 8-32t23-24q13-9 37-16t50-13 52-9 42-3q20 0 30 2t19 7 17 10 24 12h164q15-6 24-11t17-10 19-7 30-3q16 0 41 3t52 8 50 13 38 17q14 9 22 24t9 32q12 12 27 39t30 63 31 75 28 78 22 68 13 50q9 47 9 93zm-480-340q0-28-18-46t-46-18q-28 0-46 18t-18 46q0 28 18 46t46 18q28 0 46-18t18-46z" })
      ]
    }
  );
}
var XboxOneHardwareSolid_default = SvgXboxOneHardwareSolid;

// src/components/Icon/icons/XboxOneS3D.tsx
import { jsx as jsx1052, jsxs as jsxs1045 } from "react/jsx-runtime";
function SvgXboxOneS3D({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1045(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 64 64",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1052("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1052("path", { d: "M36.98 9.097a.5.5 0 01.42-.037l.08.037 26.303 15.18.057.046.053.056.031.045a.5.5 0 01.074.22l.002.046v6.96a.5.5 0 01-.178.382l-.072.051-2.701 1.558.001 1.039-34.28 19.79L1.36 39.8l-.001-1.037-1.109-.64a.5.5 0 01-.242-.345L0 37.69v-6.95a.5.5 0 01.075-.265l.043-.06.045-.045.052-.04.035-.023L18.6 19.71l.02-.013 18.36-10.6zM1 31.606v5.795l25.27 14.583v-5.795L1 31.606zm43.63 8.032l-17.36 10.03v2.315l17.36-10.02v-2.325zm0-3.475L27.27 46.188v2.325l17.36-10.029v-2.321zM18.871 20.708L1.5 30.739l25.27 14.583 17.358-10.024-25.257-14.59zM63 25.555L45.63 35.588v5.798L63 31.36v-5.805zm-.501-.865L37.23 10.107 19.87 20.131l25.258 14.59L62.499 24.69zm-3 4.97c.389-.674 1.023-1.037 1.415-.81.392.226.394.956.005 1.63-.39.675-1.023 1.038-1.415.811-.392-.226-.395-.956-.005-1.63z" })
      ]
    }
  );
}
var XboxOneS3D_default = SvgXboxOneS3D;

// src/components/Icon/icons/XboxOneSad3D.tsx
import { jsx as jsx1053, jsxs as jsxs1046 } from "react/jsx-runtime";
function SvgXboxOneSad3D({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1046(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 64 64",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1053("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1053("path", { d: "M36.98 9.097a.5.5 0 01.42-.037l.08.037 26.303 15.18.057.046.053.056.031.045a.5.5 0 01.074.22l.002.046v6.96a.5.5 0 01-.178.382l-.072.051-2.701 1.558.001 1.039-34.28 19.79L1.36 39.8l-.001-1.037-1.109-.64a.5.5 0 01-.242-.345L0 37.69v-6.95a.5.5 0 01.075-.265l.043-.06.045-.045.052-.04.035-.023L18.6 19.71l.02-.013 18.36-10.6zM1 31.606v5.795l25.27 14.583v-5.795L1 31.606zm43.63 4.557L27.27 46.188v5.795l17.36-10.02v-5.8zM18.871 20.708L1.5 30.739l25.27 14.583 17.358-10.024-25.257-14.59zM63 25.555L45.63 35.588v5.798L63 31.36v-5.805zm-.501-.865L37.23 10.107 19.87 20.131l25.258 14.59L62.499 24.69zm-3 4.97c.389-.674 1.023-1.037 1.415-.81.392.226.394.956.005 1.63-.39.675-1.023 1.038-1.415.811-.392-.226-.395-.956-.005-1.63z" })
      ]
    }
  );
}
var XboxOneSad3D_default = SvgXboxOneSad3D;

// src/components/Icon/icons/XboxOneUp.tsx
import { jsx as jsx1054, jsxs as jsxs1047 } from "react/jsx-runtime";
function SvgXboxOneUp({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1047(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1054("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1054("path", { d: "M2048 256v896H256V896H0V256h2048zm-128 640H384v128h1536V896zm0-128V384H128v384h1792zm-320-256q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45q0-26 19-45t45-19zm-576 805l365 366-90 90-275-274-275 274-90-90 365-366z" })
      ]
    }
  );
}
var XboxOneUp_default = SvgXboxOneUp;

// src/components/Icon/icons/XboxOneX3D.tsx
import { jsx as jsx1055, jsxs as jsxs1048 } from "react/jsx-runtime";
function SvgXboxOneX3D({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1048(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 64 64",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1055("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1055("path", { d: "M36.98 8.517a.5.5 0 01.42-.037l.08.037 26.283 15.178.06.042.059.059.042.058a.5.5 0 01.074.217l.002.049v9.72a.5.5 0 01-.178.382l-.072.051-33.04 19.08a.494.494 0 01-.425.035l-.076-.036-2.143-1.244-1.085.625-.07.027-.082.017-.097.002-.08-.012-.045-.014a.499.499 0 01-.087-.04l.067.032-.029-.012L.25 37.543a.5.5 0 01-.242-.345L0 37.11v-6.95l.007-.084a.498.498 0 01.068-.181l.043-.06.045-.045.052-.04.035-.023 36.73-21.21zm26.019 25.034v-1.615l-32.04 18.501v1.617l32.04-18.503zM29.96 51.014l-.895.517.895.52v-1.037zM1 31.026v5.795l25.27 14.593v-5.796L1 31.026zm61.999-.245v-5.795L27.27 45.617v5.796l2.868-1.655.072-.051L63 30.781zM37.229 9.527L1.5 30.159l25.27 14.583L62.5 24.119 37.229 9.527zm22.33 19.521c.39-.674 1.023-1.038 1.416-.811.392.226.394.957.005 1.631-.39.674-1.023 1.037-1.415.811-.393-.226-.395-.957-.006-1.631z" })
      ]
    }
  );
}
var XboxOneX3D_default = SvgXboxOneX3D;

// src/components/Icon/icons/XboxOptimized.tsx
import { jsx as jsx1056, jsxs as jsxs1049 } from "react/jsx-runtime";
function SvgXboxOptimized({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1049(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1056("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1056("path", { d: "M990 0l738 426v1165l-737 457-735-457V427L990 0zm610 1518V501L990 149 384 501v1017l607 379 609-379zm-1088-83V606l480-298 480 298v829l-480 294-480-294z" })
      ]
    }
  );
}
var XboxOptimized_default = SvgXboxOptimized;

// src/components/Icon/icons/XboxPlayAnywhere.tsx
import { jsx as jsx1057, jsxs as jsxs1050 } from "react/jsx-runtime";
function SvgXboxPlayAnywhere({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1050(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1057("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1057("path", { d: "M128 1408h1792v640H128v-640zm128 128v128h768v128H256v128h1536v-384H256zm1344 256q-26 0-45-19t-19-45q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19zM282 1280q-32 0-60-12t-49-33-33-49-12-60q0-31 11-59t34-51l211-211V0h1280v805l211 211q22 22 33 50t12 60q0 32-12 60t-33 49-49 33-60 12H282zm230-512h1024V128H512v640zm-248 339q-8 8-8 19t7 18 19 8h1484q11 0 18-7t8-19q0-11-8-19l-211-211H475l-211 211z" })
      ]
    }
  );
}
var XboxPlayAnywhere_default = SvgXboxPlayAnywhere;

// src/components/Icon/icons/XboxPlayAnywhereSolid.tsx
import { jsx as jsx1058, jsxs as jsxs1051 } from "react/jsx-runtime";
function SvgXboxPlayAnywhereSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1051(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1058("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1058("path", { d: "M128 1126q0-65 45-110l211-211V0h1280v805l211 211q21 21 33 50t12 60q0 32-12 60t-33 49-49 33-60 12H282q-32 0-60-12t-49-33-33-49-12-60zm384-998v640h1024V128H512zM128 2048v-640h1792v640H128zm1376-320q0 20 7 37t21 30 31 21 37 8q19 0 36-7t31-21 21-31 8-37q0-19-7-36t-21-31-31-21-37-8q-20 0-37 7t-30 21-21 31-8 37zm-1248-64v128h768v-128H256z" })
      ]
    }
  );
}
var XboxPlayAnywhereSolid_default = SvgXboxPlayAnywhereSolid;

// src/components/Icon/icons/XboxSeriesS3D.tsx
import { jsx as jsx1059, jsxs as jsxs1052 } from "react/jsx-runtime";
function SvgXboxSeriesS3D({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1052(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 64 64",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1059("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1059("path", { d: "M25.48.067A.5.5 0 0125.9.03l.08.037L48.046 12.81l.068.056.039.043.031.045c.05.081.076.174.076.266v44.8a.5.5 0 01-.178.382l-.072.051-9.49 5.48a.495.495 0 01-.265.067.487.487 0 01-.178-.027l-.087-.04-22-12.72a.5.5 0 01-.242-.345l-.008-.088V5.99a.496.496 0 01.172-.388l.078-.055 9.49-5.48zm-8.741 6.798v43.626l21 12.142V18.988l-21-12.123zm30.521 7.22l-8.49 4.903v43.645l8.49-4.902V14.085zm-26.2 2.253c3.583-2.069 9.163 1.152 12.563 7.042 3.4 5.89 3.4 12.332-.184 14.401-3.584 2.07-9.163-1.152-12.564-7.041-3.4-5.89-3.4-12.333.184-14.402zm11.697 7.542c-3.16-5.475-8.22-8.395-11.198-6.676-2.978 1.72-2.978 7.561.182 13.036 3.161 5.474 8.22 8.395 11.198 6.675 2.978-1.72 2.979-7.56-.182-13.035zm7.81-3.595c.39-.674 1.024-1.037 1.416-.81.392.226.395.956.005 1.63-.39.675-1.023 1.038-1.415.812-.392-.227-.394-.957-.005-1.632zM25.73 1.077L17.24 5.979l21.03 12.143 8.489-4.902-21.03-12.143z" })
      ]
    }
  );
}
var XboxSeriesS3D_default = SvgXboxSeriesS3D;

// src/components/Icon/icons/XboxSeriesX.tsx
import { jsx as jsx1060, jsxs as jsxs1053 } from "react/jsx-runtime";
function SvgXboxSeriesX({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1053(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1060("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1060("path", { d: "M832 384q-26 0-45-19t-19-45q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19zM512 0h1024v2048H512V0zm896 1920V128H640v1792h128v-896h128v896h512z" })
      ]
    }
  );
}
var XboxSeriesX_default = SvgXboxSeriesX;

// src/components/Icon/icons/XboxSeriesX3D.tsx
import { jsx as jsx1061, jsxs as jsxs1054 } from "react/jsx-runtime";
function SvgXboxSeriesX3D({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1054(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 64 64",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1061("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1061("path", { d: "M31.75.067a.5.5 0 01.42-.037l.08.037 17.555 10.132.069.057.039.043.031.045a.5.5 0 01.074.22l.002.046v42.78a.5.5 0 01-.178.382l-.072.051-14.6 8.42-2.957 1.71-.054.021-.08.02-.097.006-.06-.006-.082-.02-.075-.033L14.23 53.823a.5.5 0 01-.242-.345l-.008-.088V10.61l.007-.084a.498.498 0 01.068-.181l.044-.06.044-.045.052-.04.035-.023L31.75.067zM14.98 11.476v41.625l16.52 9.533V21.018l-16.52-9.542zM49.02 53.1V11.475L32.5 21.018v41.614l2.17-1.255L49.02 53.1zM34.257 22.88c.39-.675 1.023-1.038 1.415-.811.393.226.395.956.005 1.63-.389.675-1.022 1.038-1.415.812-.392-.227-.394-.957-.005-1.631zM32 1.077L15.479 10.61 32 20.152l16.52-9.542L32 1.077z" })
      ]
    }
  );
}
var XboxSeriesX3D_default = SvgXboxSeriesX3D;

// src/components/Icon/icons/XboxSeriesXHardware.tsx
import { jsx as jsx1062, jsxs as jsxs1055 } from "react/jsx-runtime";
function SvgXboxSeriesXHardware({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1055(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1062("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1062("path", { d: "M256 320q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19q-26 0-45-19t-19-45zm1792 1523q0 57-19 103t-69 78q-15 10-34 17t-38 7q-35 0-64-25t-57-57-53-64-55-42q-9-4-21-4t-24-1h-236q-23 0-44 14t-41 36-40 46-41 47-44 35-48 15q-20 0-37-6t-34-17q-48-32-68-78t-21-102v-24q0-12 2-24 1-23 9-58t21-76 29-83 34-82 33-70 32-51q0-36 31-56 13-9 37-16t50-13 52-9 42-3q16 0 27 2t20 6 20 10 23 13h164q15-7 24-13t17-10 20-6 29-2q18 0 43 3t50 8 49 13 39 17q14 10 21 24t10 32q12 12 27 39t30 63 31 75 28 78 22 68 13 50q9 47 9 93zm-128 2q0-35-8-73-5-24-16-61t-25-76-29-75-26-59l-8-16q-4-8-9-15-7-8-12-12t-9-8-9-10-8-18q-21-7-42-9t-45-5q-14 6-22 11t-18 11-19 8-28 3h-166q-17 0-27-3t-20-7-18-11-22-12q-23 0-44 4t-44 10q-2 20-14 27t-23 21q-5 7-8 14t-8 16q-15 31-33 76t-34 93-27 94-11 80q0 20 4 39t21 32q28-25 48-49t38-45 36-38 41-29 55-19 77-7h192q46 0 78 7t55 19 40 30 34 38 38 44 50 49q17-11 21-30t4-39zM896 1553V128H128v1792h128v-896h128v896h455q12 68 52 128H0V0h1024v1270q-10 14-14 28t-11 28l-8 14q-4 7-9 14-28 47-48 97t-38 102zm608-82q14 0 23 9t9 23q0 14-9 23t-23 9q-14 0-23-9t-9-23q0-14 9-23t23-9z" })
      ]
    }
  );
}
var XboxSeriesXHardware_default = SvgXboxSeriesXHardware;

// src/components/Icon/icons/XboxSeriesXHardwareSolid.tsx
import { jsx as jsx1063, jsxs as jsxs1056 } from "react/jsx-runtime";
function SvgXboxSeriesXHardwareSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1056(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1063("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1063("path", { d: "M846 1718l-1 6v-3q0-1 1-3zm-14 127q0 54 14 106t45 97H384V1024H256v1024H0V0h1024v1270q-10 14-14 28t-11 28q-14 28-29 54t-28 55q-20 49-39 99t-35 101-26 103-10 107zM320 384q26 0 45-19t19-45q0-26-19-45t-45-19q-26 0-45 19t-19 45q0 26 19 45t45 19zm1728 1459q0 57-19 103t-69 78q-15 10-34 17t-38 7q-35 0-64-25t-57-57-53-64-55-42q-9-4-21-4t-24-1h-236q-23 0-44 14t-41 36-40 46-41 47-44 35-48 15q-20 0-37-6t-34-17q-48-32-68-78t-21-102v-24q0-12 2-24 1-23 9-58t21-76 29-83 34-82 33-70 32-51q0-36 31-56 13-9 37-16t50-13 52-9 42-3q16 0 27 2t20 6 20 10 23 13h164q15-7 24-13t17-10 20-6 29-2q18 0 43 3t50 8 49 13 39 17q14 10 21 24t10 32q12 12 27 39t30 63 31 75 28 78 22 68 13 50q9 47 9 93zm-480-340q0-28-18-46t-46-18q-28 0-46 18t-18 46q0 28 18 46t46 18q28 0 46-18t18-46z" })
      ]
    }
  );
}
var XboxSeriesXHardwareSolid_default = SvgXboxSeriesXHardwareSolid;

// src/components/Icon/icons/XboxSeriesXSolid.tsx
import { jsx as jsx1064, jsxs as jsxs1057 } from "react/jsx-runtime";
function SvgXboxSeriesXSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1057(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1064("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1064("path", { d: "M512 0h1024v2048H896V1024H768v1024H512V0zm320 384q26 0 45-19t19-45q0-26-19-45t-45-19q-26 0-45 19t-19 45q0 26 19 45t45 19z" })
      ]
    }
  );
}
var XboxSeriesXSolid_default = SvgXboxSeriesXSolid;

// src/components/Icon/icons/XboxServicesCloudStream.tsx
import { jsx as jsx1065, jsxs as jsxs1058 } from "react/jsx-runtime";
function SvgXboxServicesCloudStream({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1058(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1065("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1065("path", { d: "M2048 896q0 80-30 149t-82 122-123 83-149 30H512q-106 0-199-40t-163-109T40 968 0 768q0-106 40-199t109-163 163-110 200-40q46 0 93 9 40-62 92-111t115-84 132-52 144-18q111 0 209 39t175 107 125 163 64 203q80 0 150 30t123 81 83 122 31 151zm-384 256q53 0 99-20t82-55 55-81 20-100q0-53-20-99t-55-82-81-55-100-20h-128v-64q0-93-35-174t-96-143-142-96-175-35q-70 0-135 21t-119 59-97 91-67 120q-75-35-158-35-80 0-149 30t-122 82-83 123-30 149q0 80 30 149t82 122 122 83 150 30h1152zM525 1717q100 98 227 149t267 52q142 0 272-54t231-154l92 92q-119 119-273 182t-323 64q-165 0-316-61t-268-178l91-92zm806-196l92 92q-81 81-185 125t-219 45q-113 0-215-43t-182-122l92-92q62 61 140 94t165 33q89 0 169-34t143-98z" })
      ]
    }
  );
}
var XboxServicesCloudStream_default = SvgXboxServicesCloudStream;

// src/components/Icon/icons/XboxServicesCloudStreamSolid.tsx
import { jsx as jsx1066, jsxs as jsxs1059 } from "react/jsx-runtime";
function SvgXboxServicesCloudStreamSolid({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1059(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1066("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1066("path", { d: "M1522 1710l92 92q-121 121-273 183t-323 63q-168 0-316-60t-268-179l91-92q102 99 226 150t268 51q70 0 139-14t133-40 122-65 109-89zm-503 73q-112 0-215-43t-182-122l92-92q61 61 139 94t166 33q91 0 170-34t142-98l92 92q-82 82-185 126t-219 44zm1029-887q0 80-30 150t-82 122-122 82-150 30H512q-106 0-199-40t-163-109T40 968 0 768q0-106 40-199t109-163 163-110 200-40q46 0 93 9 83-126 207-195t276-70q111 0 209 39t174 107 126 163 64 203q80 0 150 30t123 81 83 122 31 151z" })
      ]
    }
  );
}
var XboxServicesCloudStreamSolid_default = SvgXboxServicesCloudStreamSolid;

// src/components/Icon/icons/XboxServicesConsoleStream.tsx
import { jsx as jsx1067, jsxs as jsxs1060 } from "react/jsx-runtime";
function SvgXboxServicesConsoleStream({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1060(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1067("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1067("path", { d: "M0 896h2048v896H256v-256H0V896zm1920 768v-128H384v128h1536zm0-256v-384H128v384h1792zm-320-128q-26 0-45-19t-19-45q0-26 19-45t45-19q26 0 45 19t19 45q0 26-19 45t-45 19zm-78-814q-101-100-231-154t-272-54q-140 0-267 51T525 459l-91-92q117-116 268-177t316-62q169 0 323 63t273 183l-92 92zm-900 92q80-79 182-122t215-43q115 0 219 44t185 126l-92 92q-63-63-143-97t-169-35q-87 0-165 33t-140 94l-92-92z" })
      ]
    }
  );
}
var XboxServicesConsoleStream_default = SvgXboxServicesConsoleStream;

// src/components/Icon/icons/XboxSocial.tsx
import { jsx as jsx1068, jsxs as jsxs1061 } from "react/jsx-runtime";
function SvgXboxSocial({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1061(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1068("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1068("path", { d: "M1920 1550v114h-128v-204q0-38-4-76t-9-73-17-62q-16-36-41-54t-63-29q-67 54-147 82t-167 29q-84 0-163-27t-145-78q-12 5-23 11t-23 14q58 27 90 76t49 109 19 125 4 124v161h-128v-204q0-38-4-76t-9-73-17-62q-16-36-41-54t-63-29q-67 54-147 82t-167 29q-87 0-167-28t-148-83q-36 12-62 30t-41 54q-11 25-17 60t-9 75-3 78-1 74v127H0v-133q0-36 1-79t5-88 12-87 22-76q16-37 38-64t50-47 61-33 71-24l34-9q60 59 128 92t154 33q34 0 69-7t68-19 64-32 55-43l3-3q1-1 3-4 24-31 48-53t52-37 57-28 67-27q32 29 63 52t65 39 71 25 83 9q85 0 153-33t128-92q45 12 87 25t81 41q45 32 70 79t38 102 16 113 3 112v54zm-576-526q-66 0-124-25t-102-68-69-102-25-125q0-66 25-124t68-101 102-69 125-26q66 0 124 25t101 69 69 102 26 124q0 66-25 124t-69 102-102 69-124 25zm0-512q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15zm-768 640q-66 0-124-25t-102-68-69-102-25-125q0-66 25-124t68-101 102-69 125-26q66 0 124 25t101 69 69 102 26 124q0 66-25 124t-69 102-102 69-124 25zm0-512q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15z" })
      ]
    }
  );
}
var XboxSocial_default = SvgXboxSocial;

// src/components/Icon/icons/Xenon.tsx
import { jsx as jsx1069, jsxs as jsxs1062 } from "react/jsx-runtime";
function SvgXenon({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1062(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1069("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1069("path", { d: "M492 158q-4 0-5-1v-2l2-3Q614 77 746 39t278-39q143 0 277 38t256 113l3 2q-3 5-6 5-8 0-17-2t-17-4q-9-1-18-1t-18 0q-47 0-95 9t-96 24-92 34-88 39q-22 11-44 21t-43 25h-5q-43-27-100-54t-120-49-123-36-113-14q-19 0-39 4t-34 4zm251 412q-44 53-101 128T525 862t-117 184-102 189-72 180-28 156q0 17 2 37t8 36l-1 2-2 1-4-2q-103-139-156-293T0 1024q0-98 20-199t60-196 96-180 130-153q5-4 15-5t15-2q30 0 66 14t75 38 76 53 74 60 65 59 51 50l1 4-1 3zm968-281q7 0 16 1t15 6q73 71 130 155t96 178 59 194 21 201q0 173-53 328t-156 293l-6 1-2-3q3-4 5-14t3-21 2-22 1-16q0-69-27-155t-72-180-102-190-117-184-117-163-102-129l-1-3 1-3q21-21 50-49t65-58 73-61 77-53 75-38 66-15zm-687 533q29 18 56 42t54 47q42 37 102 94t127 128 131 149 117 155 84 149 32 129q0 23-6 43t-23 37q-31 31-69 57t-76 49q-120 72-254 109t-275 38q-141 0-274-37t-255-110q-17-10-43-26t-51-37-47-40-27-39q-7-20-7-45 0-54 30-122t78-142 110-149 123-142 118-123 97-92q34-30 72-64t76-58z" })
      ]
    }
  );
}
var Xenon_default = SvgXenon;

// src/components/Icon/icons/Xgp.tsx
import { jsx as jsx1070, jsxs as jsxs1063 } from "react/jsx-runtime";
function SvgXgp({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1063(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 1536 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1070("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1070("path", { d: "M1326 941q0 50-31 72t-77 22h-53V854h60q45 0 73 19t28 68zm210-301v768H0V640h1536zm-988 640l-155-249 152-244h-93l-92 165q-10 19-17 35h-1q-22-52-50-101t-55-99H137l149 245-162 248h99l104-181q3-5 5-11t5-12h2l4 12q2 6 6 11l101 181h98zm436-268H799v69h104v117q-20 11-43 15t-46 5q-41 0-71-14t-50-39-29-58-10-71q0-40 12-74t36-59 57-39 74-15q36 0 70 9t65 29v-84q-32-14-67-19t-71-5q-57 0-105 19t-83 53-54 83-20 106q0 56 17 101t49 78 77 51 101 18q45 0 88-10t84-32v-234zm428-74q0-40-14-69t-38-47-57-26-70-9h-149v493h81v-179h66q37 0 70-10t58-31 39-51 14-71z" })
      ]
    }
  );
}
var Xgp_default = SvgXgp;

// src/components/Icon/icons/XgpInline.tsx
import { jsx as jsx1071, jsxs as jsxs1064 } from "react/jsx-runtime";
function SvgXgpInline({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1064(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2947 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1071("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1071("path", { d: "M2544 1152q0 48-16 82t-43 55-66 32-82 11h-102V985h115q42 0 77 9t62 29 40 51 15 78zm403-577v1473H0V575h2947zM1051 1802l-297-477 292-468H867l-176 316q-19 35-33 67h-2q-7-17-15-33t-16-32L455 857H263l286 470-311 475h190l199-347q6-11 10-22t10-22h3q4 12 9 22t11 22l193 347h188zm837-514h-355v133h200v224q-39 20-82 29t-89 9q-79 0-136-27t-96-74-56-111-19-137q0-76 24-142t69-114 108-75 142-28q69 0 135 17t124 56V887q-63-26-130-36t-135-10q-110 0-202 37t-159 103-104 158-37 203q0 107 33 194t93 150 147 97 195 35q88 0 170-19t160-62v-449zm821-142q0-78-27-133t-74-89-109-51-133-16h-286v945h155v-343h127q72 0 135-20t111-59 74-98 27-136z" })
      ]
    }
  );
}
var XgpInline_default = SvgXgpInline;

// src/components/Icon/icons/ZoomIn.tsx
import { jsx as jsx1072, jsxs as jsxs1065 } from "react/jsx-runtime";
function SvgZoomIn({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1065(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1072("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1072("path", { d: "M2029 1939q19 19 19 45t-19 45-45 19q-26 0-45-19l-785-784q-97 80-211 121t-239 42q-97 0-187-25t-168-71-143-110-110-142-71-169T0 704q0-97 25-187t71-168 110-143T348 96t169-71T704 0q97 0 187 25t168 71 143 110 110 142 71 169 25 187q0 126-42 240t-121 211l784 784zM704 1280q119 0 224-45t183-124 123-183 46-224q0-119-45-224t-124-183-183-123-224-46q-119 0-224 45T297 297 174 480t-46 224q0 119 45 224t124 183 183 123 224 46zm64-640h256v128H768v256H640V768H384V640h256V384h128v256z" })
      ]
    }
  );
}
var ZoomIn_default = SvgZoomIn;

// src/components/Icon/icons/ZoomOut.tsx
import { jsx as jsx1073, jsxs as jsxs1066 } from "react/jsx-runtime";
function SvgZoomOut({ title: title3, titleId, ...props }) {
  return /* @__PURE__ */ jsxs1066(
    "svg",
    {
      "aria-labelledby": titleId,
      height: "1em",
      viewBox: "0 0 2048 2048",
      width: "1em",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children: [
        title3 ? /* @__PURE__ */ jsx1073("title", { id: titleId, children: title3 }) : null,
        /* @__PURE__ */ jsx1073("path", { d: "M2029 1939q19 19 19 45t-19 45-45 19q-26 0-45-19l-785-784q-97 80-211 121t-239 42q-97 0-187-25t-168-71-143-110-110-142-71-169T0 704q0-97 25-187t71-168 110-143T348 96t169-71T704 0q97 0 187 25t168 71 143 110 110 142 71 169 25 187q0 126-42 240t-121 211l784 784zM704 1280q119 0 224-45t183-124 123-183 46-224q0-119-45-224t-124-183-183-123-224-46q-119 0-224 45T297 297 174 480t-46 224q0 119 45 224t124 183 183 123 224 46zm320-640v128H384V640h640z" })
      ]
    }
  );
}
var ZoomOut_default = SvgZoomOut;

// src/components/Checkbox/Checkbox.tsx
import { forwardRef as forwardRef15, useId as useId4 } from "react";

// src/components/Checkbox/Checkbox.css.ts
import { createRuntimeFn as _7a46814 } from "@vanilla-extract/recipes/createRuntimeFn";
var checkbox2 = _7a46814({ defaultClassName: "Checkbox__itnbom4 Checkbox_baseContainer__itnbom0", variantClassNames: { labelPosition: { start: "Checkbox_checkbox_labelPosition_start__itnbom5", end: "Checkbox_checkbox_labelPosition_end__itnbom6" } }, defaultVariants: { labelPosition: "end" }, compoundVariants: [] });
var input2 = "Checkbox_input__itnbom1";
var label3 = "Checkbox_label__itnbom3";
var visual = "Checkbox_visual__itnbom2";

// src/components/Checkbox/CheckboxVisual.tsx
import { jsx as jsx1074 } from "react/jsx-runtime";
function CheckboxVisual({ checked = false, indeterminate = false, disabled: _disabled = false, className, onClick }) {
  const getIconComponent = () => {
    if (indeterminate) {
      return CheckBox_default;
    }
    if (checked) {
      return CheckBoxChecked_default;
    }
    return CheckBox_default;
  };
  const handleKeyDown = (event) => {
    if (onClick && (event.key === "Enter" || event.key === " ")) {
      event.preventDefault();
      onClick();
    }
  };
  const isInteractive = !!onClick;
  return /* @__PURE__ */ jsx1074(
    "div",
    {
      className,
      role: isInteractive ? "button" : void 0,
      style: { cursor: isInteractive ? "pointer" : void 0 },
      ...isInteractive && { tabIndex: 0 },
      onClick,
      onKeyDown: isInteractive ? handleKeyDown : void 0,
      children: /* @__PURE__ */ jsx1074(
        Icon,
        {
          "aria-hidden": "true",
          icon: getIconComponent(),
          iconSize: "small" /* Small */
        }
      )
    }
  );
}

// src/components/Checkbox/Checkbox.tsx
import { jsx as jsx1075, jsxs as jsxs1067 } from "react/jsx-runtime";
var Checkbox = forwardRef15(
  // eslint-disable-next-line complexity
  ({
    label: labelText,
    checked = false,
    indeterminate = false,
    disabled = false,
    labelPosition = "end",
    className,
    onChange,
    id,
    ...props
  }, ref) => {
    const generatedId = useId4();
    const checkboxId = id || generatedId;
    const handleChange = (event) => {
      if (onChange) {
        onChange(event.target.checked, event);
      }
    };
    const handleVisualClick = () => {
      const inputElement = document.getElementById(checkboxId);
      if (inputElement) {
        inputElement.click();
      }
    };
    const checkboxClasses = checkbox2({
      labelPosition
    });
    const combinedClassName = className ? `${checkboxClasses} ${className}` : checkboxClasses;
    const hasLabel = labelText && labelText.trim().length > 0;
    return /* @__PURE__ */ jsxs1067(
      "div",
      {
        className: combinedClassName,
        "data-checked": checked,
        "data-disabled": disabled,
        "data-indeterminate": indeterminate,
        children: [
          /* @__PURE__ */ jsx1075(
            "input",
            {
              ref,
              "aria-describedby": hasLabel ? `${checkboxId}-label` : void 0,
              checked,
              className: input2,
              disabled,
              id: checkboxId,
              type: "checkbox",
              onChange: handleChange,
              ...props
            }
          ),
          /* @__PURE__ */ jsx1075(
            CheckboxVisual,
            {
              checked,
              className: visual,
              disabled,
              indeterminate,
              onClick: !hasLabel && !disabled ? handleVisualClick : void 0
            }
          ),
          hasLabel && /* @__PURE__ */ jsx1075(
            "label",
            {
              className: label3,
              htmlFor: checkboxId,
              id: `${checkboxId}-label`,
              children: labelText
            }
          )
        ]
      }
    );
  }
);
Checkbox.displayName = "Checkbox";

// src/components/TextArea/TextArea.tsx
import React3, { useState as useState7, forwardRef as forwardRef16, useEffect as useEffect4 } from "react";

// src/components/TextArea/TextArea.css.ts
var areaBox = "TextArea_areaBox__9kanyb4";
var areaStyle = "TextArea_areaStyle__9kanyb8";
var base = "TextArea_base__9kanyb0";
var disabledState = "TextArea_disabledState__9kanyb7";
var errorState = "TextArea_errorState__9kanyb6";
var focusState = "TextArea_focusState__9kanyb5";
var label4 = "TextArea_label__9kanyb2";
var labelContainer = "TextArea_labelContainer__9kanyb1";
var requiredStyle = "TextArea_requiredStyle__9kanyb3";
var resizeStyle = "TextArea_resizeStyle__9kanyb9";

// src/components/TextArea/TextArea.tsx
import { jsx as jsx1076, jsxs as jsxs1068 } from "react/jsx-runtime";
var TextArea = forwardRef16(
  // eslint-disable-next-line complexity
  ({
    title: title3,
    placeholder: placeholder3,
    rows = 4,
    size = { width: void 0, height: 120 },
    hasError = false,
    isDisabled = false,
    requiredText,
    className,
    onFocus,
    onBlur,
    ...props
  }, ref) => {
    const [isFocused, setIsFocused] = useState7(false);
    const [taSize, setTaSize] = useState7({
      "--myWidth": size.width ? `${size.width}px` : "100%",
      "--myHeight": size.height ? `${size.height}px` : "auto"
    });
    const localRef = React3.useRef(null);
    const wrapperRef = React3.useRef(null);
    React3.useImperativeHandle(ref, () => localRef.current);
    const handleFocus = (e) => {
      setIsFocused(true);
      onFocus?.(e);
    };
    const handleBlur = (e) => {
      setIsFocused(false);
      onBlur?.(e);
    };
    const startResizing = (e) => {
      e.preventDefault();
      const handleMouseMove = (moveEvent) => {
        const rect = localRef.current?.getBoundingClientRect();
        if (rect) {
          const newWidth = Math.max(moveEvent.clientX - rect.left, size.width ?? rect.width);
          const newHeight = Math.max(moveEvent.clientY - rect.top, size.height ?? 120);
          setTaSize({
            "--myWidth": `${newWidth}px`,
            "--myHeight": `${newHeight}px`
          });
        }
      };
      const handleMouseUp = () => {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
      };
      document.addEventListener("mousemove", handleMouseMove);
      document.addEventListener("mouseup", handleMouseUp, { once: true });
    };
    const handleResizeKeyDown = (e) => {
      if (e.key === "Enter" || e.key === " ") {
        startResizing(e);
      }
    };
    useEffect4(() => {
      const styleId = "textarea-webkit-fixes";
      if (!document.getElementById(styleId)) {
        const style = document.createElement("style");
        style.id = styleId;
        style.textContent = `
          textarea:-webkit-autofill,
          textarea:-webkit-autofill:hover,
          textarea:-webkit-autofill:focus,
          textarea:-webkit-autofill:active {
            -webkit-background-clip: text !important;
            -webkit-text-fill-color: ${xdsVars.colors.contentPrimary} !important;
            background-color: transparent !important;
            box-shadow: inset 0 0 0 1000px transparent !important;
            transition: background-color 5000s ease-in-out 0s !important;
          }
        `;
        document.head.appendChild(style);
      }
    }, []);
    return /* @__PURE__ */ jsxs1068("div", { className: `${base} ${className || ""}`, children: [
      title3 && /* @__PURE__ */ jsxs1068("div", { className: labelContainer, children: [
        /* @__PURE__ */ jsxs1068("label", { className: label4, children: [
          title3,
          props.required && /* @__PURE__ */ jsx1076("span", { style: { color: xdsVars.colors.contentError, marginLeft: "4px" }, children: "*" })
        ] }),
        requiredText && /* @__PURE__ */ jsx1076("span", { className: requiredStyle, children: requiredText })
      ] }),
      /* @__PURE__ */ jsxs1068(
        "div",
        {
          ref: wrapperRef,
          className: `${areaBox} ${hasError ? errorState : ""} ${isFocused ? focusState : ""} ${isDisabled ? disabledState : ""}`,
          role: "button",
          style: taSize,
          tabIndex: 0,
          onClick: () => localRef.current?.focus(),
          onKeyDown: (e) => {
            if (e.key === "Enter" || e.key === " ") {
              localRef.current?.focus();
            }
          },
          children: [
            /* @__PURE__ */ jsx1076(
              "textarea",
              {
                ref: localRef,
                className: areaStyle,
                disabled: isDisabled,
                placeholder: placeholder3,
                rows,
                onBlur: handleBlur,
                onFocus: handleFocus,
                ...props
              }
            ),
            /* @__PURE__ */ jsx1076(
              "button",
              {
                "aria-label": "Resize textarea",
                className: resizeStyle,
                disabled: isDisabled,
                type: "button",
                onKeyDown: handleResizeKeyDown,
                onMouseDown: startResizing,
                children: /* @__PURE__ */ jsx1076("svg", { "aria-hidden": "true", fill: "currentColor", height: "16", viewBox: "0 0 16 16", width: "16", children: /* @__PURE__ */ jsx1076("path", { d: "M16 16H14L16 14V16ZM16 11.5L11.5 16H9.5L16 9.5V11.5ZM16 7L7 16H5L16 5V7ZM16 2.5L2.5 16H0.5L16 0.5V2.5Z" }) })
              }
            )
          ]
        }
      )
    ] });
  }
);
TextArea.displayName = "TextArea";

// src/components/Shimmer/Shimmer.tsx
import React4, { useRef as useRef5 } from "react";

// src/components/Shimmer/Shimmer.css.ts
var shimmerVisual = "Shimmer_shimmerVisual__171ljp1";

// src/components/Shimmer/Shimmer.tsx
import { jsx as jsx1077 } from "react/jsx-runtime";
var cn2 = (...args) => args.flat().map((arg) => {
  if (typeof arg === "string") {
    return arg;
  }
  if (typeof arg === "object" && arg !== null) {
    return Object.entries(arg).filter(([, value]) => value).map(([key]) => key).join(" ");
  }
  return "";
}).filter(Boolean).join(" ");
var Shimmer = React4.forwardRef(
  ({ label: label5, className, ...props }, forwardedRef) => {
    const internalRef = useRef5(null);
    const ref = forwardedRef || internalRef;
    return /* @__PURE__ */ jsx1077(
      "div",
      {
        ref,
        "data-shimmer-visual": true,
        "aria-label": label5,
        className: cn2(shimmerVisual, className),
        role: "img",
        ...props
      }
    );
  }
);
Shimmer.displayName = "Shimmer";

// src/components/Switch/Switch.tsx
import { useId as useId5 } from "react";

// src/components/Switch/Switch.css.ts
import { createRuntimeFn as _7a46815 } from "@vanilla-extract/recipes/createRuntimeFn";
var srOnly2 = "Switch_srOnly__14r3rp4m";
var switchContainer = { base: "Switch_baseSwitchContainer__14r3rp40", sizes: { small: "Switch_smallSize__14r3rp41", medium: "Switch_mediumSize__14r3rp42", large: "Switch_largeSize__14r3rp43" }, states: { disabled: "Switch_disabledStyle__14r3rp44" } };
var toggleKnob = _7a46815({ defaultClassName: "Switch__14r3rp4h Switch_toggleKnob_base__14r3rp4e", variantClassNames: { checked: { true: "Switch_toggleKnob_variants_checked_true__14r3rp4f", false: "Switch_toggleKnob_variants_checked_false__14r3rp4g" }, disabled: { true: "Switch_toggleKnob_disabled_true__14r3rp4k", false: "Switch_toggleKnob_disabled_false__14r3rp4l" } }, defaultVariants: { checked: false, disabled: false }, compoundVariants: [] });
var toggleTrack = _7a46815({ defaultClassName: "Switch__14r3rp48 Switch_toggleTrack_base__14r3rp45", variantClassNames: { checked: { true: "Switch_toggleTrack_variants_checked_true__14r3rp46", false: "Switch_toggleTrack_variants_checked_false__14r3rp47" }, disabled: { true: "Switch_toggleTrack_disabled_true__14r3rp4b", false: "Switch_toggleTrack_disabled_false__14r3rp4c" } }, defaultVariants: { checked: false, disabled: false }, compoundVariants: [[{ checked: true, disabled: true }, "Switch_toggleTrack_compound_0__14r3rp4d"]] });

// src/components/Switch/Switch.tsx
import { jsx as jsx1078, jsxs as jsxs1069 } from "react/jsx-runtime";
function Switch({
  checked,
  className,
  disabled = false,
  id: propId,
  inputProps,
  label: label5,
  onChange,
  size = "medium",
  ...rest
}) {
  const generatedId = useId5();
  const id = propId || `switch-${generatedId}`;
  const labelId = `${id}-label`;
  const handleChange = (event) => {
    if (!disabled) {
      onChange(event.target.checked);
    }
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      if (!disabled) {
        onChange(!checked);
      }
    }
  };
  return /* @__PURE__ */ jsxs1069(
    "div",
    {
      className: `${switchContainer.base} ${switchContainer.sizes[size]} ${disabled ? switchContainer.states.disabled : ""} ${className || ""}`,
      children: [
        label5 && /* @__PURE__ */ jsx1078("label", { className: srOnly2, htmlFor: id, id: labelId, children: label5 }),
        /* @__PURE__ */ jsx1078(
          "input",
          {
            "aria-checked": checked,
            "aria-labelledby": label5 ? labelId : void 0,
            checked,
            className: srOnly2,
            disabled,
            id,
            type: "checkbox",
            ...inputProps,
            ...rest,
            onChange: handleChange,
            onKeyDown: handleKeyDown
          }
        ),
        /* @__PURE__ */ jsx1078(
          "div",
          {
            "aria-hidden": "true",
            className: toggleTrack({ checked, disabled }),
            onClick: () => {
              if (!disabled) {
                onChange(!checked);
              }
            },
            children: /* @__PURE__ */ jsx1078("div", { className: toggleKnob({ checked, disabled }) })
          }
        )
      ]
    }
  );
}

// src/components/Carousel/Carousel.tsx
import { useCallback as useCallback3, useEffect as useEffect5, useRef as useRef6, useState as useState8 } from "react";

// src/components/Carousel/Carousel.css.ts
var carouselContainer = "Carousel_carouselContainer__52wln57";
var carouselContent = "Carousel_carouselContent__52wln59";
var carouselItem = "Carousel_carouselItem__52wln5a";
var carouselWrapper = "Carousel_carouselWrapper__52wln50";
var hoverNavigationLeft = "Carousel_hoverNavigationLeft__52wln5c Carousel_hoverNavigationButtons__52wln5b";
var hoverNavigationRight = "Carousel_hoverNavigationRight__52wln5d Carousel_hoverNavigationButtons__52wln5b";
var snapToCenter = "Carousel_snapToCenter__52wln58";

// src/components/Carousel/Carousel.tsx
import { jsx as jsx1079, jsxs as jsxs1070 } from "react/jsx-runtime";
var FOCUS_PADDING = 12;
function useSnapToOffsets(data, options) {
  const { landscape, cardWidth, paddingHorizontal, moduleWidth, insets = { left: 0, right: 0 } } = options;
  const runningValue = useRef6(0);
  return useState8(() => {
    if (data === null || data === void 0) {
      return [];
    }
    const insetOffset = insets.left + insets.right;
    const contentSize = moduleWidth - 2 * paddingHorizontal - insetOffset;
    const marginHorizontal = (contentSize - cardWidth) / 2;
    return data.map((_, index) => {
      if (index === 0) {
        runningValue.current = 0;
      } else if (index === 1) {
        runningValue.current += landscape ? cardWidth + paddingHorizontal - marginHorizontal : cardWidth + paddingHorizontal;
      } else {
        runningValue.current += landscape ? cardWidth + 2 * paddingHorizontal : cardWidth + paddingHorizontal;
      }
      return runningValue.current;
    });
  })[0];
}
function Carousel({
  data,
  renderItem,
  moduleWidth,
  cardSize,
  paddingHorizontal = 16,
  itemContainerStyle,
  landscape = false,
  onScroll,
  insets,
  snapToCenter: snapToCenter2 = true
}) {
  const containerRef = useRef6(null);
  const [scrollLeft, setScrollLeft] = useState8(0);
  const [canScrollLeft, setCanScrollLeft] = useState8(false);
  const [canScrollRight, setCanScrollRight] = useState8(false);
  const _snapOffsets = useSnapToOffsets(data, {
    landscape,
    cardWidth: cardSize.width,
    paddingHorizontal,
    moduleWidth: moduleWidth || 800,
    insets
  });
  const updateScrollState = useCallback3(() => {
    if (!containerRef.current) {
      return;
    }
    const { scrollLeft: currentScrollLeft, scrollWidth, clientWidth } = containerRef.current;
    setScrollLeft(currentScrollLeft);
    setCanScrollLeft(currentScrollLeft > 0);
    setCanScrollRight(currentScrollLeft < scrollWidth - clientWidth - 1);
    onScroll?.(currentScrollLeft);
  }, [onScroll]);
  const scrollTo = useCallback3(
    (direction) => {
      if (!containerRef.current) {
        return;
      }
      const scrollAmount = cardSize.width + paddingHorizontal;
      const newScrollLeft = direction === "left" ? Math.max(0, scrollLeft - scrollAmount) : scrollLeft + scrollAmount;
      containerRef.current.scrollTo({
        left: newScrollLeft,
        behavior: "smooth"
      });
    },
    [scrollLeft, cardSize.width, paddingHorizontal]
  );
  const handleScroll = useCallback3(() => {
    updateScrollState();
  }, [updateScrollState]);
  const handleKeyDown = useCallback3(
    (event) => {
      if (event.key === "ArrowLeft" && canScrollLeft) {
        event.preventDefault();
        scrollTo("left");
      } else if (event.key === "ArrowRight" && canScrollRight) {
        event.preventDefault();
        scrollTo("right");
      }
    },
    [canScrollLeft, canScrollRight, scrollTo]
  );
  useEffect5(() => {
    updateScrollState();
  }, [data, updateScrollState]);
  useEffect5(() => {
    const container6 = containerRef.current;
    if (!container6) {
      return;
    }
    container6.addEventListener("scroll", handleScroll, { passive: true });
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      container6.removeEventListener("scroll", handleScroll);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleScroll, handleKeyDown]);
  if (!data || data.length === 0) {
    return null;
  }
  const contentContainerStyle = insets ? {
    paddingLeft: insets.left,
    paddingRight: insets.right
  } : {
    paddingLeft: 0,
    paddingRight: 0
  };
  return /* @__PURE__ */ jsx1079("div", { className: carouselWrapper, style: { width: moduleWidth || "100%" }, children: /* @__PURE__ */ jsxs1070(
    "div",
    {
      ref: containerRef,
      className: `${carouselContainer} ${snapToCenter2 ? snapToCenter : ""}`,
      style: {
        height: cardSize.height + FOCUS_PADDING,
        ...contentContainerStyle
      },
      children: [
        canScrollLeft && /* @__PURE__ */ jsx1079("div", { className: hoverNavigationLeft, children: /* @__PURE__ */ jsx1079(
          IconButton,
          {
            "aria-label": "Scroll left",
            buttonSize: "Medium" /* Medium */,
            icon: ChevronLeft_default,
            iconSize: "xSmall" /* XSmall */,
            onClick: () => scrollTo("left")
          }
        ) }),
        canScrollRight && /* @__PURE__ */ jsx1079("div", { className: hoverNavigationRight, children: /* @__PURE__ */ jsx1079(
          IconButton,
          {
            "aria-label": "Scroll right",
            buttonSize: "Medium" /* Medium */,
            icon: ChevronRight_default,
            iconSize: "xSmall" /* XSmall */,
            onClick: () => scrollTo("right")
          }
        ) }),
        /* @__PURE__ */ jsx1079("div", { className: carouselContent, children: data.map((item, index) => {
          const key = item?.id || `carousel-item-${index}`;
          return /* @__PURE__ */ jsx1079(
            "div",
            {
              className: `${carouselItem} ${itemContainerStyle || ""}`,
              style: {
                width: cardSize.width,
                height: cardSize.height,
                marginRight: index < data.length - 1 ? paddingHorizontal : 0
              },
              children: renderItem({ item, index })
            },
            key
          );
        }) })
      ]
    }
  ) });
}

// src/components/Dialog/Dialog.tsx
import { useEffect as useEffect6, useRef as useRef7, useState as useState9 } from "react";
import { createPortal as createPortal2 } from "react-dom";

// src/components/Dialog/Dialog.css.ts
var accentButton = "Dialog_accentButton__68ru2bk";
var actions = "Dialog_actions__68ru2be";
var aiButton = "Dialog_aiButton__68ru2bj";
var backdrop = "Dialog_backdrop__68ru2b1";
var button2 = "Dialog_button__68ru2bf";
var closeButton2 = "Dialog_closeButton__68ru2b9";
var content2 = "Dialog_content__68ru2bd";
var dangerButton = "Dialog_dangerButton__68ru2bi";
var description = "Dialog_description__68ru2bc";
var dialog = "Dialog_dialog__68ru2b2";
var header = "Dialog_header__68ru2ba";
var lg = "Dialog_lg__68ru2b5";
var md = "Dialog_md__68ru2b4";
var primaryButton = "Dialog_primaryButton__68ru2bg";
var secondaryButton = "Dialog_secondaryButton__68ru2bh";
var sm = "Dialog_sm__68ru2b3";
var title = "Dialog_title__68ru2bb";
var xl = "Dialog_xl__68ru2b6";
var xxl = "Dialog_xxl__68ru2b7";
var xxxl = "Dialog_xxxl__68ru2b8";

// src/components/Dialog/Dialog.tsx
import { jsx as jsx1080, jsxs as jsxs1071 } from "react/jsx-runtime";
function CloseButton({ onClose }) {
  return /* @__PURE__ */ jsx1080(
    "button",
    {
      "aria-label": "Close",
      className: closeButton2,
      onClick: (e) => {
        e.stopPropagation();
        onClose();
      },
      children: /* @__PURE__ */ jsx1080("svg", { fill: "none", height: "16", viewBox: "0 0 24 24", width: "16", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx1080("path", { d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z", fill: "currentColor" }) })
    }
  );
}
function DialogHeader({ title: title3, description: description3 }) {
  if (!title3) {
    return null;
  }
  return /* @__PURE__ */ jsxs1071("div", { className: header, children: [
    /* @__PURE__ */ jsx1080("h2", { className: title, children: title3 }),
    description3 && /* @__PURE__ */ jsx1080("p", { className: description, children: description3 })
  ] });
}
function getButtonVariantClass(variant = "primary") {
  switch (variant) {
    case "primary":
      return primaryButton;
    case "secondary":
      return secondaryButton;
    case "danger":
      return dangerButton;
    case "ai":
      return aiButton;
    case "accent":
      return accentButton;
    default:
      return primaryButton;
  }
}
function getSizeClass(size) {
  switch (size) {
    case "sm":
      return sm;
    case "md":
      return md;
    case "lg":
      return lg;
    case "xl":
      return xl;
    case "xxl":
      return xxl;
    case "xxxl":
      return xxxl;
    default:
      return md;
  }
}
function renderButtonLabel(label5) {
  if (typeof label5 === "string") {
    return label5.toUpperCase();
  }
  return label5;
}
function DialogActions({
  primaryAction,
  secondaryAction,
  cancelAction,
  onCancel
}) {
  if (!primaryAction && !secondaryAction && !cancelAction) {
    return null;
  }
  return /* @__PURE__ */ jsxs1071("div", { className: actions, children: [
    primaryAction && /* @__PURE__ */ jsx1080(
      "button",
      {
        className: `${button2} ${getButtonVariantClass(primaryAction.variant)}`,
        disabled: primaryAction.disabled,
        style: { flex: 1 },
        onClick: (e) => {
          e.stopPropagation();
          primaryAction.onClick();
        },
        children: renderButtonLabel(primaryAction.label)
      }
    ),
    cancelAction && onCancel && /* @__PURE__ */ jsx1080(
      "button",
      {
        className: `${button2} ${secondaryButton}`,
        disabled: cancelAction.disabled,
        style: { flex: 1 },
        onClick: (e) => {
          e.stopPropagation();
          onCancel();
        },
        children: renderButtonLabel(cancelAction.label)
      }
    ),
    secondaryAction && /* @__PURE__ */ jsx1080(
      "button",
      {
        className: `${button2} ${getButtonVariantClass(secondaryAction.variant || "secondary")}`,
        disabled: secondaryAction.disabled,
        style: { flex: 1 },
        onClick: (e) => {
          e.stopPropagation();
          secondaryAction.onClick();
        },
        children: renderButtonLabel(secondaryAction.label)
      }
    )
  ] });
}
function Dialog({
  isOpen,
  onClose,
  title: title3,
  customHeader,
  description: description3,
  children,
  primaryAction,
  secondaryAction,
  cancelAction,
  size = "md",
  showCloseButton = true,
  className
}) {
  const dialogRef = useRef7(null);
  const [isVisible, setIsVisible] = useState9(false);
  const handleClose = () => {
    onClose();
  };
  useEffect6(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 50);
      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [isOpen]);
  useDialogEventListeners(isOpen, handleClose, dialogRef);
  if (!isOpen) {
    return null;
  }
  return createPortal2(
    /* @__PURE__ */ jsx1080(
      "div",
      {
        className: backdrop,
        style: {
          opacity: isVisible ? 1 : 0,
          pointerEvents: isVisible ? "auto" : "none"
          // Prevent interaction when invisible
        },
        children: /* @__PURE__ */ jsxs1071(
          "div",
          {
            ref: dialogRef,
            className: `${dialog} ${getSizeClass(size)} ${className || ""}`,
            style: {
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? "translateY(0)" : "translateY(-20px)"
            },
            children: [
              showCloseButton && /* @__PURE__ */ jsx1080(CloseButton, { onClose: handleClose }),
              customHeader ? /* @__PURE__ */ jsx1080("div", { className: header, children: customHeader }) : /* @__PURE__ */ jsx1080(DialogHeader, { description: description3, title: title3 }),
              /* @__PURE__ */ jsx1080("div", { className: content2, children }),
              /* @__PURE__ */ jsx1080(DialogActions, { cancelAction, primaryAction, secondaryAction, onCancel: handleClose })
            ]
          }
        )
      }
    ),
    document.body
  );
}
function useDialogEventListeners(isOpen, handleClose, dialogRef) {
  useEffect6(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && isOpen) {
        handleClose();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, handleClose]);
  useEffect6(() => {
  }, [isOpen, handleClose, dialogRef]);
  useEffect6(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);
}

// src/components/Card/Card.tsx
import { forwardRef as forwardRef17 } from "react";

// src/components/Card/Card.css.ts
import { createRuntimeFn as _7a46816 } from "@vanilla-extract/recipes/createRuntimeFn";
var card = _7a46816({ defaultClassName: "Card__1a298ne1 Card_baseCard__1a298ne0", variantClassNames: { padding: { none: "Card_card_padding_none__1a298ne2", small: "Card_card_padding_small__1a298ne3", medium: "Card_card_padding_medium__1a298ne4", large: "Card_card_padding_large__1a298ne5" }, elevation: { none: "Card_card_elevation_none__1a298ne6", low: "Card_card_elevation_low__1a298ne7", medium: "Card_card_elevation_medium__1a298ne8", high: "Card_card_elevation_high__1a298ne9" }, width: { auto: "Card_card_width_auto__1a298nea", full: "Card_card_width_full__1a298neb", sm: "Card_card_width_sm__1a298nec", md: "Card_card_width_md__1a298ned", fixed: "Card_card_width_fixed__1a298nee", lg: "Card_card_width_lg__1a298nef", xl: "Card_card_width_xl__1a298neg" }, backgroundColor: { "default": "Card_card_backgroundColor_default__1a298neh", primary: "Card_card_backgroundColor_primary__1a298nei", success: "Card_card_backgroundColor_success__1a298nej", error: "Card_card_backgroundColor_error__1a298nek", warning: "Card_card_backgroundColor_warning__1a298nel", info: "Card_card_backgroundColor_info__1a298nem", green: "Card_card_backgroundColor_green__1a298nen", blue: "Card_card_backgroundColor_blue__1a298neo", purple: "Card_card_backgroundColor_purple__1a298nep", red: "Card_card_backgroundColor_red__1a298neq", orange: "Card_card_backgroundColor_orange__1a298ner", yellow: "Card_card_backgroundColor_yellow__1a298nes" }, centered: { true: "Card_card_centered_true__1a298net" } }, defaultVariants: { padding: "medium", elevation: "medium", width: "auto", backgroundColor: "default", centered: false }, compoundVariants: [] });
var checkmarkIcon = "Card_checkmarkIcon__1a298new";
var selectableCard = "Card_selectableCard__1a298neu";
var selectedCard = "Card_selectedCard__1a298nev";

// src/components/Card/Card.tsx
import { jsx as jsx1081, jsxs as jsxs1072 } from "react/jsx-runtime";
function buildClassNames(baseClass, selectableClasses, additionalClass) {
  const classNames = [baseClass, ...selectableClasses];
  if (additionalClass) {
    classNames.push(additionalClass);
  }
  return classNames.join(" ");
}
function getSelectableClasses(isSelectable, isSelected) {
  if (!isSelectable) {
    return [];
  }
  return isSelected ? [selectableCard, selectedCard] : [selectableCard];
}
function createKeyHandler(isSelectable, onClick, onKeyDown) {
  return (e) => {
    if (isSelectable && (e.key === "Enter" || e.key === " ")) {
      e.preventDefault();
      onClick?.(e);
    }
    onKeyDown?.(e);
  };
}
function CheckmarkIcon() {
  return /* @__PURE__ */ jsx1081("div", { className: checkmarkIcon, children: /* @__PURE__ */ jsx1081("svg", { fill: "none", height: "14", viewBox: "0 0 14 14", width: "14", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx1081("path", { d: "M5.5 9.5L2.5 6.5L1.5 7.5L5.5 11.5L12.5 4.5L11.5 3.5L5.5 9.5Z", fill: "white", stroke: "white", strokeWidth: "0.5" }) }) });
}
function getElementProps(config) {
  const { isSelectable, className, onClick, onKeyDown, otherProps } = config;
  return {
    className,
    role: isSelectable ? "button" : void 0,
    tabIndex: isSelectable ? 0 : void 0,
    onClick,
    onKeyDown,
    ...otherProps
  };
}
function createClickHandler(onClick, onSelect) {
  return onClick || (onSelect ? () => onSelect() : void 0);
}
var Card = forwardRef17(
  ({
    children,
    padding = "medium",
    elevation = "medium",
    width = "auto",
    backgroundColor = "default",
    centered = false,
    as = "div",
    className: _className,
    isSelected = false,
    onClick,
    onSelect,
    onKeyDown,
    ...props
  }, ref) => {
    const handleClick = createClickHandler(onClick, onSelect);
    const isSelectable = !!handleClick;
    const cardClass = card({ padding, elevation, width, backgroundColor, centered });
    const selectableClasses = getSelectableClasses(isSelectable, isSelected);
    const combinedClassName = buildClassNames(cardClass, selectableClasses, _className);
    const handleKeyDown = createKeyHandler(isSelectable, handleClick, onKeyDown);
    const elementProps = getElementProps({
      isSelectable,
      className: combinedClassName,
      onClick: handleClick,
      onKeyDown: handleKeyDown,
      otherProps: props
    });
    const Element = as;
    return /* @__PURE__ */ jsxs1072(Element, { ref, ...elementProps, children: [
      children,
      isSelectable && isSelected && /* @__PURE__ */ jsx1081(CheckmarkIcon, {})
    ] });
  }
);
Card.displayName = "Card";

// src/components/InlineTabs/InlineTabs.tsx
import { forwardRef as forwardRef18, useCallback as useCallback4, useEffect as useEffect7, useRef as useRef8, useState as useState10 } from "react";

// src/components/InlineTabs/InlineTabs.css.ts
import { createRuntimeFn as _7a46817 } from "@vanilla-extract/recipes/createRuntimeFn";
var inlineTabs = _7a46817({ defaultClassName: "InlineTabs__7nzpu3h InlineTabs_baseContainer__7nzpu30", variantClassNames: { variant: { "default": "InlineTabs_variantStyles_default__7nzpu3a", hero: "InlineTabs_variantStyles_hero__7nzpu3b" }, size: { small: "InlineTabs_containerSizeVariants_small__7nzpu34", medium: "InlineTabs_containerSizeVariants_medium__7nzpu35", large: "InlineTabs_containerSizeVariants_large__7nzpu36" } }, defaultVariants: { variant: "default", size: "medium" }, compoundVariants: [] });
var selectionIndicator = _7a46817({ defaultClassName: "InlineTabs__7nzpu312 InlineTabs_baseSelectionIndicator__7nzpu33", variantClassNames: { variant: { "default": "InlineTabs_selectionIndicator_variant_default__7nzpu313", hero: "InlineTabs_indicatorVariants_hero__7nzpu3g" }, isVisible: { true: "InlineTabs_indicatorVariants_visible__7nzpu3e", false: "InlineTabs_selectionIndicator_isVisible_false__7nzpu316" }, hasTransition: { true: "InlineTabs_indicatorVariants_transition__7nzpu3f", false: "InlineTabs_selectionIndicator_hasTransition_false__7nzpu318" } }, defaultVariants: { variant: "default", isVisible: false, hasTransition: false }, compoundVariants: [] });
var tabButton = _7a46817({ defaultClassName: "InlineTabs__7nzpu3s InlineTabs_baseTabButton__7nzpu32", variantClassNames: { isSelected: { true: "InlineTabs_buttonStateVariants_selected__7nzpu3c", false: "InlineTabs_tabButton_isSelected_false__7nzpu3u" }, isDisabled: { true: "InlineTabs_buttonStateVariants_disabled__7nzpu3d", false: "InlineTabs_tabButton_isDisabled_false__7nzpu3w" }, variant: { "default": "InlineTabs_variantStyles_default__7nzpu3a", hero: "InlineTabs_variantStyles_hero__7nzpu3b" }, size: { small: "InlineTabs_buttonSizeVariants_small__7nzpu37", medium: "InlineTabs_buttonSizeVariants_medium__7nzpu38", large: "InlineTabs_buttonSizeVariants_large__7nzpu39" } }, defaultVariants: { isSelected: false, isDisabled: false, variant: "default", size: "medium" }, compoundVariants: [] });
var tabsList = _7a46817({ defaultClassName: "InlineTabs__7nzpu3n InlineTabs_baseTabsList__7nzpu31", variantClassNames: { blurStart: { true: "InlineTabs_tabsList_blurStart_true__7nzpu3o", false: "InlineTabs_tabsList_blurStart_false__7nzpu3p" }, blurEnd: { true: "InlineTabs_tabsList_blurEnd_true__7nzpu3q", false: "InlineTabs_tabsList_blurEnd_false__7nzpu3r" } }, defaultVariants: { blurStart: false, blurEnd: false }, compoundVariants: [] });

// src/components/InlineTabs/InlineTabs.tsx
import { jsx as jsx1082, jsxs as jsxs1073 } from "react/jsx-runtime";
var TAB_FADE_WIDTH = 80;
var InlineTabs = forwardRef18(
  ({
    tabs,
    value,
    onValueChange,
    variant = "default",
    size = "medium",
    scrollBehavior = "smooth",
    className,
    "aria-label": ariaLabel,
    ...rest
  }, _ref) => {
    const containerRef = useRef8(null);
    const scrollableRef = useRef8(null);
    const selectionIndicatorRef = useRef8(null);
    const selectedButtonRef = useRef8(null);
    const buttonRefs = useRef8([]);
    const [blurStart, setBlurStart] = useState10(false);
    const [blurEnd, setBlurEnd] = useState10(true);
    const updateSelectionIndicator = useCallback4(() => {
      if (selectionIndicatorRef.current && selectedButtonRef.current) {
        const button4 = selectedButtonRef.current;
        selectionIndicatorRef.current.style.width = `${button4.offsetWidth}px`;
        selectionIndicatorRef.current.style.left = `${button4.offsetLeft}px`;
      }
    }, []);
    const updateScroll = useCallback4((element) => {
      const scrollLeft = element?.scrollLeft;
      if (scrollLeft === void 0) {
        return;
      }
      containerRef.current?.style.setProperty(
        "--leftBlurWidth",
        `${Math.min(scrollLeft, TAB_FADE_WIDTH)}px`
      );
      if (scrollLeft < TAB_FADE_WIDTH / 2) {
        setBlurStart(false);
      } else {
        setBlurStart(true);
      }
      const scrollRight = element.scrollWidth - (element.scrollLeft + element.clientWidth);
      containerRef.current?.style.setProperty(
        "--rightBlurWidth",
        `${Math.min(scrollRight, TAB_FADE_WIDTH)}px`
      );
      if (scrollRight < TAB_FADE_WIDTH / 2) {
        setBlurEnd(false);
      } else {
        setBlurEnd(true);
      }
    }, []);
    const handleTabClick = useCallback4((index) => {
      if (tabs[index]?.disabled) {
        return;
      }
      onValueChange(index);
      setTimeout(() => {
        if (buttonRefs.current[index] && scrollableRef.current) {
          const button4 = buttonRefs.current[index];
          const container6 = scrollableRef.current;
          if (button4) {
            const buttonRect = button4.getBoundingClientRect();
            const containerRect = container6.getBoundingClientRect();
            if (buttonRect.left < containerRect.left || buttonRect.right > containerRect.right) {
              button4.scrollIntoView({
                behavior: scrollBehavior,
                block: "nearest",
                inline: "center"
              });
            }
          }
        }
      }, 0);
    }, [tabs, onValueChange, scrollBehavior]);
    const handleKeyDown = useCallback4((event, index) => {
      let newIndex = index;
      switch (event.key) {
        case "ArrowLeft":
          event.preventDefault();
          newIndex = index > 0 ? index - 1 : tabs.length - 1;
          break;
        case "ArrowRight":
          event.preventDefault();
          newIndex = index < tabs.length - 1 ? index + 1 : 0;
          break;
        case "Home":
          event.preventDefault();
          newIndex = 0;
          break;
        case "End":
          event.preventDefault();
          newIndex = tabs.length - 1;
          break;
        case "Enter":
        case " ":
          event.preventDefault();
          handleTabClick(index);
          return;
        default:
          return;
      }
      buttonRefs.current[newIndex]?.focus();
    }, [tabs.length, handleTabClick]);
    useEffect7(() => {
      updateSelectionIndicator();
    }, [value, updateSelectionIndicator]);
    useEffect7(() => {
      if (scrollableRef.current) {
        updateScroll(scrollableRef.current);
        const clientWidth = scrollableRef.current.clientWidth;
        if (scrollableRef.current.scrollWidth === clientWidth) {
          setBlurEnd(false);
        }
      }
      const timeout = setTimeout(() => {
        updateSelectionIndicator();
      }, 100);
      return () => clearTimeout(timeout);
    }, [updateScroll, updateSelectionIndicator]);
    useEffect7(() => {
      const timeout = setTimeout(updateSelectionIndicator, 50);
      return () => clearTimeout(timeout);
    }, [tabs, updateSelectionIndicator]);
    const handleScroll = useCallback4((event) => {
      updateScroll(event.currentTarget);
    }, [updateScroll]);
    return /* @__PURE__ */ jsx1082(
      "div",
      {
        ref: containerRef,
        className: `${inlineTabs({ variant, size })} ${className || ""}`.trim(),
        ...rest,
        children: /* @__PURE__ */ jsxs1073(
          "div",
          {
            ref: scrollableRef,
            "aria-label": ariaLabel,
            className: tabsList({ blurStart, blurEnd }),
            role: "tablist",
            onScroll: handleScroll,
            children: [
              tabs.map((tab, index) => /* @__PURE__ */ jsx1082(
                "button",
                {
                  ref: (el) => {
                    buttonRefs.current[index] = el;
                    if (index === value) {
                      selectedButtonRef.current = el;
                    }
                  },
                  "aria-label": tab["aria-label"],
                  "aria-selected": index === value,
                  className: tabButton({
                    isSelected: index === value,
                    isDisabled: tab.disabled,
                    variant,
                    size
                  }),
                  disabled: tab.disabled,
                  role: "tab",
                  tabIndex: index === value ? 0 : -1,
                  onClick: () => handleTabClick(index),
                  onKeyDown: (event) => handleKeyDown(event, index),
                  children: tab.label
                },
                tab.label
              )),
              /* @__PURE__ */ jsx1082(
                "div",
                {
                  ref: selectionIndicatorRef,
                  className: selectionIndicator({
                    variant,
                    isVisible: true,
                    hasTransition: true
                  })
                }
              )
            ]
          }
        )
      }
    );
  }
);
InlineTabs.displayName = "InlineTabs";

// src/components/ExternalLink/ExternalLink.tsx
import { forwardRef as forwardRef19 } from "react";

// src/components/ExternalLink/ExternalLink.css.ts
import { createRuntimeFn as _7a46818 } from "@vanilla-extract/recipes/createRuntimeFn";
var externalLink = _7a46818({ defaultClassName: "ExternalLink__1pouu7s1 ExternalLink_externalLinkBase__1pouu7s0", variantClassNames: { variant: { standard: "ExternalLink_externalLink_variant_standard__1pouu7s2", subtle: "ExternalLink_externalLink_variant_subtle__1pouu7s3", accent: "ExternalLink_externalLink_variant_accent__1pouu7s4" } }, defaultVariants: { variant: "standard" }, compoundVariants: [] });

// src/components/ExternalLink/ExternalLink.tsx
import { jsx as jsx1083, jsxs as jsxs1074 } from "react/jsx-runtime";
var ExternalLink = forwardRef19(
  ({
    children,
    href,
    variant = "standard",
    iconSize = "small" /* Small */,
    showIcon = true,
    iconStyle,
    className,
    target = "_blank",
    rel = "noopener noreferrer",
    ...props
  }, ref) => {
    const linkClassName = externalLink({ variant });
    const combinedClassName = className ? `${linkClassName} ${className}` : linkClassName;
    return /* @__PURE__ */ jsxs1074(
      "a",
      {
        ref,
        className: combinedClassName,
        href,
        rel,
        target,
        ...props,
        children: [
          /* @__PURE__ */ jsx1083("span", { children }),
          showIcon && /* @__PURE__ */ jsx1083(
            Icon,
            {
              "aria-hidden": "true",
              icon: ApplicationLaunch_default,
              iconSize,
              style: iconStyle
            }
          )
        ]
      }
    );
  }
);
ExternalLink.displayName = "ExternalLink";

// src/components/SlideSheet/SlideSheet.tsx
import { useEffect as useEffect8, useRef as useRef9, useState as useState11 } from "react";
import { createPortal as createPortal3 } from "react-dom";

// src/components/SlideSheet/SlideSheet.css.ts
var accentButton2 = "SlideSheet_accentButton__1jv2u9hj";
var actions2 = "SlideSheet_actions__1jv2u9hd";
var aiButton2 = "SlideSheet_aiButton__1jv2u9hi";
var backdrop2 = "SlideSheet_backdrop__1jv2u9h1";
var button3 = "SlideSheet_button__1jv2u9he";
var closeButton3 = "SlideSheet_closeButton__1jv2u9h7";
var container5 = "SlideSheet_container__1jv2u9h0";
var content3 = "SlideSheet_content__1jv2u9hc";
var dangerButton2 = "SlideSheet_dangerButton__1jv2u9hh";
var description2 = "SlideSheet_description__1jv2u9hb";
var header2 = "SlideSheet_header__1jv2u9h8";
var headerDark = "SlideSheet_headerDark__1jv2u9h9";
var lg2 = "SlideSheet_lg__1jv2u9h5";
var md2 = "SlideSheet_md__1jv2u9h4";
var primaryButton2 = "SlideSheet_primaryButton__1jv2u9hf";
var secondaryButton2 = "SlideSheet_secondaryButton__1jv2u9hg";
var slide = "SlideSheet_slide__1jv2u9h2";
var sm2 = "SlideSheet_sm__1jv2u9h3";
var title2 = "SlideSheet_title__1jv2u9ha";
var xl2 = "SlideSheet_xl__1jv2u9h6";

// src/components/SlideSheet/SlideSheet.tsx
import { jsx as jsx1084, jsxs as jsxs1075 } from "react/jsx-runtime";
function CloseButton2({ onClose }) {
  return /* @__PURE__ */ jsx1084("button", { "aria-label": "Close", className: closeButton3, onClick: onClose, children: /* @__PURE__ */ jsx1084("svg", { fill: "none", height: "16", viewBox: "0 0 24 24", width: "16", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx1084("path", { d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z", fill: "currentColor" }) }) });
}
function SlideSheetHeader({ title: title3, description: description3, darkHeader }) {
  if (!title3) {
    return null;
  }
  return /* @__PURE__ */ jsxs1075("div", { className: darkHeader ? headerDark : header2, children: [
    /* @__PURE__ */ jsx1084("h2", { className: title2, children: title3 }),
    description3 && /* @__PURE__ */ jsx1084("p", { className: description2, children: description3 })
  ] });
}
function getButtonVariantClass2(variant = "primary") {
  switch (variant) {
    case "primary":
      return primaryButton2;
    case "secondary":
      return secondaryButton2;
    case "danger":
      return dangerButton2;
    case "ai":
      return aiButton2;
    case "accent":
      return accentButton2;
    default:
      return primaryButton2;
  }
}
function getWidthClass(width) {
  switch (width) {
    case "sm":
      return sm2;
    case "md":
      return md2;
    case "lg":
      return lg2;
    case "xl":
      return xl2;
    default:
      return md2;
  }
}
function renderButtonLabel2(label5) {
  if (typeof label5 === "string") {
    return label5.toUpperCase();
  }
  return label5;
}
function ActionButton({ action, variant = "secondary", onClick }) {
  return /* @__PURE__ */ jsx1084(
    "button",
    {
      className: `${button3} ${getButtonVariantClass2(action.variant || variant)}`,
      disabled: action.disabled,
      id: action.id,
      style: { flex: 1 },
      onClick: onClick || action.onClick,
      children: renderButtonLabel2(action.label)
    }
  );
}
function CancelButton({ cancelAction, onCancel }) {
  return /* @__PURE__ */ jsx1084("button", { className: `${button3} ${secondaryButton2}`, disabled: cancelAction.disabled, style: { flex: 1 }, onClick: onCancel, children: renderButtonLabel2(cancelAction.label) });
}
function SlideSheetActions({
  primaryAction,
  secondaryAction,
  tertiaryAction,
  cancelAction,
  onCancel
}) {
  if (!primaryAction && !secondaryAction && !tertiaryAction && !cancelAction) {
    return null;
  }
  return /* @__PURE__ */ jsxs1075("div", { className: actions2, children: [
    primaryAction && /* @__PURE__ */ jsx1084(ActionButton, { action: primaryAction, variant: "primary" }),
    secondaryAction && /* @__PURE__ */ jsx1084(ActionButton, { action: secondaryAction }),
    cancelAction && onCancel && /* @__PURE__ */ jsx1084(CancelButton, { cancelAction, onCancel }),
    tertiaryAction && /* @__PURE__ */ jsx1084(ActionButton, { action: tertiaryAction })
  ] });
}
function SlideSheet({
  isOpen,
  onClose,
  title: title3,
  customHeader,
  description: description3,
  children,
  primaryAction,
  secondaryAction,
  tertiaryAction,
  cancelAction,
  size = "md",
  showCloseButton = true,
  className,
  contentClassName,
  showBackdrop = false,
  topOffset = 0,
  side = "right",
  darkHeader = false,
  preventBodyScroll = true
}) {
  const slideRef = useRef9(null);
  const [isVisible, setIsVisible] = useState11(false);
  const [shouldRender, setShouldRender] = useState11(false);
  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, 300);
  };
  useEffect8(() => {
    if (isOpen) {
      setShouldRender(true);
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 50);
      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
      const timer = setTimeout(() => {
        setShouldRender(false);
      }, 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);
  useSlideSheetEventListeners(isOpen, handleClose, preventBodyScroll);
  if (!shouldRender) {
    return null;
  }
  const getTransform = () => {
    if (side === "left") {
      return isVisible ? "translateX(0)" : "translateX(-100%)";
    } else {
      return isVisible ? "translateX(0)" : "translateX(100%)";
    }
  };
  const getPositionStyle = () => {
    const baseStyle = {
      top: topOffset,
      height: topOffset > 0 ? `calc(100vh - ${topOffset}px)` : "100vh",
      transform: getTransform()
    };
    if (side === "left") {
      return { ...baseStyle, left: 0 };
    } else {
      return { ...baseStyle, right: 0 };
    }
  };
  return createPortal3(
    /* @__PURE__ */ jsxs1075("div", { className: container5, children: [
      showBackdrop && /* @__PURE__ */ jsx1084(
        "div",
        {
          className: backdrop2,
          role: "button",
          style: {
            opacity: isVisible ? 1 : 0,
            pointerEvents: isVisible ? "auto" : "none"
          },
          tabIndex: 0,
          onClick: handleClose,
          onKeyDown: (e) => {
            if (e.key === "Enter" || e.key === " ") {
              handleClose();
            }
          }
        }
      ),
      /* @__PURE__ */ jsxs1075("div", { ref: slideRef, className: `${slide} ${getWidthClass(size)} ${className || ""}`, style: getPositionStyle(), children: [
        showCloseButton && /* @__PURE__ */ jsx1084(CloseButton2, { onClose: handleClose }),
        customHeader && /* @__PURE__ */ jsx1084("div", { className: darkHeader ? headerDark : header2, children: customHeader }),
        !customHeader && title3 && /* @__PURE__ */ jsx1084(SlideSheetHeader, { darkHeader, description: description3, title: title3 }),
        /* @__PURE__ */ jsx1084("div", { className: `${content3} ${contentClassName || ""}`, children }),
        (primaryAction || secondaryAction || tertiaryAction || cancelAction) && /* @__PURE__ */ jsx1084(
          SlideSheetActions,
          {
            cancelAction,
            primaryAction,
            secondaryAction,
            tertiaryAction,
            onCancel: handleClose
          }
        )
      ] })
    ] }),
    document.body
  );
}
function useSlideSheetEventListeners(isOpen, handleClose, preventBodyScroll) {
  useEffect8(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && isOpen) {
        handleClose();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, handleClose]);
  useEffect8(() => {
    if (isOpen && preventBodyScroll) {
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = originalOverflow;
      };
    }
  }, [isOpen, preventBodyScroll]);
}
export {
  AbxyButtonBaseLowerLeft_default as AbxyButtonBaseLowerLeft,
  AbxyButtonBaseLowerRight_default as AbxyButtonBaseLowerRight,
  AbxyButtonBaseTopLeft_default as AbxyButtonBaseTopLeft,
  AbxyButtonBaseTopRight_default as AbxyButtonBaseTopRight,
  AbxydlSet_default as AbxydlSet,
  Accept_default as Accept,
  AccessoriesApp_default as AccessoriesApp,
  AccountHacked_default as AccountHacked,
  AchievementLocked_default as AchievementLocked,
  Achievements_default as Achievements,
  ActionCenter_default as ActionCenter,
  ActionCenter2_default as ActionCenter2,
  ActionCenterMirrored_default as ActionCenterMirrored,
  ActionCenterNotification_default as ActionCenterNotification,
  ActionCenterNotificationMirrored_default as ActionCenterNotificationMirrored,
  ActionCenterQuiet_default as ActionCenterQuiet,
  ActionCenterSettings_default as ActionCenterSettings,
  ActivityFeed_default as ActivityFeed,
  ActivityFeed2_default as ActivityFeed2,
  ActivityFeed2Mirrored_default as ActivityFeed2Mirrored,
  ActivityFeedConfiguration_default as ActivityFeedConfiguration,
  ActivityFeedRules_default as ActivityFeedRules,
  AdaptiveController_default as AdaptiveController,
  Add_default as Add,
  AddConsole_default as AddConsole,
  AddEvent_default as AddEvent,
  AddEventSolid_default as AddEventSolid,
  AddHome_default as AddHome,
  AddTo_default as AddTo,
  AddToCollection_default as AddToCollection,
  AddToNowPlaying_default as AddToNowPlaying,
  AddToNowPlaying2_default as AddToNowPlaying2,
  AdornerConnected_default as AdornerConnected,
  Aggressive_default as Aggressive,
  AllDevices_default as AllDevices,
  AnalyticsView_default as AnalyticsView,
  Anklewear_default as Anklewear,
  AppChannels_default as AppChannels,
  AppFill_default as AppFill,
  AppFillMirrored_default as AppFillMirrored,
  AppFull_default as AppFull,
  AppIconAvatar_default as AppIconAvatar,
  AppIconDefault_default as AppIconDefault,
  AppIconHelp_default as AppIconHelp,
  AppIconHelpMirrored_default as AppIconHelpMirrored,
  AppIconParty_default as AppIconParty,
  AppIconPeople_default as AppIconPeople,
  AppSnap_default as AppSnap,
  AppSnapMirrored_default as AppSnapMirrored,
  AppSwap_default as AppSwap,
  AppSwapMirrored_default as AppSwapMirrored,
  ApplicationInstall_default as ApplicationInstall,
  ApplicationLaunch_default as ApplicationLaunch,
  ApplicationLaunchMirrored_default as ApplicationLaunchMirrored,
  ApplyAction_default as ApplyAction,
  Apps_default as Apps,
  Apps2_default as Apps2,
  Apps2Solid_default as Apps2Solid,
  ArcadeGame_default as ArcadeGame,
  ArcadeGameArt160_default as ArcadeGameArt160,
  ArcadeGameArt224_default as ArcadeGameArt224,
  Arrow2Down_default as Arrow2Down,
  Arrow2DownSolid_default as Arrow2DownSolid,
  Arrow2Left_default as Arrow2Left,
  Arrow2LeftMirrored_default as Arrow2LeftMirrored,
  Arrow2LeftSolid_default as Arrow2LeftSolid,
  Arrow2Right_default as Arrow2Right,
  Arrow2RightMirrored_default as Arrow2RightMirrored,
  Arrow2RightSolid_default as Arrow2RightSolid,
  Arrow2Up_default as Arrow2Up,
  Arrow2UpSolid_default as Arrow2UpSolid,
  Arrow3Down_default as Arrow3Down,
  Arrow3Left_default as Arrow3Left,
  Arrow3LeftMirrored_default as Arrow3LeftMirrored,
  Arrow3Right_default as Arrow3Right,
  Arrow3RightMirrored_default as Arrow3RightMirrored,
  Arrow3Up_default as Arrow3Up,
  ArrowDown_default as ArrowDown,
  ArrowLeft_default as ArrowLeft,
  ArrowLeftMirrored_default as ArrowLeftMirrored,
  ArrowRight_default as ArrowRight,
  ArrowRightMirrored_default as ArrowRightMirrored,
  ArrowUp_default as ArrowUp,
  ArrowsLeftRight_default as ArrowsLeftRight,
  ArrowsLeftRight2_default as ArrowsLeftRight2,
  ArrowsUpDown_default as ArrowsUpDown,
  ArrowsUpDown2_default as ArrowsUpDown2,
  Ascending_default as Ascending,
  AspectRatio_default as AspectRatio,
  AspectRatio2_default as AspectRatio2,
  Attach_default as Attach,
  AttractMode_default as AttractMode,
  AvatarAward_default as AvatarAward,
  AvatarItem_default as AvatarItem,
  AvatarMyFeatures_default as AvatarMyFeatures,
  AvatarNew_default as AvatarNew,
  AvatarRotateLeft_default as AvatarRotateLeft,
  AvatarRotateRight_default as AvatarRotateRight,
  BackCaseDlSet_default as BackCaseDlSet,
  BackToWindow_default as BackToWindow,
  Backspace_default as Backspace,
  BadRecommendation_default as BadRecommendation,
  Badge,
  BadgeSize,
  BadgeVariant,
  Batteries_default as Batteries,
  Battery1_default as Battery1,
  Battery2_default as Battery2,
  Battery3_default as Battery3,
  Battery4_default as Battery4,
  BatteryCharging_default as BatteryCharging,
  BatteryPack_default as BatteryPack,
  Bde_default as Bde,
  BeaconsActivity_default as BeaconsActivity,
  BingCloseSmall_default as BingCloseSmall,
  Block_default as Block,
  BluRayRgby_default as BluRayRgby,
  BluRaySubtitles_default as BluRaySubtitles,
  Blueray_default as Blueray,
  Bluetooth_default as Bluetooth,
  Body_default as Body,
  BodyAthleticFeminine_default as BodyAthleticFeminine,
  BodyAthleticMasculine_default as BodyAthleticMasculine,
  BodyAverageFeminine_default as BodyAverageFeminine,
  BodyAverageMasculine_default as BodyAverageMasculine,
  BodyChubbyFeminine_default as BodyChubbyFeminine,
  BodyChubbyMasculine_default as BodyChubbyMasculine,
  BodyHeavyFeminine_default as BodyHeavyFeminine,
  BodyHeavyMasculine_default as BodyHeavyMasculine,
  BodyMannequin_default as BodyMannequin,
  BodyPregnant_default as BodyPregnant,
  BodySkinnyFeminine_default as BodySkinnyFeminine,
  BodySkinnyMasculine_default as BodySkinnyMasculine,
  BodyStrongFeminine_default as BodyStrongFeminine,
  BodyStrongMasculine_default as BodyStrongMasculine,
  Brightness_default as Brightness,
  Broadcasting_default as Broadcasting,
  Browser_default as Browser,
  BrowserCursor_default as BrowserCursor,
  BrowserHistory_default as BrowserHistory,
  BrowserPrivate_default as BrowserPrivate,
  Bug_default as Bug,
  BuildRelationship_default as BuildRelationship,
  BumperLeft_default as BumperLeft,
  BumperLeftDlSet_default as BumperLeftDlSet,
  BumperLeftSolid_default as BumperLeftSolid,
  BumperRight_default as BumperRight,
  BumperRightDlSet_default as BumperRightDlSet,
  BumperRightSolid_default as BumperRightSolid,
  Bundle_default as Bundle,
  BundleSolid_default as BundleSolid,
  BusinessRule_default as BusinessRule,
  Button,
  ButtonA_default as ButtonA,
  ButtonASolid_default as ButtonASolid,
  ButtonB_default as ButtonB,
  ButtonBSolid_default as ButtonBSolid,
  ButtonLetterA_default as ButtonLetterA,
  ButtonLetterB_default as ButtonLetterB,
  ButtonLetterX_default as ButtonLetterX,
  ButtonLetterY_default as ButtonLetterY,
  ButtonMenu_default as ButtonMenu,
  ButtonMenuSolid_default as ButtonMenuSolid,
  ButtonSize,
  ButtonType,
  ButtonView_default as ButtonView,
  ButtonView2_default as ButtonView2,
  ButtonViewSolid_default as ButtonViewSolid,
  ButtonX_default as ButtonX,
  ButtonXSolid_default as ButtonXSolid,
  ButtonY_default as ButtonY,
  ButtonYSolid_default as ButtonYSolid,
  Cables_default as Cables,
  Calculator_default as Calculator,
  CalendarSolid_default as CalendarSolid,
  Camera_default as Camera,
  CameraReset_default as CameraReset,
  CameraTimer_default as CameraTimer,
  CaptureShare_default as CaptureShare,
  Card,
  CardPrepaid_default as CardPrepaid,
  Carousel,
  Cart_default as Cart,
  Cast_default as Cast,
  CastMirrored_default as CastMirrored,
  CellPhone_default as CellPhone,
  ChangeTheme_default as ChangeTheme,
  Characters_default as Characters,
  ChargingCable_default as ChargingCable,
  Chat_default as Chat,
  ChatBot_default as ChatBot,
  ChatBubbles_default as ChatBubbles,
  ChatHeadset_default as ChatHeadset,
  ChatHeadsetArt160_default as ChatHeadsetArt160,
  ChatHeadsetArt224_default as ChatHeadsetArt224,
  ChatInviteFriend_default as ChatInviteFriend,
  ChatMute_default as ChatMute,
  ChatPad_default as ChatPad,
  ChatSettings_default as ChatSettings,
  ChatSolid_default as ChatSolid,
  ChatVideo_default as ChatVideo,
  CheckBox_default as CheckBox,
  CheckBox2_default as CheckBox2,
  CheckBoxChecked_default as CheckBoxChecked,
  CheckBoxChecked2_default as CheckBoxChecked2,
  Checkbox,
  ChevronDown_default as ChevronDown,
  ChevronDownSmall_default as ChevronDownSmall,
  ChevronLeft_default as ChevronLeft,
  ChevronLeftMirrored_default as ChevronLeftMirrored,
  ChevronLeftSmall_default as ChevronLeftSmall,
  ChevronRight_default as ChevronRight,
  ChevronRightMirrored_default as ChevronRightMirrored,
  ChevronRightSmall_default as ChevronRightSmall,
  ChevronUp_default as ChevronUp,
  ChevronUpSmall_default as ChevronUpSmall,
  Chin_default as Chin,
  ChromeCollapse_default as ChromeCollapse,
  ChromeCollapseMirrored_default as ChromeCollapseMirrored,
  ChromeExpand_default as ChromeExpand,
  ChromeExpandMirrored_default as ChromeExpandMirrored,
  CircleButtonBackground_default as CircleButtonBackground,
  CirclePause_default as CirclePause,
  CirclePauseSolid_default as CirclePauseSolid,
  CircleStop_default as CircleStop,
  CircleStopSolid_default as CircleStopSolid,
  Clock_default as Clock,
  Close_default as Close,
  CloseSmall_default as CloseSmall,
  ClosedCaptions_default as ClosedCaptions,
  ClosedCaptionsInternational_default as ClosedCaptionsInternational,
  Cloud_default as Cloud,
  CloudImportExport_default as CloudImportExport,
  CloudNotSynced_default as CloudNotSynced,
  CloudNotSynced2_default as CloudNotSynced2,
  CloudSyncing_default as CloudSyncing,
  Clubs_default as Clubs,
  CollectionListView_default as CollectionListView,
  CollectionListViewMirrored_default as CollectionListViewMirrored,
  Color_default as Color,
  ColorEdit96_default as ColorEdit96,
  ColorEdit961_default as ColorEdit961,
  ColorEdit962_default as ColorEdit962,
  ColorEdit963_default as ColorEdit963,
  ColorEdit964_default as ColorEdit964,
  ColorEdit965_default as ColorEdit965,
  ColorEdit966_default as ColorEdit966,
  ColorEdit967_default as ColorEdit967,
  ColorEdit968_default as ColorEdit968,
  ColorWheel_default as ColorWheel,
  ColorWheelAvatar_default as ColorWheelAvatar,
  Commitments_default as Commitments,
  CommunityProgramming_default as CommunityProgramming,
  Compare_default as Compare,
  CompareGames_default as CompareGames,
  Complaint_default as Complaint,
  ComplaintError_default as ComplaintError,
  ComplaintErrorMirrored_default as ComplaintErrorMirrored,
  Completed_default as Completed,
  CompletedSolid_default as CompletedSolid,
  Computer_default as Computer,
  ConnectToConsole_default as ConnectToConsole,
  Console_default as Console,
  ConsoleControllerPluggedIn_default as ConsoleControllerPluggedIn,
  ConsoleInitialSetup_default as ConsoleInitialSetup,
  ConsoleMultiGuest_default as ConsoleMultiGuest,
  ConsoleSettings_default as ConsoleSettings,
  ConsoleSleep_default as ConsoleSleep,
  ConsoleSolid_default as ConsoleSolid,
  Container,
  ControllerBatteryFull_default as ControllerBatteryFull,
  ControllerBatteryHalf_default as ControllerBatteryHalf,
  ControllerBatteryLow_default as ControllerBatteryLow,
  ControllerBatteryThreeQuarter_default as ControllerBatteryThreeQuarter,
  ControllerNewRelease_default as ControllerNewRelease,
  ControllerOff_default as ControllerOff,
  ControllerSettings_default as ControllerSettings,
  Copilot_default as Copilot,
  CopyAllGames_default as CopyAllGames,
  CopyGames_default as CopyGames,
  CortanaLogoInner_default as CortanaLogoInner,
  CortanaLogoOuter_default as CortanaLogoOuter,
  CreateAppointment_default as CreateAppointment,
  CreateClub_default as CreateClub,
  CreateGameClubs_default as CreateGameClubs,
  CreateTournament_default as CreateTournament,
  Crown_default as Crown,
  CursorHand_default as CursorHand,
  CursorHandClosed_default as CursorHandClosed,
  CursorHandClosedHorizontal_default as CursorHandClosedHorizontal,
  Default_default as Default,
  DefaultUser_default as DefaultUser,
  Delay_default as Delay,
  Delete_default as Delete,
  Descending_default as Descending,
  Description,
  Design_default as Design,
  Desktop_default as Desktop,
  Details_default as Details,
  DetailsMirrored_default as DetailsMirrored,
  DevDeploy_default as DevDeploy,
  DevUpdate_default as DevUpdate,
  Dialog,
  Diamond_default as Diamond,
  DiamondSolid_default as DiamondSolid,
  DisabledCamera_default as DisabledCamera,
  DisabledMicrophone_default as DisabledMicrophone,
  DiscArtist_default as DiscArtist,
  DiscBad_default as DiscBad,
  DiscCantPlay_default as DiscCantPlay,
  DiscGame_default as DiscGame,
  DiscMusic_default as DiscMusic,
  Dislike_default as Dislike,
  DislikeSolid_default as DislikeSolid,
  Dlc_default as Dlc,
  DlcSolid_default as DlcSolid,
  Dock_default as Dock,
  DockMirrored_default as DockMirrored,
  Download_default as Download,
  DownloadSeeAll_default as DownloadSeeAll,
  Dpad_default as Dpad,
  DpadDlSet_default as DpadDlSet,
  DpadDown_default as DpadDown,
  DpadLeft_default as DpadLeft,
  DpadRight_default as DpadRight,
  DpadUp_default as DpadUp,
  Dress_default as Dress,
  Dropdown,
  Dvr_default as Dvr,
  EaLogo_default as EaLogo,
  EaPlayHorizontalLogo_default as EaPlayHorizontalLogo,
  EaPlayLogo_default as EaPlayLogo,
  EaPlayVerticalLogo_default as EaPlayVerticalLogo,
  EaaHorizontalLogo_default as EaaHorizontalLogo,
  EaaVerticalLogo_default as EaaVerticalLogo,
  Ear_default as Ear,
  Earrings_default as Earrings,
  EaseOfAccess_default as EaseOfAccess,
  Edit_default as Edit,
  EditSolid_default as EditSolid,
  Eject_default as Eject,
  Emoji_default as Emoji,
  Entertainment_default as Entertainment,
  EntertainmentSolid_default as EntertainmentSolid,
  Epg_default as Epg,
  Equalizer_default as Equalizer,
  Event_default as Event,
  Explore_default as Explore,
  ExploreContent_default as ExploreContent,
  Export_default as Export,
  ExportMirrored_default as ExportMirrored,
  ExternalLink,
  Eye_default as Eye,
  Eyebrow_default as Eyebrow,
  Eyelash_default as Eyelash,
  Eyeshadow_default as Eyeshadow,
  FacebookLogo_default as FacebookLogo,
  FacialHair_default as FacialHair,
  Family_default as Family,
  FamilySolid_default as FamilySolid,
  FastForward_default as FastForward,
  Favorite_default as Favorite,
  FavoriteAdd_default as FavoriteAdd,
  FavoriteHelp_default as FavoriteHelp,
  FavoriteHelpMirrored_default as FavoriteHelpMirrored,
  FavoriteRemove_default as FavoriteRemove,
  FavoriteRemove2_default as FavoriteRemove2,
  FeatureRequest_default as FeatureRequest,
  Featured_default as Featured,
  FeaturedMirrored_default as FeaturedMirrored,
  Feedback_default as Feedback,
  FeedbackSolid_default as FeedbackSolid,
  Filter_default as Filter,
  FilterSolid_default as FilterSolid,
  Fingernail_default as Fingernail,
  FirstAccessApp_default as FirstAccessApp,
  Fitness_default as Fitness,
  Flag_default as Flag,
  FlagSolid_default as FlagSolid,
  Folder_default as Folder,
  FolderAllItems_default as FolderAllItems,
  FolderAvatarItems_default as FolderAvatarItems,
  FolderDemos_default as FolderDemos,
  FolderFindContent_default as FolderFindContent,
  FolderGamerPics_default as FolderGamerPics,
  FolderGames_default as FolderGames,
  FolderGenre_default as FolderGenre,
  FolderMusic_default as FolderMusic,
  FolderProfile_default as FolderProfile,
  FolderSystemItems_default as FolderSystemItems,
  FolderThemes_default as FolderThemes,
  FolderVideo_default as FolderVideo,
  Footer,
  ForearmStrap_default as ForearmStrap,
  Forum_default as Forum,
  ForumConfirm_default as ForumConfirm,
  ForumFavorite_default as ForumFavorite,
  ForumLock_default as ForumLock,
  FullScreen_default as FullScreen,
  Game_default as Game,
  GameAdd_default as GameAdd,
  GameArt160_default as GameArt160,
  GameArt224_default as GameArt224,
  GameChat_default as GameChat,
  GameChatTranscription_default as GameChatTranscription,
  GameClip_default as GameClip,
  GameClip2_default as GameClip2,
  GameClip2Off_default as GameClip2Off,
  GameClubs_default as GameClubs,
  GameCompletion_default as GameCompletion,
  GameCompletionDlc_default as GameCompletionDlc,
  GameDemos_default as GameDemos,
  GameEditionSolid_default as GameEditionSolid,
  GameEditions_default as GameEditions,
  GameFavorite_default as GameFavorite,
  GameFreeze_default as GameFreeze,
  GameHub_default as GameHub,
  GameJoin_default as GameJoin,
  GameLaunch_default as GameLaunch,
  GameLaunchSolid_default as GameLaunchSolid,
  GameMod_default as GameMod,
  GameModSolid_default as GameModSolid,
  GameMode_default as GameMode,
  GameModeOff_default as GameModeOff,
  GamePass_default as GamePass,
  GamePassBeta_default as GamePassBeta,
  GamePassBetaInline_default as GamePassBetaInline,
  GamePassConsoleGames_default as GamePassConsoleGames,
  GamePassConsoleGamesInline_default as GamePassConsoleGamesInline,
  GamePassInline_default as GamePassInline,
  GamePassInline2_default as GamePassInline2,
  GamePassInline3_default as GamePassInline3,
  GamePassInline4_default as GamePassInline4,
  GamePassPcGames_default as GamePassPcGames,
  GamePassPcGamesInline_default as GamePassPcGamesInline,
  GamePassSuperscriptInline_default as GamePassSuperscriptInline,
  GamePassUltimate_default as GamePassUltimate,
  GamePassUltimateInline_default as GamePassUltimateInline,
  GamePassUltimateInline2_default as GamePassUltimateInline2,
  GamePassUltimateSuperscriptInline_default as GamePassUltimateSuperscriptInline,
  GamePlay_default as GamePlay,
  GameRecommendations_default as GameRecommendations,
  GameRemove_default as GameRemove,
  GameRemove2_default as GameRemove2,
  GameSolid_default as GameSolid,
  GameWait_default as GameWait,
  Gamebar_default as Gamebar,
  GamerHistory_default as GamerHistory,
  GamerScore_default as GamerScore,
  GamerScoreInline_default as GamerScoreInline,
  GamerTagChange_default as GamerTagChange,
  GamerTagSettings_default as GamerTagSettings,
  GamerTagTakePicture_default as GamerTagTakePicture,
  GamesApp_default as GamesApp,
  Gif_default as Gif,
  GiftCard_default as GiftCard,
  GiftCardSolid_default as GiftCardSolid,
  Glasses_default as Glasses,
  Gloves_default as Gloves,
  Gold_default as Gold,
  GoldGamePassInline2_default as GoldGamePassInline2,
  GoldGamePassSuperscriptInline_default as GoldGamePassSuperscriptInline,
  GoldInline_default as GoldInline,
  GoldInline2_default as GoldInline2,
  GoldSuperscriptInline_default as GoldSuperscriptInline,
  GotoLiveBroadcast_default as GotoLiveBroadcast,
  GpFlag_default as GpFlag,
  GpFlagStar_default as GpFlagStar,
  GridViewLarge_default as GridViewLarge,
  GridViewSmall_default as GridViewSmall,
  GripperBarHorizontal_default as GripperBarHorizontal,
  GripsDlSet_default as GripsDlSet,
  Grouped_default as Grouped,
  GroupedList_default as GroupedList,
  Guitar_default as Guitar,
  GuitarArt160_default as GuitarArt160,
  GuitarArt224_default as GuitarArt224,
  HairFemale_default as HairFemale,
  HairMale_default as HairMale,
  Hanger_default as Hanger,
  Harddrive_default as Harddrive,
  Hat_default as Hat,
  HdQualityResolution_default as HdQualityResolution,
  HdmiCable_default as HdmiCable,
  Heading,
  HeadsetAdapter_default as HeadsetAdapter,
  HeadsetChargeCritical_default as HeadsetChargeCritical,
  HeadsetChargeCriticalBattery_default as HeadsetChargeCriticalBattery,
  HeadsetChargeFull_default as HeadsetChargeFull,
  HeadsetChargeLow_default as HeadsetChargeLow,
  HeadsetChargeMed_default as HeadsetChargeMed,
  HeadsetCharging_default as HeadsetCharging,
  HeadsetController_default as HeadsetController,
  Heart_default as Heart,
  HeartAdd_default as HeartAdd,
  HeartAddSolid_default as HeartAddSolid,
  HeartBroken_default as HeartBroken,
  HeartFull_default as HeartFull,
  HeartRemove_default as HeartRemove,
  HeartRemoveSolid_default as HeartRemoveSolid,
  HeartWishlist_default as HeartWishlist,
  HeartWishlistMirrored_default as HeartWishlistMirrored,
  HeartWishlistMirroredSolid_default as HeartWishlistMirroredSolid,
  HeartWishlistSolid_default as HeartWishlistSolid,
  HeightBottomRange_default as HeightBottomRange,
  HeightTopRange_default as HeightTopRange,
  Helmet_default as Helmet,
  HeroStats_default as HeroStats,
  HighContrast_default as HighContrast,
  HoloLens_default as HoloLens,
  Home_default as Home,
  HomeFill_default as HomeFill,
  Icon,
  Icon4K_default as Icon4K,
  IconAndTextButton,
  IconButton,
  IconButtonSize,
  IconSize,
  Import_default as Import,
  ImportAll_default as ImportAll,
  ImportAllMirrored_default as ImportAllMirrored,
  ImportMirrored_default as ImportMirrored,
  IncidentTriangle_default as IncidentTriangle,
  Info_default as Info,
  Info16_default as Info16,
  Infrastructure_default as Infrastructure,
  InlineTabs,
  InstagramLogo_default as InstagramLogo,
  Instant_default as Instant,
  InstructionManual_default as InstructionManual,
  Internet_default as Internet,
  InternetWithController_default as InternetWithController,
  JoinClub_default as JoinClub,
  JoinGameClubs_default as JoinGameClubs,
  Key_default as Key,
  Keyboard_default as Keyboard,
  Kinect_default as Kinect,
  KinectBroadcasting_default as KinectBroadcasting,
  KinectDisconnected_default as KinectDisconnected,
  KinectIr_default as KinectIr,
  KinectSettings_default as KinectSettings,
  Label_default as Label,
  LaserCutter_default as LaserCutter,
  LauncherApp_default as LauncherApp,
  LeftArmReplacement_default as LeftArmReplacement,
  LeftDoubleQuote_default as LeftDoubleQuote,
  LeftLegReplacement_default as LeftLegReplacement,
  LeftStick_default as LeftStick,
  LeftStickClick_default as LeftStickClick,
  LeftThumbDown_default as LeftThumbDown,
  LeftThumbHorizontal_default as LeftThumbHorizontal,
  LeftThumbLeft_default as LeftThumbLeft,
  LeftThumbRight_default as LeftThumbRight,
  LeftThumbUp_default as LeftThumbUp,
  Leggings_default as Leggings,
  Library_default as Library,
  LibraryAddTo_default as LibraryAddTo,
  LibraryRemoveFrom_default as LibraryRemoveFrom,
  LibrarySolid_default as LibrarySolid,
  LicenseStore_default as LicenseStore,
  Lightbulb_default as Lightbulb,
  LightningBolt_default as LightningBolt,
  Like_default as Like,
  LikeDislike_default as LikeDislike,
  LikeDislikeSolid_default as LikeDislikeSolid,
  LikeSolid_default as LikeSolid,
  Link_default as Link,
  List_default as List,
  ListBulleted_default as ListBulleted,
  ListBulletedMirrored_default as ListBulletedMirrored,
  ListJustified_default as ListJustified,
  ListMirrored_default as ListMirrored,
  ListView_default as ListView,
  ListViewMirrored_default as ListViewMirrored,
  LiveIndicator_default as LiveIndicator,
  LiveText_default as LiveText,
  LiveTextInline_default as LiveTextInline,
  LoadingOverlay,
  LoadingSpinner,
  Lock_default as Lock,
  LockSolid_default as LockSolid,
  LowHardDrive_default as LowHardDrive,
  LowerBrightness_default as LowerBrightness,
  MailSearch_default as MailSearch,
  Mask_default as Mask,
  MediaDisc_default as MediaDisc,
  MediaDvd_default as MediaDvd,
  MediaHdDvd_default as MediaHdDvd,
  MediaMusic_default as MediaMusic,
  MediaRemote_default as MediaRemote,
  Megaphone_default as Megaphone,
  MemoryUnitExternal_default as MemoryUnitExternal,
  MemoryUnitInternal_default as MemoryUnitInternal,
  Menu,
  MenuItem,
  Message_default as Message,
  MessageFriendRequest_default as MessageFriendRequest,
  MessageJoinParty_default as MessageJoinParty,
  MessageReply_default as MessageReply,
  MessageSend_default as MessageSend,
  MessageSendMirrored_default as MessageSendMirrored,
  MessageVideo_default as MessageVideo,
  MessageVoice_default as MessageVoice,
  MicOff_default as MicOff,
  MicOff2_default as MicOff2,
  MicOn_default as MicOn,
  MicrosoftPoints_default as MicrosoftPoints,
  MiniGuide_default as MiniGuide,
  MiniGuideMirrored_default as MiniGuideMirrored,
  MixerCoStreamingSolid_default as MixerCoStreamingSolid,
  MixerEmbers_default as MixerEmbers,
  MixerEmbersSolid_default as MixerEmbersSolid,
  MixerInteractiveSolid_default as MixerInteractiveSolid,
  MixerLogo_default as MixerLogo,
  MixerLogotypeInline_default as MixerLogotypeInline,
  MixerPoll_default as MixerPoll,
  MixerPollSolid_default as MixerPollSolid,
  MixerSkillsStar_default as MixerSkillsStar,
  MixerSparksSolid_default as MixerSparksSolid,
  MixerTrending_default as MixerTrending,
  MixerTrendingSolid_default as MixerTrendingSolid,
  MixerVideoFeedback_default as MixerVideoFeedback,
  MixerVideoFeedbackSolid_default as MixerVideoFeedbackSolid,
  MixerViewers_default as MixerViewers,
  MixerViewersSolid_default as MixerViewersSolid,
  ModeSelector_default as ModeSelector,
  MoreActions_default as MoreActions,
  MoreVertical_default as MoreVertical,
  MostPopular_default as MostPopular,
  Mounts_default as Mounts,
  Mouse_default as Mouse,
  Mouth_default as Mouth,
  Move_default as Move,
  MoveToBack_default as MoveToBack,
  MoveToFront_default as MoveToFront,
  Movies_default as Movies,
  MoviesTvApp_default as MoviesTvApp,
  MultiItemJoinable_default as MultiItemJoinable,
  MultiPlayer_default as MultiPlayer,
  MultiPlayerGold_default as MultiPlayerGold,
  MultiPlayerJoinChallenge_default as MultiPlayerJoinChallenge,
  MultiPlayerLeaveParty_default as MultiPlayerLeaveParty,
  MultiPlayerPartyJoinable_default as MultiPlayerPartyJoinable,
  MultiPlayerShare_default as MultiPlayerShare,
  MultiPlayerSolid_default as MultiPlayerSolid,
  MultiPlayerTimer_default as MultiPlayerTimer,
  MultiPlayerWimax_default as MultiPlayerWimax,
  MultiSelect,
  MultiSelectMirrored_default as MultiSelectMirrored,
  Music_default as Music,
  MusicTracks_default as MusicTracks,
  MusicTracksMirrored_default as MusicTracksMirrored,
  Mute_default as Mute,
  MyMoviesTv_default as MyMoviesTv,
  Narrator_default as Narrator,
  Navigation_default as Navigation,
  Network_default as Network,
  NetworkConnected_default as NetworkConnected,
  NetworkDisconnected_default as NetworkDisconnected,
  NetworkDisconnected2_default as NetworkDisconnected2,
  NetworkSettings_default as NetworkSettings,
  NetworkTower_default as NetworkTower,
  NetworkTransfer_default as NetworkTransfer,
  Networks_default as Networks,
  NewReleases_default as NewReleases,
  NewSparkles_default as NewSparkles,
  Next_default as Next,
  NoContent_default as NoContent,
  NoThumbnail_default as NoThumbnail,
  NoVideoCamera_default as NoVideoCamera,
  NoVideoCamera2_default as NoVideoCamera2,
  Nose_default as Nose,
  NoseRing_default as NoseRing,
  NotOnline_default as NotOnline,
  Notebook_default as Notebook,
  NowPlaying_default as NowPlaying,
  Ocr1_default as Ocr1,
  Ocr2_default as Ocr2,
  Ocrp1_default as Ocrp1,
  Ocrp2_default as Ocrp2,
  Ocrp3_default as Ocrp3,
  Ocrp4_default as Ocrp4,
  Offline_default as Offline,
  Online_default as Online,
  Open_default as Open,
  OpenMirrored_default as OpenMirrored,
  OpenNewTab_default as OpenNewTab,
  OpenNewTabMirrored_default as OpenNewTabMirrored,
  OptionalMediaUpdate_default as OptionalMediaUpdate,
  OutlineHalfStarLeft_default as OutlineHalfStarLeft,
  OutlineQuarterStarLeft_default as OutlineQuarterStarLeft,
  OutlineThreeQuarterStarLeft_default as OutlineThreeQuarterStarLeft,
  OverlayMode,
  PaddleP1_default as PaddleP1,
  PaddleP2_default as PaddleP2,
  PaddleP3_default as PaddleP3,
  PaddleP4_default as PaddleP4,
  Page_default as Page,
  PageEdit_default as PageEdit,
  PanMode_default as PanMode,
  Pants_default as Pants,
  ParentalLock_default as ParentalLock,
  PartyLeader_default as PartyLeader,
  Pause_default as Pause,
  Pc1_default as Pc1,
  PerformanceMonitoring_default as PerformanceMonitoring,
  PhoneCall_default as PhoneCall,
  PhoneHangUp_default as PhoneHangUp,
  Photo_default as Photo,
  PhotoCollection_default as PhotoCollection,
  Pin_default as Pin,
  PinSolid_default as PinSolid,
  Pip_default as Pip,
  Play_default as Play,
  PlayButtonSolid_default as PlayButtonSolid,
  PlayPause_default as PlayPause,
  Player_default as Player,
  PlayerAchievement_default as PlayerAchievement,
  PlayerAdd_default as PlayerAdd,
  PlayerDownloadProfile_default as PlayerDownloadProfile,
  PlayerGold_default as PlayerGold,
  PlayerKinect_default as PlayerKinect,
  PlayerPerks_default as PlayerPerks,
  PlayerRecoverProfile_default as PlayerRecoverProfile,
  PlayerRemove_default as PlayerRemove,
  PlayerRespond_default as PlayerRespond,
  PlayerSettings_default as PlayerSettings,
  PlayerSignIn_default as PlayerSignIn,
  PlayerSignOut_default as PlayerSignOut,
  PlayerSkipSignIn_default as PlayerSkipSignIn,
  PlayerSwitchProfile_default as PlayerSwitchProfile,
  PlayerWait_default as PlayerWait,
  Playground_default as Playground,
  Playlist_default as Playlist,
  PlaylistAdd_default as PlaylistAdd,
  PlaylistAddMirrored_default as PlaylistAddMirrored,
  PlaylistGenre_default as PlaylistGenre,
  PlaylistGenreMirrored_default as PlaylistGenreMirrored,
  PlaylistMusic_default as PlaylistMusic,
  PlaylistMusicMirrored_default as PlaylistMusicMirrored,
  PlaylistRemove_default as PlaylistRemove,
  PlaylistRemoveMirrored_default as PlaylistRemoveMirrored,
  PolicyInsights_default as PolicyInsights,
  PopIn_default as PopIn,
  Pose_default as Pose,
  Power_default as Power,
  PowerCord_default as PowerCord,
  PowerSettings_default as PowerSettings,
  PowerSupply_default as PowerSupply,
  PreviewContent_default as PreviewContent,
  Previous_default as Previous,
  Profile_default as Profile,
  ProfileSearch_default as ProfileSearch,
  QrCode_default as QrCode,
  Quest_default as Quest,
  Question_default as Question,
  QuestionMirrored_default as QuestionMirrored,
  Questionnaire_default as Questionnaire,
  QuestionnaireMirrored_default as QuestionnaireMirrored,
  RadioBtnOff_default as RadioBtnOff,
  RadioBtnOn_default as RadioBtnOn,
  Ratings_default as Ratings,
  Reading_default as Reading,
  Recent_default as Recent,
  RecentInstalled_default as RecentInstalled,
  RecentPlayed_default as RecentPlayed,
  RecentSolid_default as RecentSolid,
  RecordArrow_default as RecordArrow,
  RecordDot_default as RecordDot,
  RecordInnerCircle_default as RecordInnerCircle,
  RecordOuterCircle_default as RecordOuterCircle,
  RecordSeries_default as RecordSeries,
  Refresh_default as Refresh,
  Related_default as Related,
  Reminder_default as Reminder,
  Remove_default as Remove,
  RemoveContent_default as RemoveContent,
  RemoveEvent_default as RemoveEvent,
  Repairs_default as Repairs,
  Repeat_default as Repeat,
  RepeatBlock_default as RepeatBlock,
  RepeatOnce_default as RepeatOnce,
  RepeatRefresh_default as RepeatRefresh,
  Replay_default as Replay,
  Report_default as Report,
  Resolution4K_default as Resolution4K,
  ResolutionHd_default as ResolutionHd,
  ResolutionSd_default as ResolutionSd,
  Reward_default as Reward,
  Rewind_default as Rewind,
  Ribbon_default as Ribbon,
  RightArmReplacement_default as RightArmReplacement,
  RightDoubleQuote_default as RightDoubleQuote,
  RightLegReplacement_default as RightLegReplacement,
  RightStick_default as RightStick,
  RightStickClick_default as RightStickClick,
  RightThumbDown_default as RightThumbDown,
  RightThumbDownSolid_default as RightThumbDownSolid,
  RightThumbHorizontal_default as RightThumbHorizontal,
  RightThumbLeft_default as RightThumbLeft,
  RightThumbLeftSolid_default as RightThumbLeftSolid,
  RightThumbRight_default as RightThumbRight,
  RightThumbRightSolid_default as RightThumbRightSolid,
  RightThumbUp_default as RightThumbUp,
  RightThumbUpSolid_default as RightThumbUpSolid,
  RightThumbVertical_default as RightThumbVertical,
  RightThumbVerticalSolid_default as RightThumbVerticalSolid,
  Ring_default as Ring,
  RingOfLight_default as RingOfLight,
  Ringer_default as Ringer,
  RingerAccounts_default as RingerAccounts,
  RingerOff_default as RingerOff,
  RingerSolid_default as RingerSolid,
  Rocket_default as Rocket,
  RotateClockwise_default as RotateClockwise,
  RotateCounterClockwise_default as RotateCounterClockwise,
  Sad_default as Sad,
  Sad2_default as Sad2,
  Save_default as Save,
  SaveSolid_default as SaveSolid,
  ScreenTime_default as ScreenTime,
  SdQualityResolution_default as SdQualityResolution,
  Search_default as Search,
  SearchMedium_default as SearchMedium,
  Section,
  Select,
  SelectScene_default as SelectScene,
  SelectionWheel_default as SelectionWheel,
  SemanticZoom_default as SemanticZoom,
  Send_default as Send,
  SendMirrored_default as SendMirrored,
  Sensor_default as Sensor,
  SensorWithStand_default as SensorWithStand,
  ServerProcesses_default as ServerProcesses,
  Settings_default as Settings,
  SettingsDisplaySound_default as SettingsDisplaySound,
  SettingsSolid_default as SettingsSolid,
  SgControllerDown_default as SgControllerDown,
  SgControllerLeft_default as SgControllerLeft,
  SgControllerRight_default as SgControllerRight,
  SgControllerUp_default as SgControllerUp,
  SgFavorite_default as SgFavorite,
  Share_default as Share,
  Shimmer,
  Shirt_default as Shirt,
  Shoes_default as Shoes,
  ShopBrand_default as ShopBrand,
  ShoppingCartSolid_default as ShoppingCartSolid,
  ShuffleOff_default as ShuffleOff,
  ShuffleOn_default as ShuffleOn,
  SignOut_default as SignOut,
  SignalFull_default as SignalFull,
  SignalHalf_default as SignalHalf,
  SignalLow_default as SignalLow,
  SignalNone_default as SignalNone,
  SignalThreeQuarter_default as SignalThreeQuarter,
  Signin_default as Signin,
  SingleBookmark_default as SingleBookmark,
  SingleBookmarkSolid_default as SingleBookmarkSolid,
  SizeBottomRange_default as SizeBottomRange,
  SizeTopRange_default as SizeTopRange,
  SkipBack_default as SkipBack,
  SkipBack10_default as SkipBack10,
  SkipForward_default as SkipForward,
  SkipForward10_default as SkipForward10,
  SkipForward30_default as SkipForward30,
  SkipTab_default as SkipTab,
  SlideSheet,
  SliderThumb_default as SliderThumb,
  SlotOne_default as SlotOne,
  SlotTwo_default as SlotTwo,
  SmartDj_default as SmartDj,
  SmartGlass_default as SmartGlass,
  SmartGlassConnected_default as SmartGlassConnected,
  SmartGlassConnectingConsole_default as SmartGlassConnectingConsole,
  SmartGlassConnectingRingsFull_default as SmartGlassConnectingRingsFull,
  SmartGlassConnectingRingsInner_default as SmartGlassConnectingRingsInner,
  SmartGlassConnectingRingsMid_default as SmartGlassConnectingRingsMid,
  SmartGlassConnectingRingsOuter_default as SmartGlassConnectingRingsOuter,
  SmartGlassGamerScore_default as SmartGlassGamerScore,
  SmartGlassPhone_default as SmartGlassPhone,
  SmartGlassRemote_default as SmartGlassRemote,
  SmartGlassTablet_default as SmartGlassTablet,
  SmartVj_default as SmartVj,
  Smiley_default as Smiley,
  Smooth_default as Smooth,
  Speakers_default as Speakers,
  Spinner,
  Sports_default as Sports,
  StartBack_default as StartBack,
  StartParty_default as StartParty,
  StatusCircleBlock_default as StatusCircleBlock,
  StatusCircleCheckmark_default as StatusCircleCheckmark,
  StatusCircleErrorX_default as StatusCircleErrorX,
  StatusCircleExclamation_default as StatusCircleExclamation,
  StatusCircleInner_default as StatusCircleInner,
  StatusCircleOuter_default as StatusCircleOuter,
  StatusTriangleInner_default as StatusTriangleInner,
  StatusTriangleOuter_default as StatusTriangleOuter,
  StepBack_default as StepBack,
  StepForward_default as StepForward,
  Stop_default as Stop,
  StopSolid_default as StopSolid,
  StopWatch_default as StopWatch,
  StorageInternalExternal_default as StorageInternalExternal,
  Store_default as Store,
  StoreLogo16_default as StoreLogo16,
  StoreLogoMed20_default as StoreLogoMed20,
  StoreSolid_default as StoreSolid,
  Streaming_default as Streaming,
  StyleProvider,
  Subscribe_default as Subscribe,
  SubscriptionAdd_default as SubscriptionAdd,
  SubscriptionAddMirrored_default as SubscriptionAddMirrored,
  SubscriptionAddMirroredSolid_default as SubscriptionAddMirroredSolid,
  SubscriptionAddSolid_default as SubscriptionAddSolid,
  Subscriptions_default as Subscriptions,
  Subscriptions2_default as Subscriptions2,
  Subscriptions2Mirrored_default as Subscriptions2Mirrored,
  SubscriptionsMirrored_default as SubscriptionsMirrored,
  SubtitlesAudio_default as SubtitlesAudio,
  SurfaceHub_default as SurfaceHub,
  Swap_default as Swap,
  Sweepstakes_default as Sweepstakes,
  Switch,
  SwitchFocus_default as SwitchFocus,
  SwitchFocusMirrored_default as SwitchFocusMirrored,
  SwitcherMultitask_default as SwitcherMultitask,
  TShirt_default as TShirt,
  Tag_default as Tag,
  TagCommunications_default as TagCommunications,
  TagLanguage_default as TagLanguage,
  TagPeople_default as TagPeople,
  TagPlayStyle_default as TagPlayStyle,
  TagSolid_default as TagSolid,
  Tattoo_default as Tattoo,
  Teamwork_default as Teamwork,
  Teeth_default as Teeth,
  Telemarketer_default as Telemarketer,
  TestBeaker_default as TestBeaker,
  TestBeakerSolid_default as TestBeakerSolid,
  Text,
  TextArea,
  TextField_default as TextField,
  TextInput,
  ThisPc_default as ThisPc,
  ThisPcSolid_default as ThisPcSolid,
  ThumbstickDlSet_default as ThumbstickDlSet,
  ThumbstickXAxisInverted_default as ThumbstickXAxisInverted,
  ThumbstickXAxisSwap_default as ThumbstickXAxisSwap,
  ThumbstickYAxisInverted_default as ThumbstickYAxisInverted,
  ThumbstickYAxisSwap_default as ThumbstickYAxisSwap,
  TileGroups_default as TileGroups,
  Tiles2_default as Tiles2,
  TimeLanguage_default as TimeLanguage,
  Timer_default as Timer,
  TitleMenu_default as TitleMenu,
  ToeRing_default as ToeRing,
  Toenail_default as Toenail,
  ToggleBorder_default as ToggleBorder,
  ToggleFilled_default as ToggleFilled,
  ToggleThumb_default as ToggleThumb,
  Touch_default as Touch,
  Tournament_default as Tournament,
  TransferCable_default as TransferCable,
  Translate_default as Translate,
  Trending_default as Trending,
  TrendingMirrored_default as TrendingMirrored,
  TriggerLeft_default as TriggerLeft,
  TriggerLeftDlSet_default as TriggerLeftDlSet,
  TriggerLeftSolid_default as TriggerLeftSolid,
  TriggerRight_default as TriggerRight,
  TriggerRightDlSet_default as TriggerRightDlSet,
  TriggerRightSolid_default as TriggerRightSolid,
  Trim_default as Trim,
  TvBluRaySettings_default as TvBluRaySettings,
  TvCableSettings_default as TvCableSettings,
  TvMonitor_default as TvMonitor,
  TvRecommendationsTv_default as TvRecommendationsTv,
  TvSettings_default as TvSettings,
  TvShows_default as TvShows,
  TwitterLogo_default as TwitterLogo,
  UnSnap_default as UnSnap,
  UnSnapMirrored_default as UnSnapMirrored,
  Uncompare_default as Uncompare,
  Undo_default as Undo,
  Undock_default as Undock,
  UndockMirrored_default as UndockMirrored,
  Ungrouped_default as Ungrouped,
  Uninstall_default as Uninstall,
  Unknown_default as Unknown,
  Unknown3D_default as Unknown3D,
  UnknownMirrored_default as UnknownMirrored,
  UnknownMirroredSolid_default as UnknownMirroredSolid,
  UnknownSolid_default as UnknownSolid,
  Unlock_default as Unlock,
  UnlockedAchievement_default as UnlockedAchievement,
  Unpin_default as Unpin,
  Unpin2_default as Unpin2,
  UnrecognizedFormat_default as UnrecognizedFormat,
  Upload_default as Upload,
  Usb_default as Usb,
  UsbDevice_default as UsbDevice,
  UserTypeAdult_default as UserTypeAdult,
  UserTypeChild_default as UserTypeChild,
  UserTypeTeen_default as UserTypeTeen,
  VerifiedGameClub_default as VerifiedGameClub,
  VerifiedGameClubBackplate_default as VerifiedGameClubBackplate,
  VerifiedGameClubBackplateInline_default as VerifiedGameClubBackplateInline,
  VerifiedGameClubInline_default as VerifiedGameClubInline,
  VerifiedGameClubSolid_default as VerifiedGameClubSolid,
  VerifiedGameClubSolidInline_default as VerifiedGameClubSolidInline,
  VibrateController_default as VibrateController,
  Video_default as Video,
  Video1_default as Video1,
  Video11_default as Video11,
  VideoBanned_default as VideoBanned,
  VideoCamera_default as VideoCamera,
  VideoCameraDisconnected_default as VideoCameraDisconnected,
  VideoGames_default as VideoGames,
  VideoNewRelease_default as VideoNewRelease,
  VideoPopular_default as VideoPopular,
  VideoProvider_default as VideoProvider,
  VideoRecommendations_default as VideoRecommendations,
  ViewMenuDlSet_default as ViewMenuDlSet,
  ViewProfileDetails_default as ViewProfileDetails,
  ViewProfileDetailsMirrored_default as ViewProfileDetailsMirrored,
  VirtualKeyboardClose_default as VirtualKeyboardClose,
  Volume_default as Volume,
  Volume0_default as Volume0,
  Volume1_default as Volume1,
  Volume2_default as Volume2,
  Volume3_default as Volume3,
  VolumeDisabled_default as VolumeDisabled,
  VolumeDisabled2_default as VolumeDisabled2,
  VolumeMute_default as VolumeMute,
  Warning_default as Warning,
  WelcomeApp_default as WelcomeApp,
  WheelArt160_default as WheelArt160,
  WheelArt224_default as WheelArt224,
  Wifi_default as Wifi,
  Wifi1_default as Wifi1,
  Wifi2_default as Wifi2,
  Wifi3_default as Wifi3,
  WifiWarning4_default as WifiWarning4,
  WindowsLogo_default as WindowsLogo,
  WirelessDevice_default as WirelessDevice,
  Wristwear_default as Wristwear,
  Xbox360_default as Xbox360,
  Xbox3603D_default as Xbox3603D,
  XboxAmbassadorBaseLogo16_default as XboxAmbassadorBaseLogo16,
  XboxAmbassadorBaseLogo32_default as XboxAmbassadorBaseLogo32,
  XboxAssistApp_default as XboxAssistApp,
  XboxAssistAppMirrored_default as XboxAssistAppMirrored,
  XboxChat_default as XboxChat,
  XboxClassic_default as XboxClassic,
  XboxDynamicLighting_default as XboxDynamicLighting,
  XboxGamePass_default as XboxGamePass,
  XboxGamePassBadge_default as XboxGamePassBadge,
  XboxLfg_default as XboxLfg,
  XboxLogoOutline_default as XboxLogoOutline,
  XboxMsgFulfillmentLogo_default as XboxMsgFulfillmentLogo,
  XboxOne3D_default as XboxOne3D,
  XboxOneConsole_default as XboxOneConsole,
  XboxOneDown_default as XboxOneDown,
  XboxOneHardwareSolid_default as XboxOneHardwareSolid,
  XboxOneS3D_default as XboxOneS3D,
  XboxOneSad3D_default as XboxOneSad3D,
  XboxOneUp_default as XboxOneUp,
  XboxOneX3D_default as XboxOneX3D,
  XboxOptimized_default as XboxOptimized,
  XboxPlayAnywhere_default as XboxPlayAnywhere,
  XboxPlayAnywhereSolid_default as XboxPlayAnywhereSolid,
  XboxSeriesS3D_default as XboxSeriesS3D,
  XboxSeriesX_default as XboxSeriesX,
  XboxSeriesX3D_default as XboxSeriesX3D,
  XboxSeriesXHardware_default as XboxSeriesXHardware,
  XboxSeriesXHardwareSolid_default as XboxSeriesXHardwareSolid,
  XboxSeriesXSolid_default as XboxSeriesXSolid,
  XboxServicesCloudStream_default as XboxServicesCloudStream,
  XboxServicesCloudStreamSolid_default as XboxServicesCloudStreamSolid,
  XboxServicesConsoleStream_default as XboxServicesConsoleStream,
  XboxSocial_default as XboxSocial,
  Xenon_default as Xenon,
  Xgp_default as Xgp,
  XgpInline_default as XgpInline,
  ZoomIn_default as ZoomIn,
  ZoomOut_default as ZoomOut,
  breakpoints,
  getSystemThemePreference,
  mediaQueries,
  sprinkles,
  themeMap,
  useStyleProvider,
  vars,
  vars as xdsDefaultTheme,
  vars as xdsVars
};
//# sourceMappingURL=index.mjs.map